/* eslint-disable */
import type {
  DateTimeString,
  PlainDateTimeString,
  PlainDateString,
  PlainYearMonthString,
  ZonedDateTimeString,
} from "@sa-nu/shared-utils/date";
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: DateTimeString; output: DateTimeString };
  /**
   * Prisma.Decimal に対応する。
   * JSON number としてシリアライズされる。
   */
  Decimal: { input: number; output: number };
  /**
   * Temporal.PlainDate に対応する。
   * "2024-01-01" のようにシリアライズされる。
   */
  PlainDate: { input: PlainDateString; output: PlainDateString };
  /**
   * Temporal.PlainDateTime に対応する。
   * "2024-01-01T00:00:00" のようにシリアライズされる。
   */
  PlainDateTime: { input: PlainDateTimeString; output: PlainDateTimeString };
  /**
   * Temporal.PlainYearMonth に対応する。
   * "2024-01" のようにシリアライズされる。
   */
  PlainYearMonth: { input: PlainYearMonthString; output: PlainYearMonthString };
  /**
   * Temporal.ZonedDateTime に対応する。
   * "2024-01-01T00:00:00+09:00[Asia/Tokyo]" のようにシリアライズされる。
   */
  ZonedDateTime: { input: ZonedDateTimeString; output: ZonedDateTimeString };
};

export type AcceptAccommodationReservationError = {
  __typename: "AcceptAccommodationReservationError";
  case: AcceptAccommodationReservationErrorCase;
};

export const AcceptAccommodationReservationErrorCase = {
  /** ログインユーザーとは異なるユーザーに紐づいている */
  NotAuthorized: "NotAuthorized",
  /** Stay Gift from Owners のオーナーが自身の予約を取ろうとした */
  OwnerOfStayGiftFromOwnersError: "OwnerOfStayGiftFromOwnersError",
  /** 該当する仮予約が存在しない */
  UserAcceptCodeNotFound: "UserAcceptCodeNotFound",
} as const;

export type AcceptAccommodationReservationErrorCase =
  (typeof AcceptAccommodationReservationErrorCase)[keyof typeof AcceptAccommodationReservationErrorCase];
export type AcceptAccommodationReservationPayload =
  | AcceptAccommodationReservationError
  | AccommodationReservation;

export const AccessKeyType = {
  /** 清掃スタッフ用PINコード。部屋ごとに異なる */
  SiteCleaningStaff: "SiteCleaningStaff",
  /** 管理者用PINコード。拠点単位で共通 */
  SiteManager: "SiteManager",
} as const;

export type AccessKeyType = (typeof AccessKeyType)[keyof typeof AccessKeyType];
/** アクセスルートグループに表示する交通手段アイコン */
export const AccessRouteTransportIcon = {
  Bicycle: "Bicycle",
  Bus: "Bus",
  Car: "Car",
  Ferry: "Ferry",
  Other: "Other",
  Plane: "Plane",
  Train: "Train",
  Walk: "Walk",
} as const;

export type AccessRouteTransportIcon =
  (typeof AccessRouteTransportIcon)[keyof typeof AccessRouteTransportIcon];
/** トップ画面からいつでもアクセスできる予約カレンダーの種類 */
export const AccessibleReservationCalendarType = {
  BusinessPlan: "BusinessPlan",
  CoOwnersPlan: "CoOwnersPlan",
  FullOwnerPlan: "FullOwnerPlan",
  StaffPlan: "StaffPlan",
  StandardPlan: "StandardPlan",
  TrialPlan: "TrialPlan",
} as const;

export type AccessibleReservationCalendarType =
  (typeof AccessibleReservationCalendarType)[keyof typeof AccessibleReservationCalendarType];
/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type Accommodation = {
  __typename: "Accommodation";
  /** 解錠できるアクセスキーのみ返す。未発行・ウィンドウ無し（滞在中など）・期間切れは null。JTAS には SiteCleaningStaff のみ */
  accessKey?: Maybe<AccommodationAccessKey>;
  /**
   * 部屋クラス。provider ごとの改定ルール適用前の宿泊日は null。
   * provider 引数と nullable は移行期のためのもので、forBiz の移行が完了する 2028/5 宿泊以降は不要になるので、
   * その時点で provider を外して non-null に変更する。
   * `class` は多くの言語で予約語のため、冗長だが型名に揃えて accommodationClass にしている
   */
  accommodationClass?: Maybe<AccommodationClass>;
  /** 建築タイプ */
  architectureType: ArchitectureType;
  /**
   * 空室かどうか（日付・期間指定）
   * プランによって、見れる範囲が制限されている。
   */
  availabilities: Array<AccommodationAvailability>;
  /**
   * provider の所有クラスから見た、部屋クラスの上下関係。
   * 所有クラスを持たない provider（オーナー系・Stay Gift from Owners 以外）と改定ルール適用前の宿泊日は null
   */
  classRelation?: Maybe<AccommodationClassRelation>;
  /**
   * 拠点内における名前
   * 例：1012, Crea
   */
  code: Scalars["String"]["output"];
  /** 施設のコンテンツ */
  content: AccommodationContent;
  /**
   * 施設に紐づく機器一覧。
   * 滞在中（チェックイン後〜チェックアウトまで）の予約を持つユーザーにのみ返す。
   * admin は滞在の有無に関わらず取得できる。それ以外には空リストを返す。
   */
  equipments: Array<AccommodationEquipment>;
  /** 設備一覧（管理用、IDを含む） */
  facilities: Array<AccommodationFacility>;
  /** 設備の一覧 */
  facilityTypes: Array<AccommodationFacilityType>;
  id: Scalars["ID"]["output"];
  /** 自己所有物件かどうか。Stay Gift from Owners は発行元オーナーの所有で判定する */
  isOwned: Scalars["Boolean"]["output"];
  /**
   * 名前(computed)
   * 拠点名を合わせた、グローバルな呼び名（例：一宮1st 1101、Amatsumi 安曇野）
   */
  name: Scalars["String"]["output"];
  /** 施設に関するお知らせ（旧予約カード案内） */
  notices: Array<AccommodationNotice>;
  /**
   * 運用タイプ。予約リードタイムと同じ基準（改定日時点の運用設定）で解決する。
   * 公開前の拠点で運用グループが未設定の部屋は null
   */
  operationType?: Maybe<AccommodationOperationType>;
  /** 紐づいた RemoteLOCK のデバイス ID（未設定の場合は null）。登録時に RemoteLOCK と突き合わせて検証済み */
  remoteLockDeviceId?: Maybe<Scalars["String"]["output"]>;
  /** ルームタイプ。`otaRoomUnit` の紐付けが無い accommodation では null。 */
  roomType?: Maybe<RoomType>;
  /** 施設に紐づくエッジデバイス一覧 */
  sanuEdgeDevices: Array<SanuEdgeDevice>;
  /** 施設がある拠点 */
  site: Site;
  /**
   * 並び順
   * 通常並び順を意識する必要はないが、管理ページで編集するために必要。
   */
  sort: Scalars["Int"]["output"];
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationAccessKeyArgs = {
  keyType: AccessKeyType;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationAccommodationClassArgs = {
  night: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationAvailabilitiesArgs = {
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  occupancyLimitTarget?: InputMaybe<OccupancyLimitTargetType>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationClassRelationArgs = {
  night: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationFacilityTypesArgs = {
  date?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationIsOwnedArgs = {
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/** スタッフ用アクセスキー（PINコード）の当月の状態。解錠できるときだけ返るため各フィールドは必ず揃う */
export type AccommodationAccessKey = {
  __typename: "AccommodationAccessKey";
  /** 有効期間の終了時刻。範囲の意味は startsAt と同じ */
  endsAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** デバイスまで PIN が届いたとみなせるか。RemoteLOCK へは問い合わせず最後の書き込みから 1 時間経過で判定する */
  isSynced: Scalars["Boolean"]["output"];
  /** 当月の有効なPINコード */
  pin: Scalars["String"]["output"];
  /** 有効期間の開始時刻。清掃キーは今日の入室ウィンドウ、管理者キーは当月いっぱい */
  startsAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

/** 宿泊施設の空室情報 */
export type AccommodationAvailability = {
  __typename: "AccommodationAvailability";
  /** ブロック情報 */
  block?: Maybe<AccommodationAvailabilityBlock>;
  date: Scalars["PlainDate"]["output"];
  /**
   * 必ず発生する一泊あたり料金
   * 2023/11時点だと、基本料金＋繁忙日料金＋施設追加料金＋設備利用料金（マストのもの）
   */
  guaranteedPrice?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 予約可能な日付の範囲で空室かどうか
   * Note: 予約可能な施設かどうかは反映されていない
   */
  isAvailable: Scalars["Boolean"]["output"];
};

/** 宿泊施設の利用ブロック（管理用） */
export type AccommodationAvailabilityBlock = {
  __typename: "AccommodationAvailabilityBlock";
  /** ブロックする宿泊施設（指定しない場合は拠点全体） */
  accommodation?: Maybe<Accommodation>;
  /** ブロックの開始日 */
  beginNight: Scalars["PlainDate"]["output"];
  /**
   * 一括作成でまとめて作成された予約ブロックを紐付けるID。
   * internalBulkCreateAccommodationAvailabilityBlocksで作成された場合のみ設定される。
   */
  bulkCreateId?: Maybe<Scalars["ID"]["output"]>;
  /** カテゴリー */
  category: AccommodationAvailabilityBlockCategory;
  /** カテゴリ情報 */
  categoryInfo: AccommodationAvailabilityBlockCategoryInfo;
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 作成者 */
  createdByUser?: Maybe<User>;
  /** ブロックの終了日 */
  endNight: Scalars["PlainDate"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * 一時的なブロックであることを示すフラグ
   * 予約当日には予約ブロックとして利用されないことを想定する
   */
  isTentative: Scalars["Boolean"]["output"];
  /** 名前。外部パートナーには伏字で返す */
  name: Scalars["String"]["output"];
  /** メモ。外部パートナーには伏字で返す */
  note: Scalars["String"]["output"];
  /** ブロックする拠点 */
  site: Site;
  /** 社内スタッフグループ */
  staffGroup?: Maybe<StaffGroup>;
  /** 更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 更新者 */
  updatedByUser?: Maybe<User>;
};

export const AccommodationAvailabilityBlockCategory = {
  /** @deprecated MaintenanceInspection / MaintenanceConstruction を使用してください */
  AccommodationMaintenance: "AccommodationMaintenance",
  /** @deprecated 点検・工事関連のカテゴリを使用してください */
  AccommodationSpecChange: "AccommodationSpecChange",
  /** @deprecated OpsBeforeOpening を使用してください */
  BeforeFirstUse: "BeforeFirstUse",
  /** 清掃調整 */
  CleaningAdjustment: "CleaningAdjustment",
  /** その他清掃 */
  CleaningOther: "CleaningOther",
  /** 特別清掃 */
  CleaningSpecial: "CleaningSpecial",
  /** CSp対応 */
  CustomerSupport: "CustomerSupport",
  /** @deprecated MaintenanceLandscape を使用してください */
  LandscapeMaintenance: "LandscapeMaintenance",
  /** @deprecated OpsLastMinuteCancellation を使用してください */
  LastMinuteCancellation: "LastMinuteCancellation",
  /** 工事 */
  MaintenanceConstruction: "MaintenanceConstruction",
  /** 点検 */
  MaintenanceInspection: "MaintenanceInspection",
  /** 植栽 */
  MaintenanceLandscape: "MaintenanceLandscape",
  /** その他点検・工事 */
  MaintenanceOther: "MaintenanceOther",
  /** OTA枠確保(プログラムから作成) */
  OnlineTravelAgent: "OnlineTravelAgent",
  /** 開業前 */
  OpsBeforeOpening: "OpsBeforeOpening",
  /** 直前減泊 */
  OpsLastMinuteCancellation: "OpsLastMinuteCancellation",
  /** その他オペレーション調整 */
  OpsOther: "OpsOther",
  /** SANU外部起因トラブル */
  OpsTemporaryClose: "OpsTemporaryClose",
  /** トラブル解決待ち */
  OpsTroubleWaiting: "OpsTroubleWaiting",
  /** 撮影・取材 */
  OtherShooting: "OtherShooting",
  /** @deprecated ReservationForStaff / ReservationForStakeholder などを使用してください */
  PromotionalUse: "PromotionalUse",
  /** 法人合宿 */
  ReservationForBusiness: "ReservationForBusiness",
  /** アーリーチェックイン用(プログラムから作成) */
  ReservationForEarlyCheckIn: "ReservationForEarlyCheckIn",
  /** イベント利用 */
  ReservationForEvent: "ReservationForEvent",
  /** 社員宿泊 */
  ReservationForStaff: "ReservationForStaff",
  /** 招待宿泊 */
  ReservationForStakeholder: "ReservationForStakeholder",
  /** その他宿泊用 */
  ReservationOther: "ReservationOther",
  /** @deprecated CleaningSpecial を使用してください */
  SpecialCleaning: "SpecialCleaning",
  /** @deprecated OpsTroubleWaiting などを使用してください */
  Trouble: "Trouble",
} as const;

export type AccommodationAvailabilityBlockCategory =
  (typeof AccommodationAvailabilityBlockCategory)[keyof typeof AccommodationAvailabilityBlockCategory];
/** 予約ブロックカテゴリの詳細情報 */
export type AccommodationAvailabilityBlockCategoryInfo = {
  __typename: "AccommodationAvailabilityBlockCategoryInfo";
  /** カテゴリグループ */
  categoryGroup: Scalars["String"]["output"];
  /** カテゴリキー */
  key: AccommodationAvailabilityBlockCategory;
  /** 表示ラベル */
  label: Scalars["String"]["output"];
  /** 説明 */
  note: Scalars["String"]["output"];
};

/**
 * ブロック解放スケジュール
 *
 * チェックイン N 日前のバッチ実行時に、現在のブロック室数が
 * blockRoomCountUpperLimit を超えていれば上限値まで自動解除する。
 * 0 を指定するとその日数で全解除する。
 */
export type AccommodationAvailabilityBlockReleaseSchedule = {
  __typename: "AccommodationAvailabilityBlockReleaseSchedule";
  /** 維持するブロック室数の上限（0 = 全解除） */
  blockRoomCountUpperLimit: Scalars["Int"]["output"];
  /** チェックインN日前 */
  daysBeforeCheckin: Scalars["Int"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /** 拠点ID */
  siteId: Scalars["ID"]["output"];
};

/** クラス。アルファベットが後ろほど上位（E < F < G）。 */
export const AccommodationClass = {
  E: "E",
  F: "F",
  G: "G",
} as const;

export type AccommodationClass =
  (typeof AccommodationClass)[keyof typeof AccommodationClass];
/** 所有クラスから見た部屋クラスの上下関係 */
export const AccommodationClassRelation = {
  Higher: "Higher",
  Lower: "Lower",
  Same: "Same",
} as const;

export type AccommodationClassRelation =
  (typeof AccommodationClassRelation)[keyof typeof AccommodationClassRelation];
/** 施設コンテンツ */
export type AccommodationContent = {
  __typename: "AccommodationContent";
  /** 設備マニュアルの外部リンク */
  manualUrl?: Maybe<Scalars["String"]["output"]>;
};

/** 宿泊施設の機器 */
export type AccommodationEquipment = {
  __typename: "AccommodationEquipment";
  /** この機器が設置されている宿泊施設 */
  accommodation: Accommodation;
  /** 機器種別ごとの固有情報。将来的に状態・制御方法もこの中で機器ごとに扱う。 */
  attribute?: Maybe<AccommodationEquipmentAttribute>;
  /** 一覧用の短い説明文 */
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 機器名（例: Wi-Fi, Music Connect） */
  name: Scalars["String"]["output"];
  /** 一覧での表示順。小さいほど先頭 */
  sort: Scalars["Int"]["output"];
  /** 公開ステータス */
  status: AccommodationEquipmentStatusType;
  /** 機器種別 */
  type: AccommodationEquipmentType;
};

/** 機器種別ごとの固有情報 */
export type AccommodationEquipmentAttribute =
  | MusicConnectEquipmentAttribute
  | SaunaEquipmentAttribute
  | WifiEquipmentAttribute;

/**
 * 機器の公開ステータス。
 * Draft < Preview < PublishedForSanuStaff < Published の順に公開範囲が広がる。
 */
export const AccommodationEquipmentStatusType = {
  /** 準備中。誰にも公開されない */
  Draft: "Draft",
  /** admin にのみ公開 */
  Preview: "Preview",
  /** 全ユーザーに公開 */
  Published: "Published",
  /** @sa-nu.com のユーザーまたは admin に公開 */
  PublishedForSanuStaff: "PublishedForSanuStaff",
} as const;

export type AccommodationEquipmentStatusType =
  (typeof AccommodationEquipmentStatusType)[keyof typeof AccommodationEquipmentStatusType];
/** 機器種別 */
export const AccommodationEquipmentType = {
  MusicConnect: "MusicConnect",
  Sauna: "Sauna",
  Wifi: "Wifi",
} as const;

export type AccommodationEquipmentType =
  (typeof AccommodationEquipmentType)[keyof typeof AccommodationEquipmentType];
/** 宿泊施設の種類 */
export type AccommodationFacility = {
  __typename: "AccommodationFacility";
  id: Scalars["ID"]["output"];
  slug: Scalars["String"]["output"];
  type: AccommodationFacilityType;
};

/** 宿泊施設設備フィルタータイプ */
export const AccommodationFacilityFilterType = {
  Exclude: "Exclude",
  Include: "Include",
} as const;

export type AccommodationFacilityFilterType =
  (typeof AccommodationFacilityFilterType)[keyof typeof AccommodationFacilityFilterType];
/** 宿泊施設に付属する設備 */
export const AccommodationFacilityType = {
  DogFriendly: "DogFriendly",
  DogRun: "DogRun",
  EvCharger: "EVCharger",
  Onsen: "Onsen",
  Sauna: "Sauna",
  Workation: "Workation",
} as const;

export type AccommodationFacilityType =
  (typeof AccommodationFacilityType)[keyof typeof AccommodationFacilityType];
/**
 * 宿泊料金
 * 宿泊料金とは、有料備品の利用を除く、チェックアウト日までに請求される料金のこと。
 * 例えば、ベース料金、土祝料金、リノベ料金、サウナ料金、清掃料金、Dog料金、EV料金、NoShow料金、キャンセル料金など。
 * チェックアウト日より後に請求される料金として、月末に決済される8泊目以降追加料金がある。
 */
export type AccommodationFee = {
  __typename: "AccommodationFee";
  /** 請求方法 - AutoChargeの場合は自動請求、Manualの場合は別途請求 */
  billingMethod: BillingMethod;
  /** 別途請求の詳細 - billingMethodがManualの場合のみ存在します。 */
  billingMethodManualDetail?: Maybe<Scalars["String"]["output"]>;
  /** 有料備品の免除一覧 */
  consumedSupplyFeeItemWaivers: Array<ConsumedSupplyFeeItemWaiver>;
  /** 料金の項目 */
  items: Array<AccommodationFeeItem>;
  /** 請求・支払いの状態（管理者向け）。下書き/プレビューの予約では null。 */
  status?: Maybe<AccommodationFeeStatus>;
  /** Stripe請求書ID */
  stripeInvoiceId?: Maybe<Scalars["String"]["output"]>;
  /** 料金の合計 */
  totalAmount: Scalars["Int"]["output"];
};

/** 宿泊予約に対して適用されるオプション料金の請求有無の設定 */
export type AccommodationFeeApplicability = {
  __typename: "AccommodationFeeApplicability";
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["output"];
  waiveDogFee: Scalars["Boolean"]["output"];
  waiveDogRunFee: Scalars["Boolean"]["output"];
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  waiveOnsenFee: Scalars["Boolean"]["output"];
  waiveSaunaFee: Scalars["Boolean"]["output"];
};

/** 宿泊料金の割引情報（チケットマスタの料金ルール由来）。 */
export type AccommodationFeeDiscount = {
  __typename: "AccommodationFeeDiscount";
  /** 料金修正値 */
  feeModifier: Scalars["Int"]["output"];
  /** 料金修正タイプ */
  feeModifierType: FeeModifierType;
  /**
   * 対象の泊数。ruleType により意味が異なる:
   * NightFeeModifier は対象の泊（N 泊目）、ConsecutiveNightDiscount は適用閾値（この泊数以上で適用）。
   */
  night: Scalars["Int"]["output"];
  /** 宿泊料金ルールタイプ */
  ruleType: AccommodationFeeRuleType;
};

export type AccommodationFeeInput = {
  /** 請求方法 - AutoChargeの場合は自動請求、Manualの場合は別途請求 */
  billingMethod?: InputMaybe<BillingMethod>;
  /** 別途請求の詳細 - billingMethodがManualの場合のみ使用されます。 */
  billingMethodManualDetail?: InputMaybe<Scalars["String"]["input"]>;
  items: Array<AccommodationFeeItemInput>;
};

export type AccommodationFeeItem = {
  __typename: "AccommodationFeeItem";
  /** 料金の金額 */
  amount: Scalars["Int"]["output"];
  /** 作成日時 */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** 料金種別を区別するためのキー */
  key: Scalars["ID"]["output"];
  /** 項目名 */
  label: Scalars["String"]["output"];
  /** 日付（料金の種類が PER_NIGHT の場合のみ） */
  night?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 利用した宿泊チケット */
  stayTicket?: Maybe<StayTicket>;
  /** 消費税率 */
  taxRate: Scalars["Float"]["output"];
  /** 料金の種類 */
  type: AccommodationFeeItemPerType;
};

/** 管理画面から設定される宿泊料金の項目。消費税は10%固定。 */
export type AccommodationFeeItemInput = {
  amount: Scalars["Int"]["input"];
  key: Scalars["String"]["input"];
  night?: InputMaybe<Scalars["PlainDate"]["input"]>;
  type: AccommodationFeeItemPerType;
};

export const AccommodationFeeItemPerType = {
  /** 1泊あたりの料金 */
  PerNight: "PerNight",
  /** 1滞在あたりの料金 */
  PerStay: "PerStay",
} as const;

export type AccommodationFeeItemPerType =
  (typeof AccommodationFeeItemPerType)[keyof typeof AccommodationFeeItemPerType];
/** 宿泊料金設定ルール */
export type AccommodationFeeRule = {
  __typename: "AccommodationFeeRule";
  /** 料金修正値 */
  feeModifier: Scalars["Int"]["output"];
  /** 料金修正タイプ */
  feeModifierType: FeeModifierType;
  id: Scalars["ID"]["output"];
  /** 対象の夜（1から始まる） */
  night: Scalars["Int"]["output"];
  /** ルールタイプ */
  ruleType: AccommodationFeeRuleType;
};

/** 宿泊料金設定ルールの入力 */
export type AccommodationFeeRuleInput = {
  /** 料金修正値 */
  feeModifier: Scalars["Int"]["input"];
  /** 料金修正タイプ */
  feeModifierType: FeeModifierType;
  /** 対象の夜（1から始まる） */
  night: Scalars["Int"]["input"];
  /** ルールタイプ */
  ruleType: AccommodationFeeRuleType;
};

/** 料金ルールタイプ */
export const AccommodationFeeRuleType = {
  /** 連泊割引 */
  ConsecutiveNightDiscount: "ConsecutiveNightDiscount",
  FreeNight: "FreeNight",
  /** 特定の泊に対する料金修正 */
  NightFeeModifier: "NightFeeModifier",
} as const;

export type AccommodationFeeRuleType =
  (typeof AccommodationFeeRuleType)[keyof typeof AccommodationFeeRuleType];
/** 宿泊料金の請求・支払いライフサイクル。 */
export const AccommodationFeeStatus = {
  /** 未確定（宿泊料金の確定待ち） */
  Draft: "Draft",
  /** 請求書発行済み・支払い待ち */
  InvoiceOpen: "InvoiceOpen",
  /** 支払い完了 */
  InvoicePaid: "InvoicePaid",
  /** 支払い失敗 */
  InvoicePaymentFailed: "InvoicePaymentFailed",
  /** 支払いにユーザーの追加操作が必要 */
  InvoiceRequiresAction: "InvoiceRequiresAction",
  /** 確定済み・請求書発行待ち */
  Open: "Open",
  /** 別途請求（Stripe 自動請求の対象外） */
  Unknown: "Unknown",
} as const;

export type AccommodationFeeStatus =
  (typeof AccommodationFeeStatus)[keyof typeof AccommodationFeeStatus];
/** 施設に関するお知らせ */
export type AccommodationNotice = {
  __typename: "AccommodationNotice";
  /** このお知らせを出している宿泊施設 */
  accommodations: Array<Accommodation>;
  /** infoの内容（50文字まで） */
  brief: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  /** 作成者（管理用） */
  createdUser: User;
  /** infoの内容（300文字まで） */
  detail?: Maybe<Scalars["String"]["output"]>;
  /**
   * お知らせの対象期間の終了日。
   * この期間と重なる予約に対してお知らせが提供される（予約期間との重複で判定される）。
   * 閲覧画面での「表示終了日」ではない点に注意。
   */
  endDate: Scalars["PlainDate"]["output"];
  /** infoに関する外部webサイトなどの参照urlが入る */
  externalUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 更新者（管理用） */
  lastUpdatedUser: User;
  /** 対象者にメールで通知するか（管理用） */
  sendEmailToExpectedUsers: Scalars["Boolean"]["output"];
  /**
   * お知らせの対象期間の開始日。
   * この期間と重なる予約に対してお知らせが提供される（予約期間との重複で判定される）。
   * 閲覧画面での「表示開始日」ではない点に注意。
   */
  startDate: Scalars["PlainDate"]["output"];
  /** 公開ステータス（管理用） */
  status: AccommodationNoticeStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

/** 宿泊施設お知らせのステータス（管理用） */
export const AccommodationNoticeStatus = {
  /** 公開中 */
  Active: "Active",
  /** 下書き */
  Draft: "Draft",
  /** 非公開 */
  Unpublished: "Unpublished",
} as const;

export type AccommodationNoticeStatus =
  (typeof AccommodationNoticeStatus)[keyof typeof AccommodationNoticeStatus];
/** 運用グループ。拠点 × 建築タイプの単位で運用タイプ・クラス・追加料金を割り当てる */
export type AccommodationOperationGroup = {
  __typename: "AccommodationOperationGroup";
  architectureType: ArchitectureType;
  id: Scalars["ID"]["output"];
  /** 設定値の一覧（effectiveFrom の昇順）。現状は 1 件だけ */
  settings: Array<AccommodationOperationGroupSetting>;
};

/** 運用グループの設定値 */
export type AccommodationOperationGroupSetting = {
  __typename: "AccommodationOperationGroupSetting";
  /** 法人プランで泊まるときの 1 泊あたりの追加料金 */
  additionalFeeForBusinessPlan: Scalars["Int"]["output"];
  /** E クラスのオーナーが泊まるときの 1 泊あたりの追加料金 */
  additionalFeeForClassEOwner: Scalars["Int"]["output"];
  /** F クラスのオーナーが泊まるときの 1 泊あたりの追加料金 */
  additionalFeeForClassFOwner: Scalars["Int"]["output"];
  class: AccommodationClass;
  /** 適用開始日、この宿泊日から適用 */
  effectiveFrom: Scalars["PlainDate"]["output"];
  id: Scalars["ID"]["output"];
  operationType: AccommodationOperationType;
};

/** 運用タイプ */
export const AccommodationOperationType = {
  CoOwners: "CoOwners",
  FullOwner: "FullOwner",
  Open: "Open",
} as const;

export type AccommodationOperationType =
  (typeof AccommodationOperationType)[keyof typeof AccommodationOperationType];
/**
 * 宿泊予約
 * システムにより在庫が確保されている。
 */
export type AccommodationReservation = {
  __typename: "AccommodationReservation";
  /** 部屋を解錠するための暗証番号 */
  accessCode?: Maybe<Scalars["String"]["output"]>;
  /** 滞在先の施設 */
  accommodation: Accommodation;
  /** 施設に関するお知らせ（旧予約カード案内） */
  accommodationNotices: Array<AccommodationNotice>;
  /** 利用可能な追加の鍵の情報 */
  additionalKeySet: AccommodationReservationAdditionalKeySet;
  /** キャンセルできるかどうか */
  canCancel: Scalars["Boolean"]["output"];
  /** 現時点でチェックインできるかどうか */
  canCheckIn: Scalars["Boolean"]["output"];
  /** 現時点でチェックアウトできるかどうか */
  canCheckOut: Scalars["Boolean"]["output"];
  /**
   * One more Cabin を予約できるかどうか
   * （すでに One more Cabin を予約済みの場合も false となる）
   */
  canReserveOneMoreCabin: Scalars["Boolean"]["output"];
  /** キャンセル日時（キャンセルされていない場合は null） */
  canceledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * この予約に適用されるキャンセルポリシー（表示用）。
   * 精算ロジックと同一のドメイン関数から生成される。
   */
  cancellationPolicyContent?: Maybe<CancellationPolicyContent>;
  /** チェックイン用QRコード */
  checkInQrCode?: Maybe<CheckInQrCode>;
  /** チェックイン時刻 */
  checkedInAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** チェックイン場所 */
  checkedInGeoLocation?: Maybe<GeoLocation>;
  /** チェックアウト時刻 */
  checkedOutAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 有料備品の利用料金 */
  consumedSuppliesFee: ConsumedSuppliesFee;
  /** 予約の作成時刻 */
  createdAt: Scalars["DateTime"]["output"];
  /**
   * この予約を作成したユーザー
   * 通常のサブスクの場合は user と同じだが、招待や管理者による予約などの場合に異なる
   */
  createdUser?: Maybe<User>;
  /** 現在時刻でのアーリーチェックイン料金（アーリーチェックイン対象の場合のみ） */
  currentEarlyCheckInFee?: Maybe<Scalars["Int"]["output"]>;
  /** フォームに入力した詳細情報 */
  detail: AccommodationReservationDetail;
  /** アーリーチェックイン対象かどうか */
  earlyCheckInEligible: Scalars["Boolean"]["output"];
  /** アーリーチェックインの料金テーブル（アーリーチェックイン対象の場合のみ） */
  earlyCheckInPriceTable?: Maybe<Array<EarlyCheckInPriceSlot>>;
  /**
   * ECI 表示状態。
   * - HIDDEN: ECI 案内も表示しない
   * - VISIBLE: ECI 案内ラベルのみ表示（実行不可、現在 ECI 料金時間帯外）
   * - AVAILABLE: 案内 + チェックイン実行可能（現在 ECI 料金時間帯内）
   */
  earlyCheckInStatus: EarlyCheckInStatus;
  /** 付帯サービス一覧 */
  facilities: Array<Facility>;
  /** 付帯サービスの利用料金 */
  facilityFee: FacilityFee;
  /** 付帯サービス予約一覧 */
  facilityReservations: Array<FacilityReservation>;
  /** 宿泊施設の利用料金 */
  fee: AccommodationFee;
  /** 料金計算に際して利用されたオプション料金の請求有無の設定 */
  feeApplicability: AccommodationFeeApplicability;
  /** 滞在初日 */
  firstDate: Scalars["PlainDate"]["output"];
  /**
   * いつから
   * カレンダー上で選択する、最初の日。この日の午後から滞在が可能。
   */
  firstNight: Scalars["PlainDate"]["output"];
  /**
   * チェックイン・清掃で照合するための宿泊者名。会員予約は User.name、OTA 予約は otaDetail の姓名。
   * User オブジェクトそのものは UsersRead が要る。
   */
  guestName?: Maybe<Scalars["String"]["output"]>;
  /** キャンセルされたかどうか */
  hasCanceled: Scalars["Boolean"]["output"];
  /** 施設にサウナデバイスが紐づいているかどうか */
  hasSanuDevices: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** 招待URL（まだユーザーに紐づいていない仮予約の場合に存在） */
  invitationUrl?: Maybe<Scalars["String"]["output"]>;
  /** 付帯サービス種別の追加予約が可能かどうか */
  isFacilityReservable: Scalars["Boolean"]["output"];
  /** 部屋タイプ予約として作成された予約か */
  isRoomTypeReservation: Scalars["Boolean"]["output"];
  /** サウナコントロールにアクセスできるかどうか */
  isSaunaControlAccessible: Scalars["Boolean"]["output"];
  /** 仮予約かどうか */
  isTentative: Scalars["Boolean"]["output"];
  /** 滞在最終日（予約した日の翌日） */
  lastDate: Scalars["PlainDate"]["output"];
  /**
   * いつまで
   * カレンダー上で選択する、最後の日。この日の翌日の朝まで滞在は可能。
   */
  lastNight: Scalars["PlainDate"]["output"];
  /**
   * この予約の宿泊に適用される地方税ポリシー。
   * 宿泊税は拠点、入湯税は棟に紐づくが、有効期間の判定に滞在日が要るため予約側で解決する。
   */
  localTaxPolicies: Array<LocalTaxPolicy>;
  /** 予約内容の変更ができる範囲 */
  mutationScope: AccommodationReservationMutationScope;
  /** 泊数(computed) */
  nights: Scalars["Int"]["output"];
  /** One more Cabin の予約情報 */
  oneMoreCabinAccommodationReservation?: Maybe<AccommodationReservation>;
  /** OTA予約の詳細情報 */
  otaDetail?: Maybe<AccommodationReservationOtaDetail>;
  /** 予約が作成された根拠 */
  provider: AccommodationReservationProvider;
  /** 予約の開始時刻(computed) */
  reservedFrom: Scalars["ZonedDateTime"]["output"];
  /** 予約の終了時刻(computed) */
  reservedTo: Scalars["ZonedDateTime"]["output"];
  /** 旧滞在レビュー回答 */
  review?: Maybe<StayReview>;
  /**
   * 表示用の標準チェックイン時刻。
   * ECI対象でも入室基準時刻（reservedFrom）ではなくこの値を表示に用いる。表示専用。
   */
  standardCheckInTime: Scalars["ZonedDateTime"]["output"];
  /** 新滞在レビュー回答 */
  stayReviewResponse?: Maybe<StayReviewResponse>;
  /** 滞在レビュー 2.0。null は未着手 */
  stayReviewV2?: Maybe<StayReviewV2>;
  /** 滞在ステータス */
  stayStatus: AccommodationReservationStayStatus;
  /** チケット予約の情報 */
  stayTicketUnit?: Maybe<StayTicketUnit>;
  /** 仮予約確定の期限 */
  tentativeDeadline?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** この予約を所有しているユーザー */
  user?: Maybe<User>;
  /** 仮予約コード */
  userAcceptCode?: Maybe<Scalars["String"]["output"]>;
  /** 同伴者 */
  userCompanions: Array<UserCompanion>;
};

/**
 * 宿泊予約
 * システムにより在庫が確保されている。
 */
export type AccommodationReservationFacilityReservationsArgs = {
  facilityType?: InputMaybe<FacilityType>;
  status?: InputMaybe<FacilityReservationStatusType>;
};

/**
 * 宿泊予約
 * システムにより在庫が確保されている。
 */
export type AccommodationReservationIsFacilityReservableArgs = {
  facilityType: FacilityType;
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 宿泊予約に紐づく追加の鍵の情報 */
export type AccommodationReservationAdditionalKeySet = {
  __typename: "AccommodationReservationAdditionalKeySet";
  /** コワーキングスペースの鍵 */
  coWorkingSpaceKey?: Maybe<CoWorkingSpaceKey>;
};

export type AccommodationReservationChange = {
  __typename: "AccommodationReservationChange";
  from: Scalars["String"]["output"];
  to: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type AccommodationReservationCheckOutAvailabilitiesInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
  reservationIdForChange?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccommodationReservationCheckOutAvailabilitiesPayload = {
  __typename: "AccommodationReservationCheckOutAvailabilitiesPayload";
  items: Array<AccommodationReservationCheckOutItem>;
};

export type AccommodationReservationCheckOutItem = {
  __typename: "AccommodationReservationCheckOutItem";
  /** 1泊増やすことによる追加料金 */
  additionalNightsFee: Scalars["Int"]["output"];
  /** そのチェックアウト日が選択可能かどうか */
  available: Scalars["Boolean"]["output"];
  /** ブロック情報 */
  block?: Maybe<AccommodationAvailabilityBlock>;
  /** チェックアウト日 */
  date: Scalars["PlainDate"]["output"];
  /**
   * このチェックアウト日（= この滞在日数）で実際に適用される割引（applied）。
   * StayTicket かつ負の修正値の場合のみ。ラダー全段（master）は
   * AccommodationReservationCheckOutAvailabilitiesPayload.discounts を参照。
   */
  discounts: Array<AccommodationFeeDiscount>;
};

/** 滞在予約でフォームに入力する詳細情報 */
export type AccommodationReservationDetail = {
  __typename: "AccommodationReservationDetail";
  /**
   * 部屋変更を許可する
   * One more CabinやEV充電器利用時は強制的にfalse
   */
  allowRoomChange: Scalars["Boolean"]["output"];
  /**
   * 愛犬を同伴する
   * 設備にDogfriendlyがある場合のみ true にできる
   */
  bringDog: Scalars["Boolean"]["output"];
  /**
   * アーリーチェックインで支払った料金（税込）
   * 管理者のみ閲覧可能
   */
  earlyCheckInFee?: Maybe<Scalars["Int"]["output"]>;
  /**
   * アーリーチェックインで選択した時間帯スロット
   * 管理者のみ閲覧可能
   */
  earlyCheckInSlot?: Maybe<EarlyCheckInPriceSlot>;
  /** 内部管理用スタンプ（絵文字） */
  internalStamp?: Maybe<Scalars["String"]["output"]>;
  /** 行先地 */
  nextLocation: Scalars["String"]["output"];
  /** 大人人数 */
  numberOfAdults: Scalars["Int"]["output"];
  /** 愛犬を同伴する場合の頭数 */
  numberOfDogs: Scalars["Int"]["output"];
  /** 5歳以下の子供人数 */
  numberOfInfants: Scalars["Int"]["output"];
  /** 12歳未満の子供人数 */
  numberOfKids: Scalars["Int"]["output"];
  /** 合計の子供人数 */
  numberOfTotalChildren: Scalars["Int"]["output"];
  /** 前泊地 */
  previousLocation: Scalars["String"]["output"];
  /**
   * EV充電器を利用する
   * 設備にEVChargerがある場合のみ true にできる
   */
  useEvCharger: Scalars["Boolean"]["output"];
};

export type AccommodationReservationDetailInput = {
  /** 部屋変更を許可する */
  allowRoomChange?: InputMaybe<Scalars["Boolean"]["input"]>;
  bringDog: Scalars["Boolean"]["input"];
  internalStamp?: InputMaybe<Scalars["String"]["input"]>;
  nextLocation: Scalars["String"]["input"];
  numberOfAdults: Scalars["Int"]["input"];
  numberOfDogs: Scalars["Int"]["input"];
  numberOfInfants: Scalars["Int"]["input"];
  numberOfKids: Scalars["Int"]["input"];
  previousLocation: Scalars["String"]["input"];
  useEvCharger: Scalars["Boolean"]["input"];
};

export const AccommodationReservationMutationScope = {
  /** 何も変更できない */
  Freezed: "Freezed",
  /** 宿泊施設・いつから・いつまで滞在するかの変更ができる */
  NoLimit: "NoLimit",
  /** いつまで滞在するかのみ変更ができる */
  OnlyExit: "OnlyExit",
} as const;

export type AccommodationReservationMutationScope =
  (typeof AccommodationReservationMutationScope)[keyof typeof AccommodationReservationMutationScope];
/** 滞在予約でフォームに入力する詳細情報のうち、料金計算に関わる情報 */
export type AccommodationReservationOptions = {
  __typename: "AccommodationReservationOptions";
  bringDog: Scalars["Boolean"]["output"];
  numberOfDogs: Scalars["Int"]["output"];
  useEvCharger: Scalars["Boolean"]["output"];
};

export type AccommodationReservationOtaDetail = {
  __typename: "AccommodationReservationOtaDetail";
  address?: Maybe<Scalars["String"]["output"]>;
  apiMessage?: Maybe<Scalars["String"]["output"]>;
  apiReference?: Maybe<Scalars["String"]["output"]>;
  apiSource?: Maybe<Scalars["String"]["output"]>;
  arrivalTime?: Maybe<Scalars["String"]["output"]>;
  bookingTime?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  cancelTime?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  channel?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  comments?: Maybe<Scalars["String"]["output"]>;
  commission?: Maybe<Scalars["Int"]["output"]>;
  company?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  deposit?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  languageCode?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  modifiedTime?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  postCode?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<Scalars["Int"]["output"]>;
  pricePerRoom?: Maybe<Scalars["Int"]["output"]>;
  rateDescription?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  referer?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type AccommodationReservationProvider =
  | BusinessPlanAccommodationReservationProvider
  | CoOwnersPlanAccommodationReservationProvider
  | FullOwnerPlanAccommodationReservationProvider
  | OneMoreCabinAccommodationReservationProvider
  | OnlineTravelAgentAccommodationReservationProvider
  | SanuIncAccommodationReservationProvider
  | StaffPlanAccommodationReservationProvider
  | StandardPlanAccommodationReservationProvider
  | StayDirectAccommodationReservationProvider
  | StayTicketAccommodationReservationProvider
  | TrialPlanAccommodationReservationProvider;

export type AccommodationReservationProviderInput = {
  providerOneMoreCabinParentAccommodationReservationId?: InputMaybe<
    Scalars["ID"]["input"]
  >;
  providerOrganizationId?: InputMaybe<Scalars["ID"]["input"]>;
  providerOtaIsIkyuDiamondMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  providerOtaLeadAccommodationReservationId?: InputMaybe<
    Scalars["ID"]["input"]
  >;
  providerSanuIncStaffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  providerSanuIncUsage?: InputMaybe<AccommodationReservationProviderSanuIncUsage>;
  providerStaffContractId?: InputMaybe<Scalars["ID"]["input"]>;
  providerStayTicketUnitId?: InputMaybe<Scalars["ID"]["input"]>;
  providerTrialContractId?: InputMaybe<Scalars["ID"]["input"]>;
  providerType: AccommodationReservationProviderType;
  providerUserOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
  providerUserSubscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * 記録用の宿泊用途
 * これで予約ルールを変更することはせず、もしそれが必要になる場合は Provider として切り出すことを検討する。
 * 管理画面での汎用カスタマイズに対するプリセット定義はして良い。
 */
export const AccommodationReservationProviderSanuIncUsage = {
  /** 開業前宿泊 */
  BeforeOpeningStay: "BeforeOpeningStay",
  /** 法人向け宿泊 */
  BusinessStay: "BusinessStay",
  /** 清掃ありブロック（廃止済み） */
  CleaningBlock: "CleaningBlock",
  /** 清掃あり社内利用（廃止済み） */
  CleaningInternalUse: "CleaningInternalUse",
  /** 社員業務宿泊（廃止済み） */
  EmployeeOperationalStay: "EmployeeOperationalStay",
  /** 請求書払い宿泊（廃止済み） */
  InvoicePaymentStay: "InvoicePaymentStay",
  /** One More Cabin（手動）（廃止済み） */
  OneMoreCabinManual: "OneMoreCabinManual",
  /** OTA宿泊 */
  OnlineTravelAgent: "OnlineTravelAgent",
  /** その他有料宿泊 */
  OtherStay: "OtherStay",
  /** プロモーション宿泊（廃止済み） */
  PromotionStay: "PromotionStay",
  /** プロモ枠利用宿泊 */
  PromotionalStay: "PromotionalStay",
  /** Retreat plan（廃止済み） */
  RetreatPlan: "RetreatPlan",
  /** 社員福利厚生（SANU STAY）（廃止済み） */
  SanuStay: "SanuStay",
  /** ステークホルダー宿泊（廃止済み） */
  StakeholderStay: "StakeholderStay",
  /** トラブル・補填宿泊 */
  TroubleCoverStay: "TroubleCoverStay",
  /** トラブル対応宿泊（廃止済み） */
  TroubleStay: "TroubleStay",
} as const;

export type AccommodationReservationProviderSanuIncUsage =
  (typeof AccommodationReservationProviderSanuIncUsage)[keyof typeof AccommodationReservationProviderSanuIncUsage];
/**
 * 宿泊予約を作成する根拠となる、商品・プラン・権利などのプロパイダー
 * 言い換えると、それによって宿泊予約が受ける各種ビジネスルールが異なるようなもの
 */
export const AccommodationReservationProviderType = {
  BusinessPlan: "BusinessPlan",
  CoOwnersPlan: "CoOwnersPlan",
  FullOwnerPlan: "FullOwnerPlan",
  OneMoreCabin: "OneMoreCabin",
  OnlineTravelAgent: "OnlineTravelAgent",
  SanuInc: "SanuInc",
  StaffPlan: "StaffPlan",
  StandardPlan: "StandardPlan",
  StayDirect: "StayDirect",
  StayTicket: "StayTicket",
  TrialPlan: "TrialPlan",
} as const;

export type AccommodationReservationProviderType =
  (typeof AccommodationReservationProviderType)[keyof typeof AccommodationReservationProviderType];
export const AccommodationReservationStayStatus = {
  /** 滞在しなかった */
  NoStay: "NoStay",
  /** キャンセル済み */
  StayCanceled: "StayCanceled",
  /** 滞在後 */
  Stayed: "Stayed",
  /** 滞在中 */
  Staying: "Staying",
  /** 仮押さえ */
  Tentative: "Tentative",
  /** 滞在前 */
  WillStay: "WillStay",
} as const;

export type AccommodationReservationStayStatus =
  (typeof AccommodationReservationStayStatus)[keyof typeof AccommodationReservationStayStatus];
/**
 * 宿泊施設の絞り込み条件
 * accommodationIdsまたはsiteIdsのどちらか一方のみを指定可能
 */
export type AccommodationScope =
  | { accommodationIds: Array<Scalars["ID"]["input"]>; siteIds?: never }
  | { accommodationIds?: never; siteIds: Array<Scalars["ID"]["input"]> };

/** アカウント連携のアイデンティティ情報 */
export type AccountLinkIdentity = {
  __typename: "AccountLinkIdentity";
  /** Auth0コネクション名 */
  connection: Scalars["String"]["output"];
  /** 認証プロバイダー（例: google-oauth2, apple, auth0） */
  provider: Scalars["String"]["output"];
  /** Auth0ユーザーID */
  userId: Scalars["String"]["output"];
};

/** アカウント連携のプラットフォーム */
export const AccountLinkPlatform = {
  /** ネイティブアプリ */
  Native: "Native",
  /** Webブラウザ */
  Web: "Web",
} as const;

export type AccountLinkPlatform =
  (typeof AccountLinkPlatform)[keyof typeof AccountLinkPlatform];
export type AcquireStayTicketsError = {
  __typename: "AcquireStayTicketsError";
  case: AcquireStayTicketsErrorCase;
};

export const AcquireStayTicketsErrorCase = {
  InvalidRequest: "InvalidRequest",
  NotAuthorized: "NotAuthorized",
  PaymentFailed: "PaymentFailed",
} as const;

export type AcquireStayTicketsErrorCase =
  (typeof AcquireStayTicketsErrorCase)[keyof typeof AcquireStayTicketsErrorCase];
export type AcquireStayTicketsInput = {
  items: Array<StayTicketAcquisitionItem>;
  mode: StayTicketAcquisitionMode;
};

export type AcquireStayTicketsPayload =
  | AcquireStayTicketsError
  | AcquireStayTicketsResult;

export type AcquireStayTicketsResult = {
  __typename: "AcquireStayTicketsResult";
  tickets: Array<StayTicket>;
};

export type ActivateMemberPerksDrinkTicketError = {
  __typename: "ActivateMemberPerksDrinkTicketError";
  case: ActivateMemberPerksDrinkTicketErrorCase;
};

export const ActivateMemberPerksDrinkTicketErrorCase = {
  HasAlreadyActivated: "HasAlreadyActivated",
  IsNotEligible: "IsNotEligible",
} as const;

export type ActivateMemberPerksDrinkTicketErrorCase =
  (typeof ActivateMemberPerksDrinkTicketErrorCase)[keyof typeof ActivateMemberPerksDrinkTicketErrorCase];
export type ActivateMemberPerksDrinkTicketPayload =
  | ActivateMemberPerksDrinkTicketError
  | Success;

/** アンケートの1問分の回答 */
export type AdHocQuestionnaireAnswerInput = {
  /** 質問ID（例: "q1", "q2", "q3"） */
  questionId: Scalars["String"]["input"];
  /** 回答値（回答タイプに応じていずれか1つを指定） */
  value: AdHocQuestionnaireAnswerValueInput;
};

/** 回答値の型。質問タイプに応じていずれか1つのフィールドのみ指定する。 */
export type AdHocQuestionnaireAnswerValueInput =
  /** 自由記述の回答値 */
  | {
      freeText: Scalars["String"]["input"];
      multipleSelect?: never;
      singleSelect?: never;
    } /** 複数選択の回答値 */
  | {
      freeText?: never;
      multipleSelect: AdHocQuestionnaireMultipleSelectInput;
      singleSelect?: never;
    } /** 単一選択の回答値 */
  | {
      freeText?: never;
      multipleSelect?: never;
      singleSelect: Scalars["String"]["input"];
    };

/** 複数選択の回答 */
export type AdHocQuestionnaireMultipleSelectInput = {
  /** 「その他」の自由記述テキスト（「その他」が選択された場合のみ） */
  otherText?: InputMaybe<Scalars["String"]["input"]>;
  /** 選択された選択肢のリスト */
  selected: Array<Scalars["String"]["input"]>;
};

export type AdHocQuestionnaireResponse = {
  __typename: "AdHocQuestionnaireResponse";
  id: Scalars["ID"]["output"];
  questionnaireTemplateId: Scalars["ID"]["output"];
};

/** 3人目以降の追加ゲスト料金ポリシー */
export type AdditionalGuestFeePolicy = {
  __typename: "AdditionalGuestFeePolicy";
  /** 大人の人数別単価。インデックス i = 基準を超えて (i+1) 人目。空配列=追加料金なし。 */
  adultPrices: Array<Scalars["Int"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** 内部管理用の名称 */
  internalName: Scalars["String"]["output"];
  /** 子供（6〜12歳）の人数別単価。仕様は大人と同じ。 */
  kidsPrices: Array<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export const AdditionalNoticeType = {
  Refund: "Refund",
  Transfer: "Transfer",
} as const;

export type AdditionalNoticeType =
  (typeof AdditionalNoticeType)[keyof typeof AdditionalNoticeType];
export type Address = AddressInJapan | AddressInternational;

export type AddressInJapan = {
  __typename: "AddressInJapan";
  /**
   * 住所1。郵便番号から都道府県〜町域が自動入力される（例: 東京都千代田区千代田）。
   * line2 との区切りは入力者次第で保証されないため、連結して 1 つの住所として扱う
   */
  line1: Scalars["String"]["output"];
  /** 住所2。番地・建物名・部屋番号（例: 1-1 〇〇ビル101） */
  line2: Scalars["String"]["output"];
  /** 郵便番号 */
  postalCode: Scalars["String"]["output"];
};

export type AddressInJapanInput = {
  line1: Scalars["String"]["input"];
  line2: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
};

export type AddressInternational = {
  __typename: "AddressInternational";
  /** 市区町村（City） */
  city: Scalars["String"]["output"];
  /** 国名（Country） */
  country: CountryEnum;
  /** 建物名、通り名・番地（Building Name, Street Address） */
  line1: Scalars["String"]["output"];
  /** アパート・部屋番号（Apartment/Unit/Suite Number） */
  line2?: Maybe<Scalars["String"]["output"]>;
  /** 郵便番号（ZIP/Postal Code） */
  postalCode: Scalars["String"]["output"];
  /** 州・県（State/Province） */
  stateProvince: Scalars["String"]["output"];
};

export type AddressInternationalInput = {
  city: Scalars["String"]["input"];
  country: CountryEnum;
  line1: Scalars["String"]["input"];
  line2?: InputMaybe<Scalars["String"]["input"]>;
  postalCode: Scalars["String"]["input"];
  stateProvince: Scalars["String"]["input"];
};

export const AdminRole = {
  /**
   * 管理者。業務データの閲覧・更新と、スクリプト・開発用の口を使える。unrestricted なので、
   * @access の無い internal root も旧 admin フラグと同じく通る。
   */
  Admin: "Admin",
  /** テスト専用・付与不可。既存テストが閲覧専用のロールとして使うので定義だけ残しており、削除予定。 */
  OpsSupport: "OpsSupport",
  /**
   * 清掃・管理パートナー企業の拠点責任者（外部）。常に拠点スコープで、PartnerSiteStaff と同じ閲覧・清掃の
   * 操作に加え、自分の拠点に限って PartnerSiteStaff を付与・剥奪できる。他の拠点や他のロールは付与できない。
   * scope 付きなので T2 以上は見えない。SuperAdmin が付与する。
   */
  PartnerSiteManager: "PartnerSiteManager",
  /**
   * テスト専用・付与不可。既存テストが拠点スコープの閲覧ロールとして使うので定義だけ残しており、削除予定。
   * 外部パートナーに渡すのは PartnerSiteManager / PartnerSiteStaff。
   */
  PartnerSiteOperator: "PartnerSiteOperator",
  /**
   * 清掃・管理パートナー企業のスタッフ（外部）。常に拠点スコープで、担当拠点の予約・宿泊運営カレンダー（部屋と
   * 利用ブロック。ブロックの名前とメモは伏せる）と付帯サービスの清掃タスクだけ扱う。scope 付きなので T2 以上は見えない。
   * SuperAdmin と、同じ拠点の PartnerSiteManager が付与する。
   */
  PartnerSiteStaff: "PartnerSiteStaff",
  /**
   * ロール管理者。Admin ロールの付与・剥奪と、ロール割り当ての一覧、その画面で使うユーザー検索だけ
   * できる。他の管理画面は使えない。
   */
  RoleAdmin: "RoleAdmin",
  /** すべての操作ができ、SuperAdmin・Admin・RoleAdmin・PartnerSiteManager・PartnerSiteStaff を付与・剥奪できる。Tech チームに付ける。 */
  SuperAdmin: "SuperAdmin",
} as const;

export type AdminRole = (typeof AdminRole)[keyof typeof AdminRole];
/**
 * 管理ロールの割り当て。失効は revokedAt で記録し、再付与は新しい行になる（監査のため行は消さない）。
 * 拠点スコープの主体には自分の拠点の行だけ見せ、全拠点のロールの行（site が null）は見せない。
 */
export type AdminRoleAssignment = {
  __typename: "AdminRoleAssignment";
  /** 割り当て先の氏名とメール。拠点スコープの PartnerSiteManager がロール画面で読むための射影 */
  assignee: InternalAdminRoleAssignee;
  expiresAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  grantedAt: Scalars["ZonedDateTime"]["output"];
  /**
   * 付与した管理者。adminRoleAssignments は本人にも読めるので、付与者の素性が
   * 被付与者に漏れないよう UsersRead で塞ぐ。移行で機械的に付与した行は null。
   */
  grantedByUser?: Maybe<User>;
  id: Scalars["ID"]["output"];
  revokedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  revokedByUser?: Maybe<User>;
  role: AdminRole;
  /** 拠点スコープ。scope: Site のロールでは必ず入り、それ以外では null。 */
  site?: Maybe<Site>;
  /** 割り当て先。拠点スコープの主体は User を辿れないので、ロール画面は assignee を読む */
  user: User;
};

export type AgreeToTermsError = {
  __typename: "AgreeToTermsError";
  case: AgreeToTermsErrorCase;
};

export const AgreeToTermsErrorCase = {
  /** 規約の改定が存在しない、または同意を求めていない改定（User.requiredTermsAgreements に含まれない） */
  NotFound: "NotFound",
} as const;

export type AgreeToTermsErrorCase =
  (typeof AgreeToTermsErrorCase)[keyof typeof AgreeToTermsErrorCase];
export type AgreeToTermsPayload = AgreeToTermsError | Success;

export type AgreeToWeekdayTermsError = {
  __typename: "AgreeToWeekdayTermsError";
  case: AgreeToWeekdayTermsErrorCase;
};

export const AgreeToWeekdayTermsErrorCase = {
  /** 既に同意済み */
  AlreadyAgreed: "AlreadyAgreed",
  /** サブスクリプションが存在しない */
  NotSubscribed: "NotSubscribed",
} as const;

export type AgreeToWeekdayTermsErrorCase =
  (typeof AgreeToWeekdayTermsErrorCase)[keyof typeof AgreeToWeekdayTermsErrorCase];
export type AgreeToWeekdayTermsPayload = AgreeToWeekdayTermsError | Success;

export type ApplyToTrialSubscriptionError = {
  __typename: "ApplyToTrialSubscriptionError";
  case: ApplyToTrialSubscriptionErrorCase;
};

export const ApplyToTrialSubscriptionErrorCase = {
  DuplicationError: "DuplicationError",
  InvalidEnrollmentMonth: "InvalidEnrollmentMonth",
  InvalidOperation: "InvalidOperation",
  PaymentError: "PaymentError",
} as const;

export type ApplyToTrialSubscriptionErrorCase =
  (typeof ApplyToTrialSubscriptionErrorCase)[keyof typeof ApplyToTrialSubscriptionErrorCase];
export type ApplyToTrialSubscriptionPayload =
  | ApplyToTrialSubscriptionError
  | StripeRequireNextAction
  | Success;

export type ApplyToWeekdaySubscriptionError = {
  __typename: "ApplyToWeekdaySubscriptionError";
  case: ApplyToWeekdaySubscriptionErrorCase;
};

export const ApplyToWeekdaySubscriptionErrorCase = {
  DuplicationError: "DuplicationError",
  InvalidOperation: "InvalidOperation",
  InvalidPromotionCode: "InvalidPromotionCode",
  InvalidStartDate: "InvalidStartDate",
  PaymentError: "PaymentError",
} as const;

export type ApplyToWeekdaySubscriptionErrorCase =
  (typeof ApplyToWeekdaySubscriptionErrorCase)[keyof typeof ApplyToWeekdaySubscriptionErrorCase];
export type ApplyToWeekdaySubscriptionPayload =
  | ApplyToWeekdaySubscriptionError
  | StripeRequireNextAction
  | Success;

/** 建築タイプ */
export type ArchitectureType = {
  __typename: "ArchitectureType";
  /** この建築タイプの宿泊施設一覧（管理者向け） */
  accommodations: Array<Accommodation>;
  /** この建築タイプの宿泊施設数 */
  accommodationsCount: Scalars["Int"]["output"];
  /**
   * 1泊あたりの施設追加料金
   * デフォルトは0で、主にリノベーションに対して設定される。
   */
  additionalFee: Scalars["Int"]["output"];
  /** 収容人数 */
  capacity: Scalars["Int"]["output"];
  /** 建築のコンテンツ */
  content: ContentArchitectureType;
  id: Scalars["ID"]["output"];
  /** CMS 編集用のコンテンツ。content_architecture_types 行が無い場合は null（公開側の content は throw する） */
  internalContent?: Maybe<ContentArchitectureType>;
  /**
   * 呼称
   * モデル名＋サイズ
   * e.g. BEE, MOSS Medium, ARC Small, HIARI, ...
   */
  name: Scalars["String"]["output"];
  /** 公開済みかどうか */
  published: Scalars["Boolean"]["output"];
  /** 建築ラインナップ自体のカテゴリー */
  series: ArchitectureTypeSeries;
  /** シリーズ名（DBカラム名、例：SANU CABIN） */
  seriesName: Scalars["String"]["output"];
  /**
   * モデル名
   * e.g. BEE, MOSS, ARC, HIARI, ....
   */
  seriesShortName: Scalars["String"]["output"];
  /** 建築サイズ。サイズが定義されている建築の場合のみ */
  size?: Maybe<ArchitectureTypeSize>;
  slug: Scalars["String"]["output"];
};

/** 建築シリーズ */
export const ArchitectureTypeSeries = {
  /** SANUオリジナルの設計。プロダクトとして多数展開される。 */
  Original: "Original",
  /** 主に既存の建物のリノベーション。単棟になる。 */
  Selection: "Selection",
} as const;

export type ArchitectureTypeSeries =
  (typeof ArchitectureTypeSeries)[keyof typeof ArchitectureTypeSeries];
/** 建築サイズ */
export const ArchitectureTypeSize = {
  Large: "Large",
  Medium: "Medium",
  Small: "Small",
} as const;

export type ArchitectureTypeSize =
  (typeof ArchitectureTypeSize)[keyof typeof ArchitectureTypeSize];
/** トップページ表示のArchive article (ニュースレター) */
export type ArchiveArticle = {
  __typename: "ArchiveArticle";
  /** 新しいかどうか */
  isNew: Scalars["Boolean"]["output"];
  /** 日付 */
  publishedAt: Scalars["ZonedDateTime"]["output"];
  /** タイトル */
  title: Scalars["String"]["output"];
  /** 遷移先URL */
  url: Scalars["String"]["output"];
};

/**
 * エリア
 * 散財する拠点を一定の地域でまとめたもの
 */
export type Area = {
  __typename: "Area";
  /** エリアのコンテンツ */
  content: AreaContent;
  id: Scalars["ID"]["output"];
  /**
   * エリアの名前
   * 例：一宮、安曇野
   */
  name: Scalars["String"]["output"];
  /**
   * エリアに含まれる published 済みの拠点の一覧。予約開始前の拠点も含む。
   * 非公開を含む全件は internal の InternalArea.sites を使う。
   */
  sites: Array<Site>;
  /**
   * エリアに含まれる、予約ができる拠点の一覧。
   * provider なしの場合は一般予約可能 (reservable) な拠点のみを返す。
   * 公開ページの拠点一覧には sites を使う。
   */
  sitesForReservation: Array<Site>;
  slug: Scalars["String"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
};

/**
 * エリア
 * 散財する拠点を一定の地域でまとめたもの
 */
export type AreaSitesForReservationArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/** エリアコンテンツ */
export type AreaContent = {
  __typename: "AreaContent";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  /** 東京からのアクセス説明 */
  accessFromTokyoDescription?: Maybe<Scalars["String"]["output"]>;
  allCapsName?: Maybe<Scalars["String"]["output"]>;
  /** キャッチコピー */
  catchCopy?: Maybe<Scalars["String"]["output"]>;
  /** エリア紹介文（長文） */
  description?: Maybe<Scalars["String"]["output"]>;
  /** エリアガイド記事（MAGAZINE への動線）。掲載対象エリアにこのエリアを含む記事を sort 順で返す */
  guideArticles: Array<AreaGuideArticle>;
  /** おすすめスポットをまとめたGoogle MapsリストのURL */
  guideSpotMapListUrl?: Maybe<Scalars["String"]["output"]>;
  /** おすすめスポットページ下部Tipsの本文（💡） */
  guideSpotTips?: Maybe<Scalars["String"]["output"]>;
  /** おすすめスポットページ下部Tipsの見出し（例: スーパーやショップは拠点に向かう前に立ち寄るのがおすすめ。） */
  guideSpotTipsTitle?: Maybe<Scalars["String"]["output"]>;
  /** おすすめスポット */
  guideSpots: Array<AreaGuideSpot>;
  /** ヒーロー画像 */
  heroImages: Array<UploadedFile>;
  reservationFormCoverImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 道路状況ライブカメラURL */
  roadConditionLiveCameraUrl?: Maybe<Scalars["String"]["output"]>;
  /** 短い住所表示（例: "静岡県"） */
  shortAddress?: Maybe<Scalars["String"]["output"]>;
  /** 最終更新日時（編集履歴の表示用） */
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/**
 * エリアページから MAGAZINE のエリアガイド記事へ誘導するリンク。
 * 記事本文は MAGAZINE 側にあり、ここには動線に必要なメタ情報だけを持つ。
 * guideArticles は並び順で返すので、公開側に sort は出さない (admin 用は internal schema)。
 */
export type AreaGuideArticle = {
  __typename: "AreaGuideArticle";
  /** 掲載対象エリア（admin の一覧・編集フォーム用） */
  areas: Array<InternalArea>;
  id: Scalars["ID"]["output"];
  /** MAGAZINE 上の公開日。表示専用で、掲載可否には効かない */
  publishedDate: Scalars["PlainDate"]["output"];
  /** 並び順（全記事で 1 本。エリアごとには持たない） */
  sort: Scalars["Int"]["output"];
  /** サムネイル画像。未設定なら null */
  thumbnail?: Maybe<UploadedFile>;
  title: Scalars["String"]["output"];
  /** MAGAZINE 記事の URL */
  url: Scalars["String"]["output"];
};

/** エリアのおすすめスポット */
export type AreaGuideSpot = {
  __typename: "AreaGuideSpot";
  businessHours?: Maybe<Scalars["String"]["output"]>;
  /** カテゴリ（複数可。Bubble の option_area_guide_category が String[] のため） */
  categories: Array<AreaGuideSpotCategory>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  images: Array<UploadedFile>;
  mapUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** 掲載終了日（当日を含む）。null は無期限。この日を過ぎると公開ページから外れる */
  publishEndDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 掲載開始日（当日を含む）。null は開始日の指定なし */
  publishStartDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /**
   * 今日時点で公開ページに出ているか（掲載期間の中にいるか）。
   * 公開ページの絞り込みと同じ判定なので、admin の表示はこれを使う
   */
  publishedNow: Scalars["Boolean"]["output"];
  sort: Scalars["Int"]["output"];
  /** タグ（ベーカリー・スーパー 等のフリーテキスト） */
  tags: Array<Scalars["String"]["output"]>;
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

/**
 * おすすめスポットのカテゴリ。
 * カテゴリを増やす場合はエンジニアが Prisma の enum を更新する必要がある。
 */
export const AreaGuideSpotCategory = {
  /** 飲食店 */
  CafeRestaurant: "CafeRestaurant",
  /** イベント */
  Events: "Events",
  /** 食料品店 */
  FoodStore: "FoodStore",
  /** 自然 */
  NatureSpot: "NatureSpot",
  /** その他 */
  Others: "Others",
  /** ショップ */
  Shop: "Shop",
} as const;

export type AreaGuideSpotCategory =
  (typeof AreaGuideSpotCategory)[keyof typeof AreaGuideSpotCategory];
export type Auth0User = {
  __typename: "Auth0User";
  /** Auth0 の User ID */
  id: Scalars["String"]["output"];
  /** リンク済みアイデンティティのAuth0 ID一覧（ローカルDB） */
  linkedIdentities: Array<Scalars["String"]["output"]>;
};

/** 基本料金モード */
export const BaseAccommodationFeeMode = {
  Daily: "Daily",
  Policy: "Policy",
} as const;

export type BaseAccommodationFeeMode =
  (typeof BaseAccommodationFeeMode)[keyof typeof BaseAccommodationFeeMode];
/** 基本となる1泊ごとの宿泊料金のポリシー */
export type BaseAccommodationFeePolicy = {
  __typename: "BaseAccommodationFeePolicy";
  /**
   * 1泊目、2泊目と決まる料金
   * このリストよりも長い泊数になる場合は、定義されている最後の1泊の料金が適用される。
   */
  dailyFeePolicy?: Maybe<Array<Scalars["Int"]["output"]>>;
  id: Scalars["ID"]["output"];
  /** 内部向けの名前 */
  internalName: Scalars["String"]["output"];
};

export type Beds24Booking = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  apiMessage?: InputMaybe<Scalars["String"]["input"]>;
  apiReference?: InputMaybe<Scalars["String"]["input"]>;
  apiSource?: InputMaybe<Scalars["String"]["input"]>;
  arrival: Scalars["PlainDate"]["input"];
  arrivalTime?: InputMaybe<Scalars["String"]["input"]>;
  bookingGroup?: InputMaybe<Beds24BookingGroup>;
  bookingTime?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  cancelTime?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  channel?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  comments?: InputMaybe<Scalars["String"]["input"]>;
  commission?: InputMaybe<Scalars["Int"]["input"]>;
  company?: InputMaybe<Scalars["String"]["input"]>;
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  departure: Scalars["PlainDate"]["input"];
  deposit?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  languageCode?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  masterId?: InputMaybe<Scalars["Int"]["input"]>;
  modifiedTime?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  numAdult: Scalars["Int"]["input"];
  numChild: Scalars["Int"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
  postCode?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Int"]["input"]>;
  pricePerRoom?: InputMaybe<Scalars["Int"]["input"]>;
  rateDescription?: InputMaybe<Scalars["String"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  referer?: InputMaybe<Scalars["String"]["input"]>;
  roomId: Scalars["Int"]["input"];
  state?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["String"]["input"];
  tax?: InputMaybe<Scalars["Int"]["input"]>;
  unitId: Scalars["Int"]["input"];
};

export type Beds24BookingDetail = {
  __typename: "Beds24BookingDetail";
  fee: Beds24BookingFee;
  isGroupBooking: Scalars["Boolean"]["output"];
  masterBookingId?: Maybe<Scalars["Int"]["output"]>;
};

export type Beds24BookingEvent = {
  booking: Beds24Booking;
  infoItems: Array<Beds24InfoItem>;
  invoiceItems: Array<Beds24InvoiceItem>;
  messages: Array<Beds24Message>;
};

export type Beds24BookingFee = {
  __typename: "Beds24BookingFee";
  perRoomAmount: Scalars["Int"]["output"];
  totalAmount?: Maybe<Scalars["Int"]["output"]>;
  totalUnpaidAmount?: Maybe<Scalars["Int"]["output"]>;
};

export type Beds24BookingGroup = {
  ids: Array<Scalars["Int"]["input"]>;
  master: Scalars["Int"]["input"];
};

export type Beds24BookingMessageError = {
  __typename: "Beds24BookingMessageError";
  case: Beds24BookingMessageErrorCase;
};

export const Beds24BookingMessageErrorCase = {
  GeneralError: "GeneralError",
  InvalidEmail: "InvalidEmail",
} as const;

export type Beds24BookingMessageErrorCase =
  (typeof Beds24BookingMessageErrorCase)[keyof typeof Beds24BookingMessageErrorCase];
export const Beds24BookingMessageKind = {
  ReservationReminderBefore2Day: "ReservationReminderBefore2Day",
  ReservationReminderToday: "ReservationReminderToday",
  TentativeReservationCreated: "TentativeReservationCreated",
} as const;

export type Beds24BookingMessageKind =
  (typeof Beds24BookingMessageKind)[keyof typeof Beds24BookingMessageKind];
export type Beds24BookingMessageResult = Beds24BookingMessageError | Success;

export type Beds24BookingMessageResultPayload = {
  __typename: "Beds24BookingMessageResultPayload";
  result: Beds24BookingMessageResult;
};

export type Beds24InfoItem = {
  code: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  text: Scalars["String"]["input"];
};

export type Beds24InvoiceItem = {
  id: Scalars["Int"]["input"];
  lineTotal: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

export type Beds24Message = {
  id: Scalars["Int"]["input"];
  message: Scalars["String"]["input"];
};

export type Beds24SyncFollowingReservationsResultPayload =
  | CancelAccommodationReservationError
  | ChangeAccommodationReservationError;

export type Beds24WebhookError = {
  __typename: "Beds24WebhookError";
  case: Beds24WebhookErrorCase;
};

export const Beds24WebhookErrorCase = {
  BookingStatusNotSupported: "BookingStatusNotSupported",
  GeneralError: "GeneralError",
  ReservationNotFound: "ReservationNotFound",
  UnsupportedProvider: "UnsupportedProvider",
} as const;

export type Beds24WebhookErrorCase =
  (typeof Beds24WebhookErrorCase)[keyof typeof Beds24WebhookErrorCase];
export type Beds24WebhookResult = Beds24WebhookError | Beds24WebhookSuccess;

export type Beds24WebhookResultPayload = {
  __typename: "Beds24WebhookResultPayload";
  bookingDetail?: Maybe<Beds24BookingDetail>;
  changes?: Maybe<Array<AccommodationReservationChange>>;
  message?: Maybe<Scalars["String"]["output"]>;
  reservation?: Maybe<AccommodationReservation>;
  result: Beds24WebhookResult;
};

export type Beds24WebhookSuccess = {
  __typename: "Beds24WebhookSuccess";
  case: Beds24WebhookSuccessCase;
};

export const Beds24WebhookSuccessCase = {
  BookingNotAssigned: "BookingNotAssigned",
  ProcessingSkipped: "ProcessingSkipped",
  ReservationCanceled: "ReservationCanceled",
  ReservationChanged: "ReservationChanged",
  ReservationCreated: "ReservationCreated",
  ReservationDetailUpdated: "ReservationDetailUpdated",
} as const;

export type Beds24WebhookSuccessCase =
  (typeof Beds24WebhookSuccessCase)[keyof typeof Beds24WebhookSuccessCase];
export const BillingMethod = {
  /** 自動請求 - Stripe経由で自動的に請求されます */
  AutoCharge: "AutoCharge",
  /** 別途請求 - 別途請求処理が必要です */
  Manual: "Manual",
} as const;

export type BillingMethod = (typeof BillingMethod)[keyof typeof BillingMethod];
export type BulkCreateOrganizationYearlyContractInvoicesInput = {
  /** 年間払いか、月払いか */
  frequency: OrganizationYearlyContractInvoiceFrequency;
  /**
   * 下書きとして作成するか、すぐにオープンな契約書として作成するか
   * デフォルト: true
   */
  isDraft?: Scalars["Boolean"]["input"];
  /** 請求金額（税込） */
  itemAmount: Scalars["Int"]["input"];
  /** 決済方法。銀行振込か、クレジットカード払いか */
  paymentMethodType: OrganizationYearlyContractInvoicePaymentMethodType;
  /**
   * 請求書を自動でオープンにする場合の日付（下書きの場合のみ）
   * 年払いの場合: この日付に公開
   * 月払いの場合: 各月のこの日付に公開（例: 2025-01-15を指定すると、2025年1月15日、2月15日、...、12月15日に公開）
   */
  scheduledOpenDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type BundleStayTicketsPayload = {
  __typename: "BundleStayTicketsPayload";
  /**
   * 同一のビジネスルールを持つ宿泊チケットのまとまり。
   * バリデーションエラーにならない宿泊チケットが少なくとも一つ以上ある場合、このフィールドが返る。
   */
  stayTicketUnit?: Maybe<StayTicketUnit>;
  /** 引数で与えられた宿泊チケットコードと同じ順序・数で返る。 */
  stayTicketsValidationResult: Array<StayTicketValidationResult>;
};

/** 企業が契約できるビジネスプラン */
export type BusinessPlan = {
  __typename: "BusinessPlan";
  /** メンバーが支払う1泊あたりの金額 */
  feePerNights: Scalars["Int"]["output"];
  /** 1口あたりの価格（税込） */
  feePerNum: Scalars["Int"]["output"];
  /** ビジネスプランのID（現在は名前と同じ） */
  id: Scalars["ID"]["output"];
  /** 繁忙日料金を無料にするかどうか */
  isPeakDayFeeFree: Scalars["Boolean"]["output"];
  /** ビジネスプランの名前 */
  name: Scalars["String"]["output"];
};

export type BusinessPlanAccommodationReservationProvider = {
  __typename: "BusinessPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  organizationId: Scalars["ID"]["output"];
};

export type CancelAccommodationReservationError = {
  __typename: "CancelAccommodationReservationError";
  case: CancelAccommodationReservationErrorCase;
};

export const CancelAccommodationReservationErrorCase = {
  CancelPaymentFailed: "CancelPaymentFailed",
  CancelRuleError: "CancelRuleError",
  CancelTemporarilyUnavailable: "CancelTemporarilyUnavailable",
  HasActiveFacilityReservation: "HasActiveFacilityReservation",
  NotAuthorized: "NotAuthorized",
} as const;

export type CancelAccommodationReservationErrorCase =
  (typeof CancelAccommodationReservationErrorCase)[keyof typeof CancelAccommodationReservationErrorCase];
export type CancelAccommodationReservationPayload =
  | AccommodationReservation
  | CancelAccommodationReservationError;

export type CancelCoOwnersApplicationError = {
  __typename: "CancelCoOwnersApplicationError";
  case: CancelCoOwnersApplicationErrorCase;
};

export const CancelCoOwnersApplicationErrorCase = {
  AlreadyCancelled: "AlreadyCancelled",
  CannotCancelAfterHandover: "CannotCancelAfterHandover",
  NotFound: "NotFound",
  PermissionDenied: "PermissionDenied",
  StripeRefundError: "StripeRefundError",
} as const;

export type CancelCoOwnersApplicationErrorCase =
  (typeof CancelCoOwnersApplicationErrorCase)[keyof typeof CancelCoOwnersApplicationErrorCase];
export type CancelCoOwnersApplicationPayload =
  | CancelCoOwnersApplicationError
  | Success;

export type CancelFacilityReservationError = {
  __typename: "CancelFacilityReservationError";
  case: CancelFacilityReservationErrorCase;
};

export const CancelFacilityReservationErrorCase = {
  AlreadyCanceled: "AlreadyCanceled",
  NotAuthorized: "NotAuthorized",
  NotCancelable: "NotCancelable",
  PastReserveDeadline: "PastReserveDeadline",
  ReservationNotFound: "ReservationNotFound",
} as const;

export type CancelFacilityReservationErrorCase =
  (typeof CancelFacilityReservationErrorCase)[keyof typeof CancelFacilityReservationErrorCase];
export type CancelFacilityReservationPayload =
  | CancelFacilityReservationError
  | Success;

/**
 * 宿泊料金を元にしたキャンセル料金のポリシー
 * 例えば、前日であれば100%、3日前であれば70%などのように決まる。
 */
export type CancelFeeFixedPolicy = {
  __typename: "CancelFeeFixedPolicy";
  before1DaysFee: Scalars["Int"]["output"];
  before3DaysFee: Scalars["Int"]["output"];
  before7DaysFee: Scalars["Int"]["output"];
  /** true の場合、即時100%のキャンセル料が発生する（実質的にキャンセル不可のポリシー）。 */
  immediate: Scalars["Boolean"]["output"];
};

export type CancelFeeFixedPolicyInput = {
  before1DaysFee: Scalars["Int"]["input"];
  before3DaysFee: Scalars["Int"]["input"];
  before7DaysFee: Scalars["Int"]["input"];
};

/**
 * 宿泊予約に適用されるキャンセル料金のポリシー
 * @deprecated Use AccommodationReservation.cancellationPolicy instead
 */
export type CancelFeePolicy = CancelFeeFixedPolicy | CancelFeeRatePolicy;

/** 固定額になっているキャンセル料金のポリシー */
export type CancelFeeRatePolicy = {
  __typename: "CancelFeeRatePolicy";
  before1DaysRate: Scalars["Float"]["output"];
  before3DaysRate: Scalars["Float"]["output"];
  before7DaysRate: Scalars["Float"]["output"];
  /** true の場合、即時100%のキャンセル料が発生する（実質的にキャンセル不可のポリシー）。 */
  immediate: Scalars["Boolean"]["output"];
};

export type CancelFeeRatePolicyInput = {
  before1DaysRate: Scalars["Float"]["input"];
  before3DaysRate: Scalars["Float"]["input"];
  before7DaysRate: Scalars["Float"]["input"];
};

export type CancelStandardSubscriptionApplicationError = {
  __typename: "CancelStandardSubscriptionApplicationError";
  case: CancelStandardSubscriptionApplicationErrorCase;
  stripeRequestId?: Maybe<Scalars["String"]["output"]>;
};

export const CancelStandardSubscriptionApplicationErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionScheduleError: "NoSubscriptionScheduleError",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
  UnknownError: "UnknownError",
} as const;

export type CancelStandardSubscriptionApplicationErrorCase =
  (typeof CancelStandardSubscriptionApplicationErrorCase)[keyof typeof CancelStandardSubscriptionApplicationErrorCase];
export type CancelStandardSubscriptionApplicationPayload =
  | CancelStandardSubscriptionApplicationError
  | Success;

export type CancelStandardSubscriptionPauseError = {
  __typename: "CancelStandardSubscriptionPauseError";
  case: CancelStandardSubscriptionPauseErrorCase;
};

export const CancelStandardSubscriptionPauseErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionError: "NoSubscriptionError",
  NoSubscriptionScheduleError: "NoSubscriptionScheduleError",
  StripeError: "StripeError",
  SubscriptionScheduleInvalidTrigger: "SubscriptionScheduleInvalidTrigger",
} as const;

export type CancelStandardSubscriptionPauseErrorCase =
  (typeof CancelStandardSubscriptionPauseErrorCase)[keyof typeof CancelStandardSubscriptionPauseErrorCase];
export type CancelStandardSubscriptionPausePayload =
  | CancelStandardSubscriptionPauseError
  | Success;

export type CancelStandardSubscriptionResumeError = {
  __typename: "CancelStandardSubscriptionResumeError";
  case: CancelStandardSubscriptionResumeErrorCase;
};

export const CancelStandardSubscriptionResumeErrorCase = {
  GeneralError: "GeneralError",
  InvalidOperation: "InvalidOperation",
} as const;

export type CancelStandardSubscriptionResumeErrorCase =
  (typeof CancelStandardSubscriptionResumeErrorCase)[keyof typeof CancelStandardSubscriptionResumeErrorCase];
export type CancelStandardSubscriptionResumePayload =
  | CancelStandardSubscriptionResumeError
  | Success;

export type CancelStandardSubscriptionTerminationError = {
  __typename: "CancelStandardSubscriptionTerminationError";
  case: CancelStandardSubscriptionTerminationErrorCase;
};

export const CancelStandardSubscriptionTerminationErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionError: "NoSubscriptionError",
  NotTerminating: "NotTerminating",
  StripeError: "StripeError",
} as const;

export type CancelStandardSubscriptionTerminationErrorCase =
  (typeof CancelStandardSubscriptionTerminationErrorCase)[keyof typeof CancelStandardSubscriptionTerminationErrorCase];
export type CancelStandardSubscriptionTerminationPayload =
  | CancelStandardSubscriptionTerminationError
  | Success;

export type CancelStayGiftsError = {
  __typename: "CancelStayGiftsError";
  case: CancelStayGiftsErrorCase;
};

export const CancelStayGiftsErrorCase = {
  /** チケットがキャンセル可能な状態ではない（既にキャンセル済みなど） */
  InvalidState: "InvalidState",
  /** 認証エラー（他人のチケットを指定した場合） */
  NotAuthorized: "NotAuthorized",
  /** 指定されたチケットが存在しない */
  NotFound: "NotFound",
} as const;

export type CancelStayGiftsErrorCase =
  (typeof CancelStayGiftsErrorCase)[keyof typeof CancelStayGiftsErrorCase];
/** Stay Giftチケットキャンセルの結果 */
export type CancelStayGiftsPayload =
  | CancelStayGiftsError
  | CancelStayGiftsResult;

export type CancelStayGiftsResult = {
  __typename: "CancelStayGiftsResult";
  /** キャンセルされたチケット */
  cancelledTickets: Array<StayTicket>;
};

export type CancelTrialSubscriptionError = {
  __typename: "CancelTrialSubscriptionError";
  case: CancelTrialSubscriptionErrorCase;
};

export const CancelTrialSubscriptionErrorCase = {
  ContractNotFound: "ContractNotFound",
  InvalidOperation: "InvalidOperation",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
} as const;

export type CancelTrialSubscriptionErrorCase =
  (typeof CancelTrialSubscriptionErrorCase)[keyof typeof CancelTrialSubscriptionErrorCase];
export type CancelTrialSubscriptionPayload =
  | CancelTrialSubscriptionError
  | Success;

/** キャンセル料金の1段階。表示用ラベルと料金説明のペア。 */
export type CancellationFeeTier = {
  __typename: "CancellationFeeTier";
  /** 料金の説明文（例: "11,000円（税込）" or "宿泊料金の100%"） */
  feeDescription: Scalars["String"]["output"];
  /** 表示用ラベル（例: "宿泊日3日前の15時以降"） */
  label: Scalars["String"]["output"];
};

/**
 * 予約に適用されるキャンセルポリシー全体。
 * 新旧ルール跨ぎの場合は sections が2件になる。
 */
export type CancellationPolicyContent = {
  __typename: "CancellationPolicyContent";
  sections: Array<CancellationPolicySection>;
};

/**
 * キャンセルポリシーの1セクション。
 * 新旧ルール跨ぎの場合、日付範囲ごとに conditionLabel で区別する。
 */
export type CancellationPolicySection = {
  __typename: "CancellationPolicySection";
  changeDeadlineDescription: Scalars["String"]["output"];
  /** 条件ラベル（例: "4/24以前の宿泊日"）。単一ルールの場合 null */
  conditionLabel?: Maybe<Scalars["String"]["output"]>;
  noShowDescription: Scalars["String"]["output"];
  tiers: Array<CancellationFeeTier>;
};

export type ChangeAccommodationAvailabilityBlockInput = {
  beginNight: Scalars["PlainDate"]["input"];
  category: AccommodationAvailabilityBlockCategory;
  endNight: Scalars["PlainDate"]["input"];
  /**
   * 既存の予約と重複していてもブロックを変更する。
   * 既存の他ブロックとの重複は指定に関わらず不可。
   */
  ignoreReservations?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTentative: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ChangeAccommodationReservationError = {
  __typename: "ChangeAccommodationReservationError";
  case: ChangeAccommodationReservationErrorCase;
  internalCode?: Maybe<Scalars["String"]["output"]>;
};

export const ChangeAccommodationReservationErrorCase = {
  /** 予約変更手数料の支払いに失敗した */
  ChangePaymentFailed: "ChangePaymentFailed",
  /** サブスクにおいて同一予約サイクル内ですでに予約を取っている */
  CycleDuplicationError: "CycleDuplicationError",
  /** 変更先の日程または拠点に対応していない付帯サービス予約があるため変更できない */
  HasConflictingFacilityReservation: "HasConflictingFacilityReservation",
  /** 現在予約可能な期間に収まっていない */
  InvalidReservationPeriodError: "InvalidReservationPeriodError",
  /** 月間泊数の上限を超えている */
  MaxNightsPerMonthExceededError: "MaxNightsPerMonthExceededError",
  /** 年間泊数の上限を超えている */
  MaxNightsPerYearExceededError: "MaxNightsPerYearExceededError",
  /** 同時予約数の上限を超えている */
  MaxReservationsExceededError: "MaxReservationsExceededError",
  /** 同月内予約数の上限を超えている */
  MonthlyReservationLimitExceededError: "MonthlyReservationLimitExceededError",
  /**
   * 予約変更が可能な範囲を超えている
   * 直前であるかどうかなどリードタイムによって制限がかかる
   */
  MutationScopeError: "MutationScopeError",
  /** サブスクにおいて1週間以内ですでに予約を取っている */
  Next7DaysDuplicationError: "Next7DaysDuplicationError",
  /** オーナーの泊数が不足している */
  OwnerStayCreditInsufficientError: "OwnerStayCreditInsufficientError",
  /** オーナー拠点の繁忙日はオーナー会員のみが予約可能である */
  PeakDayOwnerOnlyError: "PeakDayOwnerOnlyError",
  /** High日制限を超えている */
  PeakDaysLimitExceededError: "PeakDaysLimitExceededError",
  /** 同一の日程ですでに別の予約を取っている */
  ReservationOverlapError: "ReservationOverlapError",
  /**
   * 部屋が空室ではないため利用不可能
   * （内部的には稼働制御によるものであることもある）
   */
  ResourceUnavailable: "ResourceUnavailable",
  /** 拠点ハイシーズン制限を超えている（FullOwnerのみ） */
  SiteHighSeasonLimitExceededError: "SiteHighSeasonLimitExceededError",
  /** 宿泊チケットが使用済みまたは無効である */
  StayTicketError: "StayTicketError",
  /** サブスクリプションが支払い失敗により停止されている */
  SubscriptionSuspended: "SubscriptionSuspended",
  /** 未同意の規約の改定がある */
  TermsNotAgreedError: "TermsNotAgreedError",
  /** Trialプランが支払い失敗により停止されている */
  TrialContractSuspended: "TrialContractSuspended",
  /** Trialプランの泊数が不足している */
  TrialStayCreditInsufficientError: "TrialStayCreditInsufficientError",
  /** 予期せぬエラー */
  UnexpectedError: "UnexpectedError",
  /** 未払いの宿泊料金がある */
  UnpaidAccommodationFeeError: "UnpaidAccommodationFeeError",
} as const;

export type ChangeAccommodationReservationErrorCase =
  (typeof ChangeAccommodationReservationErrorCase)[keyof typeof ChangeAccommodationReservationErrorCase];
export type ChangeAccommodationReservationPayload =
  | AccommodationReservation
  | ChangeAccommodationReservationError;

export type CheckInAccommodationReservationError = {
  __typename: "CheckInAccommodationReservationError";
  case: CheckInAccommodationReservationErrorCase;
};

export const CheckInAccommodationReservationErrorCase = {
  /** 既にチェックイン済み */
  AlreadyCheckedIn: "AlreadyCheckedIn",
  /** チェックイン認証が完了していない（QR認証） */
  AuthenticationRequired: "AuthenticationRequired",
  /** チェックイン規則に違反している */
  CheckInRuleError: "CheckInRuleError",
  /** 暗証番号が発行されていない */
  NoAccessCode: "NoAccessCode",
} as const;

export type CheckInAccommodationReservationErrorCase =
  (typeof CheckInAccommodationReservationErrorCase)[keyof typeof CheckInAccommodationReservationErrorCase];
export type CheckInAccommodationReservationInput = {
  checkedInGeoLocation?: InputMaybe<GeoLocationInput>;
  numberOfDogs: Scalars["Int"]["input"];
};

export type CheckInAccommodationReservationPayload =
  | AccommodationReservation
  | CheckInAccommodationReservationError;

/** チェックイン認証方式 */
export const CheckInAuthenticationType = {
  /** 認証不要 */
  NotRequired: "NotRequired",
  /** QRコード認証 */
  QrCode: "QrCode",
} as const;

export type CheckInAuthenticationType =
  (typeof CheckInAuthenticationType)[keyof typeof CheckInAuthenticationType];
/** チェックイン用QRコード */
export type CheckInQrCode = {
  __typename: "CheckInQrCode";
  /** QRコード */
  code: Scalars["String"]["output"];
  /** コードの有効期限 */
  expiresAt: Scalars["ZonedDateTime"]["output"];
  /** 認証ステータス */
  status: CheckInQrCodeStatus;
  /** 認証完了日時 */
  verifiedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

/** チェックイン用QRコードの認証ステータス */
export const CheckInQrCodeStatus = {
  /** 認証失敗 */
  Failed: "Failed",
  /** 認証待ち */
  Pending: "Pending",
  /** 認証成功 */
  Verified: "Verified",
} as const;

export type CheckInQrCodeStatus =
  (typeof CheckInQrCodeStatus)[keyof typeof CheckInQrCodeStatus];
export type CheckOutAccommodationReservationError = {
  __typename: "CheckOutAccommodationReservationError";
  case: CheckOutAccommodationReservationErrorCase;
};

export const CheckOutAccommodationReservationErrorCase = {
  /** 既にチェックアウト済み */
  AlreadyCheckedOut: "AlreadyCheckedOut",
  CheckOutRuleError: "CheckOutRuleError",
  NotAuthorized: "NotAuthorized",
  /** 指定した設問が存在しない */
  QuestionnaireNotFound: "QuestionnaireNotFound",
  /** 入力値が不正（必須フィールドが未指定） */
  ValidationError: "ValidationError",
} as const;

export type CheckOutAccommodationReservationErrorCase =
  (typeof CheckOutAccommodationReservationErrorCase)[keyof typeof CheckOutAccommodationReservationErrorCase];
export type CheckOutAccommodationReservationPayload =
  | AccommodationReservation
  | CheckOutAccommodationReservationError;

/** Co-Owners の繁忙日数上限を算出するための割合、繁忙日数上限はfloor(unitNightsPerYear × 割合)で計算される */
export const CoOwnerPeakDaysRatio = {
  /** 1/2、ルール改定（2026/6/23販売開始・2027/4/1宿泊分から適用）後のプラン用 */
  OneHalf: "OneHalf",
  /** 2/3、ルール改定前のプラン用 */
  TwoThirds: "TwoThirds",
} as const;

export type CoOwnerPeakDaysRatio =
  (typeof CoOwnerPeakDaysRatio)[keyof typeof CoOwnerPeakDaysRatio];
export type CoOwnersApplicantInfo = {
  __typename: "CoOwnersApplicantInfo";
  /** 申込者の詳細情報 */
  detail: CoOwnersApplicantInfoDetail;
  /** 本人確認書類 */
  identificationDocument1?: Maybe<UploadedFile>;
  identificationDocument2?: Maybe<UploadedFile>;
  /** 本人確認書類 */
  identificationDocumentType: IdentificationDocumentType;
  /** 外国PEPsへの該当有無 */
  isPep: Scalars["Boolean"]["output"];
  /** 利用用途 */
  purchasePurpose?: Maybe<OwnerPurchasePurposeType>;
  /** 利用用途Otherの場合の自由記述 */
  purchasePurposeFree?: Maybe<Scalars["String"]["output"]>;
};

export type CoOwnersApplicantInfoDetail =
  | CoOwnersApplicantInfoDetailIndividual
  | CoOwnersApplicantInfoDetailOrganization;

export type CoOwnersApplicantInfoDetailIndividual = {
  __typename: "CoOwnersApplicantInfoDetailIndividual";
  /** 勤務先名 */
  employerName?: Maybe<Scalars["String"]["output"]>;
  /** 世帯年収 */
  householdIncome?: Maybe<IncomeBracketType>;
  /** 利用意向 */
  intendedUsage?: Maybe<OwnerIntendedUsageType>;
  /** 金融資産 */
  personalFinancialAssets?: Maybe<FinancialAssetsBracketType>;
  /** ローン申込の有無 */
  useLoan: Scalars["Boolean"]["output"];
};

export type CoOwnersApplicantInfoDetailOrganization = {
  __typename: "CoOwnersApplicantInfoDetailOrganization";
  /** 実質的支配者の住所 */
  beneficialOwnerAddress?: Maybe<AddressInJapan>;
  /** 実質的支配者の生年月日 */
  beneficialOwnerBirthDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 実質的支配者の名前 */
  beneficialOwnerName?: Maybe<Scalars["String"]["output"]>;
  /** その他の実質的支配者 */
  beneficialOwnerOthers?: Maybe<Scalars["String"]["output"]>;
  /** 実質的支配者と法人の関係性 */
  beneficialOwnerRelationship?: Maybe<OwnerOrganizationBeneficialOwnerRelationshipType>;
  /** 実質的支配者と法人の関係性はOtherの場合の自由記述 */
  beneficialOwnerRelationshipFree?: Maybe<Scalars["String"]["output"]>;
  /** 事業内容 */
  businessActivity?: Maybe<OwnerOrganizationBusinessActivityType>;
  /** 事業内容はOtherの場合の自由記述 */
  businessActivityFree?: Maybe<Scalars["String"]["output"]>;
  /** 会社の住所 */
  organizationAddress?: Maybe<AddressInJapan>;
  /** 会社名 */
  organizationName: Scalars["String"]["output"];
  /** 法人とオーナーの関係性 */
  organizationRelationship?: Maybe<OwnerOrganizationRelationshipType>;
  /** 登記簿謄本 */
  registryCertificateDocuments: Array<UploadedFile>;
  /** 会社代表者名 */
  representativeName: Scalars["String"]["output"];
};

/** CoOwners申し込み */
export type CoOwnersApplication = {
  __typename: "CoOwnersApplication";
  /** 追加購入割引額 */
  additionalPurchaseDiscountAmount: Scalars["Int"]["output"];
  /** 追加購入割引備考 */
  additionalPurchaseDiscountNote: Scalars["String"]["output"];
  /** 登録料の事前請求が必要かどうか */
  advancePaymentRequired: Scalars["Boolean"]["output"];
  /** 申込者に非表示のものを含む全ファイル */
  allFiles: Array<CoOwnersApplicationFile>;
  /** 申し込み者 */
  applicant: User;
  /** 申込者の情報 */
  applicantInfo: CoOwnersApplicantInfo;
  /** 申込金の支払い方法 */
  applicationFeePaymentMethod?: Maybe<PaymentMethodType>;
  /** 管理者用メモ */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 引渡し希望日 */
  desiredHandoverDate?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /** 重要事項説明会参加者 */
  disclosureAssitant?: Maybe<DisclosureAssistantType>;
  /** 社員紹介割引額 */
  employeeReferralDiscountAmount: Scalars["Int"]["output"];
  /** 各イベントの日時 */
  events: CoOwnersApplicationEvents;
  /** 申込者が閲覧できるファイル。管理者が非表示にしたものと削除済みのものは含まない */
  files: Array<CoOwnersApplicationFile>;
  /** 友人紹介割引額 */
  friendReferralDiscountAmount: Scalars["Int"]["output"];
  /** 必須入力項目が入力済みかどうか */
  hasCoOwnersApplicationRequiredFieldsFilled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** 本人確認情報 */
  identityVerifications: Array<IdentityVerification>;
  /** 招待コード */
  invitationCode?: Maybe<Scalars["String"]["output"]>;
  /** その他割引額 */
  otherDiscountAmount: Scalars["Int"]["output"];
  /** その他割引備考 */
  otherDiscountNote: Scalars["String"]["output"];
  /** 管理者用ファイル */
  otherFiles: Array<UploadedFile>;
  /** CoOwnersのプラン */
  ownerPlan: OwnerPlan;
  /** 登録料の支払い方法 */
  registrationFeePaymentMethod?: Maybe<PaymentMethodType>;
  /** 残金の支払い方法 */
  remainingAmountPaymentMethod?: Maybe<PaymentMethodType>;
  /** 別日程調整を希望したかどうか */
  requestedOtherWebinarSchedule: Scalars["Boolean"]["output"];
  /** Co-Owners充当特典（旧S2Oポイント）の割引金額 */
  s2oPoint?: Maybe<S2oPoint>;
  /**
   * 選択した重要事項説明会
   * NOTE: admin によって変更されたりすることも考えると、`selected` は誤解を招くかもしれない
   */
  selectedWebinarSchedule?: Maybe<CoOwnersWebinarSchedule>;
  /** ステータス */
  status: CoOwnersApplicationStatus;
  /** 口単位の売却履歴。売却予定のものは soldAt が null で、申込が売却予定の間だけ 1 件ある */
  unitSales: Array<CoOwnersUnitSale>;
  /** 口数 */
  units: Scalars["Int"]["output"];
  /** 重要事項説明会の候補日 */
  webinarSchedules: Array<CoOwnersWebinarSchedule>;
};

/** CoOwners申し込み */
export type CoOwnersApplicationAllFilesArgs = {
  includeDeleted?: Scalars["Boolean"]["input"];
};

export type CoOwnersApplicationDetailInput =
  /** 個人名義の詳細情報 */
  | {
      individual: CoOwnersApplicationIndividualInput;
      organization?: never;
    } /** 法人名義の詳細情報 */
  | { individual?: never; organization: CoOwnersApplicationOrganizationInput };

export type CoOwnersApplicationDetails =
  /** 個人名義の詳細情報 */
  | {
      individual: CoOwnersApplicationIndividualInput;
      organization?: never;
    } /** 法人名義の詳細情報 */
  | { individual?: never; organization: CoOwnersApplicationOrganizationInput };

export type CoOwnersApplicationEvents = {
  __typename: "CoOwnersApplicationEvents";
  /** 前受金受領日 */
  advancePaymentReceivedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** キャンセル日 */
  cancelledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 完了日 */
  completedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 契約サイン日 */
  contractSignedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 受け渡し完了日 */
  handoverCompletedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 重説招待日 */
  invitedToDisclosureAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 重要事項説明会参加日 */
  participatedInDisclosureAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 入金受領日 */
  paymentReceivedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** レビュー日 */
  reviewedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 仮申込日 */
  submittedAt: Scalars["ZonedDateTime"]["output"];
};

/**
 * オーナー申込ごとに申込者と管理者がやり取りするファイル。
 * 一覧取得では URL を発行せず、ダウンロード時に createCoOwnersApplicationFileDownloadUrl で都度発行する
 */
export type CoOwnersApplicationFile = {
  __typename: "CoOwnersApplicationFile";
  contentType: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy?: Maybe<User>;
  /** アップロード時のファイル名 */
  fileName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** バイト数 */
  size: Scalars["Int"]["output"];
  uploadedBy: User;
  visibleToApplicant: Scalars["Boolean"]["output"];
};

export type CoOwnersApplicationIndividualInput = {
  /** 勤務先名 */
  employerName?: InputMaybe<Scalars["String"]["input"]>;
  /** 世帯年収 */
  householdIncome?: InputMaybe<IncomeBracketType>;
  /** 利用意向 */
  intendedUsage?: InputMaybe<OwnerIntendedUsageType>;
  /** 金融資産 */
  personalFinancialAssets?: InputMaybe<FinancialAssetsBracketType>;
  /** ローン申込の有無 */
  useLoan: Scalars["Boolean"]["input"];
};

export type CoOwnersApplicationInfoInput = {
  /** 追加購入割引額 */
  additionalPurchaseDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** 追加購入割引備考 */
  additionalPurchaseDiscountNote?: InputMaybe<Scalars["String"]["input"]>;
  /** 登録料の事前請求が必要かどうか */
  advancePaymentRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 申込金の支払い方法 */
  applicationFeePaymentMethod?: InputMaybe<PaymentMethodType>;
  /** メモ（null 以外の時上書きされる） */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** 引渡し希望日 */
  desiredHandoverDate?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
  /** 重要事項説明会参加者 */
  disclosureAssitant?: InputMaybe<DisclosureAssistantType>;
  /** 社員紹介割引額 */
  employeeReferralDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** 友人紹介割引額 */
  friendReferralDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** 本人確認書類 */
  identificationDocument1?: InputMaybe<UploadedFileInput>;
  /** 本人確認書類 */
  identificationDocument2?: InputMaybe<UploadedFileInput>;
  /** 本人確認書類 */
  identificationDocumentType?: InputMaybe<IdentificationDocumentType>;
  /** その他割引額 */
  otherDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** その他割引備考 */
  otherDiscountNote?: InputMaybe<Scalars["String"]["input"]>;
  /** 登録料の支払い方法 */
  registrationFeePaymentMethod?: InputMaybe<PaymentMethodType>;
  /** 残金の支払い方法 */
  remainingAmountPaymentMethod?: InputMaybe<PaymentMethodType>;
  /**
   * 重要事項説明会日（変更用）
   * null を指定した場合はブランクにリセットされる
   */
  webinarScheduleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CoOwnersApplicationInput = {
  /** 詳細の情報 */
  details: CoOwnersApplicationDetails;
  /**
   * 本人確認書類
   * @deprecated 本人確認は申込後の eKYC（TRUSTDOCK）で実施するためアップロード不要
   */
  identificationDocument1?: InputMaybe<UploadedFileInput>;
  /** @deprecated 本人確認は申込後の eKYC（TRUSTDOCK）で実施するためアップロード不要 */
  identificationDocument2?: InputMaybe<UploadedFileInput>;
  /**
   * 本人確認書類
   * @deprecated 本人確認は申込後の eKYC（TRUSTDOCK）で実施するため書類の事前申告は不要
   */
  identificationDocumentType?: InputMaybe<IdentificationDocumentType>;
  /** 希望する本人確認方法。未指定の場合は本人確認を開始しない */
  identityVerificationMethod?: InputMaybe<IdentityVerificationMethod>;
  /** 紹介コード */
  invitationCode?: InputMaybe<Scalars["String"]["input"]>;
  /** CoOwnersプランのID */
  ownerPlanId: Scalars["ID"]["input"];
  /** 口数 */
  units: Scalars["Int"]["input"];
  /** Weekday/Trial で蓄積した充当特典を利用するかどうか */
  useS2oPoints: Scalars["Boolean"]["input"];
  /** Stay 宿泊で蓄積した充当特典を利用するかどうか。初回申込でのみ有効。 */
  useStayCredit?: Scalars["Boolean"]["input"];
};

export type CoOwnersApplicationOrganizationInput = {
  /** 実質的支配者の住所 */
  beneficialOwnerAddress?: InputMaybe<AddressInJapanInput>;
  /** 実質的支配者の生年月日 */
  beneficialOwnerBirthDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 実質的支配者の名前 */
  beneficialOwnerName?: InputMaybe<Scalars["String"]["input"]>;
  /** その他の実質的支配者 */
  beneficialOwnerOthers?: InputMaybe<Scalars["String"]["input"]>;
  /** 実質的支配者と法人の関係性 */
  beneficialOwnerRelationship?: InputMaybe<OwnerOrganizationBeneficialOwnerRelationshipType>;
  /** 実質的支配者と法人の関係性はOtherの場合の自由記述 */
  beneficialOwnerRelationshipFree?: InputMaybe<Scalars["String"]["input"]>;
  /** 事業内容 */
  businessActivity?: InputMaybe<OwnerOrganizationBusinessActivityType>;
  /** 事業内容はOtherの場合の自由記述 */
  businessActivityFree?: InputMaybe<Scalars["String"]["input"]>;
  /** 会社の住所 */
  organizationAddress?: InputMaybe<AddressInJapanInput>;
  /** 会社名 */
  organizationName: Scalars["String"]["input"];
  /** 法人とオーナーの関係性 */
  organizationRelationship?: InputMaybe<OwnerOrganizationRelationshipType>;
  /** 登記簿謄本 */
  registryCertificateDocuments?: InputMaybe<Array<UploadedFileInput>>;
  /** 会社代表者名 */
  representativeName: Scalars["String"]["input"];
};

export type CoOwnersApplicationOwnerInfoInput = {
  /** 引渡し希望日 */
  desiredHandoverDate?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
  /** 詳細の情報 */
  detail: CoOwnersApplicationDetailInput;
  /** 外国PEPsへの該当有無 */
  isPep: Scalars["Boolean"]["input"];
  /** 利用用途 */
  purchasePurpose: OwnerPurchasePurposeType;
  /** 利用用途Otherの場合の自由記述 */
  purchasePurposeFree?: InputMaybe<Scalars["String"]["input"]>;
};

export const CoOwnersApplicationStatus = {
  /** 登録料支払い済み */
  AdvancePaymentReceived: "AdvancePaymentReceived",
  /**
   * 仮申込承認済み
   * 旧フローで使用。互換性維持のため残しておく。
   */
  Approved: "Approved",
  /**
   * 申込時の支払い待ち
   * 3D セキュアで失敗時などの状態
   */
  AwaitingApplicationPayment: "AwaitingApplicationPayment",
  /** キャンセル */
  Cancelled: "Cancelled",
  /** 申込完了 */
  Completed: "Completed",
  /** 契約サイン済み */
  ContractSigned: "ContractSigned",
  /** 引渡し完了 */
  HandoverCompleted: "HandoverCompleted",
  /**
   * 仮申込レビュー待ち
   * 旧フローで使用。互換性維持のため残しておく。
   */
  InReview: "InReview",
  /**
   * 重要事項説明会招待済み
   * 重説の日程が確定している
   */
  InvitedToDisclosure: "InvitedToDisclosure",
  /** 重要事項説明会参加済み */
  ParticipatedInDisclosure: "ParticipatedInDisclosure",
  /** 残金入金完了 */
  PaymentReceived: "PaymentReceived",
  /**
   * 売却予定
   * 買い替え（HIKE への下取り）契約済みで、引渡しまで既存物件のオーナーであり続ける状態。今年度の宿泊権利は残るが、次年度以降は付与されない。
   */
  PlannedForSale: "PlannedForSale",
  /**
   * 仮申込却下
   * 旧フローで使用。互換性維持のため残しておく。
   */
  Rejected: "Rejected",
  /**
   * 無効化（売却済）
   * 売却予定の年度末精算が完了し、既存物件の権利を完全に剥奪した状態。観測上の振る舞いは Void と同じ（プラン非表示・終端）。
   */
  Sold: "Sold",
  /**
   * 無効化
   * 引渡完了後に Admin が無効化したケース。観測上の振る舞いは Cancelled と同じ（プラン非表示・終端・S2O 充当不可）だが、遷移元は HandoverCompleted のみで、遷移時アクションが異なる（権利剥奪・予約や StayGift があれば不可）。
   */
  Void: "Void",
} as const;

export type CoOwnersApplicationStatus =
  (typeof CoOwnersApplicationStatus)[keyof typeof CoOwnersApplicationStatus];
export type CoOwnersApplicationStatusInput = {
  /** 初年度の泊数オーバーライド（登録料受領済/入金完了 に変更する場合に指定。省略時は自動計算） */
  currentYearStayCredits?: InputMaybe<Scalars["Int"]["input"]>;
  /** 次年度の泊数オーバーライド（登録料受領済/入金完了 に変更する場合に指定。省略時は自動計算） */
  nextYearStayCredits?: InputMaybe<Scalars["Int"]["input"]>;
  /** 変更後のステータス */
  status: CoOwnersApplicationStatus;
};

export type CoOwnersBakurakuInvoiceAnnualPaymentItem = {
  __typename: "CoOwnersBakurakuInvoiceAnnualPaymentItem";
  /** 品目金額 */
  amount: Scalars["Int"]["output"];
  /** 申込者（送付先コードのユーザー）。CSV には含めず画面の確認用 */
  applicant: User;
  /** 日付 */
  date: Scalars["String"]["output"];
  /** 書類番号 */
  documentNumber: Scalars["String"]["output"];
  /** 品目名 */
  name: Scalars["String"]["output"];
  /** 備考 */
  note: Scalars["String"]["output"];
  /** 支払期日 */
  paymentDueDate: Scalars["String"]["output"];
  /** 送付先コード */
  recipientCode: Scalars["String"]["output"];
  /** 品目税率 */
  taxRate: Scalars["String"]["output"];
  /** 品目単位 */
  unit: Scalars["String"]["output"];
};

/** バクラク連携用の送付先マスタデータ */
export type CoOwnersBakurakuInvoiceRecipient = {
  __typename: "CoOwnersBakurakuInvoiceRecipient";
  /** コード */
  code: Scalars["String"]["output"];
  /** 部署名 */
  departmentName: Scalars["String"]["output"];
  /** メールアドレス */
  email: Scalars["String"]["output"];
  /** メール送付 */
  emailDelivery: Scalars["String"]["output"];
  /** 送付先名 */
  recipientName: Scalars["String"]["output"];
};

/** バクラク連携用の登録料請求書明細 */
export type CoOwnersBakurakuInvoiceRegistrationFeeItem = {
  __typename: "CoOwnersBakurakuInvoiceRegistrationFeeItem";
  /** 品目金額 */
  amount: Scalars["Int"]["output"];
  /** 申込者（送付先コードのユーザー）。CSV には含めず画面の確認用 */
  applicant: User;
  /** 日付 */
  date: Scalars["String"]["output"];
  /** 書類番号 */
  documentNumber: Scalars["String"]["output"];
  /** 品目名 */
  name: Scalars["String"]["output"];
  /** 備考 */
  note: Scalars["String"]["output"];
  /** 支払期日 */
  paymentDueDate: Scalars["String"]["output"];
  /** 送付先コード */
  recipientCode: Scalars["String"]["output"];
  /** 品目税率 */
  taxRate: Scalars["String"]["output"];
  /** 品目単位 */
  unit: Scalars["String"]["output"];
};

/** バクラク連携用の残代金請求書明細 */
export type CoOwnersBakurakuInvoiceRemainingPaymentItem = {
  __typename: "CoOwnersBakurakuInvoiceRemainingPaymentItem";
  /** 品目金額 */
  amount: Scalars["Int"]["output"];
  /** 申込者（送付先コードのユーザー）。CSV には含めず画面の確認用 */
  applicant: User;
  /** 日付 */
  date: Scalars["String"]["output"];
  /** 書類番号 */
  documentNumber: Scalars["String"]["output"];
  /** 品目名 */
  name: Scalars["String"]["output"];
  /** 備考 */
  note: Scalars["String"]["output"];
  /** 支払期日 */
  paymentDueDate: Scalars["String"]["output"];
  /** 送付先コード */
  recipientCode: Scalars["String"]["output"];
  /** 品目税率 */
  taxRate: Scalars["String"]["output"];
  /** 品目単位 */
  unit: Scalars["String"]["output"];
};

export type CoOwnersPlanAccommodationReservationProvider = {
  __typename: "CoOwnersPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  userOwnershipId: Scalars["ID"]["output"];
};

/** CoOwnersプランの提供内容 */
export type CoOwnersPlanOffering = {
  __typename: "CoOwnersPlanOffering";
  /** 招待コード */
  earlyAccessCode?: Maybe<Scalars["String"]["output"]>;
  /** 見積書 */
  estimate?: Maybe<UploadedFile>;
  id: Scalars["ID"]["output"];
  /** 非表示設定 */
  isHidden: Scalars["Boolean"]["output"];
  /** このプランの提供は売れ切れているかどうか */
  isSoldOut: Scalars["Boolean"]["output"];
  /** 口数 */
  units: Scalars["Int"]["output"];
};

/** Co-Owners 申込の口単位の売却（買い替えによる下取り） */
export type CoOwnersUnitSale = {
  __typename: "CoOwnersUnitSale";
  id: Scalars["ID"]["output"];
  /** 売却月。売却月が属する年度までは宿泊権利が残る */
  saleYearMonth: Scalars["PlainYearMonth"]["output"];
  /** 売却を完了した日時。売却予定の間は null */
  soldAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** 売却する口数 */
  units: Scalars["Int"]["output"];
};

/** 重説参加スケジュール */
export type CoOwnersWebinarSchedule = {
  __typename: "CoOwnersWebinarSchedule";
  /** 申し込み */
  coOwnersApplications?: Maybe<Array<CoOwnersApplication>>;
  id: Scalars["ID"]["output"];
  /** 説明会の申し込みを受け付けているかどうか */
  isActive: Scalars["Boolean"]["output"];
  /** プランの拠点 */
  site: Site;
  /** 重説開始日時 */
  startsAt: Scalars["ZonedDateTime"]["output"];
  /** Zoom MTG等のURL */
  url: Scalars["String"]["output"];
};

/** 付帯サービスコワーキングスペース向けドアロックのコントローラ属性情報 */
export type CoWorkingSpaceDoorLock = {
  __typename: "CoWorkingSpaceDoorLock";
  keyUrl?: Maybe<Scalars["String"]["output"]>;
};

/**
 * 追加の鍵の情報
 * コワーキングスペースなどに利用
 */
export type CoWorkingSpaceKey = {
  __typename: "CoWorkingSpaceKey";
  /** 鍵の有効開始時刻 */
  availableFrom: Scalars["ZonedDateTime"]["output"];
  /** 鍵の有効終了時刻 */
  availableTo: Scalars["ZonedDateTime"]["output"];
  /** 説明 URL */
  instructionUrl: Scalars["String"]["output"];
  /** 鍵の URL */
  keyUrl?: Maybe<Scalars["String"]["output"]>;
  /** 施設名 */
  name: Scalars["String"]["output"];
};

/** アイデンティティ追加完了エラー */
export type CompleteAddIdentityError = {
  __typename: "CompleteAddIdentityError";
  case: CompleteAddIdentityErrorCase;
};

/** アイデンティティ追加完了エラーケース */
export const CompleteAddIdentityErrorCase = {
  /** このソーシャルアカウントは既に別のアカウントに連携されている */
  AlreadyLinkedToAnotherAccount: "AlreadyLinkedToAnotherAccount",
  /** intent tokenが無効または期限切れ */
  InvalidIntentToken: "InvalidIntentToken",
  /** Auth0とのトークン交換に失敗 */
  TokenExchangeFailed: "TokenExchangeFailed",
} as const;

export type CompleteAddIdentityErrorCase =
  (typeof CompleteAddIdentityErrorCase)[keyof typeof CompleteAddIdentityErrorCase];
/** アイデンティティ追加完了の入力 */
export type CompleteAddIdentityInput = {
  /** Auth0から返されたauthorization code */
  code: Scalars["String"]["input"];
  /** ラウンドトリップ用のstate (intent token) */
  state: Scalars["String"]["input"];
};

/** アイデンティティ追加完了の結果 */
export type CompleteAddIdentityPayload =
  | CompleteAddIdentityError
  | CompleteAddIdentitySuccess;

/** アイデンティティ追加完了成功 */
export type CompleteAddIdentitySuccess = {
  __typename: "CompleteAddIdentitySuccess";
  /** 成功後のリダイレクトURL */
  redirectUrl: Scalars["String"]["output"];
};

export type ConfirmTentativeAccommodationReservationError = {
  __typename: "ConfirmTentativeAccommodationReservationError";
  case: ConfirmTentativeAccommodationReservationErrorCase;
};

export const ConfirmTentativeAccommodationReservationErrorCase = {
  GeneralError: "GeneralError",
  InvalidStatus: "InvalidStatus",
  NotAuthorized: "NotAuthorized",
  TentativeDeadlineExceeded: "TentativeDeadlineExceeded",
} as const;

export type ConfirmTentativeAccommodationReservationErrorCase =
  (typeof ConfirmTentativeAccommodationReservationErrorCase)[keyof typeof ConfirmTentativeAccommodationReservationErrorCase];
export type ConfirmTentativeAccommodationReservationInput = {
  nextLocation: Scalars["String"]["input"];
  numberOfAdults: Scalars["Int"]["input"];
  numberOfDogs: Scalars["Int"]["input"];
  numberOfInfants: Scalars["Int"]["input"];
  numberOfKids: Scalars["Int"]["input"];
  previousLocation: Scalars["String"]["input"];
};

export type ConfirmTentativeAccommodationReservationPayload =
  | AccommodationReservation
  | ConfirmTentativeAccommodationReservationError;

/** 有料備品の利用料金 */
export type ConsumedSuppliesFee = {
  __typename: "ConsumedSuppliesFee";
  /** 料金の項目 */
  items: Array<ConsumedSuppliesFeeItem>;
  /** 料金の合計 */
  totalAmount: Scalars["Int"]["output"];
};

/** 有料備品の利用料金の項目 */
export type ConsumedSuppliesFeeItem = {
  __typename: "ConsumedSuppliesFeeItem";
  /** 税込金額(合計) */
  amount: Scalars["Int"]["output"];
  /** 項目名 */
  label: Scalars["String"]["output"];
  /** 数量 */
  quantity: Scalars["Int"]["output"];
  /**
   * 清掃報告（JTAS）で申告された実消費数量。免除適用前の数量。
   * Bubble 経由の項目や、対応する清掃報告が存在しない場合は null。
   */
  reportedQuantity?: Maybe<Scalars["Int"]["output"]>;
  /** 消費税率 */
  taxRate: Scalars["Float"]["output"];
  /** 税込金額（単価） */
  unitAmount: Scalars["Int"]["output"];
};

/** 有料備品利用による請求項目 */
export type ConsumedSuppliesFeeItemInput = {
  externalSupplyProductMasterId: Scalars["ID"]["input"];
  label: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  taxRateType: ConsumptionTaxRateType;
  unitAmount: Scalars["Int"]["input"];
};

/** 有料備品の免除 */
export type ConsumedSupplyFeeItemWaiver = {
  __typename: "ConsumedSupplyFeeItemWaiver";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** 免除する数量 */
  quantity: Scalars["Int"]["output"];
  /** 対象の備品種別（type=BySupplyItemMasterCategory の場合のみ） */
  supplyItemMasterCategory?: Maybe<SupplyItemMasterCategory>;
  /** 免除タイプ */
  type: ConsumedSupplyFeeItemWaiverType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ConsumedSupplyFeeItemWaiverInput = {
  quantity: Scalars["Int"]["input"];
  /** type=BySupplyItemMasterCategory の場合は必須 */
  supplyItemMasterCategory?: InputMaybe<SupplyItemMasterCategory>;
  type: ConsumedSupplyFeeItemWaiverType;
};

/** 有料備品の免除のタイプ */
export const ConsumedSupplyFeeItemWaiverType = {
  /** 指定した種別の備品の中で最も単価が高いものを免除 */
  BySupplyItemMasterCategory: "BySupplyItemMasterCategory",
  /** 全備品の中で最も単価が高いものを免除 */
  HighestUnitPrice: "HighestUnitPrice",
} as const;

export type ConsumedSupplyFeeItemWaiverType =
  (typeof ConsumedSupplyFeeItemWaiverType)[keyof typeof ConsumedSupplyFeeItemWaiverType];
/** 消費税の種類 */
export const ConsumptionTaxRateType = {
  /** 軽減税率 */
  Reduced: "Reduced",
  /** 標準税率 */
  Standard: "Standard",
} as const;

export type ConsumptionTaxRateType =
  (typeof ConsumptionTaxRateType)[keyof typeof ConsumptionTaxRateType];
/** 建築家 */
export type ContentArchitect = {
  __typename: "ContentArchitect";
  /** この建築家が紐づいている建築タイプ（名前順） */
  architectureTypes: Array<ArchitectureType>;
  /** プロフィール */
  bio: Scalars["String"]["output"];
  /** 会社名 */
  company: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 写真 */
  imageUrl: UploadedFile;
  /** 名前（日本語） */
  name: Scalars["String"]["output"];
  /** 名前（英語） */
  nameEn: Scalars["String"]["output"];
};

/** 設備コンテンツ。公開ページ /architectures/features/[slug] と建築トップの設備カードの中身 */
export type ContentArchitecturalFeature = {
  __typename: "ContentArchitecturalFeature";
  /** このコンテンツが説明している設備。公開ページの「この設備がある拠点」一覧を駆動する */
  accommodationFacilities: Array<AccommodationFacility>;
  /** 設備の提供状況についての注記。未設定なら null */
  availabilityNote?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  /** 公開ページに出す特徴 */
  facilityAmenities: Array<ContentArchitectureTypeVariantFacilityAmenity>;
  id: Scalars["ID"]["output"];
  /** 公開ページのカルーセル画像 */
  imageUrls: Array<UploadedFile>;
  name: Scalars["String"]["output"];
  /** 利用ルールの末尾に出る注記 */
  ruleNoteMarkup: Scalars["String"]["output"];
  /** 利用ルールの見出し（「愛犬同伴時のお願い」など） */
  ruleTitle: Scalars["String"]["output"];
  /** 利用ルールの本文。sort 昇順 */
  rules: Array<ContentArchitecturalFeatureUsageRule>;
  /** 公開ページの URL に入る識別子。変えると既存 URL が 404 になる */
  slug: Scalars["String"]["output"];
  /** 建築トップの設備カードの並び順 */
  sort: Scalars["Int"]["output"];
  /** 建築トップの設備カードに出る画像。未設定なら null */
  thumbnailImageUrl?: Maybe<UploadedFile>;
  usageConditionsDescription: Scalars["String"]["output"];
  usageFeesDescriptionMarkup: Scalars["String"]["output"];
};

/** 設備コンテンツの利用ルール 1 件 */
export type ContentArchitecturalFeatureUsageRule = {
  __typename: "ContentArchitecturalFeatureUsageRule";
  bodyMarkup: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** ルールに添える画像。未設定なら null */
  imageUrl?: Maybe<UploadedFile>;
  sort: Scalars["Int"]["output"];
};

/** 建築ページのナビゲーション */
export type ContentArchitecturePageNavigation = {
  __typename: "ContentArchitecturePageNavigation";
  feature: Array<ContentArchitecturePageNavigationItem>;
  originalSeries: Array<ContentArchitecturePageNavigationItem>;
  selectionSeries: Array<ContentArchitecturePageNavigationItem>;
};

/** 建築ページのナビゲーション項目 */
export type ContentArchitecturePageNavigationItem = {
  __typename: "ContentArchitecturePageNavigationItem";
  /** エリア: Selectionシリーズのみ */
  area?: Maybe<Scalars["String"]["output"]>;
  /** 名前 */
  name: Scalars["String"]["output"];
  /** 遷移先 */
  path: Scalars["String"]["output"];
  /** slug (subItemsがある場合は省略) */
  slug?: Maybe<Scalars["String"]["output"]>;
  /** サブ項目 */
  subItems?: Maybe<Array<ContentArchitecturePageNavigationSubItem>>;
  /** 画像 */
  thumbnail: UploadedFile;
};

/** 建築ページのナビゲーションサブ項目（Medium, Large） */
export type ContentArchitecturePageNavigationSubItem = {
  __typename: "ContentArchitecturePageNavigationSubItem";
  /** name */
  name: Scalars["String"]["output"];
  /** 遷移先 */
  path: Scalars["String"]["output"];
  /** slug */
  slug: Scalars["String"]["output"];
};

/** 建築タイプのコンテンツ */
export type ContentArchitectureType = {
  __typename: "ContentArchitectureType";
  /** 設備の操作マニュアル（リンク） */
  amenitiesInstructionsUrl?: Maybe<Scalars["String"]["output"]>;
  /** 建築家 */
  architect: ContentArchitect;
  /** 建築家のコメント */
  architectComment: Scalars["String"]["output"];
  /** 建築タイプ */
  architectureType: ArchitectureType;
  /** エリア (Selection Seriesのみ) */
  area?: Maybe<Scalars["String"]["output"]>;
  /** 基本の設備 */
  basicAmenities: Array<ContentArchitectureTypeBasicAmenity>;
  /** 最大収容人数（フリーテキスト） */
  capacityDescription: Scalars["String"]["output"];
  /** 予約完了メールに表示される画像 URL の設定値。未設定なら null（公開側の emailCoverImageUrl はデフォルト画像にフォールバックする） */
  customEmailCoverImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 概要テキスト */
  description: Scalars["String"]["output"];
  /** 予約完了メールに表示される建築タイプの画像 URL */
  emailCoverImageUrl: Scalars["String"]["output"];
  /** 備品リスト（リンク） */
  equipmentsListUrl?: Maybe<Scalars["String"]["output"]>;
  /** 体験リスト */
  experiences: Array<ContentArchitectureTypeExperience>;
  /** 間取り図（Selection Seriesのみ） */
  floorPlanImageUrl?: Maybe<UploadedFile>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** カルーセル画像 */
  imageUrls: Array<UploadedFile>;
  /** オプション */
  options: Array<ContentArchitectureTypeVariant>;
  /** 対象拠点 */
  sites: Array<ContentArchitectureTypeSite>;
  /** 広さ（フリーテキスト） */
  sizeDescription: Scalars["String"]["output"];
  /** 広さ（㎡） */
  sizeSqm: Scalars["Float"]["output"];
  /** 建築ページ一覧での並び順 */
  sort: Scalars["Int"]["output"];
  /** 建築（一覧）ページで表示される画像。未設定なら null */
  thumbnailImageUrl?: Maybe<UploadedFile>;
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 建築バリエーション */
  variations: Array<ContentArchitectureTypeVariant>;
};

/** 基本の設備 */
export type ContentArchitectureTypeBasicAmenity = {
  __typename: "ContentArchitectureTypeBasicAmenity";
  /** この設備が紐づいている建築タイプ（名前順） */
  architectureTypes: Array<ArchitectureType>;
  /** 設備のアイコン。未設定の設備が実在するので null になりうる */
  iconUrl?: Maybe<UploadedFile>;
  id: Scalars["ID"]["output"];
  /** 設備の名前 */
  name: Scalars["String"]["output"];
  sort: Scalars["Int"]["output"];
};

/** 体験 */
export type ContentArchitectureTypeExperience = {
  __typename: "ContentArchitectureTypeExperience";
  /** 体験の説明（Markup） */
  descriptionMarkup: Scalars["String"]["output"];
  /** 体験の画像 */
  imageUrl: UploadedFile;
  /** 体験の名前 */
  name: Scalars["String"]["output"];
};

/** 建築タイプのFeature */
export type ContentArchitectureTypeFeature = {
  __typename: "ContentArchitectureTypeFeature";
  /** 対象拠点の上部に表示される注意事項（eg.「建築タイプごとに異なる仕様のサウナが設置されていますので、各建築タイプのページでご確認ください。」） */
  availabilityNote?: Maybe<Scalars["String"]["output"]>;
  /** 説明 */
  description: Scalars["String"]["output"];
  /** 設備の詳細 */
  facilityDetails: ContentFacilityDetails;
  /** カルーセル画像 */
  imageUrls: Array<UploadedFile>;
  /** 名前 */
  name: Scalars["String"]["output"];
  /** 対象拠点(部屋) */
  sitesByArchitectureType: Array<ContentArchitectureTypeFeatureSite>;
  /** 利用ルール */
  usageRule?: Maybe<ContentArchitectureTypeFeatureUsageRule>;
};

/** 建築タイプのFeatureの建築タイプごとの対象拠点 */
export type ContentArchitectureTypeFeatureSite = {
  __typename: "ContentArchitectureTypeFeatureSite";
  /** 建築タイプ名 */
  architectureTypeName: Scalars["String"]["output"];
  /** 対象拠点 */
  sites: Array<ContentArchitectureTypeVariantSite>;
};

export type ContentArchitectureTypeFeatureUsageRule = {
  __typename: "ContentArchitectureTypeFeatureUsageRule";
  /** 注意事項(Markup) */
  noteMarkup?: Maybe<Scalars["String"]["output"]>;
  /** ルール内容 */
  ruleItems: Array<ContentArchitectureTypeFeatureUsageRuleItem>;
  /** ルール見出し */
  title: Scalars["String"]["output"];
};

export type ContentArchitectureTypeFeatureUsageRuleItem = {
  __typename: "ContentArchitectureTypeFeatureUsageRuleItem";
  /** ルール内容 */
  bodyMarkup: Scalars["String"]["output"];
  /** 画像 */
  imageUrl?: Maybe<UploadedFile>;
};

/** 建築タイプの対象拠点 */
export type ContentArchitectureTypeSite = {
  __typename: "ContentArchitectureTypeSite";
  /** オープン予定 */
  isOpeningSoon: Scalars["Boolean"]["output"];
  /** 拠点の名前 */
  name: Scalars["String"]["output"];
};

/** 建築タイプのバリエーション・オプション */
export type ContentArchitectureTypeVariant = {
  __typename: "ContentArchitectureTypeVariant";
  /** このバリエーション / オプションを構成する設備 */
  accommodationFacilities: Array<AccommodationFacility>;
  /** ひとこと説明（WithSaunaの「サウナ付きのキャビン」にあたる） */
  brief: Scalars["String"]["output"];
  /** 説明 */
  description: Scalars["String"]["output"];
  /** 設備の詳細 */
  facilityDetails: ContentFacilityDetails;
  id: Scalars["ID"]["output"];
  /** カルーセル画像 */
  imageUrls: Array<UploadedFile>;
  /** バリエーションとオプションはテーブルが分かれているだけで同形なので、区別は kind で持つ */
  kind: ContentArchitectureTypeVariantKind;
  /** 名前 */
  name: Scalars["String"]["output"];
  /** 対象拠点(部屋) */
  sites: Array<ContentArchitectureTypeVariantSite>;
  slug: Scalars["String"]["output"];
};

/** 建築タイプのバリエーション・オプションに付帯する設備（「WithSauna」に付帯する「バレルサウナ」「水風呂・ととのい椅子」・「サウナ用備品」など） */
export type ContentArchitectureTypeVariantFacilityAmenity = {
  __typename: "ContentArchitectureTypeVariantFacilityAmenity";
  /** このアメニティが属する設備（「バレルサウナ」なら Sauna） */
  accommodationFacility: AccommodationFacility;
  /** 説明（Markup） */
  descriptionMarkup: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 名前 */
  name: Scalars["String"]["output"];
  /** このアメニティを参照している件数。参照が 1 件でもあると削除できない */
  referenceCounts: ContentFacilityAmenityReferenceCounts;
};

/** 建築タイプのバリエーション（Variation）とオプション（Option）は別テーブルだが、公開型は同じ ContentArchitectureTypeVariant なので kind で区別する */
export const ContentArchitectureTypeVariantKind = {
  Option: "Option",
  Variation: "Variation",
} as const;

export type ContentArchitectureTypeVariantKind =
  (typeof ContentArchitectureTypeVariantKind)[keyof typeof ContentArchitectureTypeVariantKind];
/** 建築タイプのバリエーション・オプションの対象拠点 */
export type ContentArchitectureTypeVariantSite = {
  __typename: "ContentArchitectureTypeVariantSite";
  /** 部屋リスト */
  accommodations: Array<Accommodation>;
  /** 拠点名 */
  name: Scalars["String"]["output"];
};

/** 設備アメニティの参照元の件数 */
export type ContentFacilityAmenityReferenceCounts = {
  __typename: "ContentFacilityAmenityReferenceCounts";
  features: Scalars["Int"]["output"];
  options: Scalars["Int"]["output"];
  variations: Scalars["Int"]["output"];
};

/** バリエーション・オプションや、Featureなどの詳細情報 */
export type ContentFacilityDetails = {
  __typename: "ContentFacilityDetails";
  /** 付帯する設備 */
  facilityAmenities: Array<ContentArchitectureTypeVariantFacilityAmenity>;
  /** ご利用条件・備考テキスト */
  usageConditionsDescription: Scalars["String"]["output"];
  /** ご利用料金テキスト（Markup） */
  usageFeesDescriptionMarkup: Scalars["String"]["output"];
};

/** ルームタイプの表示コンテンツ */
export type ContentRoomType = {
  __typename: "ContentRoomType";
  /** 紹介文 (空文字 / 未設定の場合は null。呼び出し側でトルツメする想定) */
  description?: Maybe<Scalars["String"]["output"]>;
  /**
   * ヒーロー画像。`count` 指定時は先頭から `count` 件のみ返す
   * （一覧サムネは count: 1、詳細はギャラリー全件、のように payload を絞れる）。
   */
  heroImages: Array<UploadedFile>;
  /** ID */
  id: Scalars["ID"]["output"];
};

/** ルームタイプの表示コンテンツ */
export type ContentRoomTypeHeroImagesArgs = {
  count?: InputMaybe<Scalars["Int"]["input"]>;
};

/** 契約継続タイプ */
export const ContractContinuationType = {
  /** 解約（次期契約を作成しない） */
  Cancel: "Cancel",
  /** 継続（契約終了5ヶ月前までに次期契約を自動作成） */
  Continue: "Continue",
} as const;

export type ContractContinuationType =
  (typeof ContractContinuationType)[keyof typeof ContractContinuationType];
/** 契約ステータス */
export const ContractStatus = {
  /** 契約中（現在有効） */
  Active: "Active",
  /** 契約満了（期間終了済み） */
  Expired: "Expired",
  /** 契約無効済（論理削除済み） */
  Invalidated: "Invalidated",
  /** 契約予定（3ヶ月以内に開始予定） */
  Scheduled: "Scheduled",
} as const;

export type ContractStatus =
  (typeof ContractStatus)[keyof typeof ContractStatus];
export const CountryEnum = {
  Abw: "ABW",
  Afg: "AFG",
  Ago: "AGO",
  Aia: "AIA",
  Alb: "ALB",
  And: "AND",
  Ant: "ANT",
  Are: "ARE",
  Arg: "ARG",
  Arm: "ARM",
  Asm: "ASM",
  Ata: "ATA",
  Atg: "ATG",
  Aus: "AUS",
  Aut: "AUT",
  Aze: "AZE",
  Bdi: "BDI",
  Bel: "BEL",
  Ben: "BEN",
  Bfa: "BFA",
  Bgd: "BGD",
  Bgr: "BGR",
  Bhr: "BHR",
  Bhs: "BHS",
  Bih: "BIH",
  Blr: "BLR",
  Blz: "BLZ",
  Bmu: "BMU",
  Bol: "BOL",
  Bra: "BRA",
  Brb: "BRB",
  Brn: "BRN",
  Btn: "BTN",
  Bwa: "BWA",
  Caf: "CAF",
  Can: "CAN",
  Cck: "CCK",
  Che: "CHE",
  Chi: "CHI",
  Chl: "CHL",
  Chn: "CHN",
  Civ: "CIV",
  Cmr: "CMR",
  Cod: "COD",
  Cog: "COG",
  Cok: "COK",
  Col: "COL",
  Com: "COM",
  Cpv: "CPV",
  Cri: "CRI",
  Cub: "CUB",
  Cxr: "CXR",
  Cym: "CYM",
  Cyp: "CYP",
  Cze: "CZE",
  Deu: "DEU",
  Dji: "DJI",
  Dma: "DMA",
  Dnk: "DNK",
  Dom: "DOM",
  Dza: "DZA",
  Ecu: "ECU",
  Egy: "EGY",
  Eri: "ERI",
  Esh: "ESH",
  Esp: "ESP",
  Est: "EST",
  Eth: "ETH",
  Fin: "FIN",
  Fji: "FJI",
  Flk: "FLK",
  Fra: "FRA",
  Fro: "FRO",
  Fsm: "FSM",
  Gab: "GAB",
  Gbr: "GBR",
  Geo: "GEO",
  Gha: "GHA",
  Gib: "GIB",
  Gin: "GIN",
  Glp: "GLP",
  Gmb: "GMB",
  Gnb: "GNB",
  Gnq: "GNQ",
  Grc: "GRC",
  Grd: "GRD",
  Grl: "GRL",
  Gtm: "GTM",
  Guf: "GUF",
  Gum: "GUM",
  Guy: "GUY",
  Hkg: "HKG",
  Hnd: "HND",
  Hrv: "HRV",
  Hti: "HTI",
  Hun: "HUN",
  Idn: "IDN",
  Imn: "IMN",
  Ind: "IND",
  Iot: "IOT",
  Irl: "IRL",
  Irn: "IRN",
  Irq: "IRQ",
  Isl: "ISL",
  Isr: "ISR",
  Ita: "ITA",
  Jam: "JAM",
  Jon: "JON",
  Jor: "JOR",
  Jpn: "JPN",
  Kas: "KAS",
  Kaz: "KAZ",
  Ken: "KEN",
  Kgz: "KGZ",
  Khm: "KHM",
  Kir: "KIR",
  Kna: "KNA",
  Kor: "KOR",
  Ksv: "KSV",
  Kwt: "KWT",
  Lao: "LAO",
  Lbn: "LBN",
  Lbr: "LBR",
  Lby: "LBY",
  Lca: "LCA",
  Lie: "LIE",
  Lka: "LKA",
  Lso: "LSO",
  Ltu: "LTU",
  Lux: "LUX",
  Lva: "LVA",
  Mac: "MAC",
  Mar: "MAR",
  Mco: "MCO",
  Mda: "MDA",
  Mdg: "MDG",
  Mdv: "MDV",
  Mex: "MEX",
  Mhl: "MHL",
  Mid: "MID",
  Mkd: "MKD",
  Mli: "MLI",
  Mlt: "MLT",
  Mmr: "MMR",
  Mne: "MNE",
  Mng: "MNG",
  Mnp: "MNP",
  Moz: "MOZ",
  Mrt: "MRT",
  Msr: "MSR",
  Mtq: "MTQ",
  Mus: "MUS",
  Mwi: "MWI",
  Mys: "MYS",
  Myt: "MYT",
  Nam: "NAM",
  Ncl: "NCL",
  Ner: "NER",
  Nfk: "NFK",
  Nga: "NGA",
  Nic: "NIC",
  Niu: "NIU",
  Nld: "NLD",
  Nor: "NOR",
  Npl: "NPL",
  Nru: "NRU",
  Nzl: "NZL",
  Omn: "OMN",
  Pak: "PAK",
  Pan: "PAN",
  Pcn: "PCN",
  Per: "PER",
  Phl: "PHL",
  Plw: "PLW",
  Png: "PNG",
  Pol: "POL",
  Pri: "PRI",
  Prk: "PRK",
  Prt: "PRT",
  Pry: "PRY",
  Pse: "PSE",
  Pyf: "PYF",
  Qat: "QAT",
  Reu: "REU",
  Rou: "ROU",
  Rus: "RUS",
  Rwa: "RWA",
  Sau: "SAU",
  Sdn: "SDN",
  Sen: "SEN",
  Sgp: "SGP",
  Shn: "SHN",
  Sjm: "SJM",
  Slb: "SLB",
  Sle: "SLE",
  Slv: "SLV",
  Smr: "SMR",
  Som: "SOM",
  Spm: "SPM",
  Srb: "SRB",
  Ssd: "SSD",
  Stp: "STP",
  Sur: "SUR",
  Svk: "SVK",
  Svn: "SVN",
  Swe: "SWE",
  Swz: "SWZ",
  Syc: "SYC",
  Syr: "SYR",
  Tca: "TCA",
  Tcd: "TCD",
  Tgo: "TGO",
  Tha: "THA",
  Tjk: "TJK",
  Tkl: "TKL",
  Tkm: "TKM",
  Tls: "TLS",
  Ton: "TON",
  Tto: "TTO",
  Tun: "TUN",
  Tur: "TUR",
  Tuv: "TUV",
  Twn: "TWN",
  Tza: "TZA",
  Uga: "UGA",
  Ukr: "UKR",
  Ury: "URY",
  Usa: "USA",
  Uzb: "UZB",
  Vat: "VAT",
  Vct: "VCT",
  Ven: "VEN",
  Vgb: "VGB",
  Vir: "VIR",
  Vnm: "VNM",
  Vut: "VUT",
  Wak: "WAK",
  Wlf: "WLF",
  Wsm: "WSM",
  Yem: "YEM",
  Zaf: "ZAF",
  Zmb: "ZMB",
  Zwe: "ZWE",
  Zzz: "ZZZ",
} as const;

export type CountryEnum = (typeof CountryEnum)[keyof typeof CountryEnum];
export type CreateAccommodationAvailabilityBlockInput = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  beginNight: Scalars["PlainDate"]["input"];
  category: AccommodationAvailabilityBlockCategory;
  endNight: Scalars["PlainDate"]["input"];
  /**
   * 既存の予約と重複していてもブロックを作成する。
   * 既存の他ブロックとの重複は指定に関わらず不可。
   */
  ignoreReservations?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTentative: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  siteId: Scalars["ID"]["input"];
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateAccommodationReservationError = {
  __typename: "CreateAccommodationReservationError";
  case: CreateAccommodationReservationErrorCase;
  internalCode?: Maybe<Scalars["String"]["output"]>;
};

export const CreateAccommodationReservationErrorCase = {
  /** サブスクにおいて同一予約サイクル内ですでに予約を取っている */
  CycleDuplicationError: "CycleDuplicationError",
  /** 現在予約可能な期間に収まっていない */
  InvalidReservationPeriodError: "InvalidReservationPeriodError",
  /** 月間泊数の上限を超えている */
  MaxNightsPerMonthExceededError: "MaxNightsPerMonthExceededError",
  /** 年間泊数の上限を超えている */
  MaxNightsPerYearExceededError: "MaxNightsPerYearExceededError",
  /** 同時予約数の上限を超えている */
  MaxReservationsExceededError: "MaxReservationsExceededError",
  /** Weekdayプランの月7泊制限を超過している */
  MonthlyNightLimitExceededError: "MonthlyNightLimitExceededError",
  /** 同月内予約数の上限を超えている */
  MonthlyReservationLimitExceededError: "MonthlyReservationLimitExceededError",
  /** サブスクにおいて1週間以内ですでに予約を取っている */
  Next7DaysDuplicationError: "Next7DaysDuplicationError",
  /** Stay Gift from Owners のオーナーが自身の予約を取ろうとした */
  OwnerOfStayGiftFromOwnersError: "OwnerOfStayGiftFromOwnersError",
  /** オーナーの泊数が不足している */
  OwnerStayCreditInsufficientError: "OwnerStayCreditInsufficientError",
  /** オーナー拠点の繁忙日はオーナー会員のみが予約可能である */
  PeakDayOwnerOnlyError: "PeakDayOwnerOnlyError",
  /** High日制限を超えている */
  PeakDaysLimitExceededError: "PeakDaysLimitExceededError",
  /** 同一の日程ですでに別の予約を取っている */
  ReservationOverlapError: "ReservationOverlapError",
  /**
   * 部屋が空室ではないため利用不可能
   * （内部的には稼働制御によるものであることもある）
   */
  ResourceUnavailable: "ResourceUnavailable",
  /** SanuIncプロバイダーでstaffGroupIdが指定されていない */
  SanuIncStaffGroupIdRequiredError: "SanuIncStaffGroupIdRequiredError",
  /** 拠点ハイシーズン制限を超えている（FullOwnerのみ） */
  SiteHighSeasonLimitExceededError: "SiteHighSeasonLimitExceededError",
  /** 宿泊チケットが使用済みまたは無効である */
  StayTicketError: "StayTicketError",
  /** サブスクリプションが支払い失敗により停止されている */
  SubscriptionSuspended: "SubscriptionSuspended",
  /** 未同意の規約の改定がある */
  TermsNotAgreedError: "TermsNotAgreedError",
  /** Trialプランが支払い失敗により停止されている */
  TrialContractSuspended: "TrialContractSuspended",
  /** Trialプランの泊数が不足している */
  TrialStayCreditInsufficientError: "TrialStayCreditInsufficientError",
  /** 予期せぬエラー */
  UnexpectedError: "UnexpectedError",
  /** 未払いの宿泊料金がある */
  UnpaidAccommodationFeeError: "UnpaidAccommodationFeeError",
  /** Weekdayプランの新規約に同意していない */
  WeekdayTermsNotAgreedError: "WeekdayTermsNotAgreedError",
} as const;

export type CreateAccommodationReservationErrorCase =
  (typeof CreateAccommodationReservationErrorCase)[keyof typeof CreateAccommodationReservationErrorCase];
export type CreateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  firstNight: Scalars["PlainDate"]["input"];
  /** 部屋タイプ予約として作成するか。省略時は false（通常予約）として扱う */
  isRoomTypeReservation?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

export type CreateAccommodationReservationPayload =
  | AccommodationReservation
  | CreateAccommodationReservationError;

export type CreateCoOwnersApplicationFileDownloadUrlError = {
  __typename: "CreateCoOwnersApplicationFileDownloadUrlError";
  case: CreateCoOwnersApplicationFileDownloadUrlErrorCase;
};

export const CreateCoOwnersApplicationFileDownloadUrlErrorCase = {
  NotFound: "NotFound",
} as const;

export type CreateCoOwnersApplicationFileDownloadUrlErrorCase =
  (typeof CreateCoOwnersApplicationFileDownloadUrlErrorCase)[keyof typeof CreateCoOwnersApplicationFileDownloadUrlErrorCase];
export type CreateCoOwnersApplicationFileDownloadUrlPayload =
  | CreateCoOwnersApplicationFileDownloadUrlError
  | CreateCoOwnersApplicationFileDownloadUrlSuccess;

export type CreateCoOwnersApplicationFileDownloadUrlSuccess = {
  __typename: "CreateCoOwnersApplicationFileDownloadUrlSuccess";
  url: Scalars["String"]["output"];
};

export type CreateCoOwnersApplicationFileUploadPolicyInput = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  /** アップロードするファイルの Content-Type。PDF または画像のみ */
  contentType: Scalars["String"]["input"];
};

export type CreateFacilityReservationError = {
  __typename: "CreateFacilityReservationError";
  case: CreateFacilityReservationErrorCase;
};

export const CreateFacilityReservationErrorCase = {
  AccommodationReservationPeriodMismatch:
    "AccommodationReservationPeriodMismatch",
  FeePolicyNotFound: "FeePolicyNotFound",
  InvalidFacilityFieldData: "InvalidFacilityFieldData",
  InvalidSlotSelection: "InvalidSlotSelection",
  InvalidStartDate: "InvalidStartDate",
  NoAccommodationReservation: "NoAccommodationReservation",
  PastReserveDeadline: "PastReserveDeadline",
  ProviderNotEligible: "ProviderNotEligible",
  ResourceUnavailable: "ResourceUnavailable",
  ServiceNotAvailable: "ServiceNotAvailable",
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type CreateFacilityReservationErrorCase =
  (typeof CreateFacilityReservationErrorCase)[keyof typeof CreateFacilityReservationErrorCase];
/** 付帯サービス予約作成入力 */
export type CreateFacilityReservationInput = {
  accommodationReservationId: Scalars["ID"]["input"];
  customFieldValues?: InputMaybe<Array<FacilityCustomFieldValueInput>>;
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  resourceId: Scalars["ID"]["input"];
  slotId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate: Scalars["PlainDate"]["input"];
};

export type CreateFacilityReservationPayload =
  | CreateFacilityReservationError
  | CreateFacilityReservationSuccess;

export type CreateFacilityReservationSuccess = {
  __typename: "CreateFacilityReservationSuccess";
  reservation: FacilityReservation;
};

export type CreateFileUploadPolicyError = {
  __typename: "CreateFileUploadPolicyError";
  case: CreateFileUploadPolicyErrorCase;
};

export const CreateFileUploadPolicyErrorCase = {
  GeneralError: "GeneralError",
  /** 紐づけ先のリソースが存在しないか、アクセスできない */
  NotFound: "NotFound",
  ResourceIdRequired: "ResourceIdRequired",
} as const;

export type CreateFileUploadPolicyErrorCase =
  (typeof CreateFileUploadPolicyErrorCase)[keyof typeof CreateFileUploadPolicyErrorCase];
export type CreateFileUploadPolicySuccess = {
  __typename: "CreateFileUploadPolicySuccess";
  policy: S3UploadPolicy;
};

export type CreateFullOwnerContractUploadPolicyInput = {
  type: SanuFileType;
};

/** 基本宿泊料金ポリシーの作成・更新時の入力 */
export type CreateOrUpdateBaseAccommodationFeePolicyInput = {
  dailyFeePolicy: Array<Scalars["Int"]["input"]>;
  feeModifier?: InputMaybe<Scalars["Int"]["input"]>;
  feeModifierType?: InputMaybe<FeeModifierType>;
  /**
   * 料金設定ルール。
   * 省略 (null) した場合は既存のルールを変更しない。
   * 空配列を渡した場合は既存のルールを全削除する。
   * 配列を渡した場合は既存のルールを全置換する。
   */
  feeRules?: InputMaybe<Array<AccommodationFeeRuleInput>>;
  internalName: Scalars["String"]["input"];
  /** 宿泊費の一部または全部が第三者（タイアップ先等）の負担であるか */
  isThirdPartyCovered?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** dailyFeePolicy に含まれない第三者負担額（泊毎） */
  thirdPartyCoveredDailyFeePolicy?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type CreateOrUpdateBusinessPlanInput = {
  feePerNights: Scalars["Int"]["input"];
  feePerNum: Scalars["Int"]["input"];
  isPeakDayFeeFree: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateOrUpdateCancelFeePolicyInput = {
  /** 固定料金の場合の設定値（0以上の整数） */
  cancelFeeFixedPolicy?: InputMaybe<CancelFeeFixedPolicyInput>;
  /** 料率ベースの場合の設定値（0.0 ~ 1.0） */
  cancelFeeRatePolicy?: InputMaybe<CancelFeeRatePolicyInput>;
  /** true の場合、即時100%のキャンセル料が発生する（実質的にキャンセル不可のポリシー）。 */
  immediate?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 内部管理用の名前 */
  internalDescription: Scalars["String"]["input"];
  /** 内部管理用の名前 */
  internalName: Scalars["String"]["input"];
};

/** 法人の作成・更新時の入力 */
export type CreateOrUpdateOrganizationInput = {
  announcementContent: Scalars["String"]["input"];
  assignedUserEmail?: InputMaybe<Scalars["String"]["input"]>;
  billingEmail?: InputMaybe<Scalars["String"]["input"]>;
  defaultFrequency?: InputMaybe<OrganizationYearlyContractInvoiceFrequency>;
  defaultPaymentMethod?: InputMaybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  /** サービス上で表示する名称。省略すると現在の値を保ち、null か空文字で未設定に戻す */
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  emailDomainsForMember: Array<Scalars["String"]["input"]>;
  invitationCode: Scalars["String"]["input"];
  maxNightsPerMember?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerStay?: InputMaybe<Scalars["Int"]["input"]>;
  memberCustomFieldEnabled: Scalars["Boolean"]["input"];
  memberCustomFieldName?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldPlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  paymentMethodCardEnabled: Scalars["Boolean"]["input"];
  suspended: Scalars["Boolean"]["input"];
};

export type CreateOrUpdateOrganizationYearlyContractInput = {
  amountRecord: Scalars["Float"]["input"];
  businessPlanId: Scalars["String"]["input"];
  continuationType?: InputMaybe<ContractContinuationType>;
  endMonth: Scalars["PlainYearMonth"]["input"];
  maxNightsPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  nightsPerMonth: Scalars["Int"]["input"];
  nightsPerYear: Scalars["Int"]["input"];
  startMonth: Scalars["PlainYearMonth"]["input"];
};

export type CreateOrUpdateOrganizationYearlyContractInvoiceInput = {
  /**
   * 年間払いか、月払いか
   * 新規作成時は必須
   */
  frequency?: InputMaybe<OrganizationYearlyContractInvoiceFrequency>;
  /**
   * 下書きとして作成するか、すぐにオープンな請求書として作成するか
   * オープンな請求書として作成すると、ユーザー側のダッシュボードにも表示される
   * 新規作成時は必須、更新時は無視される
   */
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * 請求金額（税込）
   * 新規作成時は必須
   */
  itemAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * 決済方法。銀行振込か、クレジットカード払いか
   * 新規作成時は必須
   */
  paymentMethodType?: InputMaybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  /**
   * 請求書を自動でオープンにする場合の日付。
   * 下書き状態の請求書についてのみ、設定可能。
   * nullを指定すると公開予定日をクリアする。
   */
  scheduledOpenDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 月払いの場合、いつの月分の請求書か */
  yearMonth?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
};

export type CreateOrUpdateStaffGroupInput = {
  archivedAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  smarthrId: Scalars["String"]["input"];
};

export type CreateOrUpdateUserAppInstallationError = {
  __typename: "CreateOrUpdateUserAppInstallationError";
  case: CreateOrUpdateUserAppInstallationErrorCase;
};

export const CreateOrUpdateUserAppInstallationErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type CreateOrUpdateUserAppInstallationErrorCase =
  (typeof CreateOrUpdateUserAppInstallationErrorCase)[keyof typeof CreateOrUpdateUserAppInstallationErrorCase];
export type CreateOrUpdateUserAppInstallationInput = {
  /** FCMトークン */
  fcmToken: Scalars["String"]["input"];
  /** インストールID */
  installationId: Scalars["ID"]["input"];
  /** プッシュ通知のプラットフォーム */
  platform: PushNotificationPlatform;
  /**
   * 登録時のアプリバージョン
   * デバッグ用の参考情報なのでオプショナル
   */
  registeredAppVersion?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 端末モデル
   * デバッグ用の参考情報なのでオプショナル
   */
  registeredDeviceModel?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 登録時のOSバージョン
   * デバッグ用の参考情報なのでオプショナル
   */
  registeredOsVersion?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOrUpdateUserAppInstallationPayload =
  | CreateOrUpdateUserAppInstallationError
  | Success;

export type CreateSanuOwnerPlanFileUploadPolicyInput = {
  type: SanuFileType;
};

export type CreateSanuOwnerPlanUserFileUploadPolicyInput = {
  ownerPlanId: Scalars["ID"]["input"];
  type: SanuOwnerPlanUserFileType;
  units: Scalars["Int"]["input"];
};

export type CreateStripeCardSetupIntentOfOrganizationPayload = {
  __typename: "CreateStripeCardSetupIntentOfOrganizationPayload";
  clientSecret: Scalars["String"]["output"];
};

export type CreateStripeCardSetupIntentOfViewerPayload = {
  __typename: "CreateStripeCardSetupIntentOfViewerPayload";
  clientSecret: Scalars["String"]["output"];
};

export type CreateUserFileUploadPolicyInput = {
  type: UserFileType;
};

export type CreateWebviewSessionError = {
  __typename: "CreateWebviewSessionError";
  case: CreateWebviewSessionErrorCase;
};

export const CreateWebviewSessionErrorCase = {
  /** 認証が必要 */
  Unauthorized: "Unauthorized",
} as const;

export type CreateWebviewSessionErrorCase =
  (typeof CreateWebviewSessionErrorCase)[keyof typeof CreateWebviewSessionErrorCase];
export type CreateWebviewSessionInput = {
  /** WebView内でセッション確立後にリダイレクトするパス（例: "/member"） */
  redirectTo: Scalars["String"]["input"];
};

export type CreateWebviewSessionPayload =
  | CreateWebviewSessionError
  | CreateWebviewSessionSuccess;

/** WebViewセッションURL生成成功 */
export type CreateWebviewSessionSuccess = {
  __typename: "CreateWebviewSessionSuccess";
  /** WebViewで開くべきURL（短期トークン付き） */
  url: Scalars["String"]["output"];
};

export const CronJobName = {
  ApplyGuestAccessKeys: "ApplyGuestAccessKeys",
  AutoTransitionCoOwnersHandover: "AutoTransitionCoOwnersHandover",
  CalculateAndOpenAccommodationFees: "CalculateAndOpenAccommodationFees",
  CancelExceededTentativeAccommodationReservations:
    "CancelExceededTentativeAccommodationReservations",
  CheckGuestAccessKeys: "CheckGuestAccessKeys",
  CheckOutExceededAccommodationReservations:
    "CheckOutExceededAccommodationReservations",
  CloseSupplyReports: "CloseSupplyReports",
  CreateCleaningTasks: "CreateCleaningTasks",
  CreateNextOrganizationYearlyContracts:
    "CreateNextOrganizationYearlyContracts",
  DetermineEarlyCheckInEligibility: "DetermineEarlyCheckInEligibility",
  FetchCoOwnersIdentityVerificationEvidence:
    "FetchCoOwnersIdentityVerificationEvidence",
  FetchModifiedBeds24Bookings: "FetchModifiedBeds24Bookings",
  GrantStaffStayCredits: "GrantStaffStayCredits",
  IssueInvoicesOfAccommodationFees: "IssueInvoicesOfAccommodationFees",
  JobsAt0300Jst: "JobsAt0300Jst",
  JobsAt1500Jst: "JobsAt1500Jst",
  OpenDraftInvoices: "OpenDraftInvoices",
  ReleaseExpiredAccessKeys: "ReleaseExpiredAccessKeys",
  RotateDailyStaffAccessKeys: "RotateDailyStaffAccessKeys",
  RotateMonthlyStaffAccessKeys: "RotateMonthlyStaffAccessKeys",
  ScheduledReleaseReservationBlocks: "ScheduledReleaseReservationBlocks",
  SendCheckInAndCheckOutTodayReminders: "SendCheckInAndCheckOutTodayReminders",
  SendCheckOutGuideMails: "SendCheckOutGuideMails",
  SendCleaningTasksDailyReminder: "SendCleaningTasksDailyReminder",
  SendCoOwnersIdentityVerificationReminderMails:
    "SendCoOwnersIdentityVerificationReminderMails",
  SendCoOwnersWebinarReminderMails: "SendCoOwnersWebinarReminderMails",
  SendFacilityReservationUsageEndReminders:
    "SendFacilityReservationUsageEndReminders",
  SendIchinomiyaNoticeMails: "SendIchinomiyaNoticeMails",
  SmartPlugStatusUpdate: "SmartPlugStatusUpdate",
  SyncBeds24FuturePrices: "SyncBeds24FuturePrices",
  SyncBubbleSupplyItemMasters: "SyncBubbleSupplyItemMasters",
  SyncCoOwnersIdentityVerifications: "SyncCoOwnersIdentityVerifications",
} as const;

export type CronJobName = (typeof CronJobName)[keyof typeof CronJobName];
/** 日次料金のターゲット */
export const DailyRateTarget = {
  /** OTA向け（Beds24同期用） */
  OnlineTravelAgent: "OnlineTravelAgent",
  /** 自社向け（内部価格計算用） */
  SanuInc: "SanuInc",
} as const;

export type DailyRateTarget =
  (typeof DailyRateTarget)[keyof typeof DailyRateTarget];
export type DeleteUserAppInstallationError = {
  __typename: "DeleteUserAppInstallationError";
  case: DeleteUserAppInstallationErrorCase;
};

export const DeleteUserAppInstallationErrorCase = {
  GeneralError: "GeneralError",
  NotFound: "NotFound",
} as const;

export type DeleteUserAppInstallationErrorCase =
  (typeof DeleteUserAppInstallationErrorCase)[keyof typeof DeleteUserAppInstallationErrorCase];
export type DeleteUserAppInstallationPayload =
  | DeleteUserAppInstallationError
  | Success;

export type DeleteViewerError = {
  __typename: "DeleteViewerError";
  case: DeleteViewerErrorCase;
};

export const DeleteViewerErrorCase = {
  Auth0UserNotDeleted: "Auth0UserNotDeleted",
  PendingAccommodationReservations: "PendingAccommodationReservations",
  PendingCoOwnersApplications: "PendingCoOwnersApplications",
  StripePaymentMethodNotDeleted: "StripePaymentMethodNotDeleted",
  UserDataNotDeleted: "UserDataNotDeleted",
  UserOrganizationAdmin: "UserOrganizationAdmin",
  UserOwnershipActive: "UserOwnershipActive",
  UserSubscriptionActive: "UserSubscriptionActive",
} as const;

export type DeleteViewerErrorCase =
  (typeof DeleteViewerErrorCase)[keyof typeof DeleteViewerErrorCase];
export type DeleteViewerPayload = DeleteViewerError | Success;

export const DisclosureAssistantType = {
  /** 担当 */
  PersonInCharge: "PersonInCharge",
  /** 代表 */
  Representative: "Representative",
} as const;

export type DisclosureAssistantType =
  (typeof DisclosureAssistantType)[keyof typeof DisclosureAssistantType];
export type DogfriendlyAccommodationFacility = {
  __typename: "DogfriendlyAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * ドラフト予約
 * 予約確定前の料金見積もりを含む予約
 * データベース上には保存されない
 */
export type DraftAccommodationReservation = {
  __typename: "DraftAccommodationReservation";
  accommodation: Accommodation;
  /** 滞在期間に重なる施設のお知らせ（AccommodationReservation.accommodationNotices と同じ重なり判定）。 */
  accommodationNotices: Array<AccommodationNotice>;
  /** 8泊目以降の追加料金（見込み） */
  additionalNights: Scalars["Int"]["output"];
  /** 部屋変更可否の選択をできるかどうか */
  canSelectAllowRoomChange: Scalars["Boolean"]["output"];
  /** この予約ドラフトに適用されるキャンセルポリシー（表示用）。 */
  cancellationPolicyContent?: Maybe<CancellationPolicyContent>;
  fee: AccommodationFee;
  /** 料金計算に際して利用されたオプション料金の請求有無の設定 */
  feeApplicability: AccommodationFeeApplicability;
  firstDate: Scalars["PlainDate"]["output"];
  firstNight: Scalars["PlainDate"]["output"];
  lastDate: Scalars["PlainDate"]["output"];
  lastNight: Scalars["PlainDate"]["output"];
  /** この滞在に適用される地方税ポリシー。空でなければ予約前の同意取得が必要。 */
  localTaxPolicies: Array<LocalTaxPolicy>;
  nights: Scalars["Int"]["output"];
  options: AccommodationReservationOptions;
  reservedFrom: Scalars["ZonedDateTime"]["output"];
  reservedTo: Scalars["ZonedDateTime"]["output"];
  /** 表示用の標準チェックイン時刻。 */
  standardCheckInTime: Scalars["ZonedDateTime"]["output"];
  stayTicketUnit?: Maybe<StayTicketUnit>;
};

export type DraftAccommodationReservationByStayTicketMasterInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  /** 人数情報。StayTicket master に AdditionalGuestFeePolicy が紐付いている場合のみ追加料金計算で参照される */
  guestCounts: GuestCountsInput;
  lastNight: Scalars["PlainDate"]["input"];
  options: DraftAccommodationReservationOptionsInput;
  /** 予約可能資産・期間・料金計算条件の解決元となる StayTicketMaster の参照。 */
  stayTicketMasterReference: StayTicketMasterReferenceInput;
};

/**
 * provider を経由せず StayTicketMaster から直接見積もった、非会員向けの宿泊料金プレビュー結果。
 * 発行済み StayTicketUnit の実在を前提にしたフィールド（キャンセルポリシー等）は持たない。
 */
export type DraftAccommodationReservationByStayTicketMasterResult = {
  __typename: "DraftAccommodationReservationByStayTicketMasterResult";
  fee: AccommodationFee;
};

export type DraftAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  /** 人数情報。StayTicket master に AdditionalGuestFeePolicy が紐付いている場合のみ追加料金計算で参照される */
  guestCounts: GuestCountsInput;
  /**
   * 変更予約の元 ID。指定すると SanuInc/OTA は元 fee 保持、
   * StandardPlan/StayTicket + internalPreserveDynamicPricing=true では DP 保持。
   */
  internalOriginalReservationId?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * true の場合、変更前 fee にあった動的料金 item の amount を維持する。
   * internalOriginalReservationId と組み合わせて使う。
   * 対象: StandardPlan の calculated_dynamic_pricing_fee、StayTicket の calculated_base_fee。
   * 拠点変更時は無効化。
   */
  internalPreserveDynamicPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight: Scalars["PlainDate"]["input"];
  options: DraftAccommodationReservationOptionsInput;
  /**
   * 予約変更フォームで元予約の ID。指定時は 2 つの効果がある:
   * 1. additionalNights 計算から当該予約の泊数を除外する (重複カウント防止)。
   * 2. 同じ accommodation への変更の場合、元予約の動的料金 amount を見積もりに引き継ぐ
   *    (`changeAccommodationReservation` の挙動と一致させる)。
   * 他ユーザーの ID を指定した場合は無視される (所有権チェックあり)。
   */
  originalReservationIdToExcludeForAdditionalNights?: InputMaybe<
    Scalars["ID"]["input"]
  >;
  provider: AccommodationReservationProviderInput;
};

export type DraftAccommodationReservationOptionsInput = {
  bringDog: Scalars["Boolean"]["input"];
  numberOfDogs: Scalars["Int"]["input"];
  useEvCharger: Scalars["Boolean"]["input"];
};

export type EvChargerAccommodationFacility = {
  __typename: "EVChargerAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** アーリーチェックインの料金テーブルのスロット */
export type EarlyCheckInPriceSlot = {
  __typename: "EarlyCheckInPriceSlot";
  /** 終了時刻（時） */
  endHour: Scalars["Int"]["output"];
  /** このスロットのID */
  id: Scalars["ID"]["output"];
  /** 表示用ラベル */
  label: Scalars["String"]["output"];
  /** 料金（税込） */
  price: Scalars["Int"]["output"];
  /** 開始時刻（時） */
  startHour: Scalars["Int"]["output"];
};

/** ECI 表示状態 */
export const EarlyCheckInStatus = {
  /** 案内ラベル + チェックイン実行可能（現在 ECI 料金時間帯内） */
  Available: "Available",
  /** ECI 案内も表示しない（対象外 / チェックイン後 / standardCheckInTime 以降 等） */
  Hidden: "Hidden",
  /** ECI 案内ラベル表示のみ（チェックイン実行は不可、現在 ECI 料金時間帯外） */
  Visible: "Visible",
} as const;

export type EarlyCheckInStatus =
  (typeof EarlyCheckInStatus)[keyof typeof EarlyCheckInStatus];
export type EstimateStandardSubscriptionApplicationError = {
  __typename: "EstimateStandardSubscriptionApplicationError";
  case: EstimateStandardSubscriptionApplicationErrorCase;
};

export const EstimateStandardSubscriptionApplicationErrorCase = {
  /** 割引コードに対応する商品をすでに購入したことがあるため使えない */
  HasPriorTransaction: "HasPriorTransaction",
  /**
   * 割引コードが無効
   * 割引コードが存在しない、存在するが有効期限切れなど
   */
  InvalidPromotionCode: "InvalidPromotionCode",
} as const;

export type EstimateStandardSubscriptionApplicationErrorCase =
  (typeof EstimateStandardSubscriptionApplicationErrorCase)[keyof typeof EstimateStandardSubscriptionApplicationErrorCase];
export type EstimateStandardSubscriptionApplicationFeePayload =
  | EstimateStandardSubscriptionApplicationError
  | EstimateStandardSubscriptionApplicationSuccess;

export type EstimateStandardSubscriptionApplicationSuccess = {
  __typename: "EstimateStandardSubscriptionApplicationSuccess";
  /** 割引適用後の金額 */
  amount: Scalars["Int"]["output"];
};

export type EstimatedCancelFeeOfAccommodationReservationError = {
  __typename: "EstimatedCancelFeeOfAccommodationReservationError";
  case: EstimatedCancelFeeOfAccommodationReservationErrorCase;
};

export const EstimatedCancelFeeOfAccommodationReservationErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type EstimatedCancelFeeOfAccommodationReservationErrorCase =
  (typeof EstimatedCancelFeeOfAccommodationReservationErrorCase)[keyof typeof EstimatedCancelFeeOfAccommodationReservationErrorCase];
export type EstimatedCancelFeeOfAccommodationReservationPayload =
  | EstimatedCancelFeeOfAccommodationReservationError
  | EstimatedChargeOfAccommodationReservation;

export type EstimatedChangeFeeOfAccommodationReservationError = {
  __typename: "EstimatedChangeFeeOfAccommodationReservationError";
  case: EstimatedChangeFeeOfAccommodationReservationErrorCase;
};

export const EstimatedChangeFeeOfAccommodationReservationErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type EstimatedChangeFeeOfAccommodationReservationErrorCase =
  (typeof EstimatedChangeFeeOfAccommodationReservationErrorCase)[keyof typeof EstimatedChangeFeeOfAccommodationReservationErrorCase];
export type EstimatedChangeFeeOfAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  /** 人数情報。StayTicket master に AdditionalGuestFeePolicy が紐付いている場合のみ追加料金計算で参照される */
  guestCounts: GuestCountsInput;
  lastNight: Scalars["PlainDate"]["input"];
  options: DraftAccommodationReservationOptionsInput;
};

export type EstimatedChangeFeeOfAccommodationReservationPayload =
  | EstimatedChangeFeeOfAccommodationReservationError
  | EstimatedChargeOfAccommodationReservation;

export type EstimatedChargeOfAccommodationReservation = {
  __typename: "EstimatedChargeOfAccommodationReservation";
  items: Array<EstimatedChargeOfAccommodationReservationItem>;
  totalAmountOfFee: Scalars["Int"]["output"];
};

export type EstimatedChargeOfAccommodationReservationItem = {
  __typename: "EstimatedChargeOfAccommodationReservationItem";
  amountOfFee?: Maybe<Scalars["Int"]["output"]>;
  chargeType: EstimatedChargeOfAccommodationReservationItemType;
  label: Scalars["String"]["output"];
  night: Scalars["PlainDate"]["output"];
};

export const EstimatedChargeOfAccommodationReservationItemType = {
  Fee: "Fee",
  OwnerStayCredit: "OwnerStayCredit",
  StaffStayCredit: "StaffStayCredit",
  TrialStayCredit: "TrialStayCredit",
} as const;

export type EstimatedChargeOfAccommodationReservationItemType =
  (typeof EstimatedChargeOfAccommodationReservationItemType)[keyof typeof EstimatedChargeOfAccommodationReservationItemType];
/** 付帯サービスEV充電器向けロックのコントローラ属性情報 */
export type EvChargerLock = {
  __typename: "EvChargerLock";
  controllerId?: Maybe<Scalars["String"]["output"]>;
  expireAt: Scalars["ZonedDateTime"]["output"];
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Stay Gift from Ownersのエクスポート結果 */
export type ExportStayGiftsPayload = {
  __typename: "ExportStayGiftsPayload";
  tickets: Array<StayGiftExportItem>;
};

/** 付帯サービス */
export type Facility = {
  __typename: "Facility";
  /** 料金ポリシー一覧 */
  baseFeePolicies: Array<FacilityBaseFeePolicy>;
  /** キャンセル締切の何日前（0=当日, 1=前日） */
  cancelDeadlineDaysBefore: Scalars["Int"]["output"];
  /** キャンセル締切時刻 */
  cancelDeadlineHour: Scalars["Int"]["output"];
  /** キャンセル料ポリシー一覧 */
  cancelFeePolicies: Array<FacilityCancelFeePolicy>;
  /** キャンセル料ルールURL（nullの場合はリンク非表示） */
  cancelRuleUrl?: Maybe<Scalars["String"]["output"]>;
  /** 設備詳細（Markdown） */
  contentDetail?: Maybe<Scalars["String"]["output"]>;
  /** 予約時の案内（Markdown） */
  contentGuide?: Maybe<Scalars["String"]["output"]>;
  /** コンテンツ用画像一覧（Markdown内で参照する画像） */
  contentImages: Array<UploadedFile>;
  /** 注意事項（Markdown） */
  contentNotice?: Maybe<Scalars["String"]["output"]>;
  /** 利用について（Markdown） */
  contentUsage?: Maybe<Scalars["String"]["output"]>;
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** カスタムフィールド定義（到着時刻などの動的フォーム項目） */
  customFields?: Maybe<Array<FacilityCustomFieldItem>>;
  /** 説明文 */
  description: Scalars["String"]["output"];
  /** 詳細リンクURL（nullの場合はリンク非表示） */
  detailUrl?: Maybe<Scalars["String"]["output"]>;
  /** 適用される割引一覧（予約フォーム表示用） */
  discountFeePolicies: Array<FacilityDiscountFeePolicy>;
  id: Scalars["ID"]["output"];
  /** 画像 */
  image: UploadedFile;
  /** 清掃レポート機能が有効か（将来別システム移行予定） */
  isCleaningReportEnabled: Scalars["Boolean"]["output"];
  /** データ連携管理機能が有効か */
  isDataSyncEnabled: Scalars["Boolean"]["output"];
  /** いずれかのスロットが予約可能か（バッジ表示用） */
  isReservable: Scalars["Boolean"]["output"];
  /** 予約機能が有効か（false は予約不要・無料で自由に利用できる） */
  isReserveEnabled: Scalars["Boolean"]["output"];
  /** この宿泊予約で予約済みか（AccommodationReservation.facilities 経由の場合のみ有効） */
  isReserved: Scalars["Boolean"]["output"];
  /** 予約締切時刻内か（カード有効化用。枠の有無に関わらず、締め切り前のスロットが存在するか） */
  isUsable: Scalars["Boolean"]["output"];
  /** 拠点/部屋タイプの公開ページと予約カレンダーへの掲載が有効か（滞在中の予約画面のカードには影響しない） */
  isVisibleEnabled: Scalars["Boolean"]["output"];
  /** 短縮表示名（ボタン/カード用） */
  label: Scalars["String"]["output"];
  /** 正式名称 */
  name: Scalars["String"]["output"];
  /** 予約締切の何日前（0=当日, 1=前日, 7=1週間前） */
  reserveDeadlineDaysBefore: Scalars["Int"]["output"];
  /** 予約締切時刻 */
  reserveDeadlineHour: Scalars["Int"]["output"];
  /** リソース一覧 */
  resources: Array<FacilityResource>;
  /** 利用可能な全サイト一覧 */
  sites: Array<Site>;
  /** スロット定義一覧（unitType=Slot の場合のみ） */
  slots: Array<FacilitySlot>;
  /** 公開ステータス（既存予約の表示・キャンセルには影響しない） */
  status: FacilityStatusType;
  /** 規約リンクのラベル（例: "レンタカー利用規約"） */
  termsLabel?: Maybe<Scalars["String"]["output"]>;
  /** 利用規約URL（nullの場合は規約チェックボックス非表示） */
  termsUrl?: Maybe<Scalars["String"]["output"]>;
  /** 付帯サービス種別 */
  type: FacilityType;
  /** 単位種別 */
  unitType: FacilityUnitType;
};

/** 付帯サービス料金ポリシー */
export type FacilityBaseFeePolicy = {
  __typename: "FacilityBaseFeePolicy";
  id: Scalars["ID"]["output"];
  /** 対象リソース */
  resource?: Maybe<FacilityResource>;
  /** 対象単位数。unit:1がデフォルト単価 */
  unit: Scalars["Int"]["output"];
  /** 1単位あたりの料金 */
  unitFeeAmount: Scalars["Decimal"]["output"];
};

/** 付帯サービスキャンセルポリシー */
export type FacilityCancelFeePolicy = {
  __typename: "FacilityCancelFeePolicy";
  /** 適用開始日（開始日の何日前） */
  deadlineDaysBefore: Scalars["Int"]["output"];
  /** 適用開始時刻 */
  deadlineHour: Scalars["Int"]["output"];
  /** キャンセル料タイプ */
  feeModifierType: FeeModifierType;
  /** キャンセル料値（Percentage: 料率%, Value: 固定額） */
  feeValue: Scalars["Decimal"]["output"];
  id: Scalars["ID"]["output"];
  /** 対象リソース */
  resource?: Maybe<FacilityResource>;
};

/** 付帯サービスコントローラー */
export type FacilityController = {
  __typename: "FacilityController";
  attribute?: Maybe<FacilityControllerAttribute>;
  controllerAttribute?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  type: FacilityResourceControllerType;
};

/** 付帯サービス予約のコントローラ属性情報 */
export type FacilityControllerAttribute =
  | CoWorkingSpaceDoorLock
  | EvChargerLock
  | OnsenAndSaunaDoorLock
  | RentalCycleKeyBox
  | WashingMachineTracker;

/** 付帯サービスカスタムフィールド定義 */
export type FacilityCustomFieldItem = {
  __typename: "FacilityCustomFieldItem";
  caption?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  options?: Maybe<Array<Scalars["String"]["output"]>>;
  placeholder?: Maybe<Scalars["String"]["output"]>;
  required: Scalars["Boolean"]["output"];
  type: FacilityFieldType;
};

/** 付帯サービスカスタムフィールド定義の入力 */
export type FacilityCustomFieldItemInput = {
  /** 補足テキスト（フォームのヘルプテキスト） */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /** フィールドキー（一意） */
  key: Scalars["String"]["input"];
  /** フィールドラベル（表示名） */
  label: Scalars["String"]["input"];
  /** 選択肢（type=SingleSelectの場合のみ） */
  options?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** プレースホルダー */
  placeholder?: InputMaybe<Scalars["String"]["input"]>;
  /** 必須フラグ */
  required: Scalars["Boolean"]["input"];
  /** フィールドタイプ */
  type: FacilityFieldType;
};

/** 付帯サービスカスタムフィールド値 */
export type FacilityCustomFieldValue = {
  __typename: "FacilityCustomFieldValue";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** 付帯サービスカスタムフィールド値入力 */
export type FacilityCustomFieldValueInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** 付帯サービス予約に適用される割引情報（予約確定前の表示用） */
export type FacilityDiscountFeePolicy = {
  __typename: "FacilityDiscountFeePolicy";
  /** 割引タイプ（Value: 固定金額, Percentage: 割引率） */
  discountModifierType: FeeModifierType;
  /** 割引値（Percentageの場合は割引率%, Valueの場合は固定割引額・円） */
  discountValue: Scalars["Int"]["output"];
  /** 割引ラベル（例: "奄美大島1sお試し無料宿泊チケット"） */
  label: Scalars["String"]["output"];
};

/** 付帯サービスの利用料金 */
export type FacilityFee = {
  __typename: "FacilityFee";
  /** 料金の項目 */
  items: Array<FacilityFeeItem>;
  /** 料金の合計 */
  totalAmount: Scalars["Int"]["output"];
};

/** 付帯サービスの利用料金の項目 */
export type FacilityFeeItem = {
  __typename: "FacilityFeeItem";
  /** 税込金額 */
  amount: Scalars["Int"]["output"];
  /** 項目名 */
  label: Scalars["String"]["output"];
  /** 消費税率 */
  taxRate: Scalars["Float"]["output"];
};

/** 付帯サービスフィールドタイプ */
export const FacilityFieldType = {
  SingleSelect: "SingleSelect",
  Text: "Text",
} as const;

export type FacilityFieldType =
  (typeof FacilityFieldType)[keyof typeof FacilityFieldType];
/** 請求明細ラベルのパーツ */
export type FacilityInvoiceLabelPart = {
  __typename: "FacilityInvoiceLabelPart";
  /** 予約期間の表記。type が ReservePeriod の時のみ値を持つ */
  format?: Maybe<FacilityInvoiceLabelPeriodFormat>;
  type: FacilityInvoiceLabelPartType;
  /** 固定文言。type が Text の時のみ値を持つ */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** 請求明細ラベルのパーツ入力 */
export type FacilityInvoiceLabelPartInput = {
  /** 予約期間の表記。type が ReservePeriod の時は必須 */
  format?: InputMaybe<FacilityInvoiceLabelPeriodFormat>;
  type: FacilityInvoiceLabelPartType;
  /** 固定文言。type が Text の時は必須 */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** 請求明細ラベルのパーツ種別 */
export const FacilityInvoiceLabelPartType = {
  /** 予約期間 */
  ReservePeriod: "ReservePeriod",
  /** 固定文言 */
  Text: "Text",
} as const;

export type FacilityInvoiceLabelPartType =
  (typeof FacilityInvoiceLabelPartType)[keyof typeof FacilityInvoiceLabelPartType];
/** 予約期間パーツの表記 */
export const FacilityInvoiceLabelPeriodFormat = {
  /** 日付のみ（例: 2026/9/6〜9/9） */
  Date: "Date",
  /** 日付と時刻（例: 2026/9/6 10:00〜9/9 10:00） */
  DateTime: "DateTime",
} as const;

export type FacilityInvoiceLabelPeriodFormat =
  (typeof FacilityInvoiceLabelPeriodFormat)[keyof typeof FacilityInvoiceLabelPeriodFormat];
/** 付帯サービス予約 */
export type FacilityReservation = {
  __typename: "FacilityReservation";
  /** 関連する宿泊予約 */
  accommodationReservation: AccommodationReservation;
  /** キャンセル日時 */
  canceledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 請求額（totalFeeAmount - discountAmount） */
  chargedFeeAmount: Scalars["Decimal"]["output"];
  /** 清掃レポート（設備で isCleaningReportEnabled=true の場合のみ値が入る） */
  cleaningReport?: Maybe<FacilityReservationCleaningReport>;
  /** コントローラ一覧 */
  controllers: Array<FacilityController>;
  /** 予約作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** カスタムフィールド値（Facility.customFieldsで定義されたフィールドへの入力値） */
  customFieldValues: Array<FacilityCustomFieldValue>;
  /** データ連携情報（設備で isDataSyncEnabled=true の場合のみ値が入る） */
  dataSync?: Maybe<FacilityReservationDataSync>;
  /** 割引額 */
  discountAmount: Scalars["Decimal"]["output"];
  /** 割引理由 */
  discountReason?: Maybe<Scalars["String"]["output"]>;
  /** 終了日時 */
  endAt: Scalars["PlainDateTime"]["output"];
  /** 現時点でのキャンセル料（ステータスがReserved以外の場合は0） */
  estimatedCancelFee: Scalars["Int"]["output"];
  /**
   * 清掃で照合するための宿泊者名（AccommodationReservation.guestName と同じ）。付帯サービスは複数拠点に
   * 属しうるので、拠点スコープの主体が他拠点の宿泊予約を経由せずに読めるようにする。
   */
  guestName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** キャンセル可能か（ステータスがReservedかつ予約締切内） */
  isCancelable: Scalars["Boolean"]["output"];
  /** リソース */
  resource: FacilityResource;
  /** リソース表示名（「サイト名 リソース名」形式） */
  resourceLabel: Scalars["String"]["output"];
  /** 開始日時 */
  startAt: Scalars["PlainDateTime"]["output"];
  /** 予約ステータス */
  status: FacilityReservationStatusType;
  /** 利用規約同意日時 */
  termsAgreedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 定価（unitFeeAmount × units） */
  totalFeeAmount: Scalars["Decimal"]["output"];
  /** 1単位あたりの料金（スナップショット） */
  unitFeeAmount: Scalars["Decimal"]["output"];
  /** 予約時点の単位種別 */
  unitType: FacilityUnitType;
  /** 単位数（泊数/時間数/スロット数） */
  units: Scalars["Int"]["output"];
  /** 予約したユーザー */
  user: User;
};

/** 付帯サービス清掃レポートレコード（付帯サービス予約に紐づく清掃状態を管理。将来別システム移行予定） */
export type FacilityReservationCleaningReport = {
  __typename: "FacilityReservationCleaningReport";
  status: FacilityReservationCleaningStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 付帯サービス清掃レポートステータス */
export const FacilityReservationCleaningStatus = {
  Completed: "Completed",
  Pending: "Pending",
} as const;

export type FacilityReservationCleaningStatus =
  (typeof FacilityReservationCleaningStatus)[keyof typeof FacilityReservationCleaningStatus];
/** 付帯サービスデータ連携レコード（付帯サービス予約に紐づくデータ連携状態を管理） */
export type FacilityReservationDataSync = {
  __typename: "FacilityReservationDataSync";
  status: FacilityReservationDataSyncStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 付帯サービスデータ連携ステータス */
export const FacilityReservationDataSyncStatus = {
  Pending: "Pending",
  Synced: "Synced",
} as const;

export type FacilityReservationDataSyncStatus =
  (typeof FacilityReservationDataSyncStatus)[keyof typeof FacilityReservationDataSyncStatus];
/** 付帯サービス予約ステータス */
export const FacilityReservationStatusType = {
  Canceled: "Canceled",
  Reserved: "Reserved",
} as const;

export type FacilityReservationStatusType =
  (typeof FacilityReservationStatusType)[keyof typeof FacilityReservationStatusType];
/** 付帯サービスリソース */
export type FacilityResource = {
  __typename: "FacilityResource";
  /** このリソースの料金ポリシー一覧 */
  baseFeePolicies: Array<FacilityBaseFeePolicy>;
  /** コントローラ一覧 */
  controllers: Array<FacilityController>;
  /** 請求明細ラベルのパーツ。null なら明細名は「施設名（リソース名）」になる */
  customInvoiceLabel?: Maybe<Array<FacilityInvoiceLabelPart>>;
  /** 付帯サービス */
  facility: Facility;
  id: Scalars["ID"]["output"];
  /** 識別子（ナンバー、施設番号等） */
  identifier: Scalars["String"]["output"];
  /** このリソースで予約可能な開始スロットが1つ以上あるか */
  isReservable: Scalars["Boolean"]["output"];
  /** リソース名 */
  name: Scalars["String"]["output"];
  /** リソースのコントローラ一覧 */
  resourceControllers: Array<InternalFacilityController>;
  /** このリソースのスロット一覧 */
  slotAvailabilities: Array<FacilitySlotAvailability>;
};

/** 付帯サービスリソース */
export type FacilityResourceControllersArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
};

/** 付帯サービスリソース */
export type FacilityResourceIsReservableArgs = {
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 付帯サービスリソース */
export type FacilityResourceSlotAvailabilitiesArgs = {
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 付帯サービスリソースブロック */
export type FacilityResourceBlock = {
  __typename: "FacilityResourceBlock";
  /** ブロック終了日時 */
  endAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** 理由（Admin時のみ） */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** リソース */
  resource: FacilityResource;
  /** ブロック種別 */
  resourceBlockType: FacilityResourceBlockType;
  /** ブロック開始日時 */
  startAt: Scalars["DateTime"]["output"];
};

/** 付帯サービスリソースブロック種別 */
export const FacilityResourceBlockType = {
  Admin: "Admin",
  User: "User",
} as const;

export type FacilityResourceBlockType =
  (typeof FacilityResourceBlockType)[keyof typeof FacilityResourceBlockType];
/** 付帯サービスコントローラー種別 */
export const FacilityResourceControllerType = {
  CoWorkingSpaceDoorLock: "CoWorkingSpaceDoorLock",
  EvChargerLock: "EvChargerLock",
  OnsenAndSaunaDoorLock: "OnsenAndSaunaDoorLock",
  RentalCycleKeyBox: "RentalCycleKeyBox",
  WashingMachineTracker: "WashingMachineTracker",
} as const;

export type FacilityResourceControllerType =
  (typeof FacilityResourceControllerType)[keyof typeof FacilityResourceControllerType];
/** 付帯サービススロット */
export type FacilitySlot = {
  __typename: "FacilitySlot";
  /** 終了時刻（時） */
  endHour: Scalars["Int"]["output"];
  /** 終了時刻（分） */
  endMinute: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  /** このスロットが適用されるリソース */
  resource?: Maybe<FacilityResource>;
  /** 開始時刻（時） */
  startHour: Scalars["Int"]["output"];
  /** 開始時刻（分） */
  startMinute: Scalars["Int"]["output"];
};

/** 付帯サービススロット予約可否（予約不可のものも含む、レンジ内全件） */
export type FacilitySlotAvailability = {
  __typename: "FacilitySlotAvailability";
  /** 所属日（全 unitType 共通。Night / Reservation は貸出候補日、Slot は枠の属する日） */
  date: Scalars["PlainDate"]["output"];
  /** 予約可能かどうか */
  isReservable: Scalars["Boolean"]["output"];
  /** 表示用ラベル（例: "01/15(水)"、"10:00"） */
  label: Scalars["String"]["output"];
  /** スロットID（unitType=Slot のみ。Night / Reservation は null） */
  slotId?: Maybe<Scalars["ID"]["output"]>;
  /** 予約不可の理由（isReservable: false の場合のみ） */
  unavailableReason?: Maybe<FacilitySlotUnavailableReason>;
};

/** 付帯サービススロットが予約不可の理由 */
export const FacilitySlotUnavailableReason = {
  AlreadyReserved: "AlreadyReserved",
  Blocked: "Blocked",
  DeadlinePassed: "DeadlinePassed",
  OutsideOperatingHours: "OutsideOperatingHours",
  Past: "Past",
} as const;

export type FacilitySlotUnavailableReason =
  (typeof FacilitySlotUnavailableReason)[keyof typeof FacilitySlotUnavailableReason];
/** 付帯サービス公開ステータス */
export const FacilityStatusType = {
  Draft: "Draft",
  Preview: "Preview",
  Published: "Published",
} as const;

export type FacilityStatusType =
  (typeof FacilityStatusType)[keyof typeof FacilityStatusType];
/** 付帯サービス種別 */
export const FacilityType = {
  Barbecue: "Barbecue",
  CoWorkingSpace: "CoWorkingSpace",
  EvCharger: "EvCharger",
  OnsenAndSauna: "OnsenAndSauna",
  RentalCar: "RentalCar",
  RentalCycle: "RentalCycle",
  WashingMachine: "WashingMachine",
} as const;

export type FacilityType = (typeof FacilityType)[keyof typeof FacilityType];
/** 付帯サービス予約単位種別 */
export const FacilityUnitType = {
  Night: "Night",
  Reservation: "Reservation",
  Slot: "Slot",
} as const;

export type FacilityUnitType =
  (typeof FacilityUnitType)[keyof typeof FacilityUnitType];
/** 料金修正タイプ */
export const FeeModifierType = {
  /** パーセンテージ */
  Percentage: "Percentage",
  /** 固定金額 */
  Value: "Value",
} as const;

export type FeeModifierType =
  (typeof FeeModifierType)[keyof typeof FeeModifierType];
export const FieldTierPermission = {
  AccommodationsKeysRead: "AccommodationsKeysRead",
  /** 利用ブロックの名前とメモ。社員名・取引先名・社内のメモが入りうるので、外部パートナーには伏せる（期間と分類は見える）。 */
  AvailabilityBlocksCommercialRead: "AvailabilityBlocksCommercialRead",
  CoOwnersRestrictedRead: "CoOwnersRestrictedRead",
  ReservationsKeysRead: "ReservationsKeysRead",
  StayTicketsPiiRead: "StayTicketsPiiRead",
  UsersCommercialRead: "UsersCommercialRead",
  UsersPiiRead: "UsersPiiRead",
  UsersRestrictedRead: "UsersRestrictedRead",
} as const;

export type FieldTierPermission =
  (typeof FieldTierPermission)[keyof typeof FieldTierPermission];
export const FileCopyTarget = {
  ArchitectureType: "architectureType",
  Area: "area",
  Banner: "banner",
  OwnerApplication: "ownerApplication",
  OwnerPlan: "ownerPlan",
  UserPicture: "userPicture",
} as const;

export type FileCopyTarget =
  (typeof FileCopyTarget)[keyof typeof FileCopyTarget];
export type FileUploadPolicyPayload =
  | CreateFileUploadPolicyError
  | CreateFileUploadPolicySuccess;

/** アカウント連携完了エラー */
export type FinalizeAccountLinkError = {
  __typename: "FinalizeAccountLinkError";
  case: FinalizeAccountLinkErrorCase;
};

/** アカウント連携完了エラーケース */
export const FinalizeAccountLinkErrorCase = {
  /** 再認証したユーザーが期待するIDと一致しない */
  IdentityMismatch: "IdentityMismatch",
  /** intent tokenが無効または期限切れ */
  InvalidIntentToken: "InvalidIntentToken",
  /** Auth0とのトークン交換に失敗 */
  TokenExchangeFailed: "TokenExchangeFailed",
} as const;

export type FinalizeAccountLinkErrorCase =
  (typeof FinalizeAccountLinkErrorCase)[keyof typeof FinalizeAccountLinkErrorCase];
/** アカウント連携の完了に必要な入力 */
export type FinalizeAccountLinkInput = {
  /** Auth0から返されたauthorization code */
  code: Scalars["String"]["input"];
  /** ラウンドトリップ用のstate (intent token) */
  state: Scalars["String"]["input"];
};

/** アカウント連携完了結果 */
export type FinalizeAccountLinkPayload =
  | FinalizeAccountLinkError
  | FinalizeAccountLinkSuccess;

/** アカウント連携完了成功 */
export type FinalizeAccountLinkSuccess = {
  __typename: "FinalizeAccountLinkSuccess";
  /** Auth0の /continue エンドポイントへのリダイレクトURL（link_token付き） */
  continueUrl: Scalars["String"]["output"];
};

export const FinancialAssetsBracketType = {
  Above300Mil: "Above300Mil",
  Below5Mil: "Below5Mil",
  DoNotKnowWillNotSay: "DoNotKnowWillNotSay",
  From5MilTo10Mil: "From5MilTo10Mil",
  From10MilTo30Mil: "From10MilTo30Mil",
  From30MilTo50Mil: "From30MilTo50Mil",
  From50MilTo100Mil: "From50MilTo100Mil",
  From100MilTo300Mil: "From100MilTo300Mil",
} as const;

export type FinancialAssetsBracketType =
  (typeof FinancialAssetsBracketType)[keyof typeof FinancialAssetsBracketType];
export type FullOwnerPlanAccommodationReservationProvider = {
  __typename: "FullOwnerPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  userOwnershipId: Scalars["ID"]["output"];
};

export const GenderType = {
  Female: "Female",
  Male: "Male",
  NoAnswer: "NoAnswer",
} as const;

export type GenderType = (typeof GenderType)[keyof typeof GenderType];
export type GenerateCheckInQrCodeError = {
  __typename: "GenerateCheckInQrCodeError";
  case: GenerateCheckInQrCodeErrorCase;
};

export const GenerateCheckInQrCodeErrorCase = {
  /** このサイトはQR認証を必要としない */
  QrCodeNotRequired: "QrCodeNotRequired",
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
  /** 予約の所有者でない */
  Unauthorized: "Unauthorized",
} as const;

export type GenerateCheckInQrCodeErrorCase =
  (typeof GenerateCheckInQrCodeErrorCase)[keyof typeof GenerateCheckInQrCodeErrorCase];
export type GenerateCheckInQrCodeInput = {
  /** 対象の予約ID */
  accommodationReservationId: Scalars["ID"]["input"];
};

export type GenerateCheckInQrCodePayload =
  | GenerateCheckInQrCodeError
  | GenerateCheckInQrCodeSuccess;

export type GenerateCheckInQrCodeSuccess = {
  __typename: "GenerateCheckInQrCodeSuccess";
  /** 生成されたQRコード */
  checkInQrCode: CheckInQrCode;
};

/** 位置情報 */
export type GeoLocation = {
  __typename: "GeoLocation";
  latitude: Scalars["Float"]["output"];
  longitude: Scalars["Float"]["output"];
};

export type GeoLocationInput = {
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

/** お客様向けキー適用のトリガー種別。 */
export const GuestAccessKeyTrigger = {
  CancelReserve: "CancelReserve",
  ChangeReserve: "ChangeReserve",
  CreateReserve: "CreateReserve",
} as const;

export type GuestAccessKeyTrigger =
  (typeof GuestAccessKeyTrigger)[keyof typeof GuestAccessKeyTrigger];
/** 予約時に料金計算へ流す人数情報 */
export type GuestCountsInput = {
  /** 大人の人数 */
  numberOfAdults: Scalars["Int"]["input"];
  /** 乳幼児（0〜5歳）の人数 */
  numberOfInfants: Scalars["Int"]["input"];
  /** 子供（6〜12歳）の人数 */
  numberOfKids: Scalars["Int"]["input"];
};

/** ハイシーズン期間 */
export type HighSeasonPeriod = {
  __typename: "HighSeasonPeriod";
  /** 終了日 */
  endDay: Scalars["Int"]["output"];
  /** 終了月 */
  endMonth: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  /** 有効かどうか */
  isActive: Scalars["Boolean"]["output"];
  /** 表示用ラベル（"年末年始 2026" など） */
  label: Scalars["String"]["output"];
  /** 開始日 */
  startDay: Scalars["Int"]["output"];
  /** 開始月 */
  startMonth: Scalars["Int"]["output"];
  /** ハイシーズン種別 */
  type: HighSeasonType;
  /** 適用年（nullの場合は毎年適用） */
  year?: Maybe<Scalars["Int"]["output"]>;
};

/** ハイシーズン種別 */
export const HighSeasonType = {
  /** ゴールデンウィーク */
  GoldenWeek: "GoldenWeek",
  /** 年末年始 */
  NewYear: "NewYear",
  /** お盆 */
  Obon: "Obon",
  /** シルバーウィーク */
  SilverWeek: "SilverWeek",
} as const;

export type HighSeasonType =
  (typeof HighSeasonType)[keyof typeof HighSeasonType];
export type HubSpotSyncContactError = {
  __typename: "HubSpotSyncContactError";
  case: HubSpotSyncContactErrorCase;
};

export const HubSpotSyncContactErrorCase = {
  UserNotFound: "UserNotFound",
} as const;

export type HubSpotSyncContactErrorCase =
  (typeof HubSpotSyncContactErrorCase)[keyof typeof HubSpotSyncContactErrorCase];
export type HubSpotSyncContactResult = HubSpotSyncContactError | Success;

export type HubSpotSyncDealError = {
  __typename: "HubSpotSyncDealError";
  case: HubSpotSyncDealErrorCase;
};

export const HubSpotSyncDealErrorCase = {
  ApplicationNotFound: "ApplicationNotFound",
  DealNotFound: "DealNotFound",
} as const;

export type HubSpotSyncDealErrorCase =
  (typeof HubSpotSyncDealErrorCase)[keyof typeof HubSpotSyncDealErrorCase];
export type HubSpotSyncDealResult = HubSpotSyncDealError | Success;

export const IdentificationDocumentType = {
  BasicResidentRegisterCard: "BasicResidentRegisterCard",
  DriverLicense: "DriverLicense",
  MyNumberCard: "MyNumberCard",
  Passport: "Passport",
  ResidenceCard: "ResidenceCard",
  Undetermined: "Undetermined",
} as const;

export type IdentificationDocumentType =
  (typeof IdentificationDocumentType)[keyof typeof IdentificationDocumentType];
/** アイデンティティプロバイダー */
export const IdentityProvider = {
  /** Apple ID */
  Apple: "Apple",
  /** メールアドレス＋パスワード */
  EmailPassword: "EmailPassword",
  /** Googleアカウント */
  Google: "Google",
} as const;

export type IdentityProvider =
  (typeof IdentityProvider)[keyof typeof IdentityProvider];
/**
 * 本人確認情報
 * Co-Owners は申込、Full-Owner はオーナープランのどちらか一方に紐づく
 */
export type IdentityVerification = {
  __typename: "IdentityVerification";
  id: Scalars["ID"]["output"];
  method: IdentityVerificationMethod;
  note: Scalars["String"]["output"];
  /** Full-Owner 契約の本人確認の場合、対象のオーナープラン */
  ownerPlan?: Maybe<OwnerPlan>;
  result?: Maybe<IdentityVerificationResult>;
  status: IdentityVerificationStatus;
  /** 書類提出専用 WEB ページ URL */
  submissionPageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 書類提出専用 WEB ページ URL の有効期限 */
  submissionPageUrlExpiresAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** TRUSTDOCK オペレーション画面の詳細ページ URL */
  trustdockOperationPageUrl?: Maybe<Scalars["String"]["output"]>;
  /** TRUSTDOCK 側で発行される身元確認 ID */
  trustdockVerificationId?: Maybe<Scalars["String"]["output"]>;
};

/** 本人確認の方法 */
export const IdentityVerificationMethod = {
  /** IC チップ読み取り + セルフィー、犯収法ヘ方式 */
  IcChipAndSelfie: "IcChipAndSelfie",
  /** 対面での写真付き本人確認書類の提示、犯収法イ方式 */
  InPersonPhotoId: "InPersonPhotoId",
  /** 本人限定受取郵便、犯収法ヲ方式 */
  RestrictedDeliveryMail: "RestrictedDeliveryMail",
} as const;

export type IdentityVerificationMethod =
  (typeof IdentityVerificationMethod)[keyof typeof IdentityVerificationMethod];
/** 本人確認の結果 */
export const IdentityVerificationResult = {
  Approved: "Approved",
  Denied: "Denied",
} as const;

export type IdentityVerificationResult =
  (typeof IdentityVerificationResult)[keyof typeof IdentityVerificationResult];
/** 本人確認の進行状況 */
export const IdentityVerificationStatus = {
  Accepted: "Accepted",
  DocumentSubmitted: "DocumentSubmitted",
  InProgress: "InProgress",
  NotStarted: "NotStarted",
  PlansSelected: "PlansSelected",
  Verified: "Verified",
} as const;

export type IdentityVerificationStatus =
  (typeof IdentityVerificationStatus)[keyof typeof IdentityVerificationStatus];
export const IncomeBracketType = {
  Above30Mil: "Above30Mil",
  Below5Mil: "Below5Mil",
  DoNotKnowWillNotSay: "DoNotKnowWillNotSay",
  From5MilTo8Mil: "From5MilTo8Mil",
  From8MilTo10Mil: "From8MilTo10Mil",
  From10MilTo15Mil: "From10MilTo15Mil",
  From15MilTo20Mil: "From15MilTo20Mil",
  From20MilTo30Mil: "From20MilTo30Mil",
} as const;

export type IncomeBracketType =
  (typeof IncomeBracketType)[keyof typeof IncomeBracketType];
/** アカウント連携開始エラー */
export type InitiateAccountLinkError = {
  __typename: "InitiateAccountLinkError";
  case: InitiateAccountLinkErrorCase;
};

/** アカウント連携開始エラーケース */
export const InitiateAccountLinkErrorCase = {
  /** セッショントークンが無効または期限切れ */
  InvalidSessionToken: "InvalidSessionToken",
} as const;

export type InitiateAccountLinkErrorCase =
  (typeof InitiateAccountLinkErrorCase)[keyof typeof InitiateAccountLinkErrorCase];
/** アカウント連携の開始に必要な入力 */
export type InitiateAccountLinkInput = {
  /** プラットフォーム */
  platform: AccountLinkPlatform;
  /** Auth0から受け取ったセッショントークン */
  sessionToken: Scalars["String"]["input"];
  /** Auth0のOIDC state パラメータ */
  state: Scalars["String"]["input"];
};

/** アカウント連携開始結果 */
export type InitiateAccountLinkPayload =
  | InitiateAccountLinkError
  | InitiateAccountLinkSuccess;

/** アカウント連携開始成功 */
export type InitiateAccountLinkSuccess = {
  __typename: "InitiateAccountLinkSuccess";
  /** ユーザーをリダイレクトすべきAuth0のOAuth認可URL */
  redirectUrl: Scalars["String"]["output"];
};

/** アイデンティティ追加開始エラー */
export type InitiateAddIdentityError = {
  __typename: "InitiateAddIdentityError";
  case: InitiateAddIdentityErrorCase;
};

/** アイデンティティ追加開始エラーケース */
export const InitiateAddIdentityErrorCase = {
  /** 既に同じプロバイダーが連携済み */
  AlreadyLinked: "AlreadyLinked",
  /** 認証されていない */
  Unauthorized: "Unauthorized",
} as const;

export type InitiateAddIdentityErrorCase =
  (typeof InitiateAddIdentityErrorCase)[keyof typeof InitiateAddIdentityErrorCase];
/** アイデンティティ追加開始の入力 */
export type InitiateAddIdentityInput = {
  /** プラットフォーム */
  platform: AccountLinkPlatform;
  /** 追加するプロバイダー */
  provider: IdentityProvider;
};

/** アイデンティティ追加開始結果 */
export type InitiateAddIdentityPayload =
  | InitiateAddIdentityError
  | InitiateAddIdentitySuccess;

/** アイデンティティ追加開始成功 */
export type InitiateAddIdentitySuccess = {
  __typename: "InitiateAddIdentitySuccess";
  /** ユーザーをリダイレクトすべきAuth0の再認証URL */
  redirectUrl: Scalars["String"]["output"];
};

/** 清掃ボードの 1 行（部屋 × 確認日） */
export type Inspection = {
  __typename: "Inspection";
  /** 宿泊施設 */
  accommodation: Accommodation;
  /** 確認日 */
  inspectionDate: Scalars["PlainDate"]["output"];
  /** 当日の予約 */
  reservation?: Maybe<AccommodationReservation>;
  /** 清掃ステータス。報告が無ければ NotStarted */
  status: InspectionStatusType;
};

/** 確認報告。1 予約 1 件で、有料備品の報告とハウスルール違反の報告が同じ行に載る */
export type InspectionReport = {
  __typename: "InspectionReport";
  /** 有料備品報告の締め。締め済みは請求が確定している */
  closedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** JTAS 側の報告ID */
  externalViolationReportId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 報告の対象になった滞在。確認日は lastNight の翌日 */
  reservation: AccommodationReservation;
  /** 有料備品報告の写真 */
  supplyItemMedia: Array<UploadedFile>;
  /** 報告された有料備品 */
  supplyItems: Array<InspectionSupplyItem>;
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 違反の発生事象の詳細 */
  violationDescription?: Maybe<Scalars["String"]["output"]>;
  /** ハウスルール違反への社内対応。まだ着手していない報告には行が無いので null になる */
  violationHandling?: Maybe<InspectionViolationHandling>;
  /** ハウスルール違反の項目。JTAS 側マスタのスナップショットで、報告のたびに全置換される */
  violationItems: Array<InspectionViolationItem>;
  /** 違反の証跡 */
  violationMedia: Array<UploadedFile>;
};

/** 確認報告の種別 */
export const InspectionReportType = {
  Supply: "Supply",
  Violation: "Violation",
} as const;

export type InspectionReportType =
  (typeof InspectionReportType)[keyof typeof InspectionReportType];
export const InspectionStatusType = {
  Inspected: "Inspected",
  InspectionRequired: "InspectionRequired",
  NotStarted: "NotStarted",
  Started: "Started",
} as const;

export type InspectionStatusType =
  (typeof InspectionStatusType)[keyof typeof InspectionStatusType];
export type InspectionSupplyItem = {
  __typename: "InspectionSupplyItem";
  id: Scalars["ID"]["output"];
  /** 備品マスタの表示名（スタッフ用） */
  name: Scalars["String"]["output"];
  quantity: Scalars["Int"]["output"];
};

/** ハウスルール違反への社内対応の記録 */
export type InspectionViolationHandling = {
  __typename: "InspectionViolationHandling";
  id: Scalars["ID"]["output"];
  severity: InspectionViolationSeverity;
  severityAssessedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  severityAssessedByUser?: Maybe<User>;
  status: InspectionViolationHandlingStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
  warningActionAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  warningActionByUser?: Maybe<User>;
  warningActionNote?: Maybe<Scalars["String"]["output"]>;
};

/** ハウスルール違反への対応状況 */
export const InspectionViolationHandlingStatus = {
  Assessed: "Assessed",
  Handled: "Handled",
  Pending: "Pending",
} as const;

export type InspectionViolationHandlingStatus =
  (typeof InspectionViolationHandlingStatus)[keyof typeof InspectionViolationHandlingStatus];
export type InspectionViolationItem = {
  __typename: "InspectionViolationItem";
  id: Scalars["ID"]["output"];
  /** JTAS 側マスタの識別子 */
  typeId: Scalars["Int"]["output"];
  typeName: Scalars["String"]["output"];
};

/** 違反レベル */
export const InspectionViolationSeverity = {
  High: "High",
  Low: "Low",
  Medium: "Medium",
  NotAssessed: "NotAssessed",
} as const;

export type InspectionViolationSeverity =
  (typeof InspectionViolationSeverity)[keyof typeof InspectionViolationSeverity];
export type InternalAccommodationEquipmentError = {
  __typename: "InternalAccommodationEquipmentError";
  case: InternalAccommodationEquipmentErrorCase;
};

export const InternalAccommodationEquipmentErrorCase = {
  /** 指定した宿泊施設が見つからない */
  AccommodationNotFound: "AccommodationNotFound",
  /** attribute が機器種別と一致しない */
  AttributeTypeMismatch: "AttributeTypeMismatch",
  /** 同じ宿泊施設に同じ種別の機器が既に存在する */
  DuplicateEquipmentType: "DuplicateEquipmentType",
  /** 指定した機器が見つからない */
  EquipmentNotFound: "EquipmentNotFound",
  /** 指定した deviceId が sanu_edge_devices に登録されていない */
  SanuEdgeDeviceNotFound: "SanuEdgeDeviceNotFound",
} as const;

export type InternalAccommodationEquipmentErrorCase =
  (typeof InternalAccommodationEquipmentErrorCase)[keyof typeof InternalAccommodationEquipmentErrorCase];
export type InternalAddLocalTaxPolicyError = {
  __typename: "InternalAddLocalTaxPolicyError";
  case: InternalAddLocalTaxPolicyErrorCase;
};

export const InternalAddLocalTaxPolicyErrorCase = {
  /** 適用先の拠点、またはいずれかの部屋に適用済みのポリシーと有効期間が重なる */
  OverlappingEffectivePeriod: "OverlappingEffectivePeriod",
} as const;

export type InternalAddLocalTaxPolicyErrorCase =
  (typeof InternalAddLocalTaxPolicyErrorCase)[keyof typeof InternalAddLocalTaxPolicyErrorCase];
export type InternalAddLocalTaxPolicyPayload =
  | InternalAddLocalTaxPolicyError
  | LocalTaxPolicy;

/** 地方税ポリシーの適用先。いずれか 1 つだけを指定する */
export type InternalAddLocalTaxPolicyTargetInput =
  /** 入湯税として適用する部屋 */
  | {
      accommodationIds: Array<Scalars["ID"]["input"]>;
      siteId?: never;
    } /** 宿泊税として適用する拠点 */
  | { accommodationIds?: never; siteId: Scalars["ID"]["input"] };

export type InternalAdjustOwnerStayCreditError = {
  __typename: "InternalAdjustOwnerStayCreditError";
  case: InternalAdjustOwnerStayCreditErrorCase;
};

export const InternalAdjustOwnerStayCreditErrorCase = {
  InsufficientBalance: "InsufficientBalance",
  InvalidAmount: "InvalidAmount",
  OwnershipNotFound: "OwnershipNotFound",
} as const;

export type InternalAdjustOwnerStayCreditErrorCase =
  (typeof InternalAdjustOwnerStayCreditErrorCase)[keyof typeof InternalAdjustOwnerStayCreditErrorCase];
export type InternalAdjustOwnerStayCreditPayload =
  | InternalAdjustOwnerStayCreditError
  | Success;

export type InternalAdjustStaffCreditsError = {
  __typename: "InternalAdjustStaffCreditsError";
  case: InternalAdjustStaffCreditsErrorCase;
};

export const InternalAdjustStaffCreditsErrorCase = {
  /** 契約が見つからない */
  ContractNotFound: "ContractNotFound",
  /** 残高不足（減算が残高を超える） */
  InsufficientBalance: "InsufficientBalance",
  /** 入力値が無効（泊数・ピーク日がともに0） */
  InvalidInput: "InvalidInput",
  /** 権限がない */
  NotAuthorized: "NotAuthorized",
} as const;

export type InternalAdjustStaffCreditsErrorCase =
  (typeof InternalAdjustStaffCreditsErrorCase)[keyof typeof InternalAdjustStaffCreditsErrorCase];
export type InternalAdjustStaffCreditsResult =
  | InternalAdjustStaffCreditsError
  | InternalAdjustStaffCreditsSuccess;

export type InternalAdjustStaffCreditsSuccess = {
  __typename: "InternalAdjustStaffCreditsSuccess";
  contract: StaffContract;
};

/**
 * ロール割り当ての対象ユーザーの氏名とメール。User と違い他の情報へ辿る field を持たないので、
 * 拠点スコープの主体にも返せる
 */
export type InternalAdminRoleAssignee = {
  __typename: "InternalAdminRoleAssignee";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InternalAppendS2oPointsToCoOwnersApplicationError = {
  __typename: "InternalAppendS2oPointsToCoOwnersApplicationError";
  case: InternalAppendS2oPointsToCoOwnersApplicationErrorCase;
};

export const InternalAppendS2oPointsToCoOwnersApplicationErrorCase = {
  /** CoOwnersApplicationが無効（キャンセル済みなど） */
  CoOwnersApplicationInvalid: "CoOwnersApplicationInvalid",
  /** CoOwnersApplicationが見つからない */
  CoOwnersApplicationNotFound: "CoOwnersApplicationNotFound",
  /** 有効な Co-Owners充当特典（旧S2Oポイント）残高が不足している */
  InsufficientS2oPointBalance: "InsufficientS2oPointBalance",
  /** 金額が不正（0以下） */
  InvalidAmount: "InvalidAmount",
} as const;

export type InternalAppendS2oPointsToCoOwnersApplicationErrorCase =
  (typeof InternalAppendS2oPointsToCoOwnersApplicationErrorCase)[keyof typeof InternalAppendS2oPointsToCoOwnersApplicationErrorCase];
export type InternalAppendS2oPointsToCoOwnersApplicationPayload =
  | InternalAppendS2oPointsToCoOwnersApplicationError
  | Success;

export type InternalApplyGuestAccessKeyError = {
  __typename: "InternalApplyGuestAccessKeyError";
  message: Scalars["String"]["output"];
};

export type InternalApplyGuestAccessKeyPayload =
  | InternalApplyGuestAccessKeyError
  | Success;

export type InternalApplyStaffAccessKeyError = {
  __typename: "InternalApplyStaffAccessKeyError";
  message: Scalars["String"]["output"];
};

export type InternalApplyStaffAccessKeyPayload =
  | InternalApplyStaffAccessKeyError
  | Success;

/** 建築コンテンツ系 mutation の共通エラー */
export type InternalArchitectureContentError = {
  __typename: "InternalArchitectureContentError";
  case: InternalArchitectureContentErrorCase;
  /** 管理画面にそのまま表示できる説明 */
  message: Scalars["String"]["output"];
};

export const InternalArchitectureContentErrorCase = {
  /** 新規作成時は建築家が必須（公開スキーマの architect が non-null のため） */
  ArchitectRequired: "ArchitectRequired",
  ArchitectureTypeNotFound: "ArchitectureTypeNotFound",
  /** 建築タイプにコンテンツ行が無い */
  ContentNotFound: "ContentNotFound",
  /** 他から参照中で削除できない（message に参照元を含む） */
  InUse: "InUse",
  /** S3 の rawUrl 形式でない */
  InvalidImage: "InvalidImage",
  /** http(s) の絶対 URL でない */
  InvalidUrl: "InvalidUrl",
  /** 名前が空（slug を決められない） */
  NameRequired: "NameRequired",
  /** id で指定した関連レコードが存在しない（message に id を含む） */
  ResourceNotFound: "ResourceNotFound",
  /** 新規作成時は並び順が必須 */
  SortRequired: "SortRequired",
} as const;

export type InternalArchitectureContentErrorCase =
  (typeof InternalArchitectureContentErrorCase)[keyof typeof InternalArchitectureContentErrorCase];
/**
 * 建築コンテンツ画像の用途。S3 のキーは
 * ArchitectureType なら `architecture-contents/<建築 slug>/`、それ以外は `architecture-contents/shared/<用途>/` 配下になる
 */
export const InternalArchitectureContentImageKind = {
  /** 建築家の顔写真（shared/architects） */
  Architect: "Architect",
  /** 建築タイプに紐づく画像（サムネイル・カルーセル・間取り図）。architectureTypeId が必須 */
  ArchitectureType: "ArchitectureType",
  /** 基本の設備のアイコン（shared/basic-amenity-icons） */
  BasicAmenityIcon: "BasicAmenityIcon",
  /** 特徴ページの画像（shared/features） */
  Feature: "Feature",
  /** 特徴ページの利用ルール画像（shared/feature-usage-rules） */
  FeatureUsageRule: "FeatureUsageRule",
  /** バリエーション・オプションの画像（shared/variants） */
  Variant: "Variant",
} as const;

export type InternalArchitectureContentImageKind =
  (typeof InternalArchitectureContentImageKind)[keyof typeof InternalArchitectureContentImageKind];
/**
 * 管理画面用のエリア型。public `Area` には載せたくない field（多言語名など）を含む。
 * public schema からは `localizedName` が露出しないようにここに集約する。
 */
export type InternalArea = {
  __typename: "InternalArea";
  /** エリアコンテンツ */
  content: AreaContent;
  /** おすすめスポット（未掲載・掲載期間外も含む全件）。公開ページ用は `content.guideSpots`。 */
  guideSpots: Array<AreaGuideSpot>;
  id: Scalars["ID"]["output"];
  /** 多言語化されたエリア名。admin の編集 UI で各 locale の値を取得するために使用する。 */
  localizedName: InternalLocalizedString;
  /** エリア名（canonical）。admin 表示用なので caller.locale による localize はしない。 */
  name: Scalars["String"]["output"];
  /** エリアに含まれる拠点の一覧（admin 用 InternalSite） */
  sites: Array<InternalSite>;
  slug: Scalars["String"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
};

export type InternalAssignAccessCodeToAccommodationReservationError = {
  __typename: "InternalAssignAccessCodeToAccommodationReservationError";
  internalCode: Scalars["String"]["output"];
};

export type InternalAssignAccessCodeToAccommodationReservationPayload =
  | AccommodationReservation
  | InternalAssignAccessCodeToAccommodationReservationError;

export type InternalAssignAdminRoleError = {
  __typename: "InternalAssignAdminRoleError";
  code: InternalAssignAdminRoleErrorCode;
  message: Scalars["String"]["output"];
};

export const InternalAssignAdminRoleErrorCode = {
  AlreadyAssigned: "AlreadyAssigned",
  ExpiresAtNotInFuture: "ExpiresAtNotInFuture",
  /** 付与先が userId と email のどちらか一方だけで指定されていない（両方無いか、両方ある） */
  InvalidAssignee: "InvalidAssignee",
  /** 呼び出し元が付与できないロール（internalGrantableAdminRoles に無いもの） */
  RoleNotGrantable: "RoleNotGrantable",
  ScopeNotAllowed: "ScopeNotAllowed",
  ScopeRequired: "ScopeRequired",
  /** 自分自身への付与 */
  SelfAssignment: "SelfAssignment",
  SiteNotFound: "SiteNotFound",
  /** 呼び出し元の付与権が及ばない拠点（PartnerSiteManager が自分の拠点以外に付けようとした） */
  SiteNotGrantable: "SiteNotGrantable",
  UserNotFound: "UserNotFound",
} as const;

export type InternalAssignAdminRoleErrorCode =
  (typeof InternalAssignAdminRoleErrorCode)[keyof typeof InternalAssignAdminRoleErrorCode];
export type InternalAssignAdminRoleInput = {
  /**
   * 付与先のメールアドレス。ユーザー検索（UsersRead）を持たない PartnerSiteManager 向けで、userId とどちらか一方だけを指定する（空文字や空白だけなら指定なしとみなす）。
   * 前後の空白を除き大文字小文字を区別しない完全一致で退会していないユーザーに解決し、該当が無ければ UserNotFound
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** 未来の時刻。省略時は無期限。 */
  expiresAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  role: AdminRole;
  /** scope: Site のロールでは必須。将来の軸 (facilityTypeSlug 等) はここに optional で足す。 */
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 付与先の User.id。email とどちらか一方だけを指定する（両方無いか両方あると InvalidAssignee。空文字や空白だけの email は指定なしとみなす） */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InternalAssignAdminRolePayload =
  | AdminRoleAssignment
  | InternalAssignAdminRoleError;

/** Auth0ユーザーのアイデンティティ */
export type InternalAuth0Identity = {
  __typename: "InternalAuth0Identity";
  /** コネクション名 */
  connection: Scalars["String"]["output"];
  /** ソーシャルプロバイダーかどうか */
  isSocial: Scalars["Boolean"]["output"];
  /** profileDataのメールアドレス（リンク済みアイデンティティの場合） */
  profileEmail?: Maybe<Scalars["String"]["output"]>;
  /** profileDataのメール確認済みフラグ */
  profileEmailVerified?: Maybe<Scalars["Boolean"]["output"]>;
  /** プロバイダー（auth0, google-oauth2, apple） */
  provider: Scalars["String"]["output"];
  /** プロバイダー側ユーザーID */
  userId: Scalars["String"]["output"];
};

/** Auth0 Management APIから取得したユーザー */
export type InternalAuth0User = {
  __typename: "InternalAuth0User";
  /** メールアドレス */
  email?: Maybe<Scalars["String"]["output"]>;
  /** メール確認済みかどうか */
  emailVerified: Scalars["Boolean"]["output"];
  /** アイデンティティ一覧 */
  identities: Array<InternalAuth0Identity>;
  /** Auth0ユーザーID（例: auth0|xxx, google-oauth2|xxx） */
  userId: Scalars["String"]["output"];
};

/** スタッフプラン登録可能なターム */
export type InternalAvailableStaffSemester = {
  __typename: "InternalAvailableStaffSemester";
  label: Scalars["String"]["output"];
  semester: StaffSemester;
  year: Scalars["Int"]["output"];
};

/** internalBeds24SyncFuturePrices の実行結果。 */
export type InternalBeds24SyncFuturePricesResult = {
  __typename: "InternalBeds24SyncFuturePricesResult";
  dryRun: Scalars["Boolean"]["output"];
  processedNightCount: Scalars["Int"]["output"];
  skippedRoomTypes: Array<InternalBeds24SyncFuturePricesSkip>;
  targets: Array<InternalBeds24SyncFuturePricesTarget>;
};

export type InternalBeds24SyncFuturePricesSkip = {
  __typename: "InternalBeds24SyncFuturePricesSkip";
  reason: Scalars["String"]["output"];
  roomType: RoomType;
};

export type InternalBeds24SyncFuturePricesTarget = {
  __typename: "InternalBeds24SyncFuturePricesTarget";
  blackoutRangeCount: Scalars["Int"]["output"];
  priceRangeCount: Scalars["Int"]["output"];
  roomType: RoomType;
};

/** 予約ブロック一括作成の失敗情報 */
export type InternalBulkCreateAccommodationAvailabilityBlockFailure = {
  __typename: "InternalBulkCreateAccommodationAvailabilityBlockFailure";
  /** 失敗した入力内容 */
  input: InternalBulkCreateAccommodationAvailabilityBlockFailureInput;
  /** エラー理由 */
  reason: Scalars["String"]["output"];
};

/** CreateAccommodationAvailabilityBlockInputと同じ構造（output type版） */
export type InternalBulkCreateAccommodationAvailabilityBlockFailureInput = {
  __typename: "InternalBulkCreateAccommodationAvailabilityBlockFailureInput";
  /** 部屋ID（nullの場合は全部屋対象） */
  accommodationId?: Maybe<Scalars["ID"]["output"]>;
  /** 開始日 */
  beginNight: Scalars["PlainDate"]["output"];
  /** 種別 */
  category: AccommodationAvailabilityBlockCategory;
  /** 終了日 */
  endNight: Scalars["PlainDate"]["output"];
  /** 一時的なブロックフラグ */
  isTentative: Scalars["Boolean"]["output"];
  /** ブロック名 */
  name: Scalars["String"]["output"];
  /** メモ欄 */
  note?: Maybe<Scalars["String"]["output"]>;
  /** 拠点ID */
  siteId: Scalars["ID"]["output"];
  /** グループID */
  staffGroupId?: Maybe<Scalars["ID"]["output"]>;
};

/** 予約ブロック一括作成の結果 */
export type InternalBulkCreateAccommodationAvailabilityBlocksPayload = {
  __typename: "InternalBulkCreateAccommodationAvailabilityBlocksPayload";
  /** 作成に失敗した入力とエラー理由 */
  failed: Array<InternalBulkCreateAccommodationAvailabilityBlockFailure>;
  /** 作成に成功した予約ブロック */
  success: Array<AccommodationAvailabilityBlock>;
};

export type InternalBulkCreateOrganizationYearlyContractInvoicesError = {
  __typename: "InternalBulkCreateOrganizationYearlyContractInvoicesError";
  case: InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase;
  /** 作成に失敗するまでに作成できていた件数 */
  createdCount: Scalars["Int"]["output"];
  /**
   * 作成後に取り消せず Stripe に残った請求書のID。
   * 運用者が手作業で消す必要があるため、maskedErrorsで潰れない payload で返す。
   */
  orphanedInvoiceIds: Array<Scalars["String"]["output"]>;
};

export const InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase = {
  /** カード自動決済の請求書を作ろうとしたが、カードが登録されていない */
  CardIsNotRegistered: "CardIsNotRegistered",
  /** 無効化済みの契約に対して請求書を作成しようとした */
  ContractIsInvalidated: "ContractIsInvalidated",
  /** 作成の途中でStripeへの作成に失敗した */
  CreationFailed: "CreationFailed",
  /** Stripe顧客にメールアドレスが登録されていない */
  CustomerEmailRequired: "CustomerEmailRequired",
  /** 銀行振込の支払期限が過去日になる（Stripeが受け付けない） */
  DueDateIsInPast: "DueDateIsInPast",
  /** 公開予定日が指定できる範囲（契約開始月の前月1日〜契約開始月末）の外 */
  ScheduledOpenDateOutOfRange: "ScheduledOpenDateOutOfRange",
} as const;

export type InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase =
  (typeof InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase)[keyof typeof InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase];
export type InternalBulkCreateOrganizationYearlyContractInvoicesPayload =
  | InternalBulkCreateOrganizationYearlyContractInvoicesError
  | InternalBulkCreateOrganizationYearlyContractInvoicesSuccess;

export type InternalBulkCreateOrganizationYearlyContractInvoicesSuccess = {
  __typename: "InternalBulkCreateOrganizationYearlyContractInvoicesSuccess";
  /** 作成された請求書のStripe Invoice IDs */
  invoiceIds: Array<Scalars["String"]["output"]>;
};

/** 予約ブロック一括解除の失敗情報 */
export type InternalBulkDeleteAccommodationAvailabilityBlockFailure = {
  __typename: "InternalBulkDeleteAccommodationAvailabilityBlockFailure";
  /** 失敗した予約ブロックのID */
  id: Scalars["ID"]["output"];
  /** エラー理由 */
  reason: Scalars["String"]["output"];
};

/** 予約ブロック一括解除の結果 */
export type InternalBulkDeleteAccommodationAvailabilityBlocksPayload = {
  __typename: "InternalBulkDeleteAccommodationAvailabilityBlocksPayload";
  /** 解除に失敗した予約ブロックのIDとエラー理由 */
  failed: Array<InternalBulkDeleteAccommodationAvailabilityBlockFailure>;
  /**
   * 解除に成功した予約ブロックのID。解除済みオブジェクトを返すとクライアントのキャッシュに
   * 復活してしまうため、表示に必要な情報は呼び出し側が一覧の行から ID 引きで補う。
   */
  successIds: Array<Scalars["ID"]["output"]>;
};

export type InternalBulkUpdateSeasonalFeeSettingsError = {
  __typename: "InternalBulkUpdateSeasonalFeeSettingsError";
  /** エラーメッセージ */
  message: Scalars["String"]["output"];
  /** エラーが発生した夜の日付 */
  night: Scalars["String"]["output"];
};

export type InternalBulkUpdateSeasonalFeeSettingsInput = {
  /** 追加料金。nullの場合は該当する夜の記録を削除 */
  additionalFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** 日付 */
  night: Scalars["PlainDate"]["input"];
};

export type InternalBulkUpdateSeasonalFeeSettingsPayload = {
  __typename: "InternalBulkUpdateSeasonalFeeSettingsPayload";
  /** 作成された設定の数 */
  created: Scalars["Int"]["output"];
  /** 削除された設定の数 */
  deleted: Scalars["Int"]["output"];
  /** 処理に失敗したレコードのエラー情報 */
  errors: Array<InternalBulkUpdateSeasonalFeeSettingsError>;
  /** 更新された設定の数 */
  updated: Scalars["Int"]["output"];
};

export type InternalBulkUpdateStayTicketMasterInput = {
  /** 追加ゲスト料金ポリシーID（undefinedの場合は更新しない、nullの場合は紐付けを解除） */
  additionalGuestFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 更新対象のチケットマスタID */
  id: Scalars["ID"]["input"];
  /** 管理部署ID（nullの場合は更新しない） */
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** チケット区分（nullの場合は更新しない） */
  ticketCategory?: InputMaybe<TicketCategory>;
};

export type InternalBulkUpdateStayTicketMastersError = {
  __typename: "InternalBulkUpdateStayTicketMastersError";
  /** エラーが発生したチケットマスタID */
  id: Scalars["String"]["output"];
  /** エラーメッセージ */
  message: Scalars["String"]["output"];
};

export type InternalBulkUpdateStayTicketMastersPayload = {
  __typename: "InternalBulkUpdateStayTicketMastersPayload";
  /** 処理に失敗したレコードのエラー情報 */
  errors: Array<InternalBulkUpdateStayTicketMastersError>;
  /** スキップしたレコード数 */
  skipped: Scalars["Int"]["output"];
  /** 更新成功したレコード数 */
  updated: Scalars["Int"]["output"];
};

export type InternalCancelCoOwnersApplicationError = {
  __typename: "InternalCancelCoOwnersApplicationError";
  case: InternalCancelCoOwnersApplicationErrorCase;
};

export const InternalCancelCoOwnersApplicationErrorCase = {
  /** 既にキャンセル済み */
  AlreadyCancelled: "AlreadyCancelled",
  /** 引渡完了後はキャンセル不可 */
  CannotCancelAfterHandover: "CannotCancelAfterHandover",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
  /** Stripe返金エラー */
  StripeRefundError: "StripeRefundError",
} as const;

export type InternalCancelCoOwnersApplicationErrorCase =
  (typeof InternalCancelCoOwnersApplicationErrorCase)[keyof typeof InternalCancelCoOwnersApplicationErrorCase];
export type InternalCancelCoOwnersApplicationPayload =
  | CoOwnersApplication
  | InternalCancelCoOwnersApplicationError;

export type InternalCommonError = {
  __typename: "InternalCommonError";
  message: Scalars["String"]["output"];
};

/** ルームタイプの表示コンテンツ（CMS 編集用） */
export type InternalContentRoomType = {
  __typename: "InternalContentRoomType";
  /** 紹介文 */
  description?: Maybe<Scalars["String"]["output"]>;
  heroImages: Array<UploadedFile>;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** ブロック解放スケジュールの作成入力 */
export type InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput = {
  /** 維持するブロック室数の上限（0 = 全解除） */
  blockRoomCountUpperLimit: Scalars["Int"]["input"];
  /** チェックインN日前 */
  daysBeforeCheckin: Scalars["Int"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
};

export type InternalCreateAccommodationEquipmentInput = {
  accommodationId: Scalars["ID"]["input"];
  /**
   * 機器種別ごとの固有情報を表す JSON 文字列（GraphQL に input union が無いため、Facility の
   * InternalCreateOrUpdateFacilityControllerInput.attribute に倣う）。
   * 形は type によって決まり、domain/models/AccommodationEquipment.ts の zod スキーマが検証する。
   * - Wifi: { primary: { ssid, password }, secondary: { ssid, password } | null }
   * - MusicConnect: { instruction }
   * - Sauna: { deviceId }
   */
  attribute: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  sort: Scalars["Int"]["input"];
  status: AccommodationEquipmentStatusType;
  type: AccommodationEquipmentType;
};

export type InternalCreateAccommodationEquipmentPayload =
  | AccommodationEquipment
  | InternalAccommodationEquipmentError;

export type InternalCreateAccommodationOperationGroupError = {
  __typename: "InternalCreateAccommodationOperationGroupError";
  case: InternalCreateAccommodationOperationGroupErrorCase;
};

export const InternalCreateAccommodationOperationGroupErrorCase = {
  /** 拠点 × 建築タイプの運用グループがすでにある */
  AlreadyExists: "AlreadyExists",
  /** 建築タイプが見つからない */
  ArchitectureTypeNotFound: "ArchitectureTypeNotFound",
  /** 追加料金が不正（負の値、またはクラスで使われない欄が 0 以外） */
  InvalidAdditionalFee: "InvalidAdditionalFee",
  /** 拠点が見つからない */
  SiteNotFound: "SiteNotFound",
} as const;

export type InternalCreateAccommodationOperationGroupErrorCase =
  (typeof InternalCreateAccommodationOperationGroupErrorCase)[keyof typeof InternalCreateAccommodationOperationGroupErrorCase];
export type InternalCreateAccommodationOperationGroupInput = {
  additionalFeeForBusinessPlan: Scalars["Int"]["input"];
  additionalFeeForClassEOwner: Scalars["Int"]["input"];
  additionalFeeForClassFOwner: Scalars["Int"]["input"];
  architectureTypeId: Scalars["ID"]["input"];
  class: AccommodationClass;
  operationType: AccommodationOperationType;
  siteId: Scalars["ID"]["input"];
};

export type InternalCreateAccommodationOperationGroupPayload =
  | AccommodationOperationGroup
  | InternalCreateAccommodationOperationGroupError;

export type InternalCreateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  fee?: InputMaybe<AccommodationFeeInput>;
  firstNight: Scalars["PlainDate"]["input"];
  /**
   * SanuIncの場合、TentativeDeadlineを設定するかどうか
   * true: SanuIncUsageによって期限を設定
   * false: 9999-12-31T23:59:59Zを設定
   */
  hasDeadline?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * 仮予約として取るかどうか
   * 既存ユーザーではない場合、必ず仮予約として取る必要がある。
   */
  isTentative: Scalars["Boolean"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
  /** 予約を作成する対象ユーザー（既存ユーザーの場合） */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
  waiveConsumedSuppliesFee: Scalars["Boolean"]["input"];
};

export type InternalCreateArchitectureContentImageUploadPolicyInput = {
  /** kind が ArchitectureType のとき必須（無ければ ResourceIdRequired）。それ以外は無視する */
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  kind: InternalArchitectureContentImageKind;
};

/** エリア画像アップロードポリシーの入力 */
export type InternalCreateAreaImageUploadPolicyInput = {
  /** エリアID */
  areaId: Scalars["ID"]["input"];
};

/** エリア作成の入力 */
export type InternalCreateAreaInput = {
  /** 多言語化されたエリア名。全 locale (Ja / En / ZhCn) 必須。 */
  localizedName: InternalLocalizedStringInput;
  /** エリア名（例：一宮、安曇野）。旧フィールドで analytics 等で参照されている。 */
  name: Scalars["String"]["input"];
  /** スラッグ（URLに使用、英小文字・数字・ハイフンのみ） */
  slug: Scalars["String"]["input"];
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InternalCreateCoOwnersIdentityVerificationError = {
  __typename: "InternalCreateCoOwnersIdentityVerificationError";
  case: InternalCreateCoOwnersIdentityVerificationErrorCase;
};

export const InternalCreateCoOwnersIdentityVerificationErrorCase = {
  /**
   * 同じ method の本人確認が既に存在するため作成できない
   * （IcChipAndSelfie は進行中、RestrictedDeliveryMail はステータスを問わず1件まで）
   */
  ActiveVerificationExists: "ActiveVerificationExists",
  /** 作成できない method が指定された */
  UnsupportedMethod: "UnsupportedMethod",
} as const;

export type InternalCreateCoOwnersIdentityVerificationErrorCase =
  (typeof InternalCreateCoOwnersIdentityVerificationErrorCase)[keyof typeof InternalCreateCoOwnersIdentityVerificationErrorCase];
export type InternalCreateCoOwnersIdentityVerificationInput = {
  method: IdentityVerificationMethod;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateCoOwnersIdentityVerificationPayload =
  | IdentityVerification
  | InternalCreateCoOwnersIdentityVerificationError;

export type InternalCreateConsumedSuppliesFeeItemsError = {
  __typename: "InternalCreateConsumedSuppliesFeeItemsError";
  case: InternalCreateConsumedSuppliesFeeItemsErrorCase;
};

export const InternalCreateConsumedSuppliesFeeItemsErrorCase = {
  AccommodationFeeIsNotOpen: "AccommodationFeeIsNotOpen",
  ExternalCleaningTaskIdNotMatch: "ExternalCleaningTaskIdNotMatch",
} as const;

export type InternalCreateConsumedSuppliesFeeItemsErrorCase =
  (typeof InternalCreateConsumedSuppliesFeeItemsErrorCase)[keyof typeof InternalCreateConsumedSuppliesFeeItemsErrorCase];
export type InternalCreateConsumedSuppliesFeeItemsInput = {
  accommodationReservationId: Scalars["ID"]["input"];
  externalCleaningTaskId: Scalars["ID"]["input"];
  items: Array<ConsumedSuppliesFeeItemInput>;
};

export type InternalCreateConsumedSuppliesFeeItemsPayload =
  | InternalCreateConsumedSuppliesFeeItemsError
  | Success;

/** 設備画像アップロードポリシーの入力 */
export type InternalCreateFacilityImageUploadPolicyInput = {
  /** 設備ID */
  facilityId: Scalars["ID"]["input"];
};

/** 付帯サービス新規作成入力 */
export type InternalCreateFacilityInput = {
  /** 料金ポリシー一覧 */
  baseFeePolicies: Array<InternalCreateOrUpdateFacilityBaseFeePolicyInput>;
  /** 返却後の準備日数（例: 充電1日 → 1）。デフォルト0 */
  bufferDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切の何日前（0=当日, 1=前日） */
  cancelDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切時刻 */
  cancelDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル料ポリシー一覧 */
  cancelFeePolicies: Array<InternalCreateOrUpdateFacilityCancelFeePolicyInput>;
  /** キャンセル料ルールURL */
  cancelRuleUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 設備詳細（Markdown） */
  contentDetail?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約時の案内（Markdown） */
  contentGuide?: InputMaybe<Scalars["String"]["input"]>;
  /** 注意事項（Markdown） */
  contentNotice?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用について（Markdown） */
  contentUsage?: InputMaybe<Scalars["String"]["input"]>;
  /** カスタムフィールド設定 */
  customFields?: InputMaybe<Array<FacilityCustomFieldItemInput>>;
  /** 施設説明文 */
  description: Scalars["String"]["input"];
  /** 詳細リンクURL（nullの場合はリンク非表示） */
  detailUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 付帯サービス種別 */
  facilityType: FacilityType;
  /** 単位種別 */
  facilityUnitType: FacilityUnitType;
  /** 施設画像 */
  image: UploadedFileInput;
  /** 清掃レポート機能を有効化（将来別システム移行予定） */
  isCleaningReportEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** データ連携管理機能を有効化 */
  isDataSyncEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 予約機能を有効にするか（false の場合は予約不要・無料で baseFeePolicies/cancelFeePolicies も不要） */
  isReserveEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 公開ページと予約カレンダーへの掲載を有効にするか */
  isVisibleEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 短縮表示名（ボタン/カード用） */
  label: Scalars["String"]["input"];
  /** 正式名称 */
  name: Scalars["String"]["input"];
  /** 予約締切の何日前（0=当日, 1=前日, 7=1週間前） */
  reserveDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** 予約締切時刻 */
  reserveDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** リソース一覧（最低1件必須） */
  resources: Array<InternalCreateOrUpdateFacilityResourceInput>;
  /** 拠点ID一覧 */
  siteIds: Array<Scalars["ID"]["input"]>;
  /** スロット定義一覧（facilityUnitType=Slot の場合のみ） */
  slots?: InputMaybe<Array<InternalCreateOrUpdateFacilitySlotInput>>;
  /** 公開ステータス */
  status: FacilityStatusType;
  /** 規約リンクのラベル */
  termsLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用規約URL */
  termsUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateFacilityReservationError = {
  __typename: "InternalCreateFacilityReservationError";
  case: InternalCreateFacilityReservationErrorCase;
};

export const InternalCreateFacilityReservationErrorCase = {
  AccommodationReservationPeriodMismatch:
    "AccommodationReservationPeriodMismatch",
  FeePolicyNotFound: "FeePolicyNotFound",
  InvalidDiscount: "InvalidDiscount",
  InvalidFacilityFieldData: "InvalidFacilityFieldData",
  InvalidSlotSelection: "InvalidSlotSelection",
  InvalidStartDate: "InvalidStartDate",
  NoAccommodationReservation: "NoAccommodationReservation",
  PastReserveDeadline: "PastReserveDeadline",
  ProviderNotEligible: "ProviderNotEligible",
  ResourceUnavailable: "ResourceUnavailable",
  ServiceNotAvailable: "ServiceNotAvailable",
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type InternalCreateFacilityReservationErrorCase =
  (typeof InternalCreateFacilityReservationErrorCase)[keyof typeof InternalCreateFacilityReservationErrorCase];
/** 管理者による付帯サービス予約作成入力 */
export type InternalCreateFacilityReservationInput = {
  /** 宿泊予約ID */
  accommodationReservationId: Scalars["ID"]["input"];
  /** カスタムフィールドの入力値 */
  customFieldValues?: InputMaybe<Array<FacilityCustomFieldValueInput>>;
  /** 管理者による割引。指定時は自動適用の割引（LEP対象者割引・Co-Owners特典など）を置き換える */
  discount?: InputMaybe<InternalFacilityReservationDiscountInput>;
  /** 返却/終了日（Night / Reservation の場合のみ） */
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 強制予約(admin のみ利用可能) */
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** リソースID */
  resourceId: Scalars["ID"]["input"];
  /** 選択したスロットID（unitType=Slot の場合のみ） */
  slotId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 利用開始日（Slot は利用日、Night / Reservation は貸出日） */
  startDate: Scalars["PlainDate"]["input"];
};

export type InternalCreateFacilityReservationPayload =
  | InternalCreateFacilityReservationError
  | Success;

export type InternalCreateFullOwnerIdentityVerificationError = {
  __typename: "InternalCreateFullOwnerIdentityVerificationError";
  case: InternalCreateFullOwnerIdentityVerificationErrorCase;
};

export const InternalCreateFullOwnerIdentityVerificationErrorCase = {
  /**
   * 同じ method の本人確認が既に存在するため作成できない
   * （IcChipAndSelfie は進行中、RestrictedDeliveryMail はステータスを問わず1件まで）
   */
  ActiveVerificationExists: "ActiveVerificationExists",
  /** 作成できない method が指定された */
  UnsupportedMethod: "UnsupportedMethod",
} as const;

export type InternalCreateFullOwnerIdentityVerificationErrorCase =
  (typeof InternalCreateFullOwnerIdentityVerificationErrorCase)[keyof typeof InternalCreateFullOwnerIdentityVerificationErrorCase];
export type InternalCreateFullOwnerIdentityVerificationInput = {
  method: IdentityVerificationMethod;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateFullOwnerIdentityVerificationPayload =
  | IdentityVerification
  | InternalCreateFullOwnerIdentityVerificationError;

export type InternalCreateLocalTaxPolicyError = {
  __typename: "InternalCreateLocalTaxPolicyError";
  case: InternalCreateLocalTaxPolicyErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateLocalTaxPolicyErrorCase = {
  /** 段階的定額の金額区分が正しくない（2 件以上で、0 円から隙間なく続き、最後は上限なし） */
  InvalidBrackets: "InvalidBrackets",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** 同じ自治体・税種別のポリシーと有効期間が重なる */
  OverlappingEffectivePeriod: "OverlappingEffectivePeriod",
} as const;

export type InternalCreateLocalTaxPolicyErrorCase =
  (typeof InternalCreateLocalTaxPolicyErrorCase)[keyof typeof InternalCreateLocalTaxPolicyErrorCase];
export type InternalCreateLocalTaxPolicyInput = {
  effectiveFrom: Scalars["PlainDate"]["input"];
  /** null は無期限 */
  effectiveTo?: InputMaybe<Scalars["PlainDate"]["input"]>;
  localGovernmentName: Scalars["String"]["input"];
  /** 税額の定め。指定したものが算出タイプ（一律定額・段階的定額・一律比率）になる */
  taxRule: InternalLocalTaxRuleInput;
  taxType: LocalTaxType;
  waiveKids: Scalars["Boolean"]["input"];
};

export type InternalCreateLocalTaxPolicyPayload =
  | InternalCreateLocalTaxPolicyError
  | LocalTaxPolicy;

/** 宿泊施設コンテンツ作成・更新の入力 */
export type InternalCreateOrUpdateAccommodationContentInput = {
  /** 設備マニュアルURL */
  manualUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** 部屋（Accommodation）の作成・更新時のエラー */
export type InternalCreateOrUpdateAccommodationError = {
  __typename: "InternalCreateOrUpdateAccommodationError";
  message: Scalars["String"]["output"];
};

/** 部屋（Accommodation）の作成・更新時の入力 */
export type InternalCreateOrUpdateAccommodationInput = {
  /** 部屋の建築タイプのID */
  architectureTypeId: Scalars["ID"]["input"];
  /** 部屋のコード */
  code: Scalars["String"]["input"];
  /** 設備の ID */
  facilityIds: Array<Scalars["ID"]["input"]>;
  /** RemoteLOCK のデバイスID（null で紐づけ解除）。存在しない ID は保存時に拒否される */
  remoteLockDeviceId?: InputMaybe<Scalars["String"]["input"]>;
  /** 部屋が属する拠点のID */
  siteId: Scalars["ID"]["input"];
  /** 並び順 */
  sort: Scalars["Int"]["input"];
};

/** 宿泊施設お知らせの作成・更新時のエラー */
export type InternalCreateOrUpdateAccommodationNoticeError = {
  __typename: "InternalCreateOrUpdateAccommodationNoticeError";
  case: InternalCreateOrUpdateAccommodationNoticeErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateAccommodationNoticeErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateAccommodationNoticeErrorCase =
  (typeof InternalCreateOrUpdateAccommodationNoticeErrorCase)[keyof typeof InternalCreateOrUpdateAccommodationNoticeErrorCase];
/** 宿泊施設のお知らせの作成・更新時の入力 */
export type InternalCreateOrUpdateAccommodationNoticeInput = {
  /** 対象宿泊施設のID一覧 */
  accommodationConnectionIds: Array<Scalars["ID"]["input"]>;
  /** タイトル */
  brief: Scalars["String"]["input"];
  /** 詳細 */
  detail: Scalars["String"]["input"];
  /** 表示終了日 */
  endDate: Scalars["PlainDate"]["input"];
  /** 外部URL */
  externalUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 対象者にメールで通知するか */
  sendEmailToExpectedUsers: Scalars["Boolean"]["input"];
  /** 表示開始日 */
  startDate: Scalars["PlainDate"]["input"];
  /** ステータス */
  status: AccommodationNoticeStatus;
};

/** 宿泊施設お知らせの作成・更新の結果 */
export type InternalCreateOrUpdateAccommodationNoticePayload =
  | AccommodationNotice
  | InternalCreateOrUpdateAccommodationNoticeError;

/** 部屋（Accommodation）の作成・更新の結果 */
export type InternalCreateOrUpdateAccommodationPayload =
  | Accommodation
  | InternalCreateOrUpdateAccommodationError;

/** 追加ゲスト料金ポリシーの作成・更新時のエラー */
export type InternalCreateOrUpdateAdditionalGuestFeePolicyError = {
  __typename: "InternalCreateOrUpdateAdditionalGuestFeePolicyError";
  case: InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase =
  (typeof InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase)[keyof typeof InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase];
/** 追加ゲスト料金ポリシーの作成・更新の入力 */
export type InternalCreateOrUpdateAdditionalGuestFeePolicyInput = {
  adultPrices: Array<Scalars["Int"]["input"]>;
  internalName: Scalars["String"]["input"];
  kidsPrices: Array<Scalars["Int"]["input"]>;
};

/** 追加ゲスト料金ポリシーの作成・更新の結果 */
export type InternalCreateOrUpdateAdditionalGuestFeePolicyPayload =
  | AdditionalGuestFeePolicy
  | InternalCreateOrUpdateAdditionalGuestFeePolicyError;

/** 建築タイプ作成・更新の入力 */
export type InternalCreateOrUpdateArchitectureTypeInput = {
  /** 1泊あたりの施設追加料金 */
  additionalFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** 定員 */
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  /** 公開状態 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** シリーズ */
  series?: InputMaybe<ArchitectureTypeSeries>;
  /** シリーズ名（例：SANU CABIN） */
  seriesName?: InputMaybe<Scalars["String"]["input"]>;
  /** 短縮名（例：BEE, MOSS） */
  seriesShortName?: InputMaybe<Scalars["String"]["input"]>;
  /** サイズ */
  size?: InputMaybe<ArchitectureTypeSize>;
  /** スラッグ（URLに使用、英小文字・数字・ハイフンのみ。作成時のみ必須） */
  slug?: InputMaybe<Scalars["String"]["input"]>;
};

/** エリアガイド記事作成・更新の入力 */
export type InternalCreateOrUpdateAreaGuideArticleInput = {
  /** 掲載対象エリアの ID（1 件以上。既存の紐付けは全置換） */
  areaIds: Array<Scalars["ID"]["input"]>;
  /** MAGAZINE 上の公開日 */
  publishedDate: Scalars["PlainDate"]["input"];
  /** 並び順。省略時は新規なら末尾、更新なら変更しない */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** サムネイル画像。null で外す。省略時は変更しない */
  thumbnail?: InputMaybe<UploadedFileInput>;
  title: Scalars["String"]["input"];
  /** MAGAZINE 記事の URL（http(s) の絶対 URL） */
  url: Scalars["String"]["input"];
};

/** エリアおすすめスポット作成・更新の入力 */
export type InternalCreateOrUpdateAreaGuideSpotInput = {
  /** エリアID（新規作成時に必要） */
  areaId?: InputMaybe<Scalars["ID"]["input"]>;
  businessHours?: InputMaybe<Scalars["String"]["input"]>;
  /** カテゴリ（複数可） */
  categories?: InputMaybe<Array<AreaGuideSpotCategory>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 画像（順序保持）。undefined のときは更新しない */
  images?: InputMaybe<Array<UploadedFileInput>>;
  mapUrl?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /**
   * 掲載終了日（当日を含む）。null で無期限に戻す。省略時は変更しない。
   * 掲載を止めたいときは過去日を入れる
   */
  publishEndDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 掲載開始日（当日を含む）。null で指定なしに戻す。省略時は変更しない */
  publishStartDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** タグ（ベーカリー・スーパー 等のフリーテキスト） */
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  websiteUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** 基本宿泊料金ポリシーの作成・更新時のエラー */
export type InternalCreateOrUpdateBaseAccommodationFeePolicyError = {
  __typename: "InternalCreateOrUpdateBaseAccommodationFeePolicyError";
  case: InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase = {
  /** データベースエラー */
  DatabaseError: "DatabaseError",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase =
  (typeof InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase)[keyof typeof InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase];
/** 基本宿泊料金ポリシーの作成・更新の結果 */
export type InternalCreateOrUpdateBaseAccommodationFeePolicyPayload =
  | InternalCreateOrUpdateBaseAccommodationFeePolicyError
  | RawBaseAccommodationFeePolicy;

export type InternalCreateOrUpdateBusinessPlanError = {
  __typename: "InternalCreateOrUpdateBusinessPlanError";
  case: InternalCreateOrUpdateBusinessPlanErrorCase;
  message: Scalars["String"]["output"];
};

/** 法人プランの作成・更新時のエラーの種類 */
export const InternalCreateOrUpdateBusinessPlanErrorCase = {
  /** プラン名が他の法人プランと重複している */
  DuplicatedName: "DuplicatedName",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateBusinessPlanErrorCase =
  (typeof InternalCreateOrUpdateBusinessPlanErrorCase)[keyof typeof InternalCreateOrUpdateBusinessPlanErrorCase];
export type InternalCreateOrUpdateBusinessPlanPayload =
  | BusinessPlan
  | InternalCreateOrUpdateBusinessPlanError;

export type InternalCreateOrUpdateCancelFeePolicyError = {
  __typename: "InternalCreateOrUpdateCancelFeePolicyError";
  case: InternalCreateOrUpdateCancelFeePolicyErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateCancelFeePolicyErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateCancelFeePolicyErrorCase =
  (typeof InternalCreateOrUpdateCancelFeePolicyErrorCase)[keyof typeof InternalCreateOrUpdateCancelFeePolicyErrorCase];
export type InternalCreateOrUpdateCancelFeePolicyPayload =
  | InternalCreateOrUpdateCancelFeePolicyError
  | RawCancelFeePolicy;

export type InternalCreateOrUpdateCoOwnersPlanOfferingError = {
  __typename: "InternalCreateOrUpdateCoOwnersPlanOfferingError";
  case: InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase;
};

export const InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase =
  (typeof InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase)[keyof typeof InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase];
/** CoOwnersPlanOffering の作成・更新時の入力 */
export type InternalCreateOrUpdateCoOwnersPlanOfferingInput = {
  /** 早期アクセスコード */
  earlyAccessCode?: InputMaybe<Scalars["String"]["input"]>;
  /** 見積もり書 */
  estimate?: InputMaybe<UploadedFileInput>;
  /** 非表示かどうか */
  isHidden: Scalars["Boolean"]["input"];
  /** 売り切れかどうか */
  isSoldOut: Scalars["Boolean"]["input"];
  /** オーナープランID */
  ownerPlanId: Scalars["ID"]["input"];
  /** 口数 */
  units: Scalars["Int"]["input"];
};

export type InternalCreateOrUpdateCoOwnersPlanOfferingPayload =
  | CoOwnersPlanOffering
  | InternalCreateOrUpdateCoOwnersPlanOfferingError;

/** Co-Owners 重要事項説明会スケジュールの作成・更新時のエラー */
export type InternalCreateOrUpdateCoOwnersWebinarScheduleError = {
  __typename: "InternalCreateOrUpdateCoOwnersWebinarScheduleError";
  case: InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase;
};

/** エラーの種類 */
export const InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase =
  (typeof InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase)[keyof typeof InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase];
/** Co-Owners 重要事項説明会スケジュールの作成・更新時の入力 */
export type InternalCreateOrUpdateCoOwnersWebinarScheduleInput = {
  /** 説明会の申し込みを受け付けるかどうか */
  isActive: Scalars["Boolean"]["input"];
  /** プランの拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 重説開始日時 */
  startsAt: Scalars["ZonedDateTime"]["input"];
  /** Zoom MTG等のURL */
  url: Scalars["String"]["input"];
};

/** Co-Owners 重要事項説明会スケジュールの作成・更新の結果 */
export type InternalCreateOrUpdateCoOwnersWebinarSchedulePayload =
  | CoOwnersWebinarSchedule
  | InternalCreateOrUpdateCoOwnersWebinarScheduleError;

/** 建築家の作成・更新の入力 */
export type InternalCreateOrUpdateContentArchitectInput = {
  /** プロフィール */
  bio: Scalars["String"]["input"];
  /** 会社名 */
  company: Scalars["String"]["input"];
  /** 写真 */
  image: UploadedFileInput;
  /** 名前（日本語） */
  name: Scalars["String"]["input"];
  /** 名前（英語） */
  nameEn: Scalars["String"]["input"];
};

export type InternalCreateOrUpdateContentArchitectPayload =
  | ContentArchitect
  | InternalArchitectureContentError;

/**
 * 設備コンテンツの作成・更新の入力。
 * 省略したフィールドは変更しない（カード単位で保存するため）
 */
export type InternalCreateOrUpdateContentArchitecturalFeatureInput = {
  /** このコンテンツが説明している設備（全量置き換え）。編集中の設備は外せない */
  accommodationFacilityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 設備の提供状況についての注記。空文字で未設定にする */
  availabilityNote?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 公開ページに出すアメニティ（全量置き換え） */
  facilityAmenityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 公開ページのカルーセル画像（全量置き換え） */
  images?: InputMaybe<Array<UploadedFileInput>>;
  /** 名前。作成時は必須 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用ルールの末尾に出る注記 */
  ruleNoteMarkup?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用ルールの見出し */
  ruleTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 公開ページの URL に入る識別子。作成時のみ使い、更新では無視する
   * （変えると公開済み URL が 404 になるため）
   */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** 建築トップの設備カードに出る画像。null を明示すると未設定に戻す */
  thumbnailImage?: InputMaybe<UploadedFileInput>;
  usageConditionsDescription?: InputMaybe<Scalars["String"]["input"]>;
  usageFeesDescriptionMarkup?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateOrUpdateContentArchitecturalFeaturePayload =
  | ContentArchitecturalFeature
  | InternalArchitectureContentError;

/** 設備コンテンツの利用ルールの作成・更新の入力 */
export type InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput = {
  bodyMarkup: Scalars["String"]["input"];
  /** ルールに添える画像。null で未設定にする */
  image?: InputMaybe<UploadedFileInput>;
  /** 並び順。省略すると末尾に置く */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload =
  | ContentArchitecturalFeatureUsageRule
  | InternalArchitectureContentError;

export type InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput = {
  /** アイコン。未設定の設備が実在するので null を許容する */
  icon?: InputMaybe<UploadedFileInput>;
  /** 設備の名前 */
  name: Scalars["String"]["input"];
  /** 公開ページの表示順。省略すると末尾に置く */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * 建築タイプコンテンツ作成・更新の入力。
 * 全 field 省略可能で、省略した field は更新しない。新規作成時は sort と architectId が必須
 */
export type InternalCreateOrUpdateContentArchitectureTypeInput = {
  /** 設備の操作マニュアル（リンク）。空文字で未設定 */
  amenitiesInstructionsUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 建築家のコメント */
  architectComment?: InputMaybe<Scalars["String"]["input"]>;
  /** 建築家 ID */
  architectId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 基本の設備 ID（全量置き換え） */
  basicAmenityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 最大収容人数（フリーテキスト） */
  capacityDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 概要テキスト */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約完了メールに表示される画像 URL。null で未設定（デフォルト画像にフォールバック） */
  emailCoverImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 備品リスト（リンク）。空文字で未設定 */
  equipmentsListUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 間取り図（Selection Series のみ）。null を明示すると削除 */
  floorPlanImage?: InputMaybe<UploadedFileInput>;
  /** カルーセル画像（全量置き換え） */
  images?: InputMaybe<Array<UploadedFileInput>>;
  /** 広さ（フリーテキスト） */
  sizeDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 広さ（㎡） */
  sizeSqm?: InputMaybe<Scalars["Float"]["input"]>;
  /** 建築ページ一覧での並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** 建築（一覧）ページで表示される画像。null を明示すると未設定に戻す */
  thumbnailImage?: InputMaybe<UploadedFileInput>;
};

export type InternalCreateOrUpdateContentArchitectureTypePayload =
  | ContentArchitectureType
  | InternalArchitectureContentError;

/**
 * バリエーション / オプションの作成・更新の入力。
 * 公開型が全て non-null なので省略は許さず、更新時も全 field を送る
 */
export type InternalCreateOrUpdateContentArchitectureTypeVariantInput = {
  /** このバリエーション / オプションを構成する設備 ID（全量置き換え） */
  accommodationFacilityIds: Array<Scalars["ID"]["input"]>;
  /** ひとこと説明（「サウナ付きのキャビン」など） */
  brief: Scalars["String"]["input"];
  /** 説明 */
  description: Scalars["String"]["input"];
  /** 付帯する設備アメニティ ID（全量置き換え） */
  facilityAmenityIds: Array<Scalars["ID"]["input"]>;
  /** カルーセル画像（全量置き換え） */
  images: Array<UploadedFileInput>;
  /** 名前（「With Sauna」など）。slug はここから自動生成する */
  name: Scalars["String"]["input"];
  /** 利用条件の説明 */
  usageConditionsDescription: Scalars["String"]["input"];
  /** 利用料金の説明（Markup） */
  usageFeesDescriptionMarkup: Scalars["String"]["input"];
};

export type InternalCreateOrUpdateContentArchitectureTypeVariantPayload =
  | ContentArchitectureTypeVariant
  | InternalArchitectureContentError;

export type InternalCreateOrUpdateContentBasicAmenityPayload =
  | ContentArchitectureTypeBasicAmenity
  | InternalArchitectureContentError;

/** 設備アメニティの作成・更新の入力 */
export type InternalCreateOrUpdateContentFacilityAmenityInput = {
  /** 属する設備（「バレルサウナ」なら Sauna） */
  accommodationFacilityId: Scalars["ID"]["input"];
  /** 説明（Markup） */
  descriptionMarkup: Scalars["String"]["input"];
  /** 名前（「バレルサウナ」など） */
  name: Scalars["String"]["input"];
};

export type InternalCreateOrUpdateContentFacilityAmenityPayload =
  | ContentArchitectureTypeVariantFacilityAmenity
  | InternalArchitectureContentError;

/** 付帯サービス料金ポリシー入力 */
export type InternalCreateOrUpdateFacilityBaseFeePolicyInput = {
  /**
   * リソース識別子（resource.identifierと紐づけ）
   * nullの場合はfacility全体のデフォルト料金
   */
  resourceIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** 何単位目までの累計料金か（1-indexed）。unit:1がデフォルト単価 */
  unit: Scalars["Int"]["input"];
  /** 累計料金（unit:1の場合は1単位あたりの料金） */
  unitFeeAmount: Scalars["Decimal"]["input"];
};

/** 付帯サービスキャンセル料ポリシー入力 */
export type InternalCreateOrUpdateFacilityCancelFeePolicyInput = {
  /** 適用開始日（開始日の何日前） */
  deadlineDaysBefore: Scalars["Int"]["input"];
  /** 適用開始時刻 */
  deadlineHour: Scalars["Int"]["input"];
  /** キャンセル料タイプ（Value: 固定金額, Percentage: キャンセル料率） */
  feeModifierType: FeeModifierType;
  /** キャンセル料値（Percentageの場合はキャンセル料率0-100, Valueの場合は固定キャンセル料・円） */
  feeValue: Scalars["Decimal"]["input"];
  /**
   * リソース識別子（resource.identifierと紐づけ）
   * nullの場合はfacility全体のデフォルトキャンセル料ポリシー
   */
  resourceIdentifier?: InputMaybe<Scalars["String"]["input"]>;
};

/** 付帯サービスコントローラー入力 */
export type InternalCreateOrUpdateFacilityControllerInput = {
  attribute?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  type: FacilityResourceControllerType;
};

export type InternalCreateOrUpdateFacilityError = {
  __typename: "InternalCreateOrUpdateFacilityError";
  case: InternalCreateOrUpdateFacilityErrorCase;
};

export const InternalCreateOrUpdateFacilityErrorCase = {
  CustomInvoiceLabelRequiresReserveEnabled:
    "CustomInvoiceLabelRequiresReserveEnabled",
  FacilityNotFound: "FacilityNotFound",
  InvalidControllerAttribute: "InvalidControllerAttribute",
  InvalidCustomInvoiceLabel: "InvalidCustomInvoiceLabel",
  SiteNotFound: "SiteNotFound",
} as const;

export type InternalCreateOrUpdateFacilityErrorCase =
  (typeof InternalCreateOrUpdateFacilityErrorCase)[keyof typeof InternalCreateOrUpdateFacilityErrorCase];
export type InternalCreateOrUpdateFacilityPayload =
  | InternalCreateOrUpdateFacilityError
  | Success;

export type InternalCreateOrUpdateFacilityResourceBlockError = {
  __typename: "InternalCreateOrUpdateFacilityResourceBlockError";
  case: InternalCreateOrUpdateFacilityResourceBlockErrorCase;
};

export const InternalCreateOrUpdateFacilityResourceBlockErrorCase = {
  BlockNotFound: "BlockNotFound",
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateFacilityResourceBlockErrorCase =
  (typeof InternalCreateOrUpdateFacilityResourceBlockErrorCase)[keyof typeof InternalCreateOrUpdateFacilityResourceBlockErrorCase];
/** 付帯サービスリソースブロック作成・更新入力 */
export type InternalCreateOrUpdateFacilityResourceBlockInput = {
  /** 終了日時 */
  endAt: Scalars["PlainDateTime"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /** 理由 */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  /** リソースID */
  resourceId: Scalars["ID"]["input"];
  /** 開始日時 */
  startAt: Scalars["PlainDateTime"]["input"];
};

export type InternalCreateOrUpdateFacilityResourceBlockPayload =
  | InternalCreateOrUpdateFacilityResourceBlockError
  | Success;

/** 付帯サービスリソース入力 */
export type InternalCreateOrUpdateFacilityResourceInput = {
  /** コントローラー設定 */
  controllers?: InputMaybe<
    Array<InternalCreateOrUpdateFacilityControllerInput>
  >;
  /** 請求明細ラベルのパーツ（並び順どおりに半角スペースで連結する）。予約受付が有効な施設でのみ設定できる。更新時は未指定なら変更せず、null で解除する */
  customInvoiceLabel?: InputMaybe<Array<FacilityInvoiceLabelPartInput>>;
  /** 識別子（車両番号、設備番号など） */
  identifier: Scalars["String"]["input"];
  /** リソース名 */
  name: Scalars["String"]["input"];
};

/** 付帯サービススロット入力 */
export type InternalCreateOrUpdateFacilitySlotInput = {
  /** 終了時刻（時） */
  endHour: Scalars["Int"]["input"];
  /** 終了時刻（分） */
  endMinute?: InputMaybe<Scalars["Int"]["input"]>;
  /** リソース識別子（resource.identifierと紐づけ） */
  resourceIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** 開始時刻（時） */
  startHour: Scalars["Int"]["input"];
  /** 開始時刻（分） */
  startMinute?: InputMaybe<Scalars["Int"]["input"]>;
};

/** ネイティブアプリのホームコンテンツ作成・更新時のエラー */
export type InternalCreateOrUpdateNativeAppHomeContentError = {
  __typename: "InternalCreateOrUpdateNativeAppHomeContentError";
  case: InternalCreateOrUpdateNativeAppHomeContentErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateNativeAppHomeContentErrorCase = {
  /** データベースエラー */
  DatabaseError: "DatabaseError",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  NotFound: "NotFound",
  /** 並行更新により楽観ロックが競合した（再読み込みして再試行） */
  OptimisticLockConflict: "OptimisticLockConflict",
} as const;

export type InternalCreateOrUpdateNativeAppHomeContentErrorCase =
  (typeof InternalCreateOrUpdateNativeAppHomeContentErrorCase)[keyof typeof InternalCreateOrUpdateNativeAppHomeContentErrorCase];
/**
 * ネイティブアプリのホームコンテンツ作成・更新の結果。
 * 成功時は保存後のエンティティを返す（Apollo cache の自動更新のため）
 */
export type InternalCreateOrUpdateNativeAppHomeContentPayload =
  | InternalCreateOrUpdateNativeAppHomeContentError
  | InternalNativeAppHomeContent;

/** お知らせの作成・更新時のエラー */
export type InternalCreateOrUpdateNewsError = {
  __typename: "InternalCreateOrUpdateNewsError";
  case: InternalCreateOrUpdateNewsErrorCase;
};

export const InternalCreateOrUpdateNewsErrorCase = {
  /** HTML の場合は content が必須 */
  ContentIsRequiredForHtml: "ContentIsRequiredForHTML",
  /** InternalPage は使用しない */
  InternalPageIsNoLongerUsed: "InternalPageIsNoLongerUsed",
  /** ExternalLink の場合は URL が必須 */
  UrlIsRequiredForExternalLink: "UrlIsRequiredForExternalLink",
} as const;

export type InternalCreateOrUpdateNewsErrorCase =
  (typeof InternalCreateOrUpdateNewsErrorCase)[keyof typeof InternalCreateOrUpdateNewsErrorCase];
/** お知らせの作成・更新時の入力 */
export type InternalCreateOrUpdateNewsInput = {
  /** コンテンツ（contentType が HTML の場合にはコンテンツ、ExternalLink の場合は URL を入力。） */
  content: Scalars["String"]["input"];
  /** コンテンツの種類 */
  contentType: NewsContentType;
  /** カテゴリ */
  displayCategory: NewsDisplayCategory;
  /** 公開日時 */
  publishedAt: Scalars["ZonedDateTime"]["input"];
  /** ステータス */
  status: NewsStatus;
  /** どのプランに対して表示するか */
  targetPlans: Array<TargetPlanType>;
  /** タイトル */
  title: Scalars["String"]["input"];
};

/** お知らせの作成・更新の結果 */
export type InternalCreateOrUpdateNewsPayload =
  | InternalCreateOrUpdateNewsError
  | News;

export type InternalCreateOrUpdateOrganizationError = {
  __typename: "InternalCreateOrUpdateOrganizationError";
  case: InternalCreateOrUpdateOrganizationErrorCase;
  message: Scalars["String"]["output"];
};

/** 法人の作成・更新時のエラーの種類 */
export const InternalCreateOrUpdateOrganizationErrorCase = {
  /** 指定した SANU 担当者のユーザーが存在しない */
  AssignedUserNotFound: "AssignedUserNotFound",
  /** 組織コードが他の法人と重複している */
  DuplicatedInvitationCode: "DuplicatedInvitationCode",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateOrganizationErrorCase =
  (typeof InternalCreateOrUpdateOrganizationErrorCase)[keyof typeof InternalCreateOrUpdateOrganizationErrorCase];
export type InternalCreateOrUpdateOrganizationPayload =
  | InternalCreateOrUpdateOrganizationError
  | Organization;

export type InternalCreateOrUpdateOrganizationYearlyContractError = {
  __typename: "InternalCreateOrUpdateOrganizationYearlyContractError";
  message: Scalars["String"]["output"];
};

export type InternalCreateOrUpdateOrganizationYearlyContractInvoiceError = {
  __typename: "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError";
  case: InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase;
};

export const InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase =
  {
    /** カード自動決済の請求書を作ろうとしたが、カードが登録されていない */
    CardIsNotRegistered: "CardIsNotRegistered",
    /** 新規作成時にcontractIdが指定されていない */
    ContractIdRequired: "ContractIdRequired",
    /** 無効化済みの契約に対して請求書を作成しようとした */
    ContractIsInvalidated: "ContractIsInvalidated",
    /** Stripe顧客にメールアドレスが登録されていない（銀行振込の場合に必要） */
    CustomerEmailRequired: "CustomerEmailRequired",
    /** 銀行振込の支払期限（対象年月の2ヶ月後の月末）が既に過ぎている */
    DueDateIsInPast: "DueDateIsInPast",
    /** draft状態でない請求書は更新できない */
    InvoiceIsNotDraft: "InvoiceIsNotDraft",
    /** 必須フィールドが不足 */
    MissingRequiredFields: "MissingRequiredFields",
    /** 公開予定日が指定できる範囲（対象月の前月1日〜対象月末）の外 */
    ScheduledOpenDateOutOfRange: "ScheduledOpenDateOutOfRange",
    /** 月払いの対象年月が契約期間外 */
    YearMonthOutOfContractPeriod: "YearMonthOutOfContractPeriod",
  } as const;

export type InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase =
  (typeof InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase)[keyof typeof InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase];
export type InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload =
  | InternalCreateOrUpdateOrganizationYearlyContractInvoiceError
  | Success;

export type InternalCreateOrUpdateOrganizationYearlyContractPayload =
  | InternalCreateOrUpdateOrganizationYearlyContractError
  | OrganizationYearlyContract;

/** OwnerPlan の作成・更新時のエラー */
export type InternalCreateOrUpdateOwnerPlanError = {
  __typename: "InternalCreateOrUpdateOwnerPlanError";
  case: InternalCreateOrUpdateOwnerPlanErrorCase;
};

/** エラーの種類 */
export const InternalCreateOrUpdateOwnerPlanErrorCase = {
  /** 部屋が見つからない */
  AccommodationNotFound: "AccommodationNotFound",
  /** FullOwner の場合部屋が必要 */
  AccommodationRequiredForFullOwner: "AccommodationRequiredForFullOwner",
  /** 建築タイプが見つからない */
  ArchitectureTypeNotFound: "ArchitectureTypeNotFound",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** 所有対象（拠点・建築タイプ）に対応する運用グループの設定が登録されていない */
  OperationGroupSettingNotFound: "OperationGroupSettingNotFound",
  /** オーナープランが見つからない */
  OwnerPlanNotFound: "OwnerPlanNotFound",
  /** Co-Owners の場合拠点と建築タイプが必要 */
  SiteAndArchitectureTypeRequiedForCoOwners:
    "SiteAndArchitectureTypeRequiedForCoOwners",
  /** 拠点が見つからない */
  SiteNotFound: "SiteNotFound",
} as const;

export type InternalCreateOrUpdateOwnerPlanErrorCase =
  (typeof InternalCreateOrUpdateOwnerPlanErrorCase)[keyof typeof InternalCreateOrUpdateOwnerPlanErrorCase];
/** OwnerPlan の作成・更新時の入力 */
export type InternalCreateOrUpdateOwnerPlanInput = {
  /** 宿泊施設の設備ID */
  accommodationFacilityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 部屋ID (FullOwnerの部屋所有の場合) */
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 建築タイプID(Co-OwnersとFullOwnerの部屋所有の場合、FullOwnerの拠点所有=拠点投資家の場合は null) */
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  /** バルコニー面積 */
  balconySizeSqm: Scalars["Float"]["input"];
  /** 基本料金 */
  baseAccommodationFeePerNight: Scalars["Int"]["input"];
  /**
   * ドッグ棟フィルター (CoOwnersの場合)
   * accommodationFacilityIdsにDogFriendlyが含まれる場合は自動でIncludeになる
   */
  dogFriendlyFilter?: InputMaybe<AccommodationFacilityFilterType>;
  /** 権利形態 */
  formOfRights: Scalars["String"]["input"];
  /** 客室面積 */
  guestRoomSizeSqm: Scalars["Float"]["input"];
  /** 引き渡し開始予定年月 */
  handoverStartDate?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
  /** 借地対象面積 */
  leasedLandSizeSqm: Scalars["Float"]["input"];
  /** 繁忙日の制限有無 (CoOwners のみ) */
  limitPeakDays: Scalars["Boolean"]["input"];
  /** 管理名 */
  managedName?: InputMaybe<Scalars["String"]["input"]>;
  /** 他拠点利用基本料金 */
  nonOwnedBaseAccommodationFeePerNight: Scalars["Int"]["input"];
  /**
   * 繁忙日数上限の算出割合。CoOwners かつ limitPeakDays=true のとき必須、それ以外は null。
   * mutation は floor(unitNightsPerYear × この割合) を 1 口あたりの上限として保存する。
   */
  peakDaysRatio?: InputMaybe<CoOwnerPeakDaysRatio>;
  /** 1口あたりの登録料（本来は`unit`prefixがついているべき） */
  registrationFee: Scalars["Int"]["input"];
  /** 登録料先行支払期限 */
  registrationFeeAdvancePaymentDeadline?: InputMaybe<
    Scalars["PlainDate"]["input"]
  >;
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 敷地面積 */
  siteSizeSqm: Scalars["Float"]["input"];
  /** 口数 */
  totalUnits: Scalars["Int"]["input"];
  /** プランタイプ (CoOwners または FullOwner) */
  type: OwnerPlanType;
  /** 1口に相当する火災保険料、1口あたりのに変更する */
  unitAnnualFireInsuranceFee: Scalars["Int"]["input"];
  /** 1口に相当する借地料 */
  unitAnnualLandRentFee: Scalars["Int"]["input"];
  /** 1口に相当する年間管理費 */
  unitAnnualMaintenanceFee: Scalars["Int"]["input"];
  /** 1口に相当する温泉基本料金・更新料 */
  unitAnnualOnsenFee: Scalars["Int"]["input"];
  /** 1口に相当する建物固定資産税 */
  unitAnnualPropertyTax: Scalars["Int"]["input"];
  /** 1口に相当する修繕積立金 */
  unitAnnualRepairReserve: Scalars["Int"]["input"];
  /** 1口に相当する申込金 */
  unitApplicationFee: Scalars["Int"]["input"];
  /** 1口に相当する建物費 */
  unitBuildingFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** 1口に相当する年間の泊数 */
  unitNightsPerYear: Scalars["Int"]["input"];
  /** 1口に相当する購入金額 */
  unitPurchaseAmount: Scalars["Int"]["input"];
};

/** OwnerPlan の作成・更新の結果 */
export type InternalCreateOrUpdateOwnerPlanPayload =
  | InternalCreateOrUpdateOwnerPlanError
  | OwnerPlan;

/** 拠点アクセスルートグループ作成・更新の入力 */
export type InternalCreateOrUpdateSiteAccessRouteGroupInput = {
  /**
   * 地点リスト（始点→経由→終点の順）。
   * Mutation 毎に全置換する。
   */
  points: Array<InternalSiteAccessRoutePointInput>;
  /** 拠点ID（新規作成時に必要） */
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** グループ見出し（例: "公共交通機関でお越しの方"） */
  title: Scalars["String"]["input"];
  /** グループ見出し脇のアイコン */
  transportIcon: AccessRouteTransportIcon;
};

export type InternalCreateOrUpdateSiteActivityProgramError = {
  __typename: "InternalCreateOrUpdateSiteActivityProgramError";
  case: InternalCreateOrUpdateSiteActivityProgramErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateSiteActivityProgramErrorCase = {
  ActivityProgramNotFound: "ActivityProgramNotFound",
  InvalidExternalUrl: "InvalidExternalUrl",
  InvalidPublicationPeriod: "InvalidPublicationPeriod",
  SiteNotFound: "SiteNotFound",
  TitleRequired: "TitleRequired",
} as const;

export type InternalCreateOrUpdateSiteActivityProgramErrorCase =
  (typeof InternalCreateOrUpdateSiteActivityProgramErrorCase)[keyof typeof InternalCreateOrUpdateSiteActivityProgramErrorCase];
export type InternalCreateOrUpdateSiteActivityProgramPayload =
  | InternalCreateOrUpdateSiteActivityProgramError
  | SiteActivityProgram;

export type InternalCreateOrUpdateSiteFaqError = {
  __typename: "InternalCreateOrUpdateSiteFaqError";
  case: InternalCreateOrUpdateSiteFaqErrorCase;
};

export const InternalCreateOrUpdateSiteFaqErrorCase = {
  /** 回答が空 */
  AnswerIsEmpty: "AnswerIsEmpty",
  /** 質問が空 */
  QuestionIsEmpty: "QuestionIsEmpty",
} as const;

export type InternalCreateOrUpdateSiteFaqErrorCase =
  (typeof InternalCreateOrUpdateSiteFaqErrorCase)[keyof typeof InternalCreateOrUpdateSiteFaqErrorCase];
/** 拠点FAQの作成・更新時の入力 */
export type InternalCreateOrUpdateSiteFaqInput = {
  /** 回答 (HTML) */
  answer: Scalars["String"]["input"];
  /** 案内画像URL（チェックイン当日メール・拠点ページ・nativeappチェックインシートに表示） */
  guidanceImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 質問 */
  question: Scalars["String"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InternalCreateOrUpdateSiteFaqPayload =
  | InternalCreateOrUpdateSiteFaqError
  | RawSiteFaq;

/** 拠点画像の更新時の入力 */
export type InternalCreateOrUpdateSiteImagesInput = {
  /** 画像のURLリスト（並び順を保持） */
  images: Array<UploadedFileInput>;
};

/** 社内スタッフグループ作成・更新時のエラー */
export type InternalCreateOrUpdateStaffGroupError = {
  __typename: "InternalCreateOrUpdateStaffGroupError";
  case: InternalCreateOrUpdateStaffGroupErrorCase;
  message: Scalars["String"]["output"];
};

/** 社内スタッフグループ作成・更新時のエラーの種類 */
export const InternalCreateOrUpdateStaffGroupErrorCase = {
  /** SmartHR ID が他のグループと重複している */
  DuplicatedSmarthrId: "DuplicatedSmarthrId",
  /** 更新対象のグループが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalCreateOrUpdateStaffGroupErrorCase =
  (typeof InternalCreateOrUpdateStaffGroupErrorCase)[keyof typeof InternalCreateOrUpdateStaffGroupErrorCase];
/** 社内スタッフグループ作成・更新の結果 */
export type InternalCreateOrUpdateStaffGroupPayload =
  | InternalCreateOrUpdateStaffGroupError
  | StaffGroup;

/** 宿泊チケットマスターの作成・更新時のエラー */
export type InternalCreateOrUpdateStayTicketMasterError = {
  __typename: "InternalCreateOrUpdateStayTicketMasterError";
  case: InternalCreateOrUpdateStayTicketMasterErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateStayTicketMasterErrorCase = {
  /** 不正な入力 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateStayTicketMasterErrorCase =
  (typeof InternalCreateOrUpdateStayTicketMasterErrorCase)[keyof typeof InternalCreateOrUpdateStayTicketMasterErrorCase];
/** 宿泊チケットマスターの作成・更新時の入力 */
export type InternalCreateOrUpdateStayTicketMasterInput = {
  /** 3人目以降の追加ゲスト料金ポリシーID（任意） */
  additionalGuestFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  additionalNoticeTypes: Array<AdditionalNoticeType>;
  availableAccommodationFacilityIds: Array<Scalars["ID"]["input"]>;
  availableArchitectureTypeIds: Array<Scalars["ID"]["input"]>;
  availableSiteIds: Array<Scalars["ID"]["input"]>;
  baseAccommodationFeeMode: BaseAccommodationFeeMode;
  baseAccommodationFeePolicyId: Scalars["ID"]["input"];
  cancelFeePolicyId: Scalars["ID"]["input"];
  includeSeasonalFee: Scalars["Boolean"]["input"];
  internalDescription: Scalars["String"]["input"];
  /** アーカイブ済みかどうか */
  isArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  isBulkUsage: Scalars["Boolean"]["input"];
  lookupKey?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  notice: Scalars["String"]["input"];
  occupancyLimitTarget: OccupancyLimitTarget;
  /** 管理部署ID（SmartHR組織図の末端グループ） */
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 使用したテンプレートID（任意） */
  templateId?: InputMaybe<Scalars["ID"]["input"]>;
  /** チケット区分 */
  ticketCategory?: InputMaybe<TicketCategory>;
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["input"];
  waiveCleaningFee: Scalars["Boolean"]["input"];
  waiveConsumedSuppliesFee: Scalars["Boolean"]["input"];
  waiveDogFee: Scalars["Boolean"]["input"];
  waiveDogRunFee: Scalars["Boolean"]["input"];
  waiveEvChargerFee: Scalars["Boolean"]["input"];
  waiveOnsenFee: Scalars["Boolean"]["input"];
  waivePeakDayFee: Scalars["Boolean"]["input"];
  waiveSaunaFee: Scalars["Boolean"]["input"];
  waiveSiteAdditionalFee: Scalars["Boolean"]["input"];
};

/** 宿泊チケットマスターの作成・更新の結果 */
export type InternalCreateOrUpdateStayTicketMasterPayload =
  | InternalCreateOrUpdateStayTicketMasterError
  | StayTicketMaster;

/** チケットマスター雛形の作成・更新時のエラー */
export type InternalCreateOrUpdateStayTicketMasterTemplateError = {
  __typename: "InternalCreateOrUpdateStayTicketMasterTemplateError";
  case: InternalCreateOrUpdateStayTicketMasterTemplateErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateStayTicketMasterTemplateErrorCase = {
  /** 不正な入力 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateStayTicketMasterTemplateErrorCase =
  (typeof InternalCreateOrUpdateStayTicketMasterTemplateErrorCase)[keyof typeof InternalCreateOrUpdateStayTicketMasterTemplateErrorCase];
/** チケットマスター雛形の作成・更新の入力 */
export type InternalCreateOrUpdateStayTicketMasterTemplateInput = {
  /** 3人目以降の追加ゲスト料金ポリシーID（任意） */
  additionalGuestFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 利用可能な施設タイプID */
  availableAccommodationFacilityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 利用可能な建築タイプID */
  availableArchitectureTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 利用可能な拠点ID */
  availableSiteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 基本料金モード */
  baseAccommodationFeeMode?: InputMaybe<BaseAccommodationFeeMode>;
  /** 基本宿泊料金ポリシーID */
  baseAccommodationFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** キャンセル料金ポリシーID */
  cancelFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** シーズン料金の追加有無 */
  includeSeasonalFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 管理用説明 */
  internalDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 一括利用かどうか */
  isBulkUsage?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 表示名 */
  name: Scalars["String"]["input"];
  /** 稼働制御の対象 */
  occupancyLimitTarget?: InputMaybe<OccupancyLimitTarget>;
  /** 一意識別子 */
  slug: Scalars["String"]["input"];
  /** 施設追加料金の請求をしないかどうか */
  waiveArchitectureTypeAdditionalFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** dog料金の請求をしないかどうか */
  waiveDogFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ドッグラン料金の請求をしないかどうか */
  waiveDogRunFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 繁忙日料金の請求をしないかどうか */
  waivePeakDayFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 拠点別ハイシーズン料金の請求をしないかどうか */
  waiveSiteAdditionalFee?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** チケットマスター雛形の作成・更新の結果 */
export type InternalCreateOrUpdateStayTicketMasterTemplatePayload =
  | InternalCreateOrUpdateStayTicketMasterTemplateError
  | StayTicketMasterTemplate;

/** StayTicketTemplateの作成・更新時のエラー */
export type InternalCreateOrUpdateStayTicketTemplateError = {
  __typename: "InternalCreateOrUpdateStayTicketTemplateError";
  message: Scalars["String"]["output"];
};

/** StayTicketTemplate の作成・更新時の入力 */
export type InternalCreateOrUpdateStayTicketTemplateInput = {
  /** rawExpiresAtを現在から何日後に設定するか */
  daysUntilExpiration?: InputMaybe<Scalars["Int"]["input"]>;
  /** rawStayEndNightを現在から何日後に設定するか */
  daysUntilLastStay?: InputMaybe<Scalars["Int"]["input"]>;
  /** チケット発行機能の有効／無効を設定する */
  isActive: Scalars["Boolean"]["input"];
  /** stayTicketMasterが同じでも異なる設定を入れる可能性があるので、lookupKeyで設定管理を行う */
  lookupKey: Scalars["String"]["input"];
  /** 予約期限を固定で設定する場合に使用 */
  rawExpiresAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 宿泊可能終了日を固定で設定する場合に使用 */
  rawStayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 宿泊可能開始日を固定で設定する場合に使用 */
  rawStayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 宿泊チケットマスターのID */
  stayTicketMasterId: Scalars["ID"]["input"];
};

export type InternalCreateOrUpdateSupplyItemInstallationInput = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  defaultQuantity: Scalars["Int"]["input"];
  /** 既存の設置情報ID（省略時は新規作成） */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  siteId: Scalars["ID"]["input"];
};

export type InternalCreateOrUpdateSupplyItemInstallationsError = {
  __typename: "InternalCreateOrUpdateSupplyItemInstallationsError";
  case: InternalCreateOrUpdateSupplyItemInstallationsErrorCase;
};

export const InternalCreateOrUpdateSupplyItemInstallationsErrorCase = {
  DuplicateInstallation: "DuplicateInstallation",
  InstallationNotFound: "InstallationNotFound",
  InvalidInstallationReference: "InvalidInstallationReference",
  SiteNotFound: "SiteNotFound",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type InternalCreateOrUpdateSupplyItemInstallationsErrorCase =
  (typeof InternalCreateOrUpdateSupplyItemInstallationsErrorCase)[keyof typeof InternalCreateOrUpdateSupplyItemInstallationsErrorCase];
export type InternalCreateOrUpdateSupplyItemInstallationsPayload =
  | InternalCreateOrUpdateSupplyItemInstallationsError
  | Success;

export type InternalCreateOrUpdateSupplyItemMasterError = {
  __typename: "InternalCreateOrUpdateSupplyItemMasterError";
  case: InternalCreateOrUpdateSupplyItemMasterErrorCase;
};

export const InternalCreateOrUpdateSupplyItemMasterErrorCase = {
  RequiredFieldMissing: "RequiredFieldMissing",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
} as const;

export type InternalCreateOrUpdateSupplyItemMasterErrorCase =
  (typeof InternalCreateOrUpdateSupplyItemMasterErrorCase)[keyof typeof InternalCreateOrUpdateSupplyItemMasterErrorCase];
/**
 * 新規作成時は unit / isEnabled 以外が必須（isEnabled の既定は true）。
 * 更新時は指定したフィールドだけを更新し、省略したフィールドは現在値を保つ。
 */
export type InternalCreateOrUpdateSupplyItemMasterInput = {
  category?: InputMaybe<SupplyItemMasterCategory>;
  /** マスタID（省略時は新規作成） */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  namePrivate?: InputMaybe<Scalars["String"]["input"]>;
  namePublic?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  taxRateType?: InputMaybe<ConsumptionTaxRateType>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateOrUpdateSupplyItemMasterPayload =
  | InternalCreateOrUpdateSupplyItemMasterError
  | SupplyItemMaster;

export type InternalCreateOtaRoomUnitInput = {
  /** 宿泊施設ID */
  accommodationId: Scalars["ID"]["input"];
  /** ユニット番号 */
  unit: Scalars["Int"]["input"];
};

export type InternalCreateRoomTypeImageUploadPolicyInput = {
  /** 部屋タイプID */
  roomTypeId: Scalars["ID"]["input"];
};

export type InternalCreateRoomTypeInput = {
  /** ルームタイプ名（例：SANU CABIN BEE｜シンプル客室） */
  name: Scalars["String"]["input"];
};

export type InternalCreateSiteActivityProgramInput = {
  /** 外部の詳細・予約ページ URL（https のみ） */
  externalUrl: Scalars["String"]["input"];
  image: UploadedFileInput;
  localizedDescription?: InputMaybe<InternalLocalizedStringInput>;
  localizedTitle: InternalLocalizedStringInput;
  /** 掲載終了日時。省略すると無期限 */
  publishEndAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載開始日時。省略すると登録した時点から掲載する */
  publishStartAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載する拠点 ID 一覧（1 件以上） */
  siteIds: Array<Scalars["ID"]["input"]>;
};

/** 拠点作成時のエラー */
export type InternalCreateSiteError = {
  __typename: "InternalCreateSiteError";
  case: InternalCreateSiteErrorCase;
  message: Scalars["String"]["output"];
};

/** 拠点作成時のエラー種別 */
export const InternalCreateSiteErrorCase = {
  /** 指定した RemoteLOCK Location ID が RemoteLOCK に存在しない */
  RemoteLockLocationNotFound: "RemoteLockLocationNotFound",
  /** ページを公開していない状態で予約を受け付けようとした */
  SiteNotPublished: "SiteNotPublished",
} as const;

export type InternalCreateSiteErrorCase =
  (typeof InternalCreateSiteErrorCase)[keyof typeof InternalCreateSiteErrorCase];
/** 拠点FAQ画像アップロードポリシーの入力 */
export type InternalCreateSiteFaqImageUploadPolicyInput = {
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
};

/** 拠点ハイシーズン期間の作成入力 */
export type InternalCreateSiteHighSeasonPeriodInput = {
  /** 2027 年度以降の拠点追加料金 */
  additionalFeeAmount: Scalars["Int"]["input"];
  /** 終了日（1-31） */
  endDay: Scalars["Int"]["input"];
  /** 終了月（1-12） */
  endMonth: Scalars["Int"]["input"];
  /** ラベル */
  label: Scalars["String"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 開始日（1-31） */
  startDay: Scalars["Int"]["input"];
  /** 開始月（1-12） */
  startMonth: Scalars["Int"]["input"];
};

/** 拠点画像アップロードポリシーの入力 */
export type InternalCreateSiteImageUploadPolicyInput = {
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
};

/** 拠点作成の入力 */
export type InternalCreateSiteInput = {
  /** チェックイン認証タイプ */
  checkInAuthenticationType?: InputMaybe<CheckInAuthenticationType>;
  /** カスタム予約リード月数（未設定の場合はデフォルトの3ヶ月） */
  customReservationLeadMonths?: InputMaybe<Scalars["Int"]["input"]>;
  /** 早期チェックイン可能かどうか */
  earlyCheckInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 多言語化された拠点名。全 locale 必須。 */
  localizedName: InternalLocalizedStringInput;
  /** 拠点名（例：一宮 1st）。旧フィールドで analytics 等で参照されている。 */
  name: Scalars["String"]["input"];
  /** 開業日 */
  openingDate: Scalars["PlainDate"]["input"];
  /** 拠点番号（例：1st, 2nd） */
  ordinalName?: InputMaybe<Scalars["String"]["input"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** RemoteLOCK の Location ID。拠点管理者キーの AccessPerson に紐づける。存在しない ID は保存時に拒否される */
  remoteLockLocationId?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約可能かどうか */
  reservable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** オーナー先行予約可能かどうか */
  reservableForOwnerEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** スラッグ（URLに使用、英小文字・数字・ハイフンのみ） */
  slug: Scalars["String"]["input"];
  /** SwitchBot の拠点 API キー。スマートプラグの稼働状況取得に使う */
  switchbotLocationApiKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** 拠点作成の結果 */
export type InternalCreateSitePayload = InternalCreateSiteError | InternalSite;

/** StayTicketTemplateの作成・更新の結果 */
export type InternalCreateStayTicketTemplatePayload =
  | InternalCreateOrUpdateStayTicketTemplateError
  | StayTicketTemplate;

export type InternalCreateTermsRevisionError = {
  __typename: "InternalCreateTermsRevisionError";
  case: InternalCreateTermsRevisionErrorCase;
};

export const InternalCreateTermsRevisionErrorCase = {
  /** 同じ改定日・対象の改定が既にある */
  AlreadyExists: "AlreadyExists",
  /** 入力値が不正（過去の改定日、対象を指定できない規約、個別規約を持つ OwnerPlan など） */
  InvalidInput: "InvalidInput",
  /** 規約または OwnerPlan が見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateTermsRevisionErrorCase =
  (typeof InternalCreateTermsRevisionErrorCase)[keyof typeof InternalCreateTermsRevisionErrorCase];
export type InternalCreateTermsRevisionInput = {
  /** 社内向けの改定内容の要約 */
  internalSummary: Scalars["String"]["input"];
  revisedDate: Scalars["PlainDate"]["input"];
  /** null は規約の適用者全員。FullOwnerPlan の共通規約でのみ指定できる */
  targetOwnerPlanId?: InputMaybe<Scalars["ID"]["input"]>;
  termsId: Scalars["ID"]["input"];
};

export type InternalCreateTermsRevisionPayload =
  | InternalCreateTermsRevisionError
  | Terms;

export type InternalDeleteAccommodationEquipmentPayload =
  | InternalAccommodationEquipmentError
  | InternalDeleteAccommodationEquipmentSuccess;

export type InternalDeleteAccommodationEquipmentSuccess = {
  __typename: "InternalDeleteAccommodationEquipmentSuccess";
  id: Scalars["ID"]["output"];
};

export type InternalDeleteArchitectureContentPayload =
  | InternalArchitectureContentError
  | Success;

export type InternalDeleteFacilityResourceBlockError = {
  __typename: "InternalDeleteFacilityResourceBlockError";
  case: InternalDeleteFacilityResourceBlockErrorCase;
};

export const InternalDeleteFacilityResourceBlockErrorCase = {
  BlockNotFound: "BlockNotFound",
  CannotDeleteUserBlock: "CannotDeleteUserBlock",
} as const;

export type InternalDeleteFacilityResourceBlockErrorCase =
  (typeof InternalDeleteFacilityResourceBlockErrorCase)[keyof typeof InternalDeleteFacilityResourceBlockErrorCase];
export type InternalDeleteFacilityResourceBlockPayload =
  | InternalDeleteFacilityResourceBlockError
  | Success;

export type InternalDeleteLocalTaxPolicyError = {
  __typename: "InternalDeleteLocalTaxPolicyError";
  case: InternalDeleteLocalTaxPolicyErrorCase;
};

export const InternalDeleteLocalTaxPolicyErrorCase = {
  /** 拠点・部屋に適用されている */
  LinkedToSiteOrAccommodation: "LinkedToSiteOrAccommodation",
} as const;

export type InternalDeleteLocalTaxPolicyErrorCase =
  (typeof InternalDeleteLocalTaxPolicyErrorCase)[keyof typeof InternalDeleteLocalTaxPolicyErrorCase];
export type InternalDeleteLocalTaxPolicyPayload =
  | InternalDeleteLocalTaxPolicyError
  | Success;

export type InternalDeleteSupplyItemInstallationError = {
  __typename: "InternalDeleteSupplyItemInstallationError";
  case: InternalDeleteSupplyItemInstallationErrorCase;
};

export const InternalDeleteSupplyItemInstallationErrorCase = {
  InstallationNotFound: "InstallationNotFound",
} as const;

export type InternalDeleteSupplyItemInstallationErrorCase =
  (typeof InternalDeleteSupplyItemInstallationErrorCase)[keyof typeof InternalDeleteSupplyItemInstallationErrorCase];
export type InternalDeleteSupplyItemInstallationPayload =
  | InternalDeleteSupplyItemInstallationError
  | Success;

export type InternalDeleteSupplyItemMasterError = {
  __typename: "InternalDeleteSupplyItemMasterError";
  case: InternalDeleteSupplyItemMasterErrorCase;
};

export const InternalDeleteSupplyItemMasterErrorCase = {
  HasActiveInstallations: "HasActiveInstallations",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
} as const;

export type InternalDeleteSupplyItemMasterErrorCase =
  (typeof InternalDeleteSupplyItemMasterErrorCase)[keyof typeof InternalDeleteSupplyItemMasterErrorCase];
export type InternalDeleteSupplyItemMasterPayload =
  | InternalDeleteSupplyItemMasterError
  | Success;

/** リソースのコントローラ */
export type InternalFacilityController = {
  __typename: "InternalFacilityController";
  attribute?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  type: FacilityResourceControllerType;
};

/** 管理者が付帯サービス予約に適用する割引 */
export type InternalFacilityReservationDiscountInput = {
  /** 割引タイプ（Value: 固定金額, Percentage: 割引率） */
  discountModifierType: FeeModifierType;
  /** 割引値（Percentageの場合は割引率%（1〜100）, Valueの場合は割引額・円。いずれも 1 以上） */
  discountValue: Scalars["Int"]["input"];
  /** 割引理由。FacilityReservation.discountReason に保存され、管理画面でのみ表示する */
  label: Scalars["String"]["input"];
};

export type InternalFutureCleaningAmount = {
  __typename: "InternalFutureCleaningAmount";
  /** その日に清掃が必要な部屋のリスト（デバッグ用） */
  accommodations: Array<Accommodation>;
  /** その日の全体の必要清掃数（=部屋数） */
  amount: Scalars["Int"]["output"];
  /** 部屋の設備組み合わせごとに分類した必要清掃数 */
  amountByFacilities: Array<InternalFutureCleaningAmountByFacility>;
  /** 清掃に入る日付 */
  date: Scalars["PlainDate"]["output"];
};

export type InternalFutureCleaningAmountByFacility = {
  __typename: "InternalFutureCleaningAmountByFacility";
  /** 必要清掃数 */
  amount: Scalars["Int"]["output"];
  /** 設備組み合わせの名前 */
  facilityCombinationName: Scalars["String"]["output"];
};

export type InternalFutureCleaningAmounts = {
  __typename: "InternalFutureCleaningAmounts";
  list: Array<InternalFutureCleaningAmount>;
};

export type InternalFutureCleaningAmountsError = {
  __typename: "InternalFutureCleaningAmountsError";
  message: Scalars["String"]["output"];
};

export type InternalFutureCleaningAmountsPayload =
  | InternalFutureCleaningAmounts
  | InternalFutureCleaningAmountsError;

export type InternalGenerateUserMonthlyStatementError = {
  __typename: "InternalGenerateUserMonthlyStatementError";
  case: InternalGenerateUserMonthlyStatementErrorCase;
  message?: Maybe<Scalars["String"]["output"]>;
};

export const InternalGenerateUserMonthlyStatementErrorCase = {
  /** ユーザーが見つからない */
  UserNotFound: "UserNotFound",
} as const;

export type InternalGenerateUserMonthlyStatementErrorCase =
  (typeof InternalGenerateUserMonthlyStatementErrorCase)[keyof typeof InternalGenerateUserMonthlyStatementErrorCase];
export type InternalGenerateUserMonthlyStatementPayload =
  | InternalGenerateUserMonthlyStatementError
  | UserMonthlyStatement;

/** 画面から付与できる管理ロール */
export type InternalGrantableAdminRole = {
  __typename: "InternalGrantableAdminRole";
  role: AdminRole;
  /** 割り当てに要るスコープの軸。Site なら拠点の指定が必須、null なら指定できない */
  scope?: Maybe<ScopeDimension>;
};

export type InternalInvalidateOrganizationYearlyContractError = {
  __typename: "InternalInvalidateOrganizationYearlyContractError";
  case: InternalInvalidateOrganizationYearlyContractErrorCase;
};

export const InternalInvalidateOrganizationYearlyContractErrorCase = {
  /** 対象契約期間内に予約が存在する */
  ReservationsExistInContractPeriod: "ReservationsExistInContractPeriod",
} as const;

export type InternalInvalidateOrganizationYearlyContractErrorCase =
  (typeof InternalInvalidateOrganizationYearlyContractErrorCase)[keyof typeof InternalInvalidateOrganizationYearlyContractErrorCase];
export type InternalInvalidateOrganizationYearlyContractInvoiceError = {
  __typename: "InternalInvalidateOrganizationYearlyContractInvoiceError";
  case: InternalInvalidateOrganizationYearlyContractInvoiceErrorCase;
};

export const InternalInvalidateOrganizationYearlyContractInvoiceErrorCase = {
  /** 既に無効化されている */
  InvoiceIsAlreadyInvalidated: "InvoiceIsAlreadyInvalidated",
  /** 支払い済みのinvoiceは無効化できない */
  InvoiceIsPaid: "InvoiceIsPaid",
  /** 回収不能状態のinvoiceは無効化できない */
  InvoiceIsUncollectible: "InvoiceIsUncollectible",
} as const;

export type InternalInvalidateOrganizationYearlyContractInvoiceErrorCase =
  (typeof InternalInvalidateOrganizationYearlyContractInvoiceErrorCase)[keyof typeof InternalInvalidateOrganizationYearlyContractInvoiceErrorCase];
export type InternalInvalidateOrganizationYearlyContractInvoicePayload =
  | InternalInvalidateOrganizationYearlyContractInvoiceError
  | Success;

export type InternalInvalidateOrganizationYearlyContractPayload =
  | InternalInvalidateOrganizationYearlyContractError
  | Success;

export type InternalInvalidateS2oPointsError = {
  __typename: "InternalInvalidateS2oPointsError";
  case: InternalInvalidateS2oPointsErrorCase;
};

export const InternalInvalidateS2oPointsErrorCase = {
  /** ユーザーが見つからない */
  UserNotFound: "UserNotFound",
} as const;

export type InternalInvalidateS2oPointsErrorCase =
  (typeof InternalInvalidateS2oPointsErrorCase)[keyof typeof InternalInvalidateS2oPointsErrorCase];
export type InternalInvalidateS2oPointsInput = {
  /** メモ */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** ユーザーID */
  userId: Scalars["ID"]["input"];
};

export type InternalInvalidateS2oPointsPayload =
  | InternalInvalidateS2oPointsError
  | Success;

/** Stay Ticket無効化の結果 */
export type InternalInvalidateStayTicketsByCodeResult = {
  __typename: "InternalInvalidateStayTicketsByCodeResult";
  /** 無効化されたチケット（Open → Voidに変更） */
  invalidatedTickets: Array<StayTicket>;
  /** 見つからなかったcode */
  notFoundCodes: Array<Scalars["String"]["output"]>;
  /** スキップされたチケット（Open以外のステータスだったチケット） */
  skippedTickets: Array<StayTicket>;
};

export type InternalIssueS2oPointsError = {
  __typename: "InternalIssueS2oPointsError";
  case: InternalIssueS2oPointsErrorCase;
};

export const InternalIssueS2oPointsErrorCase = {
  /** 残高不足 */
  InsufficientBalance: "InsufficientBalance",
  /** 無効な金額（0など） */
  InvalidAmount: "InvalidAmount",
  /** 無効な日付（未来または3年以上前） */
  InvalidDate: "InvalidDate",
  /** 無効なトランザクションタイプ */
  InvalidTransactionType: "InvalidTransactionType",
  /** トライアル契約が見つからない */
  TrialContractNotFound: "TrialContractNotFound",
  /** ユーザーが見つからない */
  UserNotFound: "UserNotFound",
} as const;

export type InternalIssueS2oPointsErrorCase =
  (typeof InternalIssueS2oPointsErrorCase)[keyof typeof InternalIssueS2oPointsErrorCase];
export type InternalIssueS2oPointsInput = {
  /** 付与するポイント数 */
  amount: Scalars["Int"]["input"];
  /** 付与日（省略時は今日） */
  date?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** メモ */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** トランザクションタイプ */
  transactionType: S2oPointAdminTransactionType;
  /** ユーザーID */
  userId: Scalars["ID"]["input"];
};

export type InternalIssueS2oPointsPayload =
  | InternalIssueS2oPointsError
  | Success;

export type InternalJtasCreateOrUpdateInspectionStatusesError = {
  __typename: "InternalJtasCreateOrUpdateInspectionStatusesError";
  case: InternalJtasCreateOrUpdateInspectionStatusesErrorCase;
};

export const InternalJtasCreateOrUpdateInspectionStatusesErrorCase = {
  ReservationNotFound: "ReservationNotFound",
} as const;

export type InternalJtasCreateOrUpdateInspectionStatusesErrorCase =
  (typeof InternalJtasCreateOrUpdateInspectionStatusesErrorCase)[keyof typeof InternalJtasCreateOrUpdateInspectionStatusesErrorCase];
export type InternalJtasCreateOrUpdateInspectionStatusesInput = {
  items: Array<InternalJtasInspectionStatusInput>;
};

export type InternalJtasCreateOrUpdateInspectionStatusesPayload =
  | InternalJtasCreateOrUpdateInspectionStatusesError
  | Success;

export type InternalJtasCreateOrUpdateSupplyReportError = {
  __typename: "InternalJtasCreateOrUpdateSupplyReportError";
  case: InternalJtasCreateOrUpdateSupplyReportErrorCase;
};

export const InternalJtasCreateOrUpdateSupplyReportErrorCase = {
  MediaFetchFailed: "MediaFetchFailed",
  ReservationCanceled: "ReservationCanceled",
  ReservationNotFound: "ReservationNotFound",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
  SupplyReportClosed: "SupplyReportClosed",
} as const;

export type InternalJtasCreateOrUpdateSupplyReportErrorCase =
  (typeof InternalJtasCreateOrUpdateSupplyReportErrorCase)[keyof typeof InternalJtasCreateOrUpdateSupplyReportErrorCase];
export type InternalJtasCreateOrUpdateSupplyReportInput = {
  accommodationId: Scalars["ID"]["input"];
  imageUrls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  inspectionDate: Scalars["PlainDate"]["input"];
  supplyItems: Array<InternalJtasSupplyItemInput>;
};

export type InternalJtasCreateOrUpdateSupplyReportPayload =
  | InternalJtasCreateOrUpdateSupplyReportError
  | Success;

export type InternalJtasCreateOrUpdateViolationReportError = {
  __typename: "InternalJtasCreateOrUpdateViolationReportError";
  case: InternalJtasCreateOrUpdateViolationReportErrorCase;
};

export const InternalJtasCreateOrUpdateViolationReportErrorCase = {
  MediaFetchFailed: "MediaFetchFailed",
  ReservationNotFound: "ReservationNotFound",
  ViolationReportClosed: "ViolationReportClosed",
} as const;

export type InternalJtasCreateOrUpdateViolationReportErrorCase =
  (typeof InternalJtasCreateOrUpdateViolationReportErrorCase)[keyof typeof InternalJtasCreateOrUpdateViolationReportErrorCase];
export type InternalJtasCreateOrUpdateViolationReportInput = {
  accommodationId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  externalReportId: Scalars["String"]["input"];
  imageUrls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  inspectionDate: Scalars["PlainDate"]["input"];
  violationItems: Array<InternalJtasViolationItemInput>;
};

export type InternalJtasCreateOrUpdateViolationReportPayload =
  | InternalJtasCreateOrUpdateViolationReportError
  | Success;

export type InternalJtasDeleteViolationReportError = {
  __typename: "InternalJtasDeleteViolationReportError";
  case: InternalJtasDeleteViolationReportErrorCase;
};

export const InternalJtasDeleteViolationReportErrorCase = {
  ViolationReportClosed: "ViolationReportClosed",
  ViolationReportNotFound: "ViolationReportNotFound",
} as const;

export type InternalJtasDeleteViolationReportErrorCase =
  (typeof InternalJtasDeleteViolationReportErrorCase)[keyof typeof InternalJtasDeleteViolationReportErrorCase];
export type InternalJtasDeleteViolationReportInput = {
  externalReportId: Scalars["String"]["input"];
};

export type InternalJtasDeleteViolationReportPayload =
  | InternalJtasDeleteViolationReportError
  | Success;

export type InternalJtasInspectionStatusInput = {
  accommodationId: Scalars["ID"]["input"];
  inspectionDate: Scalars["PlainDate"]["input"];
  status: InspectionStatusType;
};

export type InternalJtasSupplyItemInput = {
  quantity: Scalars["Int"]["input"];
  supplyItemMasterId: Scalars["ID"]["input"];
};

export type InternalJtasViolationItemInput = {
  typeId: Scalars["Int"]["input"];
  typeName: Scalars["String"]["input"];
};

export type InternalLeaveOrganizationError = {
  __typename: "InternalLeaveOrganizationError";
  case: InternalLeaveOrganizationErrorCase;
};

export const InternalLeaveOrganizationErrorCase = {
  /** 法人プランの予約が残っている */
  HasActiveReservation: "HasActiveReservation",
} as const;

export type InternalLeaveOrganizationErrorCase =
  (typeof InternalLeaveOrganizationErrorCase)[keyof typeof InternalLeaveOrganizationErrorCase];
export type InternalLeaveOrganizationPayload =
  | InternalLeaveOrganizationError
  | Success;

export type InternalLocalTaxFixedAmountInput = {
  /** 1 人 1 泊あたりの税額 */
  taxAmount: Scalars["Decimal"]["input"];
};

export type InternalLocalTaxFixedRateInput = {
  /** 1 人 1 泊あたりの最大税額。null は上限なし */
  maxTaxAmount?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** 1 人 1 泊あたりの宿泊費（税抜）に掛ける税率（3% は 0.03） */
  taxRate: Scalars["Decimal"]["input"];
};

/** 地方税の税額の定め。いずれか 1 つだけを指定する */
export type InternalLocalTaxRuleInput =
  /** 一律定額 */
  | {
      fixedAmount: InternalLocalTaxFixedAmountInput;
      fixedRate?: never;
      steppedAmount?: never;
    } /** 一律比率 */
  | {
      fixedAmount?: never;
      fixedRate: InternalLocalTaxFixedRateInput;
      steppedAmount?: never;
    } /** 段階的定額 */
  | {
      fixedAmount?: never;
      fixedRate?: never;
      steppedAmount: InternalLocalTaxSteppedAmountInput;
    };

export type InternalLocalTaxSteppedAmountInput = {
  /** 2 件以上。0 円から隙間なく続き、最後の区分は上限なし */
  brackets: Array<InternalLocalTaxSteppedBracketInput>;
};

export type InternalLocalTaxSteppedBracketInput = {
  /** 同上の上限（含まない）。null は上限なし */
  maxAmount?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** 1 人 1 泊あたりの宿泊費（税抜）の下限（含む） */
  minAmount: Scalars["Decimal"]["input"];
  /** 1 人 1 泊あたりの税額 */
  taxAmount: Scalars["Decimal"]["input"];
};

/**
 * 多言語化されたコンテンツを保持する type。各 locale field は optional (null = 未入力)。
 * admin の編集 UI が「locale ごとに値があるか」を扱える形にした。
 * GraphQL field 名はハイフン不可なので zhCn は camelCase。
 */
export type InternalLocalizedString = {
  __typename: "InternalLocalizedString";
  en?: Maybe<Scalars["String"]["output"]>;
  ja?: Maybe<Scalars["String"]["output"]>;
  zhCn?: Maybe<Scalars["String"]["output"]>;
  zhTw?: Maybe<Scalars["String"]["output"]>;
};

/**
 * 多言語化されたコンテンツの入力。各 locale field は optional (未入力時は null)。
 * GraphQL field 名はハイフン不可なので zhCn は camelCase。
 */
export type InternalLocalizedStringInput = {
  en?: InputMaybe<Scalars["String"]["input"]>;
  ja?: InputMaybe<Scalars["String"]["input"]>;
  zhCn?: InputMaybe<Scalars["String"]["input"]>;
  zhTw?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalMarkCoOwnersApplicationPlannedForSaleError = {
  __typename: "InternalMarkCoOwnersApplicationPlannedForSaleError";
  case: InternalMarkCoOwnersApplicationPlannedForSaleErrorCase;
};

export const InternalMarkCoOwnersApplicationPlannedForSaleErrorCase = {
  /** 売却口数が 1 未満、またはオーナーシップが現在持つ口数を超えている */
  InvalidSaleUnits: "InvalidSaleUnits",
  /** ステータスが引渡完了でないため売却予定にできない */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** 次年度以降の宿泊権利が残る口数分を超えて消費されているため減らせない */
  NextYearStayCreditsInUse: "NextYearStayCreditsInUse",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 申込に紐づく UserOwnership が存在しない（データ不整合） */
  OwnershipNotFound: "OwnershipNotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
  /** 売却月が引渡月より前 */
  SaleMonthBeforeHandover: "SaleMonthBeforeHandover",
  /** 売却月が売却済の前回の売却月より前 */
  SaleMonthBeforePreviousSale: "SaleMonthBeforePreviousSale",
  /** 売却月を後ろにずらすと減らした宿泊権利を元に戻す必要があるため変更不可 */
  SaleMonthRequiresCreditRestore: "SaleMonthRequiresCreditRestore",
  /** 他の更新と競合したため一時的に実行できない（リトライ可能） */
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type InternalMarkCoOwnersApplicationPlannedForSaleErrorCase =
  (typeof InternalMarkCoOwnersApplicationPlannedForSaleErrorCase)[keyof typeof InternalMarkCoOwnersApplicationPlannedForSaleErrorCase];
export type InternalMarkCoOwnersApplicationPlannedForSalePayload =
  | CoOwnersApplication
  | InternalMarkCoOwnersApplicationPlannedForSaleError;

export type InternalMarkCoOwnersApplicationSoldError = {
  __typename: "InternalMarkCoOwnersApplicationSoldError";
  case: InternalMarkCoOwnersApplicationSoldErrorCase;
};

export const InternalMarkCoOwnersApplicationSoldErrorCase = {
  /** 紐づくアクティブな予約があるため売却済にできない */
  HasActiveReservations: "HasActiveReservations",
  /** 未滞在の StayGift（Open / Reserved）が残っているため売却済にできない */
  HasActiveStayGifts: "HasActiveStayGifts",
  /** ステータスが売却予定でないため売却済にできない */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 申込に紐づく UserOwnership が存在しない（データ不整合） */
  OwnershipNotFound: "OwnershipNotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
} as const;

export type InternalMarkCoOwnersApplicationSoldErrorCase =
  (typeof InternalMarkCoOwnersApplicationSoldErrorCase)[keyof typeof InternalMarkCoOwnersApplicationSoldErrorCase];
export type InternalMarkCoOwnersApplicationSoldPayload =
  | CoOwnersApplication
  | InternalMarkCoOwnersApplicationSoldError;

/** 管理者用 NativeAppHomeContent エンティティ */
export type InternalNativeAppHomeContent = {
  __typename: "InternalNativeAppHomeContent";
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 説明 */
  description?: Maybe<InternalLocalizedString>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** 画像 URL */
  imageUrl: UploadedFile;
  /** ラベル */
  label?: Maybe<InternalLocalizedString>;
  /** ラベルタイプ */
  labelType: NativeAppHomeContentLabelType;
  /** リンク */
  link: InternalLocalizedString;
  /** リンクアクション */
  linkAction: NativeAppHomeContentLinkAction;
  /** リンクラベル */
  linkLabel?: Maybe<InternalLocalizedString>;
  /** 並び順 */
  sort: Scalars["Int"]["output"];
  /** 公開状態 */
  status: NativeAppHomeContentStatus;
  /** タイトル */
  title?: Maybe<InternalLocalizedString>;
  /** 更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 更新者 */
  updatedUser: User;
};

/** NativeAppHomeContent 管理者用入力 */
export type InternalNativeAppHomeContentInput = {
  /** 説明 */
  description?: InputMaybe<InternalLocalizedStringInput>;
  /** 画像 URL */
  imageUrl: UploadedFileInput;
  /** ラベル */
  label?: InputMaybe<InternalLocalizedStringInput>;
  /** ラベルタイプ */
  labelType?: InputMaybe<NativeAppHomeContentLabelType>;
  /** リンク */
  link: InternalLocalizedStringInput;
  /** リンクアクション */
  linkAction?: InputMaybe<NativeAppHomeContentLinkAction>;
  /** リンクラベル */
  linkLabel?: InputMaybe<InternalLocalizedStringInput>;
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** 公開状態 */
  status?: InputMaybe<NativeAppHomeContentStatus>;
  /** タイトル */
  title?: InputMaybe<InternalLocalizedStringInput>;
};

/** レジストリに登録された one-shot スクリプトのメタ情報とソース */
export type InternalOneShotScript = {
  __typename: "InternalOneShotScript";
  description: Scalars["String"]["output"];
  /** 最後に実行 (dry-run 含む) が開始された日時。実行履歴が無ければ null */
  lastExecutedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** ベース admin 権限に追加で要求する権限ラベル (表示用) */
  requiredPermission?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["ID"]["output"];
  /** read-only のソーステキスト (ビルド時生成マップ由来) */
  source: Scalars["String"]["output"];
  /** ビルド時に Shiki でハイライト済みのソース HTML (light/dark dual theme) */
  sourceHtml: Scalars["String"]["output"];
  supportsDryRun: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

/** OTAルームユニット */
export type InternalOtaRoomUnit = {
  __typename: "InternalOtaRoomUnit";
  accommodation: Accommodation;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  unit: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type InternalPartialUpdateOrganizationError = {
  __typename: "InternalPartialUpdateOrganizationError";
  message: Scalars["String"]["output"];
};

export type InternalPartialUpdateOrganizationPayload =
  | InternalPartialUpdateOrganizationError
  | Organization;

export type InternalRegisterCoOwnersApplicationFileInput = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  fileName: Scalars["String"]["input"];
  rawUrl: Scalars["String"]["input"];
  visibleToApplicant: Scalars["Boolean"]["input"];
};

export type InternalReleaseAccessKeyError = {
  __typename: "InternalReleaseAccessKeyError";
  message: Scalars["String"]["output"];
};

export type InternalReleaseAccessKeyPayload =
  | InternalReleaseAccessKeyError
  | Success;

export type InternalRemoveLocalTaxPolicyError = {
  __typename: "InternalRemoveLocalTaxPolicyError";
  case: InternalRemoveLocalTaxPolicyErrorCase;
};

export const InternalRemoveLocalTaxPolicyErrorCase = {
  /** 解除する拠点・部屋の予約の税額計算に使われている */
  UsedForTaxCalculation: "UsedForTaxCalculation",
} as const;

export type InternalRemoveLocalTaxPolicyErrorCase =
  (typeof InternalRemoveLocalTaxPolicyErrorCase)[keyof typeof InternalRemoveLocalTaxPolicyErrorCase];
export type InternalRemoveLocalTaxPolicyPayload =
  | InternalRemoveLocalTaxPolicyError
  | LocalTaxPolicy;

/** 地方税ポリシーの適用を解除する対象。いずれか 1 つだけを指定する */
export type InternalRemoveLocalTaxPolicyTargetInput =
  /** 入湯税の適用を解除する部屋 */
  | {
      accommodationId: Scalars["ID"]["input"];
      siteId?: never;
    } /** 宿泊税の適用を解除する拠点 */
  | { accommodationId?: never; siteId: Scalars["ID"]["input"] };

/** 宿泊施設並び順更新の入力 */
export type InternalReorderAccommodationInput = {
  /** 宿泊施設ID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** 建築コンテンツ系の並び順更新の入力 */
export type InternalReorderArchitectureContentInput = {
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** エリア並び順更新の入力 */
export type InternalReorderAreaInput = {
  /** エリアID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** 並び順更新の汎用入力 */
export type InternalReorderInput = {
  id: Scalars["ID"]["input"];
  sort: Scalars["Int"]["input"];
};

/** 拠点FAQ並び順更新の入力 */
export type InternalReorderSiteFaqInput = {
  /** FAQ ID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** 拠点並び順更新の入力 */
export type InternalReorderSiteInput = {
  /** 拠点ID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

export type InternalRevokeAdminRoleError = {
  __typename: "InternalRevokeAdminRoleError";
  code: InternalRevokeAdminRoleErrorCode;
  message: Scalars["String"]["output"];
};

export const InternalRevokeAdminRoleErrorCode = {
  AlreadyRevoked: "AlreadyRevoked",
  NotFound: "NotFound",
  /** 呼び出し元が外せないロールの割り当て。外せるのは自分が付与できるロールだけ */
  RoleNotRevocable: "RoleNotRevocable",
  /** 自分自身の割り当て */
  SelfRevocation: "SelfRevocation",
} as const;

export type InternalRevokeAdminRoleErrorCode =
  (typeof InternalRevokeAdminRoleErrorCode)[keyof typeof InternalRevokeAdminRoleErrorCode];
export type InternalRevokeAdminRolePayload =
  | AdminRoleAssignment
  | InternalRevokeAdminRoleError;

/** ルームタイプ（OTA Room Type と自社 Room Type を統合した統一モデル） */
export type InternalRoomType = {
  __typename: "InternalRoomType";
  /** 関連する建築タイプ（既存データには未設定で null） */
  architectureType?: Maybe<ArchitectureType>;
  beds24RoomId: Scalars["Int"]["output"];
  /** 表示コンテンツ（CMS 編集用） */
  content?: Maybe<InternalContentRoomType>;
  createdAt: Scalars["DateTime"]["output"];
  /** 自社サービス向け多言語表示名。未設定なら name にフォールバック */
  displayNames?: Maybe<InternalLocalizedString>;
  /** 特徴（多対多） */
  features: Array<InternalRoomTypeFeature>;
  id: Scalars["ID"]["output"];
  /** OTA / Beds24 側の名前 */
  name: Scalars["String"]["output"];
  /** 多言語備考 */
  notes?: Maybe<InternalLocalizedString>;
  otaRoomUnits: Array<InternalOtaRoomUnit>;
  /** URL 用 slug（site 内でユニーク） */
  slug?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** ルームタイプの「特徴」マスター */
export type InternalRoomTypeFeature = {
  __typename: "InternalRoomTypeFeature";
  /**
   * 対応する Accommodation 設備タイプ。
   * null = RoomType.features だけで完結する特徴（fuji-view 等）、
   * non-null = Accommodation 粒度でも評価が必要な設備（サウナ・温泉 等）。
   */
  accommodationFacilityType?: Maybe<AccommodationFacilityType>;
  category: RoomTypeFeatureCategory;
  iconSlug?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 多言語表示名 */
  name: InternalLocalizedString;
  slug: Scalars["String"]["output"];
  /** 表示・組み立て時の並び順（昇順、全体共通） */
  sort: Scalars["Int"]["output"];
};

export type InternalRunOneShotScriptError = {
  __typename: "InternalRunOneShotScriptError";
  case: InternalRunOneShotScriptErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalRunOneShotScriptErrorCase = {
  /** 同一スクリプトが既に実行中 */
  AlreadyRunning: "AlreadyRunning",
  /** confirmation が slug と一致しない */
  ConfirmationMismatch: "ConfirmationMismatch",
  /** 本番実行なのに confirmation が無い */
  ConfirmationRequired: "ConfirmationRequired",
  /** dry-run 非対応スクリプトに dryRun=true が指定された */
  DryRunNotSupported: "DryRunNotSupported",
  /** 指定 id のスクリプトがレジストリに無い */
  ScriptNotFound: "ScriptNotFound",
} as const;

export type InternalRunOneShotScriptErrorCase =
  (typeof InternalRunOneShotScriptErrorCase)[keyof typeof InternalRunOneShotScriptErrorCase];
export type InternalRunOneShotScriptInput = {
  /** 本番実行 (dryRun=false) のときに必須の確認トークン (= slug) */
  confirmation?: InputMaybe<Scalars["String"]["input"]>;
  /** true で副作用なしの dry-run。デフォルトは UI 側で ON */
  dryRun: Scalars["Boolean"]["input"];
  slug: Scalars["ID"]["input"];
};

export type InternalRunOneShotScriptResult =
  | InternalRunOneShotScriptError
  | InternalScriptExecution;

export type InternalScriptAffectedCount = {
  __typename: "InternalScriptAffectedCount";
  key: Scalars["String"]["output"];
  value: Scalars["Int"]["output"];
};

export type InternalScriptExecution = {
  __typename: "InternalScriptExecution";
  affected: Array<InternalScriptAffectedCount>;
  dryRun: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** finishedAt が null かつ十分古い場合に true (プロセスクラッシュ等で宙吊り) */
  interrupted: Scalars["Boolean"]["output"];
  logs: Array<InternalScriptExecutionLogLine>;
  slug: Scalars["ID"]["output"];
  startedAt: Scalars["DateTime"]["output"];
  status: ScriptExecutionStatus;
  summary?: Maybe<Scalars["String"]["output"]>;
  triggeredBy: InternalScriptExecutionActor;
};

export type InternalScriptExecutionActor = {
  __typename: "InternalScriptExecutionActor";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type InternalScriptExecutionLogLine = {
  __typename: "InternalScriptExecutionLogLine";
  level: ScriptLogLevel;
  message: Scalars["String"]["output"];
  ts: Scalars["DateTime"]["output"];
};

/** ユーザー指定プッシュ通知のエラー */
export type InternalSendPushNotificationsError = {
  __typename: "InternalSendPushNotificationsError";
  case: InternalSendPushNotificationsErrorCase;
  message: Scalars["String"]["output"];
};

/** ユーザー指定プッシュ通知のエラー種別 */
export const InternalSendPushNotificationsErrorCase = {
  /** 宛先が空、または title と body の両方が未指定 */
  InvalidInput: "InvalidInput",
  /** 指定した Email に一致するユーザーがいない */
  NoAppInstallations: "NoAppInstallations",
} as const;

export type InternalSendPushNotificationsErrorCase =
  (typeof InternalSendPushNotificationsErrorCase)[keyof typeof InternalSendPushNotificationsErrorCase];
/** ユーザー指定プッシュ通知の入力 */
export type InternalSendPushNotificationsInput = {
  /** 本文。title と body の少なくとも一方は必須 */
  body?: InputMaybe<Scalars["String"]["input"]>;
  /** 送信先ユーザーの Email アドレス */
  emails: Array<Scalars["String"]["input"]>;
  /** 通知に添付する画像 URL */
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 通知タップ時に開くリンク URL */
  linkUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** タイトル。title と body の少なくとも一方は必須 */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** ユーザー指定プッシュ通知の結果 */
export type InternalSendPushNotificationsPayload =
  | InternalSendPushNotificationsError
  | InternalSendPushNotificationsResult;

/**
 * ユーザー指定プッシュ通知の送信結果。
 * どのアドレスに届かなかったかを管理画面で確かめられるよう、件数ではなく Email をそのまま返す
 */
export type InternalSendPushNotificationsResult = {
  __typename: "InternalSendPushNotificationsResult";
  /** 端末に送信できた Email */
  deliveredEmails: Array<Scalars["String"]["output"]>;
  /** 送信を試みたが届かなかった Email */
  failedEmails: Array<Scalars["String"]["output"]>;
  /** ユーザーはいるが通知先の端末が登録されていない Email */
  noDeviceEmails: Array<Scalars["String"]["output"]>;
  /** 一致するユーザーがいなかった Email。大文字小文字まで一致する必要がある */
  notFoundEmails: Array<Scalars["String"]["output"]>;
};

/** 管理画面用の拠点型。public `Site` には載せたくない field（Beds24 連携・多言語名など）を含む。 */
export type InternalSite = {
  __typename: "InternalSite";
  /** 拠点内の宿泊施設一覧 */
  accommodations: Array<Accommodation>;
  /** 拠点があるエリア */
  area: InternalArea;
  /** Beds24プロパティID（未連携の場合は null） */
  beds24PropertyId?: Maybe<Scalars["Int"]["output"]>;
  /** チェックイン認証タイプ */
  checkInAuthenticationType: CheckInAuthenticationType;
  /** 拠点コンテンツ */
  content: SiteContent;
  /** カスタム予約リード月数（未設定の場合は null） */
  customReservationLeadMonths?: Maybe<Scalars["Int"]["output"]>;
  /** 早期チェックイン可能か */
  earlyCheckInEnabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** 多言語化された拠点名。admin の編集 UI で各 locale の値を取得するために使用する。 */
  localizedName: InternalLocalizedString;
  /** 拠点名（canonical）。admin 表示用なので caller.locale による localize はしない。 */
  name: Scalars["String"]["output"];
  /** 開業日 */
  openingDate: Scalars["PlainDate"]["output"];
  /** 拠点番号（例: 1st, 2nd） */
  ordinalName?: Maybe<Scalars["String"]["output"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published: Scalars["Boolean"]["output"];
  /**
   * RemoteLock の Location ID（未設定の場合は null）。拠点管理者キーの AccessPerson に
   * 拠点内の全デバイスへのアクセスを一括付与するのに使う。
   */
  remoteLockLocationId?: Maybe<Scalars["String"]["output"]>;
  /** 予約可能か */
  reservable: Scalars["Boolean"]["output"];
  /** オーナー先行予約可能か */
  reservableForOwnerEarlyAccess: Scalars["Boolean"]["output"];
  /** ルームタイプ特徴マスター一覧（sort 昇順、全 site 共通） */
  roomTypeFeatures: Array<InternalRoomTypeFeature>;
  /** ルームタイプ一覧 */
  roomTypes: Array<InternalRoomType>;
  slug: Scalars["String"]["output"];
  /**
   * この拠点における、ある備品の設置情報。同じ対象に複数行が残っているデータがあるため、
   * 対象ごとに作成日時が最も新しい1件へ畳んで返す
   */
  supplyItemInstallations: Array<SupplyItemInstallation>;
  /** SwitchBot の拠点 API キー（未設定の場合は null）。スマートプラグの稼働状況取得に使う。 */
  switchbotLocationApiKey?: Maybe<Scalars["String"]["output"]>;
};

/** 管理画面用の拠点型。public `Site` には載せたくない field（Beds24 連携・多言語名など）を含む。 */
export type InternalSiteSupplyItemInstallationsArgs = {
  masterId: Scalars["ID"]["input"];
};

/** アクセスルート上の地点（始点/経由/終点）入力 */
export type InternalSiteAccessRoutePointInput = {
  legToNextDescription?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** 拠点住所の多言語編集用の値 */
export type InternalSiteAddress = {
  __typename: "InternalSiteAddress";
  /** 町名・番地以降（{ja,en}） */
  addressLine?: Maybe<InternalLocalizedString>;
  /** 市区町村（{ja,en}） */
  city?: Maybe<InternalLocalizedString>;
  /** 都道府県（{ja,en}） */
  prefecture?: Maybe<InternalLocalizedString>;
};

/**
 * スタッフプラン契約（管理画面用）
 * ユーザー情報を含む
 */
export type InternalStaffContract = {
  __typename: "InternalStaffContract";
  /** 登録者 */
  createdUser: User;
  /** 今期の付与泊数 */
  currentSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /** 今期の残り泊数 */
  currentSemesterStayCredits: Scalars["Int"]["output"];
  enrolledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 予約可能かどうか */
  isReservable: Scalars["Boolean"]["output"];
  /** 残りのピーク日数（今期） */
  remainingPeakDays: Scalars["Int"]["output"];
  /** Semester別の宿泊数情報 */
  semesterCredits: Array<StaffSemesterCredit>;
  staffType: StaffType;
  status: StaffContractStatus;
  statusDetail: StaffContractStatusDetail;
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 更新者 */
  updatedUser: User;
  user: User;
};

/** スタッフプラン宿泊クレジット履歴（管理画面用） */
export type InternalStaffCreditTransaction = {
  __typename: "InternalStaffCreditTransaction";
  /** 紐づく予約（予約消費の場合） */
  accommodationReservation?: Maybe<AccommodationReservation>;
  /** 泊数（正=付与、負=消費） */
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  /** 実行者（nullの場合はシステム自動実行） */
  createdByUser?: Maybe<User>;
  id: Scalars["ID"]["output"];
  /** ピーク日数（正=付与、負=消費） */
  peakDaysAmount: Scalars["Int"]["output"];
  semester: StaffSemester;
  status: StaffStayCreditTransactionStatus;
  type: StaffStayCreditTransactionType;
  year: Scalars["Int"]["output"];
};

export type InternalStartStaffPlanError = {
  __typename: "InternalStartStaffPlanError";
  case: InternalStartStaffPlanErrorCase;
};

export const InternalStartStaffPlanErrorCase = {
  /** 既に有効な契約が存在する */
  AlreadyActive: "AlreadyActive",
  /** 泊数が無効（1-4泊の範囲外） */
  InvalidNights: "InvalidNights",
  /** タームが無効（現在または次のタームのみ選択可能） */
  InvalidSemester: "InvalidSemester",
  /** 権限がない */
  NotAuthorized: "NotAuthorized",
} as const;

export type InternalStartStaffPlanErrorCase =
  (typeof InternalStartStaffPlanErrorCase)[keyof typeof InternalStartStaffPlanErrorCase];
/** for Staffプラン開始の結果 */
export type InternalStartStaffPlanResult =
  | InternalStartStaffPlanError
  | InternalStartStaffPlanSuccess;

export type InternalStartStaffPlanSuccess = {
  __typename: "InternalStartStaffPlanSuccess";
  contract: StaffContract;
};

/** 宿泊チケット一覧のソート対象フィールド */
export const InternalStayTicketsOrderBy = {
  /** チケットコード */
  Code: "Code",
  /** 作成日 */
  CreatedAt: "CreatedAt",
  /** 有効期限 */
  ExpiresAt: "ExpiresAt",
  /** 宿泊終了日 */
  StayEndNight: "StayEndNight",
  /** 宿泊開始日 */
  StayStartNight: "StayStartNight",
} as const;

export type InternalStayTicketsOrderBy =
  (typeof InternalStayTicketsOrderBy)[keyof typeof InternalStayTicketsOrderBy];
/** 宿泊チケット一覧のページネーション結果 */
export type InternalStayTicketsResult = {
  __typename: "InternalStayTicketsResult";
  /** チケット一覧 */
  items: Array<StayTicket>;
  /** 総件数 */
  totalCount: Scalars["Int"]["output"];
};

export type InternalStopStaffPlanError = {
  __typename: "InternalStopStaffPlanError";
  case: InternalStopStaffPlanErrorCase;
  message?: Maybe<Scalars["String"]["output"]>;
};

export const InternalStopStaffPlanErrorCase = {
  /** 次のターム以降の予約が存在する */
  FutureReservationsExist: "FutureReservationsExist",
  /** 有効な契約が存在しない */
  NotActive: "NotActive",
  /** 権限がない */
  NotAuthorized: "NotAuthorized",
} as const;

export type InternalStopStaffPlanErrorCase =
  (typeof InternalStopStaffPlanErrorCase)[keyof typeof InternalStopStaffPlanErrorCase];
/** for Staffプラン停止の結果 */
export type InternalStopStaffPlanResult =
  | InternalStopStaffPlanError
  | InternalStopStaffPlanSuccess;

export type InternalStopStaffPlanSuccess = {
  __typename: "InternalStopStaffPlanSuccess";
  contract: StaffContract;
};

/** 管理者によるアイデンティティ解除の結果 */
export type InternalUnlinkIdentityPayload = {
  __typename: "InternalUnlinkIdentityPayload";
  /** 解除が成功したかどうか */
  success: Scalars["Boolean"]["output"];
};

/** ブロック解放スケジュールの更新入力 */
export type InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput = {
  /** 維持するブロック室数の上限（0 = 全解除） */
  blockRoomCountUpperLimit: Scalars["Int"]["input"];
  /** チェックインN日前 */
  daysBeforeCheckin: Scalars["Int"]["input"];
};

/** 未指定のフィールドは変更しない。description は null 指定でクリアできる。 */
export type InternalUpdateAccommodationEquipmentInput = {
  /** 形は InternalCreateAccommodationEquipmentInput.attribute と同じ。既存行の type に対して検証する（type 自体は変更できない）。 */
  attribute?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<AccommodationEquipmentStatusType>;
};

export type InternalUpdateAccommodationEquipmentPayload =
  | AccommodationEquipment
  | InternalAccommodationEquipmentError;

export type InternalUpdateAccommodationOperationGroupSettingError = {
  __typename: "InternalUpdateAccommodationOperationGroupSettingError";
  case: InternalUpdateAccommodationOperationGroupSettingErrorCase;
};

export const InternalUpdateAccommodationOperationGroupSettingErrorCase = {
  /** 追加料金が不正（負の値、またはクラスで使われない欄が 0 以外） */
  InvalidAdditionalFee: "InvalidAdditionalFee",
  /** 設定値が見つからない */
  NotFound: "NotFound",
  /** 拠点が予約受付中（一般またはオーナー先行）のため更新できない */
  SiteReservable: "SiteReservable",
  /**
   * 紐づくオーナープランの所有権があるため更新できない。
   * 開業前でもオーナーは所有権由来の宿泊券で他拠点を予約でき、
   * その料金は所有クラスで決まるため、クラス・追加料金は所有権の付与前に確定させる必要がある
   */
  UserOwnershipExists: "UserOwnershipExists",
} as const;

export type InternalUpdateAccommodationOperationGroupSettingErrorCase =
  (typeof InternalUpdateAccommodationOperationGroupSettingErrorCase)[keyof typeof InternalUpdateAccommodationOperationGroupSettingErrorCase];
export type InternalUpdateAccommodationOperationGroupSettingInput = {
  additionalFeeForBusinessPlan: Scalars["Int"]["input"];
  additionalFeeForClassEOwner: Scalars["Int"]["input"];
  additionalFeeForClassFOwner: Scalars["Int"]["input"];
  class: AccommodationClass;
  operationType: AccommodationOperationType;
};

export type InternalUpdateAccommodationOperationGroupSettingPayload =
  | AccommodationOperationGroupSetting
  | InternalUpdateAccommodationOperationGroupSettingError;

export type InternalUpdateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  fee?: InputMaybe<AccommodationFeeInput>;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  /**
   * true の場合、変更前 fee にあった動的料金 item の amount を維持する。
   * 対象: StandardPlan の calculated_dynamic_pricing_fee、
   *      StayTicket の calculated_base_fee。
   * 拠点変更、または対応する (night, key) が元 fee にない場合は通常再計算に fallback。
   */
  preserveDynamicPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** エリアコンテンツ更新の入力 */
export type InternalUpdateAreaContentInput = {
  /** 東京からのアクセス説明 */
  accessFromTokyoDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 英語表記の大文字名（例：ICHINOMIYA、AZUMINO） */
  allCapsName?: InputMaybe<Scalars["String"]["input"]>;
  /** キャッチコピー */
  catchCopy?: InputMaybe<Scalars["String"]["input"]>;
  /** エリア紹介文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** おすすめスポットをまとめたGoogle MapsリストのURL */
  guideSpotMapListUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** おすすめスポットページ下部Tipsの本文 */
  guideSpotTips?: InputMaybe<Scalars["String"]["input"]>;
  /** おすすめスポットページ下部Tipsの見出し */
  guideSpotTipsTitle?: InputMaybe<Scalars["String"]["input"]>;
  /** ヒーロー画像（既存を全置換する。undefined のときは更新しない） */
  heroImages?: InputMaybe<Array<UploadedFileInput>>;
  /** 予約フォームのカバー画像URL */
  reservationFormCoverImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 道路状況ライブカメラURL */
  roadConditionLiveCameraUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 短い住所表示（例: "静岡県"） */
  shortAddress?: InputMaybe<Scalars["String"]["input"]>;
};

/** エリア更新時のエラー */
export type InternalUpdateAreaError = {
  __typename: "InternalUpdateAreaError";
  case: InternalUpdateAreaErrorCase;
  message: Scalars["String"]["output"];
};

/** エリア更新時のエラー種別 */
export const InternalUpdateAreaErrorCase = {
  /** 並行更新により楽観ロックが競合した（再読み込みして再試行） */
  OptimisticLockConflict: "OptimisticLockConflict",
} as const;

export type InternalUpdateAreaErrorCase =
  (typeof InternalUpdateAreaErrorCase)[keyof typeof InternalUpdateAreaErrorCase];
/** エリア更新の入力 */
export type InternalUpdateAreaInput = {
  /** 多言語化されたエリア名。全 locale 必須。 */
  localizedName?: InputMaybe<InternalLocalizedStringInput>;
  /** エリア名 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** スラッグ */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

/** エリア更新の結果 */
export type InternalUpdateAreaPayload = InternalArea | InternalUpdateAreaError;

export type InternalUpdateCoOwnersApplicationDetailError = {
  __typename: "InternalUpdateCoOwnersApplicationDetailError";
  case: InternalUpdateCoOwnersApplicationDetailErrorCase;
};

export const InternalUpdateCoOwnersApplicationDetailErrorCase = {
  /** 詳細情報の種類が一致しない */
  DetailTypeMismatch: "DetailTypeMismatch",
  /** データが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationDetailErrorCase =
  (typeof InternalUpdateCoOwnersApplicationDetailErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationDetailErrorCase];
export type InternalUpdateCoOwnersApplicationDetailPayload =
  | CoOwnersApplication
  | InternalUpdateCoOwnersApplicationDetailError;

export type InternalUpdateCoOwnersApplicationFileError = {
  __typename: "InternalUpdateCoOwnersApplicationFileError";
  case: InternalUpdateCoOwnersApplicationFileErrorCase;
};

export const InternalUpdateCoOwnersApplicationFileErrorCase = {
  /** 存在しないか削除済み */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationFileErrorCase =
  (typeof InternalUpdateCoOwnersApplicationFileErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationFileErrorCase];
export type InternalUpdateCoOwnersApplicationFilePayload =
  | CoOwnersApplicationFile
  | InternalUpdateCoOwnersApplicationFileError;

export type InternalUpdateCoOwnersApplicationInfoError = {
  __typename: "InternalUpdateCoOwnersApplicationInfoError";
  case: InternalUpdateCoOwnersApplicationInfoErrorCase;
};

export const InternalUpdateCoOwnersApplicationInfoErrorCase = {
  /** 本人確認書類1が不正 */
  IdDocument1Invalid: "IdDocument1Invalid",
  /** 本人確認書類2が不正 */
  IdDocument2Invalid: "IdDocument2Invalid",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** データが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationInfoErrorCase =
  (typeof InternalUpdateCoOwnersApplicationInfoErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationInfoErrorCase];
export type InternalUpdateCoOwnersApplicationInfoPayload =
  | CoOwnersApplication
  | InternalUpdateCoOwnersApplicationInfoError;

export type InternalUpdateCoOwnersApplicationStatusError = {
  __typename: "InternalUpdateCoOwnersApplicationStatusError";
  case: InternalUpdateCoOwnersApplicationStatusErrorCase;
};

export const InternalUpdateCoOwnersApplicationStatusErrorCase = {
  /** 本人確認が未完了（契約サイン済み への変更時に承認済みの本人確認が必要） */
  IdentityVerificationNotApproved: "IdentityVerificationNotApproved",
  /** 無効なステータス遷移 */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** 引渡希望日が未設定（登録料受領済/入金完了 への変更時に必要） */
  MissingDesiredHandoverDate: "MissingDesiredHandoverDate",
  /** データが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationStatusErrorCase =
  (typeof InternalUpdateCoOwnersApplicationStatusErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationStatusErrorCase];
export type InternalUpdateCoOwnersApplicationStatusPayload =
  | CoOwnersApplication
  | InternalUpdateCoOwnersApplicationStatusError;

/** 設備コンテンツ用画像の更新時の入力 */
export type InternalUpdateFacilityContentImagesInput = {
  /** 画像のURLリスト（並び順を保持） */
  images: Array<UploadedFileInput>;
};

/** 設備コンテンツ用画像の更新結果 */
export type InternalUpdateFacilityContentImagesPayload =
  | InternalCommonError
  | Success;

/** 付帯サービス更新入力 */
export type InternalUpdateFacilityInput = {
  /** 料金ポリシー一覧（指定した場合は全削除→再作成） */
  baseFeePolicies?: InputMaybe<
    Array<InternalCreateOrUpdateFacilityBaseFeePolicyInput>
  >;
  /** 返却後の準備日数 */
  bufferDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切の何日前（0=当日, 1=前日） */
  cancelDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切時刻 */
  cancelDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル料ポリシー一覧（指定した場合は全削除→再作成） */
  cancelFeePolicies?: InputMaybe<
    Array<InternalCreateOrUpdateFacilityCancelFeePolicyInput>
  >;
  /** キャンセル料ルールURL */
  cancelRuleUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 設備詳細（Markdown） */
  contentDetail?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約時の案内（Markdown） */
  contentGuide?: InputMaybe<Scalars["String"]["input"]>;
  /** 注意事項（Markdown） */
  contentNotice?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用について（Markdown） */
  contentUsage?: InputMaybe<Scalars["String"]["input"]>;
  /** カスタムフィールド設定 */
  customFields?: InputMaybe<Array<FacilityCustomFieldItemInput>>;
  /** 施設説明文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 詳細リンクURL（nullの場合はリンク非表示） */
  detailUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 更新対象の設備ID */
  facilityId: Scalars["ID"]["input"];
  /** 施設画像 */
  image?: InputMaybe<UploadedFileInput>;
  /** 清掃レポート機能を有効化 */
  isCleaningReportEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** データ連携管理機能を有効化 */
  isDataSyncEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 予約機能を有効にするか */
  isReserveEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 公開ページと予約カレンダーへの掲載を有効にするか */
  isVisibleEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 短縮表示名（ボタン/カード用） */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** 正式名称 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約締切の何日前（0=当日, 1=前日, 7=1週間前） */
  reserveDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** 予約締切時刻 */
  reserveDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** リソース一覧（指定した場合は既存をsoft delete→新規作成） */
  resources?: InputMaybe<Array<InternalCreateOrUpdateFacilityResourceInput>>;
  /** 拠点ID一覧（指定した場合は全削除→再作成） */
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** スロット定義一覧（指定した場合は全削除→再作成） */
  slots?: InputMaybe<Array<InternalCreateOrUpdateFacilitySlotInput>>;
  /** 公開ステータス */
  status?: InputMaybe<FacilityStatusType>;
  /** 規約リンクのラベル */
  termsLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用規約URL */
  termsUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalUpdateFacilityReservationCleaningError = {
  __typename: "InternalUpdateFacilityReservationCleaningError";
  case: InternalUpdateFacilityReservationCleaningErrorCase;
};

export const InternalUpdateFacilityReservationCleaningErrorCase = {
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
} as const;

export type InternalUpdateFacilityReservationCleaningErrorCase =
  (typeof InternalUpdateFacilityReservationCleaningErrorCase)[keyof typeof InternalUpdateFacilityReservationCleaningErrorCase];
/** 付帯サービス予約の清掃ステータス更新結果 */
export type InternalUpdateFacilityReservationCleaningPayload =
  | InternalUpdateFacilityReservationCleaningError
  | Success;

export type InternalUpdateFacilityReservationDataSyncError = {
  __typename: "InternalUpdateFacilityReservationDataSyncError";
  case: InternalUpdateFacilityReservationDataSyncErrorCase;
};

export const InternalUpdateFacilityReservationDataSyncErrorCase = {
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
} as const;

export type InternalUpdateFacilityReservationDataSyncErrorCase =
  (typeof InternalUpdateFacilityReservationDataSyncErrorCase)[keyof typeof InternalUpdateFacilityReservationDataSyncErrorCase];
/** 付帯サービス予約のデータ連携ステータス更新結果 */
export type InternalUpdateFacilityReservationDataSyncPayload =
  | InternalUpdateFacilityReservationDataSyncError
  | Success;

export type InternalUpdateIdentityVerificationError = {
  __typename: "InternalUpdateIdentityVerificationError";
  case: InternalUpdateIdentityVerificationErrorCase;
};

export const InternalUpdateIdentityVerificationErrorCase = {
  /** ステータスが遷移不可 */
  InvalidStatusTransition: "InvalidStatusTransition",
  NotFound: "NotFound",
  /** Verified への更新時に result が指定されていない */
  ResultRequiredWhenVerified: "ResultRequiredWhenVerified",
} as const;

export type InternalUpdateIdentityVerificationErrorCase =
  (typeof InternalUpdateIdentityVerificationErrorCase)[keyof typeof InternalUpdateIdentityVerificationErrorCase];
export type InternalUpdateIdentityVerificationInput = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  result?: InputMaybe<IdentityVerificationResult>;
  status?: InputMaybe<IdentityVerificationStatus>;
};

export type InternalUpdateIdentityVerificationPayload =
  | InternalUpdateIdentityVerificationError
  | Success;

export type InternalUpdateIndividualTermsDocumentError = {
  __typename: "InternalUpdateIndividualTermsDocumentError";
  case: InternalUpdateIndividualTermsDocumentErrorCase;
};

export const InternalUpdateIndividualTermsDocumentErrorCase = {
  /** 入力値が不正（共通規約を指定した場合など） */
  InvalidInput: "InvalidInput",
  /** 規約が見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalUpdateIndividualTermsDocumentErrorCase =
  (typeof InternalUpdateIndividualTermsDocumentErrorCase)[keyof typeof InternalUpdateIndividualTermsDocumentErrorCase];
export type InternalUpdateIndividualTermsDocumentInput = {
  document: UploadedFileInput;
};

export type InternalUpdateIndividualTermsDocumentPayload =
  | InternalUpdateIndividualTermsDocumentError
  | Terms;

export type InternalUpdateInspectionViolationHandlingError = {
  __typename: "InternalUpdateInspectionViolationHandlingError";
  case: InternalUpdateInspectionViolationHandlingErrorCase;
};

export const InternalUpdateInspectionViolationHandlingErrorCase = {
  InspectionReportNotFound: "InspectionReportNotFound",
  NothingToUpdate: "NothingToUpdate",
  SeverityNotAssessed: "SeverityNotAssessed",
  ViolationNotReported: "ViolationNotReported",
} as const;

export type InternalUpdateInspectionViolationHandlingErrorCase =
  (typeof InternalUpdateInspectionViolationHandlingErrorCase)[keyof typeof InternalUpdateInspectionViolationHandlingErrorCase];
export type InternalUpdateInspectionViolationHandlingInput = {
  inspectionReportId: Scalars["ID"]["input"];
  severity?: InputMaybe<InspectionViolationSeverity>;
  warningActionNote?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalUpdateInspectionViolationHandlingPayload =
  | InternalUpdateInspectionViolationHandlingError
  | Success;

export type InternalUpdateLocalTaxPolicyError = {
  __typename: "InternalUpdateLocalTaxPolicyError";
  case: InternalUpdateLocalTaxPolicyErrorCase;
};

export const InternalUpdateLocalTaxPolicyErrorCase = {
  /** 有効終了日が有効開始日より前 */
  EffectiveToBeforeEffectiveFrom: "EffectiveToBeforeEffectiveFrom",
  /** 同じ自治体・税種別のポリシー、または同じ拠点・部屋に適用済みのポリシーと有効期間が重なる */
  OverlappingEffectivePeriod: "OverlappingEffectivePeriod",
  /** 有効終了日より後の泊の税額計算に使われている */
  UsedAfterEffectiveTo: "UsedAfterEffectiveTo",
} as const;

export type InternalUpdateLocalTaxPolicyErrorCase =
  (typeof InternalUpdateLocalTaxPolicyErrorCase)[keyof typeof InternalUpdateLocalTaxPolicyErrorCase];
export type InternalUpdateLocalTaxPolicyInput = {
  /** 有効終了日（この日を含む） */
  effectiveTo: Scalars["PlainDate"]["input"];
};

export type InternalUpdateLocalTaxPolicyPayload =
  | InternalUpdateLocalTaxPolicyError
  | LocalTaxPolicy;

export type InternalUpdateRoomTypeContentInput = {
  /** 紹介文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** ヒーロー画像一覧（全量置き換え）。省略時は更新しない。 */
  heroImages?: InputMaybe<Array<UploadedFileInput>>;
};

export type InternalUpdateRoomTypeInput = {
  /** 建築タイプ ID */
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 自社サービス向け多言語表示名 */
  displayNames?: InputMaybe<InternalLocalizedStringInput>;
  /** 紐付ける特徴 ID リスト（全量置き換え） */
  featureIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** OTA / Beds24 側の名前（変更すると Beds24 にも反映される） */
  name: Scalars["String"]["input"];
  /** 多言語備考 */
  notes?: InputMaybe<InternalLocalizedStringInput>;
  /** URL 用 slug（site 内でユニーク） */
  slug?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalUpdateSiteActivityProgramInput = {
  externalUrl?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<UploadedFileInput>;
  localizedDescription?: InputMaybe<InternalLocalizedStringInput>;
  localizedTitle?: InputMaybe<InternalLocalizedStringInput>;
  /** 掲載終了日時。null で未設定（無期限）に戻す。フィールドを省略すると変更しない */
  publishEndAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載開始日時。null で未設定（即時掲載）に戻す。フィールドを省略すると変更しない */
  publishStartAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載する拠点 ID 一覧（指定した場合は全置換） */
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** 拠点コンテンツ更新の入力 */
export type InternalUpdateSiteContentInput = {
  /** 住所: 町名・番地以降（建物名・部屋番号を含む。多言語） */
  addressLine?: InputMaybe<InternalLocalizedStringInput>;
  /** 住所: 市区町村（多言語） */
  city?: InputMaybe<InternalLocalizedStringInput>;
  /** 拠点紹介文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Google Maps レビュー URL */
  googleMapsReviewUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Google Maps URL */
  googleMapsUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** ヒーロー画像（既存を全置換する。undefined のときは更新しない） */
  heroImages?: InputMaybe<Array<UploadedFileInput>>;
  /** 路面凍結情報URL */
  iceRoadInfoUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 緯度 */
  latitude?: InputMaybe<Scalars["Float"]["input"]>;
  /** 経度 */
  longitude?: InputMaybe<Scalars["Float"]["input"]>;
  /** 拠点マップ画像URL */
  mapImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 駐車場の台数表記（例: 各部屋1台） */
  parkingCapacity?: InputMaybe<Scalars["String"]["input"]>;
  /** 駐車場の注釈 */
  parkingInfo?: InputMaybe<Scalars["String"]["input"]>;
  /** 住所: 郵便番号（言語非依存） */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** 住所: 都道府県（多言語） */
  prefecture?: InputMaybe<InternalLocalizedStringInput>;
};

/** 拠点更新時のエラー */
export type InternalUpdateSiteError = {
  __typename: "InternalUpdateSiteError";
  case: InternalUpdateSiteErrorCase;
  message: Scalars["String"]["output"];
};

/** 拠点更新時のエラー種別 */
export const InternalUpdateSiteErrorCase = {
  /** 運用グループの設定が無い部屋があるため、公開できない */
  OperationGroupSettingMissing: "OperationGroupSettingMissing",
  /** 並行更新により楽観ロックが競合した（再読み込みして再試行） */
  OptimisticLockConflict: "OptimisticLockConflict",
  /** 指定した RemoteLOCK Location ID が RemoteLOCK に存在しない */
  RemoteLockLocationNotFound: "RemoteLockLocationNotFound",
  /** ページを公開していない状態で予約を受け付けようとした */
  SiteNotPublished: "SiteNotPublished",
} as const;

export type InternalUpdateSiteErrorCase =
  (typeof InternalUpdateSiteErrorCase)[keyof typeof InternalUpdateSiteErrorCase];
/** 拠点ハイシーズン期間の更新入力 */
export type InternalUpdateSiteHighSeasonPeriodInput = {
  /** 2027 年度以降の拠点追加料金 */
  additionalFeeAmount: Scalars["Int"]["input"];
  /** 終了日（1-31） */
  endDay: Scalars["Int"]["input"];
  /** 終了月（1-12） */
  endMonth: Scalars["Int"]["input"];
  /** ラベル */
  label: Scalars["String"]["input"];
  /** 開始日（1-31） */
  startDay: Scalars["Int"]["input"];
  /** 開始月（1-12） */
  startMonth: Scalars["Int"]["input"];
};

/** 拠点画像の更新結果 */
export type InternalUpdateSiteImagesPayload = InternalCommonError | Success;

/** 拠点更新の入力 */
export type InternalUpdateSiteInput = {
  /** チェックイン認証タイプ */
  checkInAuthenticationType?: InputMaybe<CheckInAuthenticationType>;
  /** カスタム予約リード月数（未設定の場合はデフォルトの3ヶ月） */
  customReservationLeadMonths?: InputMaybe<Scalars["Int"]["input"]>;
  /** 早期チェックイン可能かどうか */
  earlyCheckInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 多言語化された拠点名。全 locale 必須。 */
  localizedName?: InputMaybe<InternalLocalizedStringInput>;
  /** 拠点名 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 開業日 */
  openingDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点番号（例：1st, 2nd） */
  ordinalName?: InputMaybe<Scalars["String"]["input"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** RemoteLock の Location ID（null で紐づけ解除）。存在しない ID は保存時に拒否される */
  remoteLockLocationId?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約可能かどうか */
  reservable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** オーナー先行予約可能かどうか */
  reservableForOwnerEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** SwitchBot の拠点 API キー（null で解除）。省略時は変更しない */
  switchbotLocationApiKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** 拠点パラメータ更新時のエラー */
export type InternalUpdateSiteParametersError = {
  __typename: "InternalUpdateSiteParametersError";
  message: Scalars["String"]["output"];
};

/** 拠点パラメータ更新の入力 */
export type InternalUpdateSiteParametersInput = {
  /** 拠点の Google Maps レビュー URL */
  googleMapsReviewUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 開業日 */
  openingDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 予約可能かのフラグ */
  reservable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** オーナー向けの予約可能かのフラグ */
  reservableForOwnerEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 拠点パラメータ更新の結果 */
export type InternalUpdateSiteParametersPayload =
  | InternalSite
  | InternalUpdateSiteParametersError;

/** 拠点更新の結果 */
export type InternalUpdateSitePayload = InternalSite | InternalUpdateSiteError;

/** StayTicket更新の入力 */
export type InternalUpdateStayTicketInput = {
  /** 送付先メールアドレス（nullの場合は変更しない、空文字の場合はクリア） */
  destinationEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** 有効期限（nullの場合は変更しない） */
  expiresAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** ステータス（nullの場合は変更しない） */
  status?: InputMaybe<StayTicketStatusType>;
  /** 宿泊可能終了日（nullの場合は変更しない） */
  stayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 宿泊可能開始日（nullの場合は変更しない） */
  stayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

/** 無効なステータス変更（Expiredは直接設定不可） */
export type InternalUpdateStayTicketInvalidStatusError = {
  __typename: "InternalUpdateStayTicketInvalidStatusError";
  message: Scalars["String"]["output"];
};

/** 指定されたチケットIDが見つからない */
export type InternalUpdateStayTicketNotFoundError = {
  __typename: "InternalUpdateStayTicketNotFoundError";
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

/** StayTicket更新の結果 */
export type InternalUpdateStayTicketPayload =
  | InternalUpdateStayTicketInvalidStatusError
  | InternalUpdateStayTicketNotFoundError
  | StayTicket;

export type InternalUpdateUserInput = {
  addressInJapan?: InputMaybe<AddressInJapanInput>;
  addressInternational?: InputMaybe<AddressInternationalInput>;
  addressIsInJapan: Scalars["Boolean"]["input"];
  birthDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  carOwnershipStatus?: InputMaybe<UserProfileCarOwnershipStatus>;
  gender?: InputMaybe<GenderType>;
  householdComposition?: InputMaybe<UserProfileHouseholdComposition>;
  name: Scalars["String"]["input"];
  nameKana?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<CountryEnum>;
  numberOfDogs?: InputMaybe<Scalars["Int"]["input"]>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  passportPhoto?: InputMaybe<UploadedFileInput>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  professionFree?: InputMaybe<Scalars["String"]["input"]>;
  professionType?: InputMaybe<UserProfileProfessionType>;
};

export type InternalUpsertBaseAccommodationFeeDailyRateError = {
  __typename: "InternalUpsertBaseAccommodationFeeDailyRateError";
  /** エラーが発生したBeds24ルームID */
  beds24RoomId?: Maybe<Scalars["Int"]["output"]>;
  /** エラーが発生した日付 */
  date?: Maybe<Scalars["String"]["output"]>;
  /** エラーが発生したレコードのインデックス */
  index: Scalars["Int"]["output"];
  /** エラーメッセージ */
  message: Scalars["String"]["output"];
};

export type InternalUpsertBaseAccommodationFeeDailyRateInput = {
  /** 金額 */
  amount: Scalars["Int"]["input"];
  /** Beds24のルームID */
  beds24RoomId: Scalars["Int"]["input"];
  /** 日付 */
  date: Scalars["PlainDate"]["input"];
};

export type InternalUpsertBaseAccommodationFeeDailyRatesPayload = {
  __typename: "InternalUpsertBaseAccommodationFeeDailyRatesPayload";
  /** 作成されたレコードの数 */
  created: Scalars["Int"]["output"];
  /** 処理に失敗したレコードのエラー情報 */
  errors: Array<InternalUpsertBaseAccommodationFeeDailyRateError>;
  /** スキップされたレコードの数 */
  skipped: Scalars["Int"]["output"];
  /** 更新されたレコードの数 */
  updated: Scalars["Int"]["output"];
};

export type InternalUpsertConsumedSupplyFeeItemWaiversError = {
  __typename: "InternalUpsertConsumedSupplyFeeItemWaiversError";
  message: Scalars["String"]["output"];
};

export type InternalUpsertConsumedSupplyFeeItemWaiversInput = {
  accommodationReservationId: Scalars["ID"]["input"];
  /** 免除ルール一覧 */
  waivers: Array<ConsumedSupplyFeeItemWaiverInput>;
};

export type InternalUpsertConsumedSupplyFeeItemWaiversPayload =
  | InternalUpsertConsumedSupplyFeeItemWaiversError
  | Success;

/** ユーザー検索結果 */
export type InternalUserSearchResult = {
  __typename: "InternalUserSearchResult";
  /** 次のページがあるか */
  hasNextPage: Scalars["Boolean"]["output"];
  /** 検索結果の総件数 */
  totalCount: Scalars["Int"]["output"];
  /** ユーザー一覧 */
  users: Array<User>;
};

/** ユーザー統計情報 */
export type InternalUserStats = {
  __typename: "InternalUserStats";
  /** アクティブメンバー数（サブスクリプションステータスがUsable） */
  activeMembers: Scalars["Int"]["output"];
  /** ゲスト数（サブスクリプションステータスがNeutralでNeutralDefault） */
  guests: Scalars["Int"]["output"];
  /** 月次解約率（パーセント） */
  monthlyChurnRate: Scalars["Float"]["output"];
  /** 今月の新規登録数 */
  newSignupsThisMonth: Scalars["Int"]["output"];
  /** 総ユーザー数（削除されていないユーザー） */
  totalUsers: Scalars["Int"]["output"];
  /** 今後の予約があるユーザー数 */
  usersWithUpcomingReservations: Scalars["Int"]["output"];
};

export type InternalVoidCoOwnersApplicationError = {
  __typename: "InternalVoidCoOwnersApplicationError";
  case: InternalVoidCoOwnersApplicationErrorCase;
};

export const InternalVoidCoOwnersApplicationErrorCase = {
  /** 紐づくアクティブな予約があるため無効化不可 */
  HasActiveReservations: "HasActiveReservations",
  /** 未滞在の StayGift（Open / Reserved）が残っているため無効化不可 */
  HasActiveStayGifts: "HasActiveStayGifts",
  /** ステータスが引渡完了でないため無効化不可 */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 申込に紐づく UserOwnership が存在しない（データ不整合） */
  OwnershipNotFound: "OwnershipNotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
} as const;

export type InternalVoidCoOwnersApplicationErrorCase =
  (typeof InternalVoidCoOwnersApplicationErrorCase)[keyof typeof InternalVoidCoOwnersApplicationErrorCase];
export type InternalVoidCoOwnersApplicationPayload =
  | CoOwnersApplication
  | InternalVoidCoOwnersApplicationError;

export type InviteBusinessMembersError = {
  __typename: "InviteBusinessMembersError";
  case: InviteBusinessMembersErrorCase;
};

export const InviteBusinessMembersErrorCase = {
  /** 送信対象のメールアドレスが 0 件 */
  EmptyEmails: "EmptyEmails",
  /** 送信対象のメールアドレスが 100 件を超えている */
  ExceedsMaxRecipients: "ExceedsMaxRecipients",
  /** 入力にメール形式として不正なアドレスが含まれている */
  InvalidEmailFormat: "InvalidEmailFormat",
  /** viewer が対象組織の Admin ではない */
  NotOrganizationAdmin: "NotOrganizationAdmin",
} as const;

export type InviteBusinessMembersErrorCase =
  (typeof InviteBusinessMembersErrorCase)[keyof typeof InviteBusinessMembersErrorCase];
export type InviteBusinessMembersInput = {
  /** 招待するメールアドレス。最大 100 件。 */
  emails: Array<Scalars["String"]["input"]>;
};

export type InviteBusinessMembersPayload =
  | InviteBusinessMembersError
  | InviteBusinessMembersSuccess;

export type InviteBusinessMembersSuccess = {
  __typename: "InviteBusinessMembersSuccess";
  /** 実際に招待メール送信を試みた件数（既存所属メンバー除外後の残数）。 */
  sentCount: Scalars["Int"]["output"];
};

export type IssueSanuEdgeDeviceAccessTokenError = {
  __typename: "IssueSanuEdgeDeviceAccessTokenError";
  case: IssueSanuEdgeDeviceAccessTokenErrorCase;
};

export const IssueSanuEdgeDeviceAccessTokenErrorCase = {
  /** デバイスにアクセスできない（時間外など） */
  DeviceNotAccessible: "DeviceNotAccessible",
  /** 施設に該当デバイスがない */
  NoDevice: "NoDevice",
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
  /** 予約の所有者でない */
  Unauthorized: "Unauthorized",
} as const;

export type IssueSanuEdgeDeviceAccessTokenErrorCase =
  (typeof IssueSanuEdgeDeviceAccessTokenErrorCase)[keyof typeof IssueSanuEdgeDeviceAccessTokenErrorCase];
export type IssueSanuEdgeDeviceAccessTokenInput = {
  /** 対象の予約ID */
  accommodationReservationId: Scalars["ID"]["input"];
  /** 対象のデバイス種別 */
  deviceType: SanuEdgeDeviceType;
};

export type IssueSanuEdgeDeviceAccessTokenPayload =
  | IssueSanuEdgeDeviceAccessTokenError
  | IssueSanuEdgeDeviceAccessTokenSuccess;

export type IssueSanuEdgeDeviceAccessTokenSuccess = {
  __typename: "IssueSanuEdgeDeviceAccessTokenSuccess";
  /** トークンが発行されたデバイス */
  device: SanuEdgeDevice;
  /** MQTTセッション用JWTトークン */
  token: Scalars["String"]["output"];
};

export type IssueStayTicketsError = {
  __typename: "IssueStayTicketsError";
  case: IssueStayTicketsErrorCase;
};

export const IssueStayTicketsErrorCase = {
  InvalidRequest: "InvalidRequest",
} as const;

export type IssueStayTicketsErrorCase =
  (typeof IssueStayTicketsErrorCase)[keyof typeof IssueStayTicketsErrorCase];
export type IssueStayTicketsInput = {
  lineId?: InputMaybe<Scalars["String"]["input"]>;
  templateKey: Scalars["String"]["input"];
};

export type IssueStayTicketsPayload =
  | IssueStayTicketsError
  | IssueStayTicketsResult;

export type IssueStayTicketsResult = {
  __typename: "IssueStayTicketsResult";
  tickets: Array<StayTicket>;
};

export type JoinOrganizationError = {
  __typename: "JoinOrganizationError";
  case: JoinOrganizationErrorCase;
};

export const JoinOrganizationErrorCase = {
  /** すでに法人組織に所属している */
  AlreadyBelongsToOrganization: "AlreadyBelongsToOrganization",
} as const;

export type JoinOrganizationErrorCase =
  (typeof JoinOrganizationErrorCase)[keyof typeof JoinOrganizationErrorCase];
export type JoinOrganizationPayload = JoinOrganizationError | Success;

export type LeaveOrganizationByViewerError = {
  __typename: "LeaveOrganizationByViewerError";
  case: LeaveOrganizationErrorCase;
};

export type LeaveOrganizationByViewerPayload =
  | LeaveOrganizationByViewerError
  | Success;

export type LeaveOrganizationError = {
  __typename: "LeaveOrganizationError";
  case: LeaveOrganizationErrorCase;
};

export const LeaveOrganizationErrorCase = {
  /** 未来の予約を保持している */
  HasActiveReservation: "HasActiveReservation",
  /** 組織に所属していない */
  NotBelongsToOrganization: "NotBelongsToOrganization",
} as const;

export type LeaveOrganizationErrorCase =
  (typeof LeaveOrganizationErrorCase)[keyof typeof LeaveOrganizationErrorCase];
/** Bubble からデータを取り込むためのマイグレーションツールの実行結果 */
export type LoadDataOutput = {
  __typename: "LoadDataOutput";
  results: Array<LoadDataOutputResult>;
};

/** マイグレーションツールのタスクごとの実行結果 */
export type LoadDataOutputResult = {
  __typename: "LoadDataOutputResult";
  destinationTable: Scalars["String"]["output"];
  errorRecords: Scalars["Int"]["output"];
  errors: Array<LoadDataOutputResultError>;
  ignoredRecords: Scalars["Int"]["output"];
  insertedRecords: Scalars["Int"]["output"];
  sourceRecords: Scalars["Int"]["output"];
  sourceTable: Scalars["String"]["output"];
};

export type LoadDataOutputResultError = {
  __typename: "LoadDataOutputResultError";
  data?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  position: Scalars["String"]["output"];
};

export const LoadDataTarget = {
  All: "all",
  Announcement: "announcement",
  Asset: "asset",
  Business: "business",
  Owner: "owner",
  Reservation: "reservation",
  Ticket: "ticket",
  User: "user",
} as const;

export type LoadDataTarget =
  (typeof LoadDataTarget)[keyof typeof LoadDataTarget];
/** 地方税の金額区分。1 人 1 泊あたりの課税対象宿泊費（税抜）が [minAmount, maxAmount) に入るときに適用される */
export type LocalTaxBracket = {
  __typename: "LocalTaxBracket";
  id: Scalars["ID"]["output"];
  /** 1 人 1 泊あたり課税対象宿泊費の上限（この値を含まない）。null は上限なし */
  maxAmount?: Maybe<Scalars["Decimal"]["output"]>;
  /** 1 人 1 泊あたりの税額の上限。FixedRate で使う */
  maxTaxAmount?: Maybe<Scalars["Decimal"]["output"]>;
  /** 1 人 1 泊あたり課税対象宿泊費の下限（この値を含む） */
  minAmount: Scalars["Decimal"]["output"];
  /** 1 人 1 泊あたりの税額。FixedAmount / SteppedAmount で使う */
  taxAmount?: Maybe<Scalars["Decimal"]["output"]>;
  /** 税率（3% は 0.03）。FixedRate で使う */
  taxRate?: Maybe<Scalars["Decimal"]["output"]>;
};

/**
 * 自治体ごとの地方税（宿泊税・入湯税）の課税設定。
 * 税額は滞在実績に基づきチェックアウト時に確定するため、予約時点では確定できず金額は公開しない。
 */
export type LocalTaxPolicy = {
  __typename: "LocalTaxPolicy";
  /** このポリシーを入湯税として適用している部屋 */
  accommodations: Array<Accommodation>;
  /** 金額区分。minAmount の昇順 */
  brackets: Array<LocalTaxBracket>;
  /** 有効開始日（この日を含む） */
  effectiveFrom: Scalars["PlainDate"]["output"];
  /** 有効終了日（この日を含む）。null は無期限 */
  effectiveTo?: Maybe<Scalars["PlainDate"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 自治体名（例: 白馬村） */
  localGovernmentName: Scalars["String"]["output"];
  /** このポリシーを宿泊税として適用している拠点 */
  sites: Array<InternalSite>;
  taxType: LocalTaxType;
  /** 算出タイプ */
  type: LocalTaxPolicyType;
  /** 子供を課税対象から除外するか */
  waiveKids: Scalars["Boolean"]["output"];
};

/** 地方税ポリシーの算出タイプ */
export const LocalTaxPolicyType = {
  /** 一律定額 */
  FixedAmount: "FixedAmount",
  /** 一律比率 */
  FixedRate: "FixedRate",
  /** 段階的定額 */
  SteppedAmount: "SteppedAmount",
} as const;

export type LocalTaxPolicyType =
  (typeof LocalTaxPolicyType)[keyof typeof LocalTaxPolicyType];
/** 地方税の種別 */
export const LocalTaxType = {
  /** 宿泊税 */
  AccommodationTax: "AccommodationTax",
  /** 入湯税 */
  BathingTax: "BathingTax",
} as const;

export type LocalTaxType = (typeof LocalTaxType)[keyof typeof LocalTaxType];
/** メンバー特典として提供されるNOWHEREのドリンクチケット */
export type MemberPerksNowhereDrinkTicket = {
  __typename: "MemberPerksNowhereDrinkTicket";
  /** ドリンクチケットの利用状況 */
  used: Scalars["Boolean"]["output"];
  /** ドリンクチケットの利用時間 */
  usedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** ドリンクチケットの対象メンバー */
  user: User;
};

/** Music Connect 機器の固有情報 */
export type MusicConnectEquipmentAttribute = {
  __typename: "MusicConnectEquipmentAttribute";
  /** 使い方の説明（マークダウン形式） */
  instruction: Scalars["String"]["output"];
};

export type Mutation = {
  __typename: "Mutation";
  /** 宿泊予約を受け取る */
  acceptAccommodationReservation: AcceptAccommodationReservationPayload;
  /** 宿泊チケットを購入する */
  acquireStayTickets: AcquireStayTicketsPayload;
  /** メンバー特典が利用可能な場合に利用する */
  activateMemberPerksDrinkTicket: ActivateMemberPerksDrinkTicketPayload;
  /**
   * 規約の改定に同意する
   * 同意済みの改定を指定した場合も Success を返す
   */
  agreeToTerms: AgreeToTermsPayload;
  /**
   * Weekdayプラン規約改定に同意する
   * @deprecated 規約の同意は Terms / TermsRevision に統合した。同意は agreeToTerms で記録する
   */
  agreeToWeekdayTerms: AgreeToWeekdayTermsPayload;
  /** Trialプランのサブスクリプションに申し込む */
  applyToTrialSubscription: ApplyToTrialSubscriptionPayload;
  /** ウィークデープランのサブスクリプションに申し込む */
  applyToWeekdaySubscription: ApplyToWeekdaySubscriptionPayload;
  /** 宿泊予約に同伴者を割り当てる */
  assignUserCompanions: Array<UserCompanion>;
  /**
   * 宿泊チケットをバリデーションした上でまとめたIDとして取得する
   * 先頭の宿泊チケットから順番にバリデーションが行われる。
   */
  bundleStayTickets: BundleStayTicketsPayload;
  /** 宿泊予約をキャンセルする */
  cancelAccommodationReservation: CancelAccommodationReservationPayload;
  /** CoOwners の申し込みをキャンセルする */
  cancelCoOwnersApplication: CancelCoOwnersApplicationPayload;
  /** 付帯サービス予約をキャンセルする */
  cancelFacilityReservation: CancelFacilityReservationPayload;
  /** スタンダードプランのサブスクリプションの申し込みをキャンセルする */
  cancelStandardSubscriptionApplication: CancelStandardSubscriptionApplicationPayload;
  /** スタンダードプランのサブスクリプションの休会申し込みをキャンセルする */
  cancelStandardSubscriptionPause: CancelStandardSubscriptionPausePayload;
  /** スタンダードプランのサブスクリプションの休会復帰を取り止めて解約する */
  cancelStandardSubscriptionResume: CancelStandardSubscriptionResumePayload;
  /** スタンダードプランのサブスクリプションの解約申し込みをキャンセルする */
  cancelStandardSubscriptionTermination: CancelStandardSubscriptionTerminationPayload;
  /** Co-Owners/Ownersが自分が発行したStay Giftチケットをキャンセルする */
  cancelStayGifts: CancelStayGiftsPayload;
  /** Trialプランのサブスクリプションをキャンセルする */
  cancelTrialSubscription: CancelTrialSubscriptionPayload;
  /** 宿泊施設のブロックを変更する */
  changeAccommodationAvailabilityBlock: Scalars["Boolean"]["output"];
  /** 宿泊予約を変更する */
  changeAccommodationReservation: ChangeAccommodationReservationPayload;
  /** チェックインを行う */
  checkInAccommodationReservation: CheckInAccommodationReservationPayload;
  /**
   * チェックアウトを行う（最終チェックのみ。滞在レビューは任意で別途送信する）
   * id は宿泊予約のID
   */
  checkOutAccommodationReservation: CheckOutAccommodationReservationPayload;
  /**
   * チェックアウトと同時に新滞在レビューを保存する
   * id は宿泊予約のID
   * @deprecated 旧 nativeapp の後方互換のため残す。新規実装は checkOutAccommodationReservation を使う
   */
  checkOutAccommodationReservationWithStayReviewResponse: CheckOutAccommodationReservationPayload;
  /** アイデンティティ追加の新プロバイダーコールバックを処理する（Step 3） */
  completeAddIdentity: CompleteAddIdentityPayload;
  /** 仮押さえの宿泊予約を確定する */
  confirmTentativeAccommodationReservation: ConfirmTentativeAccommodationReservationPayload;
  /** Bubbleでアップロードしたファイルを移行する */
  copyFilesToS3: Scalars["Boolean"]["output"];
  /** 宿泊施設の利用ブロックをする */
  createAccommodationAvailabilityBlock: Scalars["Boolean"]["output"];
  /**
   * 宿泊予約を作成する
   * WebUIの予約画面で作られた一時予約を元に作成
   */
  createAccommodationReservation: CreateAccommodationReservationPayload;
  /** 申込のファイルをダウンロードするための URL を発行する。発行はダウンロード履歴として記録される */
  createCoOwnersApplicationFileDownloadUrl: CreateCoOwnersApplicationFileDownloadUrlPayload;
  /**
   * 申込にファイルをアップロードするためのポリシーを生成する。
   * アップロード後に registerCoOwnersApplicationFile で申込に紐づける
   */
  createCoOwnersApplicationFileUploadPolicy: FileUploadPolicyPayload;
  /** 付帯サービス予約を作成する */
  createFacilityReservation: CreateFacilityReservationPayload;
  /** FullOwnerの利用規約をアップロードするためのポリシーを生成する */
  createFullOwnerContractUploadPolicy: FileUploadPolicyPayload;
  /** プッシュ通知のためのデバイス情報を登録・更新する */
  createOrUpdateUserAppInstallation: CreateOrUpdateUserAppInstallationPayload;
  /**
   * OwnerPlanに対するパブリックなファイルをアップロードするためのポリシーを生成する
   * // NOTE: 設計としてファイルアップロードを一般化したい
   */
  createSanuOwnerPlanFileUploadPolicy: FileUploadPolicyPayload;
  /**
   * OwnerPlanに対するユーザに紐づくファイルをアップロードするためのポリシーを生成する
   * // NOTE: 設計としてファイルアップロードを一般化したい
   */
  createSanuOwnerPlanUserFileUploadPolicy: FileUploadPolicyPayload;
  /** 指定された組織に紐づく形で Stripe のカードタイプの SetupIntent を作成し、クライアントシークレットを返す */
  createStripeCardSetupIntentOfOrganization: CreateStripeCardSetupIntentOfOrganizationPayload;
  /** 現在のユーザーに紐づく形で Stripe のカードタイプの SetupIntent を作成し、クライアントシークレットを返す */
  createStripeCardSetupIntentOfViewer: CreateStripeCardSetupIntentOfViewerPayload;
  /** 同伴者を追加する */
  createUserCompanion: UserCompanion;
  /** ユーザに紐づくファイルをアップロードするためのポリシーを生成する */
  createUserFileUploadPolicy: FileUploadPolicyPayload;
  /**
   * WebView用のセッションURLを生成する。
   * ネイティブアプリがAuth0アクセストークンで認証後、
   * WebView内で使用する短期セッションを確立するためのURLを返す。
   */
  createWebviewSession: CreateWebviewSessionPayload;
  /** 宿泊施設のブロックを解除する */
  deleteAccommodationAvailabilityBlock?: Maybe<Scalars["Boolean"]["output"]>;
  /** プッシュ通知のためのデバイス情報を削除する */
  deleteUserAppInstallation: DeleteUserAppInstallationPayload;
  /** 同伴者を削除する */
  deleteUserCompanion: Success;
  /** ユーザー削除（退会） */
  deleteViewer: DeleteViewerPayload;
  /** アカウント連携を完了する（OAuth codeをトークンに交換し、Auth0 /continueへのURLを返す） */
  finalizeAccountLink: FinalizeAccountLinkPayload;
  /** チェックイン用QRコードを生成する */
  generateCheckInQrCode: GenerateCheckInQrCodePayload;
  /** スタンダードプランのサブスクリプションを今すぐ開始する */
  immediatelyApplyToStandardSubscriptionForDevelop: Scalars["Boolean"]["output"];
  /** スタンダードプランのサブスクリプションを今すぐ終了する */
  immediatelyCancelStandardSubscriptionForDevelop: Scalars["Boolean"]["output"];
  /** アカウント連携を開始する（OAuth認証のリダイレクトURLを生成） */
  initiateAccountLink: InitiateAccountLinkPayload;
  /** 設定画面からアイデンティティ（ソーシャルログイン）を追加開始する */
  initiateAddIdentity: InitiateAddIdentityPayload;
  /** 地方税ポリシーを拠点または部屋に適用する。 */
  internalAddLocalTaxPolicy: InternalAddLocalTaxPolicyPayload;
  /**
   * 管理者向け：オーナーの宿泊権利を調整する
   * amount が正の値の場合は付与、負の値の場合は消化として記録される
   */
  internalAdjustOwnerStayCredit: InternalAdjustOwnerStayCreditPayload;
  /**
   * スタッフプランの宿泊クレジットを手動調整する
   * 正の値で付与、負の値で減算
   */
  internalAdjustStaffCredits: InternalAdjustStaffCreditsResult;
  /**
   * 指定した金額の Co-Owners充当特典（旧S2Oポイント）を CoOwnersApplication に適用する。
   * 利用上限（cap）や申込日までのポイント制限は適用しない。
   * 保持ポイント以上の金額は指定できない。
   */
  internalAppendS2oPointsToCoOwnersApplication: InternalAppendS2oPointsToCoOwnersApplicationPayload;
  /**
   * 予約のお客様向けキー（RemoteLock Booking）を現在の予約状態に同期する（worker経由で呼び出される）。
   * bookingId はキャンセル時のみ渡す（予約行の反映列はキャンセル時に null 済みで、実行時に読み直せない）。
   */
  internalApplyGuestAccessKey: InternalApplyGuestAccessKeyPayload;
  /**
   * 施設のアクセスキーを適用する（worker経由で呼び出される）。
   * 発行スコープだけを受け取り、拠点とロックデバイスは accommodationId から実行時に引き直す。
   * siteId は拠点スコープ（SiteManager）のときのみ渡す。
   */
  internalApplyStaffAccessKey: InternalApplyStaffAccessKeyPayload;
  /** 宿泊予約に対して RemoteLOCK の予約を発行して、暗証番号を割り当てる */
  internalAssignAccessCodeToAccommodationReservation: InternalAssignAccessCodeToAccommodationReservationPayload;
  /**
   * 管理ロールを付与する。付与先は input.userId か input.email で指定し、email はサーバーでユーザーに解決する
   * （該当が無ければ UserNotFound）。拠点スコープの付与権（PartnerSiteManager）では input.siteId が自分の拠点に限られる
   */
  internalAssignAdminRole: InternalAssignAdminRolePayload;
  internalBeds24CreateOrUpdateBlackBooking: Scalars["Boolean"]["output"];
  internalBeds24CreateOrUpdateBlackBookings: Scalars["Boolean"]["output"];
  internalBeds24CreateOrUpdateBooking: Scalars["Boolean"]["output"];
  internalBeds24DeleteBlackBookings: Scalars["Boolean"]["output"];
  /**
   * beds24 invite code を refresh token に交換する
   * （IP 環境・ローカル開発環境の Admin 限定）。
   * 返り値の refreshToken を環境変数 BEDS24_REFRESH_TOKEN に設定して使う
   */
  internalBeds24ExchangeInviteCode: Scalars["String"]["output"];
  internalBeds24ProcessWebhookEvent: Beds24WebhookResultPayload;
  internalBeds24SendBookingMessage: Beds24BookingMessageResultPayload;
  internalBeds24SendGuestMessageAutoReply: Scalars["Boolean"]["output"];
  internalBeds24SyncFollowingReservations: Array<Beds24SyncFollowingReservationsResultPayload>;
  /**
   * 今日以降の Beds24 OTA calendar を DB rate + 運用ルール (CoOwners × 繁忙日 → blackout) から
   * 再生成し全量再送する。 運用タイプ変更後の即時反映 / cutover 前の検算などに使う。
   */
  internalBeds24SyncFuturePrices: InternalBeds24SyncFuturePricesResult;
  /** 予約ブロックを一括で作成する */
  internalBulkCreateAccommodationAvailabilityBlocks: InternalBulkCreateAccommodationAvailabilityBlocksPayload;
  /** 法人向けの年間契約の請求書を一括作成する（年払いの場合は1件、月払いの場合は12件の請求書を作成） */
  internalBulkCreateOrganizationYearlyContractInvoices: InternalBulkCreateOrganizationYearlyContractInvoicesPayload;
  /** 予約ブロックを一括で解除する */
  internalBulkDeleteAccommodationAvailabilityBlocks: InternalBulkDeleteAccommodationAvailabilityBlocksPayload;
  /** シーズン料金設定を一括で作成/更新/削除する */
  internalBulkUpdateSeasonalFeeSettings: InternalBulkUpdateSeasonalFeeSettingsPayload;
  /** チケットマスタを一括更新する */
  internalBulkUpdateStayTicketMasters: InternalBulkUpdateStayTicketMastersPayload;
  /** Admin画面から、宿泊予約をキャンセル */
  internalCancelAccommodationReservation: CancelAccommodationReservationPayload;
  /** Co-Owners 申し込みをキャンセルする */
  internalCancelCoOwnersApplication: InternalCancelCoOwnersApplicationPayload;
  /** 付帯サービス予約をキャンセルする */
  internalCancelFacilityReservation: CancelFacilityReservationPayload;
  /** IP 環境 beds24 セットアップを強制終了する（クリーンアップなし） */
  internalCancelIpBeds24Setup: Scalars["Boolean"]["output"];
  /** Admin画面から、宿泊予約を変更する */
  internalChangeAccommodationReservation: ChangeAccommodationReservationPayload;
  /** 管理者が任意の予約に対してチェックインを行う */
  internalCheckInAccommodationReservation: CheckInAccommodationReservationPayload;
  /** 既存のBeds24プロパティIDを拠点に紐付ける */
  internalConnectBeds24Property: InternalSite;
  /** ブロック解放スケジュールを作成する（管理者向け） */
  internalCreateAccommodationAvailabilityBlockReleaseSchedule: AccommodationAvailabilityBlockReleaseSchedule;
  /** 機器を登録する */
  internalCreateAccommodationEquipment: InternalCreateAccommodationEquipmentPayload;
  /**
   * 運用グループを設定値 1 件つきで作成する。
   * 設定値の effectiveFrom は 2027-04-01 固定で作成される。
   * 予約可能期間の計算は 2027-04-01 時点の運用タイプだけを参照しているため、
   * 別の日付にすると運用タイプを解決できず、設定値のない泊の料金計算が失敗する
   */
  internalCreateAccommodationOperationGroup: InternalCreateAccommodationOperationGroupPayload;
  /**
   * Admin画面から、宿泊予約を作成する
   * WebUIの予約画面で作られた一時予約を元に作成
   */
  internalCreateAccommodationReservation: CreateAccommodationReservationPayload;
  /** 建築コンテンツ画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateArchitectureContentImageUploadPolicy: FileUploadPolicyPayload;
  /** エリアを作成する */
  internalCreateArea: InternalArea;
  /** エリアガイド記事のサムネイル画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateAreaGuideArticleImageUploadPolicy: FileUploadPolicyPayload;
  /** エリア画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateAreaImageUploadPolicy: FileUploadPolicyPayload;
  /** 申込のファイル（非表示のものを含む）をダウンロードするための URL を発行する */
  internalCreateCoOwnersApplicationFileDownloadUrl: CreateCoOwnersApplicationFileDownloadUrlPayload;
  /** 管理者が申込者の領域にファイルをアップロードするためのポリシーを生成する */
  internalCreateCoOwnersApplicationFileUploadPolicy: FileUploadPolicyPayload;
  /** Co-Owners 申込の本人確認レコードを手動で作成する */
  internalCreateCoOwnersIdentityVerification: InternalCreateCoOwnersIdentityVerificationPayload;
  /**
   * 有料備品の利用実績を踏まえて、宿泊料金決済の中に請求項目を入れ込む
   * 清掃・備品管理を行う Bubble のシステムから呼ばれる
   */
  internalCreateConsumedSuppliesFeeItems: InternalCreateConsumedSuppliesFeeItemsPayload;
  /** 付帯サービスを新規作成する */
  internalCreateFacility: InternalCreateOrUpdateFacilityPayload;
  /** 設備画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateFacilityImageUploadPolicy: FileUploadPolicyPayload;
  /** 付帯サービス予約を作成する */
  internalCreateFacilityReservation: InternalCreateFacilityReservationPayload;
  /**
   * Full-Owner 契約の本人確認レコードを作成する
   * userId は本人確認を行うユーザーで、法人契約では取引担当者を指定する
   */
  internalCreateFullOwnerIdentityVerification: InternalCreateFullOwnerIdentityVerificationPayload;
  /** 地方税ポリシーを金額区分とあわせて登録する。 */
  internalCreateLocalTaxPolicy: InternalCreateLocalTaxPolicyPayload;
  /** アプリホーム画面コンテンツの画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateNativeAppHomeContentImageUploadPolicy: FileUploadPolicyPayload;
  /** 管理者向けに、部屋（Accommodation）を追加・更新する */
  internalCreateOrUpdateAccommodation: InternalCreateOrUpdateAccommodationPayload;
  /** 宿泊施設コンテンツを作成・更新する */
  internalCreateOrUpdateAccommodationContent: Accommodation;
  /** 宿泊施設お知らせを追加・更新する（管理者向け） */
  internalCreateOrUpdateAccommodationNotice: InternalCreateOrUpdateAccommodationNoticePayload;
  /** 追加ゲスト料金ポリシーの新規追加・編集 */
  internalCreateOrUpdateAdditionalGuestFeePolicy: InternalCreateOrUpdateAdditionalGuestFeePolicyPayload;
  /** 建築タイプを作成・更新する。IDが空であれば新規作成となる */
  internalCreateOrUpdateArchitectureType: ArchitectureType;
  /** エリアガイド記事を作成・更新する。掲載対象エリアは areaIds で全置換する */
  internalCreateOrUpdateAreaGuideArticle: AreaGuideArticle;
  /** エリアおすすめスポットを作成・更新する */
  internalCreateOrUpdateAreaGuideSpot: AreaGuideSpot;
  /** 基本宿泊料金ポリシーの新規追加・編集 */
  internalCreateOrUpdateBaseAccommodationFeePolicy: InternalCreateOrUpdateBaseAccommodationFeePolicyPayload;
  /**
   * Beds24プロパティを拠点に作成・連携する。既にbeds24PropertyIdが設定されている
   * 拠点の場合は、新規作成ではなく既存プロパティの情報を最新の値で同期する
   */
  internalCreateOrUpdateBeds24Property: InternalSite;
  /** 法人プランを作成・更新する */
  internalCreateOrUpdateBusinessPlan: InternalCreateOrUpdateBusinessPlanPayload;
  /** キャンセル料金ポリシーの新規追加・編集 */
  internalCreateOrUpdateCancelFeePolicy: InternalCreateOrUpdateCancelFeePolicyPayload;
  /** CoOwnersPlanOffering を追加・更新する */
  internalCreateOrUpdateCoOwnersPlanOffering: InternalCreateOrUpdateCoOwnersPlanOfferingPayload;
  /** Co-Owners 重要事項説明会スケジュールを作成・更新する */
  internalCreateOrUpdateCoOwnersWebinarSchedule: InternalCreateOrUpdateCoOwnersWebinarSchedulePayload;
  /** 建築家マスタを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentArchitect: InternalCreateOrUpdateContentArchitectPayload;
  /** 設備コンテンツを作成・更新する。設備 1 件につき 1 件で、未作成なら作成する */
  internalCreateOrUpdateContentArchitecturalFeature: InternalCreateOrUpdateContentArchitecturalFeaturePayload;
  /** 設備コンテンツの利用ルールを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentArchitecturalFeatureUsageRule: InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload;
  /**
   * 建築タイプコンテンツを作成・更新する。
   * コンテンツ行が無い建築タイプでは新規作成となり、その場合 architectId が必須
   */
  internalCreateOrUpdateContentArchitectureType: InternalCreateOrUpdateContentArchitectureTypePayload;
  /** 基本の設備マスタを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentArchitectureTypeBasicAmenity: InternalCreateOrUpdateContentBasicAmenityPayload;
  /**
   * 建築タイプのバリエーション / オプションを作成・更新する。id を省略すると新規作成。
   * kind はテーブルを決めるので、作成後は変更できない
   */
  internalCreateOrUpdateContentArchitectureTypeVariant: InternalCreateOrUpdateContentArchitectureTypeVariantPayload;
  /** 設備アメニティを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentFacilityAmenity: InternalCreateOrUpdateContentFacilityAmenityPayload;
  /**
   * 付帯サービスソースのブロックを作成・更新する
   * idを指定すると既存ブロックを更新、省略すると新規作成
   */
  internalCreateOrUpdateFacilityResourceBlock: InternalCreateOrUpdateFacilityResourceBlockPayload;
  /** ネイティブアプリのホームコンテンツを作成または更新 */
  internalCreateOrUpdateNativeAppHomeContent: InternalCreateOrUpdateNativeAppHomeContentPayload;
  /** お知らせを追加・更新する（管理者向け） */
  internalCreateOrUpdateNews: InternalCreateOrUpdateNewsPayload;
  /** 法人を作成・更新する */
  internalCreateOrUpdateOrganization: InternalCreateOrUpdateOrganizationPayload;
  /** 法人の年間契約を作成・更新する */
  internalCreateOrUpdateOrganizationYearlyContract: InternalCreateOrUpdateOrganizationYearlyContractPayload;
  /** 法人向けの年間契約の請求書を作成・更新する */
  internalCreateOrUpdateOrganizationYearlyContractInvoice: InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload;
  /** OwnerPlan を作成または更新する */
  internalCreateOrUpdateOwnerPlan: InternalCreateOrUpdateOwnerPlanPayload;
  /**
   * 拠点アクセスルートグループを作成・更新する。
   * points は与えられた配列で全置換する（IDの引き継ぎは行わない）。
   */
  internalCreateOrUpdateSiteAccessRouteGroup: SiteAccessRouteGroup;
  /** 拠点FAQを追加・更新する（管理者向け） */
  internalCreateOrUpdateSiteFaq: InternalCreateOrUpdateSiteFaqPayload;
  /** 社内スタッフグループを作成または更新する */
  internalCreateOrUpdateStaffGroup: InternalCreateOrUpdateStaffGroupPayload;
  /** チケットマスターの新規追加・編集 */
  internalCreateOrUpdateStayTicketMaster: InternalCreateOrUpdateStayTicketMasterPayload;
  /** チケットマスター雛形の新規追加・編集 */
  internalCreateOrUpdateStayTicketMasterTemplate: InternalCreateOrUpdateStayTicketMasterTemplatePayload;
  internalCreateOrUpdateStayTicketTemplate: InternalCreateStayTicketTemplatePayload;
  /** 備品の設置情報を作成・更新する */
  internalCreateOrUpdateSupplyItemInstallations: InternalCreateOrUpdateSupplyItemInstallationsPayload;
  /** 備品マスタを作成または更新する */
  internalCreateOrUpdateSupplyItemMaster: InternalCreateOrUpdateSupplyItemMasterPayload;
  /** OTAルームユニットを作成する（宿泊施設をルームタイプに割り当てる） */
  internalCreateOtaRoomUnit: InternalOtaRoomUnit;
  /** OTAルームタイプを作成し、Beds24にルームを自動作成する */
  internalCreateRoomType: InternalRoomType;
  /** 部屋タイプ画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateRoomTypeImageUploadPolicy: FileUploadPolicyPayload;
  /** 拠点を作成する */
  internalCreateSite: InternalCreateSitePayload;
  /** Nature Club のアクティビティプログラムを作成する */
  internalCreateSiteActivityProgram: InternalCreateOrUpdateSiteActivityProgramPayload;
  /** アクティビティプログラム画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateSiteActivityProgramImageUploadPolicy: FileUploadPolicyPayload;
  /** 拠点FAQ画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateSiteFaqImageUploadPolicy: FileUploadPolicyPayload;
  /** 拠点ハイシーズン期間を作成する（管理者向け） */
  internalCreateSiteHighSeasonPeriod: SiteHighSeasonPeriod;
  /** 拠点画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateSiteImageUploadPolicy: FileUploadPolicyPayload;
  /** 規約の改定を作成する */
  internalCreateTermsRevision: InternalCreateTermsRevisionPayload;
  /** StayTicketMasterからチケットを発行する */
  internalCreateTicketsFromMaster: Array<StayTicket>;
  /**
   * あるユーザーにオーナーとしての権利を付与する
   * 初年度の泊数は同時に付与する
   */
  internalCreateUserOwnership: UserOwnership;
  /** 宿泊施設を削除する */
  internalDeleteAccommodation: Scalars["Boolean"]["output"];
  /** ブロック解放スケジュールを削除する（管理者向け） */
  internalDeleteAccommodationAvailabilityBlockReleaseSchedule: Scalars["Boolean"]["output"];
  /** 機器を削除する */
  internalDeleteAccommodationEquipment: InternalDeleteAccommodationEquipmentPayload;
  /** エリアガイド記事を削除する */
  internalDeleteAreaGuideArticle: Scalars["Boolean"]["output"];
  /** エリアおすすめスポットを削除する */
  internalDeleteAreaGuideSpot: Scalars["Boolean"]["output"];
  /** 管理者がAuth0ユーザーを削除する（primary identity） */
  internalDeleteAuth0User: InternalUnlinkIdentityPayload;
  /** 申込のファイルを削除する。S3 のオブジェクトは削除し、履歴として行は残す */
  internalDeleteCoOwnersApplicationFile: InternalUpdateCoOwnersApplicationFilePayload;
  /** 建築家マスタを削除する。建築タイプから参照中は削除しない */
  internalDeleteContentArchitect: InternalDeleteArchitectureContentPayload;
  /** 設備コンテンツを削除する。利用ルールも同じトランザクションで削除する */
  internalDeleteContentArchitecturalFeature: InternalDeleteArchitectureContentPayload;
  /** 設備コンテンツの利用ルールを削除する */
  internalDeleteContentArchitecturalFeatureUsageRule: InternalDeleteArchitectureContentPayload;
  /** 基本の設備マスタを削除する。建築タイプから参照中は削除しない */
  internalDeleteContentArchitectureTypeBasicAmenity: InternalDeleteArchitectureContentPayload;
  /** 建築タイプのバリエーション / オプションを削除する */
  internalDeleteContentArchitectureTypeVariant: InternalDeleteArchitectureContentPayload;
  /** 設備アメニティを削除する。バリエーション / オプション / 設備コンテンツから参照中は削除しない */
  internalDeleteContentFacilityAmenity: InternalDeleteArchitectureContentPayload;
  /** 付帯サービスリソースのブロックを削除する */
  internalDeleteFacilityResourceBlock: InternalDeleteFacilityResourceBlockPayload;
  /** 地方税ポリシーを金額区分ごと削除する。拠点・部屋に適用中のものは削除しない。税額計算に使われたものは計算記録が金額区分を参照しているため DB 制約で削除できない */
  internalDeleteLocalTaxPolicy: InternalDeleteLocalTaxPolicyPayload;
  /** OTAルームユニットを削除する（割り当て解除） */
  internalDeleteOtaRoomUnit: Scalars["Boolean"]["output"];
  /** OTAルームタイプを削除する（紐づくユニットも全て削除） */
  internalDeleteRoomType: Scalars["Boolean"]["output"];
  /** 拠点アクセスルートグループを削除する */
  internalDeleteSiteAccessRouteGroup: Scalars["Boolean"]["output"];
  /** Nature Club のアクティビティプログラムを削除する（論理削除） */
  internalDeleteSiteActivityProgram: Success;
  /** 拠点FAQを削除する（管理者向け） */
  internalDeleteSiteFaq: Scalars["Boolean"]["output"];
  /** 拠点ハイシーズン期間を削除する（管理者向け） */
  internalDeleteSiteHighSeasonPeriod: Scalars["Boolean"]["output"];
  /** 備品の設置情報を削除する。同じ対象に複数行が残っているデータがあるため、その対象の行をまとめて消す */
  internalDeleteSupplyItemInstallation: InternalDeleteSupplyItemInstallationPayload;
  /** 備品マスタを論理削除する */
  internalDeleteSupplyItemMaster: InternalDeleteSupplyItemMasterPayload;
  internalEnqueueBeds24DeleteBlackBookings: Scalars["Boolean"]["output"];
  /** RetoolのWorkflowを実行する */
  internalExecuteRetoolWorkflow: Scalars["Boolean"]["output"];
  /** 法人向けの年間契約の請求書を下書き状態からオープンに移行する */
  internalFinalizeOrganizationYearlyContractInvoice: Scalars["Boolean"]["output"];
  /**
   * オーナーに対して特定年度の泊数を付与する
   * もし年度の途中の場合は、月割りで付与する
   * すでに付与している場合は null を返す
   */
  internalGrantNightsToOwnerFirstYear?: Maybe<Scalars["Int"]["output"]>;
  /**
   * テスト用！
   * ユーザーに過去の months 分の Co-Owners充当特典（旧S2Oポイント）の amount を付与する
   */
  internalGrantTestS2oPoints: Scalars["Boolean"]["output"];
  /** ユーザー情報をHubSpotコンタクトに同期する */
  internalHubSpotSyncContact: HubSpotSyncContactResult;
  /** CoOwnersApplicationをHubSpot Dealに同期する */
  internalHubSpotSyncDeal: HubSpotSyncDealResult;
  /** 法人向けの年間契約を無効化する */
  internalInvalidateOrganizationYearlyContract: InternalInvalidateOrganizationYearlyContractPayload;
  /** 法人向けの年間契約の請求書を無効化する */
  internalInvalidateOrganizationYearlyContractInvoice: InternalInvalidateOrganizationYearlyContractInvoicePayload;
  /** 管理者がユーザーの Co-Owners充当特典（旧S2Oポイント） を全て失効する */
  internalInvalidateS2oPoints: InternalInvalidateS2oPointsPayload;
  /**
   * Codeの配列でStay Ticketを無効化する（Void状態に変更）
   * Openステータスのチケットのみ無効化され、それ以外はスキップされる
   */
  internalInvalidateStayTicketsByCode: InternalInvalidateStayTicketsByCodeResult;
  /**
   * IP 環境 beds24 セットアップの 1 step を実行する（worker 専用）。
   * state は SetupState の JSON 文字列
   */
  internalIpBeds24SetupStep: Scalars["Boolean"]["output"];
  /** 管理者がユーザーに Co-Owners充当特典（旧S2Oポイント）を付与する */
  internalIssueS2oPoints: InternalIssueS2oPointsPayload;
  /** ユーザーを法人に所属させる */
  internalJoinOrganization: Scalars["Boolean"]["output"];
  /** JTAS からの清掃ステータスの報告を反映する */
  internalJtasCreateOrUpdateInspectionStatuses: InternalJtasCreateOrUpdateInspectionStatusesPayload;
  /** JTAS からの備品消費報告を反映する */
  internalJtasCreateOrUpdateSupplyReport: InternalJtasCreateOrUpdateSupplyReportPayload;
  /** JTAS からの違反報告を反映する */
  internalJtasCreateOrUpdateViolationReport: InternalJtasCreateOrUpdateViolationReportPayload;
  /** JTAS からの違反報告の取り下げを反映する */
  internalJtasDeleteViolationReport: InternalJtasDeleteViolationReportPayload;
  /** ユーザーを法人から削除する */
  internalLeaveOrganization: InternalLeaveOrganizationPayload;
  /**
   * Co-Owners 申し込み（引渡完了済み）の一部または全部の口を売却予定にする。
   * 買い替え契約済みで引渡し前のオーナーが対象。売却月の年度までは全口の宿泊権利を残し、
   * その先の年度は残る口数分だけにする（全口売却なら剥奪する）。
   * すでに売却予定の場合は売却口数・売却月を更新する。
   */
  internalMarkCoOwnersApplicationPlannedForSale: InternalMarkCoOwnersApplicationPlannedForSalePayload;
  /**
   * Co-Owners 申し込み（売却予定）の売却を完了する。年度末精算完了後に実行する。
   * 全口の売却なら売却済にし、残っている宿泊権利を剥奪してプランを非表示にする。
   * 紐づくアクティブな予約や未滞在の StayGift が存在する場合は変更不可。
   * 一部の口の売却ならオーナーシップの口数を減らして引渡完了に戻す。
   */
  internalMarkCoOwnersApplicationSold: InternalMarkCoOwnersApplicationSoldPayload;
  /** 法人を更新する */
  internalPartialUpdateOrganization: InternalPartialUpdateOrganizationPayload;
  /** Admin画面から、ユーザーのシステム設定を更新する */
  internalPartialUpdateUserSystemSettings: User;
  /** 管理者がアップロードしたファイルを申込に紐づける */
  internalRegisterCoOwnersApplicationFile: RegisterCoOwnersApplicationFilePayload;
  /** アクセスキー（RemoteLock Booking / AccessPerson）を解放する（worker経由で呼び出される） */
  internalReleaseAccessKey: InternalReleaseAccessKeyPayload;
  /**
   * キャンセルされている予約に紐付いているAccommodationAvailabilityをリリースる
   * 処理された予約の数を返す
   */
  internalReleaseAvailabilitesFromCanceledReservations: Scalars["Int"]["output"];
  /** 仮予約に紐付いているチケットをReservedからOpenに戻す */
  internalReleaseStayTicketsFromTentativeReservation: Scalars["Boolean"]["output"];
  /** 拠点または部屋への地方税ポリシーの適用を解除する。その拠点・部屋の税額計算に使われたものは解除しない */
  internalRemoveLocalTaxPolicy: InternalRemoveLocalTaxPolicyPayload;
  /** Stripe サブスクリプション独自の支払い方法を削除する */
  internalRemoveStripeSubscriptionPaymentMethod: Scalars["String"]["output"];
  /** 宿泊施設の並び順を一括更新する */
  internalReorderAccommodations: Array<Accommodation>;
  /** エリアガイド記事の並び順を一括更新する */
  internalReorderAreaGuideArticles: Array<AreaGuideArticle>;
  /** エリアおすすめスポットの並び順を一括更新する */
  internalReorderAreaGuideSpots: Array<AreaGuideSpot>;
  /** エリアの並び順を一括更新する */
  internalReorderAreas: Array<Area>;
  /** 設備コンテンツの利用ルールの並び順を更新する。更新後の全件を sort 昇順で返す */
  internalReorderContentArchitecturalFeatureUsageRules: Array<ContentArchitecturalFeatureUsageRule>;
  /** 基本の設備マスタの並び順を更新する（公開ページの表示順）。更新後の全件を sort 昇順で返す */
  internalReorderContentArchitectureTypeBasicAmenities: Array<ContentArchitectureTypeBasicAmenity>;
  /** 建築ページ一覧の並び順（content.sort）を一括更新する */
  internalReorderContentArchitectureTypes: Array<ContentArchitectureType>;
  /** 拠点アクセスルートグループの並び順を一括更新する */
  internalReorderSiteAccessRouteGroups: Array<SiteAccessRouteGroup>;
  /** 拠点FAQの並び順を一括更新する（管理者向け） */
  internalReorderSiteFaqs: Array<RawSiteFaq>;
  /** 拠点の並び順を一括更新する */
  internalReorderSites: Array<Site>;
  /** 仮予約のユーザーをリセットする（userIdをNULLに設定） */
  internalResetTentativeReservationUser: Scalars["Boolean"]["output"];
  /** 管理ロールの割り当てを失効させる。拠点スコープの付与権では自分の拠点の割り当てに限られる */
  internalRevokeAdminRole: InternalRevokeAdminRolePayload;
  /**
   * one-shot スクリプトを実行する。dryRun=false の本番実行には confirmation
   * (= slug) が必須。実行ごとに ScriptExecution 行を必ず永続化する。
   */
  internalRunOneShotScript: InternalRunOneShotScriptResult;
  /** 指定したユーザーのスタンダードプランのサブスクリプションの解約をスケジュールする */
  internalScheduleStandardSubscriptionTermination: ScheduleStandardSubscriptionTerminationPayload;
  internalScheduledReleaseReservationBlocks: Array<Scalars["String"]["output"]>;
  /** Co-Owners 申込の本人確認（eKYC）の依頼メールを送信する */
  internalSendCoOwnersIdentityVerificationRequest: Success;
  /** ユーザーを指定してプッシュ通知を送信する */
  internalSendPushNotifications: InternalSendPushNotificationsPayload;
  /**
   * 指定した番号へテスト SMS を送り、SNS の MessageId を返す（Admin 限定）。
   * OIDC → AssumeRoleWithWebIdentity → sns:Publish の疎通を本番で確かめるためのもの。
   * 本文には必ず [TEST] が付く。message を省略すると既定の文面を送る
   */
  internalSendTestSms?: Maybe<Scalars["String"]["output"]>;
  /**
   * IP 環境 beds24 セットアップを開始する（IP 環境・ローカル開発環境の Admin 限定）。
   * 進捗を初期化し、最初の step を worker chain に enqueue する。
   * fromDate / toDate（YYYY-MM-DD）は予約・ブロックの同期対象範囲
   * （省略時は 3 日前〜無期限）
   */
  internalStartIpBeds24Setup: Scalars["Boolean"]["output"];
  /**
   * for Staffプランを開始する
   * Retoolからの初回登録時に使用
   */
  internalStartStaffPlan: InternalStartStaffPlanResult;
  /** for Staffプランを停止する */
  internalStopStaffPlan: InternalStopStaffPlanResult;
  /** 拠点の全ルームタイプをBeds24に同期する */
  internalSyncAllBeds24Rooms: InternalSite;
  /** Beds24のルーム数（qty）を同期する */
  internalSyncBeds24RoomQty: InternalRoomType;
  /** 管理者がAuth0ユーザーからリンク済みアイデンティティを解除する */
  internalUnlinkAuth0Identity: InternalUnlinkIdentityPayload;
  /** 管理者がユーザーのリンク済みアイデンティティを解除する */
  internalUnlinkIdentity: InternalUnlinkIdentityPayload;
  /** ブロック解放スケジュールを更新する（管理者向け） */
  internalUpdateAccommodationAvailabilityBlockReleaseSchedule: AccommodationAvailabilityBlockReleaseSchedule;
  /** 機器を更新する */
  internalUpdateAccommodationEquipment: InternalUpdateAccommodationEquipmentPayload;
  /**
   * 運用グループの設定値を更新する。
   * 拠点の予約受付前で、紐づくオーナープランの所有権がないときだけ更新できる
   */
  internalUpdateAccommodationOperationGroupSetting: InternalUpdateAccommodationOperationGroupSettingPayload;
  /** エリアの基本情報を更新する */
  internalUpdateArea: InternalUpdateAreaPayload;
  /** エリアのコンテンツを更新する */
  internalUpdateAreaContent: InternalArea;
  /** Co-Owners 申し込み詳細情報を更新する */
  internalUpdateCoOwnersApplicationDetail: InternalUpdateCoOwnersApplicationDetailPayload;
  /** 申込のファイルを申込者に表示するかどうかを切り替える */
  internalUpdateCoOwnersApplicationFileVisibility: InternalUpdateCoOwnersApplicationFilePayload;
  /** Co-Owners の申し込み情報を更新する */
  internalUpdateCoOwnersApplicationInfo: InternalUpdateCoOwnersApplicationInfoPayload;
  /** Co-Owners 申し込みステータスを更新する */
  internalUpdateCoOwnersApplicationStatus: InternalUpdateCoOwnersApplicationStatusPayload;
  /** 付帯サービスを更新する */
  internalUpdateFacility: InternalCreateOrUpdateFacilityPayload;
  /** 設備コンテンツ用画像一覧を更新する */
  internalUpdateFacilityContentImages: InternalUpdateFacilityContentImagesPayload;
  /** 付帯サービス予約を更新する */
  internalUpdateFacilityReservation: UpdateFacilityReservationPayload;
  /** 付帯サービスの清掃ステータスを更新する */
  internalUpdateFacilityReservationCleaning: InternalUpdateFacilityReservationCleaningPayload;
  /** 付帯サービス予約のデータ連携ステータスを更新する */
  internalUpdateFacilityReservationDataSync: InternalUpdateFacilityReservationDataSyncPayload;
  /** 本人確認のステータス・結果を手動更新する */
  internalUpdateIdentityVerification: InternalUpdateIdentityVerificationPayload;
  /** 個別規約のファイルを差し替え、差し替え日を改定日とする改定も同時に作成する */
  internalUpdateIndividualTermsDocument: InternalUpdateIndividualTermsDocumentPayload;
  /**
   * ハウスルール違反への対応を記録する。違反レベルの判定と注意喚起の実施は
   * 別々の画面操作だが、渡された項目だけを更新するのでどちらからも呼べる
   */
  internalUpdateInspectionViolationHandling: InternalUpdateInspectionViolationHandlingPayload;
  /** 地方税ポリシーを更新する。 */
  internalUpdateLocalTaxPolicy: InternalUpdateLocalTaxPolicyPayload;
  /** ルームタイプを更新する */
  internalUpdateRoomType: InternalRoomType;
  /** ルームタイプのコンテンツ（紹介文・ヒーロー画像）を更新する */
  internalUpdateRoomTypeContent: InternalContentRoomType;
  /** 拠点の基本情報を更新する */
  internalUpdateSite: InternalUpdateSitePayload;
  /** Nature Club のアクティビティプログラムを更新する */
  internalUpdateSiteActivityProgram: InternalCreateOrUpdateSiteActivityProgramPayload;
  /** 拠点コンテンツを更新する */
  internalUpdateSiteContent: InternalSite;
  /** 拠点ハイシーズン期間を更新する（管理者向け） */
  internalUpdateSiteHighSeasonPeriod: SiteHighSeasonPeriod;
  /** 拠点画像を登録 */
  internalUpdateSiteImages: InternalUpdateSiteImagesPayload;
  /** 管理者向けの拠点パラメータを更新する */
  internalUpdateSiteParameters: InternalUpdateSiteParametersPayload;
  /** 発行済みStayTicketの有効期限・宿泊期間・ステータスを更新する */
  internalUpdateStayTicket: InternalUpdateStayTicketPayload;
  /** Admin画面から、ユーザー情報を一括で更新する */
  internalUpdateUser: User;
  /** 基本日別宿泊料金を一括で作成/更新する */
  internalUpsertBaseAccommodationFeeDailyRates: InternalUpsertBaseAccommodationFeeDailyRatesPayload;
  /** 有料備品の免除を作成/更新する（指定した内容で洗い替え） */
  internalUpsertConsumedSupplyFeeItemWaivers: InternalUpsertConsumedSupplyFeeItemWaiversPayload;
  /**
   * Co-Owners 申し込み（引渡完了済み）を無効化する。
   * ステータスのみ Void へ変更し、申込レコード自体は残す。
   * 紐づくアクティブな予約や未滞在の StayGift が存在する場合は変更不可。残っている宿泊権利は剥奪される。
   */
  internalVoidCoOwnersApplication: InternalVoidCoOwnersApplicationPayload;
  /** ユーザー情報をZendeskに同期する */
  internalZendeskSyncUser: ZendeskSyncUserResult;
  /**
   * 法人組織の管理者が、複数のメールアドレスへ招待メールを一括送信する。
   * 対象は viewer が Admin として所属する組織。
   * 既存の所属メンバーはバックエンド側で送信対象から除外される。
   */
  inviteBusinessMembers: InviteBusinessMembersPayload;
  /** エッジデバイスアクセス用のMQTTセッショントークンを発行する */
  issueSanuEdgeDeviceAccessToken: IssueSanuEdgeDeviceAccessTokenPayload;
  /** 宿泊チケットを発行する */
  issueStayTickets: IssueStayTicketsPayload;
  /** ユーザーを法人に所属させる */
  joinOrganization: JoinOrganizationPayload;
  /** 法人組織からメンバーを外す */
  leaveOrganization: LeaveOrganizationPayload;
  /** ログイン中のユーザーが自分自身で法人組織から抜ける */
  leaveOrganizationByViewer: LeaveOrganizationByViewerPayload;
  /** Bubble からデータをロードする */
  loadData: LoadDataOutput;
  /** 法人組織の情報を更新する */
  partialUpdateOrganization: PartialUpdateOrganizationPayload;
  /** 法人組織のメンバーの情報を更新する */
  partialUpdateOrganizationMembership: PartialUpdateOrganizationMembershipPayload;
  /** 自身のユーザーシステム設定を一括で更新する */
  partialUpdateViewerSystemSettings: User;
  /**
   * 滞在レビューの回答を投稿する
   * id は宿泊予約のID
   */
  postStayReviewResponse: PostStayReviewResponsePayload;
  /** Vercel によってトリガーされる定期実行処理 */
  processCronJob: ProcessCronJobResponse;
  /** Stripe のイベント処理 */
  processStripeEvent: ProcessStripeEventResponse;
  /** TRUSTDOCK の Webhook イベント処理 */
  processTrustdockEvent: ProcessTrustdockEventResponse;
  /** アップロード済みのファイルを申込に紐づける */
  registerCoOwnersApplicationFile: RegisterCoOwnersApplicationFilePayload;
  /** 設定画面からアイデンティティ（ソーシャルログイン）を削除する */
  removeIdentity: RemoveIdentityPayload;
  /** スタンダードプランのサブスクリプションの休会を解除する */
  resumeStandardSubscriptionImmediately: ResumeStandardSubscriptionImmediatelyPayload;
  /** 滞在レビュー 2.0 を下書き保存する。途中離脱に備えて入力のたびに呼ぶ */
  saveStayReviewV2Draft: SaveStayReviewV2DraftPayload;
  /** スタンダードプランのサブスクリプションの休会を申し込む */
  scheduleStandardSubscriptionPause: ScheduleStandardSubscriptionPausePayload;
  /** スタンダードプランのサブスクリプションの解約を申し込む */
  scheduleStandardSubscriptionTermination: ScheduleStandardSubscriptionTerminationPayload;
  /**
   * 重要事項説明会を選択する
   * coOwnersWebinarScheduleId に null を指定したときは別日程を希望していることとする。
   */
  selectWebinarSchedule: SelectWebinarSchedulePayload;
  /** 確認されていないメールアドレスに確認メールを送信する */
  sendEmailToVerifyEmail: SendEmailToVerifyNewEmailPayload;
  /** メールアドレス変更のために、新しいメールアドレスに確認メールを送信する */
  sendEmailToVerifyNewEmail: SendEmailToVerifyNewEmailPayload;
  /** パスワードリセットメールを送る */
  sendPasswordResetEmail: SendPasswordResetEmailPayload;
  /** アンケートの回答を送信する */
  submitAdHocQuestionnaireResponse: SubmitAdHocQuestionnaireResponsePayload;
  /** Co-Owners の申し込みを行う（新フロー） */
  submitCoOwnersApplication: SubmitCoOwnersApplicationPayload;
  /** 滞在レビュー 2.0 を送信する。4 軸の評価がすべて必要 */
  submitStayReviewV2: SubmitStayReviewV2Payload;
  /**
   * 宿泊予約のオプションを更新する。
   * guestCounts を指定すると追加人数料金（StayTicket master に AdditionalGuestFeePolicy がセットされた場合）も再計算する。
   */
  updateAccommodationReservationOptions: UpdateAccommodationReservationOptionsPayload;
  /** Co-Owners申し込み詳細情報を更新する */
  updateCoOwnersApplicationOwnerInfo: UpdateCoOwnersApplicationOwnerInfoPayload;
  /** 付帯サービス予約を更新する */
  updateFacilityReservation: UpdateFacilityReservationPayload;
  /** 同伴者を編集する */
  updateUserCompanion: UserCompanion;
  /** 自身のユーザー情報を一括で更新する */
  updateViewer: User;
  /** マーケメール配信の同意を更新する */
  updateViewerMarketingEmailConsent: User;
  /**
   * ユーザーの名前を設定する
   * すでに名前が設定されている場合は更新せずに空を返す。
   */
  updateViewerName?: Maybe<User>;
  /** アイデンティティ追加の再認証コールバックを処理する（Step 2） */
  verifyAddIdentityReauth: VerifyAddIdentityReauthPayload;
  /** チェックイン用QRコードを検証する */
  verifyCheckInQrCode: VerifyCheckInQrCodePayload;
  /** 確認コードを入力して、メールアドレス変更を確定する */
  verifyNewEmail: VerifyNewEmailPayload;
  /** Bubble にデータを書き戻す */
  writeBack: Scalars["String"]["output"];
};

export type MutationAcceptAccommodationReservationArgs = {
  userAcceptCode: Scalars["String"]["input"];
};

export type MutationAcquireStayTicketsArgs = {
  input: AcquireStayTicketsInput;
};

export type MutationAgreeToTermsArgs = {
  termsRevisionId: Scalars["ID"]["input"];
};

export type MutationApplyToTrialSubscriptionArgs = {
  enrollmentMonth: Scalars["PlainYearMonth"]["input"];
};

export type MutationApplyToWeekdaySubscriptionArgs = {
  promotionCode?: InputMaybe<Scalars["String"]["input"]>;
  startFrom: Scalars["PlainDate"]["input"];
};

export type MutationAssignUserCompanionsArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
  userCompanionIds: Array<Scalars["ID"]["input"]>;
};

export type MutationBundleStayTicketsArgs = {
  codes: Array<Scalars["String"]["input"]>;
};

export type MutationCancelAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationCancelCoOwnersApplicationArgs = {
  coOwnersApplicationId: Scalars["ID"]["input"];
};

export type MutationCancelFacilityReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationCancelStandardSubscriptionResumeArgs = {
  questionnaire: UserSubscriptionTerminationQuestionnaireInput;
};

export type MutationCancelStayGiftsArgs = {
  ticketIds: Array<Scalars["ID"]["input"]>;
};

export type MutationChangeAccommodationAvailabilityBlockArgs = {
  id: Scalars["ID"]["input"];
  input: ChangeAccommodationAvailabilityBlockInput;
};

export type MutationChangeAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateAccommodationReservationInput;
};

export type MutationCheckInAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: CheckInAccommodationReservationInput;
};

export type MutationCheckOutAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationCheckOutAccommodationReservationWithStayReviewResponseArgs =
  {
    id: Scalars["ID"]["input"];
    input: PostStayReviewResponseInput;
  };

export type MutationCompleteAddIdentityArgs = {
  input: CompleteAddIdentityInput;
};

export type MutationConfirmTentativeAccommodationReservationArgs = {
  detailInput: ConfirmTentativeAccommodationReservationInput;
  id: Scalars["ID"]["input"];
};

export type MutationCopyFilesToS3Args = {
  target: FileCopyTarget;
};

export type MutationCreateAccommodationAvailabilityBlockArgs = {
  input: CreateAccommodationAvailabilityBlockInput;
};

export type MutationCreateAccommodationReservationArgs = {
  input: CreateAccommodationReservationInput;
};

export type MutationCreateCoOwnersApplicationFileDownloadUrlArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
};

export type MutationCreateCoOwnersApplicationFileUploadPolicyArgs = {
  input: CreateCoOwnersApplicationFileUploadPolicyInput;
};

export type MutationCreateFacilityReservationArgs = {
  input: CreateFacilityReservationInput;
};

export type MutationCreateFullOwnerContractUploadPolicyArgs = {
  input: CreateFullOwnerContractUploadPolicyInput;
};

export type MutationCreateOrUpdateUserAppInstallationArgs = {
  input: CreateOrUpdateUserAppInstallationInput;
};

export type MutationCreateSanuOwnerPlanFileUploadPolicyArgs = {
  input: CreateSanuOwnerPlanFileUploadPolicyInput;
};

export type MutationCreateSanuOwnerPlanUserFileUploadPolicyArgs = {
  input: CreateSanuOwnerPlanUserFileUploadPolicyInput;
};

export type MutationCreateStripeCardSetupIntentOfOrganizationArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type MutationCreateUserCompanionArgs = {
  input: UserCompanionInput;
};

export type MutationCreateUserFileUploadPolicyArgs = {
  input: CreateUserFileUploadPolicyInput;
};

export type MutationCreateWebviewSessionArgs = {
  input: CreateWebviewSessionInput;
};

export type MutationDeleteAccommodationAvailabilityBlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteUserAppInstallationArgs = {
  installationId: Scalars["ID"]["input"];
};

export type MutationDeleteUserCompanionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationFinalizeAccountLinkArgs = {
  input: FinalizeAccountLinkInput;
};

export type MutationGenerateCheckInQrCodeArgs = {
  input: GenerateCheckInQrCodeInput;
};

export type MutationInitiateAccountLinkArgs = {
  input: InitiateAccountLinkInput;
};

export type MutationInitiateAddIdentityArgs = {
  input: InitiateAddIdentityInput;
};

export type MutationInternalAddLocalTaxPolicyArgs = {
  policyId: Scalars["ID"]["input"];
  target: InternalAddLocalTaxPolicyTargetInput;
};

export type MutationInternalAdjustOwnerStayCreditArgs = {
  amount: Scalars["Int"]["input"];
  ownershipId: Scalars["ID"]["input"];
  year: Scalars["Int"]["input"];
};

export type MutationInternalAdjustStaffCreditsArgs = {
  contractId: Scalars["ID"]["input"];
  nights: Scalars["Int"]["input"];
  peakDays: Scalars["Int"]["input"];
  semester: StaffSemester;
  year: Scalars["Int"]["input"];
};

export type MutationInternalAppendS2oPointsToCoOwnersApplicationArgs = {
  amount: Scalars["Int"]["input"];
  coOwnersApplicationId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationInternalApplyGuestAccessKeyArgs = {
  bookingId?: InputMaybe<Scalars["String"]["input"]>;
  reservationId: Scalars["String"]["input"];
  triggerType: GuestAccessKeyTrigger;
};

export type MutationInternalApplyStaffAccessKeyArgs = {
  accommodationId?: InputMaybe<Scalars["String"]["input"]>;
  keyType: AccessKeyType;
  siteId?: InputMaybe<Scalars["String"]["input"]>;
  triggerType: StaffAccessKeyTrigger;
};

export type MutationInternalAssignAccessCodeToAccommodationReservationArgs = {
  checkStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
  reservationId: Scalars["ID"]["input"];
};

export type MutationInternalAssignAdminRoleArgs = {
  input: InternalAssignAdminRoleInput;
};

export type MutationInternalBeds24CreateOrUpdateBlackBookingArgs = {
  blockId: Scalars["String"]["input"];
};

export type MutationInternalBeds24CreateOrUpdateBlackBookingsArgs = {
  blockIds: Array<Scalars["ID"]["input"]>;
};

export type MutationInternalBeds24CreateOrUpdateBookingArgs = {
  reservationId: Scalars["String"]["input"];
};

export type MutationInternalBeds24ExchangeInviteCodeArgs = {
  inviteCode: Scalars["String"]["input"];
};

export type MutationInternalBeds24ProcessWebhookEventArgs = {
  event: Beds24BookingEvent;
};

export type MutationInternalBeds24SendBookingMessageArgs = {
  kind: Beds24BookingMessageKind;
  reservationId: Scalars["String"]["input"];
};

export type MutationInternalBeds24SendGuestMessageAutoReplyArgs = {
  bookingId: Scalars["Int"]["input"];
};

export type MutationInternalBeds24SyncFollowingReservationsArgs = {
  leadingReservationId: Scalars["String"]["input"];
};

export type MutationInternalBeds24SyncFuturePricesArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationInternalBulkCreateAccommodationAvailabilityBlocksArgs = {
  input: Array<CreateAccommodationAvailabilityBlockInput>;
  skipBeds24CreditCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationInternalBulkCreateOrganizationYearlyContractInvoicesArgs = {
  contractId: Scalars["ID"]["input"];
  input: BulkCreateOrganizationYearlyContractInvoicesInput;
};

export type MutationInternalBulkDeleteAccommodationAvailabilityBlocksArgs = {
  ids: Array<Scalars["ID"]["input"]>;
  skipBeds24CreditCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationInternalBulkUpdateSeasonalFeeSettingsArgs = {
  input: Array<InternalBulkUpdateSeasonalFeeSettingsInput>;
};

export type MutationInternalBulkUpdateStayTicketMastersArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  input: Array<InternalBulkUpdateStayTicketMasterInput>;
};

export type MutationInternalCancelAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalCancelCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalCancelFacilityReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalChangeAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationReservationInput;
};

export type MutationInternalCheckInAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: CheckInAccommodationReservationInput;
};

export type MutationInternalConnectBeds24PropertyArgs = {
  propertyId: Scalars["Int"]["input"];
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalCreateAccommodationAvailabilityBlockReleaseScheduleArgs =
  {
    input: InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput;
  };

export type MutationInternalCreateAccommodationEquipmentArgs = {
  input: InternalCreateAccommodationEquipmentInput;
};

export type MutationInternalCreateAccommodationOperationGroupArgs = {
  input: InternalCreateAccommodationOperationGroupInput;
};

export type MutationInternalCreateAccommodationReservationArgs = {
  input: InternalCreateAccommodationReservationInput;
};

export type MutationInternalCreateArchitectureContentImageUploadPolicyArgs = {
  input: InternalCreateArchitectureContentImageUploadPolicyInput;
};

export type MutationInternalCreateAreaArgs = {
  input: InternalCreateAreaInput;
};

export type MutationInternalCreateAreaImageUploadPolicyArgs = {
  input: InternalCreateAreaImageUploadPolicyInput;
};

export type MutationInternalCreateCoOwnersApplicationFileDownloadUrlArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
};

export type MutationInternalCreateCoOwnersApplicationFileUploadPolicyArgs = {
  input: CreateCoOwnersApplicationFileUploadPolicyInput;
};

export type MutationInternalCreateCoOwnersIdentityVerificationArgs = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  input: InternalCreateCoOwnersIdentityVerificationInput;
};

export type MutationInternalCreateConsumedSuppliesFeeItemsArgs = {
  input: InternalCreateConsumedSuppliesFeeItemsInput;
};

export type MutationInternalCreateFacilityArgs = {
  input: InternalCreateFacilityInput;
};

export type MutationInternalCreateFacilityImageUploadPolicyArgs = {
  input: InternalCreateFacilityImageUploadPolicyInput;
};

export type MutationInternalCreateFacilityReservationArgs = {
  input: InternalCreateFacilityReservationInput;
};

export type MutationInternalCreateFullOwnerIdentityVerificationArgs = {
  input: InternalCreateFullOwnerIdentityVerificationInput;
  ownerPlanId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationInternalCreateLocalTaxPolicyArgs = {
  input: InternalCreateLocalTaxPolicyInput;
};

export type MutationInternalCreateOrUpdateAccommodationArgs = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAccommodationInput;
};

export type MutationInternalCreateOrUpdateAccommodationContentArgs = {
  accommodationId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateAccommodationContentInput;
};

export type MutationInternalCreateOrUpdateAccommodationNoticeArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAccommodationNoticeInput;
};

export type MutationInternalCreateOrUpdateAdditionalGuestFeePolicyArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAdditionalGuestFeePolicyInput;
};

export type MutationInternalCreateOrUpdateArchitectureTypeArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateArchitectureTypeInput;
};

export type MutationInternalCreateOrUpdateAreaGuideArticleArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAreaGuideArticleInput;
};

export type MutationInternalCreateOrUpdateAreaGuideSpotArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAreaGuideSpotInput;
};

export type MutationInternalCreateOrUpdateBaseAccommodationFeePolicyArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateBaseAccommodationFeePolicyInput;
};

export type MutationInternalCreateOrUpdateBeds24PropertyArgs = {
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalCreateOrUpdateBusinessPlanArgs = {
  businessPlanId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateBusinessPlanInput;
};

export type MutationInternalCreateOrUpdateCancelFeePolicyArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateCancelFeePolicyInput;
};

export type MutationInternalCreateOrUpdateCoOwnersPlanOfferingArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateCoOwnersPlanOfferingInput;
};

export type MutationInternalCreateOrUpdateCoOwnersWebinarScheduleArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateCoOwnersWebinarScheduleInput;
};

export type MutationInternalCreateOrUpdateContentArchitectArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentArchitectInput;
};

export type MutationInternalCreateOrUpdateContentArchitecturalFeatureArgs = {
  accommodationFacilityId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitecturalFeatureInput;
};

export type MutationInternalCreateOrUpdateContentArchitecturalFeatureUsageRuleArgs =
  {
    featureId: Scalars["ID"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput;
  };

export type MutationInternalCreateOrUpdateContentArchitectureTypeArgs = {
  architectureTypeId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitectureTypeInput;
};

export type MutationInternalCreateOrUpdateContentArchitectureTypeBasicAmenityArgs =
  {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput;
  };

export type MutationInternalCreateOrUpdateContentArchitectureTypeVariantArgs = {
  architectureTypeId: Scalars["ID"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentArchitectureTypeVariantInput;
  kind: ContentArchitectureTypeVariantKind;
};

export type MutationInternalCreateOrUpdateContentFacilityAmenityArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentFacilityAmenityInput;
};

export type MutationInternalCreateOrUpdateFacilityResourceBlockArgs = {
  input: InternalCreateOrUpdateFacilityResourceBlockInput;
};

export type MutationInternalCreateOrUpdateNativeAppHomeContentArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalNativeAppHomeContentInput;
};

export type MutationInternalCreateOrUpdateNewsArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateNewsInput;
};

export type MutationInternalCreateOrUpdateOrganizationArgs = {
  input: CreateOrUpdateOrganizationInput;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationInternalCreateOrUpdateOrganizationYearlyContractArgs = {
  contractId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateOrganizationYearlyContractInput;
  organizationId: Scalars["ID"]["input"];
};

export type MutationInternalCreateOrUpdateOrganizationYearlyContractInvoiceArgs =
  {
    contractId?: InputMaybe<Scalars["ID"]["input"]>;
    input: CreateOrUpdateOrganizationYearlyContractInvoiceInput;
    invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
  };

export type MutationInternalCreateOrUpdateOwnerPlanArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateOwnerPlanInput;
};

export type MutationInternalCreateOrUpdateSiteAccessRouteGroupArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateSiteAccessRouteGroupInput;
};

export type MutationInternalCreateOrUpdateSiteFaqArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateSiteFaqInput;
};

export type MutationInternalCreateOrUpdateStaffGroupArgs = {
  input: CreateOrUpdateStaffGroupInput;
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationInternalCreateOrUpdateStayTicketMasterArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketMasterInput;
};

export type MutationInternalCreateOrUpdateStayTicketMasterTemplateArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketMasterTemplateInput;
};

export type MutationInternalCreateOrUpdateStayTicketTemplateArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketTemplateInput;
};

export type MutationInternalCreateOrUpdateSupplyItemInstallationsArgs = {
  installations: Array<InternalCreateOrUpdateSupplyItemInstallationInput>;
  masterId: Scalars["ID"]["input"];
};

export type MutationInternalCreateOrUpdateSupplyItemMasterArgs = {
  input: InternalCreateOrUpdateSupplyItemMasterInput;
};

export type MutationInternalCreateOtaRoomUnitArgs = {
  input: InternalCreateOtaRoomUnitInput;
  roomTypeId: Scalars["ID"]["input"];
};

export type MutationInternalCreateRoomTypeArgs = {
  input: InternalCreateRoomTypeInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalCreateRoomTypeImageUploadPolicyArgs = {
  input: InternalCreateRoomTypeImageUploadPolicyInput;
};

export type MutationInternalCreateSiteArgs = {
  areaId: Scalars["ID"]["input"];
  input: InternalCreateSiteInput;
};

export type MutationInternalCreateSiteActivityProgramArgs = {
  input: InternalCreateSiteActivityProgramInput;
};

export type MutationInternalCreateSiteFaqImageUploadPolicyArgs = {
  input: InternalCreateSiteFaqImageUploadPolicyInput;
};

export type MutationInternalCreateSiteHighSeasonPeriodArgs = {
  input: InternalCreateSiteHighSeasonPeriodInput;
};

export type MutationInternalCreateSiteImageUploadPolicyArgs = {
  input: InternalCreateSiteImageUploadPolicyInput;
};

export type MutationInternalCreateTermsRevisionArgs = {
  input: InternalCreateTermsRevisionInput;
};

export type MutationInternalCreateTicketsFromMasterArgs = {
  count: Scalars["Int"]["input"];
  destinationEmail?: InputMaybe<Scalars["String"]["input"]>;
  expiresAt: Scalars["ZonedDateTime"]["input"];
  programYear?: InputMaybe<Scalars["Int"]["input"]>;
  stayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  stayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  stayTicketMasterId?: InputMaybe<Scalars["ID"]["input"]>;
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationInternalCreateUserOwnershipArgs = {
  coOwnersApplicationId?: InputMaybe<Scalars["ID"]["input"]>;
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  ownerPlanId: Scalars["ID"]["input"];
  startDate: Scalars["PlainDate"]["input"];
  units: Scalars["Int"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationInternalDeleteAccommodationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteAccommodationAvailabilityBlockReleaseScheduleArgs =
  {
    id: Scalars["ID"]["input"];
  };

export type MutationInternalDeleteAccommodationEquipmentArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteAreaGuideArticleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteAreaGuideSpotArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteAuth0UserArgs = {
  auth0UserId: Scalars["String"]["input"];
};

export type MutationInternalDeleteCoOwnersApplicationFileArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
};

export type MutationInternalDeleteContentArchitectArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteContentArchitecturalFeatureArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteContentArchitecturalFeatureUsageRuleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteContentArchitectureTypeBasicAmenityArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteContentArchitectureTypeVariantArgs = {
  id: Scalars["ID"]["input"];
  kind: ContentArchitectureTypeVariantKind;
};

export type MutationInternalDeleteContentFacilityAmenityArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteFacilityResourceBlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteLocalTaxPolicyArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteOtaRoomUnitArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteRoomTypeArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteSiteAccessRouteGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteSiteActivityProgramArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteSiteFaqArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteSiteHighSeasonPeriodArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteSupplyItemInstallationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalDeleteSupplyItemMasterArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalExecuteRetoolWorkflowArgs = {
  event: Scalars["String"]["input"];
  payload: Scalars["String"]["input"];
};

export type MutationInternalFinalizeOrganizationYearlyContractInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type MutationInternalGrantNightsToOwnerFirstYearArgs = {
  ownershipId: Scalars["ID"]["input"];
  year: Scalars["Int"]["input"];
};

export type MutationInternalGrantTestS2oPointsArgs = {
  amount: Scalars["Int"]["input"];
  months: Scalars["Int"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationInternalHubSpotSyncContactArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationInternalHubSpotSyncDealArgs = {
  coOwnersApplicationId: Scalars["String"]["input"];
};

export type MutationInternalInvalidateOrganizationYearlyContractArgs = {
  contractId: Scalars["ID"]["input"];
};

export type MutationInternalInvalidateOrganizationYearlyContractInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type MutationInternalInvalidateS2oPointsArgs = {
  input: InternalInvalidateS2oPointsInput;
};

export type MutationInternalInvalidateStayTicketsByCodeArgs = {
  codes: Array<Scalars["String"]["input"]>;
};

export type MutationInternalIpBeds24SetupStepArgs = {
  state: Scalars["String"]["input"];
};

export type MutationInternalIssueS2oPointsArgs = {
  input: InternalIssueS2oPointsInput;
};

export type MutationInternalJoinOrganizationArgs = {
  allowConcurrentUse?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["String"]["input"];
  role: OrganizationRole;
  userEmail: Scalars["String"]["input"];
};

export type MutationInternalJtasCreateOrUpdateInspectionStatusesArgs = {
  input: InternalJtasCreateOrUpdateInspectionStatusesInput;
};

export type MutationInternalJtasCreateOrUpdateSupplyReportArgs = {
  input: InternalJtasCreateOrUpdateSupplyReportInput;
};

export type MutationInternalJtasCreateOrUpdateViolationReportArgs = {
  input: InternalJtasCreateOrUpdateViolationReportInput;
};

export type MutationInternalJtasDeleteViolationReportArgs = {
  input: InternalJtasDeleteViolationReportInput;
};

export type MutationInternalLeaveOrganizationArgs = {
  organizationId: Scalars["String"]["input"];
  userEmail: Scalars["String"]["input"];
};

export type MutationInternalMarkCoOwnersApplicationPlannedForSaleArgs = {
  id: Scalars["ID"]["input"];
  saleYearMonth: Scalars["PlainYearMonth"]["input"];
  units: Scalars["Int"]["input"];
};

export type MutationInternalMarkCoOwnersApplicationSoldArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalPartialUpdateOrganizationArgs = {
  input: PartialUpdateOrganizationInput;
  organizationId: Scalars["ID"]["input"];
};

export type MutationInternalPartialUpdateUserSystemSettingsArgs = {
  input: UserSystemSettingsInput;
  userId: Scalars["String"]["input"];
};

export type MutationInternalRegisterCoOwnersApplicationFileArgs = {
  input: InternalRegisterCoOwnersApplicationFileInput;
};

export type MutationInternalReleaseAccessKeyArgs = {
  accessPersonId: Scalars["String"]["input"];
  bookingId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationInternalReleaseStayTicketsFromTentativeReservationArgs = {
  unitId: Scalars["ID"]["input"];
};

export type MutationInternalRemoveLocalTaxPolicyArgs = {
  policyId: Scalars["ID"]["input"];
  target: InternalRemoveLocalTaxPolicyTargetInput;
};

export type MutationInternalRemoveStripeSubscriptionPaymentMethodArgs = {
  subscriptionId: Scalars["String"]["input"];
};

export type MutationInternalReorderAccommodationsArgs = {
  input: Array<InternalReorderAccommodationInput>;
};

export type MutationInternalReorderAreaGuideArticlesArgs = {
  input: Array<InternalReorderInput>;
};

export type MutationInternalReorderAreaGuideSpotsArgs = {
  input: Array<InternalReorderInput>;
};

export type MutationInternalReorderAreasArgs = {
  input: Array<InternalReorderAreaInput>;
};

export type MutationInternalReorderContentArchitecturalFeatureUsageRulesArgs = {
  input: Array<InternalReorderArchitectureContentInput>;
};

export type MutationInternalReorderContentArchitectureTypeBasicAmenitiesArgs = {
  input: Array<InternalReorderArchitectureContentInput>;
};

export type MutationInternalReorderContentArchitectureTypesArgs = {
  input: Array<InternalReorderArchitectureContentInput>;
};

export type MutationInternalReorderSiteAccessRouteGroupsArgs = {
  input: Array<InternalReorderInput>;
};

export type MutationInternalReorderSiteFaqsArgs = {
  input: Array<InternalReorderSiteFaqInput>;
};

export type MutationInternalReorderSitesArgs = {
  input: Array<InternalReorderSiteInput>;
};

export type MutationInternalResetTentativeReservationUserArgs = {
  reservationId: Scalars["ID"]["input"];
};

export type MutationInternalRevokeAdminRoleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalRunOneShotScriptArgs = {
  input: InternalRunOneShotScriptInput;
};

export type MutationInternalScheduleStandardSubscriptionTerminationArgs = {
  afterIterations: Scalars["Int"]["input"];
  targetUserId: Scalars["String"]["input"];
};

export type MutationInternalScheduledReleaseReservationBlocksArgs = {
  targetDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationInternalSendCoOwnersIdentityVerificationRequestArgs = {
  coOwnersApplicationId: Scalars["String"]["input"];
};

export type MutationInternalSendPushNotificationsArgs = {
  input: InternalSendPushNotificationsInput;
};

export type MutationInternalSendTestSmsArgs = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber: Scalars["String"]["input"];
};

export type MutationInternalStartIpBeds24SetupArgs = {
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  phases?: InputMaybe<Array<Scalars["String"]["input"]>>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationInternalStartStaffPlanArgs = {
  initialNights: Scalars["Int"]["input"];
  staffType: StaffType;
  startSemester: StaffSemester;
  startYear: Scalars["Int"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationInternalStopStaffPlanArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationInternalSyncAllBeds24RoomsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalSyncBeds24RoomQtyArgs = {
  roomTypeId: Scalars["ID"]["input"];
};

export type MutationInternalUnlinkAuth0IdentityArgs = {
  primaryAuth0UserId: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  providerUserId: Scalars["String"]["input"];
};

export type MutationInternalUnlinkIdentityArgs = {
  provider: IdentityProvider;
  userId: Scalars["String"]["input"];
};

export type MutationInternalUpdateAccommodationAvailabilityBlockReleaseScheduleArgs =
  {
    id: Scalars["ID"]["input"];
    input: InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput;
  };

export type MutationInternalUpdateAccommodationEquipmentArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationEquipmentInput;
};

export type MutationInternalUpdateAccommodationOperationGroupSettingArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationOperationGroupSettingInput;
};

export type MutationInternalUpdateAreaArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAreaInput;
};

export type MutationInternalUpdateAreaContentArgs = {
  areaId: Scalars["ID"]["input"];
  input: InternalUpdateAreaContentInput;
};

export type MutationInternalUpdateCoOwnersApplicationDetailArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationDetailInput;
};

export type MutationInternalUpdateCoOwnersApplicationFileVisibilityArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
  visibleToApplicant: Scalars["Boolean"]["input"];
};

export type MutationInternalUpdateCoOwnersApplicationInfoArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationInfoInput;
};

export type MutationInternalUpdateCoOwnersApplicationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationStatusInput;
};

export type MutationInternalUpdateFacilityArgs = {
  input: InternalUpdateFacilityInput;
};

export type MutationInternalUpdateFacilityContentImagesArgs = {
  facilityId: Scalars["ID"]["input"];
  input: InternalUpdateFacilityContentImagesInput;
};

export type MutationInternalUpdateFacilityReservationArgs = {
  input: UpdateFacilityReservationInput;
};

export type MutationInternalUpdateFacilityReservationCleaningArgs = {
  reservationId: Scalars["ID"]["input"];
  status: FacilityReservationCleaningStatus;
};

export type MutationInternalUpdateFacilityReservationDataSyncArgs = {
  reservationId: Scalars["ID"]["input"];
  status: FacilityReservationDataSyncStatus;
};

export type MutationInternalUpdateIdentityVerificationArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateIdentityVerificationInput;
};

export type MutationInternalUpdateIndividualTermsDocumentArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateIndividualTermsDocumentInput;
};

export type MutationInternalUpdateInspectionViolationHandlingArgs = {
  input: InternalUpdateInspectionViolationHandlingInput;
};

export type MutationInternalUpdateLocalTaxPolicyArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateLocalTaxPolicyInput;
};

export type MutationInternalUpdateRoomTypeArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateRoomTypeInput;
};

export type MutationInternalUpdateRoomTypeContentArgs = {
  input: InternalUpdateRoomTypeContentInput;
  roomTypeId: Scalars["ID"]["input"];
};

export type MutationInternalUpdateSiteArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteInput;
};

export type MutationInternalUpdateSiteActivityProgramArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteActivityProgramInput;
};

export type MutationInternalUpdateSiteContentArgs = {
  input: InternalUpdateSiteContentInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalUpdateSiteHighSeasonPeriodArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteHighSeasonPeriodInput;
};

export type MutationInternalUpdateSiteImagesArgs = {
  input: InternalCreateOrUpdateSiteImagesInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalUpdateSiteParametersArgs = {
  input: InternalUpdateSiteParametersInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationInternalUpdateStayTicketArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateStayTicketInput;
};

export type MutationInternalUpdateUserArgs = {
  id: Scalars["String"]["input"];
  input: InternalUpdateUserInput;
};

export type MutationInternalUpsertBaseAccommodationFeeDailyRatesArgs = {
  input: Array<InternalUpsertBaseAccommodationFeeDailyRateInput>;
  target: DailyRateTarget;
};

export type MutationInternalUpsertConsumedSupplyFeeItemWaiversArgs = {
  input: InternalUpsertConsumedSupplyFeeItemWaiversInput;
};

export type MutationInternalVoidCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInternalZendeskSyncUserArgs = {
  updateEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type MutationInviteBusinessMembersArgs = {
  input: InviteBusinessMembersInput;
};

export type MutationIssueSanuEdgeDeviceAccessTokenArgs = {
  input: IssueSanuEdgeDeviceAccessTokenInput;
};

export type MutationIssueStayTicketsArgs = {
  input: IssueStayTicketsInput;
};

export type MutationJoinOrganizationArgs = {
  customFieldValue?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  role: OrganizationRole;
};

export type MutationLeaveOrganizationArgs = {
  organizationId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationLoadDataArgs = {
  target: LoadDataTarget;
};

export type MutationPartialUpdateOrganizationArgs = {
  id: Scalars["ID"]["input"];
  input: PartialUpdateOrganizationInput;
};

export type MutationPartialUpdateOrganizationMembershipArgs = {
  input: PartialUpdateOrganizationMembershipInput;
  organizationId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationPartialUpdateViewerSystemSettingsArgs = {
  input: UserSystemSettingsInput;
};

export type MutationPostStayReviewResponseArgs = {
  id: Scalars["ID"]["input"];
  input: PostStayReviewResponseInput;
};

export type MutationProcessCronJobArgs = {
  authHeader: Scalars["String"]["input"];
  job: CronJobName;
};

export type MutationProcessStripeEventArgs = {
  payload: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
};

export type MutationProcessTrustdockEventArgs = {
  payload: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
};

export type MutationRegisterCoOwnersApplicationFileArgs = {
  input: RegisterCoOwnersApplicationFileInput;
};

export type MutationRemoveIdentityArgs = {
  input: RemoveIdentityInput;
};

export type MutationSaveStayReviewV2DraftArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
  input: StayReviewV2Input;
};

export type MutationScheduleStandardSubscriptionPauseArgs = {
  other: Scalars["String"]["input"];
  pauseDate: Scalars["PlainDate"]["input"];
  reason: Scalars["String"]["input"];
  resumeDate: Scalars["PlainDate"]["input"];
};

export type MutationScheduleStandardSubscriptionTerminationArgs = {
  questionnaire: UserSubscriptionTerminationQuestionnaireInput;
};

export type MutationSelectWebinarScheduleArgs = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  coOwnersWebinarScheduleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSendEmailToVerifyEmailArgs = {
  input: SendEmailToVerifyEmailInput;
};

export type MutationSendEmailToVerifyNewEmailArgs = {
  input: SendEmailToVerifyNewEmailInput;
};

export type MutationSubmitAdHocQuestionnaireResponseArgs = {
  input: SubmitAdHocQuestionnaireResponseInput;
};

export type MutationSubmitCoOwnersApplicationArgs = {
  input: CoOwnersApplicationInput;
};

export type MutationSubmitStayReviewV2Args = {
  accommodationReservationId: Scalars["ID"]["input"];
  input: StayReviewV2Input;
};

export type MutationUpdateAccommodationReservationOptionsArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateAccommodationReservationOptionsInput;
};

export type MutationUpdateCoOwnersApplicationOwnerInfoArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationOwnerInfoInput;
};

export type MutationUpdateFacilityReservationArgs = {
  input: UpdateFacilityReservationInput;
};

export type MutationUpdateUserCompanionArgs = {
  id: Scalars["ID"]["input"];
  input: UserCompanionInput;
};

export type MutationUpdateViewerArgs = {
  input: UpdateViewerInput;
};

export type MutationUpdateViewerMarketingEmailConsentArgs = {
  accept: Scalars["Boolean"]["input"];
};

export type MutationUpdateViewerNameArgs = {
  name: Scalars["String"]["input"];
  nameKana?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationVerifyAddIdentityReauthArgs = {
  input: VerifyAddIdentityReauthInput;
};

export type MutationVerifyCheckInQrCodeArgs = {
  input: VerifyCheckInQrCodeInput;
};

export type MutationVerifyNewEmailArgs = {
  input: VerifyNewEmailInput;
};

/** アプリホーム画面のコンテンツ */
export type NativeAppHomeContent = {
  __typename: "NativeAppHomeContent";
  /** 説明 */
  description?: Maybe<Scalars["String"]["output"]>;
  /** 画像 URL */
  imageUrl: UploadedFile;
  /** ラベル */
  label?: Maybe<NativeAppHomeContentLabel>;
  /** リンク */
  link: NativeAppHomeContentLink;
  /** タイトル */
  title?: Maybe<Scalars["String"]["output"]>;
};

export type NativeAppHomeContentLabel = {
  __typename: "NativeAppHomeContentLabel";
  /** ラベルテキスト */
  text: Scalars["String"]["output"];
  /** タイプ */
  type: NativeAppHomeContentLabelType;
};

export const NativeAppHomeContentLabelType = {
  Accent: "Accent",
  Default: "Default",
} as const;

export type NativeAppHomeContentLabelType =
  (typeof NativeAppHomeContentLabelType)[keyof typeof NativeAppHomeContentLabelType];
export type NativeAppHomeContentLink = {
  __typename: "NativeAppHomeContentLink";
  /** アクション */
  action: NativeAppHomeContentLinkAction;
  /** ラベル */
  label?: Maybe<Scalars["String"]["output"]>;
  /** パスもしくは URL */
  path: Scalars["String"]["output"];
};

export const NativeAppHomeContentLinkAction = {
  DrillDown: "DrillDown",
  ExternalBrowser: "ExternalBrowser",
  FullSheet: "FullSheet",
  Sheet: "Sheet",
} as const;

export type NativeAppHomeContentLinkAction =
  (typeof NativeAppHomeContentLinkAction)[keyof typeof NativeAppHomeContentLinkAction];
export const NativeAppHomeContentStatus = {
  Active: "Active",
  Draft: "Draft",
  Unpublished: "Unpublished",
} as const;

export type NativeAppHomeContentStatus =
  (typeof NativeAppHomeContentStatus)[keyof typeof NativeAppHomeContentStatus];
/** お知らせ */
export type News = {
  __typename: "News";
  content: Scalars["String"]["output"];
  contentType: NewsContentType;
  displayCategory: NewsDisplayCategory;
  id: Scalars["ID"]["output"];
  publishedAt: Scalars["ZonedDateTime"]["output"];
  title: Scalars["String"]["output"];
};

/**
 * お知らせの種類
 * InternalPage を含むデータは取得できないようになっています
 */
export const NewsContentType = {
  /** 外部リンク */
  ExternalLink: "ExternalLink",
  /** お知らせ詳細 */
  Html: "HTML",
  /**
   * 内部ページパス
   * このタイプは今後使用しません
   */
  InternalPage: "InternalPage",
} as const;

export type NewsContentType =
  (typeof NewsContentType)[keyof typeof NewsContentType];
export const NewsDisplayCategory = {
  /** ニュースレター（Archive Article） */
  NewsLetterArticle: "NewsLetterArticle",
  /** お知らせ */
  Notice: "Notice",
  /** サービスアップデート */
  ServiceUpdate: "ServiceUpdate",
} as const;

export type NewsDisplayCategory =
  (typeof NewsDisplayCategory)[keyof typeof NewsDisplayCategory];
/** お知らせのステータス */
export const NewsStatus = {
  /** 公開中 */
  Active: "Active",
  /** 下書き */
  Draft: "Draft",
  /** 非公開 */
  Unpublished: "Unpublished",
} as const;

export type NewsStatus = (typeof NewsStatus)[keyof typeof NewsStatus];
/**
 * 稼働制限の対象
 * （チケットマスタ更新用）
 */
export const OccupancyLimitTarget = {
  /** 都度宿泊のみ */
  Guest: "Guest",
  /** 制限なし */
  Unrestricted: "Unrestricted",
} as const;

export type OccupancyLimitTarget =
  (typeof OccupancyLimitTarget)[keyof typeof OccupancyLimitTarget];
export const OccupancyLimitTargetType = {
  Guest: "Guest",
  OrganizationMember: "OrganizationMember",
  StandardSubscriber: "StandardSubscriber",
  Unrestricted: "Unrestricted",
} as const;

export type OccupancyLimitTargetType =
  (typeof OccupancyLimitTargetType)[keyof typeof OccupancyLimitTargetType];
export type OneMoreCabinAccommodationReservationProvider = {
  __typename: "OneMoreCabinAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  parentAccommodationReservationId: Scalars["ID"]["output"];
};

export type OnlineTravelAgentAccommodationReservationProvider = {
  __typename: "OnlineTravelAgentAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  isIkyuDiamondMember: Scalars["Boolean"]["output"];
  leadAccommodationReservationId?: Maybe<Scalars["ID"]["output"]>;
};

export type OnsenAccommodationFacility = {
  __typename: "OnsenAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** 付帯サービス温泉・サウナ向けドアロックのコントローラ属性情報 */
export type OnsenAndSaunaDoorLock = {
  __typename: "OnsenAndSaunaDoorLock";
  pinCode?: Maybe<Scalars["String"]["output"]>;
};

/** 法人組織（単に"法人"とも） */
export type Organization = {
  __typename: "Organization";
  /** メンバー向けの案内文 */
  announcementContent: Scalars["String"]["output"];
  /** SANU担当者 */
  assignedUser?: Maybe<User>;
  /** 請求先メールアドレス */
  billingEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * Bubble の Organization ID
   * 法人管理者のみ取得可能
   */
  bubbleId?: Maybe<Scalars["String"]["output"]>;
  /** 特定の契約プラン */
  contract: OrganizationYearlyContract;
  /** 全ての有効な契約プラン */
  contracts: Array<OrganizationYearlyContract>;
  /** 会社による運用コントロール */
  control: OrganizationControl;
  /**
   * 現在有効な年間契約
   * 通常これがある場合は予約ができる
   */
  currentContract?: Maybe<OrganizationYearlyContract>;
  /** 現在有効な契約プランまたは将来の契約プラン */
  currentOrUpcomingContract?: Maybe<OrganizationYearlyContract>;
  /** 請求書のデフォルト請求サイクル */
  defaultFrequency?: Maybe<OrganizationYearlyContractInvoiceFrequency>;
  /** 請求書のデフォルト支払い方法 */
  defaultPaymentMethod?: Maybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  /** サービス上の表示名。未設定なら null */
  displayName?: Maybe<Scalars["String"]["output"]>;
  /**
   * 許可メールドメイン
   * 設定されていない場合は、任意のドメインでメンバー登録できる
   */
  emailDomainsForMember?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["ID"]["output"];
  /** 招待用の組織コード */
  invitationCode: Scalars["String"]["output"];
  /** メンバー入力画面におけるカスタムフィールド */
  memberCustomField: OrganizationMemberCustomField;
  /** 組織のメンバー */
  members: Array<User>;
  /** メンバーの滞在実績や滞在予定 */
  membersStay: OrganizationMembersStay;
  /** 組織のメンバーシップ */
  memberships: Array<OrganizationMembership>;
  /** 組織の名前 */
  name: Scalars["String"]["output"];
  /** ユーザー登録の前に表示する情報 */
  onboardingInfo?: Maybe<OrganizationOnboardingInfo>;
  /** クレジットカード決済が有効かどうか */
  paymentMethodCardEnabled: Scalars["Boolean"]["output"];
  /** Stripe の顧客情報 */
  stripe: StripeCustomer;
  /**
   * 予約停止ステータス
   * Sanu側によって設定される。料金未払いなどの場合に使われる。
   */
  suspended: Scalars["Boolean"]["output"];
};

/** 法人組織（単に"法人"とも） */
export type OrganizationContractArgs = {
  id: Scalars["ID"]["input"];
};

/** 法人組織（単に"法人"とも） */
export type OrganizationMembersArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** 法人組織（単に"法人"とも） */
export type OrganizationMembershipsArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** 会社による運用コントロール */
export type OrganizationControl = {
  __typename: "OrganizationControl";
  /** メンバーあたりの年間最大泊数 */
  maxNightsPerMember?: Maybe<Scalars["Int"]["output"]>;
  /** 1ヶ月あたりの最大泊数 */
  maxNightsPerMonth?: Maybe<Scalars["Int"]["output"]>;
  /** 1滞在あたりの最大連泊数 */
  maxNightsPerStay?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationMemberCustomField = {
  __typename: "OrganizationMemberCustomField";
  /** カスタムフィールドが有効かどうか */
  enabled: Scalars["Boolean"]["output"];
  /** フィールド名 */
  name?: Maybe<Scalars["String"]["output"]>;
  /** フィールドのプレイスホルダー */
  placeholder?: Maybe<Scalars["String"]["output"]>;
  /** 必須かどうか */
  required: Scalars["Boolean"]["output"];
};

/**
 * 組織メンバーの予約に関するステータス
 * 年間契約は組織メンバーに公開せず、こちらを公開する
 */
export type OrganizationMemberNewReservationStatus = {
  __typename: "OrganizationMemberNewReservationStatus";
  /** メンバー自身が最大同時予約数を既に保持しているかどうか */
  holdMaxInTotal: Scalars["Boolean"]["output"];
  /**
   * 自然月ごとの予約に関するステータス
   * 直近4ヶ月が返る
   */
  latestMonthlyReservationStatuses: Array<OrganizationMonthlyReservationStatus>;
  /**
   * 契約年ごとの予約に関するステータス
   * 現在および1つ先までの将来の契約年が返る
   */
  latestYearlyReservationStatuses: Array<OrganizationYearlyReservationStatus>;
  /**
   * 1滞在あたりの最大連泊数
   * 組織に設定された値があればそちらが反映される。
   */
  maxNightsPerStay: Scalars["Int"]["output"];
  /**
   * 予約が可能な状態かどうか。
   * SAUUによって組織がサスペンドされているか、組織管理者によってメンバーがサスペンドされているときは false になる。
   */
  suspended: Scalars["Boolean"]["output"];
};

export type OrganizationMemberPayload = {
  __typename: "OrganizationMemberPayload";
  myself: Scalars["Boolean"]["output"];
  user: User;
};

/**
 * 組織メンバーごとの予約ステータス
 * 組織管理者によって設定される
 */
export const OrganizationMemberReservationStatus = {
  /** 予約不可 */
  NotUsable: "NotUsable",
  /** 予約可能 */
  Usable: "Usable",
} as const;

export type OrganizationMemberReservationStatus =
  (typeof OrganizationMemberReservationStatus)[keyof typeof OrganizationMemberReservationStatus];
export type OrganizationMembersStay = {
  __typename: "OrganizationMembersStay";
  /**
   * 月別の利用泊数（実績）
   * 現在は直近2年間分が返るようにしている。
   */
  monthlyConsumedNights: Array<OrganizationPlanMonthlyConsumedNights>;
  /** 宿泊予約一覧 */
  reservations: Array<AccommodationReservation>;
  /**
   * エクスポート用の予約一覧
   * 全期間・全ステータスの予約を取得
   */
  reservationsForExport: Array<ReservationExportItem>;
  /**
   * 現在の契約期間における利用済み泊数
   * 滞在済みと予約済みを含む
   */
  usedNightsInCurrentContract: Scalars["Int"]["output"];
};

export type OrganizationMembersStayReservationsArgs = {
  excludeCancel?: InputMaybe<Scalars["Boolean"]["input"]>;
  month: Scalars["PlainYearMonth"]["input"];
};

/** 組織への所属 */
export type OrganizationMembership = {
  __typename: "OrganizationMembership";
  customFieldValue?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  organization: Organization;
  reservationNewStatus: OrganizationMemberNewReservationStatus;
  reservationStatus: OrganizationMemberReservationStatus;
  role: OrganizationRole;
};

/** 法人メンバーの月毎の予約に関するステータス */
export type OrganizationMonthlyReservationStatus = {
  __typename: "OrganizationMonthlyReservationStatus";
  /** この月にすでにメンバー自身の予約があるかどうか */
  alreadyHold: Scalars["Boolean"]["output"];
  /** この月に契約しているかどうか */
  isContracted: Scalars["Boolean"]["output"];
  /** この月の残りの泊数 */
  remainingNights: Scalars["Int"]["output"];
  /** 該当の月 */
  yearMonth: Scalars["PlainYearMonth"]["output"];
  /**
   * この月を含む契約年の予約に関するステータス
   * isContracted が true の場合に存在
   */
  yearlyReservationStatus?: Maybe<OrganizationYearlyReservationStatus>;
};

export type OrganizationOnboardingInfo = {
  __typename: "OrganizationOnboardingInfo";
  /** メンバーが支払う1泊あたりの金額 */
  feePerNights: Scalars["Int"]["output"];
  /** 繁忙日料 */
  isPeakDayFeeFree: Scalars["Boolean"]["output"];
  /** 1滞在あたりの最大連泊数 */
  maxNightsPerStay?: Maybe<Scalars["Int"]["output"]>;
  /** 年間最大泊数 */
  nightsPerYear: Scalars["Int"]["output"];
};

export type OrganizationPlanMonthlyConsumedNights = {
  __typename: "OrganizationPlanMonthlyConsumedNights";
  nights: Scalars["Int"]["output"];
  yearMonth: Scalars["PlainYearMonth"]["output"];
};

/** 組織における役割 */
export const OrganizationRole = {
  /** 組織の管理者 */
  Admin: "Admin",
  /** 組織のメンバー */
  Member: "Member",
} as const;

export type OrganizationRole =
  (typeof OrganizationRole)[keyof typeof OrganizationRole];
/**
 * 年間契約
 * ある1年間の契約を表す（契約上は、自動更新だが、レコードは分かれる）
 * つまり例えば2年間継続する場合は、別の OrganizationYearlyContract を作成する。
 * 組織メンバーには公開せず、組織管理者にのみ公開される。
 */
export type OrganizationYearlyContract = {
  __typename: "OrganizationYearlyContract";
  /**
   * この契約の泊数を消化する予約。キャンセル済みも含む。
   *
   * 予約時の泊数判定（`OrganizationNightsManager`）が泊ごとに契約を引くのに合わせ、
   * 契約期間に 1 泊でも入る予約を返す。契約期間をまたぐ予約は前後どちらの契約からも見える。
   */
  accommodationReservations: Array<AccommodationReservation>;
  /** 何口契約か（実際の泊数とは必ずしも連動していない） */
  amountRecord: Scalars["Float"]["output"];
  /**
   * どのビジネスプランを契約しているか
   * これによってメンバーが負担する宿泊料金が決まる
   */
  businessPlan: BusinessPlan;
  /** 契約継続フラグ（契約終了5ヶ月前までに次期契約を自動作成するか） */
  continuationType: ContractContinuationType;
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /**
   * この契約に紐づく有効な請求書の件数
   * void を除く請求書 (draft, open, paid, uncollectible) で判定
   */
  createdInvoiceCount: Scalars["Int"]["output"];
  /** 契約終了月 */
  endMonth: Scalars["PlainYearMonth"]["output"];
  id: Scalars["ID"]["output"];
  /** 無効化日時（無効化されていない場合はnull） */
  invalidatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 現在、契約期間中かどうか */
  isCurrent: Scalars["Boolean"]["output"];
  /** 無効化されているかどうか */
  isInvalidated: Scalars["Boolean"]["output"];
  /** 次期契約の終了予定月（継続フラグがCONTINUEの場合のみ） */
  nextEndMonth?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /** 次期契約の開始予定月（継続フラグがCONTINUEの場合のみ） */
  nextStartMonth?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /** 1ヶ月あたりの最大泊数 */
  nightsPerMonth: Scalars["Int"]["output"];
  /** 年間最大泊数 */
  nightsPerYear: Scalars["Int"]["output"];
  /** 紐づく法人 */
  organization: Organization;
  /** 年間の残り利用可能宿泊数（nightsPerYear - usedNightsPerYear - scheduledNightsPerYear） */
  remainingNightsPerYear: Scalars["Int"]["output"];
  /** 年間の利用予定宿泊数（予約確定済みでチェックイン前） */
  scheduledNightsPerYear: Scalars["Int"]["output"];
  /** 契約開始月 */
  startMonth: Scalars["PlainYearMonth"]["output"];
  /** 契約ステータス（期間と削除状態から自動計算） */
  status: ContractStatus;
  /**
   * 合計料金（税込）
   * 口数とビジネスプランから計算される
   */
  totalFee: Scalars["Int"]["output"];
  /** 年間の利用済み宿泊数（チェックアウト済み + チェックイン済み） */
  usedNightsPerYear: Scalars["Int"]["output"];
};

export const OrganizationYearlyContractInvoiceFrequency = {
  /** 月間払い */
  Monthly: "Monthly",
  /** 年間一括払い */
  Yearly: "Yearly",
} as const;

export type OrganizationYearlyContractInvoiceFrequency =
  (typeof OrganizationYearlyContractInvoiceFrequency)[keyof typeof OrganizationYearlyContractInvoiceFrequency];
export const OrganizationYearlyContractInvoicePaymentMethodType = {
  /** 銀行振込 */
  BankTransfer: "BankTransfer",
  /** クレジットカード */
  CreditCard: "CreditCard",
} as const;

export type OrganizationYearlyContractInvoicePaymentMethodType =
  (typeof OrganizationYearlyContractInvoicePaymentMethodType)[keyof typeof OrganizationYearlyContractInvoicePaymentMethodType];
/** 組織年間契約に紐ずく請求書一覧のページネーション結果 */
export type OrganizationYearlyContractInvoicesResult = {
  __typename: "OrganizationYearlyContractInvoicesResult";
  /** 返却された請求書の件数 */
  count: Scalars["Int"]["output"];
  /** 請求書データ */
  data: Array<StripeInvoice>;
  /** 次のページが存在するか */
  hasMore: Scalars["Boolean"]["output"];
  /** 次のページ取得用のカーソル（最後の請求書ID） */
  nextCursor?: Maybe<Scalars["ID"]["output"]>;
};

/** 契約一覧のソート対象カラム */
export const OrganizationYearlyContractSortField = {
  /** 継続タイプ */
  ContinuationType: "ContinuationType",
  /** 作成日 */
  CreatedAt: "CreatedAt",
  /** 契約終了月 */
  EndMonth: "EndMonth",
  /** 組織名 */
  OrganizationName: "OrganizationName",
  /** 契約開始月 */
  StartMonth: "StartMonth",
  /** ステータス */
  Status: "Status",
} as const;

export type OrganizationYearlyContractSortField =
  (typeof OrganizationYearlyContractSortField)[keyof typeof OrganizationYearlyContractSortField];
/** 契約一覧のソート条件 */
export type OrganizationYearlyContractSortInput = {
  /** ソート方向（デフォルト: desc） */
  direction?: InputMaybe<SortDirection>;
  /** ソート対象カラム */
  field: OrganizationYearlyContractSortField;
};

/** 組織年間契約のページネーション結果 */
export type OrganizationYearlyContractsResult = {
  __typename: "OrganizationYearlyContractsResult";
  /** 返却された契約の件数 */
  count: Scalars["Int"]["output"];
  /** 契約データ */
  data: Array<OrganizationYearlyContract>;
  /** 次のページが存在するか */
  hasMore: Scalars["Boolean"]["output"];
  /** 次のページ取得用のカーソル（最後の契約ID） */
  nextCursor?: Maybe<Scalars["ID"]["output"]>;
};

/** 法人メンバーの契約年ごとの予約に関するステータス */
export type OrganizationYearlyReservationStatus = {
  __typename: "OrganizationYearlyReservationStatus";
  /** 該当の契約年の終了月 */
  endYearMonth: Scalars["PlainYearMonth"]["output"];
  /** 年間最大泊数 */
  maxNights: Scalars["Int"]["output"];
  /** 現時点で利用可能な泊数 */
  remainingNights: Scalars["Int"]["output"];
  /** 該当の契約年の開始月 */
  startYearMonth: Scalars["PlainYearMonth"]["output"];
};

/** OTA予約検索結果: すでに事前登録済みの場合 */
export type OtaReservationLookupError = {
  __typename: "OtaReservationLookupError";
  /** エラー種別 */
  case: OtaReservationLookupErrorCase;
};

export const OtaReservationLookupErrorCase = {
  /** すでに事前登録が済んでいる */
  AlreadyRegistered: "AlreadyRegistered",
} as const;

export type OtaReservationLookupErrorCase =
  (typeof OtaReservationLookupErrorCase)[keyof typeof OtaReservationLookupErrorCase];
/** OTA予約の検索結果 */
export type OtaReservationLookupResult =
  | OtaReservationLookupError
  | OtaReservationLookupSuccess;

/** OTA予約検索結果: 事前登録が必要な場合 */
export type OtaReservationLookupSuccess = {
  __typename: "OtaReservationLookupSuccess";
  /** 施設タイプ名（例: SANU CABIN MOSS Medium） */
  architectureTypeName: Scalars["String"]["output"];
  /** オプション設備タイプ */
  facilityTypes: Array<AccommodationFacilityType>;
  /** チェックイン日（YYYY-MM-DD） */
  firstDate: Scalars["PlainDate"]["output"];
  /** チェックアウト日（YYYY-MM-DD） */
  lastDate: Scalars["PlainDate"]["output"];
  /** 事前登録ページのURL */
  preRegistrationUrl: Scalars["String"]["output"];
  /** 拠点名（例: 河口湖2nd） */
  siteName: Scalars["String"]["output"];
};

export const OwnerIntendedUsageType = {
  LongVacation: "LongVacation",
  MainlyWeekdays: "MainlyWeekdays",
  MainlyWeekends: "MainlyWeekends",
  WeekdaysOnly: "WeekdaysOnly",
  WeekendsOnly: "WeekendsOnly",
} as const;

export type OwnerIntendedUsageType =
  (typeof OwnerIntendedUsageType)[keyof typeof OwnerIntendedUsageType];
export const OwnerOrganizationBeneficialOwnerRelationshipType = {
  Creditor: "Creditor",
  Other: "Other",
  Representative: "Representative",
  Shareholder: "Shareholder",
} as const;

export type OwnerOrganizationBeneficialOwnerRelationshipType =
  (typeof OwnerOrganizationBeneficialOwnerRelationshipType)[keyof typeof OwnerOrganizationBeneficialOwnerRelationshipType];
export const OwnerOrganizationBusinessActivityType = {
  Construction: "Construction",
  FinanceInsurance: "FinanceInsurance",
  Manufacturing: "Manufacturing",
  Other: "Other",
  RealEstate: "RealEstate",
  Service: "Service",
  Transportation: "Transportation",
  WholesaleRetail: "WholesaleRetail",
} as const;

export type OwnerOrganizationBusinessActivityType =
  (typeof OwnerOrganizationBusinessActivityType)[keyof typeof OwnerOrganizationBusinessActivityType];
export const OwnerOrganizationRelationshipType = {
  Representative: "Representative",
  TransactionManager: "TransactionManager",
} as const;

export type OwnerOrganizationRelationshipType =
  (typeof OwnerOrganizationRelationshipType)[keyof typeof OwnerOrganizationRelationshipType];
/** (Co)Ownerのプラン */
export type OwnerPlan = {
  __typename: "OwnerPlan";
  /** 部屋(FullOwnerの部屋所有の場合) */
  accommodation?: Maybe<Accommodation>;
  /** 設備 */
  accommodationFacilities: Array<AccommodationFacility>;
  /** 登録料の事前請求が必要かどうか */
  advancePaymentRequired: Scalars["Boolean"]["output"];
  /** 建築タイプ(Co-OwnersとFullOwnerの部屋所有の場合、FullOwnerの拠点所有=拠点投資家の場合は null) */
  architectureType?: Maybe<ArchitectureType>;
  /** バルコニー面積 */
  balconySizeSqm: Scalars["Float"]["output"];
  /** 基本料金 */
  baseAccommodationFeePerNight: Scalars["Int"]["output"];
  /**
   * Co-Owners 1口あたりの同時予約保持件数上限。
   * CoOwners 以外は null。
   */
  coOwnersMaxConcurrentReservationsPerUnit?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Co-Owners 1口あたりのHigh日数上限。
   * CoOwners かつ繁忙日制限あり（limitPeakDays=true）のプランのみ値を持ち、それ以外は null。
   */
  coOwnersMaxPeakDaysPerUnit?: Maybe<Scalars["Int"]["output"]>;
  /** CoOwnersプランの提供内容 */
  coOwnersPlanOfferings: Array<CoOwnersPlanOffering>;
  /** ドッグ棟フィルター */
  dogFriendlyFilter?: Maybe<AccommodationFacilityFilterType>;
  /** 権利形態 */
  formOfRights: Scalars["String"]["output"];
  /**
   * FullOwnerの利用規約（常に null を返す）
   * @deprecated Owners の規約は Terms / TermsRevision に統合した。個別の規約本文は Terms.individualDocument が持つ
   */
  fullOwnerContract?: Maybe<UploadedFile>;
  /** 客室面積 */
  guestRoomSizeSqm: Scalars["Float"]["output"];
  /**
   * 引き渡し開始予定年月
   * null の場合は、引き渡し開始予定年月が未登録（過去のプラン）。
   */
  handoverStartDate?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /**
   * 指定した宿泊日の所有クラス
   * 省略時は運用タイプと同じ基準（改定日時点の設定値）で解決する、改定ルール適用前の宿泊日は null
   */
  heldAccommodationClass?: Maybe<AccommodationClass>;
  id: Scalars["ID"]["output"];
  /** CoOwners プラン（管理者向け） */
  internalCoOwnersPlanOfferings: Array<CoOwnersPlanOffering>;
  /** 借地対象面積 */
  leasedLandSizeSqm: Scalars["Float"]["output"];
  /** // 繁忙日の制限有無 (CoOwners のみ) */
  limitPeakDays: Scalars["Boolean"]["output"];
  /** 管理名 */
  managedName: Scalars["String"]["output"];
  /** プラン名（拠点所有の場合は拠点名、部屋所有の場合は部屋名） */
  name: Scalars["String"]["output"];
  /** 他拠点利用基本料金、CoOwners の場合は baseAccommodationFeePerNight と同じ値 */
  nonOwnedBaseAccommodationFeePerNight: Scalars["Int"]["output"];
  /** 1口あたりの登録料（本来は`unit`prefixがついているべき） */
  registrationFee: Scalars["Int"]["output"];
  /** 登録料先行支払期限。期限を過ぎても登録料が未入金の申込は、残代金請求に登録料を含める */
  registrationFeeAdvancePaymentDeadline?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 拠点 */
  site: Site;
  /** 敷地面積 */
  siteSizeSqm: Scalars["Float"]["output"];
  /** 口数 */
  totalUnits: Scalars["Int"]["output"];
  /** CoOwners か FullOwner か */
  type: OwnerPlanType;
  /** 1口あたり火災保険料 */
  unitAnnualFireInsuranceFee: Scalars["Int"]["output"];
  /** 1口あたり借地料 */
  unitAnnualLandRentFee: Scalars["Int"]["output"];
  /** 1口あたり年間管理費 */
  unitAnnualMaintenanceFee: Scalars["Int"]["output"];
  /** 1口あたり温泉基本料金・更新料 */
  unitAnnualOnsenFee: Scalars["Int"]["output"];
  /** 1口あたり建物固定資産税 */
  unitAnnualPropertyTax: Scalars["Int"]["output"];
  /** 1口あたり修繕積立金 */
  unitAnnualRepairReserve: Scalars["Int"]["output"];
  /** 1口あたり申込金 */
  unitApplicationFee: Scalars["Int"]["output"];
  /** 1口あたり建物費 */
  unitBuildingFee: Scalars["Int"]["output"];
  /** 1口あたり年間の泊数 */
  unitNightsPerYear: Scalars["Int"]["output"];
  /** 1口あたり購入金額 */
  unitPurchaseAmount: Scalars["Int"]["output"];
};

/** (Co)Ownerのプラン */
export type OwnerPlanCoOwnersPlanOfferingsArgs = {
  earlyAccessCode?: InputMaybe<Scalars["String"]["input"]>;
};

/** (Co)Ownerのプラン */
export type OwnerPlanHeldAccommodationClassArgs = {
  night?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export const OwnerPlanType = {
  CoOwners: "CoOwners",
  FullOwner: "FullOwner",
} as const;

export type OwnerPlanType = (typeof OwnerPlanType)[keyof typeof OwnerPlanType];
export const OwnerPurchasePurposeType = {
  Other: "Other",
  SelfUse: "SelfUse",
} as const;

export type OwnerPurchasePurposeType =
  (typeof OwnerPurchasePurposeType)[keyof typeof OwnerPurchasePurposeType];
export type PartialUpdateOrganizationError = {
  __typename: "PartialUpdateOrganizationError";
  message: Scalars["String"]["output"];
};

export type PartialUpdateOrganizationInput = {
  announcementContent?: InputMaybe<Scalars["String"]["input"]>;
  billingEmail?: InputMaybe<Scalars["String"]["input"]>;
  defaultFrequency?: InputMaybe<OrganizationYearlyContractInvoiceFrequency>;
  defaultPaymentMethod?: InputMaybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  emailDomainsForMember?: InputMaybe<Array<Scalars["String"]["input"]>>;
  invitationCode?: InputMaybe<Scalars["String"]["input"]>;
  maxNightsPerMember?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerStay?: InputMaybe<Scalars["Int"]["input"]>;
  memberCustomFieldEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  memberCustomFieldName?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldPlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodCardEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  suspended?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PartialUpdateOrganizationMembershipError = {
  __typename: "PartialUpdateOrganizationMembershipError";
  message: Scalars["String"]["output"];
};

export type PartialUpdateOrganizationMembershipInput = {
  customFieldValue?: InputMaybe<Scalars["String"]["input"]>;
  reservationStatus?: InputMaybe<OrganizationMemberReservationStatus>;
  role?: InputMaybe<OrganizationRole>;
};

export type PartialUpdateOrganizationMembershipPayload =
  | OrganizationMembership
  | PartialUpdateOrganizationMembershipError;

export type PartialUpdateOrganizationPayload =
  | Organization
  | PartialUpdateOrganizationError;

export const PaymentMethodType = {
  BankTransfer: "BankTransfer",
  Card: "Card",
} as const;

export type PaymentMethodType =
  (typeof PaymentMethodType)[keyof typeof PaymentMethodType];
/** PlainYearMonthのフィルタ条件 */
export type PlainYearMonthFilter = {
  /** 以上（gte）でフィルタする場合はtrue、完全一致の場合はfalse（デフォルト: false） */
  gte?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 以下（lte）でフィルタする場合はtrue、完全一致の場合はfalse（デフォルト: false） */
  lte?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 値 */
  value: Scalars["PlainYearMonth"]["input"];
};

/** スマートプラグのデバイス情報 */
export type PlugDevice = {
  __typename: "PlugDevice";
  /** デバイスのID */
  id: Scalars["ID"]["output"];
  /** 最終状態変更日時 */
  lastChangedAt: Scalars["ZonedDateTime"]["output"];
  /** ステータス */
  status: PlugDeviceStatus;
};

export const PlugDeviceStatus = {
  Available: "Available",
  InUse: "InUse",
  Unknown: "Unknown",
} as const;

export type PlugDeviceStatus =
  (typeof PlugDeviceStatus)[keyof typeof PlugDeviceStatus];
/** 新滞在レビュー回答投稿エラー */
export type PostStayReviewResponseError = {
  __typename: "PostStayReviewResponseError";
  case: PostStayReviewResponseErrorCase;
};

export const PostStayReviewResponseErrorCase = {
  /** 権限がない（他人の予約） */
  NotAuthorized: "NotAuthorized",
  /** 指定した設問が存在しない */
  QuestionnaireNotFound: "QuestionnaireNotFound",
  /** 入力値が不正（必須フィールドが未指定） */
  ValidationError: "ValidationError",
} as const;

export type PostStayReviewResponseErrorCase =
  (typeof PostStayReviewResponseErrorCase)[keyof typeof PostStayReviewResponseErrorCase];
/**
 * 新滞在レビュー回答投稿の入力
 * 各入力値を省略した場合は元の値を保持する
 */
export type PostStayReviewResponseInput = {
  /** チェックアウト後の自由記入設問の回答 */
  freeTextAfterCheckOutAnswer?: InputMaybe<Scalars["String"]["input"]>;
  /** チェックアウト時の自由記入設問の回答 */
  freeTextAtCheckOutAnswer?: InputMaybe<Scalars["String"]["input"]>;
  /** 回答対象の設問のID */
  questionnaireId: Scalars["ID"]["input"];
  /**
   * 滞在の満足度
   * 1-5の5段階評価
   */
  rating?: InputMaybe<Scalars["Int"]["input"]>;
  /** チェックアウト後の選択式設問の回答（選択肢の key の配列） */
  selectionAfterCheckOutAnswer?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** チェックアウト時の選択式設問の回答（選択肢の key の配列） */
  selectionAtCheckOutAnswer?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PostStayReviewResponsePayload =
  | PostStayReviewResponseError
  | StayReviewResponse;

export type PriceWithTaxRate = {
  __typename: "PriceWithTaxRate";
  price: Scalars["Int"]["output"];
  taxRate: Scalars["Float"]["output"];
};

export type ProcessCronJobResponse = {
  __typename: "ProcessCronJobResponse";
  body: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
};

export type ProcessStripeEventResponse = {
  __typename: "ProcessStripeEventResponse";
  body: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
};

export type ProcessTrustdockEventResponse = {
  __typename: "ProcessTrustdockEventResponse";
  body: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
};

export const PushNotificationPlatform = {
  Android: "Android",
  Apple: "Apple",
} as const;

export type PushNotificationPlatform =
  (typeof PushNotificationPlatform)[keyof typeof PushNotificationPlatform];
export type Query = {
  __typename: "Query";
  /** 施設 (accommodation) を id で取得する。存在しない場合は null。認証不要。 */
  accommodation?: Maybe<Accommodation>;
  /** 宿泊施設の利用ブロック */
  accommodationAvailabilityBlock: AccommodationAvailabilityBlock;
  /** 予約ブロックカテゴリのマスタ一覧 */
  accommodationAvailabilityBlockCategoryInfos: Array<AccommodationAvailabilityBlockCategoryInfo>;
  /** 宿泊施設の利用ブロック一覧 */
  accommodationAvailabilityBlocks: Array<AccommodationAvailabilityBlock>;
  /** 宿泊予約 */
  accommodationReservation: AccommodationReservation;
  /**
   * 宿泊予約として可能なチェックアウト日
   * Accommodation.availabilities が可能なチェックイン日の候補を返すのに対して、
   * チェックイン日を選択した次のステップとして、可能なチェックアウト日の候補を返す。
   */
  accommodationReservationCheckOutAvailabilities: AccommodationReservationCheckOutAvailabilitiesPayload;
  /** 建築ページトップ */
  architectureTopPage: ContentArchitecturePageNavigation;
  /** 建築タイプページ */
  architectureTypePage: ContentArchitectureType;
  /** 建築タイプ一覧 */
  architectureTypes: Array<ArchitectureType>;
  /**
   * 単一エリアを slug で取得 (DXPJ 公開ページ用)。
   * 該当なし / 非公開の場合は null。
   */
  areaBySlug?: Maybe<Area>;
  /** published 済みの拠点を持つエリアの一覧。非公開を含む全件は internalAreas を使う。 */
  areas: Array<Area>;
  /** 予約ができるエリア一覧 */
  areasForReservation: Array<Area>;
  /** キャンセル可能なStay Giftチケット一覧を取得（Co-Owners/Owners向け） */
  cancellableStayGiftsForOwner: Array<StayTicket>;
  /** CoOwnersの申し込み */
  coOwnersApplication: CoOwnersApplication;
  /** 重要事項説明会スケジュール */
  coOwnersWebinarSchedule: CoOwnersWebinarSchedule;
  /**
   * 宿泊料金の見積もりが入ったドラフト予約
   * チェックイン日・チェックアウト日を選択した次のステップとして、
   * 予約フォームの下部で確定前に表示されるオブジェクトに相当。
   * 特にデータストアに永続化される前の予約であることに注意
   */
  draftAccommodationReservation: DraftAccommodationReservation;
  /**
   * provider を経由せず StayTicketMaster から直接見積もる、非会員向けの宿泊料金プレビュー。
   * 発行済み StayTicketUnit の実在を前提にしたフィールド（キャンセルポリシー等）は持たない。
   */
  draftAccommodationReservationByStayTicketMaster: DraftAccommodationReservationByStayTicketMasterResult;
  /** スタンダードプランの初月料金の見積もり */
  estimateStandardSubscriptionApplicationFee: EstimateStandardSubscriptionApplicationFeePayload;
  /** 宿泊予約をキャンセルした場合の料金の見積もり */
  estimatedCancelFeeOfAccommodationReservation: EstimatedCancelFeeOfAccommodationReservationPayload;
  /** 宿泊予約を変更する際にかかる変更手数料の見積もり */
  estimatedChangeFeeOfAccommodationReservation: EstimatedChangeFeeOfAccommodationReservationPayload;
  /** Co-Owners/Ownersプラン所有者が発行したStay Giftチケットをエクスポート用に取得 */
  exportStayGiftsForOwner: ExportStayGiftsPayload;
  /** 付帯サービスを取得 */
  facility?: Maybe<Facility>;
  /** 付帯サービス予約を取得 */
  facilityReservation?: Maybe<FacilityReservation>;
  /** Featureページ */
  featurePage: ContentArchitectureTypeFeature;
  /** 開発用のフック */
  hook?: Maybe<Scalars["String"]["output"]>;
  /** 宿泊施設の取得（ID指定） */
  internalAccommodation?: Maybe<Accommodation>;
  /** ブロック解放スケジュール一覧（管理者向け） */
  internalAccommodationAvailabilityBlockReleaseSchedules: Array<AccommodationAvailabilityBlockReleaseSchedule>;
  /**
   * すべての宿泊施設の機器一覧（Admin 用）
   * 拠点・部屋を横断してすべての機器情報を確認できる。status を問わず全件返す
   */
  internalAccommodationEquipments: Array<AccommodationEquipment>;
  /** 設備（サウナ・温泉など宿泊施設に備わる区分）の一覧 */
  internalAccommodationFacilities: Array<AccommodationFacility>;
  /** 設備詳細（管理者向け） */
  internalAccommodationFacility: AccommodationFacility;
  /** 宿泊施設お知らせ一覧 */
  internalAccommodationNotices: Array<AccommodationNotice>;
  /** 拠点の運用グループ一覧 */
  internalAccommodationOperationGroups: Array<AccommodationOperationGroup>;
  /** 予約一覧 */
  internalAccommodationReservationsBySearch: Array<AccommodationReservation>;
  /**
   * 予約一覧の CSV 用。引数と返す行は internalAccommodationReservationsBySearch と同じで、
   * 書き出しを閲覧と別の権限で絞るために root を分けている。
   */
  internalAccommodationReservationsForExport: Array<AccommodationReservation>;
  /**
   * 宿泊施設の一覧（code順）
   * siteIdsを指定すると、指定した拠点の宿泊施設のみを返す
   */
  internalAccommodations: Array<Accommodation>;
  /** 追加ゲスト料金ポリシーの一覧 */
  internalAdditionalGuestFeePolicies: Array<AdditionalGuestFeePolicy>;
  /** ID による追加ゲスト料金ポリシーの取得 */
  internalAdditionalGuestFeePolicyById?: Maybe<AdditionalGuestFeePolicy>;
  /**
   * 全ユーザーの管理ロールの割り当て。付与の新しい順。既定は有効なもの（未失効・未期限切れ）だけ。
   * 拠点スコープの付与権（PartnerSiteManager）では siteId が必須で、その拠点の割り当てのうち自分が付与・剥奪できるロール
   * （PartnerSiteStaff）の行だけ返し、PartnerSiteManager の行（自分の行を含む）は返さない。
   * 全拠点の付与権（SuperAdmin・RoleAdmin）も持つ主体は PartnerSiteManager を兼ねていても絞らず、複数の拠点の PartnerSiteManager は指定した拠点ごとに同じく絞る
   */
  internalAdminRoleAssignments: Array<AdminRoleAssignment>;
  /** 建築タイプ詳細（管理者向け） */
  internalArchitectureType: ArchitectureType;
  /** 建築タイプ一覧（管理者向け） */
  internalArchitectureTypes: Array<ArchitectureType>;
  /** エリア詳細 */
  internalArea: InternalArea;
  /** エリアガイド記事の全件（admin 用、sort 昇順） */
  internalAreaGuideArticles: Array<AreaGuideArticle>;
  /** エリア一覧（管理者向け、sort 昇順）。配下拠点の運用フラグ (published 等) を含む。 */
  internalAreas: Array<InternalArea>;
  /** Auth0ダッシュボードのベースURL（例: https://manage.auth0.com/dashboard/jp/sanu-dev） */
  internalAuth0DashboardBaseUrl: Scalars["String"]["output"];
  /** Auth0 Management APIからメールアドレスで検索したユーザー一覧 */
  internalAuth0UsersByEmail: Array<InternalAuth0User>;
  /** スタッフプラン登録可能なターム一覧 */
  internalAvailableStaffSemesters: Array<InternalAvailableStaffSemester>;
  /** 基本宿泊料金ポリシーの一覧 */
  internalBaseAccommodationFeePolicies: Array<RawBaseAccommodationFeePolicy>;
  /** Beds24 予約Block 削除の対象件数 (accommodationAvailabilityBlockId: null かつ beds24BlackBookingId: not null) */
  internalBeds24DeleteBlackBookingsTargetCount: Scalars["Int"]["output"];
  /** Beds24プロパティ情報をAPIから取得（JSON文字列で返却） */
  internalBeds24Property: Scalars["String"]["output"];
  /**
   * beds24 refresh token の有効性チェック（valid / error を JSON 文字列で返却）。
   * IP 環境・ローカル開発環境の Admin 限定
   */
  internalBeds24TokenStatus: Scalars["String"]["output"];
  /** 法人プランの一覧 */
  internalBusinessPlans: Array<BusinessPlan>;
  /** キャンセル料金ポリシーの一覧 */
  internalCancelFeePolicies: Array<RawCancelFeePolicy>;
  /** Co-Owners 申し込み */
  internalCoOwnersApplication?: Maybe<CoOwnersApplication>;
  /** Co-Owners 申し込み一覧 */
  internalCoOwnersApplications: Array<CoOwnersApplication>;
  /**
   * バクラク連携用CoOwners年次請求明細一覧
   * 対象は引渡完了（HandoverCompleted）の申込
   */
  internalCoOwnersBakurakuInvoiceAnnualPaymentItems: Array<CoOwnersBakurakuInvoiceAnnualPaymentItem>;
  /**
   * バクラク連携用CoOwners申込者一覧
   * 対象は入金完了前の全てのステータスの申込。送付先はユーザー単位なので同一申込者は 1 件にまとめる
   */
  internalCoOwnersBakurakuInvoiceRecipients: Array<CoOwnersBakurakuInvoiceRecipient>;
  /**
   * バクラク連携用CoOwners登録料請求明細一覧
   * 対象は登録料を事前請求する（advancePaymentRequired）契約締結済み（ContractSigned）の申込のうち、登録料先行支払期限内のもの
   */
  internalCoOwnersBakurakuInvoiceRegistrationFeeItems: Array<CoOwnersBakurakuInvoiceRegistrationFeeItem>;
  /** 引渡希望日が未設定のため、残代金請求明細から除外した申込の件数 */
  internalCoOwnersBakurakuInvoiceRemainingPaymentExcludedApplicationCount: Scalars["Int"]["output"];
  /** バクラク連携用CoOwners残代金請求明細一覧 */
  internalCoOwnersBakurakuInvoiceRemainingPaymentItems: Array<CoOwnersBakurakuInvoiceRemainingPaymentItem>;
  /** 重要事項説明会一覧 */
  internalCoOwnersWebinarSchedules: Array<CoOwnersWebinarSchedule>;
  /** 建築家マスタ一覧（管理者向け、名前順） */
  internalContentArchitects: Array<ContentArchitect>;
  /** 設備コンテンツを設備 ID で引く（管理者向け）。未作成なら null */
  internalContentArchitecturalFeature?: Maybe<ContentArchitecturalFeature>;
  /** 建築ページ「基本の設備」マスタ一覧（管理者向け、sort 昇順） */
  internalContentArchitectureTypeBasicAmenities: Array<ContentArchitectureTypeBasicAmenity>;
  /**
   * 設備アメニティマスタ一覧（管理者向け、設備 → 名前順）。
   * accommodationFacilityId を指定するとその設備に属するものだけ返す
   */
  internalContentFacilityAmenities: Array<ContentArchitectureTypeVariantFacilityAmenity>;
  /**
   * Admin画面から、宿泊料金の見積もりが入ったドラフト予約
   * （予約フォームの下部で確定前に表示されるオブジェクトに相当）
   */
  internalDraftAccommodationReservation: DraftAccommodationReservation;
  /** 付帯サービス一覧を取得 */
  internalFacilities: Array<Facility>;
  /** 付帯サービスを取得 */
  internalFacility?: Maybe<Facility>;
  /** 付帯サービス予約一覧を取得 */
  internalFacilityReservations: Array<FacilityReservation>;
  /** 付帯サービスリソースのブロック一覧を取得 */
  internalFacilityResourceBlocks: Array<FacilityResourceBlock>;
  /**
   * 拠点ごとの未来の清掃量の一覧
   * 向こう2ヶ月分を返す
   * https://www.notion.so/sanu/Voyage-1b3d14f248a880a1801de9a485450222?pvs=4
   */
  internalFutureCleaningAmounts: InternalFutureCleaningAmountsPayload;
  /** ロックデバイス用の重複しないPINコードを生成する */
  internalGeneratePinCodeForLockDevice: Scalars["String"]["output"];
  /**
   * ユーザーの月次利用明細を生成する
   * 対象月（yearMonth）の予約に基づいて利用額を集計します
   * Ownersの家賃相殺計算用に作成した
   *
   * 対象月にチェックアウトしたものだけが計算対象なので注意
   * 例: 7/30チェックイン - 8/3チェックアウト: 8月が対象月
   */
  internalGenerateUserMonthlyStatement: InternalGenerateUserMonthlyStatementPayload;
  /**
   * 呼び出し元が internalAssignAdminRole で付与できるロールの一覧。siteId を渡すとその拠点に付与できるものに絞る。
   * 拠点スコープの付与権（PartnerSiteManager）では siteId が必須
   */
  internalGrantableAdminRoles: Array<InternalGrantableAdminRole>;
  /** ハイシーズン期間の一覧 */
  internalHighSeasonPeriods: Array<HighSeasonPeriod>;
  /**
   * 確認報告の一覧を新しい順に返す。
   * startFirstNight / endFirstNight は滞在の初日の範囲で絞り、片方だけの指定もできる。
   * id / type / siteId はいずれも絞り込みで、複数指定すると全てで絞る。
   * userId は宿泊者での絞り込みで、過去の違反履歴の取得に使う。
   */
  internalInspectionReports: Array<InspectionReport>;
  /**
   * IP 環境 beds24 セットアップの実行前見積もり（JSON 文字列で返却）。
   * DB カウントのみで beds24 への credit 消費なし。
   * fromDate / toDate（YYYY-MM-DD）は予約・ブロックの同期対象範囲
   */
  internalIpBeds24SetupEstimate: Scalars["String"]["output"];
  /** IP 環境 beds24 セットアップの進捗（JSON 文字列で返却、null = 未実行） */
  internalIpBeds24SetupStatus?: Maybe<Scalars["String"]["output"]>;
  /**
   * 確認日の清掃を取得する。予約が居ない部屋も空室として返す。
   * accommodationId を指定するとその部屋のみ、siteId のみなら拠点の全部屋。
   * 両方指定した場合は accommodationId が勝ち、どちらも未指定はエラー。
   * reservationId は accommodationId 指定時にのみ意味を持ち、キャンセルで
   * 在庫から引けなくなった予約の引き直しに使う
   */
  internalJtasInspections: Array<Inspection>;
  /** 地方税ポリシーの一覧。自治体名・税種別の順に並び、同じ自治体・税種別では有効開始日の新しい順 */
  internalLocalTaxPolicies: Array<LocalTaxPolicy>;
  /** 地方税ポリシーの詳細 */
  internalLocalTaxPolicy: LocalTaxPolicy;
  /** ネイティブアプリのホームコンテンツ取得 */
  internalNativeAppHomeContent?: Maybe<InternalNativeAppHomeContent>;
  /** ネイティブアプリのホームコンテンツ一覧 */
  internalNativeAppHomeContents: Array<InternalNativeAppHomeContent>;
  /** お知らせ一覧 */
  internalNews: Array<RawNews>;
  /** 指定 slug の one-shot スクリプト (ソース付き)。未登録の slug は null */
  internalOneShotScript?: Maybe<InternalOneShotScript>;
  /** レジストリに登録された one-shot スクリプト一覧 */
  internalOneShotScripts: Array<InternalOneShotScript>;
  /** 法人の詳細 */
  internalOrganization: Organization;
  /** 全法人の請求書一覧 */
  internalOrganizationYearlyContractInvoices: OrganizationYearlyContractInvoicesResult;
  /** 全法人の年間契約一覧 */
  internalOrganizationYearlyContracts: OrganizationYearlyContractsResult;
  /** 法人の一覧 */
  internalOrganizations: Array<Organization>;
  /** オーナープラン一覧 */
  internalOwnerPlans: Array<OwnerPlan>;
  /** スクリプト実行履歴 (新しい順)。slug 省略時は全スクリプト横断 */
  internalScriptExecutions: Array<InternalScriptExecution>;
  /** シーズン料金設定の一覧 */
  internalSeasonalFeeSettings: Array<SeasonalFeeSetting>;
  /** 拠点詳細 */
  internalSite: InternalSite;
  /** Nature Club のアクティビティプログラムを取得 */
  internalSiteActivityProgram?: Maybe<SiteActivityProgram>;
  /** Nature Club のアクティビティプログラム一覧を取得（削除済みを除く、作成日時の新しい順） */
  internalSiteActivityPrograms: Array<SiteActivityProgram>;
  /** 拠点FAQの一覧（管理者向け） */
  internalSiteFaqs: Array<RawSiteFaq>;
  /** 拠点ハイシーズン期間の一覧（管理者向け） */
  internalSiteHighSeasonPeriods: Array<SiteHighSeasonPeriod>;
  /** 拠点一覧。siteId を指定すると該当拠点のみ返す。省略時は予約可能な全拠点を返す。 */
  internalSites: Array<Site>;
  /** スタッフプラン契約詳細（管理画面用） */
  internalStaffContract: InternalStaffContract;
  /** スタッフプラン契約一覧（管理画面用） */
  internalStaffContracts: Array<InternalStaffContract>;
  /** スタッフプラン宿泊クレジット履歴（管理画面用） */
  internalStaffCreditTransactions: Array<InternalStaffCreditTransaction>;
  /** 社内スタッフグループの詳細（管理画面用） */
  internalStaffGroup: StaffGroup;
  /** 新滞在レビュー回答 */
  internalStayReviewResponse: StayReviewResponseWithReservation;
  /** 新滞在レビュー回答一覧 */
  internalStayReviewResponses: Array<StayReviewResponseWithReservation>;
  /** 滞在レビュー 2.0 が送信済みの宿泊予約。チェックアウト日（lastNight の翌日）の範囲で絞り、送信日時の降順で返す */
  internalStayReviewedAccommodationReservations: Array<AccommodationReservation>;
  /** コードによるチケットの取得 */
  internalStayTicketByCode?: Maybe<StayTicket>;
  /** ID によるチケットマスタの取得 */
  internalStayTicketMasterById?: Maybe<StayTicketMaster>;
  /** チケットマスター雛形一覧 */
  internalStayTicketMasterTemplates: Array<StayTicketMasterTemplate>;
  /** チケットマスタ一覧 */
  internalStayTicketMasters: Array<StayTicketMaster>;
  /** 宿泊チケットのテンプレート一覧 */
  internalStayTicketTemplates: Array<StayTicketTemplate>;
  /** 宿泊チケット一覧（管理画面用、ページネーション対応） */
  internalStayTickets: InternalStayTicketsResult;
  /** StripeダッシュボードのベースURL（例: https://dashboard.stripe.com/test） */
  internalStripeDashboardBaseUrl: Scalars["String"]["output"];
  /** 備品マスタを1件取得する。詳細画面のように id が既知の場合はこちらを使う */
  internalSupplyItemMaster?: Maybe<SupplyItemMaster>;
  /** 有効な備品マスタ一覧 */
  internalSupplyItemMasters: Array<SupplyItemMaster>;
  /** 部屋に設置されている備品を、部屋 > 建物タイプ > 拠点共通 の優先度で解決して返す */
  internalSupplyItems: Array<SupplyItem>;
  /** 規約一覧（共通規約と個別規約） */
  internalTerms: Array<Terms>;
  /** ユーザー */
  internalUser: User;
  /** オーナーシップ */
  internalUserOwnership: UserOwnership;
  /** オーナーシップ一覧 */
  internalUserOwnerships: Array<UserOwnership>;
  /** ユーザー統計情報 */
  internalUserStats: InternalUserStats;
  /** ユーザー一覧 */
  internalUsers: Array<User>;
  /** ユーザー一覧（検索） */
  internalUsersBySearch: Array<User>;
  /** ユーザー検索（ページネーション対応） */
  internalUsersSearch: InternalUserSearchResult;
  /**
   * OTA予約の予約参照番号で予約を検索し、事前登録URLまたはエラーを返す
   * 該当する予約がない場合は空配列を返す
   */
  lookupOtaReservationByReference: Array<OtaReservationLookupResult>;
  /** 現在のログインユーザー（ログインしなくても見れるがログイン情報で変化するページで利用する） */
  maybeViewer?: Maybe<User>;
  /** アプリホーム画面のコンテンツ一覧 */
  nativeAppHomeContents: Array<NativeAppHomeContent>;
  /** お知らせ一覧 */
  news: Array<News>;
  /** お知らせ詳細 */
  newsDetail: News;
  /** CoOwnersプランの提供内容 */
  offeredCoOwnersPlans: Array<OwnerPlan>;
  /** 法人組織 */
  organization: Organization;
  /** 招待コードから法人組織のIDを取得する */
  organizationIdByInvitationCode?: Maybe<Scalars["ID"]["output"]>;
  /** 組織メンバーの取得 */
  organizationMember: OrganizationMemberPayload;
  /** オーナープランの取得 */
  ownerPlan: OwnerPlan;
  /**
   * 指定期間のうち、繁忙日となる宿泊日。
   * 期間は予約できる範囲（今日〜1年後）に切り詰めて判定し、範囲外の日付は結果に含めない。
   * 繁忙日の定義は provider ごとの予約ルール改定の適用開始宿泊日によって変わるため provider を受け取る。
   * forBiz のルール移行が完了する 2028/5 宿泊以降は provider が不要になるので、その時点で引数から外す。
   */
  peakDays: Array<Scalars["PlainDate"]["output"]>;
  /** スマートプラグを取得 */
  plugDevice?: Maybe<PlugDevice>;
  /** 2027年度予約ルール改定の設定値を provider ごとに返す。 */
  reservationRuleRevision2027Policy: ReservationRuleRevision2027Policy;
  /**
   * ルームタイプを id で取得する。存在しない場合は null。認証不要。
   * 部屋タイプ予約の詳細モーダルなど、accommodation を介さず RoomType 単体で詳細を引くために使う。
   */
  roomType?: Maybe<RoomType>;
  /**
   * 部屋タイプ詳細ページ (公開)。拠点 slug と部屋タイプ slug で一意に引く。
   * 該当が無い場合は null (FE 側で notFound 表示)。
   */
  roomTypeBySlug?: Maybe<RoomType>;
  /**
   * 単一拠点を slug で取得 (DXPJ 公開ページ用)。
   * published 済みの拠点のみを返す (予約開始前の拠点も含む)。
   * 該当なし / 非公開の場合は null。
   */
  siteBySlug?: Maybe<Site>;
  /**
   * 社内スタッフグループの一覧
   * 発行したチケットや予約ブロックに紐づけるためのグループ
   * 基本的に組織図とマッチさせる
   */
  staffGroups: Array<StaffGroup>;
  /** 新滞在レビューの設問 */
  stayReviewQuestionnaire: StayReviewQuestionnaire;
  /** 滞在レビュー 2.0 の設問定義。設問は固定で、ラベルの正はサーバー側にある */
  stayReviewV2Form: StayReviewV2Form;
  /**
   * 宿泊チケットのユーザー向け情報をStayTicketUnitIdで取得する。
   * 返すのは masterやownership 由来の config のみで、個別チケットの情報（code / stayTickets 等）は含まない。
   * unit が存在しない場合は null。
   */
  stayTicketReservationInfo?: Maybe<StayTicketReservationInfo>;
  /** ユーザーに紐づいていない仮予約を `userAcceptCode` で取得する */
  tentativeAccommodationReservation: TentativeAccommodationReservationPayload;
  /** トップページコンテンツ */
  topPage: TopPage;
  /** コードから URL パスを取得する */
  urlFromCode?: Maybe<Scalars["String"]["output"]>;
  /** 同伴者 */
  userCompanion: UserCompanion;
  /** オーナーシップの取得 */
  userOwnership: UserOwnership;
  /** アカウント連携のセッショントークンを検証し、連携候補情報を返す */
  verifyAccountLinkSession: VerifyAccountLinkSessionPayload;
  /** 現在のログインユーザー（ログイン前提のページではこちらを利用すると良い） */
  viewer: User;
};

export type QueryAccommodationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAccommodationAvailabilityBlockArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAccommodationAvailabilityBlocksArgs = {
  accommodationScope?: InputMaybe<AccommodationScope>;
  endBeginNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startBeginNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAccommodationReservationCheckOutAvailabilitiesArgs = {
  input: AccommodationReservationCheckOutAvailabilitiesInput;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryArchitectureTypePageArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryArchitectureTypesArgs = {
  withPrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAreaBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryAreasForReservationArgs = {
  areaIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

export type QueryCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCoOwnersWebinarScheduleArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDraftAccommodationReservationArgs = {
  input: DraftAccommodationReservationInput;
};

export type QueryDraftAccommodationReservationByStayTicketMasterArgs = {
  input: DraftAccommodationReservationByStayTicketMasterInput;
};

export type QueryEstimateStandardSubscriptionApplicationFeeArgs = {
  promotionCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryEstimatedCancelFeeOfAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryEstimatedChangeFeeOfAccommodationReservationArgs = {
  fromAccommodationReservationId: Scalars["ID"]["input"];
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  to: EstimatedChangeFeeOfAccommodationReservationInput;
};

export type QueryExportStayGiftsForOwnerArgs = {
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFacilityArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
  facilityType: FacilityType;
};

export type QueryFacilityReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFeaturePageArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryHookArgs = {
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryInternalAccommodationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalAccommodationFacilityArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalAccommodationOperationGroupsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type QueryInternalAccommodationReservationsBySearchArgs = {
  accommodationScope?: InputMaybe<AccommodationScope>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryInternalAccommodationReservationsForExportArgs = {
  accommodationScope?: InputMaybe<AccommodationScope>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryInternalAccommodationsArgs = {
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryInternalAdditionalGuestFeePolicyByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalAdminRoleAssignmentsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
  role?: InputMaybe<AdminRole>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalArchitectureTypeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalAreaArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalAuth0UsersByEmailArgs = {
  email: Scalars["String"]["input"];
};

export type QueryInternalBeds24PropertyArgs = {
  propertyId: Scalars["Int"]["input"];
};

export type QueryInternalCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalCoOwnersBakurakuInvoiceAnnualPaymentItemsArgs = {
  programYear: Scalars["Int"]["input"];
};

export type QueryInternalContentArchitecturalFeatureArgs = {
  accommodationFacilityId: Scalars["ID"]["input"];
};

export type QueryInternalContentFacilityAmenitiesArgs = {
  accommodationFacilityId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalDraftAccommodationReservationArgs = {
  input: DraftAccommodationReservationInput;
  waiveCleaningFee: Scalars["Boolean"]["input"];
};

export type QueryInternalFacilitiesArgs = {
  facilityType?: InputMaybe<FacilityType>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalFacilityArgs = {
  accommodationReservationId?: InputMaybe<Scalars["ID"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type QueryInternalFacilityReservationsArgs = {
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  facilityType?: InputMaybe<FacilityType>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  status?: InputMaybe<FacilityReservationStatusType>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalFacilityResourceBlocksArgs = {
  blockType?: InputMaybe<FacilityResourceBlockType>;
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  facilityType?: InputMaybe<FacilityType>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryInternalFutureCleaningAmountsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type QueryInternalGenerateUserMonthlyStatementArgs = {
  userId: Scalars["ID"]["input"];
  yearMonth: Scalars["PlainYearMonth"]["input"];
};

export type QueryInternalGrantableAdminRolesArgs = {
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalInspectionReportsArgs = {
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  type?: InputMaybe<InspectionReportType>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalIpBeds24SetupEstimateArgs = {
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  phases?: InputMaybe<Array<Scalars["String"]["input"]>>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryInternalJtasInspectionsArgs = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  inspectionDate: Scalars["PlainDate"]["input"];
  reservationId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalLocalTaxPolicyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalNativeAppHomeContentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalOneShotScriptArgs = {
  slug: Scalars["ID"]["input"];
};

export type QueryInternalOrganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalOrganizationYearlyContractInvoicesArgs = {
  contractEndMonth?: InputMaybe<PlainYearMonthFilter>;
  contractIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  contractStartMonth?: InputMaybe<PlainYearMonthFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  organizationIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  startingAfter?: InputMaybe<Scalars["ID"]["input"]>;
  statuses?: InputMaybe<Array<StripeInvoiceStatus>>;
};

export type QueryInternalOrganizationYearlyContractsArgs = {
  contractIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endMonth?: InputMaybe<PlainYearMonthFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  organizationIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  sort?: InputMaybe<OrganizationYearlyContractSortInput>;
  startMonth?: InputMaybe<PlainYearMonthFilter>;
  startingAfter?: InputMaybe<Scalars["ID"]["input"]>;
  statuses?: InputMaybe<Array<ContractStatus>>;
};

export type QueryInternalOrganizationsArgs = {
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryInternalScriptExecutionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  slug?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalSiteArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalSiteActivityProgramArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalSiteHighSeasonPeriodsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type QueryInternalSitesArgs = {
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryInternalStaffContractArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalStaffCreditTransactionsArgs = {
  contractId: Scalars["ID"]["input"];
};

export type QueryInternalStaffGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalStayReviewResponseArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalStayReviewResponsesArgs = {
  endCheckOutDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startCheckOutDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryInternalStayReviewedAccommodationReservationsArgs = {
  endCheckOutDate: Scalars["PlainDate"]["input"];
  startCheckOutDate: Scalars["PlainDate"]["input"];
};

export type QueryInternalStayTicketByCodeArgs = {
  code: Scalars["String"]["input"];
};

export type QueryInternalStayTicketMasterByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalStayTicketsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InternalStayTicketsOrderBy>;
  orderDir?: InputMaybe<SortDirection>;
  statuses?: InputMaybe<Array<StayTicketStatusType>>;
  stayTicketMasterId: Scalars["ID"]["input"];
};

export type QueryInternalSupplyItemMasterArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalSupplyItemsArgs = {
  accommodationId: Scalars["ID"]["input"];
};

export type QueryInternalUserArgs = {
  id: Scalars["String"]["input"];
};

export type QueryInternalUserOwnershipArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInternalUsersBySearchArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryInternalUsersSearchArgs = {
  excludeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLookupOtaReservationByReferenceArgs = {
  reference: Scalars["String"]["input"];
};

export type QueryNewsDetailArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOfferedCoOwnersPlansArgs = {
  earlyAccessCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryOrganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationIdByInvitationCodeArgs = {
  invitationCode: Scalars["String"]["input"];
};

export type QueryOrganizationMemberArgs = {
  userId: Scalars["ID"]["input"];
};

export type QueryOwnerPlanArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPeakDaysArgs = {
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

export type QueryPlugDeviceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryReservationRuleRevision2027PolicyArgs = {
  provider: AccommodationReservationProviderInput;
};

export type QueryRoomTypeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRoomTypeBySlugArgs = {
  roomTypeSlug: Scalars["String"]["input"];
  siteSlug: Scalars["String"]["input"];
};

export type QuerySiteBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryStaffGroupsArgs = {
  includeInvalidated?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryStayTicketReservationInfoArgs = {
  stayTicketUnitId: Scalars["ID"]["input"];
};

export type QueryTentativeAccommodationReservationArgs = {
  code: Scalars["ID"]["input"];
};

export type QueryUrlFromCodeArgs = {
  code: Scalars["String"]["input"];
};

export type QueryUserCompanionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUserOwnershipArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVerifyAccountLinkSessionArgs = {
  input: VerifyAccountLinkSessionInput;
};

/** 基本宿泊料金ポリシー（管理者向け） */
export type RawBaseAccommodationFeePolicy = {
  __typename: "RawBaseAccommodationFeePolicy";
  /** 宿泊料金のポリシー */
  dailyFeePolicy: Array<Scalars["Int"]["output"]>;
  /** 動的価格モード用の価格修正値 */
  feeModifier?: Maybe<Scalars["Int"]["output"]>;
  /** 価格修正タイプ（パーセンテージまたは固定値） */
  feeModifierType?: Maybe<FeeModifierType>;
  /** 料金設定ルール */
  feeRules: Array<AccommodationFeeRule>;
  id: Scalars["ID"]["output"];
  /** 内部向けの名前 */
  internalName: Scalars["String"]["output"];
  /** 宿泊費の一部または全部が第三者（タイアップ先等）の負担であるか */
  isThirdPartyCovered: Scalars["Boolean"]["output"];
  /** dailyFeePolicy に含まれない第三者負担額（泊毎） */
  thirdPartyCoveredDailyFeePolicy: Array<Scalars["Int"]["output"]>;
};

/** キャンセル料金のポリシー （管理者向け） */
export type RawCancelFeePolicy = {
  __typename: "RawCancelFeePolicy";
  cancelFeePolicy: CancelFeePolicy;
  id: Scalars["ID"]["output"];
  internalDescription: Scalars["String"]["output"];
  internalName: Scalars["String"]["output"];
};

export type RawNews = {
  __typename: "RawNews";
  content: Scalars["String"]["output"];
  contentType: NewsContentType;
  createdUser: User;
  displayCategory: NewsDisplayCategory;
  id: Scalars["ID"]["output"];
  publishedAt: Scalars["ZonedDateTime"]["output"];
  status: NewsStatus;
  targetPlans: Array<TargetPlanType>;
  title: Scalars["String"]["output"];
};

/** 拠点FAQ（管理者向け） */
export type RawSiteFaq = {
  __typename: "RawSiteFaq";
  /** 回答 (HTML) */
  answer: Scalars["String"]["output"];
  /** 案内画像URL（チェックイン当日メール・拠点ページ・nativeappチェックインシートに表示） */
  guidanceImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** 質問 */
  question: Scalars["String"]["output"];
  /** 拠点 */
  site: Site;
  /** 並び順 */
  sort?: Maybe<Scalars["Int"]["output"]>;
};

export type RedirectLocation = {
  __typename: "RedirectLocation";
  path: Scalars["String"]["output"];
};

export type RegisterCoOwnersApplicationFileError = {
  __typename: "RegisterCoOwnersApplicationFileError";
  case: RegisterCoOwnersApplicationFileErrorCase;
};

export const RegisterCoOwnersApplicationFileErrorCase = {
  AlreadyRegistered: "AlreadyRegistered",
  /** S3 にアップロードされていない */
  FileNotUploaded: "FileNotUploaded",
  /** ファイル名・保存先・種別・サイズのいずれかが不正 */
  InvalidFile: "InvalidFile",
  NotFound: "NotFound",
} as const;

export type RegisterCoOwnersApplicationFileErrorCase =
  (typeof RegisterCoOwnersApplicationFileErrorCase)[keyof typeof RegisterCoOwnersApplicationFileErrorCase];
export type RegisterCoOwnersApplicationFileInput = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  fileName: Scalars["String"]["input"];
  /** アップロードポリシーで返された rawUrl */
  rawUrl: Scalars["String"]["input"];
};

export type RegisterCoOwnersApplicationFilePayload =
  | RegisterCoOwnersApplicationFileError
  | RegisterCoOwnersApplicationFileSuccess;

export type RegisterCoOwnersApplicationFileSuccess = {
  __typename: "RegisterCoOwnersApplicationFileSuccess";
  file: CoOwnersApplicationFile;
};

/** アイデンティティ削除エラー */
export type RemoveIdentityError = {
  __typename: "RemoveIdentityError";
  case: RemoveIdentityErrorCase;
};

/** アイデンティティ削除エラーケース */
export const RemoveIdentityErrorCase = {
  /** Appleトークンの失効に失敗したためアカウント連携を解除できない */
  AppleTokenRevocationFailed: "AppleTokenRevocationFailed",
  /** 指定のプロバイダーが見つからない */
  IdentityNotFound: "IdentityNotFound",
  /** 最後のアイデンティティは削除不可 */
  LastIdentity: "LastIdentity",
  /** 削除後に認証済みアイデンティティが残らない */
  NoVerifiedRemaining: "NoVerifiedRemaining",
  /** パスワードが未設定のためソーシャルアカウントを解除できない */
  PasswordNotSet: "PasswordNotSet",
  /** 認証されていない */
  Unauthorized: "Unauthorized",
} as const;

export type RemoveIdentityErrorCase =
  (typeof RemoveIdentityErrorCase)[keyof typeof RemoveIdentityErrorCase];
/** アイデンティティ削除の入力 */
export type RemoveIdentityInput = {
  /** 削除するプロバイダー */
  provider: IdentityProvider;
};

/** アイデンティティ削除結果 */
export type RemoveIdentityPayload = RemoveIdentityError | RemoveIdentitySuccess;

/** アイデンティティ削除成功 */
export type RemoveIdentitySuccess = {
  __typename: "RemoveIdentitySuccess";
  /** 削除されたプロバイダー */
  removedProvider: IdentityProvider;
};

/** 付帯サービスレンタサイクル向けキーボックスのコントローラ属性情報 */
export type RentalCycleKeyBox = {
  __typename: "RentalCycleKeyBox";
  comment?: Maybe<Scalars["String"]["output"]>;
  inUseAt?: Maybe<Scalars["String"]["output"]>;
  pinCode?: Maybe<Scalars["String"]["output"]>;
  reservationId: Scalars["ID"]["output"];
  returnedAt?: Maybe<Scalars["String"]["output"]>;
  usableFrom: Scalars["PlainDateTime"]["output"];
  usableTo: Scalars["PlainDateTime"]["output"];
};

/** エクスポート用の予約アイテム */
export type ReservationExportItem = {
  __typename: "ReservationExportItem";
  /** 部屋コード */
  accommodationCode: Scalars["String"]["output"];
  /** チェックイン日 */
  checkInDate: Scalars["PlainDate"]["output"];
  /** チェックアウト日 */
  checkOutDate: Scalars["PlainDate"]["output"];
  /** 紐づく契約の開始日（該当契約がない場合はnull） */
  contractStartDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 予約作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 予約ID */
  id: Scalars["ID"]["output"];
  /** 宿泊日数 */
  nights: Scalars["Int"]["output"];
  /** 宿泊人数（大人） */
  numberOfAdults: Scalars["Int"]["output"];
  /** 愛犬同伴数 */
  numberOfDogs: Scalars["Int"]["output"];
  /** 宿泊人数（6歳未満） */
  numberOfInfants: Scalars["Int"]["output"];
  /** 宿泊人数（小学生まで、12歳未満） */
  numberOfKids: Scalars["Int"]["output"];
  /** 所属企業名 */
  organizationName: Scalars["String"]["output"];
  /** 宿泊拠点 */
  siteName: Scalars["String"]["output"];
  /** 滞在コメント */
  stayComment?: Maybe<Scalars["String"]["output"]>;
  /** 滞在評価 */
  stayRating?: Maybe<Scalars["Int"]["output"]>;
  /** 滞在ステータス */
  stayStatus: AccommodationReservationStayStatus;
  /** 支払い総額 */
  totalAmount: Scalars["Int"]["output"];
  /** 最新予約更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** Eメールアドレス */
  userEmail: Scalars["String"]["output"];
  /** 名前 */
  userName: Scalars["String"]["output"];
};

export type ReservationPriceStatement = {
  __typename: "ReservationPriceStatement";
  /** 宿泊税 */
  accommodationTax: Scalars["Int"]["output"];
  /** 追加設備利用料金(サウナ・温泉・ドッグランなど) */
  additionalFacilityFee: Scalars["Int"]["output"];
  /** 追加料金（Selection, LARGE, High日 など） */
  additionalFee: Scalars["Int"]["output"];
  /** 基本金額 */
  baseFee: Scalars["Int"]["output"];
  /** 入湯税 */
  bathingTax: Scalars["Int"]["output"];
  /** キャンセル料 */
  cancelFee: Scalars["Int"]["output"];
  /** 清掃料金(簡易清掃を含む) */
  cleaningFee: Scalars["Int"]["output"];
  /**
   * 有料備品利用料金
   * 税率ごとに細かく見たい場合は `consumedSuppliesFeeByTaxRate` を使う
   */
  consumedSuppliesFee: Scalars["Int"]["output"];
  /**
   * 有料備品利用料金(税率ごと)
   * 税率ごとに把握したい場合はこちらを使う
   * とにかく合計が知りたければ `consumedSuppliesFee` を使う
   */
  consumedSuppliesFeeByTaxRate: Array<PriceWithTaxRate>;
  /** 愛犬同伴追加料金 */
  dogFee: Scalars["Int"]["output"];
  /** EV充電追加料金 */
  evFee: Scalars["Int"]["output"];
  /** 付帯サービス予約利用料金 */
  facilityReservationFee: Scalars["Int"]["output"];
};

/**
 * 2027年度予約ルール改定の provider ごとの設定値。
 * forBiz は契約更新月から法人ごとに導出し、それ以外は 2027/4/1 固定。
 * forBiz の移行が完了する 2028/5 宿泊以降は不要になるので、その時点で @deprecated を経て削除する。
 */
export type ReservationRuleRevision2027Policy = {
  __typename: "ReservationRuleRevision2027Policy";
  /**
   * ルール改定の案内を出し始める日
   * forBiz は新規約の適用開始日の 2 ヶ月前、forBiz 以外は一律で 10/1
   */
  announcementStartDate: Scalars["PlainDate"]["output"];
  /** ルール改定が適用される最初の宿泊日 */
  firstApplicableNight: Scalars["PlainDate"]["output"];
};

export type ReservationStatementItem = {
  __typename: "ReservationStatementItem";
  /** 宿泊施設名 */
  accommodationName: Scalars["String"]["output"];
  /**
   * キャンセル日時
   * Stay Gift from Ownersの場合、3日前の15:00以降にキャンセルするとキャンセル料請求が発生する。
   * このタイミングを計算するためにキャンセル日時を含めている。
   */
  canceledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用日（YYYY-MM-DD） */
  date: Scalars["PlainDate"]["output"];
  /** 宿泊料金の詳細 */
  fee: AccommodationFee;
  /** 合計金額（税込） */
  price: Scalars["Int"]["output"];
  /** 料金内訳 */
  priceStatement: ReservationPriceStatement;
  /** 予約ID */
  reservationId: Scalars["ID"]["output"];
  /** ステータス（滞在済 / キャンセル など） */
  status: Scalars["String"]["output"];
  /** 予約種別（個人サブスク / Co-Owners / チケット など） */
  type: Scalars["String"]["output"];
};

export const ResourcePermission = {
  AccommodationsRead: "AccommodationsRead",
  /** 管理ロール（AdminRoleAssignment）の付与・剥奪・一覧。どのロールを付けられるかは @role の assignableRoles で決まる。 */
  AdminRolesWrite: "AdminRolesWrite",
  AvailabilityBlocksRead: "AvailabilityBlocksRead",
  CoOwnersRead: "CoOwnersRead",
  /** 開発用の口（hook・テスト SMS・テスト用ポイント付与）。 */
  DevToolsUse: "DevToolsUse",
  FacilitiesRead: "FacilitiesRead",
  /** 付帯サービス予約の清掃ステータスの更新。 */
  FacilityCleaningWrite: "FacilityCleaningWrite",
  FullOwnersRead: "FullOwnersRead",
  FullOwnersWrite: "FullOwnersWrite",
  InspectionsRead: "InspectionsRead",
  /** マシンプリンシパル。人間のロールには付与できない。 */
  JtasSyncWrite: "JtasSyncWrite",
  OrganizationsRead: "OrganizationsRead",
  ReservationsRead: "ReservationsRead",
  /** 予約一覧の書き出し（CSV）。閲覧（ReservationsRead）とは別に、一覧をファイルで持ち出せる主体を絞る。 */
  ReservationsUse: "ReservationsUse",
  ReservationsWrite: "ReservationsWrite",
  /** one-shot スクリプトの閲覧・実行。本番と preview では resolver が allowlist も見る。 */
  ScriptsUse: "ScriptsUse",
  SitesRead: "SitesRead",
  StayTicketsRead: "StayTicketsRead",
  /** 同伴者。住所・生年月日が non-null で leaf マスクできないため、関係ごと gate する。 */
  UserCompanionsRead: "UserCompanionsRead",
  /** Auth0 の連携 identity 参照。解除 (UsersIdentityWrite) とは別の権限。 */
  UsersIdentityRead: "UsersIdentityRead",
  UsersRead: "UsersRead",
  UsersWrite: "UsersWrite",
} as const;

export type ResourcePermission =
  (typeof ResourcePermission)[keyof typeof ResourcePermission];
export type ResumeStandardSubscriptionImmediatelyError = {
  __typename: "ResumeStandardSubscriptionImmediatelyError";
  case: ResumeStandardSubscriptionImmediatelyErrorCase;
  info?: Maybe<Scalars["String"]["output"]>;
};

export const ResumeStandardSubscriptionImmediatelyErrorCase = {
  AlreadySubscribedError: "AlreadySubscribedError",
  InvalidOperation: "InvalidOperation",
  NoSubscriptionScheduleError: "NoSubscriptionScheduleError",
  StripeError: "StripeError",
  UnexpectedSubscriptionScheduleStatus: "UnexpectedSubscriptionScheduleStatus",
} as const;

export type ResumeStandardSubscriptionImmediatelyErrorCase =
  (typeof ResumeStandardSubscriptionImmediatelyErrorCase)[keyof typeof ResumeStandardSubscriptionImmediatelyErrorCase];
export type ResumeStandardSubscriptionImmediatelyPayload =
  | ResumeStandardSubscriptionImmediatelyError
  | Success;

/**
 * ルームタイプ。OTA Room Type と自社 Room Type を統合した統一モデル。
 * 複数の Accommodation が同じ RoomType を共有することがある。
 */
export type RoomType = {
  __typename: "RoomType";
  /**
   * このルームタイプの建築タイプ。一覧での建築タイプ単位グルーピングや、
   * 定員・広さ等の表示に使う。architectureTypeId 未設定の場合は null。
   */
  architectureType?: Maybe<ArchitectureType>;
  /**
   * このルームタイプの日次の空き状況と料金。provider は料金計算に必須。
   *
   * 現状は StayTicket プロバイダーでのみ動作確認している。他のプロバイダーで利用する場合は、
   * 予約可能資産や予約可能期間の前提が変わりうるため、改めて実装を確認すること。
   */
  availabilities: RoomTypeAvailabilities;
  /**
   * provider を経由せず StayTicketMaster から直接解決した、日次の空き状況と料金。
   * 非会員向けの拠点ページプレビュー（発行済み StayTicketUnit を持たない）向け。
   */
  availabilitiesByStayTicketMaster: RoomTypeAvailabilities;
  /** 表示コンテンツ */
  content?: Maybe<ContentRoomType>;
  /**
   * 自社サイト向けの表示名。`displayNames` JSON から viewer locale (現状は ja 固定)
   * で解決される。未設定の場合は空文字 (呼び出し側でトルツメする想定)。
   */
  displayName: Scalars["String"]["output"];
  /** 特徴（温泉・サウナ・ペット可・富士山ビュー 等）。`sort` 昇順で並ぶ。 */
  features: Array<RoomTypeFeature>;
  id: Scalars["ID"]["output"];
  /**
   * 注意書き（例: "焚き火台なしのお部屋です"）。viewer locale で解決される。
   * 空文字 / 未設定の場合は null（呼び出し側でトルツメする想定）。
   */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** このルームタイプが属する拠点。詳細表示の拠点名・地図リンク等に使う。 */
  site: Site;
  /**
   * URL 用 slug（拠点内でユニーク）。既存データには未設定のものがあり、
   * その場合は null（部屋タイプ詳細ページへの導線を出さない想定）。
   */
  slug?: Maybe<Scalars["String"]["output"]>;
};

/**
 * ルームタイプ。OTA Room Type と自社 Room Type を統合した統一モデル。
 * 複数の Accommodation が同じ RoomType を共有することがある。
 */
export type RoomTypeAvailabilitiesArgs = {
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  provider: AccommodationReservationProviderInput;
};

/**
 * ルームタイプ。OTA Room Type と自社 Room Type を統合した統一モデル。
 * 複数の Accommodation が同じ RoomType を共有することがある。
 */
export type RoomTypeAvailabilitiesByStayTicketMasterArgs = {
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  stayTicketMasterReference: StayTicketMasterReferenceInput;
};

/** ルームタイプの空室・料金まとめ */
export type RoomTypeAvailabilities = {
  __typename: "RoomTypeAvailabilities";
  /** 予約可能な日の中での最安単価（「◯◯円〜」表示用）。空き（予約可能日）が無いときは null。 */
  fromPrice?: Maybe<Scalars["Int"]["output"]>;
  /** 各泊の空室情報（1要素=1泊） */
  nights: Array<RoomTypeAvailability>;
  /**
   * 空き・料金の解決元となった StayTicketMaster の ID。
   * availabilitiesByStayTicketMaster 経由のときのみ解決済みの値が入り、availabilities（provider経由）では常に null。
   */
  stayTicketMasterId?: Maybe<Scalars["ID"]["output"]>;
};

/** ルームタイプの日次空室情報 */
export type RoomTypeAvailability = {
  __typename: "RoomTypeAvailability";
  /**
   * その日に空いている宿泊施設。
   * FE はここから連泊/延泊を積集合で導出し、1室を選んで従来の予約フローへ進む。
   */
  availableAccommodations: Array<Accommodation>;
  /** その日の残室数（「残り◯室」表示・連泊判定の材料） */
  availableCount: Scalars["Int"]["output"];
  /** その日に1室でも空きがあるか（= availableCount > 0、カレンダー○×用） */
  isAvailable: Scalars["Boolean"]["output"];
  /** その日 (CI) を起点に、いずれかの宿泊施設で通しで確保できる最大連泊数。 */
  maxConsecutiveNights: Scalars["Int"]["output"];
  /** 対象の宿泊日（1泊） */
  night: Scalars["PlainDate"]["output"];
  /**
   * その日・そのルームタイプの1泊単価（代表室で計算）。
   * 連泊割・人数追加・オプション・清掃料を含まない単泊基準（連泊割込み価格が要るマーケ施策では別途計算が必要）。
   */
  price: Scalars["Int"]["output"];
};

/** ルームタイプの特徴マスター。多対多で RoomType に紐付く。 */
export type RoomTypeFeature = {
  __typename: "RoomTypeFeature";
  /** カテゴリ分類 */
  category: RoomTypeFeatureCategory;
  /** 表示用の名前。`name` JSON から viewer locale で解決される。 */
  displayName: Scalars["String"]["output"];
  /**
   * アイコン slug。FE 側で `/i/dx/<iconSlug>.svg` などにマッピングして表示する。
   * 未設定なら null。
   */
  iconSlug?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /**
   * 機械可読 slug (例: "sauna", "fuji-view", "dog-friendly")。
   * FE 側で表示する feature を絞る allow-list の key にもなる。
   */
  slug: Scalars["String"]["output"];
  /** 表示・組み立て時の並び順 (昇順、全体共通) */
  sort: Scalars["Int"]["output"];
};

/** ルームタイプの特徴カテゴリ */
export const RoomTypeFeatureCategory = {
  /** 設備（サウナ・温泉・EV充電器・ワーケーション・焚き火台 等） */
  Amenity: "Amenity",
  /** 階数（1階・2階） */
  Floor: "Floor",
  /** その他（ペット可 等） */
  Other: "Other",
  /** 景色（富士山ビュー・オーシャンビュー 等） */
  View: "View",
} as const;

export type RoomTypeFeatureCategory =
  (typeof RoomTypeFeatureCategory)[keyof typeof RoomTypeFeatureCategory];
/** Co-Owners充当特典（旧S2Oポイント） */
export type S2o = {
  __typename: "S2o";
  /**
   * 台帳残高。Standard / Trial / Stay / 申込キャンセルの返却分の合計。
   * Stay 分を除いた額は weekdayTrialBalance。
   */
  balance: Scalars["Int"]["output"];
  /** 取引履歴 */
  points: Array<S2oPoint>;
  /**
   * Stay 宿泊で蓄積した充当特典。台帳の Stay 分（特例の手動付与）と宿泊履歴からの
   * 導出値の合計。対象宿泊が2回未満なら導出値は 0。
   */
  stayCreditBalance: Scalars["Int"]["output"];
  /**
   * 指定した Co-Owners プラン・口数で利用される Co-Owners充当特典（旧S2Oポイント）の額。
   * 蓄積額と1口あたり利用上限の二重制約を適用した確定額。CoOwners 以外のプランは 0。
   * useWeekdayTrial / useStayCredit で、申込画面のチェック状態に応じた額を返す。
   * Stay 分は初回申込でのみ算入する。
   */
  usedAmount: Scalars["Int"]["output"];
  userId: Scalars["ID"]["output"];
  /**
   * Weekday/Trial で蓄積した充当特典の残高。台帳残高のうち Stay 由来を除いたもの。
   * 申込キャンセルの返却分は元の由来を区別できないためこちらに含む。
   */
  weekdayTrialBalance: Scalars["Int"]["output"];
};

/** Co-Owners充当特典（旧S2Oポイント） */
export type S2oUsedAmountArgs = {
  ownerPlanId: Scalars["ID"]["input"];
  units: Scalars["Int"]["input"];
  useStayCredit?: Scalars["Boolean"]["input"];
  useWeekdayTrial?: Scalars["Boolean"]["input"];
};

export type S2oPoint = {
  __typename: "S2oPoint";
  /** 金額 */
  amount: Scalars["Int"]["output"];
  /** 付与日 */
  date: Scalars["PlainDate"]["output"];
  /** メモ（管理者向け） */
  note: Scalars["String"]["output"];
  /** ステータス */
  status: S2oPointStatus;
  /** トランザクションタイプ（管理者向け） */
  transactionType: S2oPointTransactionType;
  /** 更新日時（管理者向け） */
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

export const S2oPointAdminTransactionType = {
  /** 月額サブスクリプション支払い */
  MonthlySubscriptionPayment: "MonthlySubscriptionPayment",
  /** Stay 宿泊費支払い、検証段階のため蓄積はadmin手動付与経由のみ */
  StayGuestPayment: "StayGuestPayment",
  /** トライアル月額サブスクリプション支払い */
  TrialMonthlySubscriptionPayment: "TrialMonthlySubscriptionPayment",
} as const;

export type S2oPointAdminTransactionType =
  (typeof S2oPointAdminTransactionType)[keyof typeof S2oPointAdminTransactionType];
/** Co-Owners充当特典 のステータス */
export const S2oPointStatus = {
  /** 有効（利用可能） */
  Active: "Active",
  /** 期限切れ */
  Expired: "Expired",
  /** 利用済み・無効化済み */
  Unavailable: "Unavailable",
} as const;

export type S2oPointStatus =
  (typeof S2oPointStatus)[keyof typeof S2oPointStatus];
/** Co-Owners充当特典（旧S2Oポイント）のトランザクションタイプ */
export const S2oPointTransactionType = {
  /** キャンセルによる無効化 */
  CancellationInvalidation: "CancellationInvalidation",
  /** Co-Owners申し込み返金 */
  CoOwnerApplicationRefund: "CoOwnerApplicationRefund",
  /** Co-Owners申し込み利用 */
  CoOwnerApplicationUsage: "CoOwnerApplicationUsage",
  /** 入会金支払い */
  EnrollmentPayment: "EnrollmentPayment",
  /** 管理者による無効化 */
  InvalidatedByAdmin: "InvalidatedByAdmin",
  /** 手動調整（データマイグレーション等） */
  ManualAdjustment: "ManualAdjustment",
  /** 月額サブスクリプション支払い */
  MonthlySubscriptionPayment: "MonthlySubscriptionPayment",
  /** Stay 宿泊費支払い、検証段階のため蓄積はadmin手動付与経由のみ */
  StayGuestPayment: "StayGuestPayment",
  /** トライアルキャンセルによる無効化 */
  TrialCancellationInvalidation: "TrialCancellationInvalidation",
  /** トライアル月額サブスクリプション支払い */
  TrialMonthlySubscriptionPayment: "TrialMonthlySubscriptionPayment",
} as const;

export type S2oPointTransactionType =
  (typeof S2oPointTransactionType)[keyof typeof S2oPointTransactionType];
export type S3UploadPolicy = {
  __typename: "S3UploadPolicy";
  /** POSTリクエストに含めるべきフィールドと値のリスト */
  fields: Array<S3UploadPolicyField>;
  /**
   * アップロード後の画像の URL
   * `https://<bucket>.s3.<region>.amazonaws.com/<key>` の形式となる
   */
  rawUrl: Scalars["String"]["output"];
  /** POSTリクエストを送信するためのURL */
  uploadUrl: Scalars["String"]["output"];
};

export type S3UploadPolicyField = {
  __typename: "S3UploadPolicyField";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** 施設に紐づくエッジデバイス */
export type SanuEdgeDevice = {
  __typename: "SanuEdgeDevice";
  /** 紐づいた宿泊施設 */
  accommodation: Accommodation;
  /** 外部デバイスID */
  deviceId: Scalars["String"]["output"];
  /** デバイスの種別 */
  deviceType: SanuEdgeDeviceType;
  /** デバイスID */
  id: Scalars["ID"]["output"];
};

/** エッジデバイスの種別 */
export const SanuEdgeDeviceType = {
  /** サウナコントロールユニット */
  SaunaControlUnit: "SaunaControlUnit",
} as const;

export type SanuEdgeDeviceType =
  (typeof SanuEdgeDeviceType)[keyof typeof SanuEdgeDeviceType];
export const SanuFileType = {
  /** CoOwnersの定期建物賃貸借契約書・38条書面 */
  CoOwnersBuildingLeaseAgreement: "CoOwnersBuildingLeaseAgreement",
  /** CoOwnersの見積書 */
  CoOwnersEstimate: "CoOwnersEstimate",
  /** CoOwnersのお引き渡し時の書類 */
  CoOwnersHandoverDocument: "CoOwnersHandoverDocument",
  /** CoOwnersの重要事項説明書 */
  CoOwnersImportantMattersDocument: "CoOwnersImportantMattersDocument",
  /** CoOwnersのAdmin用ファイル */
  CoOwnersOtherFiles: "CoOwnersOtherFiles",
  /** CoOwnersの借地権付売買契約書 */
  CoOwnersSalesContract: "CoOwnersSalesContract",
  /** CoOwnersの共有者間協定書 */
  CoOwnershipAgreement: "CoOwnershipAgreement",
  /** FullOwnerの利用契約 */
  FullOwnerContract: "FullOwnerContract",
} as const;

export type SanuFileType = (typeof SanuFileType)[keyof typeof SanuFileType];
export type SanuIncAccommodationReservationProvider = {
  __typename: "SanuIncAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  staffGroup?: Maybe<StaffGroup>;
  usage: AccommodationReservationProviderSanuIncUsage;
};

export const SanuOwnerPlanUserFileType = {
  CoOwnersBuildingLeaseAgreement: "CoOwnersBuildingLeaseAgreement",
  CoOwnersHandoverDocuments: "CoOwnersHandoverDocuments",
  CoOwnersImportantMatters: "CoOwnersImportantMatters",
  CoOwnersSaleContract: "CoOwnersSaleContract",
  CoOwnershipAgreement: "CoOwnershipAgreement",
} as const;

export type SanuOwnerPlanUserFileType =
  (typeof SanuOwnerPlanUserFileType)[keyof typeof SanuOwnerPlanUserFileType];
export type SaunaAccommodationFacility = {
  __typename: "SaunaAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** サウナ機器の固有情報 */
export type SaunaEquipmentAttribute = {
  __typename: "SaunaEquipmentAttribute";
  /** 制御対象のエッジデバイス ID（MQTT トピックの識別子） */
  deviceId: Scalars["String"]["output"];
};

export type SaveStayReviewV2DraftPayload = StayReviewV2 | StayReviewV2Error;

export type ScheduleStandardSubscriptionPauseError = {
  __typename: "ScheduleStandardSubscriptionPauseError";
  case: ScheduleStandardSubscriptionPauseErrorCase;
};

export const ScheduleStandardSubscriptionPauseErrorCase = {
  InvalidOperation: "InvalidOperation",
  InvalidPauseDate: "InvalidPauseDate",
  InvalidResumeDate: "InvalidResumeDate",
  NoSubscriptionError: "NoSubscriptionError",
  NotPausableDateYet: "NotPausableDateYet",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
} as const;

export type ScheduleStandardSubscriptionPauseErrorCase =
  (typeof ScheduleStandardSubscriptionPauseErrorCase)[keyof typeof ScheduleStandardSubscriptionPauseErrorCase];
export type ScheduleStandardSubscriptionPausePayload =
  | ScheduleStandardSubscriptionPauseError
  | Success;

export type ScheduleStandardSubscriptionTerminationError = {
  __typename: "ScheduleStandardSubscriptionTerminationError";
  case: ScheduleStandardSubscriptionTerminationErrorCase;
};

export const ScheduleStandardSubscriptionTerminationErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionError: "NoSubscriptionError",
  NotPausableDateYet: "NotPausableDateYet",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
} as const;

export type ScheduleStandardSubscriptionTerminationErrorCase =
  (typeof ScheduleStandardSubscriptionTerminationErrorCase)[keyof typeof ScheduleStandardSubscriptionTerminationErrorCase];
export type ScheduleStandardSubscriptionTerminationPayload =
  | ScheduleStandardSubscriptionTerminationError
  | Success;

/** Grant を絞る軸。軸を足す = ここに値を足す + AdminRoleAssignment に列を足す + scopeKeyTypes.ts / scopeKeys.ts に表を足す。 */
export const ScopeDimension = {
  Site: "Site",
} as const;

export type ScopeDimension =
  (typeof ScopeDimension)[keyof typeof ScopeDimension];
export const ScriptExecutionStatus = {
  Failed: "Failed",
  Running: "Running",
  Success: "Success",
} as const;

export type ScriptExecutionStatus =
  (typeof ScriptExecutionStatus)[keyof typeof ScriptExecutionStatus];
export const ScriptLogLevel = {
  Error: "Error",
  Info: "Info",
  Warn: "Warn",
} as const;

export type ScriptLogLevel =
  (typeof ScriptLogLevel)[keyof typeof ScriptLogLevel];
/** シーズン料金設定 */
export type SeasonalFeeSetting = {
  __typename: "SeasonalFeeSetting";
  additionalFee: Scalars["Int"]["output"];
  night: Scalars["PlainDate"]["output"];
};

export type SelectWebinarScheduleError = {
  __typename: "SelectWebinarScheduleError";
  case: SelectWebinarScheduleErrorCase;
};

export const SelectWebinarScheduleErrorCase = {
  AlreadyCompleted: "AlreadyCompleted",
  AlreadySelected: "AlreadySelected",
  ApplicationNotFound: "ApplicationNotFound",
  InvalidWebinarSchedule: "InvalidWebinarSchedule",
  PermissionDenied: "PermissionDenied",
} as const;

export type SelectWebinarScheduleErrorCase =
  (typeof SelectWebinarScheduleErrorCase)[keyof typeof SelectWebinarScheduleErrorCase];
export type SelectWebinarSchedulePayload =
  | CoOwnersApplication
  | SelectWebinarScheduleError;

export type SendEmailToVerifyEmailInput = {
  /** 認証に成功した場合に遷移させるページ（パス以下を指定） */
  redirectAfterVerifiedPath?: InputMaybe<Scalars["String"]["input"]>;
};

export type SendEmailToVerifyNewEmailError = {
  __typename: "SendEmailToVerifyNewEmailError";
  case: SendEmailToVerifyNewEmailErrorCase;
};

export const SendEmailToVerifyNewEmailErrorCase = {
  /** メールアドレスが他のユーザに既に使われている */
  EmailAlreadyUsed: "EmailAlreadyUsed",
  GeneralError: "GeneralError",
  /** 入力されたメールアドレスのフォーマットが不正 */
  InvalidEmailFormat: "InvalidEmailFormat",
  /** ソーシャルログインが主IDで、メール/パスワードが未登録のため変更不可 */
  NoEmailPasswordIdentity: "NoEmailPasswordIdentity",
  /** 同じメールアドレスが設定・確認済み */
  SameEmail: "SameEmail",
} as const;

export type SendEmailToVerifyNewEmailErrorCase =
  (typeof SendEmailToVerifyNewEmailErrorCase)[keyof typeof SendEmailToVerifyNewEmailErrorCase];
export type SendEmailToVerifyNewEmailInput = {
  newEmail: Scalars["String"]["input"];
};

export type SendEmailToVerifyNewEmailPayload =
  | SendEmailToVerifyNewEmailError
  | SendEmailToVerifyNewEmailSuccess;

export type SendEmailToVerifyNewEmailSuccess = {
  __typename: "SendEmailToVerifyNewEmailSuccess";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SendPasswordResetEmailError = {
  __typename: "SendPasswordResetEmailError";
  case?: Maybe<SendPasswordResetEmailErrorCase>;
};

export const SendPasswordResetEmailErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type SendPasswordResetEmailErrorCase =
  (typeof SendPasswordResetEmailErrorCase)[keyof typeof SendPasswordResetEmailErrorCase];
export type SendPasswordResetEmailPayload =
  | SendPasswordResetEmailError
  | SendPasswordResetEmailSuccess;

export type SendPasswordResetEmailSuccess = {
  __typename: "SendPasswordResetEmailSuccess";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** トップページ表示のサービスアップデート */
export type ServiceUpdate = {
  __typename: "ServiceUpdate";
  /** 新しいかどうか */
  isNew: Scalars["Boolean"]["output"];
  /** 日付 */
  publishedAt: Scalars["ZonedDateTime"]["output"];
  /** タイトル */
  title: Scalars["String"]["output"];
  /** 遷移先URL */
  url: Scalars["String"]["output"];
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type Site = {
  __typename: "Site";
  /** 拠点に含まれる宿泊施設の一覧 */
  accommodations: Array<Accommodation>;
  /** 拠点に含まれる、予約ができる宿泊施設の一覧 */
  accommodationsForReservation: Array<Accommodation>;
  /** 拠点があるエリア */
  area: Area;
  /**
   * 拠点全体の日次空き状況・最低価格。roomTypesForReservation と同じフィルタ条件で対象roomTypeを絞り込み、
   * 日ごとに複数roomType横断で集約した値を返す。
   */
  availability: Array<SiteAvailabilityNight>;
  /**
   * Beds24プロパティID（未連携の場合はnull）
   * @deprecated Retool 互換のため温存。admin は InternalSite を使うこと
   */
  beds24PropertyId?: Maybe<Scalars["Int"]["output"]>;
  /** チェックイン認証方式 */
  checkInAuthenticationType: CheckInAuthenticationType;
  /** CoOwners申し込み者向け重説参加スケジュール */
  coOwnersWebinarSchedules: Array<CoOwnersWebinarSchedule>;
  /** 拠点のコンテンツ */
  content: SiteContent;
  /** カスタム予約リード月数（未設定の場合はデフォルトの3ヶ月を使用） */
  customReservationLeadMonths?: Maybe<Scalars["Int"]["output"]>;
  /** アーリーチェックイン機能が有効かどうか */
  earlyCheckInEnabled: Scalars["Boolean"]["output"];
  /**
   * この拠点に紐づく有効な設備一覧
   * providerが渡された場合、そのプロバイダーが予約可能な設備のみが表示
   */
  facilities: Array<Facility>;
  id: Scalars["ID"]["output"];
  /**
   * 遠方拠点かどうか
   * Areaにあっても良さそうだが、今後の展開が読めないのでSiteに生やしている。
   * Siteに生やした強い理由はないので、必要ならAreaに移動したりしてOK。
   */
  isRemote: Scalars["Boolean"]["output"];
  /**
   * 拠点の名前
   * 例：一宮1st、Amatsumi 安曇野
   */
  name: Scalars["String"]["output"];
  /** 拠点の開業日 */
  openingDate: Scalars["PlainDate"]["output"];
  /**
   * 拠点の番号
   * 「一宮1st」などの場合「1st」を指し、Amatsumi 安曇野のように番号がない場合は何も入らない。
   */
  ordinalName?: Maybe<Scalars["String"]["output"]>;
  /** 予約可能か？ */
  reservable: Scalars["Boolean"]["output"];
  /** 予約可能か？（オーナー向け） */
  reservableForOwnerEarlyAccess: Scalars["Boolean"]["output"];
  /**
   * ルームタイプ特徴マスター一覧（sort 昇順、全 site 共通）
   * @deprecated Retool 互換のため温存。admin は InternalSite を使うこと
   */
  roomTypeFeatures: Array<InternalRoomTypeFeature>;
  /**
   * ルームタイプ一覧
   * @deprecated Retool 互換のため温存。admin は InternalSite を使うこと
   */
  roomTypes: Array<InternalRoomType>;
  /**
   * 拠点に含まれる、予約ができるルームタイプの一覧。
   * internal の Site.roomTypes（管理用一覧）とは別物で、予約スコープ（reservableAssets）でフィルタされる。
   * 部屋(unit)が 1 件も紐づかない＝予約できないルームタイプは含まれない。
   * 並び順は「設備が少ない順」（RoomTypeFeature.sort 昇順を加味、DXPJ-86）。
   */
  roomTypesForReservation: Array<RoomType>;
  /**
   * 短い住所表示（例: "静岡県"）。
   * ContentSite.addressInJapan.line1 から派生して返す。
   */
  shortAddress?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteAccommodationsForReservationArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteAvailabilityArgs = {
  architectureTypes: Array<Scalars["String"]["input"]>;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  facilitySlugs: Array<Scalars["String"]["input"]>;
  firstNight: Scalars["PlainDate"]["input"];
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteFacilitiesArgs = {
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteRoomTypesForReservationArgs = {
  architectureTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  facilitySlugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 拠点ページ「アクセス」セクションの 1 つの移動手段グループ
 * 例: 「公共交通機関でお越しの方」「お車でお越しの方」
 */
export type SiteAccessRouteGroup = {
  __typename: "SiteAccessRouteGroup";
  id: Scalars["ID"]["output"];
  /** この移動手段グループに含まれる地点（始点→経由→終点の順） */
  points: Array<SiteAccessRoutePoint>;
  /** 並び順 */
  sort: Scalars["Int"]["output"];
  /** グループ見出し（例: "公共交通機関でお越しの方"） */
  title: Scalars["String"]["output"];
  /** グループ見出し脇のアイコン */
  transportIcon: AccessRouteTransportIcon;
};

/**
 * アクセスルート上の地点。始点・経由・終点を同一モデルで扱う。
 * sort の昇順に並び、最後の地点（終点）の legToNextDescription は
 * 「終点 → 拠点」の区間を表す。
 */
export type SiteAccessRoutePoint = {
  __typename: "SiteAccessRoutePoint";
  id: Scalars["ID"]["output"];
  /**
   * この地点から次の地点までの区間説明（例: "東海道新幹線 約45分"）
   * 最後の地点では「終点 → 拠点」の区間説明として使う
   */
  legToNextDescription?: Maybe<Scalars["String"]["output"]>;
  /** 地点名（例: "JR東京駅", "東京駅周辺", "門川交差点"） */
  name: Scalars["String"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
};

/**
 * Nature Club のアクティビティプログラム。拠点・エリア・部屋タイプページや予約一覧のカードに出し、
 * 予約は外部ページで行う。
 */
export type SiteActivityProgram = {
  __typename: "SiteActivityProgram";
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 説明文（viewer locale に解決済み）。未設定なら null */
  description?: Maybe<Scalars["String"]["output"]>;
  /** 外部の詳細・予約ページ URL */
  externalUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadedFile;
  /** 説明文（全 locale）。カードでは 3 行に省略して表示する */
  localizedDescription: InternalLocalizedString;
  /** プログラム名（全 locale） */
  localizedTitle: InternalLocalizedString;
  /** 掲載終了日時（この時刻になったら外す）。null なら無期限 */
  publishEndAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 掲載開始日時。null なら登録した時点から掲載する */
  publishStartAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 掲載する拠点（admin の一覧・編集フォーム用。エリア・拠点の並び順） */
  sites: Array<InternalSite>;
  /** プログラム名（viewer locale に解決済み） */
  title: Scalars["String"]["output"];
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 拠点の日次の空き状況・最低価格（Site.availability が複数roomType横断で集約した値） */
export type SiteAvailabilityNight = {
  __typename: "SiteAvailabilityNight";
  /** 複数roomType横断で空きがある中の最安値。全roomTypeが満室の夜はnull。 */
  fromPrice?: Maybe<Scalars["Int"]["output"]>;
  /** その日に、いずれかのroomTypeで1室でも空きがあるか */
  isAvailable: Scalars["Boolean"]["output"];
  /** 対象の宿泊日（1泊） */
  night: Scalars["PlainDate"]["output"];
};

/** 拠点コンテンツ */
export type SiteContent = {
  __typename: "SiteContent";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * 拠点へのアクセスルート（拠点ページ「アクセス」セクション）
   * 移動手段（公共交通機関 / お車 等）ごとにグループ化される
   */
  accessRouteGroups: Array<SiteAccessRouteGroup>;
  /** この拠点で現在掲載中の Nature Club アクティビティ（掲載期間内のもの、登録の古い順） */
  activityPrograms: Array<SiteActivityProgram>;
  /** 住所の多言語編集用の値（公開 prefecture/city/addressLine は解決済みの String） */
  addressForEdit?: Maybe<InternalSiteAddress>;
  /** 住所: 町名・番地以降（建物名・部屋番号を含む）。 viewer locale に解決済み（例: "富戸1234-5"）。 */
  addressLine?: Maybe<Scalars["String"]["output"]>;
  /** 住所: 市区町村。 viewer locale に解決済み（例: "伊東市"）。 */
  city?: Maybe<Scalars["String"]["output"]>;
  /** 拠点紹介文 */
  description?: Maybe<Scalars["String"]["output"]>;
  /** 拠点のfaq */
  faqs: Array<SiteFaq>;
  /** 拠点の Google Maps レビュー URL */
  googleMapsReviewUrl?: Maybe<Scalars["String"]["output"]>;
  /** 拠点の Google Maps URL */
  googleMapsUrl?: Maybe<Scalars["String"]["output"]>;
  /** ヒーロー画像 */
  heroImages: Array<UploadedFile>;
  /** 路面凍結情報URL */
  iceRoadInfoUrl?: Maybe<Scalars["String"]["output"]>;
  /** ID */
  id: Scalars["ID"]["output"];
  /**
   * 拠点の画像
   * 当初は Native App で利用
   */
  images: Array<UploadedFile>;
  /** 緯度 */
  latitude?: Maybe<Scalars["Float"]["output"]>;
  /** 経度 */
  longitude?: Maybe<Scalars["Float"]["output"]>;
  /** 拠点マップ画像 */
  mapImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 駐車場の台数表記（例: "各部屋1台"） */
  parkingCapacity?: Maybe<Scalars["String"]["output"]>;
  /** 駐車場の注釈（例: "2003・2019ご利用の方は、EV充電器の利用有無にかかわらず指定スペースへの駐車をお願い致します"） */
  parkingInfo?: Maybe<Scalars["String"]["output"]>;
  /** 住所: 郵便番号（言語非依存。例: "413-0001"） */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** 住所: 都道府県。 viewer locale に解決済み（例: "静岡県"）。 編集用の多言語値は internal の prefectureTranslation。 */
  prefecture?: Maybe<Scalars["String"]["output"]>;
  /** 最終更新日時（編集履歴の表示用） */
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 拠点のFAQ */
export type SiteFaq = {
  __typename: "SiteFaq";
  /** 回答 (HTML) */
  answer: Scalars["String"]["output"];
  /** 案内画像URL（チェックイン当日メール・拠点ページ・nativeappチェックインシートに表示） */
  guidanceImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 質問 */
  question: Scalars["String"]["output"];
};

/** 拠点ハイシーズン期間（管理者向け） */
export type SiteHighSeasonPeriod = {
  __typename: "SiteHighSeasonPeriod";
  /** 2027 年度以降の拠点追加料金 */
  additionalFeeAmount: Scalars["Int"]["output"];
  /** 終了日（1-31） */
  endDay: Scalars["Int"]["output"];
  /** 終了月（1-12） */
  endMonth: Scalars["Int"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /** ラベル（例: "夏シーズン"） */
  label: Scalars["String"]["output"];
  /** 拠点ID */
  siteId: Scalars["ID"]["output"];
  /** 開始日（1-31） */
  startDay: Scalars["Int"]["output"];
  /** 開始月（1-12） */
  startMonth: Scalars["Int"]["output"];
};

/** ソート方向 */
export const SortDirection = {
  /** 昇順 */
  Asc: "Asc",
  /** 降順 */
  Desc: "Desc",
} as const;

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];
/** スタッフ用アクセスキー適用のトリガー種別。 */
export const StaffAccessKeyTrigger = {
  CancelReserve: "CancelReserve",
  ChangeReserve: "ChangeReserve",
  CheckOutReserve: "CheckOutReserve",
  CreateReserve: "CreateReserve",
  CronJob: "CronJob",
} as const;

export type StaffAccessKeyTrigger =
  (typeof StaffAccessKeyTrigger)[keyof typeof StaffAccessKeyTrigger];
/**
 * for Staff 契約
 * 従業員向け福利厚生プラン
 */
export type StaffContract = {
  __typename: "StaffContract";
  /**
   * 今期の付与泊数
   * 当期（前半または後半）で付与された泊数
   */
  currentSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /**
   * 今期の残り泊数
   * 当期（前半または後半）の残り宿泊数
   */
  currentSemesterStayCredits: Scalars["Int"]["output"];
  /** 利用開始日（契約開始日） */
  enrolledAt: Scalars["ZonedDateTime"]["output"];
  /** 利用開始日（PlainDate形式） */
  enrolledDate: Scalars["PlainDate"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * 予約可能かどうか
   * status=Usable かつ terminatedDate が未来または null
   */
  isReservable: Scalars["Boolean"]["output"];
  /** 残りのピーク日数（今期） */
  remainingPeakDays: Scalars["Int"]["output"];
  /**
   * Semester別の宿泊数情報（現在と次のsemester）
   * 現在のsemesterと次のsemesterの宿泊数を配列で返す
   */
  semesterCredits: Array<StaffSemesterCredit>;
  /** 雇用形態 */
  staffType: StaffType;
  /**
   * 基本的なステータス
   * 予約できるかどうかなど
   */
  status: StaffContractStatus;
  /** 詳細なステータス */
  statusDetail: StaffContractStatusDetail;
  /** 利用停止日 */
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用停止日（PlainDate形式） */
  terminatedDate?: Maybe<Scalars["PlainDate"]["output"]>;
};

/** for Staff 契約ステータス */
export const StaffContractStatus = {
  /** 契約なし */
  Neutral: "Neutral",
  /** 利用可能 */
  Usable: "Usable",
} as const;

export type StaffContractStatus =
  (typeof StaffContractStatus)[keyof typeof StaffContractStatus];
/** for Staff 契約詳細ステータス */
export const StaffContractStatusDetail = {
  /** デフォルト（契約なし） */
  NeutralDefault: "NeutralDefault",
  /** 契約終了済み */
  NeutralTerminated: "NeutralTerminated",
  /** 利用中（通常） */
  UsableDefault: "UsableDefault",
} as const;

export type StaffContractStatusDetail =
  (typeof StaffContractStatusDetail)[keyof typeof StaffContractStatusDetail];
/**
 * 社内スタッフグループ
 * 財務・アセットマネジメント向けに活用しており、現状全てのグループは格納されていない。
 * scriptディレクトリに同期用のスクリプトがあるので活用すること。
 *
 * SmartHRのデータと紐づけて、チームごとに各種リソースを財務的に管理する。
 */
export type StaffGroup = {
  __typename: "StaffGroup";
  /** アーカイブ日時（この日時以降は新規ブロック作成時の選択肢から除外） */
  archivedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  createdAt: Scalars["ZonedDateTime"]["output"];
  /**
   * 親組織の名を含んだ名前
   * 例: 2nd Home事業本部/Co-Owners事業部/インサイドセールスグループ
   */
  fullName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 名前 */
  name: Scalars["String"]["output"];
  /** SmartHRとの紐付け用ID */
  smarthrId: Scalars["String"]["output"];
  /** 現在のステータス（archivedAtから計算） */
  status: StaffGroupStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** グループの有効/無効ステータス */
export const StaffGroupStatus = {
  /** 有効（選択肢として使用可能） */
  Active: "Active",
  /** 無効（選択肢から除外） */
  Inactive: "Inactive",
} as const;

export type StaffGroupStatus =
  (typeof StaffGroupStatus)[keyof typeof StaffGroupStatus];
export type StaffPlanAccommodationReservationProvider = {
  __typename: "StaffPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  staffContractId: Scalars["ID"]["output"];
};

/** for Staff ターム（前半/後半） */
export const StaffSemester = {
  /** 前半（1/1-6/30） */
  First: "First",
  /** 後半（7/1-12/31） */
  Second: "Second",
} as const;

export type StaffSemester = (typeof StaffSemester)[keyof typeof StaffSemester];
/** Semester別のスタッフ宿泊数情報 */
export type StaffSemesterCredit = {
  __typename: "StaffSemesterCredit";
  /** 付与された宿泊数 */
  grantedStayCredits: Scalars["Int"]["output"];
  /** 残りのピーク日数 */
  remainingPeakDays: Scalars["Int"]["output"];
  /** 残り宿泊数 */
  remainingStayCredits: Scalars["Int"]["output"];
  /** Semester（前半/後半） */
  semester: StaffSemester;
  /** 年 */
  year: Scalars["Int"]["output"];
};

export const StaffStayCreditTransactionStatus = {
  Finalized: "Finalized",
  Open: "Open",
  Void: "Void",
} as const;

export type StaffStayCreditTransactionStatus =
  (typeof StaffStayCreditTransactionStatus)[keyof typeof StaffStayCreditTransactionStatus];
export const StaffStayCreditTransactionType = {
  GrantByBatch: "GrantByBatch",
  GrantByManual: "GrantByManual",
  RedeemByCancel: "RedeemByCancel",
  RedeemByNoShow: "RedeemByNoShow",
  RedeemByReserve: "RedeemByReserve",
} as const;

export type StaffStayCreditTransactionType =
  (typeof StaffStayCreditTransactionType)[keyof typeof StaffStayCreditTransactionType];
/** 従業員区分 */
export const StaffType = {
  /** 契約社員（2泊/ターム、繁忙期1日） */
  Contractor: "Contractor",
  /** 正社員（4泊/ターム、繁忙期2日） */
  Permanent: "Permanent",
} as const;

export type StaffType = (typeof StaffType)[keyof typeof StaffType];
export type StandardPlanAccommodationReservationProvider = {
  __typename: "StandardPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  userSubscriptionId?: Maybe<Scalars["ID"]["output"]>;
};

/** StayCreditEstimate の内訳1件（対象宿泊1予約分） */
export type StayCreditBreakdownItem = {
  __typename: "StayCreditBreakdownItem";
  /** この宿泊の蓄積額（税抜 net / OTA 換算） */
  amount: Scalars["Int"]["output"];
  reservationId: Scalars["ID"]["output"];
};

/**
 * Co-Owners充当特典（Stay）の割引予測額。宿泊履歴から算出した読み取り専用の値。
 * 商談時にセールスが参照する「予測」であり、最終的な充当額は上限適用・CSの請求書確認を経て確定する。
 * S2oPoint 台帳には書き込まない（都度計算）。
 */
export type StayCreditEstimate = {
  __typename: "StayCreditEstimate";
  /** 有効化条件（自社・OTA の対象宿泊が2回以上）を満たすか。未満は保留（申込時の適用対象外）。 */
  activatable: Scalars["Boolean"]["output"];
  /** 対象宿泊ごとの内訳。予約ごとの充当対象額の表示に使う。 */
  breakdown: Array<StayCreditBreakdownItem>;
  /** 蓄積対象として数えた宿泊回数 */
  qualifyingStayCount: Scalars["Int"]["output"];
  /** 有効化まであと何回の対象宿泊が必要か。有効化済みなら 0。 */
  remainingStayCount: Scalars["Int"]["output"];
  /** 対象宿泊の蓄積額合計（税抜・上限適用前）。有効化前でも算出される。 */
  total: Scalars["Int"]["output"];
};

export type StayDirectAccommodationReservationProvider = {
  __typename: "StayDirectAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** エクスポート用のStay Giftチケット情報 */
export type StayGiftExportItem = {
  __typename: "StayGiftExportItem";
  /** チケットコード */
  code: Scalars["String"]["output"];
  /** 招待URL */
  invitationUrl: Scalars["String"]["output"];
  /** 発行日 */
  issuedAt: Scalars["PlainDate"]["output"];
  /** チケットステータス */
  status: StayTicketStatusType;
  /** 利用可能期間（開始日） */
  validFrom: Scalars["PlainDate"]["output"];
  /** 利用可能期間（終了日） */
  validTo: Scalars["PlainDate"]["output"];
};

/** 滞在レビュー */
export type StayReview = {
  __typename: "StayReview";
  /** レビューコメント */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 案内に関するコメント */
  commentForSigns?: Maybe<Scalars["String"]["output"]>;
  /** 今後利用してみたい食体験（複数選択可） */
  desiredFoodExperiences?: Maybe<Array<StayReviewFoodExperienceType>>;
  /** 今回の滞在中に行った体験（複数選択可） */
  experiencesDuringStay?: Maybe<Array<StayReviewExperienceType>>;
  /** 食体験の感想 */
  foodExperienceImpression?: Maybe<Scalars["String"]["output"]>;
  /**
   * 改善コメント
   * 改善ポイントで「その他」を選択した場合の自由記述コメント
   */
  improvementPointFree?: Maybe<Scalars["String"]["output"]>;
  /**
   * 改善ポイント
   * rating が4以下の場合に入力を促す
   */
  improvementPoints?: Maybe<Array<Scalars["String"]["output"]>>;
  /** 今回の滞在の感想や今後期待すること */
  overallImpressionForExperience?: Maybe<Scalars["String"]["output"]>;
  /**
   * 滞在の満足度
   * 1-5の5段階評価
   */
  rating: Scalars["Int"]["output"];
  /** ポスターを見たか（複数選択可） */
  sawPoster?: Maybe<Array<StayReviewPosterViewType>>;
  /** 夜間の足元の明るさや道案内 */
  signAndBrightnessInSite?: Maybe<StayReviewSignResponseType>;
  /** 駐車場から部屋までの案内 */
  signForApproach?: Maybe<StayReviewSignResponseType>;
  /** 駐車場の案内 */
  signForParking?: Maybe<StayReviewSignResponseType>;
  /** 拠点までの道案内 */
  signForWayToSite?: Maybe<StayReviewSignResponseType>;
  /** 利用した食体験（複数選択可） */
  usedFoodExperiences?: Maybe<Array<StayReviewFoodExperienceType>>;
};

/** 滞在レビュー 2.0 の評価軸 */
export const StayReviewAxis = {
  ArchitectureAndNature: "ArchitectureAndNature",
  Cleaning: "Cleaning",
  Equipment: "Equipment",
  GuidanceAndSupport: "GuidanceAndSupport",
} as const;

export type StayReviewAxis =
  (typeof StayReviewAxis)[keyof typeof StayReviewAxis];
export type StayReviewAxisDefinition = {
  __typename: "StayReviewAxisDefinition";
  axis: StayReviewAxis;
  /** この軸で聞く「気になったもの」の種別（表示順） */
  concernKinds: Array<StayReviewConcernKindDefinition>;
  /** 見出しの下に添える、この軸で評価する対象の補足（例: 建物・内装・虫・騒音・アクセス） */
  description: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

/** 気になったものの選択肢。どの種別に属するかは stayReviewV2Form が返す */
export const StayReviewConcernDetail = {
  CheckInProcedureUnclear: "CheckInProcedureUnclear",
  CheckOutGuideNotFound: "CheckOutGuideNotFound",
  CheckOutTooManyTasks: "CheckOutTooManyTasks",
  DarkAtNight: "DarkAtNight",
  FarFromShops: "FarFromShops",
  FarFromStationOrAirport: "FarFromStationOrAirport",
  FewRestaurants: "FewRestaurants",
  KeyDidNotOpen: "KeyDidNotOpen",
  NarrowRoad: "NarrowRoad",
  NoiseFromEquipment: "NoiseFromEquipment",
  NoiseFromNeighborRoom: "NoiseFromNeighborRoom",
  NoiseFromOutside: "NoiseFromOutside",
  ParkingFarOrRoughRoad: "ParkingFarOrRoughRoad",
  ParkingLocationUnclear: "ParkingLocationUnclear",
  PoorSignalForKey: "PoorSignalForKey",
  RouteOrNavigationFailed: "RouteOrNavigationFailed",
  SignageOrEntranceUnclear: "SignageOrEntranceUnclear",
  SupportOperatorQuality: "SupportOperatorQuality",
  SupportSlowResponse: "SupportSlowResponse",
  SupportUnreachable: "SupportUnreachable",
} as const;

export type StayReviewConcernDetail =
  (typeof StayReviewConcernDetail)[keyof typeof StayReviewConcernDetail];
export type StayReviewConcernDetailOption = {
  __typename: "StayReviewConcernDetailOption";
  label: Scalars["String"]["output"];
  value: StayReviewConcernDetail;
};

/** 気になったものの種別。どの軸に属するか・選択式か自由記述かは stayReviewV2Form が返す */
export const StayReviewConcernKind = {
  ArchitectureAndNatureOther: "ArchitectureAndNatureOther",
  ArrivalGuidanceOrParking: "ArrivalGuidanceOrParking",
  Breakage: "Breakage",
  BuildingDefect: "BuildingDefect",
  CheckOut: "CheckOut",
  CleaningOther: "CleaningOther",
  Dirt: "Dirt",
  EquipmentOther: "EquipmentOther",
  GuidanceAndSupportOther: "GuidanceAndSupportOther",
  Insects: "Insects",
  KeyOrCheckIn: "KeyOrCheckIn",
  LocationAccess: "LocationAccess",
  Noise: "Noise",
  Odor: "Odor",
  Shortage: "Shortage",
  Support: "Support",
  TrashOrHair: "TrashOrHair",
  UsageUnclear: "UsageUnclear",
} as const;

export type StayReviewConcernKind =
  (typeof StayReviewConcernKind)[keyof typeof StayReviewConcernKind];
export type StayReviewConcernKindDefinition = {
  __typename: "StayReviewConcernKindDefinition";
  /** 自由記述で聞く種別のプレースホルダ。選択式の種別では null */
  commentPlaceholder?: Maybe<Scalars["String"]["output"]>;
  /** 選択式の種別の選択肢。自由記述の種別では空 */
  details: Array<StayReviewConcernDetailOption>;
  kind: StayReviewConcernKind;
  label: Scalars["String"]["output"];
};

export const StayReviewExperienceType = {
  /** 自然を感じながらコーヒーを飲む */
  DrinkingCoffee: "DrinkingCoffee",
  /** 夜ご飯を作って食卓を囲む（ピザの温めなど簡単な調理も含む） */
  MakingDinner: "MakingDinner",
  /** 該当しない */
  NotApplicable: "NotApplicable",
  /** 花を摘んでいける */
  PickingFlowers: "PickingFlowers",
} as const;

export type StayReviewExperienceType =
  (typeof StayReviewExperienceType)[keyof typeof StayReviewExperienceType];
export const StayReviewFoodExperienceType = {
  /** 冷凍パン */
  FrozenBread: "FrozenBread",
  /** 冷凍ピザ */
  FrozenPizza: "FrozenPizza",
  /** ハーブガーデン */
  HerbGarden: "HerbGarden",
  /** 利用していない */
  NotUsedOrNotApplicable: "NotUsedOrNotApplicable",
  /** スープ */
  Soup: "Soup",
  /** ワイン */
  Wine: "Wine",
} as const;

export type StayReviewFoodExperienceType =
  (typeof StayReviewFoodExperienceType)[keyof typeof StayReviewFoodExperienceType];
/** 自由記入設問 */
export type StayReviewFreeTextQuestion = {
  __typename: "StayReviewFreeTextQuestion";
  key: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export const StayReviewMemorableExperience = {
  /** 空間の心地よさ */
  ComfortableSpace: "ComfortableSpace",
  /** 没頭する時間（仕事や読書など） */
  FocusedOnOwnTime: "FocusedOnOwnTime",
  /** 自然の音や景色 */
  NatureSoundsAndScenery: "NatureSoundsAndScenery",
  /** 外での体験（散歩や焚き火、サウナなど） */
  OutdoorActivities: "OutdoorActivities",
  /** 季節や生きものの気配。選択肢からは外したが、保存済みの回答を読めるよう残す */
  SeasonsAndCreatures: "SeasonsAndCreatures",
  /** 家族や友人とのひととき */
  TimeWithFamilyAndFriends: "TimeWithFamilyAndFriends",
} as const;

export type StayReviewMemorableExperience =
  (typeof StayReviewMemorableExperience)[keyof typeof StayReviewMemorableExperience];
export type StayReviewMemorableExperienceOption = {
  __typename: "StayReviewMemorableExperienceOption";
  /** ラベルの横に添える例示（例: 仕事や読書など）。例示のない選択肢は null */
  description?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  value: StayReviewMemorableExperience;
};

export const StayReviewPosterViewType = {
  /** 見ていない／気づかなかった */
  NotSeenOrNoticed: "NotSeenOrNoticed",
  /** 見て「いいな」と思った */
  SeenAndLiked: "SeenAndLiked",
  /** 見て「体験してみたい」と思った */
  SeenAndWantToTry: "SeenAndWantToTry",
  /** 見たが特に印象はなかった */
  SeenButNoImpression: "SeenButNoImpression",
  /** ポスターを持ち帰った */
  TookPosterHome: "TookPosterHome",
  /** 書いてある体験をひとつ以上やった */
  TriedExperience: "TriedExperience",
} as const;

export type StayReviewPosterViewType =
  (typeof StayReviewPosterViewType)[keyof typeof StayReviewPosterViewType];
/** 新滞在レビュー設問テンプレート */
export type StayReviewQuestionnaire = {
  __typename: "StayReviewQuestionnaire";
  /** チェックアウト後の自由記入設問 */
  freeTextAfterCheckOut: StayReviewFreeTextQuestion;
  /** チェックアウト時の自由記入設問 */
  freeTextAtCheckOut: StayReviewFreeTextQuestion;
  id: Scalars["ID"]["output"];
  /** チェックアウト後の選択式設問 */
  selectionAfterCheckOut: StayReviewSelectionQuestion;
  /** チェックアウト時の選択式設問 */
  selectionAtCheckOut: StayReviewSelectionQuestion;
};

/** 新滞在レビューの回答 */
export type StayReviewResponse = {
  __typename: "StayReviewResponse";
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** チェックアウト後の自由記入設問の回答 */
  freeTextAfterCheckOutAnswer: Scalars["String"]["output"];
  /** チェックアウト時の自由記入設問の回答 */
  freeTextAtCheckOutAnswer: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 回答した設問 */
  questionnaire: StayReviewQuestionnaire;
  /**
   * 滞在の満足度
   * 1-5の5段階評価
   */
  rating: Scalars["Int"]["output"];
  /** チェックアウト後の選択式設問の回答 */
  selectionAfterCheckOutAnswer: Array<StayReviewSelectionOption>;
  /** チェックアウト時の選択式設問の回答 */
  selectionAtCheckOutAnswer: Array<StayReviewSelectionOption>;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 回答と予約情報を含む滞在レビュー回答（管理者向け） */
export type StayReviewResponseWithReservation = {
  __typename: "StayReviewResponseWithReservation";
  accommodationReservation: AccommodationReservation;
  createdAt: Scalars["ZonedDateTime"]["output"];
  freeTextAfterCheckOutAnswer: Scalars["String"]["output"];
  freeTextAtCheckOutAnswer: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  questionnaire: StayReviewQuestionnaire;
  rating: Scalars["Int"]["output"];
  selectionAfterCheckOutAnswer: Array<StayReviewSelectionOption>;
  selectionAtCheckOutAnswer: Array<StayReviewSelectionOption>;
};

/** 新滞在レビュー設問の選択肢 */
export type StayReviewSelectionOption = {
  __typename: "StayReviewSelectionOption";
  /** バージョン間で不変の安定キー（集計に使用） */
  key: Scalars["String"]["output"];
  /** 表示ラベル（変更可能） */
  label: Scalars["String"]["output"];
};

/** 選択式設問 */
export type StayReviewSelectionQuestion = {
  __typename: "StayReviewSelectionQuestion";
  key: Scalars["String"]["output"];
  options: Array<StayReviewSelectionOption>;
  title: Scalars["String"]["output"];
};

export const StayReviewSignResponseType = {
  /** 分かりづらい／迷った */
  Difficult: "Difficult",
  /** 特に問題ない */
  NoProblem: "NoProblem",
  /** 利用していない・記憶にない */
  NotUseOrRemember: "NotUseOrRemember",
} as const;

export type StayReviewSignResponseType =
  (typeof StayReviewSignResponseType)[keyof typeof StayReviewSignResponseType];
/** 滞在レビュー 2.0（4 軸評価）。submittedAt が null の間は下書き */
export type StayReviewV2 = {
  __typename: "StayReviewV2";
  /** 建築と自然環境の評価（1〜5）。下書き中の未回答は null */
  architectureAndNatureRating?: Maybe<Scalars["Int"]["output"]>;
  /** 清掃のクオリティの評価（1〜5）。下書き中の未回答は null */
  cleaningRating?: Maybe<Scalars["Int"]["output"]>;
  /** 滞在の感想・運営に伝えたいこと（自由記述）。書いていなければ null */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 気になったもの */
  concerns: Array<StayReviewV2Concern>;
  /** 設備と備品の評価（1〜5）。下書き中の未回答は null */
  equipmentRating?: Maybe<Scalars["Int"]["output"]>;
  /** 案内とサポートの評価（1〜5）。下書き中の未回答は null */
  guidanceAndSupportRating?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 心に残った体験（複数選択） */
  memorableExperiences: Array<StayReviewMemorableExperience>;
  /** 送信日時。null は下書き（途中離脱した内容の保持） */
  submittedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

/** 気になったもの。kind ごとに 1 件 */
export type StayReviewV2Concern = {
  __typename: "StayReviewV2Concern";
  /** 自由記述の kind で書いた内容。書いていなければ null */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 選択式の kind で選んだ項目。自由記述の kind では空 */
  details: Array<StayReviewConcernDetail>;
  kind: StayReviewConcernKind;
};

export type StayReviewV2ConcernInput = {
  /** 自由記述の種別で書いた内容 */
  comment: Scalars["String"]["input"];
  /** 選択式の種別で選んだ項目。自由記述の種別では空 */
  details: Array<StayReviewConcernDetail>;
  kind: StayReviewConcernKind;
};

export type StayReviewV2Error = {
  __typename: "StayReviewV2Error";
  case: StayReviewV2ErrorCase;
};

export const StayReviewV2ErrorCase = {
  /** 送信済みのレビューは下書き保存できない（更新は submitStayReviewV2 で行う） */
  AlreadySubmitted: "AlreadySubmitted",
  /** 権限がない（他人の予約） */
  NotAuthorized: "NotAuthorized",
  /** 記入できる期間外（チェックイン前、またはチェックアウト後 7 日を過ぎた） */
  OutOfPeriod: "OutOfPeriod",
  /** 入力値が不正（評価が 1〜5 の範囲外、送信時の評価未回答、種別に属さない選択肢など） */
  ValidationError: "ValidationError",
} as const;

export type StayReviewV2ErrorCase =
  (typeof StayReviewV2ErrorCase)[keyof typeof StayReviewV2ErrorCase];
/** 滞在レビュー 2.0 の設問定義 */
export type StayReviewV2Form = {
  __typename: "StayReviewV2Form";
  axes: Array<StayReviewAxisDefinition>;
  memorableExperiences: Array<StayReviewMemorableExperienceOption>;
};

/** 滞在レビュー 2.0 の入力。下書き保存では評価を null のまま送れる */
export type StayReviewV2Input = {
  architectureAndNatureRating?: InputMaybe<Scalars["Int"]["input"]>;
  cleaningRating?: InputMaybe<Scalars["Int"]["input"]>;
  comment: Scalars["String"]["input"];
  concerns: Array<StayReviewV2ConcernInput>;
  equipmentRating?: InputMaybe<Scalars["Int"]["input"]>;
  guidanceAndSupportRating?: InputMaybe<Scalars["Int"]["input"]>;
  memorableExperiences: Array<StayReviewMemorableExperience>;
};

/**
 * 宿泊チケット。
 * 現状は1泊あたり1チケットになる。
 */
export type StayTicket = {
  __typename: "StayTicket";
  /** このチケットで予約された予約情報（キャンセル分も含む） */
  accommodationReservations: Array<AccommodationReservation>;
  /** 利用するためのコード */
  code: Scalars["String"]["output"];
  /** 作成者 */
  createdByUser?: Maybe<User>;
  /** 送付先メールアドレス */
  destinationEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * 適用期限
   * これを過ぎると予約作成・予約変更ができなくなる。
   */
  expiresAt: Scalars["ZonedDateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** チケットマスタ（管理用） */
  master?: Maybe<StayTicketMaster>;
  /** 宿泊チケットの共通情報 */
  reservationInfo: StayTicketReservationInfo;
  /** 予約が作られた時刻 */
  reservedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用ステータス */
  status: StayTicketStatusType;
  /** 宿泊可能期間の終了日 */
  stayEndNight: Scalars["PlainDate"]["output"];
  /** 宿泊可能期間の開始日 */
  stayStartNight: Scalars["PlainDate"]["output"];
  /** Stay Ticket from Owners の場合のオーナーシップ */
  userOwnership?: Maybe<UserOwnership>;
};

export type StayTicketAccommodationReservationProvider = {
  __typename: "StayTicketAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  stayTicketUnitId: Scalars["ID"]["output"];
};

export type StayTicketAcquisitionItem = {
  /**
   * オーナープランの年度
   * StayGiftFromOwnersの場合は必須
   */
  programYear?: InputMaybe<Scalars["Int"]["input"]>;
  /** チケット数 */
  quantity: Scalars["Int"]["input"];
  /**
   * UserOwnershipのID
   * StayGiftFromOwnersの場合は必須
   */
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
};

export const StayTicketAcquisitionMode = {
  OwnerNightExchange: "OwnerNightExchange",
  Purchase: "Purchase",
} as const;

export type StayTicketAcquisitionMode =
  (typeof StayTicketAcquisitionMode)[keyof typeof StayTicketAcquisitionMode];
/** 宿泊チケットの振る舞いを規定する共通のビジネスルール */
export type StayTicketMaster = {
  __typename: "StayTicketMaster";
  /** 3人目以降の追加ゲスト料金ポリシー（任意） */
  additionalGuestFeePolicy?: Maybe<AdditionalGuestFeePolicy>;
  /** 追加の注意事項 */
  additionalNoticeTypes: Array<AdditionalNoticeType>;
  /**
   * 予約可能な設備のリスト
   * 前提として、何も設備がついていない宿泊施設は常に予約できる。
   * その上で、設備がついている宿泊施設は、このリストにその設備が含まれる場合に予約できる。
   */
  availableAccommodationFacilities: Array<AccommodationFacility>;
  /** 予約可能な建築タイプのリスト */
  availableArchitectureTypes: Array<ArchitectureType>;
  /** 予約可能な拠点のリスト */
  availableSites: Array<Site>;
  /** 基本料金モード: 'Policy' は BaseAccommodationFeePolicy を使用、'Daily' は BaseAccommodationFeeDailyRate を使用 */
  baseAccommodationFeeMode: BaseAccommodationFeeMode;
  id: Scalars["ID"]["output"];
  /** シーズン料金の追加有無 */
  includeSeasonalFee: Scalars["Boolean"]["output"];
  /** 内部向けの説明 */
  internalDescription: Scalars["String"]["output"];
  /** アーカイブ済みかどうか */
  isArchived: Scalars["Boolean"]["output"];
  /** 一括利用かどうか */
  isBulkUsage: Scalars["Boolean"]["output"];
  /** 検索キー */
  lookupKey?: Maybe<Scalars["String"]["output"]>;
  /** ユーザーに表示する名称。 */
  name: Scalars["String"]["output"];
  /**
   * 予約時に表示される文章。
   * 構造化マークアップ（？）のフォーマットになる。
   */
  notice?: Maybe<Scalars["String"]["output"]>;
  /** 稼働制御の対象 */
  occupancyLimitTarget: OccupancyLimitTarget;
  /** 基本となる1泊ごとの宿泊料金のポリシー */
  rawBaseAccommodationFeePolicy: RawBaseAccommodationFeePolicy;
  /** キャンセル料金のポリシー */
  rawCancelFeePolicy: RawCancelFeePolicy;
  /** 管理部署 */
  staffGroup?: Maybe<StaffGroup>;
  /** チケット */
  stayTickets: Array<StayTicket>;
  /** 使用したチケットマスター雛形（任意） */
  template?: Maybe<StayTicketMasterTemplate>;
  /** このマスターに紐づくテンプレート */
  templates: Array<StayTicketTemplate>;
  /** チケット区分 */
  ticketCategory?: Maybe<TicketCategory>;
  /** 施設追加料金の請求をしないかどうか */
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["output"];
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee: Scalars["Boolean"]["output"];
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee: Scalars["Boolean"]["output"];
  /** dog料金の請求をしないかどうか */
  waiveDogFee: Scalars["Boolean"]["output"];
  /** ドッグラン料金の請求をしないかどうか */
  waiveDogRunFee: Scalars["Boolean"]["output"];
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee: Scalars["Boolean"]["output"];
  /** 繁忙日料金の請求をしないかどうか */
  waivePeakDayFee: Scalars["Boolean"]["output"];
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee: Scalars["Boolean"]["output"];
  /** 拠点別ハイシーズン料金の請求をしないかどうか */
  waiveSiteAdditionalFee: Scalars["Boolean"]["output"];
};

/** 宿泊チケットの振る舞いを規定する共通のビジネスルール */
export type StayTicketMasterStayTicketsArgs = {
  includeExpiredTicket?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * provider を経由せず StayTicketMaster に辿り着くための入力。
 * RoomType.availabilitiesByStayTicketMaster が使う。
 */
export type StayTicketMasterReferenceInput =
  /** StayTicketTemplate.lookupKey。非会員プレビュー等、固定のテンプレートを指す。 */
  { templateLookupKey: Scalars["String"]["input"] };

/** 宿泊チケットマスターのデフォルト値雛形 */
export type StayTicketMasterTemplate = {
  __typename: "StayTicketMasterTemplate";
  /** 3人目以降の追加ゲスト料金ポリシー（任意） */
  additionalGuestFeePolicy?: Maybe<AdditionalGuestFeePolicy>;
  /** 利用可能な施設タイプ */
  availableAccommodationFacilities: Array<AccommodationFacility>;
  /** 利用可能な建築タイプ */
  availableArchitectureTypes: Array<ArchitectureType>;
  /** 利用可能な拠点 */
  availableSites: Array<Site>;
  /** 基本料金モード */
  baseAccommodationFeeMode: BaseAccommodationFeeMode;
  id: Scalars["ID"]["output"];
  /** シーズン料金の追加有無 */
  includeSeasonalFee: Scalars["Boolean"]["output"];
  /** 管理用説明 */
  internalDescription?: Maybe<Scalars["String"]["output"]>;
  /** 一括利用かどうか */
  isBulkUsage: Scalars["Boolean"]["output"];
  /** 表示名 */
  name: Scalars["String"]["output"];
  /** 稼働制御の対象 */
  occupancyLimitTarget: OccupancyLimitTarget;
  /** 基本となる1泊ごとの宿泊料金のポリシー */
  rawBaseAccommodationFeePolicy?: Maybe<RawBaseAccommodationFeePolicy>;
  /** キャンセル料金のポリシー */
  rawCancelFeePolicy?: Maybe<RawCancelFeePolicy>;
  /** 一意識別子（FreePromo, FreeBase, Discount, Fixed など） */
  slug: Scalars["String"]["output"];
  /** 施設追加料金の請求をしないかどうか */
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["output"];
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee: Scalars["Boolean"]["output"];
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee: Scalars["Boolean"]["output"];
  /** dog料金の請求をしないかどうか */
  waiveDogFee: Scalars["Boolean"]["output"];
  /** ドッグラン料金の請求をしないかどうか */
  waiveDogRunFee: Scalars["Boolean"]["output"];
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee: Scalars["Boolean"]["output"];
  /** 繁忙日料金の請求をしないかどうか */
  waivePeakDayFee: Scalars["Boolean"]["output"];
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee: Scalars["Boolean"]["output"];
  /** 拠点別ハイシーズン料金の請求をしないかどうか */
  waiveSiteAdditionalFee: Scalars["Boolean"]["output"];
};

export type StayTicketReservationInfo = {
  __typename: "StayTicketReservationInfo";
  /**
   * 追加ゲスト料金（大人1人あたり、1泊）。基準人数を超えて1人目の単価。
   * AdditionalGuestFeePolicy が紐付いていない場合は null（追加料金なし）。
   */
  additionalGuestFeeAdultPricePerNight?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 追加ゲスト料金（6-11歳の子供1人あたり、1泊）。基準人数を超えて1人目の単価。
   * AdditionalGuestFeePolicy が紐付いていない場合は null（追加料金なし）。
   */
  additionalGuestFeeKidsPricePerNight?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 追加ゲスト料金が課金対象となる最小人数。
   * AdditionalGuestFeePolicy が紐付いていない場合は null（追加料金なし）。
   * 例: 基準人数 2 + 1 = 3 → 「3 名以上は追加料金あり」と案内する。
   * 将来 ArchitectureType / master ごとに基準人数を可変化する想定で
   * サーバ側から具体的な数値を返す設計とする。
   */
  additionalGuestFeeStartsAt?: Maybe<Scalars["Int"]["output"]>;
  /** 追加の注意事項 */
  additionalNoticeTypes: Array<AdditionalNoticeType>;
  /**
   * 予約可能な設備のリスト
   * 前提として、何も設備がついていない宿泊施設は常に予約できる。
   * その上で、設備がついている宿泊施設は、このリストにその設備が含まれる場合に予約できる。
   */
  availableAccommodationFacilityTypes: Array<AccommodationFacilityType>;
  /** 予約可能な建築タイプのリスト */
  availableArchitectureTypes: Array<ArchitectureType>;
  /** 予約可能な拠点のリスト */
  availableSites: Array<Site>;
  /**
   * キャンセル料金のポリシー
   * @deprecated Use AccommodationReservation.cancellationPolicy instead
   */
  cancelFeePolicy: CancelFeePolicy;
  /**
   * このチケットに設定された料金割引（feeModifier < 0 の料金ルール）。night 昇順。
   * チェックイン日・滞在日数に依存しない master 属性で、割引案内の表示に使う。
   * （「N 泊以上で◯◯OFF」の注意文に使うのは ruleType=ConsecutiveNightDiscount のみ。）
   * 料金割引が無い場合は空配列。
   */
  discounts: Array<AccommodationFeeDiscount>;
  /** ユーザーに表示する名称。 */
  name: Scalars["String"]["output"];
  /**
   * 予約時に表示される文章。
   * 構造化マークアップ（？）のフォーマットになる。
   */
  notice?: Maybe<Scalars["String"]["output"]>;
  /**
   * StayGiftFromOwners の場合の OwnerPlan の種類
   * 権利が Owners か Co-Owners かがわかる
   */
  ownerPlanType?: Maybe<OwnerPlanType>;
  /** 宿泊チケットのタイプ */
  type: StayTicketType;
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee: Scalars["Boolean"]["output"];
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee: Scalars["Boolean"]["output"];
  /** dog料金の請求をしないかどうか */
  waiveDogFee: Scalars["Boolean"]["output"];
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee: Scalars["Boolean"]["output"];
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee: Scalars["Boolean"]["output"];
};

/** 宿泊チケットの利用ステータス */
export const StayTicketStatusType = {
  /** 適用期限が過ぎている（終了状態） */
  Expired: "Expired",
  /** 予約作成が可能 */
  Open: "Open",
  /** すでに予約が取られている */
  Reserved: "Reserved",
  /** 宿泊済み（終了状態） */
  Stayed: "Stayed",
  /** 無効化されている（終了状態） */
  Void: "Void",
} as const;

export type StayTicketStatusType =
  (typeof StayTicketStatusType)[keyof typeof StayTicketStatusType];
export type StayTicketTemplate = {
  __typename: "StayTicketTemplate";
  /** 作成日時 */
  createdAt: Scalars["DateTime"]["output"];
  /** expiresAtを現在から何日後に設定するか */
  daysUntilExpiration?: Maybe<Scalars["Int"]["output"]>;
  /** stayEndNightを現在から何日後に設定するか */
  daysUntilLastStay?: Maybe<Scalars["Int"]["output"]>;
  /** 予約期限 */
  expiresAt: Scalars["ZonedDateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** チケット発行機能の有効／無効を設定する */
  isActive: Scalars["Boolean"]["output"];
  /** stayTicketMasterが同じでも異なる設定を入れる可能性があるので、lookupKeyで設定管理を行う */
  lookupKey: Scalars["String"]["output"];
  /** 宿泊チケットマスター */
  master: StayTicketMaster;
  /** 予約期限を固定で設定する場合に使用 */
  rawExpiresAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 宿泊可能終了日 */
  rawStayEndNight?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 宿泊可能開始日 */
  rawStayStartNight?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 宿泊可能終了日を固定で設定する場合に使用 */
  stayEndNight: Scalars["PlainDate"]["output"];
  /** 宿泊可能開始日を固定で設定する場合に使用 */
  stayStartNight: Scalars["PlainDate"]["output"];
};

/** 宿泊チケットのタイプ */
export const StayTicketType = {
  Regular: "Regular",
  StayGiftFromOwners: "StayGiftFromOwners",
} as const;

export type StayTicketType =
  (typeof StayTicketType)[keyof typeof StayTicketType];
/** 同一のビジネスルールを持つ宿泊チケットのまとまり */
export type StayTicketUnit = {
  __typename: "StayTicketUnit";
  id: Scalars["ID"]["output"];
  /** 宿泊チケットの共通情報 */
  reservationInfo: StayTicketReservationInfo;
  /** 宿泊可能期間の終了日（複数のチケットがある場合、一番遅い日） */
  stayEndNight: Scalars["PlainDate"]["output"];
  /** 宿泊可能期間の開始日（複数のチケットがある場合、一番早い日） */
  stayStartNight: Scalars["PlainDate"]["output"];
  /**
   * チケットマスターID
   * （計測用）
   */
  stayTicketMasterId?: Maybe<Scalars["String"]["output"]>;
  /** 適用されたチケット */
  stayTickets: Array<StayTicket>;
};

export const StayTicketValidationError = {
  /** 同じ宿泊チケットが複数回指定されている */
  Duplicate: "Duplicate",
  /** 適用期間内に、現在の日付が当てはまらない */
  Expired: "Expired",
  /** 宿泊チケットのマスターが異なる */
  MasterMismatch: "MasterMismatch",
  /** 宿泊チケットが存在しない */
  NotFound: "NotFound",
  /** ユニット化できる宿泊チケット数の上限を超えている */
  UnitFull: "UnitFull",
  /** 宿泊チケットが使用済みまたは無効である */
  Unusable: "Unusable",
} as const;

export type StayTicketValidationError =
  (typeof StayTicketValidationError)[keyof typeof StayTicketValidationError];
export type StayTicketValidationResult = {
  __typename: "StayTicketValidationResult";
  stayTicketCode: Scalars["String"]["output"];
  validationError?: Maybe<StayTicketValidationError>;
};

/**
 * Stripe のクレジットカード情報
 * 特に説明のないものは https://docs.stripe.com/api/cards/object を参照
 */
export type StripeCard = {
  __typename: "StripeCard";
  brand: Scalars["String"]["output"];
  exp_month: Scalars["Int"]["output"];
  exp_year: Scalars["Int"]["output"];
  last4: Scalars["String"]["output"];
};

/**
 * Stripe の請求方法
 * https://docs.stripe.com/api/invoices/create#create_invoice-collection_method
 */
export const StripeCollectionMethod = {
  ChargeAutomatically: "charge_automatically",
  SendInvoice: "send_invoice",
} as const;

export type StripeCollectionMethod =
  (typeof StripeCollectionMethod)[keyof typeof StripeCollectionMethod];
/** customerId を経由して紐づく Stripe の顧客情報 */
export type StripeCustomer = {
  __typename: "StripeCustomer";
  /** Customer ID */
  customerId: Scalars["String"]["output"];
  /**
   * デフォルトの支払い方法に設定されているクレジットカードの情報
   * Custoemr に設定された defaultPaymentMethod で type=card のもの
   */
  defaultCard?: Maybe<StripeCard>;
  /** 発行済みの請求書の一覧 */
  invoices: Array<StripeInvoice>;
};

/** customerId を経由して紐づく Stripe の顧客情報 */
export type StripeCustomerInvoicesArgs = {
  statuses?: InputMaybe<Array<StripeInvoiceStatus>>;
};

/**
 * Stripe の請求書情報
 * 特に説明のないものは https://docs.stripe.com/api/invoices/object を参照
 */
export type StripeInvoice = {
  __typename: "StripeInvoice";
  collection_method?: Maybe<StripeCollectionMethod>;
  createdAt: Scalars["ZonedDateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  hosted_invoice_url?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  metadata_list: Array<StripeMetadataItem>;
  status: StripeInvoiceStatus;
  status_transitions?: Maybe<StripeInvoiceStatusTransitions>;
  subscription?: Maybe<StripeInvoiceSubscription>;
  total: Scalars["Int"]["output"];
};

/** Stripe の請求書のステータス */
export const StripeInvoiceStatus = {
  Draft: "draft",
  Open: "open",
  Paid: "paid",
  Uncollectible: "uncollectible",
  Void: "void",
} as const;

export type StripeInvoiceStatus =
  (typeof StripeInvoiceStatus)[keyof typeof StripeInvoiceStatus];
/** Stripe 請求書のステータス遷移情報 */
export type StripeInvoiceStatusTransitions = {
  __typename: "StripeInvoiceStatusTransitions";
  paid_at?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

export type StripeInvoiceSubscription = {
  __typename: "StripeInvoiceSubscription";
  id: Scalars["ID"]["output"];
};

/** Stripe 請求書のメタデータの要素 */
export type StripeMetadataItem = {
  __typename: "StripeMetadataItem";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type StripeRequireNextAction = {
  __typename: "StripeRequireNextAction";
  clientSecret: Scalars["String"]["output"];
  /** Co-Owners 申込の場合 */
  coOwnersApplicationId?: Maybe<Scalars["String"]["output"]>;
};

export type SubmitAdHocQuestionnaireResponseError = {
  __typename: "SubmitAdHocQuestionnaireResponseError";
  case: SubmitAdHocQuestionnaireResponseErrorCase;
};

export const SubmitAdHocQuestionnaireResponseErrorCase = {
  GeneralError: "GeneralError",
  TemplateNotFound: "TemplateNotFound",
} as const;

export type SubmitAdHocQuestionnaireResponseErrorCase =
  (typeof SubmitAdHocQuestionnaireResponseErrorCase)[keyof typeof SubmitAdHocQuestionnaireResponseErrorCase];
export type SubmitAdHocQuestionnaireResponseInput = {
  /** 回答のリスト */
  answers: Array<AdHocQuestionnaireAnswerInput>;
  /** アンケート回答に付随する任意のメタデータのJSON文字列（予約ID、行動ログなど） */
  metaJsonStr?: InputMaybe<Scalars["String"]["input"]>;
  /** アンケートテンプレートのID */
  questionnaireTemplateId: Scalars["ID"]["input"];
};

export type SubmitAdHocQuestionnaireResponsePayload =
  | SubmitAdHocQuestionnaireResponseError
  | Success;

export type SubmitCoOwnersApplicationError = {
  __typename: "SubmitCoOwnersApplicationError";
  case: SubmitCoOwnersApplicationErrorCase;
};

export const SubmitCoOwnersApplicationErrorCase = {
  IdDocument1Invalid: "IdDocument1Invalid",
  IdDocument2Invalid: "IdDocument2Invalid",
  InvalidRequest: "InvalidRequest",
  NoBeneficialOwnerRelationshipFree: "NoBeneficialOwnerRelationshipFree",
  NoBusinessActivityFree: "NoBusinessActivityFree",
  NoIndividualEmployerName: "NoIndividualEmployerName",
  NoPurchasePurposeFree: "NoPurchasePurposeFree",
  NoSomeOfOrganizationName: "NoSomeOfOrganizationName",
  PaymentFailed: "PaymentFailed",
  PaymentRequiresAction: "PaymentRequiresAction",
  RegistryCertificateInvalid: "RegistryCertificateInvalid",
  UnitsOutOfRange: "UnitsOutOfRange",
} as const;

export type SubmitCoOwnersApplicationErrorCase =
  (typeof SubmitCoOwnersApplicationErrorCase)[keyof typeof SubmitCoOwnersApplicationErrorCase];
export type SubmitCoOwnersApplicationPayload =
  | CoOwnersApplication
  | StripeRequireNextAction
  | SubmitCoOwnersApplicationError;

export type SubmitStayReviewV2Payload = StayReviewV2 | StayReviewV2Error;

export type Success = {
  __typename: "Success";
  _: Scalars["Boolean"]["output"];
};

/** ある部屋に置かれる備品。マスタと、その部屋に適用される補充基準数の組 */
export type SupplyItem = {
  __typename: "SupplyItem";
  defaultQuantity: Scalars["Int"]["output"];
  master: SupplyItemMaster;
};

/** 備品の設置情報。対象は accommodation > architectureType > どちらも null（拠点共通）の優先順で決まる */
export type SupplyItemInstallation = {
  __typename: "SupplyItemInstallation";
  accommodation?: Maybe<Accommodation>;
  architectureType?: Maybe<ArchitectureType>;
  defaultQuantity: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
};

/** 備品マスタ項目 */
export type SupplyItemMaster = {
  __typename: "SupplyItemMaster";
  /** 備品種別。有料備品の免除ルール */
  category: SupplyItemMasterCategory;
  /** 備品マスタID */
  id: Scalars["ID"]["output"];
  /** 有効かどうか */
  isEnabled: Scalars["Boolean"]["output"];
  /** 表示名（スタッフ用） */
  namePrivate: Scalars["String"]["output"];
  /** 表示名（公開用） */
  namePublic: Scalars["String"]["output"];
  /** 単価（税抜） */
  price: Scalars["Int"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
  /** 消費税の種類 */
  taxRateType: ConsumptionTaxRateType;
  /** 単位（本、個など） */
  unit?: Maybe<Scalars["String"]["output"]>;
};

/** 備品の種別 */
export const SupplyItemMasterCategory = {
  Bread: "Bread",
  CoffeeBean: "CoffeeBean",
  Curry: "Curry",
  Firewood: "Firewood",
  FrozenDessert: "FrozenDessert",
  Other: "Other",
  Pizza: "Pizza",
  Rice: "Rice",
  Soup: "Soup",
  Toothbrush: "Toothbrush",
  Wine: "Wine",
} as const;

export type SupplyItemMasterCategory =
  (typeof SupplyItemMasterCategory)[keyof typeof SupplyItemMasterCategory];
/** 対象プランタイプ */
export const TargetPlanType = {
  /** 法人サブスク */
  BusinessSubscription: "BusinessSubscription",
  /** Co-Owners */
  CoOwners: "CoOwners",
  /** Owners(旧: Full-Owner) */
  FullOwner: "FullOwner",
  /** 個人サブスク */
  IndividualSubscription: "IndividualSubscription",
  /** プランなし */
  NoPlan: "NoPlan",
} as const;

export type TargetPlanType =
  (typeof TargetPlanType)[keyof typeof TargetPlanType];
export type TentativeAccommodationReservationError = {
  __typename: "TentativeAccommodationReservationError";
  case: TentativeAccommodationReservationErrorCase;
};

export const TentativeAccommodationReservationErrorCase = {
  /** 有効期限切れ */
  Expired: "Expired",
  /** 異なるユーザーに紐づいている */
  NotAuthorized: "NotAuthorized",
  /** 仮予約が存在しない */
  NotFound: "NotFound",
  /** One more Cabin の親予約のユーザー */
  OneMoreCabinParentReservationUser: "OneMoreCabinParentReservationUser",
} as const;

export type TentativeAccommodationReservationErrorCase =
  (typeof TentativeAccommodationReservationErrorCase)[keyof typeof TentativeAccommodationReservationErrorCase];
export type TentativeAccommodationReservationPayload =
  | AccommodationReservation
  | RedirectLocation
  | TentativeAccommodationReservationError;

/**
 * 規約
 * プランごとに共通の規約を持つ、白馬オーナーなど例外として個別規約を持つ場合もある
 */
export type Terms = {
  __typename: "Terms";
  /** 規約本文の URL。個別規約はそのファイル、共通規約はプラン共通の規約ページ */
  documentUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 個別規約の対象 OwnerPlan。共通規約は null */
  ownerPlan?: Maybe<OwnerPlan>;
  plan: TermsPlanType;
  /** 改定（改定日の降順） */
  revisions: Array<TermsRevision>;
};

/** 規約の対象プラン */
export const TermsPlanType = {
  BusinessPlan: "BusinessPlan",
  CoOwnersPlan: "CoOwnersPlan",
  FullOwnerPlan: "FullOwnerPlan",
  StandardPlan: "StandardPlan",
} as const;

export type TermsPlanType = (typeof TermsPlanType)[keyof typeof TermsPlanType];
/**
 * 規約の改定
 * 本文の更新を伴わない改定（料金変更など）も 1 件として扱う
 */
export type TermsRevision = {
  __typename: "TermsRevision";
  /** 改定の説明文 */
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 社内向けの改定内容の要約。会員には表示しない */
  internalSummary: Scalars["String"]["output"];
  /** 改定内容の詳細を案内するお知らせ */
  news?: Maybe<News>;
  /** 改定日 */
  revisedDate: Scalars["PlainDate"]["output"];
  /** 同意を求める対象の OwnerPlan。null は規約の適用者全員 */
  targetOwnerPlan?: Maybe<OwnerPlan>;
  terms: Terms;
};

/** チケット区分 */
export const TicketCategory = {
  /** Stay Gift */
  StayGift: "StayGift",
  /** Stay自社予約 */
  StaySelfBooking: "StaySelfBooking",
  /** タイアップ */
  Tieup: "Tieup",
  /** タイアップ（別途請求） */
  TieupSeparateBilling: "TieupSeparateBilling",
  /** 試泊（無償） */
  TrialFree: "TrialFree",
  /** 試泊（有償） */
  TrialPaid: "TrialPaid",
} as const;

export type TicketCategory =
  (typeof TicketCategory)[keyof typeof TicketCategory];
/** トップページコンテンツ */
export type TopPage = {
  __typename: "TopPage";
  /** Archive article (ニュースレター) */
  archiveArticle?: Maybe<ArchiveArticle>;
  /** バナーコンテンツ */
  bannerContents: Array<TopPageBannerContent>;
  /** 最新のお知らせ1件 */
  news?: Maybe<News>;
  /** サービスアップデート */
  serviceUpdate?: Maybe<ServiceUpdate>;
};

/** トップページのバナーコンテンツ */
export type TopPageBannerContent = {
  __typename: "TopPageBannerContent";
  /** 管理名 */
  name: Scalars["String"]["output"];
  /** 表示画像 */
  thumbnail: Scalars["String"]["output"];
  /** 遷移先URL */
  url: Scalars["String"]["output"];
};

/** Trial契約（12ヶ月お試しプラン） */
export type TrialContract = {
  __typename: "TrialContract";
  /**
   * Co-Owners充当特典（旧S2Oポイント）累積額（円）
   * 月額料金（税抜）の100%を毎月付与
   */
  accumulatedS2oAmount: Scalars["Int"]["output"];
  /** 申込日 */
  appliedAt: Scalars["ZonedDateTime"]["output"];
  /** キャンセル日 */
  cancelledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 現在の期間の付与泊数
   * 前半期間なら前半で付与された泊数、後半期間なら後半で付与された泊数
   * GrantBySubscriptionトランザクションの合計
   */
  currentPeriodGrantedStayCredits: Scalars["Int"]["output"];
  /**
   * 現在の期間の残り泊数
   * 前半期間なら前半の残り、後半期間なら後半の残り
   */
  currentPeriodStayCredits: Scalars["Int"]["output"];
  /** 契約終了日（利用開始日から12ヶ月後の前日） */
  endDate: Scalars["PlainDate"]["output"];
  /**
   * 利用開始日（契約開始日）
   * ユーザーが選択した翌月または翌々月の1日
   */
  enrolledAt: Scalars["ZonedDateTime"]["output"];
  /** 利用開始日（PlainDate形式） */
  enrolledDate: Scalars["PlainDate"]["output"];
  /** 前半期間の終了日（利用開始日から6ヶ月後の前日） */
  firstSemesterEndDate: Scalars["PlainDate"]["output"];
  /** 前半期間の付与泊数 */
  firstSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /** 前半期間の残りピーク日数 */
  firstSemesterRemainingPeakDays: Scalars["Int"]["output"];
  /** 前半期間の残り泊数 */
  firstSemesterStayCredits: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  /** 残りのピーク日数（全期間の合計） */
  remainingPeakDays: Scalars["Int"]["output"];
  /**
   * 合計残り泊数
   * 前半4泊 + 後半4泊の合計から使用済み泊数を引いた数
   */
  remainingStayCredits: Scalars["Int"]["output"];
  /** 後半期間の付与泊数 */
  secondSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /** 後半期間の残りピーク日数 */
  secondSemesterRemainingPeakDays: Scalars["Int"]["output"];
  /** 後半期間の開始日（利用開始日から6ヶ月後） */
  secondSemesterStartDate: Scalars["PlainDate"]["output"];
  /** 後半期間の残り泊数 */
  secondSemesterStayCredits: Scalars["Int"]["output"];
  /**
   * 基本的なステータス
   * 予約できるかどうか、宿泊できるかどうかなど
   */
  status: TrialContractStatus;
  /** 詳細なステータス */
  statusDetail: TrialContractStatusDetail;
  stripeSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  /** Stripe連携情報 */
  stripeSubscriptionScheduleId?: Maybe<Scalars["String"]["output"]>;
  /** 決済失敗による新規予約の停止 */
  suspended: Scalars["Boolean"]["output"];
  /** 停止日時 */
  suspendedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 解約日 */
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 合計付与泊数（常に8泊） */
  totalStayCredits: Scalars["Int"]["output"];
};

export const TrialContractStatus = {
  /** デフォルト（契約期間外） */
  Neutral: "Neutral",
  /** 利用の予定がある（利用予約ができる） */
  Planned: "Planned",
  /** 利用中（利用予約ができる＋利用ができる） */
  Usable: "Usable",
} as const;

export type TrialContractStatus =
  (typeof TrialContractStatus)[keyof typeof TrialContractStatus];
export const TrialContractStatusDetail = {
  /** デフォルト（契約なし） */
  NeutralDefault: "NeutralDefault",
  /** 契約終了済み */
  NeutralTerminated: "NeutralTerminated",
  /** 契約開始予定 */
  PlannedDefault: "PlannedDefault",
  /** 利用中（通常） */
  UsableDefault: "UsableDefault",
} as const;

export type TrialContractStatusDetail =
  (typeof TrialContractStatusDetail)[keyof typeof TrialContractStatusDetail];
export type TrialPlanAccommodationReservationProvider = {
  __typename: "TrialPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  trialContractId: Scalars["ID"]["output"];
};

export type UpdateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
};

export type UpdateAccommodationReservationOptionsError = {
  __typename: "UpdateAccommodationReservationOptionsError";
  case: UpdateAccommodationReservationOptionsErrorCase;
};

export const UpdateAccommodationReservationOptionsErrorCase = {
  /** オプションを更新できる予約ステータスではない */
  DeniedByStatus: "DeniedByStatus",
  /**
   * 未知のエラー
   * チェックイン画面で利用されるためエラーもレスポンスとして返す
   */
  UnknownError: "UnknownError",
} as const;

export type UpdateAccommodationReservationOptionsErrorCase =
  (typeof UpdateAccommodationReservationOptionsErrorCase)[keyof typeof UpdateAccommodationReservationOptionsErrorCase];
export type UpdateAccommodationReservationOptionsInput = {
  bringDog: Scalars["Boolean"]["input"];
  /**
   * 人数情報 (省略時は変更しない)。
   * 指定された場合は detail を更新し、StayTicket master の AdditionalGuestFeePolicy 由来の
   * calculated_additional_guest_fee 行を partial に再計算する。
   */
  guestCounts?: InputMaybe<GuestCountsInput>;
  numberOfDogs: Scalars["Int"]["input"];
  useEvCharger: Scalars["Boolean"]["input"];
};

export type UpdateAccommodationReservationOptionsPayload =
  | AccommodationReservation
  | UpdateAccommodationReservationOptionsError;

export type UpdateCoOwnersApplicationOwnerInfoError = {
  __typename: "UpdateCoOwnersApplicationOwnerInfoError";
  case: UpdateCoOwnersApplicationOwnerInfoErrorCase;
};

export const UpdateCoOwnersApplicationOwnerInfoErrorCase = {
  /** 詳細情報の種類が一致しない */
  DetailTypeMismatch: "DetailTypeMismatch",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 権限がない（申込者本人でない） */
  Unauthorized: "Unauthorized",
} as const;

export type UpdateCoOwnersApplicationOwnerInfoErrorCase =
  (typeof UpdateCoOwnersApplicationOwnerInfoErrorCase)[keyof typeof UpdateCoOwnersApplicationOwnerInfoErrorCase];
export type UpdateCoOwnersApplicationOwnerInfoPayload =
  | CoOwnersApplication
  | UpdateCoOwnersApplicationOwnerInfoError;

export type UpdateFacilityReservationError = {
  __typename: "UpdateFacilityReservationError";
  case: UpdateFacilityReservationErrorCase;
};

export const UpdateFacilityReservationErrorCase = {
  CommentPeriodExpired: "CommentPeriodExpired",
  InvalidAttribute: "InvalidAttribute",
  InvalidTransition: "InvalidTransition",
  NotAuthorized: "NotAuthorized",
  OutsideUsablePeriod: "OutsideUsablePeriod",
  ReservationNotFound: "ReservationNotFound",
  UsageFlowNotSupported: "UsageFlowNotSupported",
} as const;

export type UpdateFacilityReservationErrorCase =
  (typeof UpdateFacilityReservationErrorCase)[keyof typeof UpdateFacilityReservationErrorCase];
/** 付帯サービス予約更新入力 */
export type UpdateFacilityReservationInput = {
  controllerAttribute: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateFacilityReservationPayload =
  | UpdateFacilityReservationError
  | UpdateFacilityReservationSuccess;

export type UpdateFacilityReservationSuccess = {
  __typename: "UpdateFacilityReservationSuccess";
  reservation: FacilityReservation;
};

export type UpdateViewerInput = {
  addressInJapan?: InputMaybe<AddressInJapanInput>;
  addressInternational?: InputMaybe<AddressInternationalInput>;
  addressIsInJapan: Scalars["Boolean"]["input"];
  birthDate: Scalars["PlainDate"]["input"];
  /**
   * 車保有状況
   * 任意だが入力した後に null で上書きできない
   */
  carOwnershipStatus?: InputMaybe<UserProfileCarOwnershipStatus>;
  facePhoto?: InputMaybe<UploadedFileInput>;
  /**
   * 性別
   * 任意だが入力した後に null で上書きできない
   */
  gender?: InputMaybe<GenderType>;
  /**
   * 世帯構成
   * 任意だが入力した後に null で上書きできない
   */
  householdComposition?: InputMaybe<UserProfileHouseholdComposition>;
  name: Scalars["String"]["input"];
  nameKana?: InputMaybe<Scalars["String"]["input"]>;
  nationality: CountryEnum;
  /**
   * 愛犬数
   * 任意だが入力した後に null で上書きできない（0 になる）
   */
  numberOfDogs?: InputMaybe<Scalars["Int"]["input"]>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  passportPhoto?: InputMaybe<UploadedFileInput>;
  phoneNumber: Scalars["String"]["input"];
  /**
   * 職業(フリーテキスト)
   * 任意だが入力した後に null で上書きできない（空文字列は可）
   */
  professionFree?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 職業
   * 任意だが入力した後に null で上書きできない
   */
  professionType?: InputMaybe<UserProfileProfessionType>;
};

export type UploadedFile = {
  __typename: "UploadedFile";
  /** 画像と紐付ける任意のキャプション。 */
  caption?: Maybe<Scalars["String"]["output"]>;
  /**
   * アップロード後のファイルの URL。
   * この URL でファイルにアクセスすることはできない。
   * このファイルを持つエンティティの update mutation に渡すことを想定した値。
   */
  rawUrl: Scalars["String"]["output"];
  /**
   * 期限付きの Presigned URL。
   * 一般ユーザの場合、自分がアップロードしたファイルしか見ることができない。
   * 他のユーザがアップロードした画像の場合は URL の取得に失敗する。
   */
  url: Scalars["String"]["output"];
};

export type UploadedFileInput = {
  /** 画像と紐付ける任意のキャプション。 */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * アップロードしたファイルの URL。
   * `https://<bucket>.s3.<region>.amazonaws.com/<key>` の形式。
   */
  rawUrl: Scalars["String"]["input"];
};

/**
 * ユーザー（会員）
 * Webアプリにログインできる、メールアドレスを持っている。
 * 特に SANU 2nd Home を利用するユーザーのことを、会員と呼ぶ。
 */
export type User = {
  __typename: "User";
  /** マーケメール配信に同意しているか、未回答の場合は null。 */
  acceptMarketingEmail?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * トップ画面からアクセスできる予約カレンダーのリスト
   * 複数なのは、例えば StandardPlan と CoOwners を併用している場合などがあるため
   */
  accessibleReservationCalendars: Array<AccessibleReservationCalendarType>;
  /**
   * 持っている宿泊予約
   * （現在はチェックアウトしていないもので仮予約以外を全て返す。デフォルトの挙動やページングなど、別途定義する）
   */
  accommodationReservations: Array<AccommodationReservation>;
  /** AdHocアンケートの回答一覧 */
  adHocQuestionnaireResponses: Array<AdHocQuestionnaireResponse>;
  /** 管理ロールの割り当て。本人か SuperAdmin / Admin のみ読める。既定は有効なもの（未失効・未期限切れ）だけ */
  adminRoleAssignments: Array<AdminRoleAssignment>;
  /**
   * 対象ユーザーが所有者のすべての宿泊予約
   * (キャンセル・仮予約も含む)
   */
  allAccommodationReservations: Array<AccommodationReservation>;
  /** ユーザーに紐づく App インストールの一覧 */
  appInstallations: Array<UserAppInstallation>;
  /** ユーザーに紐づく Auth0 ユーザーの一覧 */
  auth0Users: Array<Auth0User>;
  /**
   * Bubble の User ID
   * 支払い履歴へのリンクに使用
   */
  bubbleId?: Maybe<Scalars["String"]["output"]>;
  /** CoOwnersの申し込みの情報 */
  coOwnersApplications: Array<CoOwnersApplication>;
  /** 共同オーナーの情報 */
  coOwnerships: Array<UserOwnership>;
  /** 登録されている同伴者 */
  companions?: Maybe<Array<UserCompanion>>;
  /** ユーザー作成日時 */
  createdAt: Scalars["DateTime"]["output"];
  /** 当月の利用済みメンバー特典ドリンクチケット */
  currentMonthUsedDrinkTicket?: Maybe<MemberPerksNowhereDrinkTicket>;
  /** ユーザー削除日時 */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** ログインメールアドレス */
  email: Scalars["String"]["output"];
  /** ログインメールアドレスが確認済みかどうか */
  emailVerified: Scalars["Boolean"]["output"];
  /** Full-Owner 契約でこのユーザーが行った本人確認の一覧（新しい順） */
  fullOwnerIdentityVerifications: Array<IdentityVerification>;
  /** フルオーナーの情報 */
  fullOwnerships: Array<UserOwnership>;
  /**
   * 予約可能なプランを 1 つ以上保有しているか
   * （accessibleReservationCalendars が 1 件以上あるかと同義）
   */
  hasReservablePlan: Scalars["Boolean"]["output"];
  /** 未払いの宿泊料金があるかどうか */
  hasUnpaidAccommodationFee: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** Auth0に紐づくアイデンティティ一覧（ソーシャルログイン等） */
  identities: Array<UserIdentity>;
  /** Intercom Messenger 用の JWT トークン */
  intercomJwt?: Maybe<Scalars["String"]["output"]>;
  /** SuperAdmin か Admin（unrestricted なロール）を持つか。旧 admin フラグは見ない。ロールの内訳は adminRoleAssignments */
  isAdmin: Scalars["Boolean"]["output"];
  /** メンバー特典ドリンクチケット利用対象者か否か */
  isEligibleMemberForDrinkTicketPerks: Scalars["Boolean"]["output"];
  /** Stay Gift が購入可能か */
  isEligibleToPurchaseStayGift: Scalars["Boolean"]["output"];
  /** 宿泊予約に必要なプロフィールを入力済みかどうか */
  isFilledRequiredProfile: Scalars["Boolean"]["output"];
  /** どのプランにも入っていないゲストかどうか */
  isGuest: Scalars["Boolean"]["output"];
  /** 対象のプラン（Subscription、Business、CoOwners、FullOwner）を持っているメンバーかどうか */
  isMember: Scalars["Boolean"]["output"];
  /**
   * プロフィール
   * (未作成/削除済みの場合にnullを返す)
   */
  maybeProfile?: Maybe<UserProfile>;
  /** 氏名 */
  name: Scalars["String"]["output"];
  /** 氏名のふりがな */
  nameKana?: Maybe<Scalars["String"]["output"]>;
  /** 所属企業 */
  organization?: Maybe<Organization>;
  /** 所属企業の詳細情報 */
  organizationMembership?: Maybe<OrganizationMembership>;
  /** ペルソナ分析メトリクス（内部API用） */
  personaMetrics: UserPersonaMetrics;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** プロフィール */
  profile: UserProfile;
  /**
   * 同意が必要な改定
   * 全ての契約中プランの規約の改定のうち、改定日を迎えていて未同意のもの全て。
   * provider を指定すると、その provider での予約に適用される規約の改定に絞る。
   * provider に適用される改定に同意するまで、その provider で予約の作成・変更ができない
   */
  requiredTermsAgreements: Array<TermsRevision>;
  /** Co-Owners充当特典（旧S2Oポイント） */
  s2o: S2o;
  /**
   * for Staff契約の情報（従業員向け福利厚生プラン）
   * 契約が存在しない場合はnull
   */
  staffContract?: Maybe<StaffContract>;
  /** Co-Owners充当特典（Stay）の割引予測額（内部API用・読み取り専用） */
  stayCreditEstimate: StayCreditEstimate;
  /** 保有宿泊チケット */
  stayTickets: Array<StayTicket>;
  /** 宿泊した回数 */
  stayedReservationCount: Scalars["Int"]["output"];
  /** Stripe の情報 */
  stripe: StripeCustomer;
  /** サブスクリプションの情報 */
  subscription: UserSubscription;
  /** システム設定 */
  systemSettings: UserSystemSettings;
  /**
   * Trial契約の情報（12ヶ月お試しプラン）
   * 契約が存在しない場合はnull
   */
  trialContract?: Maybe<TrialContract>;
  /** 持っている仮予約 */
  unconfirmedAccommodationReservations: Array<AccommodationReservation>;
  /** ユーザー情報更新日時 */
  updatedAt: Scalars["DateTime"]["output"];
  /**
   * Zendesk の User ID
   * 問い合わせ対応時のユーザー照会に使用
   */
  zendeskId?: Maybe<Scalars["String"]["output"]>;
};

/**
 * ユーザー（会員）
 * Webアプリにログインできる、メールアドレスを持っている。
 * 特に SANU 2nd Home を利用するユーザーのことを、会員と呼ぶ。
 */
export type UserAdminRoleAssignmentsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * ユーザー（会員）
 * Webアプリにログインできる、メールアドレスを持っている。
 * 特に SANU 2nd Home を利用するユーザーのことを、会員と呼ぶ。
 */
export type UserRequiredTermsAgreementsArgs = {
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

export type UserAppInstallation = {
  __typename: "UserAppInstallation";
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** FCM トークン */
  fcmToken: Scalars["String"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /** インストール ID */
  installationId: Scalars["String"]["output"];
  /** プラットフォーム */
  platform: PushNotificationPlatform;
  /** 登録時のアプリのバージョン */
  registeredAppVersion?: Maybe<Scalars["String"]["output"]>;
  /** デバイスモデル */
  registeredDeviceModel?: Maybe<Scalars["String"]["output"]>;
  /** 登録時のデバイスの OS バージョン */
  registeredOsVersion?: Maybe<Scalars["String"]["output"]>;
  /** 更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** ユーザー */
  user: User;
};

export type UserCompanion = {
  __typename: "UserCompanion";
  /** 住所 */
  address: Address;
  /** 生年月日 */
  birthDate: Scalars["PlainDate"]["output"];
  /** 性別 */
  gender: GenderType;
  id: Scalars["ID"]["output"];
  /** 氏名 */
  name: Scalars["String"]["output"];
  /** 国籍 */
  nationality?: Maybe<CountryEnum>;
  /** パスポート番号（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportNumber?: Maybe<Scalars["String"]["output"]>;
  /** パスポート写真（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportPhoto?: Maybe<UploadedFile>;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** 職業 */
  professionType?: Maybe<UserProfileProfessionType>;
};

export type UserCompanionInput = {
  addressInJapan?: InputMaybe<AddressInJapanInput>;
  addressInternational?: InputMaybe<AddressInternationalInput>;
  addressIsInJapan: Scalars["Boolean"]["input"];
  birthDate: Scalars["PlainDate"]["input"];
  gender: GenderType;
  name: Scalars["String"]["input"];
  nationality?: InputMaybe<CountryEnum>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  passportPhoto?: InputMaybe<UploadedFileInput>;
  phoneNumber: Scalars["String"]["input"];
  professionType?: InputMaybe<UserProfileProfessionType>;
};

export const UserFileType = {
  /** CoOwners法人名義の場合の登記簿謄本（履歴事項全部証明書） */
  RegistryCertificate: "RegistryCertificate",
  /** 顔写真 */
  UserFacePhoto: "UserFacePhoto",
  /** 本人確認書類1 */
  UserIdentityDocument1: "UserIdentityDocument1",
  /** 本人確認書類2 */
  UserIdentityDocument2: "UserIdentityDocument2",
  /** パスポート写真 */
  UserPassportPhoto: "UserPassportPhoto",
} as const;

export type UserFileType = (typeof UserFileType)[keyof typeof UserFileType];
/** Auth0に紐づくアイデンティティ情報 */
export type UserIdentity = {
  __typename: "UserIdentity";
  /**
   * パスワードが自動生成されたものかどうか（ソーシャルサインアップ時に自動作成された場合true）。
   * EmailPasswordプロバイダーのみ有効、それ以外はnull。
   */
  autoGeneratedPassword?: Maybe<Scalars["Boolean"]["output"]>;
  /** Auth0のコネクション名 */
  connection: Scalars["String"]["output"];
  /** アイデンティティのメールアドレス */
  email?: Maybe<Scalars["String"]["output"]>;
  /** メールアドレスが確認済みかどうか */
  emailVerified: Scalars["Boolean"]["output"];
  /** Apple Private Relayメールアドレスかどうか */
  isAppleRelay: Scalars["Boolean"]["output"];
  /** ソーシャルプロバイダーかどうか */
  isSocial: Scalars["Boolean"]["output"];
  /** ローカルDB（auth0_users.linked_identities）に同期済みかどうか */
  isSyncedLocally: Scalars["Boolean"]["output"];
  /** プロバイダー種別 */
  provider: IdentityProvider;
  /** Auth0ユーザーID */
  userId: Scalars["String"]["output"];
};

export type UserMonthlyStatement = {
  __typename: "UserMonthlyStatement";
  /** 予約明細一覧 */
  reservationStatements: Array<ReservationStatementItem>;
  /** 合計金額（税込） */
  totalPrice: Scalars["Int"]["output"];
  /** 対象ユーザー */
  user: User;
  /** 対象年月 */
  yearMonth: Scalars["PlainYearMonth"]["output"];
};

/** オーナーとして所有済みの物件情報 */
export type UserOwnership = {
  __typename: "UserOwnership";
  /** CoOwner 申し込み */
  coOwnersApplication?: Maybe<CoOwnersApplication>;
  /** 現在の年度の報情 */
  currentYearStatus: UserOwnershipProgramYearStatus;
  /** 名義人（個人：ユーザー名／法人：会社名） */
  holderName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * 年間あたりの繁忙日の最大宿泊可能数(High日)
   * （月割りのない場合の最大値）
   * FullOwner は 2027 program year から適用されるため、それ以前の期間中は null。
   */
  maxPeakDaysPerYear?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 年間あたりの拠点ハイシーズンの最大宿泊可能数
   * （月割りのない場合の最大値）
   */
  maxSiteHighSeasonDaysPerYear?: Maybe<Scalars["Int"]["output"]>;
  /** 次回お支払日 */
  nextPaymentDate: Scalars["PlainDate"]["output"];
  /**
   * 次の年度の情報
   * 10月1日以降になると返るようになる
   */
  nextYearStatus?: Maybe<UserOwnershipProgramYearStatus>;
  /**
   * 年間利用泊数
   * （月割りのない場合の最大値）
   */
  nightsPerYear: Scalars["Int"]["output"];
  /** プラン */
  plan: OwnerPlan;
  /** 口数 */
  units: Scalars["Int"]["output"];
  /** 利用終了日 */
  usageEndDate: Scalars["PlainDate"]["output"];
  /** 利用開始日 */
  usageStartDate: Scalars["PlainDate"]["output"];
  /** このオーナーシップのユーザー */
  user: User;
};

/** オーナー機能における年度ごとの情報 */
export type UserOwnershipProgramYearStatus = {
  __typename: "UserOwnershipProgramYearStatus";
  /** 年度の終わり */
  endDate: Scalars["PlainDate"]["output"];
  /** 残りの泊数 */
  remainingNights: Scalars["Int"]["output"];
  /**
   * 残りの泊数のうち繁忙日の残り。
   * 限度日数を持つプラン (limitPeakDays=true) のみ値を持ち、それ以外は null。
   */
  remainingPeakDays?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 残りの泊数のうち拠点ハイシーズン期間の残り。
   * FullOwner のみ値を持ち、CoOwners や拠点ハイシーズン期間の登録されていない拠点の owner は null。
   */
  remainingSiteHighSeasonDays?: Maybe<Scalars["Int"]["output"]>;
  /** 年度の始まり */
  startDate: Scalars["PlainDate"]["output"];
  /** 年度 */
  year: Scalars["Int"]["output"];
};

/**
 * ユーザーペルソナ分析のメトリクス
 * 各指標は0-100のスコア
 */
export type UserPersonaMetrics = {
  __typename: "UserPersonaMetrics";
  /** 探索性スコア（訪問済みサイト数を元に計算） */
  exploration: Scalars["Int"]["output"];
  /** 利用頻度スコア（過去6ヶ月の予約回数を元に計算） */
  frequency: Scalars["Int"]["output"];
  /** 投資額スコア（累計支払額を元に計算） */
  investment: Scalars["Int"]["output"];
  /** ロイヤリティスコア（継続利用月数を元に計算） */
  loyalty: Scalars["Int"]["output"];
  /** 季節性スコア（ピークシーズン利用率を元に計算） */
  seasonality: Scalars["Int"]["output"];
};

/**
 * ユーザーのプロフィール
 * ユーザー自身についての情報。
 * 宿泊に際しての法律・条例的な必要条件になるものもここに含まれる。
 */
export type UserProfile = {
  __typename: "UserProfile";
  /** 住所 */
  address?: Maybe<Address>;
  /** 生年月日 */
  birthDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 車保有状況 */
  carOwnershipStatus?: Maybe<UserProfileCarOwnershipStatus>;
  /** 顔写真 */
  facePhoto?: Maybe<UploadedFile>;
  /** 性別 */
  gender?: Maybe<GenderType>;
  /** 世帯構成 */
  householdComposition?: Maybe<UserProfileHouseholdComposition>;
  id: Scalars["ID"]["output"];
  /** 国籍 */
  nationality?: Maybe<CountryEnum>;
  /** 愛犬数 */
  numberOfDogs?: Maybe<Scalars["Int"]["output"]>;
  /** パスポート番号（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportNumber?: Maybe<Scalars["String"]["output"]>;
  /** パスポート写真（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportPhoto?: Maybe<UploadedFile>;
  /** 職業(フリーテキスト) */
  professionFree?: Maybe<Scalars["String"]["output"]>;
  /** 職業 */
  professionType?: Maybe<UserProfileProfessionType>;
  user: User;
};

export const UserProfileCarOwnershipStatus = {
  /** カーシェア契約あり */
  WithCarShare: "WithCarShare",
  /** 自家用車あり */
  WithOwnCar: "WithOwnCar",
  /** 自家用車・カーシェア契約なし */
  WithoutAny: "WithoutAny",
} as const;

export type UserProfileCarOwnershipStatus =
  (typeof UserProfileCarOwnershipStatus)[keyof typeof UserProfileCarOwnershipStatus];
export const UserProfileHouseholdComposition = {
  /** ファミリー（子供あり） */
  FamilyWithKids: "FamilyWithKids",
  /** 夫婦・カップルのみ（子供なし） */
  FamilyWithoutKids: "FamilyWithoutKids",
  /** その他 */
  Other: "Other",
  /** 単身 */
  Single: "Single",
} as const;

export type UserProfileHouseholdComposition =
  (typeof UserProfileHouseholdComposition)[keyof typeof UserProfileHouseholdComposition];
export const UserProfileProfessionType = {
  /**
   * 公務員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  CivilServant: "CivilServant",
  /** 公務員・団体職員 */
  CivilServantOrOrganizationEmployee: "CivilServantOrOrganizationEmployee",
  /**
   * 会社員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  CompanyEmployee: "CompanyEmployee",
  /** 会社員（出社中心） */
  CompanyEmployeeOffice: "CompanyEmployeeOffice",
  /** 会社員（リモートワーク中心） */
  CompanyEmployeeRemote: "CompanyEmployeeRemote",
  /**
   * 会社経営 / 役員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  ExecutiveOrDirector: "ExecutiveOrDirector",
  /** 経営者・会社役員・開業医・士業 */
  ExecutiveOrProfessional: "ExecutiveOrProfessional",
  /** 専業主婦・主夫 */
  FullTimeHomemaker: "FullTimeHomemaker",
  /**
   * 団体職員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  OrganizationEmployee: "OrganizationEmployee",
  /** その他 */
  Other: "Other",
  /**
   * 教授 / 教員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  ProfessorOrTeacher: "ProfessorOrTeacher",
  /** 個人事業主・フリーランス */
  SelfEmployedOrFreelancer: "SelfEmployedOrFreelancer",
  /** 学生 */
  Student: "Student",
  /**
   * 無職・未成年（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  UnemployedOrMinor: "UnemployedOrMinor",
} as const;

export type UserProfileProfessionType =
  (typeof UserProfileProfessionType)[keyof typeof UserProfileProfessionType];
export type UserSubscription = {
  __typename: "UserSubscription";
  /** Standardプランで蓄積した Co-Owners充当特典（旧S2Oポイント）の累計額 */
  accumulatedS2oAmount: Scalars["Int"]["output"];
  /** 利用申込日 */
  appliedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 毎月の決済日
   * - status=Usable の場合は現行のサブスクリプションの決済日
   * - status=Planed の場合は予定しているサブスクリプションの決済日
   * 概念的には statusDetail=UsableToPause の場合は復帰前と復帰後の2つのサイクルがありうるので注意。
   */
  billingCycleDay?: Maybe<Scalars["Int"]["output"]>;
  /** 利用開始日（実績） */
  enrolledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用開始予定日 */
  enrollmentScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 直近一週間の追加予約ができる期間 */
  next7DaysReservationPeriod?: Maybe<UserSubscriptionNext7DaysReservationPeriod>;
  /**
   * 休会可能日
   * いますぐ休会した時に休会予定日に選択可能な日
   */
  pausableDates: Array<Scalars["PlainDate"]["output"]>;
  /** この日以降、休会可能 */
  pausableFrom?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 休会予定日 */
  pauseScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 休会日（実績） */
  pausedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * Weekdayプラン規約改定への同意が必要かどうか
   * 既存会員（2026/01/12以前に申込）かつ未同意の場合にtrue
   * @deprecated 規約の同意は Terms / TermsRevision に統合した。未同意の改定は User.requiredTermsAgreements で取る
   */
  requiresWeekdayTermsAgreement: Scalars["Boolean"]["output"];
  /** 毎月の予約サイクル定義 */
  reservationCycle?: Maybe<UserSubscriptionReservationCycle>;
  /** 直近以降の予約サイクル期間 */
  reservationCyclePeriods: Array<UserSubscriptionReservationCyclePeriod>;
  /** 休会復帰予定日 */
  resumeScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 休会復帰日（実績） */
  resumedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 基本的なステータス
   * 予約できるかどうか、宿泊できるかどうかなどであれば、こちらで十分。
   */
  status: UserSubscriptionStatus;
  /** 詳細なステータス */
  statusDetail: UserSubscriptionStatusDetail;
  stripeCurrentSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  stripeCurrentSubscriptionScheduleId?: Maybe<Scalars["String"]["output"]>;
  stripeUpcomingSubscriptionScheduleId?: Maybe<Scalars["String"]["output"]>;
  /** 決済失敗による、新規予約の停止 */
  suspended: Scalars["Boolean"]["output"];
  /** 利用停止中の場合の停止日時 */
  suspendedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 解約可能日
   * いますぐ解約した時に解約予定日になる日
   */
  terminatableDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** この日以降、解約可能 */
  terminatableFrom?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 解約日（実績） */
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 解約禁止理由 */
  terminationProhibitReason: UserSubscriptionTerminationProhibitReason;
  /** 解約予定日 */
  terminationScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * Weekdayプラン規約改定への同意日時
   * nullの場合は未同意
   */
  weekdayTermsAgreedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

export type UserSubscriptionReservationCyclePeriodsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserSubscriptionNext7DaysReservationPeriod = {
  __typename: "UserSubscriptionNext7DaysReservationPeriod";
  /** lastNight として選択可能な最終日 */
  end: Scalars["PlainDate"]["output"];
  /** firstNight として選択可能な最初の日 */
  start: Scalars["PlainDate"]["output"];
};

export type UserSubscriptionReservationCycle = {
  __typename: "UserSubscriptionReservationCycle";
  /**
   * 予約サイクルの終了日
   * 空の場合は、startDay と同じ月の月末とする。
   */
  endDay?: Maybe<Scalars["Int"]["output"]>;
  /** 予約サイクルの開始日 */
  startDay: Scalars["Int"]["output"];
};

export type UserSubscriptionReservationCyclePeriod = {
  __typename: "UserSubscriptionReservationCyclePeriod";
  /** 追加料金が発生する泊数（宿泊済みおよび予約しているものをカウント） */
  additionalNights: Scalars["Int"]["output"];
  end: Scalars["PlainDate"]["output"];
  /**
   * アクティブな予約があるかどうか
   * ある場合は、一週間前予約としてのみ予約可能
   */
  hasActiveReservation: Scalars["Boolean"]["output"];
  /** 追加料金なしで泊まれる残りの泊数（宿泊済みおよび予約しているものをカウント） */
  remainingBaseNights: Scalars["Int"]["output"];
  start: Scalars["PlainDate"]["output"];
  /**
   * 予約サイクルでサブスクとして宿泊済みまたは予約している泊数
   * 8泊目以降の追加料金に影響する
   */
  stayedAndReservedNights: Scalars["Int"]["output"];
};

export const UserSubscriptionStatus = {
  Neutral: "Neutral",
  Planed: "Planed",
  Usable: "Usable",
} as const;

export type UserSubscriptionStatus =
  (typeof UserSubscriptionStatus)[keyof typeof UserSubscriptionStatus];
export const UserSubscriptionStatusDetail = {
  NeutralDefault: "NeutralDefault",
  NeutralTerminated: "NeutralTerminated",
  PlanedDefault: "PlanedDefault",
  PlanedToResume: "PlanedToResume",
  UsableDefault: "UsableDefault",
  UsableToPause: "UsableToPause",
  UsableToTerminate: "UsableToTerminate",
} as const;

export type UserSubscriptionStatusDetail =
  (typeof UserSubscriptionStatusDetail)[keyof typeof UserSubscriptionStatusDetail];
export const UserSubscriptionTerminationProhibitReason = {
  /** InvalidOperation（異常系） */
  InvalidOperation: "InvalidOperation",
  /** 想定外の繊維（異常系） */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** 解約可能 */
  NoReason: "NoReason",
  /** NoSubscription（異常系） */
  NoSubscription: "NoSubscription",
  /** 解約できない期間 */
  NotPausableDateYet: "NotPausableDateYet",
  /** 予約があるため */
  ReservationExists: "ReservationExists",
  /** 不明なエラー（異常系） */
  UnknownError: "UnknownError",
} as const;

export type UserSubscriptionTerminationProhibitReason =
  (typeof UserSubscriptionTerminationProhibitReason)[keyof typeof UserSubscriptionTerminationProhibitReason];
/** 解約アンケート */
export type UserSubscriptionTerminationQuestionnaireInput = {
  /** 解約の背景 */
  backgroundOfTermination: Scalars["String"]["input"];
  /** 満足した点（その他を選択した場合） */
  detailOfSatisfactionOfUse?: InputMaybe<Scalars["String"]["input"]>;
  /** 解約理由（その他を選択した場合） */
  detailOfTerminationReason?: InputMaybe<Scalars["String"]["input"]>;
  /** 改善点 */
  improvementPoint: Scalars["String"]["input"];
  /** １番の解約理由 */
  primaryReasonOfTermination: Scalars["String"]["input"];
  /** 解約理由 */
  reasonsOfTermination: Array<Scalars["String"]["input"]>;
  /** 満足した点 */
  satisfactionsOfUse: Array<Scalars["String"]["input"]>;
  /** 今後の情報受信について */
  whetherToReceiveInformation: Scalars["Boolean"]["input"];
};

export type UserSystemSettings = {
  __typename: "UserSystemSettings";
  /** ハウスルールの表示 */
  hasSeenHouseRules: Scalars["Boolean"]["output"];
};

export type UserSystemSettingsInput = {
  hasSeenHouseRules?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** アカウント連携セッション検証のエラーレスポンス */
export type VerifyAccountLinkSessionError = {
  __typename: "VerifyAccountLinkSessionError";
  /** エラーケース */
  case: VerifyAccountLinkSessionErrorCase;
};

/** アカウント連携セッション検証のエラーケース */
export const VerifyAccountLinkSessionErrorCase = {
  /** セッショントークンが無効または期限切れ */
  InvalidSessionToken: "InvalidSessionToken",
} as const;

export type VerifyAccountLinkSessionErrorCase =
  (typeof VerifyAccountLinkSessionErrorCase)[keyof typeof VerifyAccountLinkSessionErrorCase];
/** アカウント連携セッション検証の入力 */
export type VerifyAccountLinkSessionInput = {
  /** Auth0から渡されたセッショントークン */
  sessionToken: Scalars["String"]["input"];
};

/** アカウント連携セッション検証の結果 */
export type VerifyAccountLinkSessionPayload =
  | VerifyAccountLinkSessionError
  | VerifyAccountLinkSessionSuccess;

/** アカウント連携セッション検証の成功レスポンス */
export type VerifyAccountLinkSessionSuccess = {
  __typename: "VerifyAccountLinkSessionSuccess";
  /** 連携先の既存アカウント（同じメールアドレスの認証済み auth0| アカウント） */
  candidateIdentity: AccountLinkIdentity;
  /** 現在のログインに使用されたアイデンティティ */
  currentIdentity: AccountLinkIdentity;
  /** メールアドレス */
  email: Scalars["String"]["output"];
};

/** アイデンティティ追加再認証エラー */
export type VerifyAddIdentityReauthError = {
  __typename: "VerifyAddIdentityReauthError";
  case: VerifyAddIdentityReauthErrorCase;
};

/** アイデンティティ追加再認証エラーケース */
export const VerifyAddIdentityReauthErrorCase = {
  /** 再認証したユーザーが期待するIDと一致しない */
  IdentityMismatch: "IdentityMismatch",
  /** intent tokenが無効または期限切れ */
  InvalidIntentToken: "InvalidIntentToken",
  /** Auth0とのトークン交換に失敗 */
  TokenExchangeFailed: "TokenExchangeFailed",
} as const;

export type VerifyAddIdentityReauthErrorCase =
  (typeof VerifyAddIdentityReauthErrorCase)[keyof typeof VerifyAddIdentityReauthErrorCase];
/** アイデンティティ追加再認証の入力 */
export type VerifyAddIdentityReauthInput = {
  /** Auth0から返されたauthorization code */
  code: Scalars["String"]["input"];
  /** ラウンドトリップ用のstate (intent token) */
  state: Scalars["String"]["input"];
};

/** アイデンティティ追加再認証の結果 */
export type VerifyAddIdentityReauthPayload =
  | VerifyAddIdentityReauthError
  | VerifyAddIdentityReauthRedirect;

/** アイデンティティ追加再認証: 対象プロバイダーへリダイレクト */
export type VerifyAddIdentityReauthRedirect = {
  __typename: "VerifyAddIdentityReauthRedirect";
  /** 対象プロバイダーのOAuth認可URL */
  redirectUrl: Scalars["String"]["output"];
};

export type VerifyCheckInQrCodeError = {
  __typename: "VerifyCheckInQrCodeError";
  case: VerifyCheckInQrCodeErrorCase;
};

export const VerifyCheckInQrCodeErrorCase = {
  /** 既に使用済み */
  AlreadyUsed: "AlreadyUsed",
  /** コードの有効期限切れ */
  Expired: "Expired",
  /** 無効なコード */
  InvalidCode: "InvalidCode",
  /** サイトが一致しない */
  SiteMismatch: "SiteMismatch",
} as const;

export type VerifyCheckInQrCodeErrorCase =
  (typeof VerifyCheckInQrCodeErrorCase)[keyof typeof VerifyCheckInQrCodeErrorCase];
export type VerifyCheckInQrCodeInput = {
  /** QRコード */
  code: Scalars["String"]["input"];
  /** サイトのslug */
  siteSlug: Scalars["String"]["input"];
};

export type VerifyCheckInQrCodePayload =
  | VerifyCheckInQrCodeError
  | VerifyCheckInQrCodeSuccess;

export type VerifyCheckInQrCodeSuccess = {
  __typename: "VerifyCheckInQrCodeSuccess";
  /** 検証が成功した予約ID */
  accommodationReservationId: Scalars["ID"]["output"];
};

export type VerifyNewEmailError = {
  __typename: "VerifyNewEmailError";
  case: VerifyNewEmailErrorCase;
};

export const VerifyNewEmailErrorCase = {
  /**
   * 直前に確認メールを送ったメールアドレスと異なる
   * メールアドレス入力からやり直してもらう
   */
  DifferentEmail: "DifferentEmail",
  GeneralError: "GeneralError",
  /** メールアドレスもしくは確認コードが間違っている */
  InvalidEmailOrCode: "InvalidEmailOrCode",
} as const;

export type VerifyNewEmailErrorCase =
  (typeof VerifyNewEmailErrorCase)[keyof typeof VerifyNewEmailErrorCase];
export type VerifyNewEmailInput = {
  /** システム（Auth0）からメールで送信された確認コード */
  code: Scalars["String"]["input"];
  newEmail: Scalars["String"]["input"];
};

export type VerifyNewEmailPayload = VerifyNewEmailError | VerifyNewEmailSuccess;

export type VerifyNewEmailSuccess = {
  __typename: "VerifyNewEmailSuccess";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** 付帯サービス洗濯乾燥機の稼働状況のコントローラ属性情報（機器の状態はこの ID で PlugDevice を引く） */
export type WashingMachineTracker = {
  __typename: "WashingMachineTracker";
  controllerId?: Maybe<Scalars["String"]["output"]>;
};

/** Wi-Fi 接続方法（SSID とパスワードの組） */
export type WifiConnection = {
  __typename: "WifiConnection";
  /** パスワード */
  password: Scalars["String"]["output"];
  /** SSID */
  ssid: Scalars["String"]["output"];
};

/** Wi-Fi 機器の固有情報 */
export type WifiEquipmentAttribute = {
  __typename: "WifiEquipmentAttribute";
  /** 主接続方法 */
  primary: WifiConnection;
  /**
   * 副接続方法
   * （存在しない施設では null）
   */
  secondary?: Maybe<WifiConnection>;
};

export type WorkationAccommodationFacility = {
  __typename: "WorkationAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ZendeskSyncUserError = {
  __typename: "ZendeskSyncUserError";
  case: ZendeskSyncUserErrorCase;
};

export const ZendeskSyncUserErrorCase = {
  UserEmailNotVerified: "UserEmailNotVerified",
  UserNotFound: "UserNotFound",
  /**
   * Zendesk API が permanent なエラー（401 / 403 / 404 等）を返した。
   * 再試行せず Slack にメンション通知して諦める。
   */
  ZendeskApiPermanentError: "ZendeskApiPermanentError",
  /**
   * Zendesk API が transient なエラー（409 / 422 / 429 / 5xx）を返した。
   * qstash の自動再試行に乗せる。
   */
  ZendeskApiTransientError: "ZendeskApiTransientError",
  ZendeskIdNotFound: "ZendeskIdNotFound",
  ZendeskIdUpdateError: "ZendeskIdUpdateError",
} as const;

export type ZendeskSyncUserErrorCase =
  (typeof ZendeskSyncUserErrorCase)[keyof typeof ZendeskSyncUserErrorCase];
export type ZendeskSyncUserResult = Success | ZendeskSyncUserError;

export type LeaveOrganizationPayload = LeaveOrganizationError | Success;

export type OfferedCoOwnerPlansQueryVariables = Exact<{
  code?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OfferedCoOwnerPlansQuery = {
  __typename: "Query";
  offeredCoOwnersPlans: Array<
    {
      __typename: "OwnerPlan";
      id: string;
      type: OwnerPlanType;
      name: string;
      advancePaymentRequired: boolean;
      unitNightsPerYear: number;
      unitPurchaseAmount: number;
      unitApplicationFee: number;
      coOwnersMaxPeakDaysPerUnit?: number | null;
      coOwnersMaxConcurrentReservationsPerUnit?: number | null;
      site: { __typename: "Site"; id: string; name: string };
      architectureType?: {
        __typename: "ArchitectureType";
        id: string;
        name: string;
      } | null;
      accommodationFacilities: Array<{
        __typename: "AccommodationFacility";
        type: AccommodationFacilityType;
      }>;
      coOwnersPlanOfferings: Array<{
        __typename: "CoOwnersPlanOffering";
        units: number;
        isSoldOut: boolean;
        estimate?: { __typename: "UploadedFile"; url: string } | null;
      }>;
    } & {
      " $fragmentRefs"?: {
        CoOwnersApplicationDetailsFragment: CoOwnersApplicationDetailsFragment;
      };
    }
  >;
};

export type OwnerPlanQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  code?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OwnerPlanQuery = {
  __typename: "Query";
  ownerPlan: {
    __typename: "OwnerPlan";
    id: string;
    unitNightsPerYear: number;
    unitPurchaseAmount: number;
    unitApplicationFee: number;
    site: { __typename: "Site"; name: string };
    architectureType?: { __typename: "ArchitectureType"; name: string } | null;
  } & {
    " $fragmentRefs"?: {
      CoOwnersApplicationDetailsFragment: CoOwnersApplicationDetailsFragment;
    };
  };
};

export type S2oPointsOfViewerQueryVariables = Exact<{
  ownerPlanId: Scalars["ID"]["input"];
  units: Scalars["Int"]["input"];
  useWeekdayTrial: Scalars["Boolean"]["input"];
  useStayCredit: Scalars["Boolean"]["input"];
}>;

export type S2oPointsOfViewerQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    s2o: {
      __typename: "S2o";
      weekdayTrialBalance: number;
      stayCreditBalance: number;
      usedAmount: number;
    };
  };
};

export type TentativeReservationQueryVariables = Exact<{
  code: Scalars["ID"]["input"];
}>;

export type TentativeReservationQuery = {
  __typename: "Query";
  tentativeAccommodationReservation:
    | ({
        __typename: "AccommodationReservation";
        firstDate: PlainDateString;
        lastDate: PlainDateString;
        tentativeDeadline?: ZonedDateTimeString | null;
        reservedFrom: ZonedDateTimeString;
        accommodation: {
          __typename: "Accommodation";
          name: string;
          code: string;
          architectureType: {
            __typename: "ArchitectureType";
            name: string;
            series: ArchitectureTypeSeries;
          };
          site: {
            __typename: "Site";
            slug: string;
            name: string;
            area: { __typename: "Area"; slug: string };
          };
        };
        fee: {
          __typename: "AccommodationFee";
          totalAmount: number;
          items: Array<{
            __typename: "AccommodationFeeItem";
            label: string;
            amount: number;
            night?: PlainDateString | null;
          }>;
        };
        provider:
          | { __typename: "BusinessPlanAccommodationReservationProvider" }
          | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
          | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
          | { __typename: "OneMoreCabinAccommodationReservationProvider" }
          | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
          | { __typename: "SanuIncAccommodationReservationProvider" }
          | { __typename: "StaffPlanAccommodationReservationProvider" }
          | { __typename: "StandardPlanAccommodationReservationProvider" }
          | { __typename: "StayDirectAccommodationReservationProvider" }
          | { __typename: "StayTicketAccommodationReservationProvider" }
          | { __typename: "TrialPlanAccommodationReservationProvider" };
      } & {
        " $fragmentRefs"?: {
          AccommodationReservationInfoFragment: AccommodationReservationInfoFragment;
        };
      })
    | { __typename: "RedirectLocation"; path: string }
    | ({ __typename: "TentativeAccommodationReservationError" } & {
        " $fragmentRefs"?: {
          TentativeAccommodationReservationErrorCaseFragment: TentativeAccommodationReservationErrorCaseFragment;
        };
      });
};

export type AdminApproveIdentityVerificationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateIdentityVerificationInput;
}>;

export type AdminApproveIdentityVerificationMutation = {
  __typename: "Mutation";
  internalUpdateIdentityVerification:
    | {
        __typename: "InternalUpdateIdentityVerificationError";
        case: InternalUpdateIdentityVerificationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminAreaFilterAreasQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAreaFilterAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    slug: string;
    name: string;
  }>;
};

export type ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment = {
  __typename: "ConsumedSupplyFeeItemWaiver";
  id: string;
  type: ConsumedSupplyFeeItemWaiverType;
  supplyItemMasterCategory?: SupplyItemMasterCategory | null;
  quantity: number;
  createdAt: DateTimeString;
  updatedAt: DateTimeString;
} & {
  " $fragmentName"?: "ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment";
};

export type ReservationWaivers_ConsumedSuppliesFeeItemFragment = {
  __typename: "ConsumedSuppliesFeeItem";
  label: string;
  quantity: number;
  amount: number;
  reportedQuantity?: number | null;
} & { " $fragmentName"?: "ReservationWaivers_ConsumedSuppliesFeeItemFragment" };

export type IdentityVerificationItem_IdentityVerificationFragment = {
  __typename: "IdentityVerification";
  id: string;
  method: IdentityVerificationMethod;
  status: IdentityVerificationStatus;
  result?: IdentityVerificationResult | null;
  note: string;
  trustdockVerificationId?: string | null;
  trustdockOperationPageUrl?: string | null;
  submissionPageUrl?: string | null;
  submissionPageUrlExpiresAt?: ZonedDateTimeString | null;
} & {
  " $fragmentName"?: "IdentityVerificationItem_IdentityVerificationFragment";
};

export type AdminRejectIdentityVerificationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateIdentityVerificationInput;
}>;

export type AdminRejectIdentityVerificationMutation = {
  __typename: "Mutation";
  internalUpdateIdentityVerification:
    | {
        __typename: "InternalUpdateIdentityVerificationError";
        case: InternalUpdateIdentityVerificationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminSiteFilterAreasQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminSiteFilterAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    slug: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
    }>;
  }>;
};

export type AdminCreateArchitectureContentImageUploadPolicyMutationVariables =
  Exact<{
    input: InternalCreateArchitectureContentImageUploadPolicyInput;
  }>;

export type AdminCreateArchitectureContentImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateArchitectureContentImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminAccommodationFacilityBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAccommodationFacilityBasicInfoQuery = {
  __typename: "Query";
  internalAccommodationFacility: {
    __typename: "AccommodationFacility";
    id: string;
    type: AccommodationFacilityType;
    slug: string;
  };
};

export type AdminAccommodationFacilityHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAccommodationFacilityHeaderQuery = {
  __typename: "Query";
  internalAccommodationFacility: { __typename: "AccommodationFacility" } & {
    " $fragmentRefs"?: {
      AccommodationFacilityHeaderFragment: AccommodationFacilityHeaderFragment;
    };
  };
  internalContentArchitecturalFeature?: {
    __typename: "ContentArchitecturalFeature";
    slug: string;
  } | null;
};

export type AccommodationFacilityHeaderFragment = {
  __typename: "AccommodationFacility";
  id: string;
  type: AccommodationFacilityType;
  slug: string;
} & { " $fragmentName"?: "AccommodationFacilityHeaderFragment" };

export type AdminAccommodationFacilityAmenitiesQueryVariables = Exact<{
  accommodationFacilityId: Scalars["ID"]["input"];
}>;

export type AdminAccommodationFacilityAmenitiesQuery = {
  __typename: "Query";
  internalContentFacilityAmenities: Array<{
    __typename: "ContentArchitectureTypeVariantFacilityAmenity";
    id: string;
    name: string;
    descriptionMarkup: string;
    referenceCounts: {
      __typename: "ContentFacilityAmenityReferenceCounts";
      variations: number;
      options: number;
      features: number;
    };
  }>;
};

export type AdminDeleteContentFacilityAmenityMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteContentFacilityAmenityMutation = {
  __typename: "Mutation";
  internalDeleteContentFacilityAmenity:
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      }
    | { __typename: "Success" };
};

export type AdminCreateOrUpdateContentFacilityAmenityMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentFacilityAmenityInput;
}>;

export type AdminCreateOrUpdateContentFacilityAmenityMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentFacilityAmenity:
    | {
        __typename: "ContentArchitectureTypeVariantFacilityAmenity";
        id: string;
        name: string;
        descriptionMarkup: string;
        accommodationFacility: {
          __typename: "AccommodationFacility";
          id: string;
          type: AccommodationFacilityType;
          slug: string;
        };
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminDeleteContentArchitecturalFeatureMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteContentArchitecturalFeatureMutation = {
  __typename: "Mutation";
  internalDeleteContentArchitecturalFeature:
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      }
    | { __typename: "Success" };
};

export type AdminCreateOrUpdateContentArchitecturalFeatureMutationVariables =
  Exact<{
    accommodationFacilityId: Scalars["ID"]["input"];
    input: InternalCreateOrUpdateContentArchitecturalFeatureInput;
  }>;

export type AdminCreateOrUpdateContentArchitecturalFeatureMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitecturalFeature:
    | { __typename: "ContentArchitecturalFeature"; id: string }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminAccommodationFacilityContentQueryVariables = Exact<{
  accommodationFacilityId: Scalars["ID"]["input"];
}>;

export type AdminAccommodationFacilityContentQuery = {
  __typename: "Query";
  internalContentArchitecturalFeature?: {
    __typename: "ContentArchitecturalFeature";
    id: string;
    slug: string;
    name: string;
    description: string;
    usageFeesDescriptionMarkup: string;
    usageConditionsDescription: string;
    availabilityNote?: string | null;
    ruleTitle: string;
    ruleNoteMarkup: string;
    thumbnailImageUrl?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
    imageUrls: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    }>;
    facilityAmenities: Array<{
      __typename: "ContentArchitectureTypeVariantFacilityAmenity";
      id: string;
      name: string;
    }>;
    rules: Array<{
      __typename: "ContentArchitecturalFeatureUsageRule";
      id: string;
      bodyMarkup: string;
      sort: number;
      imageUrl?: {
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      } | null;
    }>;
  } | null;
  internalContentFacilityAmenities: Array<{
    __typename: "ContentArchitectureTypeVariantFacilityAmenity";
    id: string;
    name: string;
  }>;
};

export type AdminUpdateContentArchitecturalFeatureImagesMutationVariables =
  Exact<{
    accommodationFacilityId: Scalars["ID"]["input"];
    input: InternalCreateOrUpdateContentArchitecturalFeatureInput;
  }>;

export type AdminUpdateContentArchitecturalFeatureImagesMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitecturalFeature:
    | {
        __typename: "ContentArchitecturalFeature";
        id: string;
        thumbnailImageUrl?: {
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        } | null;
        imageUrls: Array<{
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        }>;
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminCreateOrUpdateContentArchitecturalFeatureUsageRuleMutationVariables =
  Exact<{
    featureId: Scalars["ID"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput;
  }>;

export type AdminCreateOrUpdateContentArchitecturalFeatureUsageRuleMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitecturalFeatureUsageRule:
    | {
        __typename: "ContentArchitecturalFeatureUsageRule";
        id: string;
        bodyMarkup: string;
        sort: number;
        imageUrl?: {
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        } | null;
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminReorderContentArchitecturalFeatureUsageRulesMutationVariables =
  Exact<{
    input:
      | Array<InternalReorderArchitectureContentInput>
      | InternalReorderArchitectureContentInput;
  }>;

export type AdminReorderContentArchitecturalFeatureUsageRulesMutation = {
  __typename: "Mutation";
  internalReorderContentArchitecturalFeatureUsageRules: Array<{
    __typename: "ContentArchitecturalFeatureUsageRule";
    id: string;
    sort: number;
  }>;
};

export type AdminDeleteContentArchitecturalFeatureUsageRuleMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
  }>;

export type AdminDeleteContentArchitecturalFeatureUsageRuleMutation = {
  __typename: "Mutation";
  internalDeleteContentArchitecturalFeatureUsageRule:
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      }
    | { __typename: "Success" };
};

export type AdminAccommodationFacilitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAccommodationFacilitiesQuery = {
  __typename: "Query";
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    type: AccommodationFacilityType;
    slug: string;
  }>;
};

export type AdminCreateOrUpdateAccommodationNoticeMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAccommodationNoticeInput;
}>;

export type AdminCreateOrUpdateAccommodationNoticeMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAccommodationNotice:
    | ({ __typename: "AccommodationNotice" } & {
        " $fragmentRefs"?: {
          AccommodationNoticesTable_AccommodationNoticeFragment: AccommodationNoticesTable_AccommodationNoticeFragment;
        };
      })
    | {
        __typename: "InternalCreateOrUpdateAccommodationNoticeError";
        case: InternalCreateOrUpdateAccommodationNoticeErrorCase;
        message: string;
      };
};

export type AdminAccommodationNoticesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAccommodationNoticesQuery = {
  __typename: "Query";
  internalAccommodationNotices: Array<
    { __typename: "AccommodationNotice" } & {
      " $fragmentRefs"?: {
        AccommodationNoticesTable_AccommodationNoticeFragment: AccommodationNoticesTable_AccommodationNoticeFragment;
      };
    }
  >;
};

export type AdminAccommodationNoticeMastersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAccommodationNoticeMastersQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      slug: string;
      accommodations: Array<{
        __typename: "Accommodation";
        id: string;
        code: string;
        name: string;
      }>;
    }>;
  }>;
};

export type AccommodationNoticesTable_AccommodationNoticeFragment = {
  __typename: "AccommodationNotice";
  id: string;
  createdAt: DateTimeString;
  updatedAt: DateTimeString;
  brief: string;
  detail?: string | null;
  externalUrl?: string | null;
  startDate: PlainDateString;
  endDate: PlainDateString;
  sendEmailToExpectedUsers: boolean;
  status: AccommodationNoticeStatus;
  createdUser: { __typename: "User"; id: string; name: string; email: string };
  lastUpdatedUser: {
    __typename: "User";
    id: string;
    name: string;
    email: string;
  };
  accommodations: Array<{
    __typename: "Accommodation";
    id: string;
    code: string;
    name: string;
    site: { __typename: "Site"; id: string; name: string; slug: string };
  }>;
} & {
  " $fragmentName"?: "AccommodationNoticesTable_AccommodationNoticeFragment";
};

export type AdminAccommodationBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAccommodationBasicInfoQuery = {
  __typename: "Query";
  internalAccommodation?:
    | ({ __typename: "Accommodation" } & {
        " $fragmentRefs"?: {
          AccommodationBasicInfoFragment: AccommodationBasicInfoFragment;
        };
      })
    | null;
};

export type AccommodationBasicInfoFragment = ({
  __typename: "Accommodation";
  id: string;
  name: string;
  code: string;
  facilityTypes: Array<AccommodationFacilityType>;
  remoteLockDeviceId?: string | null;
  architectureType: {
    __typename: "ArchitectureType";
    id: string;
    name: string;
    seriesShortName: string;
    size?: ArchitectureTypeSize | null;
  };
} & {
  " $fragmentRefs"?: {
    AccommodationEditSheetFragment: AccommodationEditSheetFragment;
  };
}) & { " $fragmentName"?: "AccommodationBasicInfoFragment" };

export type AccommodationContentEditSheetFragment = {
  __typename: "Accommodation";
  id: string;
  content: { __typename: "AccommodationContent"; manualUrl?: string | null };
} & { " $fragmentName"?: "AccommodationContentEditSheetFragment" };

export type AdminCreateOrUpdateAccommodationContentMutationVariables = Exact<{
  accommodationId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateAccommodationContentInput;
}>;

export type AdminCreateOrUpdateAccommodationContentMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAccommodationContent: {
    __typename: "Accommodation";
    id: string;
    content: { __typename: "AccommodationContent"; manualUrl?: string | null };
  };
};

export type AdminAccommodationContentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAccommodationContentQuery = {
  __typename: "Query";
  internalAccommodation?:
    | ({ __typename: "Accommodation" } & {
        " $fragmentRefs"?: {
          AccommodationContentTabFragment: AccommodationContentTabFragment;
        };
      })
    | null;
};

export type AccommodationContentTabFragment = ({
  __typename: "Accommodation";
  id: string;
  code: string;
  facilityTypes: Array<AccommodationFacilityType>;
  architectureType: {
    __typename: "ArchitectureType";
    size?: ArchitectureTypeSize | null;
  };
  content: { __typename: "AccommodationContent"; manualUrl?: string | null };
} & {
  " $fragmentRefs"?: {
    AccommodationContentEditSheetFragment: AccommodationContentEditSheetFragment;
  };
}) & { " $fragmentName"?: "AccommodationContentTabFragment" };

export type AdminAccommodationHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAccommodationHeaderQuery = {
  __typename: "Query";
  internalAccommodation?:
    | ({ __typename: "Accommodation" } & {
        " $fragmentRefs"?: {
          AccommodationHeaderFragment: AccommodationHeaderFragment;
        };
      })
    | null;
};

export type AccommodationHeaderFragment = {
  __typename: "Accommodation";
  id: string;
  name: string;
  code: string;
  site: {
    __typename: "Site";
    id: string;
    name: string;
    area: { __typename: "Area"; id: string; name: string };
  };
} & { " $fragmentName"?: "AccommodationHeaderFragment" };

export type AccommodationEditSheetFragment = {
  __typename: "Accommodation";
  id: string;
  code: string;
  sort: number;
  remoteLockDeviceId?: string | null;
  site: { __typename: "Site"; id: string; name: string };
  architectureType: { __typename: "ArchitectureType"; id: string };
  facilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    type: AccommodationFacilityType;
  }>;
} & { " $fragmentName"?: "AccommodationEditSheetFragment" };

export type AdminUpdateAccommodationMutationVariables = Exact<{
  accommodationId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateAccommodationInput;
}>;

export type AdminUpdateAccommodationMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAccommodation:
    | {
        __typename: "Accommodation";
        id: string;
        name: string;
        code: string;
        sort: number;
        facilityTypes: Array<AccommodationFacilityType>;
        remoteLockDeviceId?: string | null;
        site: { __typename: "Site"; id: string; name: string };
        architectureType: {
          __typename: "ArchitectureType";
          id: string;
          seriesShortName: string;
          size?: ArchitectureTypeSize | null;
        };
        facilities: Array<{
          __typename: "AccommodationFacility";
          id: string;
          type: AccommodationFacilityType;
        }>;
      }
    | {
        __typename: "InternalCreateOrUpdateAccommodationError";
        message: string;
      };
};

export type AdminArchitectureTypesForAccommodationEditQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminArchitectureTypesForAccommodationEditQuery = {
  __typename: "Query";
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
    seriesShortName: string;
    size?: ArchitectureTypeSize | null;
  }>;
};

export type AdminFacilitiesForAccommodationEditQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminFacilitiesForAccommodationEditQuery = {
  __typename: "Query";
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    slug: string;
    type: AccommodationFacilityType;
  }>;
};

export type AdminAccommodationsQueryVariables = Exact<{
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type AdminAccommodationsQuery = {
  __typename: "Query";
  internalAccommodations: Array<{
    __typename: "Accommodation";
    id: string;
    name: string;
    code: string;
    sort: number;
    facilityTypes: Array<AccommodationFacilityType>;
    remoteLockDeviceId?: string | null;
    site: { __typename: "Site"; id: string; name: string };
    architectureType: {
      __typename: "ArchitectureType";
      id: string;
      seriesShortName: string;
      size?: ArchitectureTypeSize | null;
    };
  }>;
};

export type AdminAccommodationAreasQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAccommodationAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    slug: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
    }>;
  }>;
};

export type AdminAccommodationArchitectureTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAccommodationArchitectureTypesQuery = {
  __typename: "Query";
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    slug: string;
    seriesShortName: string;
    size?: ArchitectureTypeSize | null;
  }>;
};

export type AdminReorderAccommodationsMutationVariables = Exact<{
  input:
    | Array<InternalReorderAccommodationInput>
    | InternalReorderAccommodationInput;
}>;

export type AdminReorderAccommodationsMutation = {
  __typename: "Mutation";
  internalReorderAccommodations: Array<{
    __typename: "Accommodation";
    id: string;
  }>;
};

export type AdminCreateAccommodationMutationVariables = Exact<{
  input: InternalCreateOrUpdateAccommodationInput;
}>;

export type AdminCreateAccommodationMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAccommodation:
    | { __typename: "Accommodation"; id: string; name: string; code: string }
    | {
        __typename: "InternalCreateOrUpdateAccommodationError";
        message: string;
      };
};

export type AdminArchitectureTypesForAccommodationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminArchitectureTypesForAccommodationQuery = {
  __typename: "Query";
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
    seriesShortName: string;
    size?: ArchitectureTypeSize | null;
  }>;
};

export type AdminFacilitiesForAccommodationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminFacilitiesForAccommodationQuery = {
  __typename: "Query";
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    slug: string;
    type: AccommodationFacilityType;
  }>;
};

export type AdminActivityProgramsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminActivityProgramsQuery = {
  __typename: "Query";
  internalSiteActivityPrograms: Array<
    {
      __typename: "SiteActivityProgram";
      id: string;
      publishStartAt?: ZonedDateTimeString | null;
      publishEndAt?: ZonedDateTimeString | null;
      createdAt: ZonedDateTimeString;
      updatedAt: ZonedDateTimeString;
      localizedTitle: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
      };
      image: { __typename: "UploadedFile"; url: string };
      sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
    } & {
      " $fragmentRefs"?: {
        ActivityProgramSheet_SiteActivityProgramFragment: ActivityProgramSheet_SiteActivityProgramFragment;
      };
    }
  >;
};

export type ActivityProgramSheet_SiteActivityProgramFragment = {
  __typename: "SiteActivityProgram";
  id: string;
  externalUrl: string;
  publishStartAt?: ZonedDateTimeString | null;
  publishEndAt?: ZonedDateTimeString | null;
  updatedAt: ZonedDateTimeString;
  localizedTitle: {
    __typename: "InternalLocalizedString";
    ja?: string | null;
    en?: string | null;
    zhCn?: string | null;
    zhTw?: string | null;
  };
  localizedDescription: {
    __typename: "InternalLocalizedString";
    ja?: string | null;
    en?: string | null;
    zhCn?: string | null;
    zhTw?: string | null;
  };
  image: { __typename: "UploadedFile"; rawUrl: string; url: string };
  sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
} & { " $fragmentName"?: "ActivityProgramSheet_SiteActivityProgramFragment" };

export type AdminActivityProgramSiteOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminActivityProgramSiteOptionsQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
};

export type AdminCreateActivityProgramMutationVariables = Exact<{
  input: InternalCreateSiteActivityProgramInput;
}>;

export type AdminCreateActivityProgramMutation = {
  __typename: "Mutation";
  internalCreateSiteActivityProgram:
    | {
        __typename: "InternalCreateOrUpdateSiteActivityProgramError";
        case: InternalCreateOrUpdateSiteActivityProgramErrorCase;
        message: string;
      }
    | ({ __typename: "SiteActivityProgram"; id: string } & {
        " $fragmentRefs"?: {
          ActivityProgramSheet_SiteActivityProgramFragment: ActivityProgramSheet_SiteActivityProgramFragment;
        };
      });
};

export type AdminUpdateActivityProgramMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteActivityProgramInput;
}>;

export type AdminUpdateActivityProgramMutation = {
  __typename: "Mutation";
  internalUpdateSiteActivityProgram:
    | {
        __typename: "InternalCreateOrUpdateSiteActivityProgramError";
        case: InternalCreateOrUpdateSiteActivityProgramErrorCase;
        message: string;
      }
    | ({ __typename: "SiteActivityProgram"; id: string } & {
        " $fragmentRefs"?: {
          ActivityProgramSheet_SiteActivityProgramFragment: ActivityProgramSheet_SiteActivityProgramFragment;
        };
      });
};

export type AdminDeleteActivityProgramMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteActivityProgramMutation = {
  __typename: "Mutation";
  internalDeleteSiteActivityProgram: { __typename: "Success"; _: boolean };
};

export type AdminCreateActivityProgramImageUploadPolicyMutationVariables =
  Exact<{ [key: string]: never }>;

export type AdminCreateActivityProgramImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateSiteActivityProgramImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminAdditionalGuestFeePolicyDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAdditionalGuestFeePolicyDetailQuery = {
  __typename: "Query";
  internalAdditionalGuestFeePolicyById?: {
    __typename: "AdditionalGuestFeePolicy";
    id: string;
    internalName: string;
    adultPrices: Array<number>;
    kidsPrices: Array<number>;
    createdAt: DateTimeString;
    updatedAt: DateTimeString;
  } | null;
  internalStayTicketMasters: Array<{
    __typename: "StayTicketMaster";
    id: string;
    name: string;
    internalDescription: string;
    isArchived: boolean;
    additionalGuestFeePolicy?: {
      __typename: "AdditionalGuestFeePolicy";
      id: string;
    } | null;
  }>;
};

export type AdminAdditionalGuestFeePoliciesContentQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAdditionalGuestFeePoliciesContentQuery = {
  __typename: "Query";
  internalAdditionalGuestFeePolicies: Array<{
    __typename: "AdditionalGuestFeePolicy";
    id: string;
    internalName: string;
    adultPrices: Array<number>;
    kidsPrices: Array<number>;
    createdAt: DateTimeString;
    updatedAt: DateTimeString;
  }>;
};

export type AdminCreateOrUpdateAdditionalGuestFeePolicyMutationVariables =
  Exact<{
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateAdditionalGuestFeePolicyInput;
  }>;

export type AdminCreateOrUpdateAdditionalGuestFeePolicyMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAdditionalGuestFeePolicy:
    | {
        __typename: "AdditionalGuestFeePolicy";
        id: string;
        internalName: string;
        adultPrices: Array<number>;
        kidsPrices: Array<number>;
      }
    | {
        __typename: "InternalCreateOrUpdateAdditionalGuestFeePolicyError";
        case: InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase;
        message: string;
      };
};

export type AdminAdditionalGuestFeePoliciesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAdditionalGuestFeePoliciesQuery = {
  __typename: "Query";
  internalAdditionalGuestFeePolicies: Array<{
    __typename: "AdditionalGuestFeePolicy";
    id: string;
    internalName: string;
    adultPrices: Array<number>;
    kidsPrices: Array<number>;
    createdAt: DateTimeString;
    updatedAt: DateTimeString;
  }>;
};

export type AdminAdminRoleAssignmentsQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
  role?: InputMaybe<AdminRole>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminAdminRoleAssignmentsQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
  internalAdminRoleAssignments: Array<
    { __typename: "AdminRoleAssignment" } & {
      " $fragmentRefs"?: {
        AdminRoleAssignmentsTable_AdminRoleAssignmentFragment: AdminRoleAssignmentsTable_AdminRoleAssignmentFragment;
      };
    }
  >;
};

export type AdminAdminRoleAssignmentSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAdminRoleAssignmentSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
    }>;
  }>;
};

export type AdminAdminRoleAssignmentFilterUserQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminAdminRoleAssignmentFilterUserQuery = {
  __typename: "Query";
  internalUser: { __typename: "User"; id: string; name: string; email: string };
};

export type AdminRevokeAdminRoleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminRevokeAdminRoleMutation = {
  __typename: "Mutation";
  internalRevokeAdminRole:
    | {
        __typename: "AdminRoleAssignment";
        id: string;
        revokedAt?: ZonedDateTimeString | null;
        revokedByUser?: {
          __typename: "User";
          id: string;
          name: string;
          email: string;
        } | null;
      }
    | {
        __typename: "InternalRevokeAdminRoleError";
        code: InternalRevokeAdminRoleErrorCode;
        message: string;
      };
};

export type AdminRoleAssignmentsTable_AdminRoleAssignmentFragment = {
  __typename: "AdminRoleAssignment";
  id: string;
  role: AdminRole;
  grantedAt: ZonedDateTimeString;
  expiresAt?: ZonedDateTimeString | null;
  revokedAt?: ZonedDateTimeString | null;
  assignee: {
    __typename: "InternalAdminRoleAssignee";
    id: string;
    name: string;
    email: string;
  };
  site?: { __typename: "Site"; id: string; name: string } | null;
  grantedByUser?: {
    __typename: "User";
    id: string;
    name: string;
    email: string;
  } | null;
  revokedByUser?: {
    __typename: "User";
    id: string;
    name: string;
    email: string;
  } | null;
} & {
  " $fragmentName"?: "AdminRoleAssignmentsTable_AdminRoleAssignmentFragment";
};

export type AdminGrantableAdminRolesQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminGrantableAdminRolesQuery = {
  __typename: "Query";
  internalGrantableAdminRoles: Array<{
    __typename: "InternalGrantableAdminRole";
    role: AdminRole;
    scope?: ScopeDimension | null;
  }>;
};

export type AdminAssignAdminRoleMutationVariables = Exact<{
  input: InternalAssignAdminRoleInput;
}>;

export type AdminAssignAdminRoleMutation = {
  __typename: "Mutation";
  internalAssignAdminRole:
    | { __typename: "AdminRoleAssignment"; id: string }
    | {
        __typename: "InternalAssignAdminRoleError";
        code: InternalAssignAdminRoleErrorCode;
        message: string;
      };
};

export type AdminAdminRoleUserCandidatesQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  excludeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AdminAdminRoleUserCandidatesQuery = {
  __typename: "Query";
  internalUsersSearch: {
    __typename: "InternalUserSearchResult";
    totalCount: number;
    users: Array<{
      __typename: "User";
      id: string;
      name: string;
      email: string;
    }>;
  };
};

export type AdminCreateOrUpdateContentArchitectMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentArchitectInput;
}>;

export type AdminCreateOrUpdateContentArchitectMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitect:
    | {
        __typename: "ContentArchitect";
        id: string;
        name: string;
        nameEn: string;
        company: string;
        bio: string;
        architectureTypes: Array<{
          __typename: "ArchitectureType";
          id: string;
          name: string;
        }>;
        imageUrl: { __typename: "UploadedFile"; rawUrl: string; url: string };
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminContentArchitectsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminContentArchitectsQuery = {
  __typename: "Query";
  internalContentArchitects: Array<{
    __typename: "ContentArchitect";
    id: string;
    name: string;
    nameEn: string;
    company: string;
    bio: string;
    architectureTypes: Array<{
      __typename: "ArchitectureType";
      id: string;
      name: string;
    }>;
    imageUrl: { __typename: "UploadedFile"; rawUrl: string; url: string };
  }>;
};

export type AdminDeleteContentArchitectMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteContentArchitectMutation = {
  __typename: "Mutation";
  internalDeleteContentArchitect:
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      }
    | { __typename: "Success" };
};

export type AdminArchitectureTypeBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminArchitectureTypeBasicInfoQuery = {
  __typename: "Query";
  internalArchitectureType: { __typename: "ArchitectureType" } & {
    " $fragmentRefs"?: {
      ArchitectureTypeBasicInfoFragment: ArchitectureTypeBasicInfoFragment;
    };
  };
};

export type ArchitectureTypeBasicInfoFragment = ({
  __typename: "ArchitectureType";
  id: string;
  name: string;
  slug: string;
  seriesName: string;
  seriesShortName: string;
  series: ArchitectureTypeSeries;
  size?: ArchitectureTypeSize | null;
  capacity: number;
  additionalFee: number;
  published: boolean;
  accommodations: Array<{
    __typename: "Accommodation";
    id: string;
    name: string;
    code: string;
    site: { __typename: "Site"; id: string; name: string };
  }>;
} & {
  " $fragmentRefs"?: {
    ArchitectureTypeEditSheetFragment: ArchitectureTypeEditSheetFragment;
  };
}) & { " $fragmentName"?: "ArchitectureTypeBasicInfoFragment" };

export type AdminArchitectureTypeContentEditSheetOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminArchitectureTypeContentEditSheetOptionsQuery = {
  __typename: "Query";
  internalContentArchitects: Array<{
    __typename: "ContentArchitect";
    id: string;
    name: string;
  }>;
  internalContentArchitectureTypeBasicAmenities: Array<{
    __typename: "ContentArchitectureTypeBasicAmenity";
    id: string;
    name: string;
  }>;
};

export type AdminUpdateContentArchitectureTypeMutationVariables = Exact<{
  architectureTypeId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitectureTypeInput;
}>;

export type AdminUpdateContentArchitectureTypeMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitectureType:
    | {
        __typename: "ContentArchitectureType";
        id: string;
        description: string;
        capacityDescription: string;
        sizeDescription: string;
        sizeSqm: number;
        architectComment: string;
        customEmailCoverImageUrl?: string | null;
        equipmentsListUrl?: string | null;
        amenitiesInstructionsUrl?: string | null;
        architect: { __typename: "ContentArchitect"; id: string; name: string };
        basicAmenities: Array<{
          __typename: "ContentArchitectureTypeBasicAmenity";
          id: string;
          name: string;
          iconUrl?: { __typename: "UploadedFile"; url: string } | null;
        }>;
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminArchitectureTypeContentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminArchitectureTypeContentQuery = {
  __typename: "Query";
  internalArchitectureType: { __typename: "ArchitectureType" } & {
    " $fragmentRefs"?: {
      ArchitectureTypeContentTabFragment: ArchitectureTypeContentTabFragment;
    };
  };
};

export type ArchitectureTypeContentTabFragment = {
  __typename: "ArchitectureType";
  id: string;
  name: string;
  internalContent?: {
    __typename: "ContentArchitectureType";
    id: string;
    customEmailCoverImageUrl?: string | null;
    description: string;
    capacityDescription: string;
    sizeDescription: string;
    sizeSqm: number;
    architectComment: string;
    equipmentsListUrl?: string | null;
    amenitiesInstructionsUrl?: string | null;
    architect: { __typename: "ContentArchitect"; id: string; name: string };
    thumbnailImageUrl?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
    imageUrls: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    }>;
    basicAmenities: Array<{
      __typename: "ContentArchitectureTypeBasicAmenity";
      id: string;
      name: string;
      iconUrl?: { __typename: "UploadedFile"; url: string } | null;
    }>;
    floorPlanImageUrl?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
  } | null;
} & { " $fragmentName"?: "ArchitectureTypeContentTabFragment" };

export type AdminUpdateContentArchitectureTypeImagesMutationVariables = Exact<{
  architectureTypeId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitectureTypeInput;
}>;

export type AdminUpdateContentArchitectureTypeImagesMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitectureType:
    | {
        __typename: "ContentArchitectureType";
        id: string;
        thumbnailImageUrl?: {
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        } | null;
        imageUrls: Array<{
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        }>;
        floorPlanImageUrl?: {
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        } | null;
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminArchitectureTypeHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminArchitectureTypeHeaderQuery = {
  __typename: "Query";
  internalArchitectureType: { __typename: "ArchitectureType" } & {
    " $fragmentRefs"?: {
      ArchitectureTypeHeaderFragment: ArchitectureTypeHeaderFragment;
    };
  };
};

export type ArchitectureTypeEditSheetFragment = {
  __typename: "ArchitectureType";
  id: string;
  slug: string;
  series: ArchitectureTypeSeries;
  size?: ArchitectureTypeSize | null;
  capacity: number;
  additionalFee: number;
  published: boolean;
} & { " $fragmentName"?: "ArchitectureTypeEditSheetFragment" };

export type AdminUpdateArchitectureTypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateArchitectureTypeInput;
}>;

export type AdminUpdateArchitectureTypeMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateArchitectureType: {
    __typename: "ArchitectureType";
    id: string;
    name: string;
    slug: string;
    seriesShortName: string;
    series: ArchitectureTypeSeries;
    size?: ArchitectureTypeSize | null;
    capacity: number;
    additionalFee: number;
    published: boolean;
  };
};

export type ArchitectureTypeHeaderFragment = {
  __typename: "ArchitectureType";
  id: string;
  name: string;
  slug: string;
  published: boolean;
  series: ArchitectureTypeSeries;
  internalContent?: {
    __typename: "ContentArchitectureType";
    id: string;
  } | null;
} & { " $fragmentName"?: "ArchitectureTypeHeaderFragment" };

export type AdminArchitectureTypeVariantEditSheetOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminArchitectureTypeVariantEditSheetOptionsQuery = {
  __typename: "Query";
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    type: AccommodationFacilityType;
    slug: string;
  }>;
  internalContentFacilityAmenities: Array<{
    __typename: "ContentArchitectureTypeVariantFacilityAmenity";
    id: string;
    name: string;
    accommodationFacility: {
      __typename: "AccommodationFacility";
      id: string;
      type: AccommodationFacilityType;
      slug: string;
    };
  }>;
};

export type AdminCreateOrUpdateContentArchitectureTypeVariantMutationVariables =
  Exact<{
    id?: InputMaybe<Scalars["ID"]["input"]>;
    architectureTypeId: Scalars["ID"]["input"];
    kind: ContentArchitectureTypeVariantKind;
    input: InternalCreateOrUpdateContentArchitectureTypeVariantInput;
  }>;

export type AdminCreateOrUpdateContentArchitectureTypeVariantMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitectureTypeVariant:
    | { __typename: "ContentArchitectureTypeVariant" }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminArchitectureTypeVariantsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminArchitectureTypeVariantsQuery = {
  __typename: "Query";
  internalArchitectureType: { __typename: "ArchitectureType" } & {
    " $fragmentRefs"?: {
      ArchitectureTypeVariantsTabFragment: ArchitectureTypeVariantsTabFragment;
    };
  };
};

export type ArchitectureTypeVariantsTabFragment = {
  __typename: "ArchitectureType";
  id: string;
  internalContent?: {
    __typename: "ContentArchitectureType";
    id: string;
    variations: Array<
      { __typename: "ContentArchitectureTypeVariant" } & {
        " $fragmentRefs"?: {
          ArchitectureTypeVariantCardFragment: ArchitectureTypeVariantCardFragment;
        };
      }
    >;
    options: Array<
      { __typename: "ContentArchitectureTypeVariant" } & {
        " $fragmentRefs"?: {
          ArchitectureTypeVariantCardFragment: ArchitectureTypeVariantCardFragment;
        };
      }
    >;
  } | null;
} & { " $fragmentName"?: "ArchitectureTypeVariantsTabFragment" };

export type ArchitectureTypeVariantCardFragment = {
  __typename: "ContentArchitectureTypeVariant";
  id: string;
  slug: string;
  name: string;
  brief: string;
  description: string;
  imageUrls: Array<{
    __typename: "UploadedFile";
    rawUrl: string;
    url: string;
    caption?: string | null;
  }>;
  accommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    slug: string;
    type: AccommodationFacilityType;
  }>;
  facilityDetails: {
    __typename: "ContentFacilityDetails";
    usageFeesDescriptionMarkup: string;
    usageConditionsDescription: string;
    facilityAmenities: Array<{
      __typename: "ContentArchitectureTypeVariantFacilityAmenity";
      id: string;
      name: string;
    }>;
  };
} & { " $fragmentName"?: "ArchitectureTypeVariantCardFragment" };

export type AdminDeleteContentArchitectureTypeVariantMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  kind: ContentArchitectureTypeVariantKind;
}>;

export type AdminDeleteContentArchitectureTypeVariantMutation = {
  __typename: "Mutation";
  internalDeleteContentArchitectureTypeVariant:
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      }
    | { __typename: "Success" };
};

export type AdminCreateArchitectureTypeContentOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCreateArchitectureTypeContentOptionsQuery = {
  __typename: "Query";
  internalContentArchitects: Array<{
    __typename: "ContentArchitect";
    id: string;
    name: string;
  }>;
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    internalContent?: {
      __typename: "ContentArchitectureType";
      id: string;
      sort: number;
    } | null;
  }>;
};

export type AdminCreateContentArchitectureTypeMutationVariables = Exact<{
  architectureTypeId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitectureTypeInput;
}>;

export type AdminCreateContentArchitectureTypeMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitectureType:
    | { __typename: "ContentArchitectureType"; id: string; sort: number }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminArchitectureTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminArchitectureTypesQuery = {
  __typename: "Query";
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
    slug: string;
    seriesShortName: string;
    series: ArchitectureTypeSeries;
    size?: ArchitectureTypeSize | null;
    capacity: number;
    additionalFee: number;
    published: boolean;
    accommodationsCount: number;
    internalContent?: {
      __typename: "ContentArchitectureType";
      id: string;
      sort: number;
    } | null;
  }>;
};

export type AdminReorderContentArchitectureTypesMutationVariables = Exact<{
  input:
    | Array<InternalReorderArchitectureContentInput>
    | InternalReorderArchitectureContentInput;
}>;

export type AdminReorderContentArchitectureTypesMutation = {
  __typename: "Mutation";
  internalReorderContentArchitectureTypes: Array<{
    __typename: "ContentArchitectureType";
    id: string;
    sort: number;
  }>;
};

export type AdminCreateArchitectureTypeMutationVariables = Exact<{
  input: InternalCreateOrUpdateArchitectureTypeInput;
}>;

export type AdminCreateArchitectureTypeMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateArchitectureType: {
    __typename: "ArchitectureType";
    id: string;
    name: string;
    slug: string;
  };
};

export type AdminAreaGuideArticleAreaOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAreaGuideArticleAreaOptionsQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
  }>;
};

export type AdminCreateOrUpdateAreaGuideArticleMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAreaGuideArticleInput;
}>;

export type AdminCreateOrUpdateAreaGuideArticleMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAreaGuideArticle: {
    __typename: "AreaGuideArticle";
    id: string;
    title: string;
    url: string;
    publishedDate: PlainDateString;
    sort: number;
    thumbnail?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
    areas: Array<{ __typename: "InternalArea"; id: string; name: string }>;
  };
};

export type AdminAreaGuideArticlesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAreaGuideArticlesQuery = {
  __typename: "Query";
  internalAreaGuideArticles: Array<{
    __typename: "AreaGuideArticle";
    id: string;
    title: string;
    url: string;
    publishedDate: PlainDateString;
    sort: number;
    thumbnail?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
    areas: Array<{ __typename: "InternalArea"; id: string; name: string }>;
  }>;
};

export type AdminDeleteAreaGuideArticleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteAreaGuideArticleMutation = {
  __typename: "Mutation";
  internalDeleteAreaGuideArticle: boolean;
};

export type AdminReorderAreaGuideArticlesMutationVariables = Exact<{
  input: Array<InternalReorderInput> | InternalReorderInput;
}>;

export type AdminReorderAreaGuideArticlesMutation = {
  __typename: "Mutation";
  internalReorderAreaGuideArticles: Array<{
    __typename: "AreaGuideArticle";
    id: string;
    sort: number;
  }>;
};

export type AdminCreateAreaGuideArticleImageUploadPolicyMutationVariables =
  Exact<{ [key: string]: never }>;

export type AdminCreateAreaGuideArticleImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateAreaGuideArticleImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminAreaBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAreaBasicInfoQuery = {
  __typename: "Query";
  internalArea: { __typename: "InternalArea" } & {
    " $fragmentRefs"?: { AreaBasicInfoFragment: AreaBasicInfoFragment };
  };
};

export type AreaBasicInfoFragment = ({
  __typename: "InternalArea";
  id: string;
  name: string;
  slug: string;
  sites: Array<{
    __typename: "InternalSite";
    id: string;
    name: string;
    slug: string;
    ordinalName?: string | null;
    openingDate: PlainDateString;
    published: boolean;
    reservable: boolean;
    reservableForOwnerEarlyAccess: boolean;
  }>;
} & { " $fragmentRefs"?: { AreaEditSheetFragment: AreaEditSheetFragment } }) & {
  " $fragmentName"?: "AreaBasicInfoFragment";
};

export type AreaContentEditSheetFragment = {
  __typename: "InternalArea";
  id: string;
  content: {
    __typename: "AreaContent";
    allCapsName?: string | null;
    reservationFormCoverImageUrl?: string | null;
    roadConditionLiveCameraUrl?: string | null;
    shortAddress?: string | null;
    catchCopy?: string | null;
    description?: string | null;
    accessFromTokyoDescription?: string | null;
    guideSpotTipsTitle?: string | null;
    guideSpotTips?: string | null;
    guideSpotMapListUrl?: string | null;
  };
} & { " $fragmentName"?: "AreaContentEditSheetFragment" };

export type AdminUpdateAreaContentMutationVariables = Exact<{
  areaId: Scalars["ID"]["input"];
  input: InternalUpdateAreaContentInput;
}>;

export type AdminUpdateAreaContentMutation = {
  __typename: "Mutation";
  internalUpdateAreaContent: {
    __typename: "InternalArea";
    id: string;
    content: {
      __typename: "AreaContent";
      allCapsName?: string | null;
      reservationFormCoverImageUrl?: string | null;
      roadConditionLiveCameraUrl?: string | null;
      shortAddress?: string | null;
      catchCopy?: string | null;
      description?: string | null;
      accessFromTokyoDescription?: string | null;
      guideSpotTipsTitle?: string | null;
      guideSpotTips?: string | null;
      guideSpotMapListUrl?: string | null;
    };
  };
};

export type AdminAreaContentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAreaContentQuery = {
  __typename: "Query";
  internalArea: { __typename: "InternalArea" } & {
    " $fragmentRefs"?: { AreaContentTabFragment: AreaContentTabFragment };
  };
};

export type AdminUpdateAreaReservationFormCoverImageMutationVariables = Exact<{
  areaId: Scalars["ID"]["input"];
  input: InternalUpdateAreaContentInput;
}>;

export type AdminUpdateAreaReservationFormCoverImageMutation = {
  __typename: "Mutation";
  internalUpdateAreaContent: {
    __typename: "InternalArea";
    id: string;
    content: {
      __typename: "AreaContent";
      reservationFormCoverImageUrl?: string | null;
    };
  };
};

export type AdminReplaceAreaHeroImagesMutationVariables = Exact<{
  areaId: Scalars["ID"]["input"];
  input: InternalUpdateAreaContentInput;
}>;

export type AdminReplaceAreaHeroImagesMutation = {
  __typename: "Mutation";
  internalUpdateAreaContent: {
    __typename: "InternalArea";
    id: string;
    content: {
      __typename: "AreaContent";
      heroImages: Array<{
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
        caption?: string | null;
      }>;
    };
  };
};

export type AreaContentTabFragment = ({
  __typename: "InternalArea";
  id: string;
  name: string;
  content: {
    __typename: "AreaContent";
    allCapsName?: string | null;
    reservationFormCoverImageUrl?: string | null;
    roadConditionLiveCameraUrl?: string | null;
    shortAddress?: string | null;
    catchCopy?: string | null;
    description?: string | null;
    accessFromTokyoDescription?: string | null;
    guideSpotTipsTitle?: string | null;
    guideSpotTips?: string | null;
    guideSpotMapListUrl?: string | null;
    updatedAt: ZonedDateTimeString;
    heroImages: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
      caption?: string | null;
    }>;
  };
} & {
  " $fragmentRefs"?: {
    AreaContentEditSheetFragment: AreaContentEditSheetFragment;
  };
}) & { " $fragmentName"?: "AreaContentTabFragment" };

export type AdminAreaDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAreaDetailQuery = {
  __typename: "Query";
  internalArea: { __typename: "InternalArea" } & {
    " $fragmentRefs"?: {
      AreaHeaderFragment: AreaHeaderFragment;
      AreaBasicInfoFragment: AreaBasicInfoFragment;
      AreaContentTabFragment: AreaContentTabFragment;
    };
  };
};

export type AdminAreaHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAreaHeaderQuery = {
  __typename: "Query";
  internalArea: { __typename: "InternalArea" } & {
    " $fragmentRefs"?: { AreaHeaderFragment: AreaHeaderFragment };
  };
};

export type AreaEditSheetFragment = {
  __typename: "InternalArea";
  id: string;
  name: string;
  slug: string;
  localizedName: {
    __typename: "InternalLocalizedString";
    ja?: string | null;
    en?: string | null;
    zhCn?: string | null;
    zhTw?: string | null;
  };
} & { " $fragmentName"?: "AreaEditSheetFragment" };

export type AdminUpdateAreaMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateAreaInput;
}>;

export type AdminUpdateAreaMutation = {
  __typename: "Mutation";
  internalUpdateArea:
    | {
        __typename: "InternalArea";
        id: string;
        name: string;
        slug: string;
        localizedName: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        };
      }
    | {
        __typename: "InternalUpdateAreaError";
        case: InternalUpdateAreaErrorCase;
        message: string;
      };
};

export type AdminAreaGuideSpotsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminAreaGuideSpotsQuery = {
  __typename: "Query";
  internalArea: {
    __typename: "InternalArea";
    id: string;
    slug: string;
    guideSpots: Array<{
      __typename: "AreaGuideSpot";
      id: string;
      name: string;
      categories: Array<AreaGuideSpotCategory>;
      tags: Array<string>;
      description?: string | null;
      businessHours?: string | null;
      websiteUrl?: string | null;
      mapUrl?: string | null;
      sort: number;
      publishStartDate?: PlainDateString | null;
      publishEndDate?: PlainDateString | null;
      publishedNow: boolean;
      images: Array<{
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      }>;
    }>;
  };
};

export type AdminCreateOrUpdateAreaGuideSpotMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAreaGuideSpotInput;
}>;

export type AdminCreateOrUpdateAreaGuideSpotMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateAreaGuideSpot: {
    __typename: "AreaGuideSpot";
    id: string;
    name: string;
    categories: Array<AreaGuideSpotCategory>;
    tags: Array<string>;
    description?: string | null;
    businessHours?: string | null;
    websiteUrl?: string | null;
    mapUrl?: string | null;
    sort: number;
    publishStartDate?: PlainDateString | null;
    publishEndDate?: PlainDateString | null;
    publishedNow: boolean;
    images: Array<{ __typename: "UploadedFile"; rawUrl: string; url: string }>;
  };
};

export type AdminDeleteAreaGuideSpotMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteAreaGuideSpotMutation = {
  __typename: "Mutation";
  internalDeleteAreaGuideSpot: boolean;
};

export type AdminReorderAreaGuideSpotsMutationVariables = Exact<{
  input: Array<InternalReorderInput> | InternalReorderInput;
}>;

export type AdminReorderAreaGuideSpotsMutation = {
  __typename: "Mutation";
  internalReorderAreaGuideSpots: Array<{
    __typename: "AreaGuideSpot";
    id: string;
    sort: number;
  }>;
};

export type AreaHeaderFragment = {
  __typename: "InternalArea";
  id: string;
  name: string;
  slug: string;
} & { " $fragmentName"?: "AreaHeaderFragment" };

export type AdminCreateAreaImageUploadPolicyMutationVariables = Exact<{
  input: InternalCreateAreaImageUploadPolicyInput;
}>;

export type AdminCreateAreaImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateAreaImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminAreasQueryVariables = Exact<{ [key: string]: never }>;

export type AdminAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    slug: string;
    name: string;
    sort: number;
    sites: Array<{ __typename: "InternalSite"; id: string }>;
    content: {
      __typename: "AreaContent";
      allCapsName?: string | null;
      roadConditionLiveCameraUrl?: string | null;
    };
  }>;
};

export type AdminReorderAreasMutationVariables = Exact<{
  input: Array<InternalReorderAreaInput> | InternalReorderAreaInput;
}>;

export type AdminReorderAreasMutation = {
  __typename: "Mutation";
  internalReorderAreas: Array<{ __typename: "Area"; id: string; sort: number }>;
};

export type AdminCreateAreaMutationVariables = Exact<{
  input: InternalCreateAreaInput;
}>;

export type AdminCreateAreaMutation = {
  __typename: "Mutation";
  internalCreateArea: {
    __typename: "InternalArea";
    id: string;
    name: string;
    slug: string;
    sort: number;
  };
};

export type AdminBeds24DeleteBlackBookingsTargetCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBeds24DeleteBlackBookingsTargetCountQuery = {
  __typename: "Query";
  internalBeds24DeleteBlackBookingsTargetCount: number;
};

export type AdminEnqueueBeds24DeleteBlackBookingsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AdminEnqueueBeds24DeleteBlackBookingsMutation = {
  __typename: "Mutation";
  internalEnqueueBeds24DeleteBlackBookings: boolean;
};

export type AdminAvailabilityBlocksQueryVariables = Exact<{
  startBeginNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endBeginNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
}>;

export type AdminAvailabilityBlocksQuery = {
  __typename: "Query";
  accommodationAvailabilityBlocks: Array<{
    __typename: "AccommodationAvailabilityBlock";
    id: string;
    beginNight: PlainDateString;
    endNight: PlainDateString;
    name: string;
    category: AccommodationAvailabilityBlockCategory;
    isTentative: boolean;
    note: string;
    createdAt: ZonedDateTimeString;
    categoryInfo: {
      __typename: "AccommodationAvailabilityBlockCategoryInfo";
      label: string;
      categoryGroup: string;
    };
    site: { __typename: "Site"; id: string; name: string; slug: string };
    accommodation?: {
      __typename: "Accommodation";
      id: string;
      code: string;
    } | null;
    staffGroup?: { __typename: "StaffGroup"; id: string; name: string } | null;
    createdByUser?: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    } | null;
  }>;
};

export type AdminAvailabilityBlockFilterMastersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAvailabilityBlockFilterMastersQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      slug: string;
      accommodations: Array<{
        __typename: "Accommodation";
        id: string;
        code: string;
        name: string;
      }>;
    }>;
  }>;
  accommodationAvailabilityBlockCategoryInfos: Array<{
    __typename: "AccommodationAvailabilityBlockCategoryInfo";
    key: AccommodationAvailabilityBlockCategory;
    label: string;
    note: string;
    categoryGroup: string;
  }>;
  staffGroups: Array<{
    __typename: "StaffGroup";
    id: string;
    name: string;
    fullName?: string | null;
    status: StaffGroupStatus;
  }>;
};

export type AdminAvailabilityBlockViewerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAvailabilityBlockViewerQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
};

export type AdminCreateAvailabilityBlockMutationVariables = Exact<{
  input: CreateAccommodationAvailabilityBlockInput;
}>;

export type AdminCreateAvailabilityBlockMutation = {
  __typename: "Mutation";
  createAccommodationAvailabilityBlock: boolean;
};

export type AdminChangeAvailabilityBlockMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: ChangeAccommodationAvailabilityBlockInput;
}>;

export type AdminChangeAvailabilityBlockMutation = {
  __typename: "Mutation";
  changeAccommodationAvailabilityBlock: boolean;
};

export type AdminBulkDeleteAvailabilityBlocksMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AdminBulkDeleteAvailabilityBlocksMutation = {
  __typename: "Mutation";
  internalBulkDeleteAccommodationAvailabilityBlocks: {
    __typename: "InternalBulkDeleteAccommodationAvailabilityBlocksPayload";
    successIds: Array<string>;
    failed: Array<{
      __typename: "InternalBulkDeleteAccommodationAvailabilityBlockFailure";
      id: string;
      reason: string;
    }>;
  };
};

export type AdminDeleteAvailabilityBlockMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteAvailabilityBlockMutation = {
  __typename: "Mutation";
  deleteAccommodationAvailabilityBlock?: boolean | null;
};

export type AdminBaseFeePolicyDetailQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBaseFeePolicyDetailQuery = {
  __typename: "Query";
  internalBaseAccommodationFeePolicies: Array<{
    __typename: "RawBaseAccommodationFeePolicy";
    id: string;
    internalName: string;
    dailyFeePolicy: Array<number>;
    feeModifier?: number | null;
    feeModifierType?: FeeModifierType | null;
    isThirdPartyCovered: boolean;
    thirdPartyCoveredDailyFeePolicy: Array<number>;
    feeRules: Array<{
      __typename: "AccommodationFeeRule";
      id: string;
      ruleType: AccommodationFeeRuleType;
      night: number;
      feeModifierType: FeeModifierType;
      feeModifier: number;
    }>;
  }>;
  internalStayTicketMasters: Array<{
    __typename: "StayTicketMaster";
    id: string;
    name: string;
    isArchived: boolean;
    rawBaseAccommodationFeePolicy: {
      __typename: "RawBaseAccommodationFeePolicy";
      id: string;
    };
  }>;
};

export type AdminBaseFeePoliciesContentQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBaseFeePoliciesContentQuery = {
  __typename: "Query";
  internalBaseAccommodationFeePolicies: Array<{
    __typename: "RawBaseAccommodationFeePolicy";
    id: string;
    internalName: string;
    dailyFeePolicy: Array<number>;
    feeModifier?: number | null;
    feeModifierType?: FeeModifierType | null;
    isThirdPartyCovered: boolean;
    thirdPartyCoveredDailyFeePolicy: Array<number>;
  }>;
};

export type AdminCreateOrUpdateBaseFeePolicyMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateBaseAccommodationFeePolicyInput;
}>;

export type AdminCreateOrUpdateBaseFeePolicyMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateBaseAccommodationFeePolicy:
    | {
        __typename: "InternalCreateOrUpdateBaseAccommodationFeePolicyError";
        case: InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase;
        message: string;
      }
    | {
        __typename: "RawBaseAccommodationFeePolicy";
        id: string;
        internalName: string;
        dailyFeePolicy: Array<number>;
        feeModifier?: number | null;
        feeModifierType?: FeeModifierType | null;
        isThirdPartyCovered: boolean;
        thirdPartyCoveredDailyFeePolicy: Array<number>;
        feeRules: Array<{
          __typename: "AccommodationFeeRule";
          id: string;
          ruleType: AccommodationFeeRuleType;
          night: number;
          feeModifierType: FeeModifierType;
          feeModifier: number;
        }>;
      };
};

export type AdminBaseFeePoliciesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBaseFeePoliciesQuery = {
  __typename: "Query";
  internalBaseAccommodationFeePolicies: Array<{
    __typename: "RawBaseAccommodationFeePolicy";
    id: string;
    internalName: string;
    dailyFeePolicy: Array<number>;
    feeModifier?: number | null;
    feeModifierType?: FeeModifierType | null;
    isThirdPartyCovered: boolean;
    thirdPartyCoveredDailyFeePolicy: Array<number>;
  }>;
};

export type AdminContentBasicAmenitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminContentBasicAmenitiesQuery = {
  __typename: "Query";
  internalContentArchitectureTypeBasicAmenities: Array<{
    __typename: "ContentArchitectureTypeBasicAmenity";
    id: string;
    name: string;
    sort: number;
    architectureTypes: Array<{
      __typename: "ArchitectureType";
      id: string;
      name: string;
    }>;
    iconUrl?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
  }>;
};

export type AdminDeleteContentBasicAmenityMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteContentBasicAmenityMutation = {
  __typename: "Mutation";
  internalDeleteContentArchitectureTypeBasicAmenity:
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      }
    | { __typename: "Success" };
};

export type AdminReorderContentBasicAmenitiesMutationVariables = Exact<{
  input:
    | Array<InternalReorderArchitectureContentInput>
    | InternalReorderArchitectureContentInput;
}>;

export type AdminReorderContentBasicAmenitiesMutation = {
  __typename: "Mutation";
  internalReorderContentArchitectureTypeBasicAmenities: Array<{
    __typename: "ContentArchitectureTypeBasicAmenity";
    id: string;
    sort: number;
  }>;
};

export type AdminCreateOrUpdateContentBasicAmenityMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput;
}>;

export type AdminCreateOrUpdateContentBasicAmenityMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateContentArchitectureTypeBasicAmenity:
    | {
        __typename: "ContentArchitectureTypeBasicAmenity";
        id: string;
        name: string;
        sort: number;
        architectureTypes: Array<{
          __typename: "ArchitectureType";
          id: string;
          name: string;
        }>;
        iconUrl?: {
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        } | null;
      }
    | {
        __typename: "InternalArchitectureContentError";
        case: InternalArchitectureContentErrorCase;
        message: string;
      };
};

export type AdminBeds24TokenStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBeds24TokenStatusQuery = {
  __typename: "Query";
  internalBeds24TokenStatus: string;
};

export type AdminBeds24ExchangeInviteCodeMutationVariables = Exact<{
  inviteCode: Scalars["String"]["input"];
}>;

export type AdminBeds24ExchangeInviteCodeMutation = {
  __typename: "Mutation";
  internalBeds24ExchangeInviteCode: string;
};

export type AdminIpBeds24SetupStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminIpBeds24SetupStatusQuery = {
  __typename: "Query";
  internalIpBeds24SetupStatus?: string | null;
};

export type AdminIpBeds24SetupEstimateQueryVariables = Exact<{
  phases?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminIpBeds24SetupEstimateQuery = {
  __typename: "Query";
  internalIpBeds24SetupEstimate: string;
};

export type AdminStartIpBeds24SetupMutationVariables = Exact<{
  phases?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminStartIpBeds24SetupMutation = {
  __typename: "Mutation";
  internalStartIpBeds24Setup: boolean;
};

export type AdminCancelIpBeds24SetupMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCancelIpBeds24SetupMutation = {
  __typename: "Mutation";
  internalCancelIpBeds24Setup: boolean;
};

export type AdminBlockReleaseSchedulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBlockReleaseSchedulesQuery = {
  __typename: "Query";
  internalAccommodationAvailabilityBlockReleaseSchedules: Array<{
    __typename: "AccommodationAvailabilityBlockReleaseSchedule";
    id: string;
    siteId: string;
    daysBeforeCheckin: number;
    blockRoomCountUpperLimit: number;
  }>;
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
};

export type AdminCreateBlockReleaseScheduleMutationVariables = Exact<{
  input: InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput;
}>;

export type AdminCreateBlockReleaseScheduleMutation = {
  __typename: "Mutation";
  internalCreateAccommodationAvailabilityBlockReleaseSchedule: {
    __typename: "AccommodationAvailabilityBlockReleaseSchedule";
    id: string;
    siteId: string;
    daysBeforeCheckin: number;
    blockRoomCountUpperLimit: number;
  };
};

export type AdminUpdateBlockReleaseScheduleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput;
}>;

export type AdminUpdateBlockReleaseScheduleMutation = {
  __typename: "Mutation";
  internalUpdateAccommodationAvailabilityBlockReleaseSchedule: {
    __typename: "AccommodationAvailabilityBlockReleaseSchedule";
    id: string;
    siteId: string;
    daysBeforeCheckin: number;
    blockRoomCountUpperLimit: number;
  };
};

export type AdminDeleteBlockReleaseScheduleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteBlockReleaseScheduleMutation = {
  __typename: "Mutation";
  internalDeleteAccommodationAvailabilityBlockReleaseSchedule: boolean;
};

export type AdminCreateOrUpdateBusinessPlanMutationVariables = Exact<{
  businessPlanId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateBusinessPlanInput;
}>;

export type AdminCreateOrUpdateBusinessPlanMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateBusinessPlan:
    | {
        __typename: "BusinessPlan";
        id: string;
        name: string;
        feePerNum: number;
        feePerNights: number;
        isPeakDayFeeFree: boolean;
      }
    | {
        __typename: "InternalCreateOrUpdateBusinessPlanError";
        case: InternalCreateOrUpdateBusinessPlanErrorCase;
        message: string;
      };
};

export type AdminBusinessPlansQueryVariables = Exact<{ [key: string]: never }>;

export type AdminBusinessPlansQuery = {
  __typename: "Query";
  internalBusinessPlans: Array<
    { __typename: "BusinessPlan" } & {
      " $fragmentRefs"?: {
        BusinessPlansTable_BusinessPlanFragment: BusinessPlansTable_BusinessPlanFragment;
      };
    }
  >;
};

export type BusinessPlansTable_BusinessPlanFragment = {
  __typename: "BusinessPlan";
  id: string;
  name: string;
  feePerNum: number;
  feePerNights: number;
  isPeakDayFeeFree: boolean;
} & { " $fragmentName"?: "BusinessPlansTable_BusinessPlanFragment" };

export type AdminCancelFeePolicyDetailQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCancelFeePolicyDetailQuery = {
  __typename: "Query";
  internalCancelFeePolicies: Array<{
    __typename: "RawCancelFeePolicy";
    id: string;
    internalName: string;
    internalDescription: string;
    cancelFeePolicy:
      | {
          __typename: "CancelFeeFixedPolicy";
          before1DaysFee: number;
          before3DaysFee: number;
          before7DaysFee: number;
          immediate: boolean;
        }
      | {
          __typename: "CancelFeeRatePolicy";
          before1DaysRate: number;
          before3DaysRate: number;
          before7DaysRate: number;
          immediate: boolean;
        };
  }>;
  internalStayTicketMasters: Array<{
    __typename: "StayTicketMaster";
    id: string;
    name: string;
    internalDescription: string;
    isArchived: boolean;
    rawCancelFeePolicy: { __typename: "RawCancelFeePolicy"; id: string };
  }>;
};

export type AdminCancelFeePoliciesContentQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCancelFeePoliciesContentQuery = {
  __typename: "Query";
  internalCancelFeePolicies: Array<{
    __typename: "RawCancelFeePolicy";
    id: string;
    internalName: string;
    internalDescription: string;
    cancelFeePolicy:
      | {
          __typename: "CancelFeeFixedPolicy";
          before1DaysFee: number;
          before3DaysFee: number;
          before7DaysFee: number;
          immediate: boolean;
        }
      | {
          __typename: "CancelFeeRatePolicy";
          before1DaysRate: number;
          before3DaysRate: number;
          before7DaysRate: number;
          immediate: boolean;
        };
  }>;
};

export type AdminCreateOrUpdateCancelFeePolicyMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateCancelFeePolicyInput;
}>;

export type AdminCreateOrUpdateCancelFeePolicyMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateCancelFeePolicy:
    | {
        __typename: "InternalCreateOrUpdateCancelFeePolicyError";
        case: InternalCreateOrUpdateCancelFeePolicyErrorCase;
        message: string;
      }
    | {
        __typename: "RawCancelFeePolicy";
        id: string;
        internalName: string;
        internalDescription: string;
        cancelFeePolicy:
          | {
              __typename: "CancelFeeFixedPolicy";
              before1DaysFee: number;
              before3DaysFee: number;
              before7DaysFee: number;
              immediate: boolean;
            }
          | {
              __typename: "CancelFeeRatePolicy";
              before1DaysRate: number;
              before3DaysRate: number;
              before7DaysRate: number;
              immediate: boolean;
            };
      };
};

export type AdminCancelFeePoliciesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCancelFeePoliciesQuery = {
  __typename: "Query";
  internalCancelFeePolicies: Array<{
    __typename: "RawCancelFeePolicy";
    id: string;
    internalName: string;
    internalDescription: string;
    cancelFeePolicy:
      | {
          __typename: "CancelFeeFixedPolicy";
          before1DaysFee: number;
          before3DaysFee: number;
          before7DaysFee: number;
          immediate: boolean;
        }
      | {
          __typename: "CancelFeeRatePolicy";
          before1DaysRate: number;
          before3DaysRate: number;
          before7DaysRate: number;
          immediate: boolean;
        };
  }>;
};

export type AdminCleaningTasksQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  unrestricted: Scalars["Boolean"]["input"];
}>;

export type AdminCleaningTasksQuery = {
  __typename: "Query";
  internalFacilityReservations: Array<{
    __typename: "FacilityReservation";
    id: string;
    guestName?: string | null;
    startAt: PlainDateTimeString;
    endAt: PlainDateTimeString;
    status: FacilityReservationStatusType;
    user?: { __typename: "User"; id: string; name: string };
    resource: {
      __typename: "FacilityResource";
      id: string;
      name: string;
      facility: {
        __typename: "Facility";
        id: string;
        name: string;
        type: FacilityType;
        isCleaningReportEnabled: boolean;
        sites: Array<{
          __typename: "Site";
          id: string;
          name: string;
          slug: string;
        }>;
      };
    };
    accommodationReservation?: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastNight: PlainDateString;
      accommodation: { __typename: "Accommodation"; id: string; name: string };
    };
    cleaningReport?: {
      __typename: "FacilityReservationCleaningReport";
      status: FacilityReservationCleaningStatus;
      updatedAt: ZonedDateTimeString;
    } | null;
  }>;
};

export type CoOwnersApplicationComment_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  comment?: string | null;
} & {
  " $fragmentName"?: "CoOwnersApplicationComment_CoOwnersApplicationFragment";
};

export type AdminCoOwnersApplicationCommentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationCommentQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationComment_CoOwnersApplicationFragment: CoOwnersApplicationComment_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type AdminCoOwnersApplicationHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationHeaderQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationHeader_CoOwnersApplicationFragment: CoOwnersApplicationHeader_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type CoOwnersApplicationHeader_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  status: CoOwnersApplicationStatus;
  units: number;
  applicant: { __typename: "User"; id: string; name: string; email: string };
  ownerPlan: {
    __typename: "OwnerPlan";
    id: string;
    site: { __typename: "Site"; id: string; name: string };
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    } | null;
  };
  events: {
    __typename: "CoOwnersApplicationEvents";
    submittedAt: ZonedDateTimeString;
  };
} & {
  " $fragmentName"?: "CoOwnersApplicationHeader_CoOwnersApplicationFragment";
};

export type CoOwnersApplicationOverview_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  units: number;
  invitationCode?: string | null;
  desiredHandoverDate?: PlainYearMonthString | null;
  ownerPlan: {
    __typename: "OwnerPlan";
    id: string;
    unitNightsPerYear: number;
    unitPurchaseAmount: number;
    site: { __typename: "Site"; id: string; name: string };
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    } | null;
    accommodationFacilities: Array<{
      __typename: "AccommodationFacility";
      id: string;
      type: AccommodationFacilityType;
    }>;
  };
  s2oPoint?: { __typename: "S2oPoint"; amount: number } | null;
  events: {
    __typename: "CoOwnersApplicationEvents";
    submittedAt: ZonedDateTimeString;
  };
} & {
  " $fragmentName"?: "CoOwnersApplicationOverview_CoOwnersApplicationFragment";
};

export type AdminCoOwnersApplicationOverviewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationOverviewQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationOverview_CoOwnersApplicationFragment: CoOwnersApplicationOverview_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type AdminUpdateCoOwnersApplicationInfoMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationInfoInput;
}>;

export type AdminUpdateCoOwnersApplicationInfoMutation = {
  __typename: "Mutation";
  internalUpdateCoOwnersApplicationInfo:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
        comment?: string | null;
        disclosureAssitant?: DisclosureAssistantType | null;
        applicationFeePaymentMethod?: PaymentMethodType | null;
        registrationFeePaymentMethod?: PaymentMethodType | null;
        remainingAmountPaymentMethod?: PaymentMethodType | null;
        advancePaymentRequired: boolean;
        desiredHandoverDate?: PlainYearMonthString | null;
        friendReferralDiscountAmount: number;
        employeeReferralDiscountAmount: number;
        additionalPurchaseDiscountAmount: number;
        additionalPurchaseDiscountNote: string;
        otherDiscountAmount: number;
        otherDiscountNote: string;
        applicantInfo: {
          __typename: "CoOwnersApplicantInfo";
          isPep: boolean;
          purchasePurpose?: OwnerPurchasePurposeType | null;
          purchasePurposeFree?: string | null;
          identificationDocumentType: IdentificationDocumentType;
          identificationDocument1?: {
            __typename: "UploadedFile";
            rawUrl: string;
            url: string;
          } | null;
          identificationDocument2?: {
            __typename: "UploadedFile";
            rawUrl: string;
            url: string;
          } | null;
          detail:
            | {
                __typename: "CoOwnersApplicantInfoDetailIndividual";
                householdIncome?: IncomeBracketType | null;
                personalFinancialAssets?: FinancialAssetsBracketType | null;
                employerName?: string | null;
                intendedUsage?: OwnerIntendedUsageType | null;
                useLoan: boolean;
              }
            | {
                __typename: "CoOwnersApplicantInfoDetailOrganization";
                organizationName: string;
                representativeName: string;
                businessActivity?: OwnerOrganizationBusinessActivityType | null;
                businessActivityFree?: string | null;
                organizationRelationship?: OwnerOrganizationRelationshipType | null;
                beneficialOwnerRelationship?: OwnerOrganizationBeneficialOwnerRelationshipType | null;
                beneficialOwnerRelationshipFree?: string | null;
                beneficialOwnerName?: string | null;
                beneficialOwnerBirthDate?: PlainDateString | null;
                beneficialOwnerOthers?: string | null;
                organizationAddress?: {
                  __typename: "AddressInJapan";
                  postalCode: string;
                  line1: string;
                  line2: string;
                } | null;
                registryCertificateDocuments: Array<{
                  __typename: "UploadedFile";
                  rawUrl: string;
                  url: string;
                }>;
                beneficialOwnerAddress?: {
                  __typename: "AddressInJapan";
                  postalCode: string;
                  line1: string;
                  line2: string;
                } | null;
              };
        };
        selectedWebinarSchedule?: {
          __typename: "CoOwnersWebinarSchedule";
          id: string;
          startsAt: ZonedDateTimeString;
          url: string;
        } | null;
        events: {
          __typename: "CoOwnersApplicationEvents";
          submittedAt: ZonedDateTimeString;
          reviewedAt?: ZonedDateTimeString | null;
          completedAt?: ZonedDateTimeString | null;
          invitedToDisclosureAt?: ZonedDateTimeString | null;
          participatedInDisclosureAt?: ZonedDateTimeString | null;
          contractSignedAt?: ZonedDateTimeString | null;
          advancePaymentReceivedAt?: ZonedDateTimeString | null;
          paymentReceivedAt?: ZonedDateTimeString | null;
          handoverCompletedAt?: ZonedDateTimeString | null;
          cancelledAt?: ZonedDateTimeString | null;
        };
      }
    | {
        __typename: "InternalUpdateCoOwnersApplicationInfoError";
        case: InternalUpdateCoOwnersApplicationInfoErrorCase;
      };
};

export type CoOwnersApplicantInfo_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  applicantInfo: {
    __typename: "CoOwnersApplicantInfo";
    isPep: boolean;
    purchasePurpose?: OwnerPurchasePurposeType | null;
    purchasePurposeFree?: string | null;
    detail:
      | {
          __typename: "CoOwnersApplicantInfoDetailIndividual";
          householdIncome?: IncomeBracketType | null;
          personalFinancialAssets?: FinancialAssetsBracketType | null;
          employerName?: string | null;
          intendedUsage?: OwnerIntendedUsageType | null;
          useLoan: boolean;
        }
      | {
          __typename: "CoOwnersApplicantInfoDetailOrganization";
          organizationName: string;
          representativeName: string;
          businessActivity?: OwnerOrganizationBusinessActivityType | null;
          businessActivityFree?: string | null;
          organizationRelationship?: OwnerOrganizationRelationshipType | null;
          beneficialOwnerRelationship?: OwnerOrganizationBeneficialOwnerRelationshipType | null;
          beneficialOwnerRelationshipFree?: string | null;
          beneficialOwnerName?: string | null;
          beneficialOwnerBirthDate?: PlainDateString | null;
          beneficialOwnerOthers?: string | null;
          organizationAddress?: {
            __typename: "AddressInJapan";
            postalCode: string;
            line1: string;
            line2: string;
          } | null;
          registryCertificateDocuments: Array<{
            __typename: "UploadedFile";
            rawUrl: string;
            url: string;
          }>;
          beneficialOwnerAddress?: {
            __typename: "AddressInJapan";
            postalCode: string;
            line1: string;
            line2: string;
          } | null;
        };
  };
} & { " $fragmentName"?: "CoOwnersApplicantInfo_CoOwnersApplicationFragment" };

export type AdminCoOwnersApplicantInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicantInfoQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicantInfo_CoOwnersApplicationFragment: CoOwnersApplicantInfo_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type AdminUpdateCoOwnersApplicationDetailMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationDetailInput;
}>;

export type AdminUpdateCoOwnersApplicationDetailMutation = {
  __typename: "Mutation";
  internalUpdateCoOwnersApplicationDetail:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        applicantInfo: {
          __typename: "CoOwnersApplicantInfo";
          isPep: boolean;
          purchasePurpose?: OwnerPurchasePurposeType | null;
          purchasePurposeFree?: string | null;
          identificationDocumentType: IdentificationDocumentType;
          identificationDocument1?: {
            __typename: "UploadedFile";
            rawUrl: string;
            url: string;
          } | null;
          identificationDocument2?: {
            __typename: "UploadedFile";
            rawUrl: string;
            url: string;
          } | null;
          detail:
            | {
                __typename: "CoOwnersApplicantInfoDetailIndividual";
                householdIncome?: IncomeBracketType | null;
                personalFinancialAssets?: FinancialAssetsBracketType | null;
                employerName?: string | null;
                intendedUsage?: OwnerIntendedUsageType | null;
                useLoan: boolean;
              }
            | {
                __typename: "CoOwnersApplicantInfoDetailOrganization";
                organizationName: string;
                representativeName: string;
                businessActivity?: OwnerOrganizationBusinessActivityType | null;
                businessActivityFree?: string | null;
                organizationRelationship?: OwnerOrganizationRelationshipType | null;
                beneficialOwnerRelationship?: OwnerOrganizationBeneficialOwnerRelationshipType | null;
                beneficialOwnerRelationshipFree?: string | null;
                beneficialOwnerName?: string | null;
                beneficialOwnerBirthDate?: PlainDateString | null;
                beneficialOwnerOthers?: string | null;
                organizationAddress?: {
                  __typename: "AddressInJapan";
                  postalCode: string;
                  line1: string;
                  line2: string;
                } | null;
                registryCertificateDocuments: Array<{
                  __typename: "UploadedFile";
                  rawUrl: string;
                  url: string;
                }>;
                beneficialOwnerAddress?: {
                  __typename: "AddressInJapan";
                  postalCode: string;
                  line1: string;
                  line2: string;
                } | null;
              };
        };
      }
    | {
        __typename: "InternalUpdateCoOwnersApplicationDetailError";
        case: InternalUpdateCoOwnersApplicationDetailErrorCase;
      };
};

export type CoOwnersApplicationFileRow_CoOwnersApplicationFileFragment = {
  __typename: "CoOwnersApplicationFile";
  id: string;
  fileName: string;
  size: number;
  createdAt: DateTimeString;
  visibleToApplicant: boolean;
  deletedAt?: DateTimeString | null;
  uploadedBy: {
    __typename: "User";
    id: string;
    name: string;
    isAdmin: boolean;
  };
  deletedBy?: { __typename: "User"; id: string; name: string } | null;
} & {
  " $fragmentName"?: "CoOwnersApplicationFileRow_CoOwnersApplicationFileFragment";
};

export type AdminCoOwnersApplicationFilesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationFilesQuery = {
  __typename: "Query";
  internalCoOwnersApplication?: {
    __typename: "CoOwnersApplication";
    id: string;
    allFiles: Array<
      {
        __typename: "CoOwnersApplicationFile";
        id: string;
        deletedAt?: DateTimeString | null;
      } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationFileRow_CoOwnersApplicationFileFragment: CoOwnersApplicationFileRow_CoOwnersApplicationFileFragment;
        };
      }
    >;
  } | null;
};

export type AdminCreateCoOwnersApplicationFileUploadPolicyMutationVariables =
  Exact<{
    input: CreateCoOwnersApplicationFileUploadPolicyInput;
  }>;

export type AdminCreateCoOwnersApplicationFileUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateCoOwnersApplicationFileUploadPolicy:
    | { __typename: "CreateFileUploadPolicyError" }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminRegisterCoOwnersApplicationFileMutationVariables = Exact<{
  input: InternalRegisterCoOwnersApplicationFileInput;
}>;

export type AdminRegisterCoOwnersApplicationFileMutation = {
  __typename: "Mutation";
  internalRegisterCoOwnersApplicationFile:
    | {
        __typename: "RegisterCoOwnersApplicationFileError";
        case: RegisterCoOwnersApplicationFileErrorCase;
      }
    | { __typename: "RegisterCoOwnersApplicationFileSuccess" };
};

export type AdminCreateCoOwnersApplicationFileDownloadUrlMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
  }>;

export type AdminCreateCoOwnersApplicationFileDownloadUrlMutation = {
  __typename: "Mutation";
  internalCreateCoOwnersApplicationFileDownloadUrl:
    | { __typename: "CreateCoOwnersApplicationFileDownloadUrlError" }
    | {
        __typename: "CreateCoOwnersApplicationFileDownloadUrlSuccess";
        url: string;
      };
};

export type AdminUpdateCoOwnersApplicationFileVisibilityMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    visibleToApplicant: Scalars["Boolean"]["input"];
  }>;

export type AdminUpdateCoOwnersApplicationFileVisibilityMutation = {
  __typename: "Mutation";
  internalUpdateCoOwnersApplicationFileVisibility:
    | {
        __typename: "CoOwnersApplicationFile";
        id: string;
        visibleToApplicant: boolean;
      }
    | { __typename: "InternalUpdateCoOwnersApplicationFileError" };
};

export type AdminDeleteCoOwnersApplicationFileMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteCoOwnersApplicationFileMutation = {
  __typename: "Mutation";
  internalDeleteCoOwnersApplicationFile:
    | {
        __typename: "CoOwnersApplicationFile";
        id: string;
        deletedAt?: DateTimeString | null;
        deletedBy?: { __typename: "User"; id: string; name: string } | null;
      }
    | { __typename: "InternalUpdateCoOwnersApplicationFileError" };
};

export type CoOwnersApplicationIdentityVerification_CoOwnersApplicationFragment =
  {
    __typename: "CoOwnersApplication";
    id: string;
    identityVerifications: Array<
      { __typename: "IdentityVerification"; id: string } & {
        " $fragmentRefs"?: {
          IdentityVerificationItem_IdentityVerificationFragment: IdentityVerificationItem_IdentityVerificationFragment;
        };
      }
    >;
    applicantInfo: {
      __typename: "CoOwnersApplicantInfo";
      identificationDocumentType: IdentificationDocumentType;
      identificationDocument1?: {
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      } | null;
      identificationDocument2?: {
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      } | null;
    };
  } & {
    " $fragmentName"?: "CoOwnersApplicationIdentityVerification_CoOwnersApplicationFragment";
  };

export type AdminCoOwnersApplicationIdentityVerificationQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationIdentityVerificationQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationIdentityVerification_CoOwnersApplicationFragment: CoOwnersApplicationIdentityVerification_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type AdminCreateCoOwnersIdentityVerificationMutationVariables = Exact<{
  coOwnersApplicationId: Scalars["ID"]["input"];
  input: InternalCreateCoOwnersIdentityVerificationInput;
}>;

export type AdminCreateCoOwnersIdentityVerificationMutation = {
  __typename: "Mutation";
  internalCreateCoOwnersIdentityVerification:
    | {
        __typename: "IdentityVerification";
        id: string;
        method: IdentityVerificationMethod;
        status: IdentityVerificationStatus;
        result?: IdentityVerificationResult | null;
        note: string;
      }
    | {
        __typename: "InternalCreateCoOwnersIdentityVerificationError";
        case: InternalCreateCoOwnersIdentityVerificationErrorCase;
      };
};

export type AdminCreateUserFileUploadPolicyMutationVariables = Exact<{
  input: CreateUserFileUploadPolicyInput;
}>;

export type AdminCreateUserFileUploadPolicyMutation = {
  __typename: "Mutation";
  createUserFileUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type CoOwnersApplicationManagement_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  requestedOtherWebinarSchedule: boolean;
  disclosureAssitant?: DisclosureAssistantType | null;
  desiredHandoverDate?: PlainYearMonthString | null;
  selectedWebinarSchedule?: {
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
    url: string;
    site: { __typename: "Site"; id: string; name: string };
  } | null;
  otherFiles: Array<{
    __typename: "UploadedFile";
    rawUrl: string;
    url: string;
    caption?: string | null;
  }>;
} & {
  " $fragmentName"?: "CoOwnersApplicationManagement_CoOwnersApplicationFragment";
};

export type AdminCoOwnersApplicationManagementQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationManagementQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationManagement_CoOwnersApplicationFragment: CoOwnersApplicationManagement_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type AdminWebinarScheduleOptionsQueryVariables = Exact<{
  applicationId: Scalars["ID"]["input"];
}>;

export type AdminWebinarScheduleOptionsQuery = {
  __typename: "Query";
  internalCoOwnersApplication?: {
    __typename: "CoOwnersApplication";
    id: string;
    ownerPlan: {
      __typename: "OwnerPlan";
      id: string;
      site: { __typename: "Site"; id: string };
    };
  } | null;
  internalCoOwnersWebinarSchedules: Array<{
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
    isActive: boolean;
    site: { __typename: "Site"; id: string; name: string };
  }>;
};

export type AdminAppendS2oPointsToCoOwnersApplicationMutationVariables = Exact<{
  coOwnersApplicationId: Scalars["ID"]["input"];
  amount: Scalars["Int"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminAppendS2oPointsToCoOwnersApplicationMutation = {
  __typename: "Mutation";
  internalAppendS2oPointsToCoOwnersApplication:
    | {
        __typename: "InternalAppendS2oPointsToCoOwnersApplicationError";
        case: InternalAppendS2oPointsToCoOwnersApplicationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type CoOwnersApplicationPayment_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  applicationFeePaymentMethod?: PaymentMethodType | null;
  registrationFeePaymentMethod?: PaymentMethodType | null;
  remainingAmountPaymentMethod?: PaymentMethodType | null;
  advancePaymentRequired: boolean;
  friendReferralDiscountAmount: number;
  employeeReferralDiscountAmount: number;
  additionalPurchaseDiscountAmount: number;
  additionalPurchaseDiscountNote: string;
  otherDiscountAmount: number;
  otherDiscountNote: string;
  s2oPoint?: { __typename: "S2oPoint"; amount: number } | null;
  applicant: {
    __typename: "User";
    id: string;
    s2o: { __typename: "S2o"; balance: number };
  };
} & {
  " $fragmentName"?: "CoOwnersApplicationPayment_CoOwnersApplicationFragment";
};

export type AdminCoOwnersApplicationPaymentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationPaymentQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationPayment_CoOwnersApplicationFragment: CoOwnersApplicationPayment_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type ApplicationSummaryList_CoOwnersApplicationFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  units: number;
  applicationFeePaymentMethod?: PaymentMethodType | null;
  applicant: { __typename: "User"; id: string; name: string; email: string };
  ownerPlan: {
    __typename: "OwnerPlan";
    id: string;
    unitPurchaseAmount: number;
    site: { __typename: "Site"; id: string; name: string };
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    } | null;
  };
} & { " $fragmentName"?: "ApplicationSummaryList_CoOwnersApplicationFragment" };

export type CancelApplicationDialog_CoOwnersApplicationFragment = ({
  __typename: "CoOwnersApplication";
  id: string;
  status: CoOwnersApplicationStatus;
  applicationFeePaymentMethod?: PaymentMethodType | null;
} & {
  " $fragmentRefs"?: {
    ApplicationSummaryList_CoOwnersApplicationFragment: ApplicationSummaryList_CoOwnersApplicationFragment;
  };
}) & {
  " $fragmentName"?: "CancelApplicationDialog_CoOwnersApplicationFragment";
};

export type AdminCancelCoOwnersApplicationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCancelCoOwnersApplicationMutation = {
  __typename: "Mutation";
  internalCancelCoOwnersApplication:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
        events: {
          __typename: "CoOwnersApplicationEvents";
          submittedAt: ZonedDateTimeString;
          reviewedAt?: ZonedDateTimeString | null;
          completedAt?: ZonedDateTimeString | null;
          invitedToDisclosureAt?: ZonedDateTimeString | null;
          participatedInDisclosureAt?: ZonedDateTimeString | null;
          contractSignedAt?: ZonedDateTimeString | null;
          advancePaymentReceivedAt?: ZonedDateTimeString | null;
          paymentReceivedAt?: ZonedDateTimeString | null;
          handoverCompletedAt?: ZonedDateTimeString | null;
          cancelledAt?: ZonedDateTimeString | null;
        };
      }
    | {
        __typename: "InternalCancelCoOwnersApplicationError";
        case: InternalCancelCoOwnersApplicationErrorCase;
      };
};

export type CoOwnersApplicationStatusTab_CoOwnersApplicationFragment = ({
  __typename: "CoOwnersApplication";
  id: string;
  status: CoOwnersApplicationStatus;
  units: number;
  unitSales: Array<{
    __typename: "CoOwnersUnitSale";
    id: string;
    units: number;
    saleYearMonth: PlainYearMonthString;
    soldAt?: DateTimeString | null;
  }>;
  selectedWebinarSchedule?: {
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
  } | null;
  events: {
    __typename: "CoOwnersApplicationEvents";
    submittedAt: ZonedDateTimeString;
    reviewedAt?: ZonedDateTimeString | null;
    completedAt?: ZonedDateTimeString | null;
    invitedToDisclosureAt?: ZonedDateTimeString | null;
    participatedInDisclosureAt?: ZonedDateTimeString | null;
    contractSignedAt?: ZonedDateTimeString | null;
    advancePaymentReceivedAt?: ZonedDateTimeString | null;
    paymentReceivedAt?: ZonedDateTimeString | null;
    handoverCompletedAt?: ZonedDateTimeString | null;
    cancelledAt?: ZonedDateTimeString | null;
  };
} & {
  " $fragmentRefs"?: {
    StatusActionButtons_CoOwnersApplicationFragment: StatusActionButtons_CoOwnersApplicationFragment;
  };
}) & {
  " $fragmentName"?: "CoOwnersApplicationStatusTab_CoOwnersApplicationFragment";
};

export type AdminCoOwnersApplicationStatusTabQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCoOwnersApplicationStatusTabQuery = {
  __typename: "Query";
  internalCoOwnersApplication?:
    | ({ __typename: "CoOwnersApplication" } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationStatusTab_CoOwnersApplicationFragment: CoOwnersApplicationStatusTab_CoOwnersApplicationFragment;
        };
      })
    | null;
};

export type AdminInternalMarkCoOwnersApplicationSoldMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminInternalMarkCoOwnersApplicationSoldMutation = {
  __typename: "Mutation";
  internalMarkCoOwnersApplicationSold:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
        unitSales: Array<{
          __typename: "CoOwnersUnitSale";
          id: string;
          units: number;
          saleYearMonth: PlainYearMonthString;
          soldAt?: DateTimeString | null;
        }>;
      }
    | {
        __typename: "InternalMarkCoOwnersApplicationSoldError";
        case: InternalMarkCoOwnersApplicationSoldErrorCase;
      };
};

export type AdminInternalMarkCoOwnersApplicationPlannedForSaleMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    units: Scalars["Int"]["input"];
    saleYearMonth: Scalars["PlainYearMonth"]["input"];
  }>;

export type AdminInternalMarkCoOwnersApplicationPlannedForSaleMutation = {
  __typename: "Mutation";
  internalMarkCoOwnersApplicationPlannedForSale:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
        unitSales: Array<{
          __typename: "CoOwnersUnitSale";
          id: string;
          units: number;
          saleYearMonth: PlainYearMonthString;
          soldAt?: DateTimeString | null;
        }>;
      }
    | {
        __typename: "InternalMarkCoOwnersApplicationPlannedForSaleError";
        case: InternalMarkCoOwnersApplicationPlannedForSaleErrorCase;
      };
};

export type StatusActionButtons_CoOwnersApplicationFragment = ({
  __typename: "CoOwnersApplication";
  id: string;
  status: CoOwnersApplicationStatus;
  advancePaymentRequired: boolean;
} & {
  " $fragmentRefs"?: {
    StayCreditOverrideSheet_CoOwnersApplicationFragment: StayCreditOverrideSheet_CoOwnersApplicationFragment;
    CancelApplicationDialog_CoOwnersApplicationFragment: CancelApplicationDialog_CoOwnersApplicationFragment;
  };
}) & { " $fragmentName"?: "StatusActionButtons_CoOwnersApplicationFragment" };

export type StayCreditOverrideSheet_CoOwnersApplicationFragment = ({
  __typename: "CoOwnersApplication";
  id: string;
  desiredHandoverDate?: PlainYearMonthString | null;
} & {
  " $fragmentRefs"?: {
    ApplicationSummaryList_CoOwnersApplicationFragment: ApplicationSummaryList_CoOwnersApplicationFragment;
  };
}) & {
  " $fragmentName"?: "StayCreditOverrideSheet_CoOwnersApplicationFragment";
};

export type AdminInternalVoidCoOwnersApplicationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminInternalVoidCoOwnersApplicationMutation = {
  __typename: "Mutation";
  internalVoidCoOwnersApplication:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
        events: {
          __typename: "CoOwnersApplicationEvents";
          submittedAt: ZonedDateTimeString;
          handoverCompletedAt?: ZonedDateTimeString | null;
          cancelledAt?: ZonedDateTimeString | null;
        };
      }
    | {
        __typename: "InternalVoidCoOwnersApplicationError";
        case: InternalVoidCoOwnersApplicationErrorCase;
      };
};

export type AdminUpdateCoOwnersApplicationStatusMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationStatusInput;
}>;

export type AdminUpdateCoOwnersApplicationStatusMutation = {
  __typename: "Mutation";
  internalUpdateCoOwnersApplicationStatus:
    | {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
        events: {
          __typename: "CoOwnersApplicationEvents";
          submittedAt: ZonedDateTimeString;
          reviewedAt?: ZonedDateTimeString | null;
          completedAt?: ZonedDateTimeString | null;
          invitedToDisclosureAt?: ZonedDateTimeString | null;
          participatedInDisclosureAt?: ZonedDateTimeString | null;
          contractSignedAt?: ZonedDateTimeString | null;
          advancePaymentReceivedAt?: ZonedDateTimeString | null;
          paymentReceivedAt?: ZonedDateTimeString | null;
          handoverCompletedAt?: ZonedDateTimeString | null;
          cancelledAt?: ZonedDateTimeString | null;
        };
      }
    | {
        __typename: "InternalUpdateCoOwnersApplicationStatusError";
        case: InternalUpdateCoOwnersApplicationStatusErrorCase;
      };
};

export type AdminCoOwnersApplicationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCoOwnersApplicationsQuery = {
  __typename: "Query";
  internalCoOwnersApplications: Array<{
    __typename: "CoOwnersApplication";
    id: string;
    status: CoOwnersApplicationStatus;
    units: number;
    comment?: string | null;
    applicant: { __typename: "User"; id: string; name: string; email: string };
    ownerPlan: {
      __typename: "OwnerPlan";
      id: string;
      unitNightsPerYear: number;
      unitPurchaseAmount: number;
      site: { __typename: "Site"; id: string; slug: string; name: string };
      architectureType?: {
        __typename: "ArchitectureType";
        id: string;
        name: string;
      } | null;
      accommodationFacilities: Array<{
        __typename: "AccommodationFacility";
        id: string;
        type: AccommodationFacilityType;
      }>;
    };
    events: {
      __typename: "CoOwnersApplicationEvents";
      submittedAt: ZonedDateTimeString;
    };
  }>;
};

export type AdminCoOwnersInvoiceAnnualPaymentItemsQueryVariables = Exact<{
  programYear: Scalars["Int"]["input"];
}>;

export type AdminCoOwnersInvoiceAnnualPaymentItemsQuery = {
  __typename: "Query";
  internalCoOwnersBakurakuInvoiceAnnualPaymentItems: Array<{
    __typename: "CoOwnersBakurakuInvoiceAnnualPaymentItem";
    recipientCode: string;
    documentNumber: string;
    name: string;
    note: string;
    amount: number;
    unit: string;
    taxRate: string;
    paymentDueDate: string;
    date: string;
    applicant: { __typename: "User"; id: string; name: string };
  }>;
};

export type AdminCoOwnersInvoiceRecipientsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCoOwnersInvoiceRecipientsQuery = {
  __typename: "Query";
  internalCoOwnersBakurakuInvoiceRecipients: Array<{
    __typename: "CoOwnersBakurakuInvoiceRecipient";
    code: string;
    recipientName: string;
    departmentName: string;
    email: string;
    emailDelivery: string;
  }>;
};

export type AdminCoOwnersInvoiceRegistrationFeeItemsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCoOwnersInvoiceRegistrationFeeItemsQuery = {
  __typename: "Query";
  internalCoOwnersBakurakuInvoiceRegistrationFeeItems: Array<{
    __typename: "CoOwnersBakurakuInvoiceRegistrationFeeItem";
    recipientCode: string;
    documentNumber: string;
    name: string;
    note: string;
    amount: number;
    unit: string;
    taxRate: string;
    paymentDueDate: string;
    date: string;
    applicant: { __typename: "User"; id: string; name: string };
  }>;
};

export type AdminCoOwnersInvoiceRemainingPaymentItemsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCoOwnersInvoiceRemainingPaymentItemsQuery = {
  __typename: "Query";
  internalCoOwnersBakurakuInvoiceRemainingPaymentExcludedApplicationCount: number;
  internalCoOwnersBakurakuInvoiceRemainingPaymentItems: Array<{
    __typename: "CoOwnersBakurakuInvoiceRemainingPaymentItem";
    recipientCode: string;
    documentNumber: string;
    name: string;
    note: string;
    amount: number;
    unit: string;
    taxRate: string;
    paymentDueDate: string;
    date: string;
    applicant: { __typename: "User"; id: string; name: string };
  }>;
};

export type AdminCoOwnersWebinarScheduleDetailQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCoOwnersWebinarScheduleDetailQuery = {
  __typename: "Query";
  internalCoOwnersWebinarSchedules: Array<{
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
    url: string;
    isActive: boolean;
    site: { __typename: "Site"; id: string; name: string };
    coOwnersApplications?: Array<{
      __typename: "CoOwnersApplication";
      id: string;
      status: CoOwnersApplicationStatus;
      units: number;
      applicant: {
        __typename: "User";
        id: string;
        name: string;
        email: string;
      };
      ownerPlan: {
        __typename: "OwnerPlan";
        id: string;
        site: { __typename: "Site"; id: string; name: string };
        architectureType?: {
          __typename: "ArchitectureType";
          id: string;
          name: string;
        } | null;
      };
    }> | null;
  }>;
};

export type AdminCoOwnersWebinarSchedulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminCoOwnersWebinarSchedulesQuery = {
  __typename: "Query";
  internalCoOwnersWebinarSchedules: Array<{
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
    url: string;
    isActive: boolean;
    site: { __typename: "Site"; id: string; slug: string; name: string };
    coOwnersApplications?: Array<{
      __typename: "CoOwnersApplication";
      id: string;
    }> | null;
  }>;
};

export type AdminWebinarScheduleSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminWebinarScheduleSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
};

export type AdminCreateOrUpdateCoOwnersWebinarScheduleMutationVariables =
  Exact<{
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateCoOwnersWebinarScheduleInput;
  }>;

export type AdminCreateOrUpdateCoOwnersWebinarScheduleMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateCoOwnersWebinarSchedule:
    | {
        __typename: "CoOwnersWebinarSchedule";
        id: string;
        startsAt: ZonedDateTimeString;
        url: string;
        isActive: boolean;
        site: { __typename: "Site"; id: string; name: string };
      }
    | {
        __typename: "InternalCreateOrUpdateCoOwnersWebinarScheduleError";
        case: InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase;
      };
};

export type AdminBulkCreateAvailabilityBlocksMutationVariables = Exact<{
  input:
    | Array<CreateAccommodationAvailabilityBlockInput>
    | CreateAccommodationAvailabilityBlockInput;
}>;

export type AdminBulkCreateAvailabilityBlocksMutation = {
  __typename: "Mutation";
  internalBulkCreateAccommodationAvailabilityBlocks: {
    __typename: "InternalBulkCreateAccommodationAvailabilityBlocksPayload";
    success: Array<{
      __typename: "AccommodationAvailabilityBlock";
      id: string;
      name: string;
      beginNight: PlainDateString;
      endNight: PlainDateString;
      site: { __typename: "Site"; id: string };
      accommodation?: {
        __typename: "Accommodation";
        id: string;
        code: string;
      } | null;
    }>;
    failed: Array<{
      __typename: "InternalBulkCreateAccommodationAvailabilityBlockFailure";
      reason: string;
      input: {
        __typename: "InternalBulkCreateAccommodationAvailabilityBlockFailureInput";
        name: string;
        beginNight: PlainDateString;
        endNight: PlainDateString;
        accommodationId?: string | null;
      };
    }>;
  };
};

export type AdminBlockMatrixQueryVariables = Exact<{
  siteIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  scope: AccommodationScope;
  from: Scalars["PlainDate"]["input"];
  to: Scalars["PlainDate"]["input"];
}>;

export type AdminBlockMatrixQuery = {
  __typename: "Query";
  internalAccommodations: Array<{
    __typename: "Accommodation";
    id: string;
    code: string;
    facilityTypes: Array<AccommodationFacilityType>;
    architectureType: {
      __typename: "ArchitectureType";
      id: string;
      seriesShortName: string;
      size?: ArchitectureTypeSize | null;
    };
    site: { __typename: "Site"; id: string };
  }>;
  internalAccommodationReservationsBySearch: Array<{
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    stayStatus: AccommodationReservationStayStatus;
    accommodation: { __typename: "Accommodation"; id: string };
    user?: { __typename: "User"; id: string; name: string } | null;
  }>;
  accommodationAvailabilityBlocks: Array<{
    __typename: "AccommodationAvailabilityBlock";
    id: string;
    name: string;
    beginNight: PlainDateString;
    endNight: PlainDateString;
    note: string;
    isTentative: boolean;
    categoryInfo: {
      __typename: "AccommodationAvailabilityBlockCategoryInfo";
      label: string;
    };
    createdByUser?: { __typename: "User"; id: string; name: string } | null;
    site: { __typename: "Site"; id: string };
    accommodation?: { __typename: "Accommodation"; id: string } | null;
  }>;
};

export type AdminCsvBulkCreateAvailabilityBlocksMutationVariables = Exact<{
  input:
    | Array<CreateAccommodationAvailabilityBlockInput>
    | CreateAccommodationAvailabilityBlockInput;
}>;

export type AdminCsvBulkCreateAvailabilityBlocksMutation = {
  __typename: "Mutation";
  internalBulkCreateAccommodationAvailabilityBlocks: {
    __typename: "InternalBulkCreateAccommodationAvailabilityBlocksPayload";
    success: Array<{
      __typename: "AccommodationAvailabilityBlock";
      id: string;
      name: string;
      beginNight: PlainDateString;
      endNight: PlainDateString;
      site: { __typename: "Site"; id: string };
      accommodation?: {
        __typename: "Accommodation";
        id: string;
        code: string;
      } | null;
    }>;
    failed: Array<{
      __typename: "InternalBulkCreateAccommodationAvailabilityBlockFailure";
      reason: string;
      input: {
        __typename: "InternalBulkCreateAccommodationAvailabilityBlockFailureInput";
        name: string;
        beginNight: PlainDateString;
        endNight: PlainDateString;
        siteId: string;
        accommodationId?: string | null;
      };
    }>;
  };
};

export type AdminBlockCsvMastersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBlockCsvMastersQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      accommodations: Array<{
        __typename: "Accommodation";
        id: string;
        code: string;
      }>;
    }>;
  }>;
  accommodationAvailabilityBlockCategoryInfos: Array<{
    __typename: "AccommodationAvailabilityBlockCategoryInfo";
    key: AccommodationAvailabilityBlockCategory;
    label: string;
  }>;
  staffGroups: Array<{ __typename: "StaffGroup"; id: string; name: string }>;
};

export type AdminBulkBlockMastersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBulkBlockMastersQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      slug: string;
      content: {
        __typename: "SiteContent";
        id: string;
        mapImageUrl?: string | null;
      };
    }>;
  }>;
  accommodationAvailabilityBlockCategoryInfos: Array<{
    __typename: "AccommodationAvailabilityBlockCategoryInfo";
    key: AccommodationAvailabilityBlockCategory;
    label: string;
    note: string;
    categoryGroup: string;
  }>;
  staffGroups: Array<{
    __typename: "StaffGroup";
    id: string;
    name: string;
    fullName?: string | null;
    status: StaffGroupStatus;
  }>;
};

export type AdminEquipmentAccommodationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminEquipmentAccommodationsQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      accommodations: Array<{
        __typename: "Accommodation";
        id: string;
        name: string;
        code: string;
        sanuEdgeDevices: Array<{
          __typename: "SanuEdgeDevice";
          deviceId: string;
        }>;
      }>;
    }>;
  }>;
};

export type AdminCreateAccommodationEquipmentMutationVariables = Exact<{
  input: InternalCreateAccommodationEquipmentInput;
}>;

export type AdminCreateAccommodationEquipmentMutation = {
  __typename: "Mutation";
  internalCreateAccommodationEquipment:
    | ({ __typename: "AccommodationEquipment" } & {
        " $fragmentRefs"?: {
          EquipmentDetailSheet_AccommodationEquipmentFragment: EquipmentDetailSheet_AccommodationEquipmentFragment;
        };
      })
    | {
        __typename: "InternalAccommodationEquipmentError";
        case: InternalAccommodationEquipmentErrorCase;
      };
};

export type EquipmentDetailSheet_AccommodationEquipmentFragment = {
  __typename: "AccommodationEquipment";
  id: string;
  type: AccommodationEquipmentType;
  name: string;
  description?: string | null;
  status: AccommodationEquipmentStatusType;
  sort: number;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    name: string;
    code: string;
    sanuEdgeDevices: Array<{ __typename: "SanuEdgeDevice"; deviceId: string }>;
  };
  attribute?:
    | { __typename: "MusicConnectEquipmentAttribute"; instruction: string }
    | { __typename: "SaunaEquipmentAttribute"; deviceId: string }
    | {
        __typename: "WifiEquipmentAttribute";
        primary: {
          __typename: "WifiConnection";
          ssid: string;
          password: string;
        };
        secondary?: {
          __typename: "WifiConnection";
          ssid: string;
          password: string;
        } | null;
      }
    | null;
} & {
  " $fragmentName"?: "EquipmentDetailSheet_AccommodationEquipmentFragment";
};

export type AdminUpdateAccommodationEquipmentMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationEquipmentInput;
}>;

export type AdminUpdateAccommodationEquipmentMutation = {
  __typename: "Mutation";
  internalUpdateAccommodationEquipment:
    | ({ __typename: "AccommodationEquipment" } & {
        " $fragmentRefs"?: {
          EquipmentDetailSheet_AccommodationEquipmentFragment: EquipmentDetailSheet_AccommodationEquipmentFragment;
        };
      })
    | {
        __typename: "InternalAccommodationEquipmentError";
        case: InternalAccommodationEquipmentErrorCase;
      };
};

export type AdminDeleteAccommodationEquipmentMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteAccommodationEquipmentMutation = {
  __typename: "Mutation";
  internalDeleteAccommodationEquipment:
    | {
        __typename: "InternalAccommodationEquipmentError";
        case: InternalAccommodationEquipmentErrorCase;
      }
    | { __typename: "InternalDeleteAccommodationEquipmentSuccess"; id: string };
};

export type AdminEquipmentsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminEquipmentsQuery = {
  __typename: "Query";
  internalAccommodationEquipments: Array<
    {
      __typename: "AccommodationEquipment";
      id: string;
      type: AccommodationEquipmentType;
      name: string;
      description?: string | null;
      status: AccommodationEquipmentStatusType;
      sort: number;
      accommodation: { __typename: "Accommodation"; id: string; name: string };
    } & {
      " $fragmentRefs"?: {
        EquipmentDetailSheet_AccommodationEquipmentFragment: EquipmentDetailSheet_AccommodationEquipmentFragment;
      };
    }
  >;
};

export type AdminUpdateFeePoliciesMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminUpdateFeePoliciesMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityFeePoliciesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityFeePoliciesQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    resources: Array<{
      __typename: "FacilityResource";
      name: string;
      identifier: string;
    }>;
    baseFeePolicies: Array<{
      __typename: "FacilityBaseFeePolicy";
      id: string;
      unit: number;
      unitFeeAmount: number;
      resource?: {
        __typename: "FacilityResource";
        name: string;
        identifier: string;
      } | null;
    }>;
  } | null;
};

export type AdminDeleteFeePolicyMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminDeleteFeePolicyMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type EditFacilitySheetFragment = {
  __typename: "Facility";
  id: string;
  name: string;
  label: string;
  type: FacilityType;
  unitType: FacilityUnitType;
  status: FacilityStatusType;
  isReserveEnabled: boolean;
  isVisibleEnabled: boolean;
  isCleaningReportEnabled: boolean;
  isDataSyncEnabled: boolean;
  description: string;
  detailUrl?: string | null;
  termsUrl?: string | null;
  termsLabel?: string | null;
  reserveDeadlineHour: number;
  reserveDeadlineDaysBefore: number;
  cancelDeadlineHour: number;
  cancelDeadlineDaysBefore: number;
  image: { __typename: "UploadedFile"; rawUrl: string; url: string };
  sites: Array<{ __typename: "Site"; id: string; name: string }>;
  resources: Array<{
    __typename: "FacilityResource";
    name: string;
    identifier: string;
  }>;
  baseFeePolicies: Array<{
    __typename: "FacilityBaseFeePolicy";
    id: string;
    unit: number;
    unitFeeAmount: number;
  }>;
  cancelFeePolicies: Array<{
    __typename: "FacilityCancelFeePolicy";
    id: string;
    deadlineDaysBefore: number;
    deadlineHour: number;
    feeModifierType: FeeModifierType;
    feeValue: number;
    resource?: { __typename: "FacilityResource"; identifier: string } | null;
  }>;
  slots: Array<{
    __typename: "FacilitySlot";
    id: string;
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
  }>;
} & { " $fragmentName"?: "EditFacilitySheetFragment" };

export type AdminFacilityEditSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminFacilityEditSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
};

export type AdminUpdateFacilityMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminUpdateFacilityMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityBasicInfoQuery = {
  __typename: "Query";
  internalFacility?:
    | ({
        __typename: "Facility";
        id: string;
        name: string;
        label: string;
        type: FacilityType;
        unitType: FacilityUnitType;
        isReserveEnabled: boolean;
        description: string;
        detailUrl?: string | null;
        termsUrl?: string | null;
        termsLabel?: string | null;
        reserveDeadlineHour: number;
        reserveDeadlineDaysBefore: number;
        cancelDeadlineHour: number;
        cancelDeadlineDaysBefore: number;
        image: { __typename: "UploadedFile"; url: string; rawUrl: string };
        resources: Array<{
          __typename: "FacilityResource";
          id: string;
          name: string;
          identifier: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          EditFacilitySheetFragment: EditFacilitySheetFragment;
        };
      })
    | null;
};

export type AdminUpdateFacilityImageMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminUpdateFacilityImageMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityForBlockQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
}>;

export type AdminFacilityForBlockQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    name: string;
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      name: string;
      identifier: string;
    }>;
  } | null;
};

export type AdminCreateFacilityResourceBlockMutationVariables = Exact<{
  input: InternalCreateOrUpdateFacilityResourceBlockInput;
}>;

export type AdminCreateFacilityResourceBlockMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateFacilityResourceBlock:
    | {
        __typename: "InternalCreateOrUpdateFacilityResourceBlockError";
        case: InternalCreateOrUpdateFacilityResourceBlockErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityDetailBlocksQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  blockType?: InputMaybe<FacilityResourceBlockType>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminFacilityDetailBlocksQuery = {
  __typename: "Query";
  internalFacilityResourceBlocks: Array<{
    __typename: "FacilityResourceBlock";
    id: string;
    startAt: DateTimeString;
    endAt: DateTimeString;
    resourceBlockType: FacilityResourceBlockType;
    reason?: string | null;
    resource: {
      __typename: "FacilityResource";
      id: string;
      name: string;
      identifier: string;
      facility: {
        __typename: "Facility";
        id: string;
        name: string;
        type: FacilityType;
      };
    };
  }>;
};

export type AdminDeleteFacilityResourceBlockMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteFacilityResourceBlockMutation = {
  __typename: "Mutation";
  internalDeleteFacilityResourceBlock:
    | {
        __typename: "InternalDeleteFacilityResourceBlockError";
        case: InternalDeleteFacilityResourceBlockErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityDetailBlocksResourcesQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
}>;

export type AdminFacilityDetailBlocksResourcesQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      name: string;
    }>;
  } | null;
};

export type AdminUpdateCancelFeePoliciesMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminUpdateCancelFeePoliciesMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityCancelFeePoliciesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityCancelFeePoliciesQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    resources: Array<{
      __typename: "FacilityResource";
      name: string;
      identifier: string;
    }>;
    cancelFeePolicies: Array<{
      __typename: "FacilityCancelFeePolicy";
      id: string;
      deadlineDaysBefore: number;
      deadlineHour: number;
      feeModifierType: FeeModifierType;
      feeValue: number;
      resource?: {
        __typename: "FacilityResource";
        name: string;
        identifier: string;
      } | null;
    }>;
  } | null;
};

export type AdminDeleteCancelFeePolicyMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminDeleteCancelFeePolicyMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminUpdateFacilityContentMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminUpdateFacilityContentMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityContentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityContentQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    contentUsage?: string | null;
    contentDetail?: string | null;
    contentNotice?: string | null;
    contentGuide?: string | null;
    contentImages: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    }>;
  } | null;
};

export type AdminUpdateFacilityContentImagesMutationVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
  input: InternalUpdateFacilityContentImagesInput;
}>;

export type AdminUpdateFacilityContentImagesMutation = {
  __typename: "Mutation";
  internalUpdateFacilityContentImages:
    | { __typename: "InternalCommonError" }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityTabsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityTabsQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    unitType: FacilityUnitType;
    isReserveEnabled: boolean;
  } | null;
};

export type AdminFacilityForReservationFormQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
  accommodationReservationId: Scalars["ID"]["input"];
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AdminFacilityForReservationFormQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    name: string;
    unitType: FacilityUnitType;
    termsUrl?: string | null;
    termsLabel?: string | null;
    discountFeePolicies: Array<{
      __typename: "FacilityDiscountFeePolicy";
      label: string;
      discountModifierType: FeeModifierType;
      discountValue: number;
    }>;
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      name: string;
      identifier: string;
      isReservable: boolean;
      baseFeePolicies: Array<{
        __typename: "FacilityBaseFeePolicy";
        id: string;
        unit: number;
        unitFeeAmount: number;
      }>;
      slotAvailabilities: Array<{
        __typename: "FacilitySlotAvailability";
        slotId?: string | null;
        date: PlainDateString;
        label: string;
        isReservable: boolean;
        unavailableReason?: FacilitySlotUnavailableReason | null;
      }>;
    }>;
    customFields?: Array<{
      __typename: "FacilityCustomFieldItem";
      key: string;
      label: string;
      type: FacilityFieldType;
      required: boolean;
      options?: Array<string> | null;
      placeholder?: string | null;
      caption?: string | null;
    }> | null;
  } | null;
};

export type AdminCreateFacilityReservationMutationVariables = Exact<{
  input: InternalCreateFacilityReservationInput;
}>;

export type AdminCreateFacilityReservationMutation = {
  __typename: "Mutation";
  internalCreateFacilityReservation:
    | {
        __typename: "InternalCreateFacilityReservationError";
        case: InternalCreateFacilityReservationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityForReservationQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
}>;

export type AdminFacilityForReservationQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    name: string;
    type: FacilityType;
    sites: Array<{ __typename: "Site"; id: string }>;
  } | null;
};

export type FacilityReservationControllerAttributeSection_FacilityReservationFragment =
  {
    __typename: "FacilityReservation";
    controllers: Array<{
      __typename: "FacilityController";
      id: string;
      type: FacilityResourceControllerType;
      controllerAttribute?: string | null;
    }>;
  } & {
    " $fragmentName"?: "FacilityReservationControllerAttributeSection_FacilityReservationFragment";
  };

export type FacilityReservationDetailSheet_FacilityReservationFragment = ({
  __typename: "FacilityReservation";
  id: string;
  status: FacilityReservationStatusType;
  canceledAt?: ZonedDateTimeString | null;
  startAt: PlainDateTimeString;
  endAt: PlainDateTimeString;
  units: number;
  unitFeeAmount: number;
  totalFeeAmount: number;
  discountAmount: number;
  chargedFeeAmount: number;
  discountReason?: string | null;
  termsAgreedAt?: ZonedDateTimeString | null;
  createdAt: ZonedDateTimeString;
  user: {
    __typename: "User";
    id: string;
    name: string;
    email: string;
    phoneNumber?: string | null;
  };
  resource: {
    __typename: "FacilityResource";
    id: string;
    name: string;
    identifier: string;
    facility: {
      __typename: "Facility";
      id: string;
      name: string;
      type: FacilityType;
      isDataSyncEnabled: boolean;
    };
  };
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    firstDate: PlainDateString;
    lastDate: PlainDateString;
    nights: number;
    accommodation: { __typename: "Accommodation"; id: string; name: string };
  };
  dataSync?: {
    __typename: "FacilityReservationDataSync";
    status: FacilityReservationDataSyncStatus;
  } | null;
  customFieldValues: Array<{
    __typename: "FacilityCustomFieldValue";
    key: string;
    value: string;
  }>;
} & {
  " $fragmentRefs"?: {
    FacilityReservationUsageSection_FacilityReservationFragment: FacilityReservationUsageSection_FacilityReservationFragment;
    FacilityReservationControllerAttributeSection_FacilityReservationFragment: FacilityReservationControllerAttributeSection_FacilityReservationFragment;
  };
}) & {
  " $fragmentName"?: "FacilityReservationDetailSheet_FacilityReservationFragment";
};

export type AdminCancelFacilityReservationSharedMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCancelFacilityReservationSharedMutation = {
  __typename: "Mutation";
  internalCancelFacilityReservation:
    | {
        __typename: "CancelFacilityReservationError";
        case: CancelFacilityReservationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type FacilityReservationUsageSection_FacilityReservationFragment = {
  __typename: "FacilityReservation";
  id: string;
  startAt: PlainDateTimeString;
  endAt: PlainDateTimeString;
  controllers: Array<{
    __typename: "FacilityController";
    type: FacilityResourceControllerType;
    controllerAttribute?: string | null;
  }>;
} & {
  " $fragmentName"?: "FacilityReservationUsageSection_FacilityReservationFragment";
};

export type AdminFacilityDetailReservationsQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  status?: InputMaybe<FacilityReservationStatusType>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminFacilityDetailReservationsQuery = {
  __typename: "Query";
  internalFacilityReservations: Array<
    {
      __typename: "FacilityReservation";
      id: string;
      startAt: PlainDateTimeString;
      endAt: PlainDateTimeString;
      units: number;
      chargedFeeAmount: number;
      status: FacilityReservationStatusType;
      createdAt: ZonedDateTimeString;
      user: { __typename: "User"; id: string; name: string };
      resource: {
        __typename: "FacilityResource";
        id: string;
        name: string;
        facility: {
          __typename: "Facility";
          id: string;
          isDataSyncEnabled: boolean;
        };
      };
      accommodationReservation: {
        __typename: "AccommodationReservation";
        id: string;
        accommodation: {
          __typename: "Accommodation";
          id: string;
          code: string;
          site: { __typename: "Site"; id: string; name: string };
        };
      };
      dataSync?: {
        __typename: "FacilityReservationDataSync";
        status: FacilityReservationDataSyncStatus;
      } | null;
    } & {
      " $fragmentRefs"?: {
        FacilityReservationDetailSheet_FacilityReservationFragment: FacilityReservationDetailSheet_FacilityReservationFragment;
      };
    }
  >;
};

export type AdminCancelFacilityReservationFromListMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminCancelFacilityReservationFromListMutation = {
  __typename: "Mutation";
  internalCancelFacilityReservation:
    | {
        __typename: "CancelFacilityReservationError";
        case: CancelFacilityReservationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type UpdateFacilityReservationCleaningMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"];
  status: FacilityReservationCleaningStatus;
}>;

export type UpdateFacilityReservationCleaningMutation = {
  __typename: "Mutation";
  internalUpdateFacilityReservationCleaning:
    | {
        __typename: "InternalUpdateFacilityReservationCleaningError";
        case: InternalUpdateFacilityReservationCleaningErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type UpdateFacilityReservationDataSyncMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"];
  status: FacilityReservationDataSyncStatus;
}>;

export type UpdateFacilityReservationDataSyncMutation = {
  __typename: "Mutation";
  internalUpdateFacilityReservationDataSync:
    | {
        __typename: "InternalUpdateFacilityReservationDataSyncError";
        case: InternalUpdateFacilityReservationDataSyncErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityUsageOperatorQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminFacilityUsageOperatorQuery = {
  __typename: "Query";
  internalUser: { __typename: "User"; id: string; name: string };
};

export type AdminUpdateFacilityReservationMutationVariables = Exact<{
  input: UpdateFacilityReservationInput;
}>;

export type AdminUpdateFacilityReservationMutation = {
  __typename: "Mutation";
  internalUpdateFacilityReservation:
    | {
        __typename: "UpdateFacilityReservationError";
        case: UpdateFacilityReservationErrorCase;
      }
    | {
        __typename: "UpdateFacilityReservationSuccess";
        reservation: {
          __typename: "FacilityReservation";
          id: string;
          controllers: Array<{
            __typename: "FacilityController";
            type: FacilityResourceControllerType;
            controllerAttribute?: string | null;
          }>;
        };
      };
};

export type AdminFacilityDetailReservationsResourcesQueryVariables = Exact<{
  facilityId: Scalars["ID"]["input"];
}>;

export type AdminFacilityDetailReservationsResourcesQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      name: string;
    }>;
  } | null;
};

export type AdminAccommodationReservationsForFacilityQueryVariables = Exact<{
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  accommodationScope?: InputMaybe<AccommodationScope>;
  facilityType: FacilityType;
}>;

export type AdminAccommodationReservationsForFacilityQuery = {
  __typename: "Query";
  internalAccommodationReservationsBySearch: Array<{
    __typename: "AccommodationReservation";
    id: string;
    hasCanceled: boolean;
    isTentative: boolean;
    isFacilityReservable: boolean;
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    user?: { __typename: "User"; id: string; name: string } | null;
    accommodation: { __typename: "Accommodation"; name: string };
  }>;
};

export type AdminUpdateResourcesMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminUpdateResourcesMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilityResourcesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityResourcesQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    name: string;
    isReserveEnabled: boolean;
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      identifier: string;
      name: string;
      customInvoiceLabel?: Array<{
        __typename: "FacilityInvoiceLabelPart";
        type: FacilityInvoiceLabelPartType;
        value?: string | null;
        format?: FacilityInvoiceLabelPeriodFormat | null;
      }> | null;
      resourceControllers: Array<{
        __typename: "InternalFacilityController";
        type: FacilityResourceControllerType;
        id: string;
        attribute?: string | null;
      }>;
    }>;
  } | null;
};

export type AdminDeleteFacilityResourceMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminDeleteFacilityResourceMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminCreateSlotMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminCreateSlotMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilitySlotsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilitySlotsQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    resources: Array<{
      __typename: "FacilityResource";
      name: string;
      identifier: string;
    }>;
    slots: Array<{
      __typename: "FacilitySlot";
      id: string;
      startHour: number;
      startMinute: number;
      endHour: number;
      endMinute: number;
      resource?: {
        __typename: "FacilityResource";
        name: string;
        identifier: string;
      } | null;
    }>;
  } | null;
};

export type AdminDeleteSlotMutationVariables = Exact<{
  input: InternalUpdateFacilityInput;
}>;

export type AdminDeleteSlotMutation = {
  __typename: "Mutation";
  internalUpdateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminCreateFacilityMutationVariables = Exact<{
  input: InternalCreateFacilityInput;
}>;

export type AdminCreateFacilityMutation = {
  __typename: "Mutation";
  internalCreateFacility:
    | {
        __typename: "InternalCreateOrUpdateFacilityError";
        case: InternalCreateOrUpdateFacilityErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFacilitiesQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  facilityType?: InputMaybe<FacilityType>;
}>;

export type AdminFacilitiesQuery = {
  __typename: "Query";
  internalFacilities: Array<{
    __typename: "Facility";
    id: string;
    name: string;
    type: FacilityType;
    unitType: FacilityUnitType;
    status: FacilityStatusType;
    isReserveEnabled: boolean;
    reserveDeadlineHour: number;
    reserveDeadlineDaysBefore: number;
    cancelDeadlineHour: number;
    cancelDeadlineDaysBefore: number;
    createdAt: ZonedDateTimeString;
    sites: Array<{ __typename: "Site"; id: string; name: string }>;
  }>;
};

export type AdminFacilityHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminFacilityHeaderQuery = {
  __typename: "Query";
  internalFacility?: {
    __typename: "Facility";
    id: string;
    name: string;
    status: FacilityStatusType;
    sites: Array<{ __typename: "Site"; id: string; name: string }>;
  } | null;
};

export type AdminFacilitiesSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminFacilitiesSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
    }>;
  }>;
};

export type AdminCreateFacilityImageUploadPolicyMutationVariables = Exact<{
  input: InternalCreateFacilityImageUploadPolicyInput;
}>;

export type AdminCreateFacilityImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateFacilityImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminViewerQueryVariables = Exact<{ [key: string]: never }>;

export type AdminViewerQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    id: string;
    name: string;
    email: string;
    adminRoleAssignments: Array<{
      __typename: "AdminRoleAssignment";
      role: AdminRole;
      site?: {
        __typename: "Site";
        id: string;
        slug: string;
        name: string;
      } | null;
    }>;
    maybeProfile?: {
      __typename: "UserProfile";
      facePhoto?: { __typename: "UploadedFile"; url: string } | null;
    } | null;
  } | null;
};

export type AdminDeleteLocalTaxPolicyMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalDeleteLocalTaxPolicy:
    | {
        __typename: "InternalDeleteLocalTaxPolicyError";
        case: InternalDeleteLocalTaxPolicyErrorCase;
      }
    | { __typename: "Success" };
};

export type AdminUpdateLocalTaxPolicyMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateLocalTaxPolicyInput;
}>;

export type AdminUpdateLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalUpdateLocalTaxPolicy:
    | {
        __typename: "InternalUpdateLocalTaxPolicyError";
        case: InternalUpdateLocalTaxPolicyErrorCase;
      }
    | {
        __typename: "LocalTaxPolicy";
        id: string;
        effectiveTo?: PlainDateString | null;
      };
};

export type AdminLocalTaxPolicyHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminLocalTaxPolicyHeaderQuery = {
  __typename: "Query";
  internalLocalTaxPolicy: {
    __typename: "LocalTaxPolicy";
    id: string;
    taxType: LocalTaxType;
    localGovernmentName: string;
    type: LocalTaxPolicyType;
  };
};

export type AdminLocalTaxPolicyDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminLocalTaxPolicyDetailQuery = {
  __typename: "Query";
  internalLocalTaxPolicy: {
    __typename: "LocalTaxPolicy";
    id: string;
    taxType: LocalTaxType;
    localGovernmentName: string;
    type: LocalTaxPolicyType;
    effectiveFrom: PlainDateString;
    effectiveTo?: PlainDateString | null;
    waiveKids: boolean;
    brackets: Array<{
      __typename: "LocalTaxBracket";
      id: string;
      minAmount: number;
      maxAmount?: number | null;
      taxAmount?: number | null;
      taxRate?: number | null;
      maxTaxAmount?: number | null;
    }>;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
    accommodations: Array<{
      __typename: "Accommodation";
      id: string;
      name: string;
    }>;
  };
};

export type AdminCreateLocalTaxPolicyMutationVariables = Exact<{
  input: InternalCreateLocalTaxPolicyInput;
}>;

export type AdminCreateLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalCreateLocalTaxPolicy:
    | {
        __typename: "InternalCreateLocalTaxPolicyError";
        case: InternalCreateLocalTaxPolicyErrorCase;
      }
    | { __typename: "LocalTaxPolicy"; id: string };
};

export type AdminLocalTaxPoliciesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminLocalTaxPoliciesQuery = {
  __typename: "Query";
  internalLocalTaxPolicies: Array<{
    __typename: "LocalTaxPolicy";
    id: string;
    taxType: LocalTaxType;
    localGovernmentName: string;
    type: LocalTaxPolicyType;
    effectiveFrom: PlainDateString;
    effectiveTo?: PlainDateString | null;
    sites: Array<{ __typename: "InternalSite"; id: string }>;
    accommodations: Array<{ __typename: "Accommodation"; id: string }>;
  }>;
};

export type AdminCreateOrUpdateNativeAppHomeContentMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalNativeAppHomeContentInput;
}>;

export type AdminCreateOrUpdateNativeAppHomeContentMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateNativeAppHomeContent:
    | {
        __typename: "InternalCreateOrUpdateNativeAppHomeContentError";
        case: InternalCreateOrUpdateNativeAppHomeContentErrorCase;
        message: string;
      }
    | {
        __typename: "InternalNativeAppHomeContent";
        id: string;
        createdAt: ZonedDateTimeString;
        updatedAt: ZonedDateTimeString;
        labelType: NativeAppHomeContentLabelType;
        linkAction: NativeAppHomeContentLinkAction;
        sort: number;
        status: NativeAppHomeContentStatus;
        imageUrl: { __typename: "UploadedFile"; rawUrl: string };
        title?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        } | null;
        description?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        } | null;
        label?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        } | null;
        link: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        };
        linkLabel?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        } | null;
        updatedUser: {
          __typename: "User";
          id: string;
          name: string;
          email: string;
        };
      };
};

export type AdminNativeAppHomeContentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminNativeAppHomeContentsQuery = {
  __typename: "Query";
  internalNativeAppHomeContents: Array<{
    __typename: "InternalNativeAppHomeContent";
    id: string;
    createdAt: ZonedDateTimeString;
    updatedAt: ZonedDateTimeString;
    labelType: NativeAppHomeContentLabelType;
    linkAction: NativeAppHomeContentLinkAction;
    sort: number;
    status: NativeAppHomeContentStatus;
    imageUrl: { __typename: "UploadedFile"; rawUrl: string };
    title?: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
      zhCn?: string | null;
      zhTw?: string | null;
    } | null;
    description?: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
      zhCn?: string | null;
      zhTw?: string | null;
    } | null;
    label?: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
      zhCn?: string | null;
      zhTw?: string | null;
    } | null;
    link: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
      zhCn?: string | null;
      zhTw?: string | null;
    };
    linkLabel?: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
      zhCn?: string | null;
      zhTw?: string | null;
    } | null;
    updatedUser: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    };
  }>;
};

export type AdminCreateNativeAppHomeContentImageUploadPolicyMutationVariables =
  Exact<{ [key: string]: never }>;

export type AdminCreateNativeAppHomeContentImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateNativeAppHomeContentImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminSendPushNotificationsMutationVariables = Exact<{
  input: InternalSendPushNotificationsInput;
}>;

export type AdminSendPushNotificationsMutation = {
  __typename: "Mutation";
  internalSendPushNotifications:
    | {
        __typename: "InternalSendPushNotificationsError";
        case: InternalSendPushNotificationsErrorCase;
        message: string;
      }
    | {
        __typename: "InternalSendPushNotificationsResult";
        deliveredEmails: Array<string>;
        notFoundEmails: Array<string>;
        noDeviceEmails: Array<string>;
        failedEmails: Array<string>;
      };
};

export type NewsTable_RawNewsFragment = {
  __typename: "RawNews";
  id: string;
  title: string;
  publishedAt: ZonedDateTimeString;
  contentType: NewsContentType;
  displayCategory: NewsDisplayCategory;
  content: string;
  status: NewsStatus;
  targetPlans: Array<TargetPlanType>;
  createdUser: { __typename: "User"; id: string; name: string; email: string };
} & { " $fragmentName"?: "NewsTable_RawNewsFragment" };

export type AdminNewsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminNewsQuery = {
  __typename: "Query";
  internalNews: Array<
    { __typename: "RawNews" } & {
      " $fragmentRefs"?: {
        NewsTable_RawNewsFragment: NewsTable_RawNewsFragment;
      };
    }
  >;
};

export type AdminCreateOrUpdateNewsMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateNewsInput;
}>;

export type AdminCreateOrUpdateNewsMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateNews:
    | {
        __typename: "InternalCreateOrUpdateNewsError";
        case: InternalCreateOrUpdateNewsErrorCase;
      }
    | {
        __typename: "News";
        id: string;
        title: string;
        publishedAt: ZonedDateTimeString;
        contentType: NewsContentType;
        displayCategory: NewsDisplayCategory;
        content: string;
      };
};

export type AdminNewsTopPageQueryVariables = Exact<{ [key: string]: never }>;

export type AdminNewsTopPageQuery = {
  __typename: "Query";
  topPage: {
    __typename: "TopPage";
    serviceUpdate?: {
      __typename: "ServiceUpdate";
      title: string;
      url: string;
      publishedAt: ZonedDateTimeString;
      isNew: boolean;
    } | null;
    archiveArticle?: {
      __typename: "ArchiveArticle";
      title: string;
      url: string;
      publishedAt: ZonedDateTimeString;
      isNew: boolean;
    } | null;
    news?: {
      __typename: "News";
      id: string;
      title: string;
      publishedAt: ZonedDateTimeString;
      contentType: NewsContentType;
      content: string;
    } | null;
  };
};

export type OrganizationContractsListTable_OrganizationYearlyContractFragment =
  {
    __typename: "OrganizationYearlyContract";
    id: string;
    status: ContractStatus;
    startMonth: PlainYearMonthString;
    endMonth: PlainYearMonthString;
    amountRecord: number;
    totalFee: number;
    nightsPerYear: number;
    nightsPerMonth: number;
    continuationType: ContractContinuationType;
    createdAt: ZonedDateTimeString;
    createdInvoiceCount: number;
    organization: {
      __typename: "Organization";
      id: string;
      name: string;
      defaultFrequency?: OrganizationYearlyContractInvoiceFrequency | null;
      defaultPaymentMethod?: OrganizationYearlyContractInvoicePaymentMethodType | null;
    };
    businessPlan: { __typename: "BusinessPlan"; id: string; name: string };
  } & {
    " $fragmentName"?: "OrganizationContractsListTable_OrganizationYearlyContractFragment";
  };

export type AdminAllOrganizationContractsQueryVariables = Exact<{
  organizationIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  statuses?: InputMaybe<Array<ContractStatus> | ContractStatus>;
  startMonth?: InputMaybe<PlainYearMonthFilter>;
  endMonth?: InputMaybe<PlainYearMonthFilter>;
  sort?: InputMaybe<OrganizationYearlyContractSortInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  startingAfter?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminAllOrganizationContractsQuery = {
  __typename: "Query";
  internalOrganizationYearlyContracts: {
    __typename: "OrganizationYearlyContractsResult";
    count: number;
    hasMore: boolean;
    nextCursor?: string | null;
    data: Array<
      { __typename: "OrganizationYearlyContract" } & {
        " $fragmentRefs"?: {
          OrganizationContractsListTable_OrganizationYearlyContractFragment: OrganizationContractsListTable_OrganizationYearlyContractFragment;
        };
      }
    >;
  };
};

export type AdminOrganizationContractOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminOrganizationContractOrganizationsQuery = {
  __typename: "Query";
  internalOrganizations: Array<{
    __typename: "Organization";
    id: string;
    name: string;
  }>;
};

export type OrganizationInvoicesListTable_StripeInvoiceFragment = {
  __typename: "StripeInvoice";
  id: string;
  total: number;
  status: StripeInvoiceStatus;
  createdAt: ZonedDateTimeString;
  collection_method?: StripeCollectionMethod | null;
  metadata_list: Array<{
    __typename: "StripeMetadataItem";
    key: string;
    value: string;
  }>;
} & {
  " $fragmentName"?: "OrganizationInvoicesListTable_StripeInvoiceFragment";
};

export type AdminAllOrganizationInvoicesQueryVariables = Exact<{
  organizationIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  statuses?: InputMaybe<Array<StripeInvoiceStatus> | StripeInvoiceStatus>;
  contractStartMonth?: InputMaybe<PlainYearMonthFilter>;
  contractEndMonth?: InputMaybe<PlainYearMonthFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  startingAfter?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminAllOrganizationInvoicesQuery = {
  __typename: "Query";
  internalOrganizationYearlyContractInvoices: {
    __typename: "OrganizationYearlyContractInvoicesResult";
    count: number;
    hasMore: boolean;
    nextCursor?: string | null;
    data: Array<
      { __typename: "StripeInvoice" } & {
        " $fragmentRefs"?: {
          OrganizationInvoicesListTable_StripeInvoiceFragment: OrganizationInvoicesListTable_StripeInvoiceFragment;
        };
      }
    >;
  };
};

export type AdminOrganizationInvoiceOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminOrganizationInvoiceOrganizationsQuery = {
  __typename: "Query";
  internalOrganizations: Array<{
    __typename: "Organization";
    id: string;
    name: string;
  }>;
};

export type OrganizationContractsTable_OrganizationYearlyContractFragment = {
  __typename: "OrganizationYearlyContract";
  id: string;
  status: ContractStatus;
  startMonth: PlainYearMonthString;
  endMonth: PlainYearMonthString;
  amountRecord: number;
  totalFee: number;
  nightsPerYear: number;
  nightsPerMonth: number;
  continuationType: ContractContinuationType;
  businessPlan: { __typename: "BusinessPlan"; id: string; name: string };
} & {
  " $fragmentName"?: "OrganizationContractsTable_OrganizationYearlyContractFragment";
};

export type AdminBusinessPlansForContractQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminBusinessPlansForContractQuery = {
  __typename: "Query";
  internalBusinessPlans: Array<{
    __typename: "BusinessPlan";
    id: string;
    name: string;
  }>;
};

export type AdminCreateOrUpdateOrganizationYearlyContractMutationVariables =
  Exact<{
    organizationId: Scalars["ID"]["input"];
    contractId?: InputMaybe<Scalars["ID"]["input"]>;
    input: CreateOrUpdateOrganizationYearlyContractInput;
  }>;

export type AdminCreateOrUpdateOrganizationYearlyContractMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateOrganizationYearlyContract:
    | {
        __typename: "InternalCreateOrUpdateOrganizationYearlyContractError";
        message: string;
      }
    | {
        __typename: "OrganizationYearlyContract";
        id: string;
        status: ContractStatus;
        startMonth: PlainYearMonthString;
        endMonth: PlainYearMonthString;
        amountRecord: number;
        totalFee: number;
        nightsPerYear: number;
        nightsPerMonth: number;
        continuationType: ContractContinuationType;
        businessPlan: { __typename: "BusinessPlan"; id: string; name: string };
      };
};

export type AdminInvalidateOrganizationYearlyContractMutationVariables = Exact<{
  contractId: Scalars["ID"]["input"];
}>;

export type AdminInvalidateOrganizationYearlyContractMutation = {
  __typename: "Mutation";
  internalInvalidateOrganizationYearlyContract:
    | {
        __typename: "InternalInvalidateOrganizationYearlyContractError";
        case: InternalInvalidateOrganizationYearlyContractErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminOrganizationContractsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminOrganizationContractsQuery = {
  __typename: "Query";
  internalOrganization: {
    __typename: "Organization";
    id: string;
    name: string;
    contracts: Array<
      { __typename: "OrganizationYearlyContract" } & {
        " $fragmentRefs"?: {
          OrganizationContractsTable_OrganizationYearlyContractFragment: OrganizationContractsTable_OrganizationYearlyContractFragment;
        };
      }
    >;
  };
};

export type OrganizationInvoicesTable_StripeInvoiceFragment = {
  __typename: "StripeInvoice";
  id: string;
  total: number;
  description?: string | null;
  status: StripeInvoiceStatus;
  hosted_invoice_url?: string | null;
  createdAt: ZonedDateTimeString;
  collection_method?: StripeCollectionMethod | null;
  metadata_list: Array<{
    __typename: "StripeMetadataItem";
    key: string;
    value: string;
  }>;
} & { " $fragmentName"?: "OrganizationInvoicesTable_StripeInvoiceFragment" };

export type AdminUpdateOrganizationYearlyContractInvoiceMutationVariables =
  Exact<{
    invoiceId: Scalars["ID"]["input"];
    input: CreateOrUpdateOrganizationYearlyContractInvoiceInput;
  }>;

export type AdminUpdateOrganizationYearlyContractInvoiceMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateOrganizationYearlyContractInvoice:
    | {
        __typename: "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError";
        case: InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminFinalizeOrganizationYearlyContractInvoiceMutationVariables =
  Exact<{
    invoiceId: Scalars["ID"]["input"];
  }>;

export type AdminFinalizeOrganizationYearlyContractInvoiceMutation = {
  __typename: "Mutation";
  internalFinalizeOrganizationYearlyContractInvoice: boolean;
};

export type AdminInvalidateOrganizationYearlyContractInvoiceMutationVariables =
  Exact<{
    invoiceId: Scalars["ID"]["input"];
  }>;

export type AdminInvalidateOrganizationYearlyContractInvoiceMutation = {
  __typename: "Mutation";
  internalInvalidateOrganizationYearlyContractInvoice:
    | {
        __typename: "InternalInvalidateOrganizationYearlyContractInvoiceError";
        case: InternalInvalidateOrganizationYearlyContractInvoiceErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminCreateOrganizationYearlyContractInvoiceMutationVariables =
  Exact<{
    contractId: Scalars["ID"]["input"];
    input: CreateOrUpdateOrganizationYearlyContractInvoiceInput;
  }>;

export type AdminCreateOrganizationYearlyContractInvoiceMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateOrganizationYearlyContractInvoice:
    | {
        __typename: "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError";
        case: InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminBulkCreateOrganizationYearlyContractInvoicesMutationVariables =
  Exact<{
    contractId: Scalars["ID"]["input"];
    input: BulkCreateOrganizationYearlyContractInvoicesInput;
  }>;

export type AdminBulkCreateOrganizationYearlyContractInvoicesMutation = {
  __typename: "Mutation";
  internalBulkCreateOrganizationYearlyContractInvoices:
    | {
        __typename: "InternalBulkCreateOrganizationYearlyContractInvoicesError";
        case: InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase;
        createdCount: number;
        orphanedInvoiceIds: Array<string>;
      }
    | {
        __typename: "InternalBulkCreateOrganizationYearlyContractInvoicesSuccess";
        invoiceIds: Array<string>;
      };
};

export type AdminOrganizationInvoicesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminOrganizationInvoicesQuery = {
  __typename: "Query";
  internalOrganization: {
    __typename: "Organization";
    id: string;
    name: string;
    defaultFrequency?: OrganizationYearlyContractInvoiceFrequency | null;
    defaultPaymentMethod?: OrganizationYearlyContractInvoicePaymentMethodType | null;
    contracts: Array<{
      __typename: "OrganizationYearlyContract";
      id: string;
      startMonth: PlainYearMonthString;
      endMonth: PlainYearMonthString;
    }>;
    stripe: {
      __typename: "StripeCustomer";
      customerId: string;
      invoices: Array<
        { __typename: "StripeInvoice" } & {
          " $fragmentRefs"?: {
            OrganizationInvoicesTable_StripeInvoiceFragment: OrganizationInvoicesTable_StripeInvoiceFragment;
          };
        }
      >;
    };
  };
};

export type AdminOrganizationMemberCandidatesQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdminOrganizationMemberCandidatesQuery = {
  __typename: "Query";
  internalUsersSearch: {
    __typename: "InternalUserSearchResult";
    totalCount: number;
    users: Array<{
      __typename: "User";
      id: string;
      name: string;
      email: string;
      organizationMembership?: {
        __typename: "OrganizationMembership";
        id: string;
        organization: { __typename: "Organization"; id: string; name: string };
      } | null;
    }>;
  };
};

export type AdminJoinOrganizationMutationVariables = Exact<{
  userEmail: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
  role: OrganizationRole;
}>;

export type AdminJoinOrganizationMutation = {
  __typename: "Mutation";
  internalJoinOrganization: boolean;
};

export type OrganizationMembersTable_UserFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  organizationMembership?: {
    __typename: "OrganizationMembership";
    id: string;
    role: OrganizationRole;
    reservationStatus: OrganizationMemberReservationStatus;
  } | null;
} & { " $fragmentName"?: "OrganizationMembersTable_UserFragment" };

export type AdminOrganizationMembersQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminOrganizationMembersQuery = {
  __typename: "Query";
  internalOrganization: {
    __typename: "Organization";
    id: string;
    name: string;
    members: Array<
      { __typename: "User" } & {
        " $fragmentRefs"?: {
          OrganizationMembersTable_UserFragment: OrganizationMembersTable_UserFragment;
        };
      }
    >;
  };
};

export type AdminUpdateOrganizationMembershipMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  organizationId: Scalars["ID"]["input"];
  role: OrganizationRole;
}>;

export type AdminUpdateOrganizationMembershipMutation = {
  __typename: "Mutation";
  partialUpdateOrganizationMembership:
    | {
        __typename: "OrganizationMembership";
        id: string;
        role: OrganizationRole;
      }
    | {
        __typename: "PartialUpdateOrganizationMembershipError";
        message: string;
      };
};

export type AdminLeaveOrganizationMutationVariables = Exact<{
  userEmail: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
}>;

export type AdminLeaveOrganizationMutation = {
  __typename: "Mutation";
  internalLeaveOrganization:
    | {
        __typename: "InternalLeaveOrganizationError";
        case: InternalLeaveOrganizationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminOrganizationHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminOrganizationHeaderQuery = {
  __typename: "Query";
  internalOrganization: {
    __typename: "Organization";
    id: string;
    name: string;
    displayName?: string | null;
    stripe: { __typename: "StripeCustomer"; customerId: string };
    assignedUser?: { __typename: "User"; id: string; name: string } | null;
  };
};

export type AdminOrganizationInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminOrganizationInfoQuery = {
  __typename: "Query";
  internalOrganization: { __typename: "Organization"; id: string } & {
    " $fragmentRefs"?: {
      OrganizationStatus_OrganizationFragment: OrganizationStatus_OrganizationFragment;
      OrganizationInfo_OrganizationFragment: OrganizationInfo_OrganizationFragment;
      OrganizationFormSheet_OrganizationFragment: OrganizationFormSheet_OrganizationFragment;
    };
  };
};

export type OrganizationInfo_OrganizationFragment = {
  __typename: "Organization";
  invitationCode: string;
  emailDomainsForMember?: Array<string> | null;
  billingEmail?: string | null;
  announcementContent: string;
  paymentMethodCardEnabled: boolean;
  defaultFrequency?: OrganizationYearlyContractInvoiceFrequency | null;
  defaultPaymentMethod?: OrganizationYearlyContractInvoicePaymentMethodType | null;
  control: {
    __typename: "OrganizationControl";
    maxNightsPerStay?: number | null;
    maxNightsPerMember?: number | null;
    maxNightsPerMonth?: number | null;
  };
  assignedUser?: { __typename: "User"; id: string; name: string } | null;
  memberCustomField: {
    __typename: "OrganizationMemberCustomField";
    enabled: boolean;
    name?: string | null;
    placeholder?: string | null;
    required: boolean;
  };
} & { " $fragmentName"?: "OrganizationInfo_OrganizationFragment" };

export type OrganizationStatus_OrganizationFragment = {
  __typename: "Organization";
  suspended: boolean;
  membersStay: {
    __typename: "OrganizationMembersStay";
    usedNightsInCurrentContract: number;
  };
  currentOrUpcomingContract?: {
    __typename: "OrganizationYearlyContract";
    id: string;
    status: ContractStatus;
    startMonth: PlainYearMonthString;
    endMonth: PlainYearMonthString;
    nightsPerYear: number;
  } | null;
} & { " $fragmentName"?: "OrganizationStatus_OrganizationFragment" };

export type OrganizationReservationsTable_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  firstNight: PlainDateString;
  lastDate: PlainDateString;
  nights: number;
  isTentative: boolean;
  hasCanceled: boolean;
  stayStatus: AccommodationReservationStayStatus;
  user?: { __typename: "User"; id: string; name: string } | null;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    code: string;
    site: { __typename: "Site"; id: string; name: string };
  };
} & {
  " $fragmentName"?: "OrganizationReservationsTable_AccommodationReservationFragment";
};

export type AdminOrganizationReservationsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminOrganizationReservationsQuery = {
  __typename: "Query";
  internalOrganization: {
    __typename: "Organization";
    id: string;
    contracts: Array<{
      __typename: "OrganizationYearlyContract";
      id: string;
      status: ContractStatus;
      startMonth: PlainYearMonthString;
      endMonth: PlainYearMonthString;
      nightsPerYear: number;
      usedNightsPerYear: number;
      scheduledNightsPerYear: number;
      remainingNightsPerYear: number;
      businessPlan: { __typename: "BusinessPlan"; id: string; name: string };
      accommodationReservations: Array<
        { __typename: "AccommodationReservation" } & {
          " $fragmentRefs"?: {
            OrganizationReservationsTable_AccommodationReservationFragment: OrganizationReservationsTable_AccommodationReservationFragment;
          };
        }
      >;
    }>;
  };
};

export type OrganizationFormSheet_OrganizationFragment = {
  __typename: "Organization";
  id: string;
  name: string;
  displayName?: string | null;
  invitationCode: string;
  billingEmail?: string | null;
  emailDomainsForMember?: Array<string> | null;
  suspended: boolean;
  paymentMethodCardEnabled: boolean;
  defaultFrequency?: OrganizationYearlyContractInvoiceFrequency | null;
  defaultPaymentMethod?: OrganizationYearlyContractInvoicePaymentMethodType | null;
  announcementContent: string;
  control: {
    __typename: "OrganizationControl";
    maxNightsPerStay?: number | null;
    maxNightsPerMember?: number | null;
    maxNightsPerMonth?: number | null;
  };
  memberCustomField: {
    __typename: "OrganizationMemberCustomField";
    enabled: boolean;
    name?: string | null;
    placeholder?: string | null;
    required: boolean;
  };
  assignedUser?: { __typename: "User"; id: string; email: string } | null;
} & { " $fragmentName"?: "OrganizationFormSheet_OrganizationFragment" };

export type AdminCreateOrUpdateOrganizationMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateOrganizationInput;
}>;

export type AdminCreateOrUpdateOrganizationMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateOrganization:
    | {
        __typename: "InternalCreateOrUpdateOrganizationError";
        case: InternalCreateOrUpdateOrganizationErrorCase;
        message: string;
      }
    | {
        __typename: "Organization";
        id: string;
        name: string;
        displayName?: string | null;
        invitationCode: string;
        emailDomainsForMember?: Array<string> | null;
        suspended: boolean;
        billingEmail?: string | null;
        paymentMethodCardEnabled: boolean;
        defaultFrequency?: OrganizationYearlyContractInvoiceFrequency | null;
        defaultPaymentMethod?: OrganizationYearlyContractInvoicePaymentMethodType | null;
        announcementContent: string;
        control: {
          __typename: "OrganizationControl";
          maxNightsPerStay?: number | null;
          maxNightsPerMember?: number | null;
          maxNightsPerMonth?: number | null;
        };
        memberCustomField: {
          __typename: "OrganizationMemberCustomField";
          enabled: boolean;
          name?: string | null;
          placeholder?: string | null;
          required: boolean;
        };
        assignedUser?: {
          __typename: "User";
          id: string;
          name: string;
          email: string;
        } | null;
      };
};

export type AdminOrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminOrganizationsQuery = {
  __typename: "Query";
  internalOrganizations: Array<{
    __typename: "Organization";
    id: string;
    name: string;
    displayName?: string | null;
    invitationCode: string;
    suspended: boolean;
    assignedUser?: { __typename: "User"; id: string; name: string } | null;
    currentOrUpcomingContract?: {
      __typename: "OrganizationYearlyContract";
      id: string;
      status: ContractStatus;
      startMonth: PlainYearMonthString;
      endMonth: PlainYearMonthString;
    } | null;
  }>;
};

export type AdminOwnerPlanDetailQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminOwnerPlanDetailQuery = {
  __typename: "Query";
  internalOwnerPlans: Array<{
    __typename: "OwnerPlan";
    id: string;
    type: OwnerPlanType;
    name: string;
    managedName: string;
    dogFriendlyFilter?: AccommodationFacilityFilterType | null;
    unitNightsPerYear: number;
    unitPurchaseAmount: number;
    unitApplicationFee: number;
    unitBuildingFee: number;
    totalUnits: number;
    baseAccommodationFeePerNight: number;
    nonOwnedBaseAccommodationFeePerNight: number;
    registrationFee: number;
    unitAnnualMaintenanceFee: number;
    unitAnnualRepairReserve: number;
    unitAnnualLandRentFee: number;
    unitAnnualFireInsuranceFee: number;
    unitAnnualPropertyTax: number;
    unitAnnualOnsenFee: number;
    formOfRights: string;
    siteSizeSqm: number;
    leasedLandSizeSqm: number;
    guestRoomSizeSqm: number;
    balconySizeSqm: number;
    limitPeakDays: boolean;
    coOwnersMaxPeakDaysPerUnit?: number | null;
    coOwnersMaxConcurrentReservationsPerUnit?: number | null;
    handoverStartDate?: PlainYearMonthString | null;
    registrationFeeAdvancePaymentDeadline?: PlainDateString | null;
    advancePaymentRequired: boolean;
    site: { __typename: "Site"; id: string; name: string };
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    } | null;
    accommodation?: {
      __typename: "Accommodation";
      id: string;
      name: string;
    } | null;
    accommodationFacilities: Array<{
      __typename: "AccommodationFacility";
      id: string;
      type: AccommodationFacilityType;
    }>;
    internalCoOwnersPlanOfferings: Array<{
      __typename: "CoOwnersPlanOffering";
      id: string;
      units: number;
      isHidden: boolean;
      isSoldOut: boolean;
      earlyAccessCode?: string | null;
      estimate?: {
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      } | null;
    }>;
  }>;
};

export type AdminCreateOrUpdateCoOwnersPlanOfferingMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateCoOwnersPlanOfferingInput;
}>;

export type AdminCreateOrUpdateCoOwnersPlanOfferingMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateCoOwnersPlanOffering:
    | {
        __typename: "CoOwnersPlanOffering";
        id: string;
        units: number;
        isHidden: boolean;
        isSoldOut: boolean;
        earlyAccessCode?: string | null;
        estimate?: {
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
        } | null;
      }
    | {
        __typename: "InternalCreateOrUpdateCoOwnersPlanOfferingError";
        case: InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase;
      };
};

export type AdminCreateSanuOwnerPlanFileUploadPolicyMutationVariables = Exact<{
  input: CreateSanuOwnerPlanFileUploadPolicyInput;
}>;

export type AdminCreateSanuOwnerPlanFileUploadPolicyMutation = {
  __typename: "Mutation";
  createSanuOwnerPlanFileUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminOwnerPlanFormOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminOwnerPlanFormOptionsQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
  }>;
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    type: AccommodationFacilityType;
  }>;
};

export type AdminOwnerPlanAccommodationsQueryVariables = Exact<{
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type AdminOwnerPlanAccommodationsQuery = {
  __typename: "Query";
  internalAccommodations: Array<{
    __typename: "Accommodation";
    id: string;
    name: string;
    code: string;
    architectureType: { __typename: "ArchitectureType"; id: string };
  }>;
};

export type AdminCreateOrUpdateOwnerPlanMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateOwnerPlanInput;
}>;

export type AdminCreateOrUpdateOwnerPlanMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateOwnerPlan:
    | {
        __typename: "InternalCreateOrUpdateOwnerPlanError";
        case: InternalCreateOrUpdateOwnerPlanErrorCase;
      }
    | {
        __typename: "OwnerPlan";
        id: string;
        type: OwnerPlanType;
        name: string;
        managedName: string;
        dogFriendlyFilter?: AccommodationFacilityFilterType | null;
        unitNightsPerYear: number;
        unitPurchaseAmount: number;
        unitApplicationFee: number;
        unitBuildingFee: number;
        totalUnits: number;
        baseAccommodationFeePerNight: number;
        nonOwnedBaseAccommodationFeePerNight: number;
        registrationFee: number;
        unitAnnualMaintenanceFee: number;
        unitAnnualRepairReserve: number;
        unitAnnualLandRentFee: number;
        unitAnnualFireInsuranceFee: number;
        unitAnnualPropertyTax: number;
        unitAnnualOnsenFee: number;
        formOfRights: string;
        siteSizeSqm: number;
        leasedLandSizeSqm: number;
        guestRoomSizeSqm: number;
        balconySizeSqm: number;
        limitPeakDays: boolean;
        coOwnersMaxPeakDaysPerUnit?: number | null;
        handoverStartDate?: PlainYearMonthString | null;
        registrationFeeAdvancePaymentDeadline?: PlainDateString | null;
        site: { __typename: "Site"; id: string; name: string };
        architectureType?: {
          __typename: "ArchitectureType";
          id: string;
          name: string;
        } | null;
        accommodation?: {
          __typename: "Accommodation";
          id: string;
          name: string;
        } | null;
        accommodationFacilities: Array<{
          __typename: "AccommodationFacility";
          id: string;
          type: AccommodationFacilityType;
        }>;
      };
};

export type AdminOwnerPlansQueryVariables = Exact<{ [key: string]: never }>;

export type AdminOwnerPlansQuery = {
  __typename: "Query";
  internalOwnerPlans: Array<{
    __typename: "OwnerPlan";
    id: string;
    type: OwnerPlanType;
    managedName: string;
    totalUnits: number;
    unitNightsPerYear: number;
    unitPurchaseAmount: number;
    handoverStartDate?: PlainYearMonthString | null;
    site: { __typename: "Site"; id: string; slug: string; name: string };
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    } | null;
    accommodation?: {
      __typename: "Accommodation";
      id: string;
      name: string;
    } | null;
    accommodationFacilities: Array<{
      __typename: "AccommodationFacility";
      id: string;
      type: AccommodationFacilityType;
    }>;
  }>;
};

export type CompanionDetailSheet_UserCompanionFragment = {
  __typename: "UserCompanion";
  name: string;
  gender: GenderType;
  birthDate: PlainDateString;
  phoneNumber?: string | null;
  professionType?: UserProfileProfessionType | null;
  nationality?: CountryEnum | null;
  passportNumber?: string | null;
  passportPhoto?: { __typename: "UploadedFile"; url: string } | null;
  address:
    | {
        __typename: "AddressInJapan";
        postalCode: string;
        line1: string;
        japanLine2: string;
      }
    | {
        __typename: "AddressInternational";
        line1: string;
        city: string;
        stateProvince: string;
        postalCode: string;
        country: CountryEnum;
        intlLine2?: string | null;
      };
} & { " $fragmentName"?: "CompanionDetailSheet_UserCompanionFragment" };

export type AdminUpsertConsumedSupplyFeeItemWaiversMutationVariables = Exact<{
  input: InternalUpsertConsumedSupplyFeeItemWaiversInput;
}>;

export type AdminUpsertConsumedSupplyFeeItemWaiversMutation = {
  __typename: "Mutation";
  internalUpsertConsumedSupplyFeeItemWaivers:
    | {
        __typename: "InternalUpsertConsumedSupplyFeeItemWaiversError";
        message: string;
      }
    | { __typename: "Success" };
};

export type ReservationBasicInfo_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  stayStatus: AccommodationReservationStayStatus;
  isTentative: boolean;
  firstNight: PlainDateString;
  lastNight: PlainDateString;
  lastDate: PlainDateString;
  nights: number;
  createdAt: DateTimeString;
  tentativeDeadline?: ZonedDateTimeString | null;
  checkedInAt?: ZonedDateTimeString | null;
  checkedOutAt?: ZonedDateTimeString | null;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  stayTicketUnit?: {
    __typename: "StayTicketUnit";
    id: string;
    stayTicketMasterId?: string | null;
    reservationInfo: { __typename: "StayTicketReservationInfo"; name: string };
    stayTickets: Array<{ __typename: "StayTicket"; id: string; code: string }>;
  } | null;
  otaDetail?: {
    __typename: "AccommodationReservationOtaDetail";
    referer?: string | null;
    apiReference?: string | null;
  } | null;
  user?: { __typename: "User"; id: string; name: string } | null;
  createdUser?: { __typename: "User"; id: string; name: string } | null;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    code: string;
    site: { __typename: "Site"; id: string; name: string };
    architectureType: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    };
  };
  fee: {
    __typename: "AccommodationFee";
    totalAmount: number;
    status?: AccommodationFeeStatus | null;
    items: Array<{
      __typename: "AccommodationFeeItem";
      key: string;
      label: string;
      amount: number;
      night?: PlainDateString | null;
    }>;
  };
  consumedSuppliesFee: {
    __typename: "ConsumedSuppliesFee";
    items: Array<{
      __typename: "ConsumedSuppliesFeeItem";
      label: string;
      amount: number;
    }>;
  };
  facilityFee: {
    __typename: "FacilityFee";
    items: Array<{
      __typename: "FacilityFeeItem";
      label: string;
      amount: number;
    }>;
  };
} & {
  " $fragmentName"?: "ReservationBasicInfo_AccommodationReservationFragment";
};

export type AdminReservationBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationBasicInfoQuery = {
  __typename: "Query";
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationBasicInfo_AccommodationReservationFragment: ReservationBasicInfo_AccommodationReservationFragment;
    };
  };
};

export type AdminCheckInAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CheckInAccommodationReservationInput;
}>;

export type AdminCheckInAccommodationReservationMutation = {
  __typename: "Mutation";
  internalCheckInAccommodationReservation:
    | ({ __typename: "AccommodationReservation" } & {
        " $fragmentRefs"?: {
          ReservationStayStatusTab_AccommodationReservationFragment: ReservationStayStatusTab_AccommodationReservationFragment;
        };
      })
    | {
        __typename: "CheckInAccommodationReservationError";
        case: CheckInAccommodationReservationErrorCase;
      };
};

export type ReservationCompanionsTab_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  user?: {
    __typename: "User";
    id: string;
    name: string;
    nameKana?: string | null;
    email: string;
    phoneNumber?: string | null;
  } | null;
  detail: {
    __typename: "AccommodationReservationDetail";
    numberOfAdults: number;
    numberOfKids: number;
    numberOfInfants: number;
    numberOfDogs: number;
  };
  userCompanions: Array<
    {
      __typename: "UserCompanion";
      id: string;
      name: string;
      gender: GenderType;
      birthDate: PlainDateString;
      phoneNumber?: string | null;
    } & {
      " $fragmentRefs"?: {
        CompanionDetailSheet_UserCompanionFragment: CompanionDetailSheet_UserCompanionFragment;
      };
    }
  >;
} & {
  " $fragmentName"?: "ReservationCompanionsTab_AccommodationReservationFragment";
};

export type AdminReservationCompanionsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationCompanionsQuery = {
  __typename: "Query";
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationCompanionsTab_AccommodationReservationFragment: ReservationCompanionsTab_AccommodationReservationFragment;
    };
  };
};

export type ReservationDetailHeader_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  stayStatus: AccommodationReservationStayStatus;
  firstNight: PlainDateString;
  lastDate: PlainDateString;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  accommodation: {
    __typename: "Accommodation";
    code: string;
    site: { __typename: "Site"; id: string; name: string };
  };
  user?: { __typename: "User"; id: string; name: string } | null;
  fee: { __typename: "AccommodationFee"; stripeInvoiceId?: string | null };
} & {
  " $fragmentName"?: "ReservationDetailHeader_AccommodationReservationFragment";
};

export type AdminReservationHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationHeaderQuery = {
  __typename: "Query";
  internalStripeDashboardBaseUrl: string;
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationDetailHeader_AccommodationReservationFragment: ReservationDetailHeader_AccommodationReservationFragment;
    };
  };
};

export type AdminReservationFacilitiesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationFacilitiesQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    facilityReservations: Array<
      {
        __typename: "FacilityReservation";
        id: string;
        startAt: PlainDateTimeString;
        endAt: PlainDateTimeString;
        units: number;
        chargedFeeAmount: number;
        status: FacilityReservationStatusType;
        user: { __typename: "User"; id: string; name: string };
        resource: {
          __typename: "FacilityResource";
          id: string;
          name: string;
          facility: {
            __typename: "Facility";
            id: string;
            name: string;
            type: FacilityType;
          };
        };
      } & {
        " $fragmentRefs"?: {
          FacilityReservationDetailSheet_FacilityReservationFragment: FacilityReservationDetailSheet_FacilityReservationFragment;
        };
      }
    >;
  };
};

export type ReservationReviewTab_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  stayReviewV2?: {
    __typename: "StayReviewV2";
    id: string;
    submittedAt?: ZonedDateTimeString | null;
    memorableExperiences: Array<StayReviewMemorableExperience>;
    architectureAndNatureRating?: number | null;
    cleaningRating?: number | null;
    equipmentRating?: number | null;
    guidanceAndSupportRating?: number | null;
    comment?: string | null;
    concerns: Array<{
      __typename: "StayReviewV2Concern";
      kind: StayReviewConcernKind;
      details: Array<StayReviewConcernDetail>;
      comment?: string | null;
    }>;
  } | null;
  stayReviewResponse?: {
    __typename: "StayReviewResponse";
    id: string;
    rating: number;
    freeTextAtCheckOutAnswer: string;
    freeTextAfterCheckOutAnswer: string;
    questionnaire: {
      __typename: "StayReviewQuestionnaire";
      selectionAtCheckOut: {
        __typename: "StayReviewSelectionQuestion";
        title: string;
      };
      freeTextAtCheckOut: {
        __typename: "StayReviewFreeTextQuestion";
        title: string;
      };
      selectionAfterCheckOut: {
        __typename: "StayReviewSelectionQuestion";
        title: string;
      };
      freeTextAfterCheckOut: {
        __typename: "StayReviewFreeTextQuestion";
        title: string;
      };
    };
    selectionAtCheckOutAnswer: Array<{
      __typename: "StayReviewSelectionOption";
      key: string;
      label: string;
    }>;
    selectionAfterCheckOutAnswer: Array<{
      __typename: "StayReviewSelectionOption";
      key: string;
      label: string;
    }>;
  } | null;
} & {
  " $fragmentName"?: "ReservationReviewTab_AccommodationReservationFragment";
};

export type AdminReservationReviewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationReviewQuery = {
  __typename: "Query";
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationReviewTab_AccommodationReservationFragment: ReservationReviewTab_AccommodationReservationFragment;
    };
  };
  stayReviewV2Form: {
    __typename: "StayReviewV2Form";
    memorableExperiences: Array<{
      __typename: "StayReviewMemorableExperienceOption";
      value: StayReviewMemorableExperience;
      label: string;
    }>;
    axes: Array<{
      __typename: "StayReviewAxisDefinition";
      axis: StayReviewAxis;
      label: string;
      concernKinds: Array<{
        __typename: "StayReviewConcernKindDefinition";
        kind: StayReviewConcernKind;
        label: string;
        details: Array<{
          __typename: "StayReviewConcernDetailOption";
          value: StayReviewConcernDetail;
          label: string;
        }>;
      }>;
    }>;
  };
};

export type ReservationStaffGroup_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | {
        __typename: "SanuIncAccommodationReservationProvider";
        usage: AccommodationReservationProviderSanuIncUsage;
        staffGroup?: {
          __typename: "StaffGroup";
          id: string;
          name: string;
          fullName?: string | null;
        } | null;
      }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
} & {
  " $fragmentName"?: "ReservationStaffGroup_AccommodationReservationFragment";
};

export type AdminReservationStaffGroupQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationStaffGroupQuery = {
  __typename: "Query";
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationStaffGroup_AccommodationReservationFragment: ReservationStaffGroup_AccommodationReservationFragment;
    };
  };
};

export type ReservationStayStatusTab_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  stayStatus: AccommodationReservationStayStatus;
  hasCanceled: boolean;
  canceledAt?: ZonedDateTimeString | null;
  createdAt: DateTimeString;
  accessCode?: string | null;
  checkedInAt?: ZonedDateTimeString | null;
  checkedOutAt?: ZonedDateTimeString | null;
  firstNight: PlainDateString;
  lastDate: PlainDateString;
  checkedInGeoLocation?: {
    __typename: "GeoLocation";
    latitude: number;
    longitude: number;
  } | null;
  checkInQrCode?: {
    __typename: "CheckInQrCode";
    code: string;
    status: CheckInQrCodeStatus;
    verifiedAt?: ZonedDateTimeString | null;
    expiresAt: ZonedDateTimeString;
  } | null;
  detail: {
    __typename: "AccommodationReservationDetail";
    numberOfDogs: number;
  };
  user?: { __typename: "User"; id: string; name: string; email: string } | null;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    code: string;
    site: { __typename: "Site"; id: string; name: string };
  };
} & {
  " $fragmentName"?: "ReservationStayStatusTab_AccommodationReservationFragment";
};

export type AdminReservationStayStatusQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationStayStatusQuery = {
  __typename: "Query";
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationStayStatusTab_AccommodationReservationFragment: ReservationStayStatusTab_AccommodationReservationFragment;
    };
  };
};

export type AdminAssignAccessCodeToAccommodationReservationMutationVariables =
  Exact<{
    reservationId: Scalars["ID"]["input"];
  }>;

export type AdminAssignAccessCodeToAccommodationReservationMutation = {
  __typename: "Mutation";
  internalAssignAccessCodeToAccommodationReservation:
    | ({
        __typename: "AccommodationReservation";
        id: string;
        accessCode?: string | null;
      } & {
        " $fragmentRefs"?: {
          ReservationStayStatusTab_AccommodationReservationFragment: ReservationStayStatusTab_AccommodationReservationFragment;
        };
      })
    | {
        __typename: "InternalAssignAccessCodeToAccommodationReservationError";
        internalCode: string;
      };
};

export type ReservationTicketsTab_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  stayStatus: AccommodationReservationStayStatus;
  tentativeDeadline?: ZonedDateTimeString | null;
  invitationUrl?: string | null;
  user?: { __typename: "User"; id: string; name: string } | null;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  accommodation: {
    __typename: "Accommodation";
    code: string;
    site: { __typename: "Site"; name: string };
  };
  stayTicketUnit?: {
    __typename: "StayTicketUnit";
    id: string;
    reservationInfo: {
      __typename: "StayTicketReservationInfo";
      type: StayTicketType;
      name: string;
    };
    stayTickets: Array<{
      __typename: "StayTicket";
      id: string;
      code: string;
      status: StayTicketStatusType;
      expiresAt: ZonedDateTimeString;
      stayStartNight: PlainDateString;
      stayEndNight: PlainDateString;
    }>;
  } | null;
} & {
  " $fragmentName"?: "ReservationTicketsTab_AccommodationReservationFragment";
};

export type AdminReservationTicketsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationTicketsQuery = {
  __typename: "Query";
  accommodationReservation: { __typename: "AccommodationReservation" } & {
    " $fragmentRefs"?: {
      ReservationTicketsTab_AccommodationReservationFragment: ReservationTicketsTab_AccommodationReservationFragment;
    };
  };
};

export type AdminReservationWaiversQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminReservationWaiversQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    fee: {
      __typename: "AccommodationFee";
      consumedSupplyFeeItemWaivers: Array<
        { __typename: "ConsumedSupplyFeeItemWaiver" } & {
          " $fragmentRefs"?: {
            ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment: ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment;
          };
        }
      >;
    };
    consumedSuppliesFee: {
      __typename: "ConsumedSuppliesFee";
      items: Array<
        { __typename: "ConsumedSuppliesFeeItem" } & {
          " $fragmentRefs"?: {
            ReservationWaivers_ConsumedSuppliesFeeItemFragment: ReservationWaivers_ConsumedSuppliesFeeItemFragment;
          };
        }
      >;
    };
  };
};

export type AdminResetTentativeReservationUserMutationVariables = Exact<{
  reservationId: Scalars["ID"]["input"];
}>;

export type AdminResetTentativeReservationUserMutation = {
  __typename: "Mutation";
  internalResetTentativeReservationUser: boolean;
};

export type AdminReservationAreasQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminReservationAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    slug: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      slug: string;
      accommodations: Array<{
        __typename: "Accommodation";
        id: string;
        code: string;
        name: string;
      }>;
    }>;
  }>;
};

export type AdminReservationsQueryVariables = Exact<{
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  accommodationScope?: InputMaybe<AccommodationScope>;
  withAccessCode: Scalars["Boolean"]["input"];
  withFee: Scalars["Boolean"]["input"];
}>;

export type AdminReservationsQuery = {
  __typename: "Query";
  internalAccommodationReservationsBySearch: Array<{
    __typename: "AccommodationReservation";
    id: string;
    createdAt: DateTimeString;
    guestName?: string | null;
    firstNight: PlainDateString;
    lastDate: PlainDateString;
    nights: number;
    checkedInAt?: ZonedDateTimeString | null;
    checkedOutAt?: ZonedDateTimeString | null;
    stayStatus: AccommodationReservationStayStatus;
    accessCode?: string | null;
    user?: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    } | null;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      code: string;
      site: { __typename: "Site"; id: string; name: string };
    };
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      numberOfDogs: number;
    };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    fee?: { __typename: "AccommodationFee"; totalAmount: number };
  }>;
};

export type AdminReservationsExportQueryVariables = Exact<{
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  accommodationScope?: InputMaybe<AccommodationScope>;
}>;

export type AdminReservationsExportQuery = {
  __typename: "Query";
  internalAccommodationReservationsForExport: Array<{
    __typename: "AccommodationReservation";
    id: string;
    createdAt: DateTimeString;
    guestName?: string | null;
    firstNight: PlainDateString;
    lastDate: PlainDateString;
    nights: number;
    checkedInAt?: ZonedDateTimeString | null;
    checkedOutAt?: ZonedDateTimeString | null;
    stayStatus: AccommodationReservationStayStatus;
    user?: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    } | null;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      code: string;
      site: { __typename: "Site"; id: string; name: string };
    };
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      numberOfDogs: number;
    };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    fee: { __typename: "AccommodationFee"; totalAmount: number };
  }>;
};

export type AdminRunOneShotScriptMutationVariables = Exact<{
  input: InternalRunOneShotScriptInput;
}>;

export type AdminRunOneShotScriptMutation = {
  __typename: "Mutation";
  internalRunOneShotScript:
    | {
        __typename: "InternalRunOneShotScriptError";
        case: InternalRunOneShotScriptErrorCase;
        message: string;
      }
    | {
        __typename: "InternalScriptExecution";
        id: string;
        slug: string;
        status: ScriptExecutionStatus;
        dryRun: boolean;
        summary?: string | null;
        error?: string | null;
        interrupted: boolean;
        startedAt: DateTimeString;
        finishedAt?: DateTimeString | null;
        affected: Array<{
          __typename: "InternalScriptAffectedCount";
          key: string;
          value: number;
        }>;
        logs: Array<{
          __typename: "InternalScriptExecutionLogLine";
          ts: DateTimeString;
          level: ScriptLogLevel;
          message: string;
        }>;
        triggeredBy: {
          __typename: "InternalScriptExecutionActor";
          id: string;
          email: string;
          name?: string | null;
        };
      };
};

export type AdminOneShotScriptDetailQueryVariables = Exact<{
  slug: Scalars["ID"]["input"];
}>;

export type AdminOneShotScriptDetailQuery = {
  __typename: "Query";
  internalOneShotScript?: {
    __typename: "InternalOneShotScript";
    slug: string;
    title: string;
    description: string;
    supportsDryRun: boolean;
    requiredPermission?: string | null;
    source: string;
    sourceHtml: string;
  } | null;
};

export type AdminScriptExecutionsQueryVariables = Exact<{
  slug: Scalars["ID"]["input"];
}>;

export type AdminScriptExecutionsQuery = {
  __typename: "Query";
  internalScriptExecutions: Array<{
    __typename: "InternalScriptExecution";
    id: string;
    slug: string;
    status: ScriptExecutionStatus;
    dryRun: boolean;
    summary?: string | null;
    error?: string | null;
    interrupted: boolean;
    startedAt: DateTimeString;
    finishedAt?: DateTimeString | null;
    affected: Array<{
      __typename: "InternalScriptAffectedCount";
      key: string;
      value: number;
    }>;
    logs: Array<{
      __typename: "InternalScriptExecutionLogLine";
      ts: DateTimeString;
      level: ScriptLogLevel;
      message: string;
    }>;
    triggeredBy: {
      __typename: "InternalScriptExecutionActor";
      id: string;
      email: string;
      name?: string | null;
    };
  }>;
};

export type AdminOneShotScriptsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminOneShotScriptsQuery = {
  __typename: "Query";
  internalOneShotScripts: Array<{
    __typename: "InternalOneShotScript";
    slug: string;
    title: string;
    description: string;
    supportsDryRun: boolean;
    requiredPermission?: string | null;
    lastExecutedAt?: DateTimeString | null;
  }>;
};

export type SiteOpeningCreateAreaMutationVariables = Exact<{
  input: InternalCreateAreaInput;
}>;

export type SiteOpeningCreateAreaMutation = {
  __typename: "Mutation";
  internalCreateArea: {
    __typename: "InternalArea";
    id: string;
    name: string;
    slug: string;
    sort: number;
  };
};

export type AdminSiteOpeningAreasQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminSiteOpeningAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    slug: string;
    name: string;
    sort: number;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
      ordinalName?: string | null;
      openingDate: PlainDateString;
      publicOpeningDate?: PlainDateString | null;
      published: boolean;
      reservable: boolean;
      reservableForOwnerEarlyAccess: boolean;
      checkInAuthenticationType: CheckInAuthenticationType;
    }>;
  }>;
};

export type AdminUpdateSiteBasicInfoMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  input: InternalUpdateSiteParametersInput;
}>;

export type AdminUpdateSiteBasicInfoMutation = {
  __typename: "Mutation";
  internalUpdateSiteParameters:
    | {
        __typename: "InternalSite";
        id: string;
        slug: string;
        name: string;
        ordinalName?: string | null;
        openingDate: PlainDateString;
        publicOpeningDate?: PlainDateString | null;
        published: boolean;
        reservable: boolean;
        reservableForOwnerEarlyAccess: boolean;
        checkInAuthenticationType: CheckInAuthenticationType;
      }
    | { __typename: "InternalUpdateSiteParametersError"; message: string };
};

export type AdminCreateOtaRoomTypeMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  input: InternalCreateRoomTypeInput;
}>;

export type AdminCreateOtaRoomTypeMutation = {
  __typename: "Mutation";
  internalCreateRoomType: {
    __typename: "InternalRoomType";
    id: string;
    name: string;
    beds24RoomId: number;
  };
};

export type AdminUpdateOtaRoomTypeMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateRoomTypeInput;
}>;

export type AdminUpdateOtaRoomTypeMutation = {
  __typename: "Mutation";
  internalUpdateRoomType: {
    __typename: "InternalRoomType";
    id: string;
    name: string;
  };
};

export type AdminCreateOtaRoomUnitMutationVariables = Exact<{
  roomTypeId: Scalars["ID"]["input"];
  input: InternalCreateOtaRoomUnitInput;
}>;

export type AdminCreateOtaRoomUnitMutation = {
  __typename: "Mutation";
  internalCreateOtaRoomUnit: { __typename: "InternalOtaRoomUnit"; id: string };
};

export type AdminSyncBeds24RoomQtyMutationVariables = Exact<{
  roomTypeId: Scalars["ID"]["input"];
}>;

export type AdminSyncBeds24RoomQtyMutation = {
  __typename: "Mutation";
  internalSyncBeds24RoomQty: { __typename: "InternalRoomType"; id: string };
};

export type AdminSiteAccessRouteGroupsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminSiteAccessRouteGroupsQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    name: string;
    content: {
      __typename: "SiteContent";
      id: string;
      postalCode?: string | null;
      prefecture?: string | null;
      city?: string | null;
      addressLine?: string | null;
      accessRouteGroups: Array<{
        __typename: "SiteAccessRouteGroup";
        id: string;
        title: string;
        transportIcon: AccessRouteTransportIcon;
        sort: number;
        points: Array<{
          __typename: "SiteAccessRoutePoint";
          id: string;
          name: string;
          legToNextDescription?: string | null;
          sort: number;
        }>;
      }>;
    };
  };
};

export type AdminCreateOrUpdateSiteAccessRouteGroupMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateSiteAccessRouteGroupInput;
}>;

export type AdminCreateOrUpdateSiteAccessRouteGroupMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateSiteAccessRouteGroup: {
    __typename: "SiteAccessRouteGroup";
    id: string;
    title: string;
    transportIcon: AccessRouteTransportIcon;
    sort: number;
    points: Array<{
      __typename: "SiteAccessRoutePoint";
      id: string;
      name: string;
      legToNextDescription?: string | null;
      sort: number;
    }>;
  };
};

export type AdminDeleteSiteAccessRouteGroupMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteSiteAccessRouteGroupMutation = {
  __typename: "Mutation";
  internalDeleteSiteAccessRouteGroup: boolean;
};

export type AdminReorderSiteAccessRouteGroupsMutationVariables = Exact<{
  input: Array<InternalReorderInput> | InternalReorderInput;
}>;

export type AdminReorderSiteAccessRouteGroupsMutation = {
  __typename: "Mutation";
  internalReorderSiteAccessRouteGroups: Array<{
    __typename: "SiteAccessRouteGroup";
    id: string;
    sort: number;
  }>;
};

export type AdminSiteBasicInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminSiteBasicInfoQuery = {
  __typename: "Query";
  internalSite: { __typename: "InternalSite" } & {
    " $fragmentRefs"?: { SiteBasicInfoFragment: SiteBasicInfoFragment };
  };
};

export type SiteBasicInfoFragment = ({
  __typename: "InternalSite";
  id: string;
  name: string;
  slug: string;
  ordinalName?: string | null;
  openingDate: PlainDateString;
  publicOpeningDate?: PlainDateString | null;
  checkInAuthenticationType: CheckInAuthenticationType;
  customReservationLeadMonths?: number | null;
  published: boolean;
  reservable: boolean;
  reservableForOwnerEarlyAccess: boolean;
  earlyCheckInEnabled: boolean;
  switchbotLocationApiKey?: string | null;
  remoteLockLocationId?: string | null;
  area: { __typename: "InternalArea"; id: string; name: string };
  accommodations: Array<{
    __typename: "Accommodation";
    id: string;
    name: string;
    code: string;
  }>;
} & { " $fragmentRefs"?: { SiteEditSheetFragment: SiteEditSheetFragment } }) & {
  " $fragmentName"?: "SiteBasicInfoFragment";
};

export type SiteContentEditSheetFragment = {
  __typename: "InternalSite";
  id: string;
  content: {
    __typename: "SiteContent";
    id: string;
    googleMapsUrl?: string | null;
    googleMapsReviewUrl?: string | null;
    mapImageUrl?: string | null;
    iceRoadInfoUrl?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    postalCode?: string | null;
    description?: string | null;
    parkingCapacity?: string | null;
    parkingInfo?: string | null;
    addressForEdit?: {
      __typename: "InternalSiteAddress";
      prefecture?: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      } | null;
      city?: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      } | null;
      addressLine?: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      } | null;
    } | null;
  };
} & { " $fragmentName"?: "SiteContentEditSheetFragment" };

export type AdminUpdateSiteContentMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  input: InternalUpdateSiteContentInput;
}>;

export type AdminUpdateSiteContentMutation = {
  __typename: "Mutation";
  internalUpdateSiteContent: {
    __typename: "InternalSite";
    id: string;
    content: {
      __typename: "SiteContent";
      id: string;
      googleMapsUrl?: string | null;
      googleMapsReviewUrl?: string | null;
      mapImageUrl?: string | null;
      iceRoadInfoUrl?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      postalCode?: string | null;
      description?: string | null;
      parkingCapacity?: string | null;
      parkingInfo?: string | null;
      addressForEdit?: {
        __typename: "InternalSiteAddress";
        prefecture?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
        } | null;
        city?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
        } | null;
        addressLine?: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
        } | null;
      } | null;
    };
  };
};

export type AdminSiteContentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminSiteContentQuery = {
  __typename: "Query";
  internalSite: { __typename: "InternalSite" } & {
    " $fragmentRefs"?: { SiteContentTabFragment: SiteContentTabFragment };
  };
};

export type AdminDeleteSiteImageMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateSiteImagesInput;
}>;

export type AdminDeleteSiteImageMutation = {
  __typename: "Mutation";
  internalUpdateSiteImages:
    | { __typename: "InternalCommonError" }
    | { __typename: "Success"; _: boolean };
};

export type SiteContentTabFragment = ({
  __typename: "InternalSite";
  id: string;
  name: string;
  ordinalName?: string | null;
  accommodations: Array<{
    __typename: "Accommodation";
    architectureType: {
      __typename: "ArchitectureType";
      seriesShortName: string;
      slug: string;
    };
  }>;
  content: {
    __typename: "SiteContent";
    id: string;
    googleMapsUrl?: string | null;
    googleMapsReviewUrl?: string | null;
    mapImageUrl?: string | null;
    iceRoadInfoUrl?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    postalCode?: string | null;
    prefecture?: string | null;
    city?: string | null;
    addressLine?: string | null;
    description?: string | null;
    parkingCapacity?: string | null;
    parkingInfo?: string | null;
    updatedAt: ZonedDateTimeString;
    images: Array<{ __typename: "UploadedFile"; rawUrl: string; url: string }>;
    heroImages: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
      caption?: string | null;
    }>;
  };
} & {
  " $fragmentRefs"?: {
    SiteContentEditSheetFragment: SiteContentEditSheetFragment;
  };
}) & { " $fragmentName"?: "SiteContentTabFragment" };

export type AdminReplaceSiteHeroImagesMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  input: InternalUpdateSiteContentInput;
}>;

export type AdminReplaceSiteHeroImagesMutation = {
  __typename: "Mutation";
  internalUpdateSiteContent: {
    __typename: "InternalSite";
    id: string;
    content: {
      __typename: "SiteContent";
      id: string;
      heroImages: Array<{
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
        caption?: string | null;
      }>;
    };
  };
};

export type AdminUpdateSiteMapImageMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  input: InternalUpdateSiteContentInput;
}>;

export type AdminUpdateSiteMapImageMutation = {
  __typename: "Mutation";
  internalUpdateSiteContent: {
    __typename: "InternalSite";
    id: string;
    content: {
      __typename: "SiteContent";
      id: string;
      mapImageUrl?: string | null;
    };
  };
};

export type AdminSiteHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminSiteHeaderQuery = {
  __typename: "Query";
  internalSite: { __typename: "InternalSite" } & {
    " $fragmentRefs"?: { SiteHeaderFragment: SiteHeaderFragment };
  };
};

export type SiteEditSheetFragment = {
  __typename: "InternalSite";
  id: string;
  name: string;
  slug: string;
  ordinalName?: string | null;
  openingDate: PlainDateString;
  publicOpeningDate?: PlainDateString | null;
  checkInAuthenticationType: CheckInAuthenticationType;
  customReservationLeadMonths?: number | null;
  published: boolean;
  reservable: boolean;
  reservableForOwnerEarlyAccess: boolean;
  earlyCheckInEnabled: boolean;
  switchbotLocationApiKey?: string | null;
  remoteLockLocationId?: string | null;
  localizedName: {
    __typename: "InternalLocalizedString";
    ja?: string | null;
    en?: string | null;
    zhCn?: string | null;
    zhTw?: string | null;
  };
} & { " $fragmentName"?: "SiteEditSheetFragment" };

export type AdminUpdateSiteMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteInput;
}>;

export type AdminUpdateSiteMutation = {
  __typename: "Mutation";
  internalUpdateSite:
    | {
        __typename: "InternalSite";
        id: string;
        name: string;
        slug: string;
        ordinalName?: string | null;
        openingDate: PlainDateString;
        publicOpeningDate?: PlainDateString | null;
        checkInAuthenticationType: CheckInAuthenticationType;
        customReservationLeadMonths?: number | null;
        published: boolean;
        reservable: boolean;
        reservableForOwnerEarlyAccess: boolean;
        earlyCheckInEnabled: boolean;
        switchbotLocationApiKey?: string | null;
        remoteLockLocationId?: string | null;
        localizedName: {
          __typename: "InternalLocalizedString";
          ja?: string | null;
          en?: string | null;
          zhCn?: string | null;
          zhTw?: string | null;
        };
      }
    | {
        __typename: "InternalUpdateSiteError";
        case: InternalUpdateSiteErrorCase;
        message: string;
      };
};

export type AdminSiteFaqsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminSiteFaqsQuery = {
  __typename: "Query";
  internalSiteFaqs: Array<{
    __typename: "RawSiteFaq";
    id: string;
    question: string;
    answer: string;
    sort?: number | null;
    guidanceImageUrl?: string | null;
    site: { __typename: "Site"; id: string };
  }>;
};

export type AdminCreateOrUpdateSiteFaqMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateSiteFaqInput;
}>;

export type AdminCreateOrUpdateSiteFaqMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateSiteFaq:
    | {
        __typename: "InternalCreateOrUpdateSiteFaqError";
        case: InternalCreateOrUpdateSiteFaqErrorCase;
      }
    | {
        __typename: "RawSiteFaq";
        id: string;
        question: string;
        answer: string;
        sort?: number | null;
        guidanceImageUrl?: string | null;
      };
};

export type AdminDeleteSiteFaqMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteSiteFaqMutation = {
  __typename: "Mutation";
  internalDeleteSiteFaq: boolean;
};

export type AdminReorderSiteFaqsMutationVariables = Exact<{
  input: Array<InternalReorderSiteFaqInput> | InternalReorderSiteFaqInput;
}>;

export type AdminReorderSiteFaqsMutation = {
  __typename: "Mutation";
  internalReorderSiteFaqs: Array<{
    __typename: "RawSiteFaq";
    id: string;
    sort?: number | null;
  }>;
};

export type SiteHeaderFragment = {
  __typename: "InternalSite";
  id: string;
  name: string;
  slug: string;
  published: boolean;
  reservable: boolean;
  reservableForOwnerEarlyAccess: boolean;
  area: { __typename: "InternalArea"; id: string; name: string; slug: string };
} & { " $fragmentName"?: "SiteHeaderFragment" };

export type AdminSiteHighSeasonPeriodsQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminSiteHighSeasonPeriodsQuery = {
  __typename: "Query";
  internalSiteHighSeasonPeriods: Array<{
    __typename: "SiteHighSeasonPeriod";
    id: string;
    siteId: string;
    label: string;
    startMonth: number;
    startDay: number;
    endMonth: number;
    endDay: number;
    additionalFeeAmount: number;
  }>;
};

export type AdminCreateSiteHighSeasonPeriodMutationVariables = Exact<{
  input: InternalCreateSiteHighSeasonPeriodInput;
}>;

export type AdminCreateSiteHighSeasonPeriodMutation = {
  __typename: "Mutation";
  internalCreateSiteHighSeasonPeriod: {
    __typename: "SiteHighSeasonPeriod";
    id: string;
    label: string;
    startMonth: number;
    startDay: number;
    endMonth: number;
    endDay: number;
    additionalFeeAmount: number;
  };
};

export type AdminUpdateSiteHighSeasonPeriodMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteHighSeasonPeriodInput;
}>;

export type AdminUpdateSiteHighSeasonPeriodMutation = {
  __typename: "Mutation";
  internalUpdateSiteHighSeasonPeriod: {
    __typename: "SiteHighSeasonPeriod";
    id: string;
    label: string;
    startMonth: number;
    startDay: number;
    endMonth: number;
    endDay: number;
    additionalFeeAmount: number;
  };
};

export type AdminDeleteSiteHighSeasonPeriodMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteSiteHighSeasonPeriodMutation = {
  __typename: "Mutation";
  internalDeleteSiteHighSeasonPeriod: boolean;
};

export type AdminSiteOtaQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminSiteOtaQuery = {
  __typename: "Query";
  internalSite: { __typename: "InternalSite" } & {
    " $fragmentRefs"?: { SiteOtaTabFragment: SiteOtaTabFragment };
  };
};

export type SiteOtaTabFragment = {
  __typename: "InternalSite";
  id: string;
  beds24PropertyId?: number | null;
  roomTypes: Array<{
    __typename: "InternalRoomType";
    id: string;
    name: string;
    beds24RoomId: number;
    otaRoomUnits: Array<{
      __typename: "InternalOtaRoomUnit";
      id: string;
      unit: number;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        name: string;
        facilityTypes: Array<AccommodationFacilityType>;
        architectureType: {
          __typename: "ArchitectureType";
          id: string;
          seriesShortName: string;
          size?: ArchitectureTypeSize | null;
        };
      };
    }>;
  }>;
  accommodations: Array<{
    __typename: "Accommodation";
    id: string;
    code: string;
    name: string;
  }>;
} & { " $fragmentName"?: "SiteOtaTabFragment" };

export type AdminCreateOrUpdateBeds24PropertyMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminCreateOrUpdateBeds24PropertyMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateBeds24Property: {
    __typename: "InternalSite";
    id: string;
    beds24PropertyId?: number | null;
  };
};

export type AdminConnectBeds24PropertyMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  propertyId: Scalars["Int"]["input"];
}>;

export type AdminConnectBeds24PropertyMutation = {
  __typename: "Mutation";
  internalConnectBeds24Property: {
    __typename: "InternalSite";
    id: string;
    beds24PropertyId?: number | null;
  };
};

export type AdminSyncAllBeds24RoomsMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminSyncAllBeds24RoomsMutation = {
  __typename: "Mutation";
  internalSyncAllBeds24Rooms: { __typename: "InternalSite"; id: string };
};

export type AdminBeds24PropertyQueryVariables = Exact<{
  propertyId: Scalars["Int"]["input"];
}>;

export type AdminBeds24PropertyQuery = {
  __typename: "Query";
  internalBeds24Property: string;
};

export type AdminCreateSiteFaqImageUploadPolicyMutationVariables = Exact<{
  input: InternalCreateSiteFaqImageUploadPolicyInput;
}>;

export type AdminCreateSiteFaqImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateSiteFaqImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminCreateSiteImageUploadPolicyMutationVariables = Exact<{
  input: InternalCreateSiteImageUploadPolicyInput;
}>;

export type AdminCreateSiteImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateSiteImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminAddAccommodationLocalTaxPolicyMutationVariables = Exact<{
  accommodationIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  policyId: Scalars["ID"]["input"];
}>;

export type AdminAddAccommodationLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalAddLocalTaxPolicy:
    | {
        __typename: "InternalAddLocalTaxPolicyError";
        case: InternalAddLocalTaxPolicyErrorCase;
      }
    | {
        __typename: "LocalTaxPolicy";
        id: string;
        accommodations: Array<{ __typename: "Accommodation"; id: string }>;
      };
};

export type AdminAddSiteLocalTaxPolicyMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  policyId: Scalars["ID"]["input"];
}>;

export type AdminAddSiteLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalAddLocalTaxPolicy:
    | {
        __typename: "InternalAddLocalTaxPolicyError";
        case: InternalAddLocalTaxPolicyErrorCase;
      }
    | {
        __typename: "LocalTaxPolicy";
        id: string;
        sites: Array<{ __typename: "InternalSite"; id: string }>;
      };
};

export type AdminRemoveAccommodationLocalTaxPolicyMutationVariables = Exact<{
  accommodationId: Scalars["ID"]["input"];
  policyId: Scalars["ID"]["input"];
}>;

export type AdminRemoveAccommodationLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalRemoveLocalTaxPolicy:
    | {
        __typename: "InternalRemoveLocalTaxPolicyError";
        case: InternalRemoveLocalTaxPolicyErrorCase;
      }
    | {
        __typename: "LocalTaxPolicy";
        id: string;
        accommodations: Array<{ __typename: "Accommodation"; id: string }>;
      };
};

export type AdminRemoveSiteLocalTaxPolicyMutationVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  policyId: Scalars["ID"]["input"];
}>;

export type AdminRemoveSiteLocalTaxPolicyMutation = {
  __typename: "Mutation";
  internalRemoveLocalTaxPolicy:
    | {
        __typename: "InternalRemoveLocalTaxPolicyError";
        case: InternalRemoveLocalTaxPolicyErrorCase;
      }
    | {
        __typename: "LocalTaxPolicy";
        id: string;
        sites: Array<{ __typename: "InternalSite"; id: string }>;
      };
};

export type AdminSiteLocalTaxPoliciesQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminSiteLocalTaxPoliciesQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    accommodations: Array<{
      __typename: "Accommodation";
      id: string;
      code: string;
      name: string;
      facilities: Array<{
        __typename: "AccommodationFacility";
        type: AccommodationFacilityType;
      }>;
    }>;
  };
  internalLocalTaxPolicies: Array<{
    __typename: "LocalTaxPolicy";
    id: string;
    taxType: LocalTaxType;
    localGovernmentName: string;
    type: LocalTaxPolicyType;
    effectiveFrom: PlainDateString;
    effectiveTo?: PlainDateString | null;
    sites: Array<{ __typename: "InternalSite"; id: string }>;
    accommodations: Array<{ __typename: "Accommodation"; id: string }>;
  }>;
};

export type AdminCreateAccommodationOperationGroupMutationVariables = Exact<{
  input: InternalCreateAccommodationOperationGroupInput;
}>;

export type AdminCreateAccommodationOperationGroupMutation = {
  __typename: "Mutation";
  internalCreateAccommodationOperationGroup:
    | { __typename: "AccommodationOperationGroup"; id: string }
    | {
        __typename: "InternalCreateAccommodationOperationGroupError";
        case: InternalCreateAccommodationOperationGroupErrorCase;
      };
};

export type AdminUpdateAccommodationOperationGroupSettingMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    input: InternalUpdateAccommodationOperationGroupSettingInput;
  }>;

export type AdminUpdateAccommodationOperationGroupSettingMutation = {
  __typename: "Mutation";
  internalUpdateAccommodationOperationGroupSetting:
    | {
        __typename: "AccommodationOperationGroupSetting";
        id: string;
        effectiveFrom: PlainDateString;
        class: AccommodationClass;
        operationType: AccommodationOperationType;
        additionalFeeForClassEOwner: number;
        additionalFeeForClassFOwner: number;
        additionalFeeForBusinessPlan: number;
      }
    | {
        __typename: "InternalUpdateAccommodationOperationGroupSettingError";
        case: InternalUpdateAccommodationOperationGroupSettingErrorCase;
      };
};

export type AdminSiteOperationGroupsQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminSiteOperationGroupsQuery = {
  __typename: "Query";
  internalAccommodationOperationGroups: Array<{
    __typename: "AccommodationOperationGroup";
    id: string;
    architectureType: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    };
    settings: Array<{
      __typename: "AccommodationOperationGroupSetting";
      id: string;
      effectiveFrom: PlainDateString;
      class: AccommodationClass;
      operationType: AccommodationOperationType;
      additionalFeeForClassEOwner: number;
      additionalFeeForClassFOwner: number;
      additionalFeeForBusinessPlan: number;
    }>;
  }>;
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
  }>;
};

export type AdminRoomTypeBasicQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminRoomTypeBasicQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    roomTypes: Array<{
      __typename: "InternalRoomType";
      id: string;
      name: string;
      slug?: string | null;
      displayNames?: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      } | null;
      notes?: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      } | null;
      architectureType?: {
        __typename: "ArchitectureType";
        id: string;
        name: string;
      } | null;
      features: Array<{
        __typename: "InternalRoomTypeFeature";
        id: string;
        slug: string;
        iconSlug?: string | null;
        category: RoomTypeFeatureCategory;
        sort: number;
        name: { __typename: "InternalLocalizedString"; ja?: string | null };
      }>;
      otaRoomUnits: Array<{
        __typename: "InternalOtaRoomUnit";
        id: string;
        unit: number;
        accommodation: {
          __typename: "Accommodation";
          id: string;
          name: string;
          facilityTypes: Array<AccommodationFacilityType>;
          architectureType: {
            __typename: "ArchitectureType";
            id: string;
            name: string;
          };
        };
      }>;
    }>;
    roomTypeFeatures: Array<{
      __typename: "InternalRoomTypeFeature";
      id: string;
      slug: string;
      iconSlug?: string | null;
      category: RoomTypeFeatureCategory;
      sort: number;
      name: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      };
    }>;
  };
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
    slug: string;
    series: ArchitectureTypeSeries;
    seriesShortName: string;
    size?: ArchitectureTypeSize | null;
  }>;
};

export type AdminUpdateRoomTypeMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateRoomTypeInput;
}>;

export type AdminUpdateRoomTypeMutation = {
  __typename: "Mutation";
  internalUpdateRoomType: {
    __typename: "InternalRoomType";
    id: string;
    name: string;
    slug?: string | null;
    displayNames?: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
    } | null;
    notes?: {
      __typename: "InternalLocalizedString";
      ja?: string | null;
      en?: string | null;
    } | null;
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    } | null;
    features: Array<{
      __typename: "InternalRoomTypeFeature";
      id: string;
      slug: string;
      iconSlug?: string | null;
      category: RoomTypeFeatureCategory;
      sort: number;
      name: {
        __typename: "InternalLocalizedString";
        ja?: string | null;
        en?: string | null;
      };
    }>;
  };
};

export type AdminRoomTypeHeaderQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminRoomTypeHeaderQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    name: string;
    slug: string;
    area: { __typename: "InternalArea"; slug: string };
    roomTypes: Array<{
      __typename: "InternalRoomType";
      id: string;
      name: string;
      slug?: string | null;
    }>;
  };
};

export type AdminCreateRoomTypeImageUploadPolicyMutationVariables = Exact<{
  input: InternalCreateRoomTypeImageUploadPolicyInput;
}>;

export type AdminCreateRoomTypeImageUploadPolicyMutation = {
  __typename: "Mutation";
  internalCreateRoomTypeImageUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminRoomTypeContentQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminRoomTypeContentQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    roomTypes: Array<{
      __typename: "InternalRoomType";
      id: string;
      content?: {
        __typename: "InternalContentRoomType";
        id: string;
        description?: string | null;
        updatedAt: ZonedDateTimeString;
        heroImages: Array<{
          __typename: "UploadedFile";
          rawUrl: string;
          url: string;
          caption?: string | null;
        }>;
      } | null;
    }>;
  };
};

export type AdminUpdateRoomTypeContentMutationVariables = Exact<{
  roomTypeId: Scalars["ID"]["input"];
  input: InternalUpdateRoomTypeContentInput;
}>;

export type AdminUpdateRoomTypeContentMutation = {
  __typename: "Mutation";
  internalUpdateRoomTypeContent: {
    __typename: "InternalContentRoomType";
    id: string;
    description?: string | null;
    updatedAt: ZonedDateTimeString;
    heroImages: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
      caption?: string | null;
    }>;
  };
};

export type AdminSiteRoomTypesSelectorQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminSiteRoomTypesSelectorQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    roomTypes: Array<{
      __typename: "InternalRoomType";
      id: string;
      name: string;
      slug?: string | null;
    }>;
  };
};

export type AdminSiteFirstRoomTypeQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type AdminSiteFirstRoomTypeQuery = {
  __typename: "Query";
  internalSite: {
    __typename: "InternalSite";
    id: string;
    roomTypes: Array<{ __typename: "InternalRoomType"; id: string }>;
  };
};

export type AdminCreateSiteMutationVariables = Exact<{
  areaId: Scalars["ID"]["input"];
  input: InternalCreateSiteInput;
}>;

export type AdminCreateSiteMutation = {
  __typename: "Mutation";
  internalCreateSite:
    | {
        __typename: "InternalCreateSiteError";
        case: InternalCreateSiteErrorCase;
        message: string;
      }
    | {
        __typename: "InternalSite";
        id: string;
        name: string;
        slug: string;
        ordinalName?: string | null;
        openingDate: PlainDateString;
        checkInAuthenticationType: CheckInAuthenticationType;
        customReservationLeadMonths?: number | null;
        published: boolean;
        reservable: boolean;
        reservableForOwnerEarlyAccess: boolean;
        earlyCheckInEnabled: boolean;
      };
};

export type AdminSitesQueryVariables = Exact<{ [key: string]: never }>;

export type AdminSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    slug: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      slug: string;
      ordinalName?: string | null;
      openingDate: PlainDateString;
      published: boolean;
      reservable: boolean;
      reservableForOwnerEarlyAccess: boolean;
      checkInAuthenticationType: CheckInAuthenticationType;
      customReservationLeadMonths?: number | null;
      earlyCheckInEnabled: boolean;
      remoteLockLocationId?: string | null;
      accommodations: Array<{ __typename: "Accommodation"; id: string }>;
    }>;
  }>;
};

export type AdminReorderSitesMutationVariables = Exact<{
  input: Array<InternalReorderSiteInput> | InternalReorderSiteInput;
}>;

export type AdminReorderSitesMutation = {
  __typename: "Mutation";
  internalReorderSites: Array<{ __typename: "Site"; id: string }>;
};

export type AdminStaffGroupHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStaffGroupHeaderQuery = {
  __typename: "Query";
  internalStaffGroup: {
    __typename: "StaffGroup";
    id: string;
    name: string;
    status: StaffGroupStatus;
  };
};

export type AdminStaffGroupDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStaffGroupDetailQuery = {
  __typename: "Query";
  internalStaffGroup: {
    __typename: "StaffGroup";
    id: string;
    name: string;
    fullName?: string | null;
    smarthrId: string;
    status: StaffGroupStatus;
    archivedAt?: ZonedDateTimeString | null;
    createdAt: ZonedDateTimeString;
    updatedAt: ZonedDateTimeString;
  } & {
    " $fragmentRefs"?: {
      StaffGroupFormSheet_StaffGroupFragment: StaffGroupFormSheet_StaffGroupFragment;
    };
  };
};

export type StaffGroupFormSheet_StaffGroupFragment = {
  __typename: "StaffGroup";
  id: string;
  name: string;
  fullName?: string | null;
  smarthrId: string;
  archivedAt?: ZonedDateTimeString | null;
} & { " $fragmentName"?: "StaffGroupFormSheet_StaffGroupFragment" };

export type AdminCreateOrUpdateStaffGroupMutationVariables = Exact<{
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateStaffGroupInput;
}>;

export type AdminCreateOrUpdateStaffGroupMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateStaffGroup:
    | {
        __typename: "InternalCreateOrUpdateStaffGroupError";
        case: InternalCreateOrUpdateStaffGroupErrorCase;
        message: string;
      }
    | {
        __typename: "StaffGroup";
        id: string;
        name: string;
        fullName?: string | null;
        smarthrId: string;
        status: StaffGroupStatus;
        archivedAt?: ZonedDateTimeString | null;
        createdAt: ZonedDateTimeString;
        updatedAt: ZonedDateTimeString;
      };
};

export type AdminStaffGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminStaffGroupsQuery = {
  __typename: "Query";
  staffGroups: Array<{
    __typename: "StaffGroup";
    id: string;
    name: string;
    fullName?: string | null;
    smarthrId: string;
    status: StaffGroupStatus;
    archivedAt?: ZonedDateTimeString | null;
    createdAt: ZonedDateTimeString;
  }>;
};

export type AdminAdjustStaffCreditsMutationVariables = Exact<{
  contractId: Scalars["ID"]["input"];
  semester: StaffSemester;
  year: Scalars["Int"]["input"];
  nights: Scalars["Int"]["input"];
  peakDays: Scalars["Int"]["input"];
}>;

export type AdminAdjustStaffCreditsMutation = {
  __typename: "Mutation";
  internalAdjustStaffCredits:
    | {
        __typename: "InternalAdjustStaffCreditsError";
        case: InternalAdjustStaffCreditsErrorCase;
      }
    | {
        __typename: "InternalAdjustStaffCreditsSuccess";
        contract: { __typename: "StaffContract"; id: string };
      };
};

export type AdminStaffContractDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStaffContractDetailQuery = {
  __typename: "Query";
  internalStaffContract: {
    __typename: "InternalStaffContract";
    id: string;
    staffType: StaffType;
    status: StaffContractStatus;
    statusDetail: StaffContractStatusDetail;
    enrolledAt?: ZonedDateTimeString | null;
    terminatedAt?: ZonedDateTimeString | null;
    isReservable: boolean;
    currentSemesterStayCredits: number;
    currentSemesterGrantedStayCredits: number;
    remainingPeakDays: number;
    semesterCredits: Array<{
      __typename: "StaffSemesterCredit";
      semester: StaffSemester;
      year: number;
      remainingStayCredits: number;
      grantedStayCredits: number;
      remainingPeakDays: number;
    }>;
    user: { __typename: "User"; id: string; name: string; email: string };
    createdUser: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    };
    updatedUser: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    };
  };
};

export type AdminStaffCreditTransactionsQueryVariables = Exact<{
  contractId: Scalars["ID"]["input"];
}>;

export type AdminStaffCreditTransactionsQuery = {
  __typename: "Query";
  internalStaffCreditTransactions: Array<{
    __typename: "InternalStaffCreditTransaction";
    id: string;
    amount: number;
    peakDaysAmount: number;
    status: StaffStayCreditTransactionStatus;
    type: StaffStayCreditTransactionType;
    semester: StaffSemester;
    year: number;
    createdAt: DateTimeString;
    createdByUser?: { __typename: "User"; id: string; name: string } | null;
    accommodationReservation?: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastNight: PlainDateString;
      accommodation: { __typename: "Accommodation"; id: string; name: string };
    } | null;
  }>;
};

export type AdminStaffContractHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStaffContractHeaderQuery = {
  __typename: "Query";
  internalStaffContract: {
    __typename: "InternalStaffContract";
    id: string;
    staffType: StaffType;
    status: StaffContractStatus;
    statusDetail: StaffContractStatusDetail;
    user: { __typename: "User"; id: string; name: string; email: string };
  };
};

export type AdminViewerForStaffPlanQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminViewerForStaffPlanQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; name: string } | null;
};

export type AdminStopStaffPlanFromDetailMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type AdminStopStaffPlanFromDetailMutation = {
  __typename: "Mutation";
  internalStopStaffPlan:
    | {
        __typename: "InternalStopStaffPlanError";
        case: InternalStopStaffPlanErrorCase;
        message?: string | null;
      }
    | {
        __typename: "InternalStopStaffPlanSuccess";
        contract: {
          __typename: "StaffContract";
          id: string;
          status: StaffContractStatus;
          statusDetail: StaffContractStatusDetail;
          terminatedAt?: ZonedDateTimeString | null;
        };
      };
};

export type AdminStaffContractsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminStaffContractsQuery = {
  __typename: "Query";
  internalStaffContracts: Array<{
    __typename: "InternalStaffContract";
    id: string;
    staffType: StaffType;
    status: StaffContractStatus;
    statusDetail: StaffContractStatusDetail;
    enrolledAt?: ZonedDateTimeString | null;
    terminatedAt?: ZonedDateTimeString | null;
    user: { __typename: "User"; id: string; name: string; email: string };
  }>;
};

export type AdminAvailableStaffSemestersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminAvailableStaffSemestersQuery = {
  __typename: "Query";
  internalAvailableStaffSemesters: Array<{
    __typename: "InternalAvailableStaffSemester";
    semester: StaffSemester;
    year: number;
    label: string;
  }>;
};

export type AdminUsersBySearchForStaffPlanQueryVariables = Exact<{
  email?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminUsersBySearchForStaffPlanQuery = {
  __typename: "Query";
  internalUsersBySearch: Array<{
    __typename: "User";
    id: string;
    name: string;
    email: string;
  }>;
};

export type AdminStartStaffPlanMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  staffType: StaffType;
  startSemester: StaffSemester;
  startYear: Scalars["Int"]["input"];
  initialNights: Scalars["Int"]["input"];
}>;

export type AdminStartStaffPlanMutation = {
  __typename: "Mutation";
  internalStartStaffPlan:
    | {
        __typename: "InternalStartStaffPlanError";
        case: InternalStartStaffPlanErrorCase;
      }
    | {
        __typename: "InternalStartStaffPlanSuccess";
        contract: { __typename: "StaffContract"; id: string };
      };
};

export type AdminStayReviewResponseQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStayReviewResponseQuery = {
  __typename: "Query";
  internalStayReviewResponse: {
    __typename: "StayReviewResponseWithReservation";
    id: string;
    createdAt: ZonedDateTimeString;
    rating: number;
    freeTextAtCheckOutAnswer: string;
    freeTextAfterCheckOutAnswer: string;
    accommodationReservation: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastDate: PlainDateString;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      user?: { __typename: "User"; id: string; name: string } | null;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        site: { __typename: "Site"; id: string; name: string };
        architectureType: {
          __typename: "ArchitectureType";
          id: string;
          name: string;
        };
        facilities: Array<{
          __typename: "AccommodationFacility";
          id: string;
          slug: string;
          type: AccommodationFacilityType;
        }>;
      };
    };
    questionnaire: {
      __typename: "StayReviewQuestionnaire";
      selectionAtCheckOut: {
        __typename: "StayReviewSelectionQuestion";
        key: string;
        title: string;
        options: Array<{
          __typename: "StayReviewSelectionOption";
          key: string;
          label: string;
        }>;
      };
      freeTextAtCheckOut: {
        __typename: "StayReviewFreeTextQuestion";
        key: string;
        title: string;
      };
      selectionAfterCheckOut: {
        __typename: "StayReviewSelectionQuestion";
        key: string;
        title: string;
        options: Array<{
          __typename: "StayReviewSelectionOption";
          key: string;
          label: string;
        }>;
      };
      freeTextAfterCheckOut: {
        __typename: "StayReviewFreeTextQuestion";
        key: string;
        title: string;
      };
    };
    selectionAtCheckOutAnswer: Array<{
      __typename: "StayReviewSelectionOption";
      key: string;
    }>;
    selectionAfterCheckOutAnswer: Array<{
      __typename: "StayReviewSelectionOption";
      key: string;
    }>;
  };
};

export type AdminStayReviewResponsesQueryVariables = Exact<{
  startCheckOutDate: Scalars["PlainDate"]["input"];
  endCheckOutDate: Scalars["PlainDate"]["input"];
}>;

export type AdminStayReviewResponsesQuery = {
  __typename: "Query";
  internalStayReviewResponses: Array<{
    __typename: "StayReviewResponseWithReservation";
    id: string;
    createdAt: ZonedDateTimeString;
    rating: number;
    accommodationReservation: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastDate: PlainDateString;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      user?: { __typename: "User"; name: string } | null;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        site: { __typename: "Site"; id: string; slug: string; name: string };
        architectureType: {
          __typename: "ArchitectureType";
          id: string;
          slug: string;
          name: string;
        };
      };
    };
  }>;
};

export type AdminStayReviewArchitectureTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminStayReviewArchitectureTypesQuery = {
  __typename: "Query";
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    slug: string;
    name: string;
  }>;
};

export type AdminStayReviewResponsePreviewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStayReviewResponsePreviewQuery = {
  __typename: "Query";
  internalStayReviewResponse: {
    __typename: "StayReviewResponseWithReservation";
    id: string;
    rating: number;
    freeTextAtCheckOutAnswer: string;
    freeTextAfterCheckOutAnswer: string;
    accommodationReservation: {
      __typename: "AccommodationReservation";
      id: string;
    };
    questionnaire: {
      __typename: "StayReviewQuestionnaire";
      selectionAtCheckOut: {
        __typename: "StayReviewSelectionQuestion";
        key: string;
        title: string;
      };
      freeTextAtCheckOut: {
        __typename: "StayReviewFreeTextQuestion";
        key: string;
        title: string;
      };
      selectionAfterCheckOut: {
        __typename: "StayReviewSelectionQuestion";
        key: string;
        title: string;
      };
      freeTextAfterCheckOut: {
        __typename: "StayReviewFreeTextQuestion";
        key: string;
        title: string;
      };
    };
    selectionAtCheckOutAnswer: Array<{
      __typename: "StayReviewSelectionOption";
      key: string;
      label: string;
    }>;
    selectionAfterCheckOutAnswer: Array<{
      __typename: "StayReviewSelectionOption";
      key: string;
      label: string;
    }>;
  };
};

export type AdminStayReviewFilterArchitectureTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminStayReviewFilterArchitectureTypesQuery = {
  __typename: "Query";
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    slug: string;
    name: string;
  }>;
};

export type AdminStayReviewedReservationsQueryVariables = Exact<{
  startCheckOutDate: Scalars["PlainDate"]["input"];
  endCheckOutDate: Scalars["PlainDate"]["input"];
}>;

export type AdminStayReviewedReservationsQuery = {
  __typename: "Query";
  internalStayReviewedAccommodationReservations: Array<{
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastDate: PlainDateString;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    user?: { __typename: "User"; id: string; name: string } | null;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      code: string;
      site: { __typename: "Site"; id: string; slug: string; name: string };
      architectureType: {
        __typename: "ArchitectureType";
        id: string;
        slug: string;
        name: string;
      };
    };
    stayReviewV2?: {
      __typename: "StayReviewV2";
      id: string;
      submittedAt?: ZonedDateTimeString | null;
      memorableExperiences: Array<StayReviewMemorableExperience>;
      architectureAndNatureRating?: number | null;
      cleaningRating?: number | null;
      equipmentRating?: number | null;
      guidanceAndSupportRating?: number | null;
      comment?: string | null;
      concerns: Array<{
        __typename: "StayReviewV2Concern";
        kind: StayReviewConcernKind;
        details: Array<StayReviewConcernDetail>;
        comment?: string | null;
      }>;
    } | null;
  }>;
};

export type AdminStayReviewFormLabelsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminStayReviewFormLabelsQuery = {
  __typename: "Query";
  stayReviewV2Form: {
    __typename: "StayReviewV2Form";
    memorableExperiences: Array<{
      __typename: "StayReviewMemorableExperienceOption";
      value: StayReviewMemorableExperience;
      label: string;
    }>;
    axes: Array<{
      __typename: "StayReviewAxisDefinition";
      axis: StayReviewAxis;
      label: string;
      concernKinds: Array<{
        __typename: "StayReviewConcernKindDefinition";
        kind: StayReviewConcernKind;
        label: string;
        details: Array<{
          __typename: "StayReviewConcernDetailOption";
          value: StayReviewConcernDetail;
          label: string;
        }>;
      }>;
    }>;
  };
};

export type AdminMasterTemplateRefDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminMasterTemplateRefDataQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
  }>;
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    slug: string;
    type: AccommodationFacilityType;
  }>;
  internalBaseAccommodationFeePolicies: Array<{
    __typename: "RawBaseAccommodationFeePolicy";
    id: string;
    internalName: string;
  }>;
  internalCancelFeePolicies: Array<{
    __typename: "RawCancelFeePolicy";
    id: string;
    internalName: string;
  }>;
  internalAdditionalGuestFeePolicies: Array<{
    __typename: "AdditionalGuestFeePolicy";
    id: string;
    internalName: string;
  }>;
};

export type AdminCreateOrUpdateStayTicketMasterTemplateMutationVariables =
  Exact<{
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateStayTicketMasterTemplateInput;
  }>;

export type AdminCreateOrUpdateStayTicketMasterTemplateMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateStayTicketMasterTemplate:
    | {
        __typename: "InternalCreateOrUpdateStayTicketMasterTemplateError";
        case: InternalCreateOrUpdateStayTicketMasterTemplateErrorCase;
        message: string;
      }
    | { __typename: "StayTicketMasterTemplate"; id: string; name: string };
};

export type AdminStayTicketMasterTemplatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminStayTicketMasterTemplatesQuery = {
  __typename: "Query";
  internalStayTicketMasterTemplates: Array<{
    __typename: "StayTicketMasterTemplate";
    id: string;
    slug: string;
    name: string;
    internalDescription?: string | null;
    isBulkUsage: boolean;
    occupancyLimitTarget: OccupancyLimitTarget;
    baseAccommodationFeeMode: BaseAccommodationFeeMode;
    waiveArchitectureTypeAdditionalFee: boolean;
    waiveDogFee: boolean;
    waiveSaunaFee: boolean;
    waiveOnsenFee: boolean;
    waiveEvChargerFee: boolean;
    waiveDogRunFee: boolean;
    waivePeakDayFee: boolean;
    waiveCleaningFee: boolean;
    waiveConsumedSuppliesFee: boolean;
    waiveSiteAdditionalFee: boolean;
    includeSeasonalFee: boolean;
    rawBaseAccommodationFeePolicy?: {
      __typename: "RawBaseAccommodationFeePolicy";
      id: string;
    } | null;
    rawCancelFeePolicy?: {
      __typename: "RawCancelFeePolicy";
      id: string;
    } | null;
    additionalGuestFeePolicy?: {
      __typename: "AdditionalGuestFeePolicy";
      id: string;
    } | null;
    availableSites: Array<{ __typename: "Site"; id: string }>;
    availableArchitectureTypes: Array<{
      __typename: "ArchitectureType";
      id: string;
    }>;
    availableAccommodationFacilities: Array<{
      __typename: "AccommodationFacility";
      id: string;
    }>;
  }>;
};

export type AdminCreateTicketsFromMasterMutationVariables = Exact<{
  stayTicketMasterId?: InputMaybe<Scalars["ID"]["input"]>;
  count: Scalars["Int"]["input"];
  expiresAt: Scalars["ZonedDateTime"]["input"];
  stayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  stayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  destinationEmail?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminCreateTicketsFromMasterMutation = {
  __typename: "Mutation";
  internalCreateTicketsFromMaster: Array<{
    __typename: "StayTicket";
    id: string;
    code: string;
  }>;
};

export type AdminStayTicketMasterHeaderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStayTicketMasterHeaderQuery = {
  __typename: "Query";
  internalStayTicketMasterById?: {
    __typename: "StayTicketMaster";
    id: string;
    name: string;
    ticketCategory?: TicketCategory | null;
    isArchived: boolean;
  } | null;
};

export type AdminStayTicketMasterDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminStayTicketMasterDetailQuery = {
  __typename: "Query";
  internalStayTicketMasterById?: {
    __typename: "StayTicketMaster";
    id: string;
    name: string;
    internalDescription: string;
    notice?: string | null;
    isBulkUsage: boolean;
    occupancyLimitTarget: OccupancyLimitTarget;
    baseAccommodationFeeMode: BaseAccommodationFeeMode;
    lookupKey?: string | null;
    ticketCategory?: TicketCategory | null;
    isArchived: boolean;
    includeSeasonalFee: boolean;
    waiveArchitectureTypeAdditionalFee: boolean;
    waiveDogFee: boolean;
    waiveSaunaFee: boolean;
    waiveOnsenFee: boolean;
    waiveEvChargerFee: boolean;
    waiveDogRunFee: boolean;
    waivePeakDayFee: boolean;
    waiveCleaningFee: boolean;
    waiveConsumedSuppliesFee: boolean;
    waiveSiteAdditionalFee: boolean;
    additionalNoticeTypes: Array<AdditionalNoticeType>;
    rawBaseAccommodationFeePolicy: {
      __typename: "RawBaseAccommodationFeePolicy";
      id: string;
      internalName: string;
    };
    rawCancelFeePolicy: {
      __typename: "RawCancelFeePolicy";
      id: string;
      internalName: string;
    };
    additionalGuestFeePolicy?: {
      __typename: "AdditionalGuestFeePolicy";
      id: string;
      internalName: string;
      adultPrices: Array<number>;
      kidsPrices: Array<number>;
    } | null;
    availableSites: Array<{ __typename: "Site"; id: string; name: string }>;
    availableArchitectureTypes: Array<{
      __typename: "ArchitectureType";
      id: string;
      name: string;
    }>;
    availableAccommodationFacilities: Array<{
      __typename: "AccommodationFacility";
      id: string;
      slug: string;
    }>;
    template?: {
      __typename: "StayTicketMasterTemplate";
      id: string;
      name: string;
    } | null;
    staffGroup?: { __typename: "StaffGroup"; id: string; name: string } | null;
  } | null;
};

export type AdminMastersForTemplateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminMastersForTemplateQuery = {
  __typename: "Query";
  internalStayTicketMasters: Array<{
    __typename: "StayTicketMaster";
    id: string;
    name: string;
  }>;
};

export type AdminCreateOrUpdateStayTicketTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketTemplateInput;
}>;

export type AdminCreateOrUpdateStayTicketTemplateMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateStayTicketTemplate:
    | {
        __typename: "InternalCreateOrUpdateStayTicketTemplateError";
        message: string;
      }
    | { __typename: "StayTicketTemplate"; id: string; lookupKey: string };
};

export type AdminMasterTemplatesTabQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminMasterTemplatesTabQuery = {
  __typename: "Query";
  internalStayTicketMasterById?: {
    __typename: "StayTicketMaster";
    id: string;
    templates: Array<{
      __typename: "StayTicketTemplate";
      id: string;
      lookupKey: string;
      isActive: boolean;
      daysUntilExpiration?: number | null;
      daysUntilLastStay?: number | null;
      rawExpiresAt?: ZonedDateTimeString | null;
      rawStayStartNight?: PlainDateString | null;
      rawStayEndNight?: PlainDateString | null;
      master: { __typename: "StayTicketMaster"; id: string; name: string };
    }>;
  } | null;
};

export type AdminMasterTicketsPaginatedQueryVariables = Exact<{
  masterId: Scalars["ID"]["input"];
  statuses?: InputMaybe<Array<StayTicketStatusType> | StayTicketStatusType>;
  orderBy?: InputMaybe<InternalStayTicketsOrderBy>;
  orderDir?: InputMaybe<SortDirection>;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type AdminMasterTicketsPaginatedQuery = {
  __typename: "Query";
  internalStayTickets: {
    __typename: "InternalStayTicketsResult";
    totalCount: number;
    items: Array<{
      __typename: "StayTicket";
      id: string;
      code: string;
      status: StayTicketStatusType;
      expiresAt: ZonedDateTimeString;
      stayStartNight: PlainDateString;
      stayEndNight: PlainDateString;
      destinationEmail?: string | null;
    }>;
  };
};

export type AdminUpdateStayTicketMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateStayTicketInput;
}>;

export type AdminUpdateStayTicketMutation = {
  __typename: "Mutation";
  internalUpdateStayTicket:
    | {
        __typename: "InternalUpdateStayTicketInvalidStatusError";
        message: string;
      }
    | { __typename: "InternalUpdateStayTicketNotFoundError"; message: string }
    | {
        __typename: "StayTicket";
        id: string;
        status: StayTicketStatusType;
        expiresAt: ZonedDateTimeString;
        stayStartNight: PlainDateString;
        stayEndNight: PlainDateString;
        destinationEmail?: string | null;
      };
};

export type AdminMasterFormReferenceDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminMasterFormReferenceDataQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
  internalArchitectureTypes: Array<{
    __typename: "ArchitectureType";
    id: string;
    name: string;
    series: ArchitectureTypeSeries;
  }>;
  internalAccommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    id: string;
    slug: string;
    type: AccommodationFacilityType;
  }>;
  internalBaseAccommodationFeePolicies: Array<{
    __typename: "RawBaseAccommodationFeePolicy";
    id: string;
    internalName: string;
  }>;
  internalCancelFeePolicies: Array<{
    __typename: "RawCancelFeePolicy";
    id: string;
    internalName: string;
  }>;
  internalAdditionalGuestFeePolicies: Array<{
    __typename: "AdditionalGuestFeePolicy";
    id: string;
    internalName: string;
  }>;
  internalStayTicketMasterTemplates: Array<{
    __typename: "StayTicketMasterTemplate";
    id: string;
    name: string;
    slug: string;
    occupancyLimitTarget: OccupancyLimitTarget;
    isBulkUsage: boolean;
    baseAccommodationFeeMode: BaseAccommodationFeeMode;
    waiveArchitectureTypeAdditionalFee: boolean;
    waiveDogFee: boolean;
    waiveSaunaFee: boolean;
    waiveOnsenFee: boolean;
    waiveEvChargerFee: boolean;
    waiveDogRunFee: boolean;
    waivePeakDayFee: boolean;
    waiveCleaningFee: boolean;
    waiveConsumedSuppliesFee: boolean;
    waiveSiteAdditionalFee: boolean;
    includeSeasonalFee: boolean;
    rawBaseAccommodationFeePolicy?: {
      __typename: "RawBaseAccommodationFeePolicy";
      id: string;
    } | null;
    rawCancelFeePolicy?: {
      __typename: "RawCancelFeePolicy";
      id: string;
    } | null;
    additionalGuestFeePolicy?: {
      __typename: "AdditionalGuestFeePolicy";
      id: string;
    } | null;
    availableSites: Array<{ __typename: "Site"; id: string }>;
    availableArchitectureTypes: Array<{
      __typename: "ArchitectureType";
      id: string;
    }>;
    availableAccommodationFacilities: Array<{
      __typename: "AccommodationFacility";
      id: string;
    }>;
  }>;
  staffGroups: Array<{ __typename: "StaffGroup"; id: string; name: string }>;
};

export type AdminCreateOrUpdateStayTicketMasterMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketMasterInput;
}>;

export type AdminCreateOrUpdateStayTicketMasterMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateStayTicketMaster:
    | {
        __typename: "InternalCreateOrUpdateStayTicketMasterError";
        case: InternalCreateOrUpdateStayTicketMasterErrorCase;
        message: string;
      }
    | {
        __typename: "StayTicketMaster";
        id: string;
        name: string;
        additionalGuestFeePolicy?: {
          __typename: "AdditionalGuestFeePolicy";
          id: string;
          internalName: string;
        } | null;
      };
};

export type AdminStayTicketMastersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminStayTicketMastersQuery = {
  __typename: "Query";
  internalStayTicketMasters: Array<{
    __typename: "StayTicketMaster";
    id: string;
    name: string;
    internalDescription: string;
    isBulkUsage: boolean;
    ticketCategory?: TicketCategory | null;
    isArchived: boolean;
    lookupKey?: string | null;
    staffGroup?: { __typename: "StaffGroup"; id: string; name: string } | null;
  }>;
};

export type AdminStayTicketTemplatesSearchQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminStayTicketTemplatesSearchQuery = {
  __typename: "Query";
  internalStayTicketTemplates: Array<{
    __typename: "StayTicketTemplate";
    id: string;
    lookupKey: string;
    isActive: boolean;
    daysUntilExpiration?: number | null;
    daysUntilLastStay?: number | null;
    createdAt: DateTimeString;
    master: { __typename: "StayTicketMaster"; id: string; name: string };
  }>;
};

export type AdminStayTicketByCodeQueryVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type AdminStayTicketByCodeQuery = {
  __typename: "Query";
  internalStayTicketByCode?: {
    __typename: "StayTicket";
    id: string;
    code: string;
    status: StayTicketStatusType;
    expiresAt: ZonedDateTimeString;
    stayStartNight: PlainDateString;
    stayEndNight: PlainDateString;
    destinationEmail?: string | null;
    master?: {
      __typename: "StayTicketMaster";
      id: string;
      name: string;
    } | null;
    userOwnership?: {
      __typename: "UserOwnership";
      id: string;
      user: { __typename: "User"; id: string; name: string; email: string };
    } | null;
    accommodationReservations: Array<{
      __typename: "AccommodationReservation";
      id: string;
      stayStatus: AccommodationReservationStayStatus;
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      nights: number;
      accommodation: { __typename: "Accommodation"; name: string };
      user?: { __typename: "User"; id: string; name: string } | null;
    }>;
  } | null;
};

export type AdminUpdateStayTicketFromSearchMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateStayTicketInput;
}>;

export type AdminUpdateStayTicketFromSearchMutation = {
  __typename: "Mutation";
  internalUpdateStayTicket:
    | {
        __typename: "InternalUpdateStayTicketInvalidStatusError";
        message: string;
      }
    | { __typename: "InternalUpdateStayTicketNotFoundError"; message: string }
    | {
        __typename: "StayTicket";
        id: string;
        status: StayTicketStatusType;
        expiresAt: ZonedDateTimeString;
        stayStartNight: PlainDateString;
        stayEndNight: PlainDateString;
        destinationEmail?: string | null;
      };
};

export type EditSupplyItemInstallationsSheet_SiteFragment = {
  __typename: "InternalSite";
  id: string;
  name: string;
  accommodations: Array<{
    __typename: "Accommodation";
    id: string;
    code: string;
    architectureType: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    };
  }>;
} & { " $fragmentName"?: "EditSupplyItemInstallationsSheet_SiteFragment" };

export type EditSupplyItemInstallationsSheet_SupplyItemInstallationFragment = {
  __typename: "SupplyItemInstallation";
  id: string;
  defaultQuantity: number;
  architectureType?: {
    __typename: "ArchitectureType";
    id: string;
    name: string;
  } | null;
  accommodation?: {
    __typename: "Accommodation";
    id: string;
    code: string;
  } | null;
} & {
  " $fragmentName"?: "EditSupplyItemInstallationsSheet_SupplyItemInstallationFragment";
};

export type AdminUpsertSupplyItemInstallationsMutationVariables = Exact<{
  masterId: Scalars["ID"]["input"];
  installations:
    | Array<InternalCreateOrUpdateSupplyItemInstallationInput>
    | InternalCreateOrUpdateSupplyItemInstallationInput;
}>;

export type AdminUpsertSupplyItemInstallationsMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateSupplyItemInstallations:
    | {
        __typename: "InternalCreateOrUpdateSupplyItemInstallationsError";
        case: InternalCreateOrUpdateSupplyItemInstallationsErrorCase;
      }
    | { __typename: "Success" };
};

export type AdminDeleteSupplyItemInstallationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminDeleteSupplyItemInstallationMutation = {
  __typename: "Mutation";
  internalDeleteSupplyItemInstallation:
    | {
        __typename: "InternalDeleteSupplyItemInstallationError";
        case: InternalDeleteSupplyItemInstallationErrorCase;
      }
    | { __typename: "Success" };
};

export type AdminInstallationSupplyItemsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminInstallationSupplyItemsQuery = {
  __typename: "Query";
  internalSupplyItemMasters: Array<{
    __typename: "SupplyItemMaster";
    id: string;
    namePrivate: string;
    category: SupplyItemMasterCategory;
  }>;
};

export type AdminSupplyItemMasterInstallationsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminSupplyItemMasterInstallationsQuery = {
  __typename: "Query";
  internalSupplyItemMaster?: {
    __typename: "SupplyItemMaster";
    id: string;
    unit?: string | null;
  } | null;
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    sites: Array<
      {
        __typename: "InternalSite";
        id: string;
        name: string;
        accommodations: Array<{
          __typename: "Accommodation";
          id: string;
          code: string;
          architectureType: {
            __typename: "ArchitectureType";
            id: string;
            name: string;
          };
        }>;
        supplyItemInstallations: Array<
          {
            __typename: "SupplyItemInstallation";
            id: string;
            defaultQuantity: number;
            architectureType?: {
              __typename: "ArchitectureType";
              id: string;
              name: string;
            } | null;
            accommodation?: {
              __typename: "Accommodation";
              id: string;
              code: string;
            } | null;
          } & {
            " $fragmentRefs"?: {
              EditSupplyItemInstallationsSheet_SupplyItemInstallationFragment: EditSupplyItemInstallationsSheet_SupplyItemInstallationFragment;
            };
          }
        >;
      } & {
        " $fragmentRefs"?: {
          EditSupplyItemInstallationsSheet_SiteFragment: EditSupplyItemInstallationsSheet_SiteFragment;
        };
      }
    >;
  }>;
};

export type AdminCreateSupplyItemMasterMutationVariables = Exact<{
  input: InternalCreateOrUpdateSupplyItemMasterInput;
}>;

export type AdminCreateSupplyItemMasterMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateSupplyItemMaster:
    | {
        __typename: "InternalCreateOrUpdateSupplyItemMasterError";
        case: InternalCreateOrUpdateSupplyItemMasterErrorCase;
      }
    | { __typename: "SupplyItemMaster"; id: string };
};

export type EditSupplyItemSheet_SupplyItemMasterFragment = {
  __typename: "SupplyItemMaster";
  id: string;
  namePublic: string;
  namePrivate: string;
  unit?: string | null;
  price: number;
  category: SupplyItemMasterCategory;
  taxRateType: ConsumptionTaxRateType;
  sort: number;
} & { " $fragmentName"?: "EditSupplyItemSheet_SupplyItemMasterFragment" };

export type AdminUpdateSupplyItemMasterMutationVariables = Exact<{
  input: InternalCreateOrUpdateSupplyItemMasterInput;
}>;

export type AdminUpdateSupplyItemMasterMutation = {
  __typename: "Mutation";
  internalCreateOrUpdateSupplyItemMaster:
    | {
        __typename: "InternalCreateOrUpdateSupplyItemMasterError";
        case: InternalCreateOrUpdateSupplyItemMasterErrorCase;
      }
    | {
        __typename: "SupplyItemMaster";
        id: string;
        namePublic: string;
        namePrivate: string;
        unit?: string | null;
        price: number;
        category: SupplyItemMasterCategory;
        taxRateType: ConsumptionTaxRateType;
        sort: number;
      };
};

export type AdminSupplyItemMastersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminSupplyItemMastersQuery = {
  __typename: "Query";
  internalSupplyItemMasters: Array<
    {
      __typename: "SupplyItemMaster";
      id: string;
      namePublic: string;
      namePrivate: string;
      unit?: string | null;
      price: number;
      category: SupplyItemMasterCategory;
      taxRateType: ConsumptionTaxRateType;
      sort: number;
    } & {
      " $fragmentRefs"?: {
        EditSupplyItemSheet_SupplyItemMasterFragment: EditSupplyItemSheet_SupplyItemMasterFragment;
      };
    }
  >;
};

export type AdminSupplyReportDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminSupplyReportDetailQuery = {
  __typename: "Query";
  internalInspectionReports: Array<{
    __typename: "InspectionReport";
    id: string;
    closedAt?: ZonedDateTimeString | null;
    supplyItems: Array<{
      __typename: "InspectionSupplyItem";
      id: string;
      name: string;
      quantity: number;
    }>;
    supplyItemMedia: Array<{ __typename: "UploadedFile"; url: string }>;
    reservation: {
      __typename: "AccommodationReservation";
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      user?: { __typename: "User"; id: string; name: string } | null;
      accommodation: {
        __typename: "Accommodation";
        code: string;
        site: { __typename: "Site"; name: string };
      };
    };
  }>;
};

export type AdminSupplyReportsQueryVariables = Exact<{
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminSupplyReportsQuery = {
  __typename: "Query";
  internalInspectionReports: Array<{
    __typename: "InspectionReport";
    id: string;
    updatedAt: ZonedDateTimeString;
    supplyItems: Array<{
      __typename: "InspectionSupplyItem";
      id: string;
      quantity: number;
    }>;
    reservation: {
      __typename: "AccommodationReservation";
      id: string;
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      user?: { __typename: "User"; id: string; name: string } | null;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        site: { __typename: "Site"; id: string; name: string };
      };
    };
  }>;
};

export type AdminSupplyReportSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminSupplyReportSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
    }>;
  }>;
};

export type AdminCreateTermsRevisionMutationVariables = Exact<{
  input: InternalCreateTermsRevisionInput;
}>;

export type AdminCreateTermsRevisionMutation = {
  __typename: "Mutation";
  internalCreateTermsRevision:
    | {
        __typename: "InternalCreateTermsRevisionError";
        case: InternalCreateTermsRevisionErrorCase;
      }
    | ({ __typename: "Terms" } & {
        " $fragmentRefs"?: {
          TermsDetail_TermsFragment: TermsDetail_TermsFragment;
        };
      });
};

export type AdminTermsRevisionTargetOwnerPlansQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminTermsRevisionTargetOwnerPlansQuery = {
  __typename: "Query";
  internalOwnerPlans: Array<{
    __typename: "OwnerPlan";
    id: string;
    type: OwnerPlanType;
    name: string;
  }>;
};

export type AdminCreateIndividualTermsDocumentUploadPolicyMutationVariables =
  Exact<{
    input: CreateFullOwnerContractUploadPolicyInput;
  }>;

export type AdminCreateIndividualTermsDocumentUploadPolicyMutation = {
  __typename: "Mutation";
  createFullOwnerContractUploadPolicy:
    | { __typename: "CreateFileUploadPolicyError" }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type AdminUpdateIndividualTermsDocumentMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateIndividualTermsDocumentInput;
}>;

export type AdminUpdateIndividualTermsDocumentMutation = {
  __typename: "Mutation";
  internalUpdateIndividualTermsDocument:
    | {
        __typename: "InternalUpdateIndividualTermsDocumentError";
        case: InternalUpdateIndividualTermsDocumentErrorCase;
      }
    | ({ __typename: "Terms" } & {
        " $fragmentRefs"?: {
          TermsDetail_TermsFragment: TermsDetail_TermsFragment;
        };
      });
};

export type TermsDetail_TermsFragment = {
  __typename: "Terms";
  id: string;
  plan: TermsPlanType;
  documentUrl: string;
  ownerPlan?: { __typename: "OwnerPlan"; id: string; name: string } | null;
  revisions: Array<{
    __typename: "TermsRevision";
    id: string;
    revisedDate: PlainDateString;
    internalSummary: string;
    targetOwnerPlan?: {
      __typename: "OwnerPlan";
      id: string;
      name: string;
    } | null;
  }>;
} & { " $fragmentName"?: "TermsDetail_TermsFragment" };

export type AdminTermsDetailQueryVariables = Exact<{ [key: string]: never }>;

export type AdminTermsDetailQuery = {
  __typename: "Query";
  internalTerms: Array<
    { __typename: "Terms" } & {
      " $fragmentRefs"?: {
        TermsDetail_TermsFragment: TermsDetail_TermsFragment;
      };
    }
  >;
};

export type AdminTermsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminTermsQuery = {
  __typename: "Query";
  internalTerms: Array<{
    __typename: "Terms";
    id: string;
    plan: TermsPlanType;
    ownerPlan?: { __typename: "OwnerPlan"; id: string; name: string } | null;
    revisions: Array<{
      __typename: "TermsRevision";
      id: string;
      revisedDate: PlainDateString;
    }>;
  }>;
};

export type AdminSendTestSmsMutationVariables = Exact<{
  phoneNumber: Scalars["String"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminSendTestSmsMutation = {
  __typename: "Mutation";
  internalSendTestSms?: string | null;
};

export type AdminUserOwnershipDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AdminUserOwnershipDetailQuery = {
  __typename: "Query";
  internalUserOwnership: {
    __typename: "UserOwnership";
    id: string;
    units: number;
    nightsPerYear: number;
    maxPeakDaysPerYear?: number | null;
    maxSiteHighSeasonDaysPerYear?: number | null;
    usageStartDate: PlainDateString;
    usageEndDate: PlainDateString;
    nextPaymentDate: PlainDateString;
    holderName: string;
    currentYearStatus: {
      __typename: "UserOwnershipProgramYearStatus";
      year: number;
      startDate: PlainDateString;
      endDate: PlainDateString;
      remainingNights: number;
      remainingPeakDays?: number | null;
      remainingSiteHighSeasonDays?: number | null;
    };
    nextYearStatus?: {
      __typename: "UserOwnershipProgramYearStatus";
      year: number;
      startDate: PlainDateString;
      endDate: PlainDateString;
      remainingNights: number;
      remainingPeakDays?: number | null;
      remainingSiteHighSeasonDays?: number | null;
    } | null;
    user: { __typename: "User"; id: string; name: string; email: string };
    plan: {
      __typename: "OwnerPlan";
      id: string;
      type: OwnerPlanType;
      name: string;
      managedName: string;
      site: { __typename: "Site"; id: string; name: string };
      architectureType?: {
        __typename: "ArchitectureType";
        id: string;
        name: string;
      } | null;
      accommodation?: {
        __typename: "Accommodation";
        id: string;
        name: string;
      } | null;
    };
  };
};

export type AdminAdjustOwnerStayCreditMutationVariables = Exact<{
  ownershipId: Scalars["ID"]["input"];
  year: Scalars["Int"]["input"];
  amount: Scalars["Int"]["input"];
}>;

export type AdminAdjustOwnerStayCreditMutation = {
  __typename: "Mutation";
  internalAdjustOwnerStayCredit:
    | {
        __typename: "InternalAdjustOwnerStayCreditError";
        case: InternalAdjustOwnerStayCreditErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type AdminUserOwnershipsListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminUserOwnershipsListQuery = {
  __typename: "Query";
  internalUserOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    units: number;
    usageStartDate: PlainDateString;
    user: { __typename: "User"; id: string; name: string; email: string };
    plan: {
      __typename: "OwnerPlan";
      id: string;
      type: OwnerPlanType;
      name: string;
      site: { __typename: "Site"; id: string; name: string };
      architectureType?: {
        __typename: "ArchitectureType";
        id: string;
        name: string;
      } | null;
      accommodation?: {
        __typename: "Accommodation";
        id: string;
        name: string;
      } | null;
    };
  }>;
};

export type AdminUserAnalyticsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserAnalyticsQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    personaMetrics: {
      __typename: "UserPersonaMetrics";
      frequency: number;
      loyalty: number;
      investment: number;
      exploration: number;
      seasonality: number;
    };
  };
};

export type ContractDetailFragment = {
  __typename: "User";
  id: string;
  subscription: {
    __typename: "UserSubscription";
    id: string;
    status: UserSubscriptionStatus;
    statusDetail: UserSubscriptionStatusDetail;
    suspended: boolean;
    billingCycleDay?: number | null;
    appliedAt?: ZonedDateTimeString | null;
    enrolledAt?: ZonedDateTimeString | null;
    enrollmentScheduledAt?: ZonedDateTimeString | null;
    terminationScheduledAt?: ZonedDateTimeString | null;
    terminatedAt?: ZonedDateTimeString | null;
    pauseScheduledAt?: ZonedDateTimeString | null;
    pausedAt?: ZonedDateTimeString | null;
    resumeScheduledAt?: ZonedDateTimeString | null;
    resumedAt?: ZonedDateTimeString | null;
    accumulatedS2oAmount: number;
    reservationCycle?: {
      __typename: "UserSubscriptionReservationCycle";
      startDay: number;
    } | null;
  };
  trialContract?: {
    __typename: "TrialContract";
    id: string;
    status: TrialContractStatus;
    statusDetail: TrialContractStatusDetail;
    appliedAt: ZonedDateTimeString;
    enrolledDate: PlainDateString;
    endDate: PlainDateString;
    remainingStayCredits: number;
    totalStayCredits: number;
    currentPeriodStayCredits: number;
    firstSemesterStayCredits: number;
    secondSemesterStayCredits: number;
    cancelledAt?: ZonedDateTimeString | null;
    terminatedAt?: ZonedDateTimeString | null;
  } | null;
  staffContract?: {
    __typename: "StaffContract";
    id: string;
    status: StaffContractStatus;
    statusDetail: StaffContractStatusDetail;
    staffType: StaffType;
    enrolledDate: PlainDateString;
    terminatedDate?: PlainDateString | null;
    isReservable: boolean;
    currentSemesterStayCredits: number;
    currentSemesterGrantedStayCredits: number;
  } | null;
  organizationMembership?: {
    __typename: "OrganizationMembership";
    id: string;
    role: OrganizationRole;
    customFieldValue?: string | null;
    organization: { __typename: "Organization"; id: string; name: string };
    reservationNewStatus: {
      __typename: "OrganizationMemberNewReservationStatus";
      suspended: boolean;
      maxNightsPerStay: number;
      latestYearlyReservationStatuses: Array<{
        __typename: "OrganizationYearlyReservationStatus";
        startYearMonth: PlainYearMonthString;
        endYearMonth: PlainYearMonthString;
        remainingNights: number;
        maxNights: number;
      }>;
    };
  } | null;
  coOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    units: number;
    nightsPerYear: number;
    maxPeakDaysPerYear?: number | null;
    usageStartDate: PlainDateString;
    usageEndDate: PlainDateString;
    nextPaymentDate: PlainDateString;
    holderName: string;
    currentYearStatus: {
      __typename: "UserOwnershipProgramYearStatus";
      year: number;
      startDate: PlainDateString;
      endDate: PlainDateString;
      remainingNights: number;
      remainingPeakDays?: number | null;
    };
    plan: {
      __typename: "OwnerPlan";
      id: string;
      name: string;
      site: { __typename: "Site"; id: string; name: string };
    };
  }>;
  fullOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    units: number;
    nightsPerYear: number;
    usageStartDate: PlainDateString;
    usageEndDate: PlainDateString;
    nextPaymentDate: PlainDateString;
    holderName: string;
    currentYearStatus: {
      __typename: "UserOwnershipProgramYearStatus";
      year: number;
      startDate: PlainDateString;
      endDate: PlainDateString;
      remainingNights: number;
    };
    plan: {
      __typename: "OwnerPlan";
      id: string;
      name: string;
      accommodation?: {
        __typename: "Accommodation";
        id: string;
        name: string;
        site: { __typename: "Site"; id: string; name: string };
      } | null;
    };
  }>;
} & { " $fragmentName"?: "ContractDetailFragment" };

export type ContractListFragment = {
  __typename: "User";
  id: string;
  subscription: {
    __typename: "UserSubscription";
    id: string;
    status: UserSubscriptionStatus;
    statusDetail: UserSubscriptionStatusDetail;
  };
  trialContract?: {
    __typename: "TrialContract";
    id: string;
    status: TrialContractStatus;
    statusDetail: TrialContractStatusDetail;
  } | null;
  staffContract?: {
    __typename: "StaffContract";
    id: string;
    status: StaffContractStatus;
    statusDetail: StaffContractStatusDetail;
  } | null;
  organizationMembership?: {
    __typename: "OrganizationMembership";
    id: string;
    role: OrganizationRole;
    organization: { __typename: "Organization"; id: string; name: string };
  } | null;
  coOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    units: number;
    nightsPerYear: number;
    plan: {
      __typename: "OwnerPlan";
      id: string;
      name: string;
      site: { __typename: "Site"; id: string; name: string };
    };
  }>;
  fullOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    units: number;
    nightsPerYear: number;
    plan: {
      __typename: "OwnerPlan";
      id: string;
      name: string;
      accommodation?: {
        __typename: "Accommodation";
        id: string;
        name: string;
        site: { __typename: "Site"; id: string; name: string };
      } | null;
    };
  }>;
} & { " $fragmentName"?: "ContractListFragment" };

export type ReservationDetailFragment = {
  __typename: "User";
  id: string;
  allAccommodationReservations: Array<{
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastDate: PlainDateString;
    nights: number;
    isTentative: boolean;
    hasCanceled: boolean;
    canceledAt?: ZonedDateTimeString | null;
    stayStatus: AccommodationReservationStayStatus;
    checkedInAt?: ZonedDateTimeString | null;
    checkedOutAt?: ZonedDateTimeString | null;
    createdAt: DateTimeString;
    accessCode?: string | null;
    createdUser?: {
      __typename: "User";
      id: string;
      name: string;
      email: string;
    } | null;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      name: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: {
        __typename: "Site";
        id: string;
        name: string;
        content: {
          __typename: "SiteContent";
          faqs: Array<{
            __typename: "SiteFaq";
            question: string;
            answer: string;
          }>;
        };
      };
    };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      numberOfDogs: number;
      bringDog: boolean;
      useEvCharger: boolean;
    };
    userCompanions: Array<{
      __typename: "UserCompanion";
      id: string;
      name: string;
      gender: GenderType;
      birthDate: PlainDateString;
    }>;
    accommodationNotices: Array<{
      __typename: "AccommodationNotice";
      id: string;
      brief: string;
      detail?: string | null;
      externalUrl?: string | null;
      startDate: PlainDateString;
      endDate: PlainDateString;
    }>;
    fee: {
      __typename: "AccommodationFee";
      totalAmount: number;
      billingMethod: BillingMethod;
      items: Array<{
        __typename: "AccommodationFeeItem";
        key: string;
        label: string;
        amount: number;
        type: AccommodationFeeItemPerType;
        night?: PlainDateString | null;
      }>;
      consumedSupplyFeeItemWaivers: Array<
        { __typename: "ConsumedSupplyFeeItemWaiver" } & {
          " $fragmentRefs"?: {
            ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment: ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment;
          };
        }
      >;
    };
    facilityReservations: Array<{
      __typename: "FacilityReservation";
      id: string;
      status: FacilityReservationStatusType;
      startAt: PlainDateTimeString;
      endAt: PlainDateTimeString;
      chargedFeeAmount: number;
      resource: {
        __typename: "FacilityResource";
        name: string;
        facility: { __typename: "Facility"; name: string; type: FacilityType };
      };
    }>;
    stayTicketUnit?: {
      __typename: "StayTicketUnit";
      id: string;
      stayTicketMasterId?: string | null;
      reservationInfo: {
        __typename: "StayTicketReservationInfo";
        type: StayTicketType;
        name: string;
      };
      stayTickets: Array<{
        __typename: "StayTicket";
        id: string;
        code: string;
        status: StayTicketStatusType;
        expiresAt: ZonedDateTimeString;
        stayStartNight: PlainDateString;
        stayEndNight: PlainDateString;
      }>;
    } | null;
    otaDetail?: {
      __typename: "AccommodationReservationOtaDetail";
      referer?: string | null;
      apiReference?: string | null;
    } | null;
  }>;
} & { " $fragmentName"?: "ReservationDetailFragment" };

export type ReservationListFragment = {
  __typename: "User";
  id: string;
  allAccommodationReservations: Array<{
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    lastDate: PlainDateString;
    nights: number;
    isTentative: boolean;
    hasCanceled: boolean;
    stayStatus: AccommodationReservationStayStatus;
    accommodation: { __typename: "Accommodation"; id: string; name: string };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
  }>;
} & { " $fragmentName"?: "ReservationListFragment" };

export type AdminUserRequiredTermsAgreementsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  provider: AccommodationReservationProviderInput;
}>;

export type AdminUserRequiredTermsAgreementsQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    requiredTermsAgreements: Array<{ __typename: "TermsRevision"; id: string }>;
  };
};

export type AdminUserOverviewQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserOverviewQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    email: string;
    phoneNumber?: string | null;
    zendeskId?: string | null;
    createdAt: DateTimeString;
  } & {
    " $fragmentRefs"?: {
      ContractListFragment: ContractListFragment;
      ContractDetailFragment: ContractDetailFragment;
      ReservationListFragment: ReservationListFragment;
      ReservationDetailFragment: ReservationDetailFragment;
    };
  };
};

export type UserProfileTabFragment = ({
  __typename: "User";
  id: string;
  name: string;
  nameKana?: string | null;
  email: string;
  phoneNumber?: string | null;
  maybeProfile?: {
    __typename: "UserProfile";
    birthDate?: PlainDateString | null;
    gender?: GenderType | null;
    nationality?: CountryEnum | null;
    passportNumber?: string | null;
    professionType?: UserProfileProfessionType | null;
    professionFree?: string | null;
    householdComposition?: UserProfileHouseholdComposition | null;
    numberOfDogs?: number | null;
    carOwnershipStatus?: UserProfileCarOwnershipStatus | null;
    facePhoto?: { __typename: "UploadedFile"; url: string } | null;
    passportPhoto?: { __typename: "UploadedFile"; url: string } | null;
    address?:
      | {
          __typename: "AddressInJapan";
          postalCode: string;
          line1: string;
          japanLine2: string;
        }
      | {
          __typename: "AddressInternational";
          line1: string;
          city: string;
          stateProvince: string;
          postalCode: string;
          country: CountryEnum;
          intlLine2?: string | null;
        }
      | null;
  } | null;
} & { " $fragmentRefs"?: { UserEditSheetFragment: UserEditSheetFragment } }) & {
  " $fragmentName"?: "UserProfileTabFragment";
};

export type AdminUserProfileQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserProfileQuery = {
  __typename: "Query";
  internalUser: { __typename: "User" } & {
    " $fragmentRefs"?: { UserProfileTabFragment: UserProfileTabFragment };
  };
};

export type AdminUserSettingsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserSettingsQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    systemSettings: {
      __typename: "UserSystemSettings";
      hasSeenHouseRules: boolean;
    };
  };
};

export type InternalPartialUpdateUserSystemSettingsMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  input: UserSystemSettingsInput;
}>;

export type InternalPartialUpdateUserSystemSettingsMutation = {
  __typename: "Mutation";
  internalPartialUpdateUserSystemSettings: {
    __typename: "User";
    id: string;
    systemSettings: {
      __typename: "UserSystemSettings";
      hasSeenHouseRules: boolean;
    };
  };
};

export type AdminUserHeaderQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserHeaderQuery = {
  __typename: "Query";
  internalUser: { __typename: "User" } & {
    " $fragmentRefs"?: { UserHeaderFragment: UserHeaderFragment };
  };
};

export type UserEditSheetFragment = {
  __typename: "User";
  id: string;
  name: string;
  nameKana?: string | null;
  phoneNumber?: string | null;
  maybeProfile?: {
    __typename: "UserProfile";
    birthDate?: PlainDateString | null;
    gender?: GenderType | null;
    nationality?: CountryEnum | null;
    passportNumber?: string | null;
    professionType?: UserProfileProfessionType | null;
    professionFree?: string | null;
    householdComposition?: UserProfileHouseholdComposition | null;
    numberOfDogs?: number | null;
    carOwnershipStatus?: UserProfileCarOwnershipStatus | null;
    address?:
      | {
          __typename: "AddressInJapan";
          postalCode: string;
          line1: string;
          japanLine2: string;
        }
      | {
          __typename: "AddressInternational";
          city: string;
          stateProvince: string;
          country: CountryEnum;
          intlLine1: string;
          intlLine2?: string | null;
          intlPostalCode: string;
        }
      | null;
  } | null;
} & { " $fragmentName"?: "UserEditSheetFragment" };

export type InternalUpdateUserMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: InternalUpdateUserInput;
}>;

export type InternalUpdateUserMutation = {
  __typename: "Mutation";
  internalUpdateUser: {
    __typename: "User";
    id: string;
    name: string;
    nameKana?: string | null;
    phoneNumber?: string | null;
    maybeProfile?: {
      __typename: "UserProfile";
      birthDate?: PlainDateString | null;
      gender?: GenderType | null;
      nationality?: CountryEnum | null;
      passportNumber?: string | null;
      professionType?: UserProfileProfessionType | null;
      professionFree?: string | null;
      householdComposition?: UserProfileHouseholdComposition | null;
      numberOfDogs?: number | null;
      carOwnershipStatus?: UserProfileCarOwnershipStatus | null;
      address?:
        | {
            __typename: "AddressInJapan";
            postalCode: string;
            line1: string;
            japanLine2: string;
          }
        | {
            __typename: "AddressInternational";
            city: string;
            stateProvince: string;
            country: CountryEnum;
            intlLine1: string;
            intlLine2?: string | null;
            intlPostalCode: string;
          }
        | null;
    } | null;
  };
};

export type UserHeaderFragment = {
  __typename: "User";
  id: string;
  name: string;
  deletedAt?: DateTimeString | null;
  maybeProfile?: {
    __typename: "UserProfile";
    facePhoto?: { __typename: "UploadedFile"; url: string } | null;
  } | null;
  subscription: {
    __typename: "UserSubscription";
    status: UserSubscriptionStatus;
  };
  organizationMembership?: {
    __typename: "OrganizationMembership";
    organization: { __typename: "Organization"; name: string };
  } | null;
  coOwnerships: Array<{ __typename: "UserOwnership"; id: string }>;
  fullOwnerships: Array<{ __typename: "UserOwnership"; id: string }>;
} & { " $fragmentName"?: "UserHeaderFragment" };

export type AdminFullOwnerPlanOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminFullOwnerPlanOptionsQuery = {
  __typename: "Query";
  internalOwnerPlans: Array<{
    __typename: "OwnerPlan";
    id: string;
    type: OwnerPlanType;
    name: string;
    managedName: string;
    site: { __typename: "Site"; id: string; name: string };
    accommodation?: {
      __typename: "Accommodation";
      id: string;
      name: string;
    } | null;
  }>;
};

export type AdminUserAccountsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserAccountsQuery = {
  __typename: "Query";
  internalAuth0DashboardBaseUrl: string;
  internalUser: {
    __typename: "User";
    id: string;
    email: string;
    emailVerified: boolean;
    identities: Array<{
      __typename: "UserIdentity";
      provider: IdentityProvider;
      email?: string | null;
      emailVerified: boolean;
      userId: string;
      connection: string;
      isAppleRelay: boolean;
      isSocial: boolean;
      isSyncedLocally: boolean;
    }>;
  };
};

export type AdminAuth0UsersByEmailQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type AdminAuth0UsersByEmailQuery = {
  __typename: "Query";
  internalAuth0UsersByEmail: Array<{
    __typename: "InternalAuth0User";
    userId: string;
    email?: string | null;
    emailVerified: boolean;
    identities: Array<{
      __typename: "InternalAuth0Identity";
      provider: string;
      userId: string;
      connection: string;
      isSocial: boolean;
      profileEmail?: string | null;
      profileEmailVerified?: boolean | null;
    }>;
  }>;
};

export type InternalUnlinkIdentityMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  provider: IdentityProvider;
}>;

export type InternalUnlinkIdentityMutation = {
  __typename: "Mutation";
  internalUnlinkIdentity: {
    __typename: "InternalUnlinkIdentityPayload";
    success: boolean;
  };
};

export type InternalDeleteAuth0UserMutationVariables = Exact<{
  auth0UserId: Scalars["String"]["input"];
}>;

export type InternalDeleteAuth0UserMutation = {
  __typename: "Mutation";
  internalDeleteAuth0User: {
    __typename: "InternalUnlinkIdentityPayload";
    success: boolean;
  };
};

export type InternalUnlinkAuth0IdentityMutationVariables = Exact<{
  primaryAuth0UserId: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  providerUserId: Scalars["String"]["input"];
}>;

export type InternalUnlinkAuth0IdentityMutation = {
  __typename: "Mutation";
  internalUnlinkAuth0Identity: {
    __typename: "InternalUnlinkIdentityPayload";
    success: boolean;
  };
};

export type AdminUserDevicesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserDevicesQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    appInstallations: Array<{
      __typename: "UserAppInstallation";
      id: string;
      createdAt: ZonedDateTimeString;
      updatedAt: ZonedDateTimeString;
      fcmToken: string;
      platform: PushNotificationPlatform;
      installationId: string;
      registeredDeviceModel?: string | null;
      registeredOsVersion?: string | null;
      registeredAppVersion?: string | null;
    }>;
  };
};

export type AdminCreateFullOwnerIdentityVerificationMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  ownerPlanId: Scalars["ID"]["input"];
  input: InternalCreateFullOwnerIdentityVerificationInput;
}>;

export type AdminCreateFullOwnerIdentityVerificationMutation = {
  __typename: "Mutation";
  internalCreateFullOwnerIdentityVerification:
    | { __typename: "IdentityVerification"; id: string }
    | {
        __typename: "InternalCreateFullOwnerIdentityVerificationError";
        case: InternalCreateFullOwnerIdentityVerificationErrorCase;
      };
};

export type AdminUserIdentityVerificationsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserIdentityVerificationsQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    fullOwnerIdentityVerifications: Array<
      {
        __typename: "IdentityVerification";
        id: string;
        ownerPlan?: {
          __typename: "OwnerPlan";
          id: string;
          name: string;
          managedName: string;
        } | null;
      } & {
        " $fragmentRefs"?: {
          IdentityVerificationItem_IdentityVerificationFragment: IdentityVerificationItem_IdentityVerificationFragment;
        };
      }
    >;
  };
};

export type AdminUserInvoicesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserInvoicesQuery = {
  __typename: "Query";
  internalStripeDashboardBaseUrl: string;
  internalUser: {
    __typename: "User";
    id: string;
    name: string;
    stripe: {
      __typename: "StripeCustomer";
      customerId: string;
      defaultCard?: {
        __typename: "StripeCard";
        brand: string;
        last4: string;
        exp_month: number;
        exp_year: number;
      } | null;
      invoices: Array<{
        __typename: "StripeInvoice";
        id: string;
        createdAt: ZonedDateTimeString;
        status: StripeInvoiceStatus;
        total: number;
        description?: string | null;
        hosted_invoice_url?: string | null;
      }>;
    };
  };
};

export type AdminUserMonthlyStatementQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  yearMonth: Scalars["PlainYearMonth"]["input"];
}>;

export type AdminUserMonthlyStatementQuery = {
  __typename: "Query";
  internalGenerateUserMonthlyStatement:
    | {
        __typename: "InternalGenerateUserMonthlyStatementError";
        case: InternalGenerateUserMonthlyStatementErrorCase;
        message?: string | null;
      }
    | {
        __typename: "UserMonthlyStatement";
        yearMonth: PlainYearMonthString;
        totalPrice: number;
        user: { __typename: "User"; id: string; name: string };
        reservationStatements: Array<{
          __typename: "ReservationStatementItem";
          reservationId: string;
          accommodationName: string;
          date: PlainDateString;
          canceledAt?: ZonedDateTimeString | null;
          status: string;
          type: string;
          price: number;
          fee: {
            __typename: "AccommodationFee";
            billingMethod: BillingMethod;
            billingMethodManualDetail?: string | null;
          };
          priceStatement: {
            __typename: "ReservationPriceStatement";
            baseFee: number;
            additionalFee: number;
            additionalFacilityFee: number;
            cleaningFee: number;
            cancelFee: number;
            dogFee: number;
            evFee: number;
            consumedSuppliesFeeByTaxRate: Array<{
              __typename: "PriceWithTaxRate";
              price: number;
              taxRate: number;
            }>;
          };
        }>;
      };
};

export type AdminUserMembershipQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserMembershipQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    subscription: {
      __typename: "UserSubscription";
      id: string;
      status: UserSubscriptionStatus;
      appliedAt?: ZonedDateTimeString | null;
      enrolledAt?: ZonedDateTimeString | null;
      enrollmentScheduledAt?: ZonedDateTimeString | null;
      resumedAt?: ZonedDateTimeString | null;
      resumeScheduledAt?: ZonedDateTimeString | null;
      terminatedAt?: ZonedDateTimeString | null;
      terminationScheduledAt?: ZonedDateTimeString | null;
      reservationCycle?: {
        __typename: "UserSubscriptionReservationCycle";
        startDay: number;
      } | null;
    };
    organizationMembership?: {
      __typename: "OrganizationMembership";
      id: string;
      role: OrganizationRole;
      organization: { __typename: "Organization"; id: string; name: string };
    } | null;
  };
};

export type AdminCreateFullOwnershipMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  ownerPlanId: Scalars["ID"]["input"];
  startDate: Scalars["PlainDate"]["input"];
}>;

export type AdminCreateFullOwnershipMutation = {
  __typename: "Mutation";
  internalCreateUserOwnership: { __typename: "UserOwnership"; id: string };
};

export type UserOwnershipTab_UserOwnershipFragment = {
  __typename: "UserOwnership";
  id: string;
  units: number;
  nightsPerYear: number;
  usageStartDate: PlainDateString;
  plan: {
    __typename: "OwnerPlan";
    id: string;
    name: string;
    site: { __typename: "Site"; id: string; name: string };
    accommodation?: {
      __typename: "Accommodation";
      id: string;
      name: string;
      site: { __typename: "Site"; id: string; name: string };
    } | null;
  };
} & { " $fragmentName"?: "UserOwnershipTab_UserOwnershipFragment" };

export type AdminUserOwnershipsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserOwnershipsQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    fullOwnerships: Array<
      { __typename: "UserOwnership" } & {
        " $fragmentRefs"?: {
          UserOwnershipTab_UserOwnershipFragment: UserOwnershipTab_UserOwnershipFragment;
        };
      }
    >;
    coOwnerships: Array<
      { __typename: "UserOwnership" } & {
        " $fragmentRefs"?: {
          UserOwnershipTab_UserOwnershipFragment: UserOwnershipTab_UserOwnershipFragment;
        };
      }
    >;
    coOwnersApplications: Array<{
      __typename: "CoOwnersApplication";
      id: string;
      status: CoOwnersApplicationStatus;
      units: number;
      ownerPlan: { __typename: "OwnerPlan"; id: string; name: string };
    }>;
  };
};

export type AdminUserReservationsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserReservationsQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    allAccommodationReservations: Array<{
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastDate: PlainDateString;
      nights: number;
      isTentative: boolean;
      stayStatus: AccommodationReservationStayStatus;
      accommodation: { __typename: "Accommodation"; id: string; name: string };
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      fee: {
        __typename: "AccommodationFee";
        totalAmount: number;
        status?: AccommodationFeeStatus | null;
      };
    }>;
    stayCreditEstimate: {
      __typename: "StayCreditEstimate";
      breakdown: Array<{
        __typename: "StayCreditBreakdownItem";
        reservationId: string;
        amount: number;
      }>;
    };
  };
};

export type AdminUserS2oQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUserS2oQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    coOwnersApplications: Array<{
      __typename: "CoOwnersApplication";
      id: string;
    }>;
    s2o: {
      __typename: "S2o";
      balance: number;
      points: Array<{
        __typename: "S2oPoint";
        date: PlainDateString;
        updatedAt: ZonedDateTimeString;
        amount: number;
        status: S2oPointStatus;
        transactionType: S2oPointTransactionType;
        note: string;
      }>;
    };
    stayCreditEstimate: {
      __typename: "StayCreditEstimate";
      total: number;
      qualifyingStayCount: number;
      remainingStayCount: number;
      activatable: boolean;
    };
  };
};

export type UserTableRowFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  phoneNumber?: string | null;
  deletedAt?: DateTimeString | null;
  maybeProfile?: {
    __typename: "UserProfile";
    facePhoto?: { __typename: "UploadedFile"; url: string } | null;
  } | null;
  subscription: {
    __typename: "UserSubscription";
    status: UserSubscriptionStatus;
  };
  organizationMembership?: {
    __typename: "OrganizationMembership";
    id: string;
  } | null;
  coOwnerships: Array<{ __typename: "UserOwnership"; id: string }>;
  fullOwnerships: Array<{ __typename: "UserOwnership"; id: string }>;
} & { " $fragmentName"?: "UserTableRowFragment" };

export type AdminUsersSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdminUsersSearchQuery = {
  __typename: "Query";
  internalUsersSearch: {
    __typename: "InternalUserSearchResult";
    totalCount: number;
    hasNextPage: boolean;
    users: Array<
      { __typename: "User" } & {
        " $fragmentRefs"?: { UserTableRowFragment: UserTableRowFragment };
      }
    >;
  };
};

export type AdminUserStatsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminUserStatsQuery = {
  __typename: "Query";
  internalUserStats: {
    __typename: "InternalUserStats";
    totalUsers: number;
    activeMembers: number;
    guests: number;
    newSignupsThisMonth: number;
    monthlyChurnRate: number;
    usersWithUpcomingReservations: number;
  };
};

export type ViolationHandlingForm_InspectionViolationHandlingFragment = {
  __typename: "InspectionViolationHandling";
  id: string;
  severity: InspectionViolationSeverity;
  severityAssessedAt?: ZonedDateTimeString | null;
  warningActionNote?: string | null;
  warningActionAt?: ZonedDateTimeString | null;
  severityAssessedByUser?: {
    __typename: "User";
    id: string;
    name: string;
  } | null;
  warningActionByUser?: { __typename: "User"; id: string; name: string } | null;
} & {
  " $fragmentName"?: "ViolationHandlingForm_InspectionViolationHandlingFragment";
};

export type AdminUpdateInspectionViolationHandlingMutationVariables = Exact<{
  input: InternalUpdateInspectionViolationHandlingInput;
}>;

export type AdminUpdateInspectionViolationHandlingMutation = {
  __typename: "Mutation";
  internalUpdateInspectionViolationHandling:
    | {
        __typename: "InternalUpdateInspectionViolationHandlingError";
        case: InternalUpdateInspectionViolationHandlingErrorCase;
      }
    | { __typename: "Success" };
};

export type AdminUserPastViolationReportsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminUserPastViolationReportsQuery = {
  __typename: "Query";
  internalInspectionReports: Array<{
    __typename: "InspectionReport";
    id: string;
    reservation: {
      __typename: "AccommodationReservation";
      id: string;
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        site: { __typename: "Site"; id: string; name: string };
      };
    };
    violationHandling?: {
      __typename: "InspectionViolationHandling";
      id: string;
      status: InspectionViolationHandlingStatus;
      severity: InspectionViolationSeverity;
    } | null;
  }>;
};

export type AdminViolationReportDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminViolationReportDetailQuery = {
  __typename: "Query";
  internalInspectionReports: Array<{
    __typename: "InspectionReport";
    id: string;
    violationDescription?: string | null;
    violationItems: Array<{
      __typename: "InspectionViolationItem";
      id: string;
      typeName: string;
    }>;
    violationMedia: Array<{ __typename: "UploadedFile"; url: string }>;
    violationHandling?:
      | ({
          __typename: "InspectionViolationHandling";
          id: string;
          status: InspectionViolationHandlingStatus;
          severity: InspectionViolationSeverity;
          severityAssessedAt?: ZonedDateTimeString | null;
          warningActionAt?: ZonedDateTimeString | null;
          severityAssessedByUser?: {
            __typename: "User";
            id: string;
            name: string;
          } | null;
          warningActionByUser?: {
            __typename: "User";
            id: string;
            name: string;
          } | null;
        } & {
          " $fragmentRefs"?: {
            ViolationHandlingForm_InspectionViolationHandlingFragment: ViolationHandlingForm_InspectionViolationHandlingFragment;
          };
        })
      | null;
    reservation: {
      __typename: "AccommodationReservation";
      id: string;
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      user?: { __typename: "User"; id: string; name: string } | null;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        site: { __typename: "Site"; id: string; name: string };
      };
    };
  }>;
};

export type AdminViolationReportsQueryVariables = Exact<{
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AdminViolationReportsQuery = {
  __typename: "Query";
  internalInspectionReports: Array<{
    __typename: "InspectionReport";
    id: string;
    updatedAt: ZonedDateTimeString;
    violationHandling?: {
      __typename: "InspectionViolationHandling";
      id: string;
      status: InspectionViolationHandlingStatus;
      severity: InspectionViolationSeverity;
      updatedAt: ZonedDateTimeString;
      severityAssessedAt?: ZonedDateTimeString | null;
      warningActionAt?: ZonedDateTimeString | null;
      severityAssessedByUser?: {
        __typename: "User";
        id: string;
        name: string;
      } | null;
      warningActionByUser?: {
        __typename: "User";
        id: string;
        name: string;
      } | null;
    } | null;
    reservation: {
      __typename: "AccommodationReservation";
      id: string;
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
      user?: { __typename: "User"; id: string; name: string } | null;
      accommodation: {
        __typename: "Accommodation";
        id: string;
        code: string;
        site: { __typename: "Site"; id: string; name: string };
      };
    };
  }>;
};

export type AdminViolationReportSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminViolationReportSitesQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      slug: string;
      name: string;
    }>;
  }>;
};

export type GetOrganizationIdQueryVariables = Exact<{
  invitationCode: Scalars["String"]["input"];
}>;

export type GetOrganizationIdQuery = {
  __typename: "Query";
  organizationIdByInvitationCode?: string | null;
};

export type GetViewerKindQueryVariables = Exact<{ [key: string]: never }>;

export type GetViewerKindQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    organizationMembership?: {
      __typename: "OrganizationMembership";
      organization: { __typename: "Organization"; id: string };
    } | null;
  } | null;
};

export type GetOrganizationForOnboardingQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetOrganizationForOnboardingQuery = {
  __typename: "Query";
  organization: {
    __typename: "Organization";
    id: string;
    name: string;
    emailDomainsForMember?: Array<string> | null;
    invitationCode: string;
    announcementContent: string;
    onboardingInfo?: {
      __typename: "OrganizationOnboardingInfo";
      maxNightsPerStay?: number | null;
      isPeakDayFeeFree: boolean;
      feePerNights: number;
      nightsPerYear: number;
    } | null;
  };
  maybeViewer?: {
    __typename: "User";
    organizationMembership?: {
      __typename: "OrganizationMembership";
      organization: { __typename: "Organization"; id: string };
    } | null;
  } | null;
};

export type ReservationStatusLocalePageQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ReservationStatusLocalePageQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    canCheckIn: boolean;
    isTentative: boolean;
  };
};

export type TentativeReservationForLocaleReservationStatusQueryVariables =
  Exact<{
    code: Scalars["ID"]["input"];
  }>;

export type TentativeReservationForLocaleReservationStatusQuery = {
  __typename: "Query";
  tentativeAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | { __typename: "RedirectLocation"; path: string }
    | ({
        __typename: "TentativeAccommodationReservationError";
        case: TentativeAccommodationReservationErrorCase;
      } & {
        " $fragmentRefs"?: {
          TentativeAccommodationReservationErrorCaseFragment: TentativeAccommodationReservationErrorCaseFragment;
        };
      });
};

export type MaybeViewerForLocaleReservationStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MaybeViewerForLocaleReservationStatusQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    isFilledRequiredProfile: boolean;
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; last4: string } | null;
    };
  } | null;
};

export type AcceptTentativeReservationLocaleMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type AcceptTentativeReservationLocaleMutation = {
  __typename: "Mutation";
  acceptAccommodationReservation:
    | {
        __typename: "AcceptAccommodationReservationError";
        case: AcceptAccommodationReservationErrorCase;
      }
    | { __typename: "AccommodationReservation"; id: string };
};

export type ContentArchitectureTypeVariantFragment = {
  __typename: "ContentArchitectureTypeVariant";
  name: string;
  brief: string;
  description: string;
  imageUrls: Array<{ __typename: "UploadedFile"; rawUrl: string }>;
  facilityDetails: { __typename: "ContentFacilityDetails" } & {
    " $fragmentRefs"?: {
      ContentFacilityDetailsFragment: ContentFacilityDetailsFragment;
    };
  };
  sites: Array<
    { __typename: "ContentArchitectureTypeVariantSite" } & {
      " $fragmentRefs"?: {
        AccommodationsPerSiteFragment: AccommodationsPerSiteFragment;
      };
    }
  >;
} & { " $fragmentName"?: "ContentArchitectureTypeVariantFragment" };

export type ArchitectureTypePageQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type ArchitectureTypePageQuery = {
  __typename: "Query";
  architectureTypePage: {
    __typename: "ContentArchitectureType";
    id: string;
    area?: string | null;
    description: string;
    capacityDescription: string;
    sizeDescription: string;
    equipmentsListUrl?: string | null;
    amenitiesInstructionsUrl?: string | null;
    architectComment: string;
    architectureType: {
      __typename: "ArchitectureType";
      name: string;
      seriesShortName: string;
    };
    imageUrls: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    }>;
    architect: {
      __typename: "ContentArchitect";
      company: string;
      name: string;
      nameEn: string;
      bio: string;
      imageUrl: { __typename: "UploadedFile"; rawUrl: string };
    };
    sites: Array<{
      __typename: "ContentArchitectureTypeSite";
      name: string;
      isOpeningSoon: boolean;
    }>;
    basicAmenities: Array<{
      __typename: "ContentArchitectureTypeBasicAmenity";
      name: string;
      iconUrl?: { __typename: "UploadedFile"; rawUrl: string } | null;
    }>;
    floorPlanImageUrl?: { __typename: "UploadedFile"; rawUrl: string } | null;
    variations: Array<
      { __typename: "ContentArchitectureTypeVariant" } & {
        " $fragmentRefs"?: {
          ContentArchitectureTypeVariantFragment: ContentArchitectureTypeVariantFragment;
        };
      }
    >;
    options: Array<
      { __typename: "ContentArchitectureTypeVariant" } & {
        " $fragmentRefs"?: {
          ContentArchitectureTypeVariantFragment: ContentArchitectureTypeVariantFragment;
        };
      }
    >;
  } & {
    " $fragmentRefs"?: {
      ContentArchitectureTypeExperiencesFragment: ContentArchitectureTypeExperiencesFragment;
    };
  };
};

export type AccommodationsPerSiteFragment = {
  __typename: "ContentArchitectureTypeVariantSite";
  name: string;
  accommodations: Array<{ __typename: "Accommodation"; id: string }>;
} & { " $fragmentName"?: "AccommodationsPerSiteFragment" };

export type ContentArchitecturePageNavigationItemFragment = {
  __typename: "ContentArchitecturePageNavigationItem";
  name: string;
  slug?: string | null;
  path: string;
  area?: string | null;
  thumbnail: { __typename: "UploadedFile"; rawUrl: string };
  subItems?: Array<{
    __typename: "ContentArchitecturePageNavigationSubItem";
    slug: string;
    name: string;
    path: string;
  }> | null;
} & { " $fragmentName"?: "ContentArchitecturePageNavigationItemFragment" };

export type ContentArchitectureTypeExperiencesFragment = {
  __typename: "ContentArchitectureType";
  experiences: Array<{
    __typename: "ContentArchitectureTypeExperience";
    name: string;
    descriptionMarkup: string;
    imageUrl: { __typename: "UploadedFile"; rawUrl: string };
  }>;
} & { " $fragmentName"?: "ContentArchitectureTypeExperiencesFragment" };

export type ContentFacilityDetailsFragment = {
  __typename: "ContentFacilityDetails";
  usageFeesDescriptionMarkup: string;
  usageConditionsDescription: string;
  facilityAmenities: Array<{
    __typename: "ContentArchitectureTypeVariantFacilityAmenity";
    name: string;
    descriptionMarkup: string;
  }>;
} & { " $fragmentName"?: "ContentFacilityDetailsFragment" };

export type FeaturePageQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type FeaturePageQuery = {
  __typename: "Query";
  featurePage: {
    __typename: "ContentArchitectureTypeFeature";
    name: string;
    description: string;
    availabilityNote?: string | null;
    imageUrls: Array<{
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    }>;
    facilityDetails: { __typename: "ContentFacilityDetails" } & {
      " $fragmentRefs"?: {
        ContentFacilityDetailsFragment: ContentFacilityDetailsFragment;
      };
    };
    usageRule?: {
      __typename: "ContentArchitectureTypeFeatureUsageRule";
      title: string;
      noteMarkup?: string | null;
      ruleItems: Array<{
        __typename: "ContentArchitectureTypeFeatureUsageRuleItem";
        bodyMarkup: string;
        imageUrl?: { __typename: "UploadedFile"; rawUrl: string } | null;
      }>;
    } | null;
    sitesByArchitectureType: Array<{
      __typename: "ContentArchitectureTypeFeatureSite";
      architectureTypeName: string;
      sites: Array<
        { __typename: "ContentArchitectureTypeVariantSite" } & {
          " $fragmentRefs"?: {
            AccommodationsPerSiteFragment: AccommodationsPerSiteFragment;
          };
        }
      >;
    }>;
  };
};

export type ArchitectureTopNavigationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ArchitectureTopNavigationQuery = {
  __typename: "Query";
  architectureTopPage: {
    __typename: "ContentArchitecturePageNavigation";
    originalSeries: Array<
      {
        __typename: "ContentArchitecturePageNavigationItem";
        slug?: string | null;
        name: string;
        subItems?: Array<{
          __typename: "ContentArchitecturePageNavigationSubItem";
          slug: string;
          name: string;
        }> | null;
      } & {
        " $fragmentRefs"?: {
          ContentArchitecturePageNavigationItemFragment: ContentArchitecturePageNavigationItemFragment;
        };
      }
    >;
    selectionSeries: Array<
      {
        __typename: "ContentArchitecturePageNavigationItem";
        slug?: string | null;
        name: string;
      } & {
        " $fragmentRefs"?: {
          ContentArchitecturePageNavigationItemFragment: ContentArchitecturePageNavigationItemFragment;
        };
      }
    >;
    feature: Array<
      {
        __typename: "ContentArchitecturePageNavigationItem";
        slug?: string | null;
        name: string;
      } & {
        " $fragmentRefs"?: {
          ContentArchitecturePageNavigationItemFragment: ContentArchitecturePageNavigationItemFragment;
        };
      }
    >;
  };
};

export type ArchitectureTopQueryVariables = Exact<{ [key: string]: never }>;

export type ArchitectureTopQuery = {
  __typename: "Query";
  architectureTopPage: {
    __typename: "ContentArchitecturePageNavigation";
    originalSeries: Array<{
      __typename: "ContentArchitecturePageNavigationItem";
      name: string;
      path: string;
      thumbnail: { __typename: "UploadedFile"; rawUrl: string };
      subItems?: Array<{
        __typename: "ContentArchitecturePageNavigationSubItem";
        name: string;
        path: string;
      }> | null;
    }>;
    selectionSeries: Array<{
      __typename: "ContentArchitecturePageNavigationItem";
      name: string;
      path: string;
      area?: string | null;
      thumbnail: { __typename: "UploadedFile"; rawUrl: string };
    }>;
    feature: Array<{
      __typename: "ContentArchitecturePageNavigationItem";
      name: string;
      path: string;
      thumbnail: { __typename: "UploadedFile"; rawUrl: string };
    }>;
  };
};

export type AreaAbout_AreaFragment = {
  __typename: "Area";
  content: {
    __typename: "AreaContent";
    catchCopy?: string | null;
    description?: string | null;
  };
} & { " $fragmentName"?: "AreaAbout_AreaFragment" };

export type AreaActivityPrograms_AreaFragment = {
  __typename: "Area";
  sites: Array<{
    __typename: "Site";
    id: string;
    content: {
      __typename: "SiteContent";
      activityPrograms: Array<
        { __typename: "SiteActivityProgram"; id: string } & {
          " $fragmentRefs"?: {
            DxActivityProgramSection_SiteActivityProgramFragment: DxActivityProgramSection_SiteActivityProgramFragment;
          };
        }
      >;
    };
  }>;
} & { " $fragmentName"?: "AreaActivityPrograms_AreaFragment" };

export type AreaBases_AreaFragment = {
  __typename: "Area";
  slug: string;
  sites: Array<{
    __typename: "Site";
    id: string;
    slug: string;
    name: string;
    content: {
      __typename: "SiteContent";
      heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
    };
  }>;
} & { " $fragmentName"?: "AreaBases_AreaFragment" };

export type AreaGuideArticles_AreaFragment = {
  __typename: "Area";
  content: {
    __typename: "AreaContent";
    guideArticles: Array<{
      __typename: "AreaGuideArticle";
      id: string;
      title: string;
      url: string;
      publishedDate: PlainDateString;
      thumbnail?: { __typename: "UploadedFile"; url: string } | null;
    }>;
  };
} & { " $fragmentName"?: "AreaGuideArticles_AreaFragment" };

export type AreaHero_AreaFragment = {
  __typename: "Area";
  name: string;
  content: {
    __typename: "AreaContent";
    heroImages: Array<{
      __typename: "UploadedFile";
      url: string;
      caption?: string | null;
    }>;
  };
} & { " $fragmentName"?: "AreaHero_AreaFragment" };

export type AreaJsonLd_AreaFragment = {
  __typename: "Area";
  name: string;
  slug: string;
} & { " $fragmentName"?: "AreaJsonLd_AreaFragment" };

export type AreaSidebar_AreaFragment = {
  __typename: "Area";
  slug: string;
  name: string;
  content: {
    __typename: "AreaContent";
    shortAddress?: string | null;
    accessFromTokyoDescription?: string | null;
  };
  sites: Array<{
    __typename: "Site";
    id: string;
    slug: string;
    name: string;
    accommodations: Array<{
      __typename: "Accommodation";
      id: string;
      architectureType: {
        __typename: "ArchitectureType";
        id: string;
        seriesShortName: string;
        content: {
          __typename: "ContentArchitectureType";
          id: string;
          capacityDescription: string;
        };
      };
      roomType?: {
        __typename: "RoomType";
        id: string;
        features: Array<{
          __typename: "RoomTypeFeature";
          slug: string;
          displayName: string;
          sort: number;
        }>;
      } | null;
    }>;
    content: {
      __typename: "SiteContent";
      heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
    };
  }>;
} & { " $fragmentName"?: "AreaSidebar_AreaFragment" };

export type AreaSpHeader_AreaFragment = {
  __typename: "Area";
  name: string;
  content: {
    __typename: "AreaContent";
    shortAddress?: string | null;
    accessFromTokyoDescription?: string | null;
  };
} & { " $fragmentName"?: "AreaSpHeader_AreaFragment" };

export type AreaSpotsPreview_AreaFragment = {
  __typename: "Area";
  slug: string;
  content: {
    __typename: "AreaContent";
    guideSpots: Array<{
      __typename: "AreaGuideSpot";
      id: string;
      name: string;
      categories: Array<AreaGuideSpotCategory>;
      images: Array<{ __typename: "UploadedFile"; url: string }>;
    }>;
  };
} & { " $fragmentName"?: "AreaSpotsPreview_AreaFragment" };

export type AreaLayoutQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type AreaLayoutQuery = {
  __typename: "Query";
  areaBySlug?:
    | ({ __typename: "Area"; id: string } & {
        " $fragmentRefs"?: {
          AreaSidebar_AreaFragment: AreaSidebar_AreaFragment;
          AreaSpHeader_AreaFragment: AreaSpHeader_AreaFragment;
        };
      })
    | null;
};

export type AreaDetailPageMeta_AreaFragment = {
  __typename: "Area";
  name: string;
  content: {
    __typename: "AreaContent";
    shortAddress?: string | null;
    accessFromTokyoDescription?: string | null;
    heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
  };
} & { " $fragmentName"?: "AreaDetailPageMeta_AreaFragment" };

export type AreaDetailPageQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type AreaDetailPageQuery = {
  __typename: "Query";
  areaBySlug?:
    | ({
        __typename: "Area";
        id: string;
        slug: string;
        name: string;
        sites: Array<{
          __typename: "Site";
          id: string;
          reservable: boolean;
          reservableForOwnerEarlyAccess: boolean;
        }>;
      } & {
        " $fragmentRefs"?: {
          AreaDetailPageMeta_AreaFragment: AreaDetailPageMeta_AreaFragment;
          AreaJsonLd_AreaFragment: AreaJsonLd_AreaFragment;
          AreaHero_AreaFragment: AreaHero_AreaFragment;
          AreaAbout_AreaFragment: AreaAbout_AreaFragment;
          AreaActivityPrograms_AreaFragment: AreaActivityPrograms_AreaFragment;
          AreaGuideArticles_AreaFragment: AreaGuideArticles_AreaFragment;
          AreaSpotsPreview_AreaFragment: AreaSpotsPreview_AreaFragment;
          AreaBases_AreaFragment: AreaBases_AreaFragment;
        };
      })
    | null;
};

export type SiteAboutFacilities_SiteFragment = {
  __typename: "Site";
  content: {
    __typename: "SiteContent";
    parkingCapacity?: string | null;
    parkingInfo?: string | null;
    mapImageUrl?: string | null;
  };
  facilities: Array<
    {
      __typename: "Facility";
      id: string;
      type: FacilityType;
      name: string;
      description: string;
    } & {
      " $fragmentRefs"?: {
        FacilityDetailModalFragmentFragment: FacilityDetailModalFragmentFragment;
      };
    }
  >;
} & { " $fragmentName"?: "SiteAboutFacilities_SiteFragment" };

export type SiteAboutOverview_SiteFragment = {
  __typename: "Site";
  content: { __typename: "SiteContent"; description?: string | null };
} & { " $fragmentName"?: "SiteAboutOverview_SiteFragment" };

export type SiteAbout_SiteFragment = ({ __typename: "Site" } & {
  " $fragmentRefs"?: {
    SiteAboutOverview_SiteFragment: SiteAboutOverview_SiteFragment;
    SiteAboutFacilities_SiteFragment: SiteAboutFacilities_SiteFragment;
  };
}) & { " $fragmentName"?: "SiteAbout_SiteFragment" };

export type SiteActivityPrograms_SiteFragment = {
  __typename: "Site";
  content: {
    __typename: "SiteContent";
    activityPrograms: Array<
      { __typename: "SiteActivityProgram"; id: string } & {
        " $fragmentRefs"?: {
          DxActivityProgramSection_SiteActivityProgramFragment: DxActivityProgramSection_SiteActivityProgramFragment;
        };
      }
    >;
  };
} & { " $fragmentName"?: "SiteActivityPrograms_SiteFragment" };

export type SiteHero_SiteFragment = {
  __typename: "Site";
  name: string;
  content: {
    __typename: "SiteContent";
    prefecture?: string | null;
    city?: string | null;
    mapImageUrl?: string | null;
    heroImages: Array<{
      __typename: "UploadedFile";
      url: string;
      caption?: string | null;
    }>;
  };
  accommodations: Array<{
    __typename: "Accommodation";
    id: string;
    architectureType: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
    };
  }>;
} & { " $fragmentName"?: "SiteHero_SiteFragment" };

export type SiteRoomTypes_SiteFragment = {
  __typename: "Site";
  roomTypesForReservation: Array<{
    __typename: "RoomType";
    id: string;
    slug?: string | null;
    displayName: string;
    architectureType?: {
      __typename: "ArchitectureType";
      id: string;
      name: string;
      size?: ArchitectureTypeSize | null;
      content: {
        __typename: "ContentArchitectureType";
        id: string;
        capacityDescription: string;
        sizeDescription: string;
      };
    } | null;
    content?: {
      __typename: "ContentRoomType";
      id: string;
      heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
    } | null;
  }>;
} & { " $fragmentName"?: "SiteRoomTypes_SiteFragment" };

export type SiteDetailPageMeta_SiteFragment = {
  __typename: "Site";
  name: string;
  content: {
    __typename: "SiteContent";
    heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
  };
} & { " $fragmentName"?: "SiteDetailPageMeta_SiteFragment" };

export type SiteDetailPageQueryVariables = Exact<{
  siteSlug: Scalars["String"]["input"];
}>;

export type SiteDetailPageQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; hasReservablePlan: boolean } | null;
  siteBySlug?:
    | ({
        __typename: "Site";
        id: string;
        slug: string;
        reservable: boolean;
        reservableForOwnerEarlyAccess: boolean;
        area: { __typename: "Area"; slug: string; name: string };
        roomTypesForReservation: Array<{
          __typename: "RoomType";
          id: string;
          architectureType?: {
            __typename: "ArchitectureType";
            id: string;
            seriesShortName: string;
          } | null;
        }>;
      } & {
        " $fragmentRefs"?: {
          SiteDetailPageMeta_SiteFragment: SiteDetailPageMeta_SiteFragment;
          SiteHero_SiteFragment: SiteHero_SiteFragment;
          SiteAbout_SiteFragment: SiteAbout_SiteFragment;
          SiteRoomTypes_SiteFragment: SiteRoomTypes_SiteFragment;
          SiteActivityPrograms_SiteFragment: SiteActivityPrograms_SiteFragment;
          DxAccessSection_SiteFragment: DxAccessSection_SiteFragment;
          DxFaqSection_SiteFragment: DxFaqSection_SiteFragment;
          DxHotelJsonLd_SiteFragment: DxHotelJsonLd_SiteFragment;
        };
      })
    | null;
};

export type RoomTypeAbout_RoomTypeFragment = {
  __typename: "RoomType";
  displayName: string;
  notes?: string | null;
  content?: {
    __typename: "ContentRoomType";
    description?: string | null;
  } | null;
  site: {
    __typename: "Site";
    name: string;
    content: {
      __typename: "SiteContent";
      prefecture?: string | null;
      city?: string | null;
      parkingCapacity?: string | null;
      parkingInfo?: string | null;
      mapImageUrl?: string | null;
    };
    area: { __typename: "Area"; slug: string };
  };
  architectureType?: {
    __typename: "ArchitectureType";
    name: string;
    content: {
      __typename: "ContentArchitectureType";
      id: string;
      capacityDescription: string;
      sizeDescription: string;
      basicAmenities: Array<{
        __typename: "ContentArchitectureTypeBasicAmenity";
        name: string;
      }>;
    };
  } | null;
  features: Array<{
    __typename: "RoomTypeFeature";
    slug: string;
    displayName: string;
    iconSlug?: string | null;
    sort: number;
  }>;
} & { " $fragmentName"?: "RoomTypeAbout_RoomTypeFragment" };

export type RoomTypeAccess_RoomTypeFragment = {
  __typename: "RoomType";
  site: { __typename: "Site" } & {
    " $fragmentRefs"?: {
      DxAccessSection_SiteFragment: DxAccessSection_SiteFragment;
    };
  };
} & { " $fragmentName"?: "RoomTypeAccess_RoomTypeFragment" };

export type RoomTypeActivityPrograms_RoomTypeFragment = {
  __typename: "RoomType";
  site: {
    __typename: "Site";
    content: {
      __typename: "SiteContent";
      activityPrograms: Array<
        { __typename: "SiteActivityProgram"; id: string } & {
          " $fragmentRefs"?: {
            DxActivityProgramSection_SiteActivityProgramFragment: DxActivityProgramSection_SiteActivityProgramFragment;
          };
        }
      >;
    };
  };
} & { " $fragmentName"?: "RoomTypeActivityPrograms_RoomTypeFragment" };

export type RoomTypeAmenities_RoomTypeFragment = {
  __typename: "RoomType";
  architectureType?: {
    __typename: "ArchitectureType";
    content: {
      __typename: "ContentArchitectureType";
      id: string;
      equipmentsListUrl?: string | null;
    };
  } | null;
} & { " $fragmentName"?: "RoomTypeAmenities_RoomTypeFragment" };

export type RoomTypeHero_RoomTypeFragment = {
  __typename: "RoomType";
  displayName: string;
  content?: {
    __typename: "ContentRoomType";
    heroImages: Array<{
      __typename: "UploadedFile";
      url: string;
      caption?: string | null;
    }>;
  } | null;
  site: {
    __typename: "Site";
    slug: string;
    area: { __typename: "Area"; slug: string };
  };
} & { " $fragmentName"?: "RoomTypeHero_RoomTypeFragment" };

export type RoomTypeInformation_RoomTypeFragment = {
  __typename: "RoomType";
  site: { __typename: "Site" } & {
    " $fragmentRefs"?: { DxFaqSection_SiteFragment: DxFaqSection_SiteFragment };
  };
} & { " $fragmentName"?: "RoomTypeInformation_RoomTypeFragment" };

export type RoomTypeJsonLd_RoomTypeFragment = {
  __typename: "RoomType";
  slug?: string | null;
  displayName: string;
  content?: {
    __typename: "ContentRoomType";
    description?: string | null;
    heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
  } | null;
  site: {
    __typename: "Site";
    name: string;
    slug: string;
    area: { __typename: "Area"; slug: string };
  };
  architectureType?: {
    __typename: "ArchitectureType";
    name: string;
    capacity: number;
    content: {
      __typename: "ContentArchitectureType";
      id: string;
      sizeSqm: number;
    };
  } | null;
  features: Array<{
    __typename: "RoomTypeFeature";
    slug: string;
    displayName: string;
    category: RoomTypeFeatureCategory;
  }>;
} & { " $fragmentName"?: "RoomTypeJsonLd_RoomTypeFragment" };

export type RoomTypeManual_RoomTypeFragment = {
  __typename: "RoomType";
  architectureType?: {
    __typename: "ArchitectureType";
    content: {
      __typename: "ContentArchitectureType";
      id: string;
      amenitiesInstructionsUrl?: string | null;
    };
  } | null;
} & { " $fragmentName"?: "RoomTypeManual_RoomTypeFragment" };

export type RoomTypeServices_RoomTypeFragment = {
  __typename: "RoomType";
  site: {
    __typename: "Site";
    facilities: Array<
      {
        __typename: "Facility";
        id: string;
        label: string;
        image: { __typename: "UploadedFile"; url: string };
      } & {
        " $fragmentRefs"?: {
          FacilityDetailModalFragmentFragment: FacilityDetailModalFragmentFragment;
        };
      }
    >;
  };
} & { " $fragmentName"?: "RoomTypeServices_RoomTypeFragment" };

export type RoomTypeDetailPageQueryVariables = Exact<{
  siteSlug: Scalars["String"]["input"];
  roomTypeSlug: Scalars["String"]["input"];
}>;

export type RoomTypeDetailPageQuery = {
  __typename: "Query";
  roomTypeBySlug?:
    | ({
        __typename: "RoomType";
        id: string;
        site: {
          __typename: "Site";
          id: string;
          reservable: boolean;
          reservableForOwnerEarlyAccess: boolean;
          area: { __typename: "Area"; slug: string; name: string };
        };
        architectureType?: {
          __typename: "ArchitectureType";
          id: string;
          seriesShortName: string;
        } | null;
        features: Array<{
          __typename: "RoomTypeFeature";
          id: string;
          slug: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          RoomTypeJsonLd_RoomTypeFragment: RoomTypeJsonLd_RoomTypeFragment;
          RoomTypeHero_RoomTypeFragment: RoomTypeHero_RoomTypeFragment;
          RoomTypeAbout_RoomTypeFragment: RoomTypeAbout_RoomTypeFragment;
          RoomTypeServices_RoomTypeFragment: RoomTypeServices_RoomTypeFragment;
          RoomTypeActivityPrograms_RoomTypeFragment: RoomTypeActivityPrograms_RoomTypeFragment;
          RoomTypeAmenities_RoomTypeFragment: RoomTypeAmenities_RoomTypeFragment;
          RoomTypeAccess_RoomTypeFragment: RoomTypeAccess_RoomTypeFragment;
          RoomTypeManual_RoomTypeFragment: RoomTypeManual_RoomTypeFragment;
          RoomTypeInformation_RoomTypeFragment: RoomTypeInformation_RoomTypeFragment;
        };
      })
    | null;
};

export type SpotCard_AreaGuideSpotFragment = {
  __typename: "AreaGuideSpot";
  id: string;
  name: string;
  categories: Array<AreaGuideSpotCategory>;
  tags: Array<string>;
  description?: string | null;
  businessHours?: string | null;
  websiteUrl?: string | null;
  mapUrl?: string | null;
  images: Array<{ __typename: "UploadedFile"; url: string }>;
} & { " $fragmentName"?: "SpotCard_AreaGuideSpotFragment" };

export type SpotsBottomInfo_AreaFragment = {
  __typename: "Area";
  content: {
    __typename: "AreaContent";
    guideSpotTipsTitle?: string | null;
    guideSpotTips?: string | null;
    guideSpotMapListUrl?: string | null;
  };
} & { " $fragmentName"?: "SpotsBottomInfo_AreaFragment" };

export type SpotsJsonLd_AreaFragment = { __typename: "Area"; name: string } & {
  " $fragmentName"?: "SpotsJsonLd_AreaFragment";
};

export type SpotsList_AreaFragment = {
  __typename: "Area";
  content: {
    __typename: "AreaContent";
    guideSpots: Array<
      {
        __typename: "AreaGuideSpot";
        id: string;
        categories: Array<AreaGuideSpotCategory>;
      } & {
        " $fragmentRefs"?: {
          SpotCard_AreaGuideSpotFragment: SpotCard_AreaGuideSpotFragment;
        };
      }
    >;
  };
} & { " $fragmentName"?: "SpotsList_AreaFragment" };

export type SpotsPanelHeader_AreaFragment = {
  __typename: "Area";
  name: string;
} & { " $fragmentName"?: "SpotsPanelHeader_AreaFragment" };

export type AreaSpotsQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type AreaSpotsQuery = {
  __typename: "Query";
  areaBySlug?:
    | ({
        __typename: "Area";
        id: string;
        name: string;
        content: {
          __typename: "AreaContent";
          shortAddress?: string | null;
          accessFromTokyoDescription?: string | null;
          heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
        };
      } & {
        " $fragmentRefs"?: {
          SpotsPanelHeader_AreaFragment: SpotsPanelHeader_AreaFragment;
          SpotsList_AreaFragment: SpotsList_AreaFragment;
          SpotsBottomInfo_AreaFragment: SpotsBottomInfo_AreaFragment;
          SpotsJsonLd_AreaFragment: SpotsJsonLd_AreaFragment;
        };
      })
    | null;
};

export type DxAccessSection_SiteFragment = {
  __typename: "Site";
  name: string;
  content: {
    __typename: "SiteContent";
    id: string;
    postalCode?: string | null;
    prefecture?: string | null;
    city?: string | null;
    addressLine?: string | null;
    googleMapsUrl?: string | null;
    accessRouteGroups: Array<{
      __typename: "SiteAccessRouteGroup";
      id: string;
      title: string;
      transportIcon: AccessRouteTransportIcon;
      sort: number;
      points: Array<{
        __typename: "SiteAccessRoutePoint";
        id: string;
        name: string;
        legToNextDescription?: string | null;
        sort: number;
      }>;
    }>;
  };
} & { " $fragmentName"?: "DxAccessSection_SiteFragment" };

export type DxActivityProgramSection_SiteActivityProgramFragment = {
  __typename: "SiteActivityProgram";
  id: string;
  title: string;
  description?: string | null;
  externalUrl: string;
  image: { __typename: "UploadedFile"; url: string };
} & {
  " $fragmentName"?: "DxActivityProgramSection_SiteActivityProgramFragment";
};

export type DxFaqSection_SiteFragment = {
  __typename: "Site";
  content: {
    __typename: "SiteContent";
    faqs: Array<{ __typename: "SiteFaq"; question: string; answer: string }>;
  };
} & { " $fragmentName"?: "DxFaqSection_SiteFragment" };

export type DxHotelJsonLd_SiteFragment = {
  __typename: "Site";
  name: string;
  slug: string;
  content: {
    __typename: "SiteContent";
    description?: string | null;
    postalCode?: string | null;
    prefecture?: string | null;
    city?: string | null;
    addressLine?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    heroImages: Array<{ __typename: "UploadedFile"; url: string }>;
  };
  area: { __typename: "Area"; name: string; slug: string };
  accommodations: Array<{
    __typename: "Accommodation";
    architectureType: { __typename: "ArchitectureType"; name: string };
    roomType?: {
      __typename: "RoomType";
      slug?: string | null;
      displayName: string;
    } | null;
  }>;
} & { " $fragmentName"?: "DxHotelJsonLd_SiteFragment" };

export type ResendEmailToVerifyEmailMutationVariables = Exact<{
  input: SendEmailToVerifyEmailInput;
}>;

export type ResendEmailToVerifyEmailMutation = {
  __typename: "Mutation";
  sendEmailToVerifyEmail:
    | {
        __typename: "SendEmailToVerifyNewEmailError";
        case: SendEmailToVerifyNewEmailErrorCase;
      }
    | { __typename: "SendEmailToVerifyNewEmailSuccess"; _?: boolean | null };
};

export type SendVerificationEmailMutationVariables = Exact<{
  input: SendEmailToVerifyEmailInput;
}>;

export type SendVerificationEmailMutation = {
  __typename: "Mutation";
  sendEmailToVerifyEmail:
    | {
        __typename: "SendEmailToVerifyNewEmailError";
        case: SendEmailToVerifyNewEmailErrorCase;
      }
    | { __typename: "SendEmailToVerifyNewEmailSuccess"; _?: boolean | null };
};

export type IsOrganizationManagerForGlobalMenuQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IsOrganizationManagerForGlobalMenuQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    organizationMembership?: {
      __typename: "OrganizationMembership";
      role: OrganizationRole;
    } | null;
  } | null;
};

export type OrgMemberQueryVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OrgMemberQuery = {
  __typename: "Query";
  organizationMember: {
    __typename: "OrganizationMemberPayload";
    myself: boolean;
    user: {
      __typename: "User";
      name: string;
      email: string;
      phoneNumber?: string | null;
      organizationMembership?: {
        __typename: "OrganizationMembership";
        role: OrganizationRole;
        reservationStatus: OrganizationMemberReservationStatus;
        customFieldValue?: string | null;
        organization: { __typename: "Organization"; id: string };
      } | null;
    };
  };
};

export type UpdateMembershipMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  organizationId: Scalars["ID"]["input"];
  input: PartialUpdateOrganizationMembershipInput;
}>;

export type UpdateMembershipMutation = {
  __typename: "Mutation";
  partialUpdateOrganizationMembership:
    | {
        __typename: "OrganizationMembership";
        role: OrganizationRole;
        reservationStatus: OrganizationMemberReservationStatus;
        customFieldValue?: string | null;
      }
    | {
        __typename: "PartialUpdateOrganizationMembershipError";
        message: string;
      };
};

export type LeaveOrganizationMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  organizationId: Scalars["ID"]["input"];
}>;

export type LeaveOrganizationMutation = {
  __typename: "Mutation";
  leaveOrganization:
    | { __typename: "LeaveOrganizationError"; case: LeaveOrganizationErrorCase }
    | { __typename: "Success" };
};

export type InviteBusinessMembersMutationVariables = Exact<{
  input: InviteBusinessMembersInput;
}>;

export type InviteBusinessMembersMutation = {
  __typename: "Mutation";
  inviteBusinessMembers:
    | {
        __typename: "InviteBusinessMembersError";
        case: InviteBusinessMembersErrorCase;
      }
    | { __typename: "InviteBusinessMembersSuccess"; sentCount: number };
};

export type OrganizationMemberTableFragmentFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  organizationMembership?: {
    __typename: "OrganizationMembership";
    role: OrganizationRole;
    reservationStatus: OrganizationMemberReservationStatus;
  } | null;
} & { " $fragmentName"?: "OrganizationMemberTableFragmentFragment" };

export type OrganizationMemberExportFragmentFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  phoneNumber?: string | null;
  createdAt: DateTimeString;
  updatedAt: DateTimeString;
  maybeProfile?: {
    __typename: "UserProfile";
    birthDate?: PlainDateString | null;
    professionType?: UserProfileProfessionType | null;
    address?:
      | { __typename: "AddressInJapan"; japanLine1: string; japanLine2: string }
      | {
          __typename: "AddressInternational";
          city: string;
          stateProvince: string;
          country: CountryEnum;
          intlLine1: string;
          intlLine2?: string | null;
        }
      | null;
  } | null;
  organizationMembership?: {
    __typename: "OrganizationMembership";
    role: OrganizationRole;
    customFieldValue?: string | null;
    reservationStatus: OrganizationMemberReservationStatus;
  } | null;
} & { " $fragmentName"?: "OrganizationMemberExportFragmentFragment" };

export type DataForOrgMembersQueryVariables = Exact<{ [key: string]: never }>;

export type DataForOrgMembersQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    organization?: {
      __typename: "Organization";
      id: string;
      name: string;
      emailDomainsForMember?: Array<string> | null;
      members: Array<
        {
          __typename: "User";
          id: string;
          deletedAt?: DateTimeString | null;
        } & {
          " $fragmentRefs"?: {
            OrganizationMemberTableFragmentFragment: OrganizationMemberTableFragmentFragment;
            OrganizationMemberExportFragmentFragment: OrganizationMemberExportFragmentFragment;
          };
        }
      >;
      memberCustomField: {
        __typename: "OrganizationMemberCustomField";
        enabled: boolean;
        name?: string | null;
        placeholder?: string | null;
      };
    } | null;
  };
};

export type DataForDashboardQueryVariables = Exact<{ [key: string]: never }>;

export type DataForDashboardQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    organization?: {
      __typename: "Organization";
      name: string;
      currentOrUpcomingContract?: {
        __typename: "OrganizationYearlyContract";
        nightsPerYear: number;
        nightsPerMonth: number;
        totalFee: number;
        startMonth: PlainYearMonthString;
        endMonth: PlainYearMonthString;
        amountRecord: number;
        businessPlan: {
          __typename: "BusinessPlan";
          name: string;
          feePerNights: number;
          isPeakDayFeeFree: boolean;
        };
      } | null;
      membersStay: {
        __typename: "OrganizationMembersStay";
        usedNightsInCurrentContract: number;
        monthlyConsumedNights: Array<{
          __typename: "OrganizationPlanMonthlyConsumedNights";
          yearMonth: PlainYearMonthString;
          nights: number;
        }>;
      };
      control: {
        __typename: "OrganizationControl";
        maxNightsPerMonth?: number | null;
        maxNightsPerStay?: number | null;
      };
    } | null;
  };
};

export type OrganizationBillingEmailFragment = {
  __typename: "Organization";
  id: string;
  billingEmail?: string | null;
} & { " $fragmentName"?: "OrganizationBillingEmailFragment" };

export type UpdateOrganizationBillingEmailMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: PartialUpdateOrganizationInput;
}>;

export type UpdateOrganizationBillingEmailMutation = {
  __typename: "Mutation";
  partialUpdateOrganization:
    | { __typename: "Organization" }
    | { __typename: "PartialUpdateOrganizationError"; message: string };
};

export type OrganizationPaymentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OrganizationPaymentsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    organization?:
      | ({
          __typename: "Organization";
          id: string;
          name: string;
          paymentMethodCardEnabled: boolean;
          bubbleId?: string | null;
          stripe: {
            __typename: "StripeCustomer";
            defaultCard?: {
              __typename: "StripeCard";
              brand: string;
              last4: string;
              exp_month: number;
              exp_year: number;
            } | null;
            invoices: Array<{
              __typename: "StripeInvoice";
              id: string;
              total: number;
              description?: string | null;
              status: StripeInvoiceStatus;
              hosted_invoice_url?: string | null;
              createdAt: ZonedDateTimeString;
              subscription?: {
                __typename: "StripeInvoiceSubscription";
                id: string;
              } | null;
              status_transitions?: {
                __typename: "StripeInvoiceStatusTransitions";
                paid_at?: ZonedDateTimeString | null;
              } | null;
            }>;
          };
        } & {
          " $fragmentRefs"?: {
            OrganizationBillingEmailFragment: OrganizationBillingEmailFragment;
          };
        })
      | null;
  };
};

export type ReservationsForExportQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ReservationsForExportQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    organization?: {
      __typename: "Organization";
      membersStay: {
        __typename: "OrganizationMembersStay";
        reservationsForExport: Array<{
          __typename: "ReservationExportItem";
          id: string;
          contractStartDate?: PlainDateString | null;
          organizationName: string;
          userName: string;
          userEmail: string;
          accommodationCode: string;
          siteName: string;
          checkInDate: PlainDateString;
          checkOutDate: PlainDateString;
          stayStatus: AccommodationReservationStayStatus;
          totalAmount: number;
          numberOfAdults: number;
          numberOfInfants: number;
          numberOfKids: number;
          numberOfDogs: number;
          nights: number;
          stayComment?: string | null;
          stayRating?: number | null;
          createdAt: ZonedDateTimeString;
          updatedAt: ZonedDateTimeString;
        }>;
      };
    } | null;
  };
};

export type AccommodationReservationDetailFragment = {
  __typename: "AccommodationReservation";
  id: string;
  reservedFrom: ZonedDateTimeString;
  reservedTo: ZonedDateTimeString;
  stayStatus: AccommodationReservationStayStatus;
  checkedInAt?: ZonedDateTimeString | null;
  checkedOutAt?: ZonedDateTimeString | null;
  user?: { __typename: "User"; id: string; name: string; email: string } | null;
  accommodation: { __typename: "Accommodation"; name: string };
  detail: {
    __typename: "AccommodationReservationDetail";
    numberOfAdults: number;
    numberOfKids: number;
    numberOfInfants: number;
  };
  review?: {
    __typename: "StayReview";
    rating: number;
    comment?: string | null;
  } | null;
} & { " $fragmentName"?: "AccommodationReservationDetailFragment" };

export type DataForOrgReservationsQueryVariables = Exact<{
  yearMonth: Scalars["PlainYearMonth"]["input"];
}>;

export type DataForOrgReservationsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    organization?: {
      __typename: "Organization";
      name: string;
      membersStay: {
        __typename: "OrganizationMembersStay";
        reservations: Array<
          {
            __typename: "AccommodationReservation";
            id: string;
            firstDate: PlainDateString;
            lastDate: PlainDateString;
            nights: number;
            stayStatus: AccommodationReservationStayStatus;
            user?: { __typename: "User"; name: string; email: string } | null;
            accommodation: { __typename: "Accommodation"; name: string };
          } & {
            " $fragmentRefs"?: {
              AccommodationReservationDetailFragment: AccommodationReservationDetailFragment;
            };
          }
        >;
      };
    } | null;
  };
};

export type OrganizationSettingsFormFragment = {
  __typename: "Organization";
  id: string;
  invitationCode: string;
  emailDomainsForMember?: Array<string> | null;
  announcementContent: string;
  control: {
    __typename: "OrganizationControl";
    maxNightsPerMonth?: number | null;
    maxNightsPerStay?: number | null;
    maxNightsPerMember?: number | null;
  };
  memberCustomField: {
    __typename: "OrganizationMemberCustomField";
    enabled: boolean;
    name?: string | null;
    placeholder?: string | null;
    required: boolean;
  };
  currentOrUpcomingContract?: {
    __typename: "OrganizationYearlyContract";
    nightsPerYear: number;
    nightsPerMonth: number;
  } | null;
} & { " $fragmentName"?: "OrganizationSettingsFormFragment" };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: PartialUpdateOrganizationInput;
}>;

export type UpdateOrganizationSettingsMutation = {
  __typename: "Mutation";
  partialUpdateOrganization:
    | { __typename: "Organization" }
    | { __typename: "PartialUpdateOrganizationError"; message: string };
};

export type DataForOrgSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type DataForOrgSettingsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    organization?:
      | ({
          __typename: "Organization";
          name: string;
          currentOrUpcomingContract?: {
            __typename: "OrganizationYearlyContract";
            nightsPerYear: number;
            amountRecord: number;
            businessPlan: { __typename: "BusinessPlan"; name: string };
          } | null;
        } & {
          " $fragmentRefs"?: {
            OrganizationSettingsFormFragment: OrganizationSettingsFormFragment;
          };
        })
      | null;
  };
};

export type GetOrganizationForSignUpQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetOrganizationForSignUpQuery = {
  __typename: "Query";
  organization: {
    __typename: "Organization";
    id: string;
    name: string;
    emailDomainsForMember?: Array<string> | null;
    invitationCode: string;
    announcementContent: string;
    memberCustomField: {
      __typename: "OrganizationMemberCustomField";
      enabled: boolean;
      name?: string | null;
      placeholder?: string | null;
      required: boolean;
    };
  };
  maybeViewer?: { __typename: "User"; email: string; name: string } | null;
};

export type SetUserNameAndJoinOrganizationMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  customFieldValue?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SetUserNameAndJoinOrganizationMutation = {
  __typename: "Mutation";
  updateViewerName?: { __typename: "User"; id: string } | null;
  joinOrganization:
    | { __typename: "JoinOrganizationError"; case: JoinOrganizationErrorCase }
    | { __typename: "Success" };
};

export type AccommodationReservationForCheckInQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationForCheckInQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; id: string; email: string };
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    reservedFrom: ZonedDateTimeString;
    reservedTo: ZonedDateTimeString;
    standardCheckInTime: ZonedDateTimeString;
    earlyCheckInStatus: EarlyCheckInStatus;
    currentEarlyCheckInFee?: number | null;
    user?: { __typename: "User"; id: string } | null;
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfTotalChildren: number;
      previousLocation: string;
      nextLocation: string;
      bringDog: boolean;
      numberOfDogs: number;
      useEvCharger: boolean;
    };
    feeApplicability: {
      __typename: "AccommodationFeeApplicability";
      waiveDogFee: boolean;
      waiveEvChargerFee: boolean;
    };
    accommodation: {
      __typename: "Accommodation";
      name: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: {
        __typename: "Site";
        checkInAuthenticationType: CheckInAuthenticationType;
      };
    };
    userCompanions: Array<{
      __typename: "UserCompanion";
      id: string;
      name: string;
    }>;
    checkInQrCode?: {
      __typename: "CheckInQrCode";
      status: CheckInQrCodeStatus;
    } | null;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
  } & {
    " $fragmentRefs"?: {
      EarlyCheckInInfoModalFragment: EarlyCheckInInfoModalFragment;
    };
  };
};

export type UpdateAccommodationReservationOptionsOnCheckInPageMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    input: UpdateAccommodationReservationOptionsInput;
  }>;

export type UpdateAccommodationReservationOptionsOnCheckInPageMutation = {
  __typename: "Mutation";
  updateAccommodationReservationOptions:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "UpdateAccommodationReservationOptionsError";
        case: UpdateAccommodationReservationOptionsErrorCase;
      };
};

export type CheckInAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CheckInAccommodationReservationInput;
}>;

export type CheckInAccommodationReservationMutation = {
  __typename: "Mutation";
  checkInAccommodationReservation:
    | { __typename: "AccommodationReservation"; accessCode?: string | null }
    | {
        __typename: "CheckInAccommodationReservationError";
        case: CheckInAccommodationReservationErrorCase;
      };
};

export type AccommodationReservationForQrCodeAuthGuideQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationForQrCodeAuthGuideQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      site: {
        __typename: "Site";
        id: string;
        checkInAuthenticationType: CheckInAuthenticationType;
        content: {
          __typename: "SiteContent";
          id: string;
          mapImageUrl?: string | null;
        };
      };
    };
  };
};

export type CheckInQrCodeFieldsFragment = {
  __typename: "CheckInQrCode";
  code: string;
  expiresAt: ZonedDateTimeString;
  status: CheckInQrCodeStatus;
} & { " $fragmentName"?: "CheckInQrCodeFieldsFragment" };

export type GenerateCheckInQrCodeMutationVariables = Exact<{
  input: GenerateCheckInQrCodeInput;
}>;

export type GenerateCheckInQrCodeMutation = {
  __typename: "Mutation";
  generateCheckInQrCode:
    | {
        __typename: "GenerateCheckInQrCodeError";
        case: GenerateCheckInQrCodeErrorCase;
      }
    | {
        __typename: "GenerateCheckInQrCodeSuccess";
        checkInQrCode: { __typename: "CheckInQrCode" } & {
          " $fragmentRefs"?: {
            CheckInQrCodeFieldsFragment: CheckInQrCodeFieldsFragment;
          };
        };
      };
};

export type CheckInQrCodeStatusQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type CheckInQrCodeStatusQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    checkInQrCode?:
      | ({ __typename: "CheckInQrCode" } & {
          " $fragmentRefs"?: {
            CheckInQrCodeFieldsFragment: CheckInQrCodeFieldsFragment;
          };
        })
      | null;
  };
};

export type IsViewerLoggedInForCheckinQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IsViewerLoggedInForCheckinQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
};

export type LookupOtaReservationQueryVariables = Exact<{
  reference: Scalars["String"]["input"];
}>;

export type LookupOtaReservationQuery = {
  __typename: "Query";
  lookupOtaReservationByReference: Array<
    | {
        __typename: "OtaReservationLookupError";
        case: OtaReservationLookupErrorCase;
      }
    | {
        __typename: "OtaReservationLookupSuccess";
        preRegistrationUrl: string;
        siteName: string;
        architectureTypeName: string;
        facilityTypes: Array<AccommodationFacilityType>;
        firstDate: PlainDateString;
        lastDate: PlainDateString;
      }
  >;
};

export type CheckinRedirectMaybeViewerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CheckinRedirectMaybeViewerQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    id: string;
    allAccommodationReservations: Array<{
      __typename: "AccommodationReservation";
      id: string;
      stayStatus: AccommodationReservationStayStatus;
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
    }>;
  } | null;
};

export type CoOwnersApplicationDetailsFragment = {
  __typename: "OwnerPlan";
  type: OwnerPlanType;
  unitNightsPerYear: number;
  unitPurchaseAmount: number;
  unitApplicationFee: number;
  registrationFee: number;
  coOwnersMaxPeakDaysPerUnit?: number | null;
  coOwnersMaxConcurrentReservationsPerUnit?: number | null;
  site: { __typename: "Site"; name: string };
  architectureType?: { __typename: "ArchitectureType"; name: string } | null;
  coOwnersPlanOfferings: Array<{
    __typename: "CoOwnersPlanOffering";
    units: number;
    estimate?: { __typename: "UploadedFile"; url: string } | null;
  }>;
  accommodationFacilities: Array<{
    __typename: "AccommodationFacility";
    type: AccommodationFacilityType;
  }>;
} & { " $fragmentName"?: "CoOwnersApplicationDetailsFragment" };

export type SubmitCoOwnersApplicationMutationVariables = Exact<{
  input: CoOwnersApplicationInput;
}>;

export type SubmitCoOwnersApplicationMutation = {
  __typename: "Mutation";
  submitCoOwnersApplication:
    | { __typename: "CoOwnersApplication"; id: string }
    | {
        __typename: "StripeRequireNextAction";
        clientSecret: string;
        coOwnersApplicationId?: string | null;
      }
    | {
        __typename: "SubmitCoOwnersApplicationError";
        case: SubmitCoOwnersApplicationErrorCase;
      };
};

export type FacilityControllerFragmentFragment = {
  __typename: "FacilityController";
  attribute?:
    | ({ __typename: "CoWorkingSpaceDoorLock" } & {
        " $fragmentRefs"?: {
          CoWorkingSpaceDoorLockFragmentFragment: CoWorkingSpaceDoorLockFragmentFragment;
        };
      })
    | ({ __typename: "EvChargerLock" } & {
        " $fragmentRefs"?: {
          EvChargerLockFragmentFragment: EvChargerLockFragmentFragment;
        };
      })
    | ({ __typename: "OnsenAndSaunaDoorLock" } & {
        " $fragmentRefs"?: {
          OnsenAndSaunaDoorLockFragmentFragment: OnsenAndSaunaDoorLockFragmentFragment;
        };
      })
    | ({ __typename: "RentalCycleKeyBox" } & {
        " $fragmentRefs"?: {
          RentalCycleKeyBoxFragmentFragment: RentalCycleKeyBoxFragmentFragment;
        };
      })
    | ({ __typename: "WashingMachineTracker" } & {
        " $fragmentRefs"?: {
          WashingMachineTrackerFragmentFragment: WashingMachineTrackerFragmentFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "FacilityControllerFragmentFragment" };

export type FacilityReservationCancelDialogQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type FacilityReservationCancelDialogQuery = {
  __typename: "Query";
  facilityReservation?: {
    __typename: "FacilityReservation";
    resourceLabel: string;
    startAt: PlainDateTimeString;
    endAt: PlainDateTimeString;
    units: number;
    unitType: FacilityUnitType;
    chargedFeeAmount: number;
    estimatedCancelFee: number;
    resource: {
      __typename: "FacilityResource";
      facility: { __typename: "Facility"; cancelRuleUrl?: string | null };
    };
  } | null;
};

export type CoWorkingSpaceDoorLockFragmentFragment = {
  __typename: "CoWorkingSpaceDoorLock";
  keyUrl?: string | null;
} & { " $fragmentName"?: "CoWorkingSpaceDoorLockFragmentFragment" };

export type EvChargerLockFragmentFragment = {
  __typename: "EvChargerLock";
  controllerId?: string | null;
  token?: string | null;
  expireAt: ZonedDateTimeString;
} & { " $fragmentName"?: "EvChargerLockFragmentFragment" };

export type OnsenAndSaunaDoorLockFragmentFragment = {
  __typename: "OnsenAndSaunaDoorLock";
  pinCode?: string | null;
} & { " $fragmentName"?: "OnsenAndSaunaDoorLockFragmentFragment" };

export type RentalCycleKeyBoxFragmentFragment = {
  __typename: "RentalCycleKeyBox";
  pinCode?: string | null;
  comment?: string | null;
  inUseAt?: string | null;
  returnedAt?: string | null;
  reservationId: string;
  usableFrom: PlainDateTimeString;
  usableTo: PlainDateTimeString;
} & { " $fragmentName"?: "RentalCycleKeyBoxFragmentFragment" };

export type UpdateFacilityReservationMutationVariables = Exact<{
  input: UpdateFacilityReservationInput;
}>;

export type UpdateFacilityReservationMutation = {
  __typename: "Mutation";
  updateFacilityReservation:
    | {
        __typename: "UpdateFacilityReservationError";
        case: UpdateFacilityReservationErrorCase;
      }
    | {
        __typename: "UpdateFacilityReservationSuccess";
        reservation: {
          __typename: "FacilityReservation";
          id: string;
          isCancelable: boolean;
          estimatedCancelFee: number;
          controllers: Array<{
            __typename: "FacilityController";
            attribute?:
              | { __typename: "CoWorkingSpaceDoorLock" }
              | { __typename: "EvChargerLock" }
              | { __typename: "OnsenAndSaunaDoorLock" }
              | ({ __typename: "RentalCycleKeyBox" } & {
                  " $fragmentRefs"?: {
                    RentalCycleKeyBoxFragmentFragment: RentalCycleKeyBoxFragmentFragment;
                  };
                })
              | { __typename: "WashingMachineTracker" }
              | null;
          }>;
        };
      };
};

export type WashingMachineTrackerFragmentFragment = {
  __typename: "WashingMachineTracker";
  controllerId?: string | null;
} & { " $fragmentName"?: "WashingMachineTrackerFragmentFragment" };

export type WashingMachineTrackerStatusQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type WashingMachineTrackerStatusQuery = {
  __typename: "Query";
  plugDevice?: {
    __typename: "PlugDevice";
    id: string;
    status: PlugDeviceStatus;
    lastChangedAt: ZonedDateTimeString;
  } | null;
};

export type FacilityDetailPageQueryVariables = Exact<{
  facilityType: FacilityType;
  id: Scalars["ID"]["input"];
}>;

export type FacilityDetailPageQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    reservedTo: ZonedDateTimeString;
  };
  facility?: {
    __typename: "Facility";
    id: string;
    name: string;
    description: string;
    isReserveEnabled: boolean;
    unitType: FacilityUnitType;
    reserveDeadlineHour: number;
    reserveDeadlineDaysBefore: number;
    detailUrl?: string | null;
    contentUsage?: string | null;
    contentDetail?: string | null;
    contentNotice?: string | null;
    facilityType: FacilityType;
    image: { __typename: "UploadedFile"; rawUrl: string };
    baseFeePolicies: Array<{
      __typename: "FacilityBaseFeePolicy";
      unit: number;
      unitFeeAmount: number;
    }>;
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      name: string;
      controllers: Array<
        { __typename: "FacilityController" } & {
          " $fragmentRefs"?: {
            FacilityControllerFragmentFragment: FacilityControllerFragmentFragment;
          };
        }
      >;
    }>;
  } | null;
};

export type FacilityReservationDetailFragment = {
  __typename: "FacilityReservation";
  id: string;
  startAt: PlainDateTimeString;
  endAt: PlainDateTimeString;
  units: number;
  unitType: FacilityUnitType;
  chargedFeeAmount: number;
  isCancelable: boolean;
  estimatedCancelFee: number;
  resourceLabel: string;
  customFieldValues: Array<{
    __typename: "FacilityCustomFieldValue";
    key: string;
    value: string;
  }>;
  controllers: Array<
    { __typename: "FacilityController" } & {
      " $fragmentRefs"?: {
        FacilityControllerFragmentFragment: FacilityControllerFragmentFragment;
      };
    }
  >;
  resource: {
    __typename: "FacilityResource";
    facility: {
      __typename: "Facility";
      id: string;
      name: string;
      detailUrl?: string | null;
      description: string;
      contentUsage?: string | null;
      contentDetail?: string | null;
      contentNotice?: string | null;
      cancelRuleUrl?: string | null;
      facilityType: FacilityType;
      image: { __typename: "UploadedFile"; rawUrl: string };
      customFields?: Array<{
        __typename: "FacilityCustomFieldItem";
        key: string;
        label: string;
        type: FacilityFieldType;
        required: boolean;
        options?: Array<string> | null;
        placeholder?: string | null;
      }> | null;
    };
  };
} & { " $fragmentName"?: "FacilityReservationDetailFragment" };

export type FacilityReservationsByAccommodationQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  facilityType: FacilityType;
}>;

export type FacilityReservationsByAccommodationQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    hasCanceled: boolean;
    isFacilityReservable: boolean;
    facilityReservations: Array<
      { __typename: "FacilityReservation" } & {
        " $fragmentRefs"?: {
          FacilityReservationDetailFragment: FacilityReservationDetailFragment;
        };
      }
    >;
  };
};

export type CancelFacilityReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type CancelFacilityReservationMutation = {
  __typename: "Mutation";
  cancelFacilityReservation:
    | {
        __typename: "CancelFacilityReservationError";
        case: CancelFacilityReservationErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type CreateFacilityReservationMutationVariables = Exact<{
  input: CreateFacilityReservationInput;
}>;

export type CreateFacilityReservationMutation = {
  __typename: "Mutation";
  createFacilityReservation:
    | {
        __typename: "CreateFacilityReservationError";
        case: CreateFacilityReservationErrorCase;
      }
    | {
        __typename: "CreateFacilityReservationSuccess";
        reservation: { __typename: "FacilityReservation"; id: string };
      };
};

export type FacilityReservationPageQueryVariables = Exact<{
  facilityType: FacilityType;
  id: Scalars["ID"]["input"];
}>;

export type FacilityReservationPageQuery = {
  __typename: "Query";
  facility?: {
    __typename: "Facility";
    unitType: FacilityUnitType;
    isReserveEnabled: boolean;
    name: string;
    description: string;
    detailUrl?: string | null;
    reserveDeadlineHour: number;
    reserveDeadlineDaysBefore: number;
    contentGuide?: string | null;
    termsUrl?: string | null;
    termsLabel?: string | null;
    image: { __typename: "UploadedFile"; rawUrl: string };
    resources: Array<{
      __typename: "FacilityResource";
      id: string;
      name: string;
      isReservable: boolean;
      baseFeePolicies: Array<{
        __typename: "FacilityBaseFeePolicy";
        id: string;
        unit: number;
        unitFeeAmount: number;
      }>;
      slotAvailabilities: Array<{
        __typename: "FacilitySlotAvailability";
        slotId?: string | null;
        date: PlainDateString;
        label: string;
        isReservable: boolean;
        unavailableReason?: FacilitySlotUnavailableReason | null;
      }>;
    }>;
    customFields?: Array<{
      __typename: "FacilityCustomFieldItem";
      key: string;
      label: string;
      type: FacilityFieldType;
      required: boolean;
      options?: Array<string> | null;
      placeholder?: string | null;
      caption?: string | null;
    }> | null;
    discountFeePolicies: Array<{
      __typename: "FacilityDiscountFeePolicy";
      label: string;
      discountModifierType: FeeModifierType;
      discountValue: number;
    }>;
  } | null;
};

export type FacilityItemFragment = {
  __typename: "Facility";
  id: string;
  isReserveEnabled: boolean;
  isReservable: boolean;
  isUsable: boolean;
  isReserved: boolean;
  name: string;
  facilityType: FacilityType;
  image: { __typename: "UploadedFile"; rawUrl: string };
} & { " $fragmentName"?: "FacilityItemFragment" };

export type AccommodationFacilityListFragment = {
  __typename: "AccommodationReservation";
  id: string;
  facilities: Array<
    { __typename: "Facility"; id: string } & {
      " $fragmentRefs"?: { FacilityItemFragment: FacilityItemFragment };
    }
  >;
} & { " $fragmentName"?: "AccommodationFacilityListFragment" };

export type FacilityDetailModalFragmentFragment = {
  __typename: "Facility";
  label: string;
  name: string;
  description: string;
  detailUrl?: string | null;
  isReserveEnabled: boolean;
  unitType: FacilityUnitType;
  reserveDeadlineHour: number;
  reserveDeadlineDaysBefore: number;
  image: { __typename: "UploadedFile"; rawUrl: string };
  resources: Array<{
    __typename: "FacilityResource";
    baseFeePolicies: Array<{
      __typename: "FacilityBaseFeePolicy";
      unit: number;
      unitFeeAmount: number;
    }>;
  }>;
} & { " $fragmentName"?: "FacilityDetailModalFragmentFragment" };

export type TentativeAccommodationReservationErrorCaseFragment = {
  __typename: "TentativeAccommodationReservationError";
  case: TentativeAccommodationReservationErrorCase;
} & { " $fragmentName"?: "TentativeAccommodationReservationErrorCaseFragment" };

export type PermissionOnDefaultLayoutQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PermissionOnDefaultLayoutQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    id: string;
    hasReservablePlan: boolean;
    organization?: { __typename: "Organization"; id: string } | null;
  } | null;
};

export type MyReservationsQueryVariables = Exact<{ [key: string]: never }>;

export type MyReservationsQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    id: string;
    accommodationReservations: Array<
      {
        __typename: "AccommodationReservation";
        id: string;
        stayStatus: AccommodationReservationStayStatus;
        canCheckIn: boolean;
        canCheckOut: boolean;
        accessCode?: string | null;
        currentEarlyCheckInFee?: number | null;
      } & {
        " $fragmentRefs"?: { ReservationBoxFragment: ReservationBoxFragment };
      }
    >;
  } | null;
};

export type InitiateAccountLinkMutationVariables = Exact<{
  input: InitiateAccountLinkInput;
}>;

export type InitiateAccountLinkMutation = {
  __typename: "Mutation";
  initiateAccountLink:
    | {
        __typename: "InitiateAccountLinkError";
        case: InitiateAccountLinkErrorCase;
      }
    | { __typename: "InitiateAccountLinkSuccess"; redirectUrl: string };
};

export type VerifyAccountLinkSessionQueryVariables = Exact<{
  input: VerifyAccountLinkSessionInput;
}>;

export type VerifyAccountLinkSessionQuery = {
  __typename: "Query";
  verifyAccountLinkSession:
    | {
        __typename: "VerifyAccountLinkSessionError";
        case: VerifyAccountLinkSessionErrorCase;
      }
    | {
        __typename: "VerifyAccountLinkSessionSuccess";
        email: string;
        currentIdentity: {
          __typename: "AccountLinkIdentity";
          userId: string;
          provider: string;
          connection: string;
        };
        candidateIdentity: {
          __typename: "AccountLinkIdentity";
          userId: string;
          provider: string;
          connection: string;
        };
      };
};

export type EditEmailDialogSendEmailToVerifyNewEmailMutationVariables = Exact<{
  newEmail: Scalars["String"]["input"];
}>;

export type EditEmailDialogSendEmailToVerifyNewEmailMutation = {
  __typename: "Mutation";
  sendEmailToVerifyNewEmail:
    | {
        __typename: "SendEmailToVerifyNewEmailError";
        case: SendEmailToVerifyNewEmailErrorCase;
      }
    | { __typename: "SendEmailToVerifyNewEmailSuccess" };
};

export type EditEmailDialogVerifyNewEmailMutationVariables = Exact<{
  newEmail: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type EditEmailDialogVerifyNewEmailMutation = {
  __typename: "Mutation";
  verifyNewEmail:
    | { __typename: "VerifyNewEmailError"; case: VerifyNewEmailErrorCase }
    | { __typename: "VerifyNewEmailSuccess" };
};

export type LinkedIdentitiesQueryVariables = Exact<{ [key: string]: never }>;

export type LinkedIdentitiesQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    email: string;
    identities: Array<{
      __typename: "UserIdentity";
      provider: IdentityProvider;
      email?: string | null;
      emailVerified: boolean;
      userId: string;
      connection: string;
      isAppleRelay: boolean;
      autoGeneratedPassword?: boolean | null;
    }>;
  };
};

export type InitiateAddIdentityMutationVariables = Exact<{
  input: InitiateAddIdentityInput;
}>;

export type InitiateAddIdentityMutation = {
  __typename: "Mutation";
  initiateAddIdentity:
    | {
        __typename: "InitiateAddIdentityError";
        case: InitiateAddIdentityErrorCase;
      }
    | { __typename: "InitiateAddIdentitySuccess"; redirectUrl: string };
};

export type RemoveIdentityMutationVariables = Exact<{
  input: RemoveIdentityInput;
}>;

export type RemoveIdentityMutation = {
  __typename: "Mutation";
  removeIdentity:
    | { __typename: "RemoveIdentityError"; case: RemoveIdentityErrorCase }
    | {
        __typename: "RemoveIdentitySuccess";
        removedProvider: IdentityProvider;
      };
};

export type LinkedIdentitiesResendVerificationEmailMutationVariables = Exact<{
  input: SendEmailToVerifyEmailInput;
}>;

export type LinkedIdentitiesResendVerificationEmailMutation = {
  __typename: "Mutation";
  sendEmailToVerifyEmail:
    | {
        __typename: "SendEmailToVerifyNewEmailError";
        case: SendEmailToVerifyNewEmailErrorCase;
      }
    | { __typename: "SendEmailToVerifyNewEmailSuccess"; _?: boolean | null };
};

export type LinkedIdentitiesSendPasswordResetEmailMutationVariables = Exact<{
  [key: string]: never;
}>;

export type LinkedIdentitiesSendPasswordResetEmailMutation = {
  __typename: "Mutation";
  sendPasswordResetEmail:
    | { __typename: "SendPasswordResetEmailError" }
    | { __typename: "SendPasswordResetEmailSuccess"; _?: boolean | null };
};

export type CoOwnerApplicationDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  code?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CoOwnerApplicationDetailQuery = {
  __typename: "Query";
  coOwnersApplication: {
    __typename: "CoOwnersApplication";
    status: CoOwnersApplicationStatus;
    units: number;
    ownerPlan: {
      __typename: "OwnerPlan";
      unitApplicationFee: number;
      unitPurchaseAmount: number;
    } & {
      " $fragmentRefs"?: {
        CoOwnersApplicationDetailsFragment: CoOwnersApplicationDetailsFragment;
      };
    };
    selectedWebinarSchedule?: {
      __typename: "CoOwnersWebinarSchedule";
      startsAt: ZonedDateTimeString;
      url: string;
    } | null;
    s2oPoint?: { __typename: "S2oPoint"; amount: number } | null;
  } & {
    " $fragmentRefs"?: {
      CoOwnersApplicationProgressAreaFragment: CoOwnersApplicationProgressAreaFragment;
      CoOwnersApplicationFilesAreaFragment: CoOwnersApplicationFilesAreaFragment;
    };
  };
};

export type CancelCoOwnersApplicationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type CancelCoOwnersApplicationMutation = {
  __typename: "Mutation";
  cancelCoOwnersApplication:
    | {
        __typename: "CancelCoOwnersApplicationError";
        case: CancelCoOwnersApplicationErrorCase;
      }
    | { __typename: "Success" };
};

export type CoOwnersApplicationFilesAreaFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  files: Array<{
    __typename: "CoOwnersApplicationFile";
    id: string;
    fileName: string;
    createdAt: DateTimeString;
  }>;
} & { " $fragmentName"?: "CoOwnersApplicationFilesAreaFragment" };

export type CoOwnersApplicationFilesAreaCreateUploadPolicyMutationVariables =
  Exact<{
    input: CreateCoOwnersApplicationFileUploadPolicyInput;
  }>;

export type CoOwnersApplicationFilesAreaCreateUploadPolicyMutation = {
  __typename: "Mutation";
  createCoOwnersApplicationFileUploadPolicy:
    | { __typename: "CreateFileUploadPolicyError" }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type CoOwnersApplicationFilesAreaRegisterMutationVariables = Exact<{
  input: RegisterCoOwnersApplicationFileInput;
}>;

export type CoOwnersApplicationFilesAreaRegisterMutation = {
  __typename: "Mutation";
  registerCoOwnersApplicationFile:
    | { __typename: "RegisterCoOwnersApplicationFileError" }
    | { __typename: "RegisterCoOwnersApplicationFileSuccess" };
};

export type CoOwnersApplicationFilesAreaCreateDownloadUrlMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
  }>;

export type CoOwnersApplicationFilesAreaCreateDownloadUrlMutation = {
  __typename: "Mutation";
  createCoOwnersApplicationFileDownloadUrl:
    | { __typename: "CreateCoOwnersApplicationFileDownloadUrlError" }
    | {
        __typename: "CreateCoOwnersApplicationFileDownloadUrlSuccess";
        url: string;
      };
};

export type CoOwnersApplicationFormDialogFragment = ({
  __typename: "CoOwnersApplication";
  id: string;
  webinarSchedules: Array<{
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
  }>;
  selectedWebinarSchedule?: {
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
  } | null;
} & {
  " $fragmentRefs"?: {
    CoOwnersOwnerInfoFormDefaultValuesFragment: CoOwnersOwnerInfoFormDefaultValuesFragment;
  };
}) & { " $fragmentName"?: "CoOwnersApplicationFormDialogFragment" };

export type CoOwnersApplicationProgressAreaFragment = ({
  __typename: "CoOwnersApplication";
  status: CoOwnersApplicationStatus;
  advancePaymentRequired: boolean;
  hasCoOwnersApplicationRequiredFieldsFilled: boolean;
  requestedOtherWebinarSchedule: boolean;
  webinarSchedules: Array<{
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
  }>;
  selectedWebinarSchedule?: {
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
    url: string;
  } | null;
} & {
  " $fragmentRefs"?: {
    CoOwnersApplicationFormDialogFragment: CoOwnersApplicationFormDialogFragment;
    CoOwnersApplicationWebinarSelectorFragment: CoOwnersApplicationWebinarSelectorFragment;
  };
}) & { " $fragmentName"?: "CoOwnersApplicationProgressAreaFragment" };

export type UpdateCoOwnersApplicationOwnerInfoMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationOwnerInfoInput;
}>;

export type UpdateCoOwnersApplicationOwnerInfoMutation = {
  __typename: "Mutation";
  updateCoOwnersApplicationOwnerInfo:
    | { __typename: "CoOwnersApplication"; id: string }
    | {
        __typename: "UpdateCoOwnersApplicationOwnerInfoError";
        case: UpdateCoOwnersApplicationOwnerInfoErrorCase;
      };
};

export type CoOwnersOwnerInfoFormDefaultValuesFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  desiredHandoverDate?: PlainYearMonthString | null;
  ownerPlan: {
    __typename: "OwnerPlan";
    handoverStartDate?: PlainYearMonthString | null;
  };
  applicantInfo: {
    __typename: "CoOwnersApplicantInfo";
    detail:
      | {
          __typename: "CoOwnersApplicantInfoDetailIndividual";
          useLoan: boolean;
        }
      | {
          __typename: "CoOwnersApplicantInfoDetailOrganization";
          organizationName: string;
          representativeName: string;
        };
  };
} & { " $fragmentName"?: "CoOwnersOwnerInfoFormDefaultValuesFragment" };

export type CoOwnersApplicationWebinarSelectorFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  webinarSchedules: Array<{
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
  }>;
  selectedWebinarSchedule?: {
    __typename: "CoOwnersWebinarSchedule";
    id: string;
    startsAt: ZonedDateTimeString;
  } | null;
} & { " $fragmentName"?: "CoOwnersApplicationWebinarSelectorFragment" };

export type SelectWebinarScheduleMutationVariables = Exact<{
  webinarScheduleId?: InputMaybe<Scalars["ID"]["input"]>;
  applicationId: Scalars["ID"]["input"];
}>;

export type SelectWebinarScheduleMutation = {
  __typename: "Mutation";
  selectWebinarSchedule:
    | { __typename: "CoOwnersApplication"; id: string }
    | {
        __typename: "SelectWebinarScheduleError";
        case: SelectWebinarScheduleErrorCase;
      };
};

export type GetViewerQueryVariables = Exact<{ [key: string]: never }>;

export type GetViewerQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    profile: {
      __typename: "UserProfile";
      address?:
        | {
            __typename: "AddressInJapan";
            line1: string;
            line2: string;
            postalCode: string;
          }
        | {
            __typename: "AddressInternational";
            city: string;
            stateProvince: string;
            postalCode: string;
            country: CountryEnum;
            lineOne: string;
            lineTwo?: string | null;
          }
        | null;
    };
  };
};

export type GetUserCompanionQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetUserCompanionQuery = {
  __typename: "Query";
  userCompanion: {
    __typename: "UserCompanion";
    id: string;
    name: string;
    phoneNumber?: string | null;
    professionType?: UserProfileProfessionType | null;
    gender: GenderType;
    birthDate: PlainDateString;
    nationality?: CountryEnum | null;
    passportNumber?: string | null;
    address:
      | {
          __typename: "AddressInJapan";
          line1: string;
          line2: string;
          postalCode: string;
        }
      | {
          __typename: "AddressInternational";
          city: string;
          stateProvince: string;
          postalCode: string;
          country: CountryEnum;
          lineOne: string;
          lineTwo?: string | null;
        };
    passportPhoto?: {
      __typename: "UploadedFile";
      rawUrl: string;
      url: string;
    } | null;
  };
};

export type CreateUserCompanionMutationVariables = Exact<{
  input: UserCompanionInput;
}>;

export type CreateUserCompanionMutation = {
  __typename: "Mutation";
  createUserCompanion: { __typename: "UserCompanion"; id: string };
};

export type UpdateUserCompanionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UserCompanionInput;
}>;

export type UpdateUserCompanionMutation = {
  __typename: "Mutation";
  updateUserCompanion: { __typename: "UserCompanion"; id: string };
};

export type DeleteUserCompanionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteUserCompanionMutation = {
  __typename: "Mutation";
  deleteUserCompanion: { __typename: "Success" };
};

export type UserCompanionsQueryVariables = Exact<{ [key: string]: never }>;

export type UserCompanionsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    companions?: Array<{
      __typename: "UserCompanion";
      id: string;
      name: string;
    }> | null;
  };
};

export type DeleteViewerMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteViewerMutation = {
  __typename: "Mutation";
  deleteViewer:
    | { __typename: "DeleteViewerError"; case: DeleteViewerErrorCase }
    | { __typename: "Success" };
};

export type GetInvoicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetInvoicesQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    bubbleId?: string | null;
    subscription: {
      __typename: "UserSubscription";
      billingCycleDay?: number | null;
    };
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: {
        __typename: "StripeCard";
        brand: string;
        last4: string;
        exp_month: number;
        exp_year: number;
      } | null;
      invoices: Array<{
        __typename: "StripeInvoice";
        id: string;
        total: number;
        description?: string | null;
        hosted_invoice_url?: string | null;
        createdAt: ZonedDateTimeString;
        subscription?: {
          __typename: "StripeInvoiceSubscription";
          id: string;
        } | null;
      }>;
    };
  };
};

export type PastStayRowFragmentFragment = {
  __typename: "AccommodationReservation";
  id: string;
  firstDate: PlainDateString;
  lastDate: PlainDateString;
  stayStatus: AccommodationReservationStayStatus;
  nights: number;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  accommodation: { __typename: "Accommodation"; name: string };
} & { " $fragmentName"?: "PastStayRowFragmentFragment" };

export type ViewerPastStayQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerPastStayQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    allAccommodationReservations: Array<
      {
        __typename: "AccommodationReservation";
        id: string;
        stayStatus: AccommodationReservationStayStatus;
        lastDate: PlainDateString;
      } & {
        " $fragmentRefs"?: {
          PastStayRowFragmentFragment: PastStayRowFragmentFragment;
        };
      }
    >;
  };
};

export type ViewerOwnershipQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewerOwnershipQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; name: string };
  userOwnership: {
    __typename: "UserOwnership";
    plan: { __typename: "OwnerPlan"; type: OwnerPlanType };
  } & {
    " $fragmentRefs"?: {
      CoOwnersPlanDetail_UserOwnershipFragment: CoOwnersPlanDetail_UserOwnershipFragment;
      FullOwnerPlanDetail_UserOwnershipFragment: FullOwnerPlanDetail_UserOwnershipFragment;
    };
  };
};

export type CoOwnersPlanDetail_UserOwnershipFragment = {
  __typename: "UserOwnership";
  units: number;
  nightsPerYear: number;
  maxPeakDaysPerYear?: number | null;
  maxSiteHighSeasonDaysPerYear?: number | null;
  holderName: string;
  plan: {
    __typename: "OwnerPlan";
    siteSizeSqm: number;
    leasedLandSizeSqm: number;
    guestRoomSizeSqm: number;
    balconySizeSqm: number;
    registrationFee: number;
    baseAccommodationFeePerNight: number;
    heldAccommodationClass?: AccommodationClass | null;
    unitPurchaseAmount: number;
    unitAnnualMaintenanceFee: number;
    unitAnnualRepairReserve: number;
    unitAnnualLandRentFee: number;
    formOfRights: string;
  } & { " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment } };
} & { " $fragmentName"?: "CoOwnersPlanDetail_UserOwnershipFragment" };

export type FullOwnerPlanDetail_UserOwnershipFragment = {
  __typename: "UserOwnership";
  plan: {
    __typename: "OwnerPlan";
    baseAccommodationFeePerNight: number;
    nonOwnedBaseAccommodationFeePerNight: number;
    heldAccommodationClass?: AccommodationClass | null;
  } & { " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment } };
} & { " $fragmentName"?: "FullOwnerPlanDetail_UserOwnershipFragment" };

export type ResolveBusinessMembershipQueryVariables = Exact<{
  invitationCode: Scalars["String"]["input"];
}>;

export type ResolveBusinessMembershipQuery = {
  __typename: "Query";
  organizationIdByInvitationCode?: string | null;
  maybeViewer?: {
    __typename: "User";
    organizationMembership?: {
      __typename: "OrganizationMembership";
      organization: { __typename: "Organization"; id: string };
    } | null;
  } | null;
};

export type CancelStandardSubscriptionApplicationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CancelStandardSubscriptionApplicationMutation = {
  __typename: "Mutation";
  cancelStandardSubscriptionApplication:
    | {
        __typename: "CancelStandardSubscriptionApplicationError";
        case: CancelStandardSubscriptionApplicationErrorCase;
        stripeRequestId?: string | null;
      }
    | { __typename: "Success" };
};

export type CancelStandardSubscriptionPauseMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CancelStandardSubscriptionPauseMutation = {
  __typename: "Mutation";
  cancelStandardSubscriptionPause:
    | {
        __typename: "CancelStandardSubscriptionPauseError";
        case: CancelStandardSubscriptionPauseErrorCase;
      }
    | { __typename: "Success" };
};

export type CancelStandardSubscriptionTerminationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CancelStandardSubscriptionTerminationMutation = {
  __typename: "Mutation";
  cancelStandardSubscriptionTermination:
    | {
        __typename: "CancelStandardSubscriptionTerminationError";
        case: CancelStandardSubscriptionTerminationErrorCase;
      }
    | { __typename: "Success" };
};

export type ResumeStandardSubscriptionImmediatelyMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ResumeStandardSubscriptionImmediatelyMutation = {
  __typename: "Mutation";
  resumeStandardSubscriptionImmediately:
    | {
        __typename: "ResumeStandardSubscriptionImmediatelyError";
        case: ResumeStandardSubscriptionImmediatelyErrorCase;
      }
    | { __typename: "Success" };
};

export type CancelTrialSubscriptionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CancelTrialSubscriptionMutation = {
  __typename: "Mutation";
  cancelTrialSubscription:
    | {
        __typename: "CancelTrialSubscriptionError";
        case: CancelTrialSubscriptionErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type GetSubscriptionStatusForPollingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSubscriptionStatusForPollingQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    subscription: {
      __typename: "UserSubscription";
      status: UserSubscriptionStatus;
      statusDetail: UserSubscriptionStatusDetail;
    };
  };
};

export type GetTrialContractStatusForPollingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTrialContractStatusForPollingQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    trialContract?: {
      __typename: "TrialContract";
      status: TrialContractStatus;
      statusDetail: TrialContractStatusDetail;
    } | null;
  };
};

export type GetViewerDataToEditQueryVariables = Exact<{ [key: string]: never }>;

export type GetViewerDataToEditQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    organizationMembership?:
      | ({ __typename: "OrganizationMembership" } & {
          " $fragmentRefs"?: {
            OrganizationMembershipOnPlanSectionFragmentFragment: OrganizationMembershipOnPlanSectionFragmentFragment;
          };
        })
      | null;
    subscription: { __typename: "UserSubscription" } & {
      " $fragmentRefs"?: {
        SubscriptionOnPlanSectionFragmentFragment: SubscriptionOnPlanSectionFragmentFragment;
      };
    };
    trialContract?:
      | ({ __typename: "TrialContract" } & {
          " $fragmentRefs"?: {
            TrialContractOnPlanSectionFragmentFragment: TrialContractOnPlanSectionFragmentFragment;
          };
        })
      | null;
    staffContract?:
      | ({ __typename: "StaffContract" } & {
          " $fragmentRefs"?: {
            StaffContractOnPlanSectionFragmentFragment: StaffContractOnPlanSectionFragmentFragment;
          };
        })
      | null;
    coOwnerships: Array<
      {
        __typename: "UserOwnership";
        id: string;
        coOwnersApplication?: {
          __typename: "CoOwnersApplication";
          id: string;
        } | null;
      } & {
        " $fragmentRefs"?: {
          CoOwnershipOnPlanSectionFragmentFragment: CoOwnershipOnPlanSectionFragmentFragment;
        };
      }
    >;
    fullOwnerships: Array<
      { __typename: "UserOwnership"; id: string } & {
        " $fragmentRefs"?: {
          FullOwnershipOnPlanSectionFragmentFragment: FullOwnershipOnPlanSectionFragmentFragment;
        };
      }
    >;
    coOwnersApplications: Array<
      {
        __typename: "CoOwnersApplication";
        id: string;
        status: CoOwnersApplicationStatus;
      } & {
        " $fragmentRefs"?: {
          CoOwnersApplicationSectionFragmentFragment: CoOwnersApplicationSectionFragmentFragment;
        };
      }
    >;
  };
};

export type TrialContractOnPlanSectionFragmentFragment = {
  __typename: "TrialContract";
  status: TrialContractStatus;
  enrolledDate: PlainDateString;
  endDate: PlainDateString;
  firstSemesterStayCredits: number;
  firstSemesterGrantedStayCredits: number;
  secondSemesterStayCredits: number;
  secondSemesterGrantedStayCredits: number;
  accumulatedS2oAmount: number;
} & { " $fragmentName"?: "TrialContractOnPlanSectionFragmentFragment" };

export type StaffContractOnPlanSectionFragmentFragment = {
  __typename: "StaffContract";
  status: StaffContractStatus;
  statusDetail: StaffContractStatusDetail;
  staffType: StaffType;
  enrolledDate: PlainDateString;
  terminatedDate?: PlainDateString | null;
  isReservable: boolean;
  currentSemesterStayCredits: number;
  currentSemesterGrantedStayCredits: number;
  remainingPeakDays: number;
  semesterCredits: Array<{
    __typename: "StaffSemesterCredit";
    semester: StaffSemester;
    year: number;
    remainingStayCredits: number;
    grantedStayCredits: number;
    remainingPeakDays: number;
  }>;
} & { " $fragmentName"?: "StaffContractOnPlanSectionFragmentFragment" };

export type CoOwnershipOnPlanSectionFragmentFragment = {
  __typename: "UserOwnership";
  id: string;
  nightsPerYear: number;
  plan: { __typename: "OwnerPlan" } & {
    " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
  };
  currentYearStatus: {
    __typename: "UserOwnershipProgramYearStatus";
    startDate: PlainDateString;
    endDate: PlainDateString;
    remainingNights: number;
  };
} & { " $fragmentName"?: "CoOwnershipOnPlanSectionFragmentFragment" };

export type CoOwnersApplicationSectionFragmentFragment = {
  __typename: "CoOwnersApplication";
  id: string;
  units: number;
  status: CoOwnersApplicationStatus;
  ownerPlan: { __typename: "OwnerPlan"; unitNightsPerYear: number } & {
    " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
  };
} & { " $fragmentName"?: "CoOwnersApplicationSectionFragmentFragment" };

export type FullOwnershipOnPlanSectionFragmentFragment = {
  __typename: "UserOwnership";
  id: string;
  nightsPerYear: number;
  usageStartDate: PlainDateString;
  usageEndDate: PlainDateString;
  nextPaymentDate: PlainDateString;
  plan: { __typename: "OwnerPlan" } & {
    " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
  };
  currentYearStatus: {
    __typename: "UserOwnershipProgramYearStatus";
    startDate: PlainDateString;
    endDate: PlainDateString;
    remainingNights: number;
  };
} & { " $fragmentName"?: "FullOwnershipOnPlanSectionFragmentFragment" };

export type SubscriptionOnPlanSectionFragmentFragment = {
  __typename: "UserSubscription";
  status: UserSubscriptionStatus;
  statusDetail: UserSubscriptionStatusDetail;
  enrollmentScheduledAt?: ZonedDateTimeString | null;
  enrolledAt?: ZonedDateTimeString | null;
  terminationScheduledAt?: ZonedDateTimeString | null;
  terminatedAt?: ZonedDateTimeString | null;
  pauseScheduledAt?: ZonedDateTimeString | null;
  pausedAt?: ZonedDateTimeString | null;
  resumeScheduledAt?: ZonedDateTimeString | null;
  resumedAt?: ZonedDateTimeString | null;
  pausableFrom?: PlainDateString | null;
  terminatableFrom?: PlainDateString | null;
  billingCycleDay?: number | null;
  accumulatedS2oAmount: number;
  reservationCycle?: {
    __typename: "UserSubscriptionReservationCycle";
    startDay: number;
    endDay?: number | null;
  } | null;
} & { " $fragmentName"?: "SubscriptionOnPlanSectionFragmentFragment" };

export type OrganizationMembershipOnPlanSectionFragmentFragment = {
  __typename: "OrganizationMembership";
  role: OrganizationRole;
  organization: { __typename: "Organization"; id: string; name: string };
  reservationNewStatus: {
    __typename: "OrganizationMemberNewReservationStatus";
    latestYearlyReservationStatuses: Array<{
      __typename: "OrganizationYearlyReservationStatus";
      endYearMonth: PlainYearMonthString;
    }>;
  };
} & {
  " $fragmentName"?: "OrganizationMembershipOnPlanSectionFragmentFragment";
};

export type LeaveOrganizationMembershipMutationVariables = Exact<{
  [key: string]: never;
}>;

export type LeaveOrganizationMembershipMutation = {
  __typename: "Mutation";
  leaveOrganizationByViewer:
    | {
        __typename: "LeaveOrganizationByViewerError";
        case: LeaveOrganizationErrorCase;
      }
    | { __typename: "Success" };
};

export type TopPageBannerContentsFragment = {
  __typename: "TopPage";
  bannerContents: Array<{
    __typename: "TopPageBannerContent";
    name: string;
    thumbnail: string;
    url: string;
  }>;
} & { " $fragmentName"?: "TopPageBannerContentsFragment" };

export type DrinkTicketCurrentStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DrinkTicketCurrentStatusQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    isEligibleMemberForDrinkTicketPerks: boolean;
    currentMonthUsedDrinkTicket?: {
      __typename: "MemberPerksNowhereDrinkTicket";
      used: boolean;
      usedAt?: ZonedDateTimeString | null;
    } | null;
  };
};

export type ActivateDrinkTicketMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ActivateDrinkTicketMutation = {
  __typename: "Mutation";
  activateMemberPerksDrinkTicket:
    | {
        __typename: "ActivateMemberPerksDrinkTicketError";
        case: ActivateMemberPerksDrinkTicketErrorCase;
      }
    | { __typename: "Success" };
};

export type HouseRulesDialogFragmentFragment = {
  __typename: "User";
  accommodationReservations: Array<{
    __typename: "AccommodationReservation";
    stayStatus: AccommodationReservationStayStatus;
    accommodation: {
      __typename: "Accommodation";
      site: { __typename: "Site"; slug: string };
    };
  }>;
  systemSettings: {
    __typename: "UserSystemSettings";
    hasSeenHouseRules: boolean;
  };
} & { " $fragmentName"?: "HouseRulesDialogFragmentFragment" };

export type UpdateViewerSettingsMutationVariables = Exact<{
  input: UserSystemSettingsInput;
}>;

export type UpdateViewerSettingsMutation = {
  __typename: "Mutation";
  partialUpdateViewerSystemSettings: {
    __typename: "User";
    systemSettings: {
      __typename: "UserSystemSettings";
      hasSeenHouseRules: boolean;
    };
  };
};

export type PreRegistrationResumeButtonQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PreRegistrationResumeButtonQueryQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    isFilledRequiredProfile: boolean;
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; last4: string } | null;
    };
  };
};

export type QueryForMyTentativeReservationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type QueryForMyTentativeReservationsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    unconfirmedAccommodationReservations: Array<{
      __typename: "AccommodationReservation";
      id: string;
      firstDate: PlainDateString;
      lastDate: PlainDateString;
      accommodation: {
        __typename: "Accommodation";
        site: { __typename: "Site"; name: string };
      };
    }>;
  };
};

export type TermsAgreementSection_UserFragment = {
  __typename: "User";
  requiredTermsAgreements: Array<
    {
      __typename: "TermsRevision";
      id: string;
      terms: { __typename: "Terms"; id: string; plan: TermsPlanType };
    } & {
      " $fragmentRefs"?: {
        TermsAgreementModal_TermsRevisionFragment: TermsAgreementModal_TermsRevisionFragment;
      };
    }
  >;
} & { " $fragmentName"?: "TermsAgreementSection_UserFragment" };

export type TopPageQueryVariables = Exact<{ [key: string]: never }>;

export type TopPageQuery = {
  __typename: "Query";
  topPage: {
    __typename: "TopPage";
    bannerContents: Array<{ __typename: "TopPageBannerContent" }>;
  } & {
    " $fragmentRefs"?: {
      TopPageBannerContentsFragment: TopPageBannerContentsFragment;
      TopPageUpdatesFragment: TopPageUpdatesFragment;
    };
  };
  viewer: {
    __typename: "User";
    organizationMembership?: {
      __typename: "OrganizationMembership";
      id: string;
    } | null;
  } & {
    " $fragmentRefs"?: {
      HouseRulesDialogFragmentFragment: HouseRulesDialogFragmentFragment;
      TermsAgreementSection_UserFragment: TermsAgreementSection_UserFragment;
    };
  };
};

export type TopPageUpdatesFragment = {
  __typename: "TopPage";
  serviceUpdate?: {
    __typename: "ServiceUpdate";
    title: string;
    url: string;
    publishedAt: ZonedDateTimeString;
    isNew: boolean;
  } | null;
  archiveArticle?: {
    __typename: "ArchiveArticle";
    title: string;
    url: string;
    publishedAt: ZonedDateTimeString;
    isNew: boolean;
  } | null;
  news?: {
    __typename: "News";
    id: string;
    title: string;
    publishedAt: ZonedDateTimeString;
    contentType: NewsContentType;
    content: string;
  } | null;
} & { " $fragmentName"?: "TopPageUpdatesFragment" };

export type NewsDetailQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type NewsDetailQuery = {
  __typename: "Query";
  newsDetail: {
    __typename: "News";
    title: string;
    publishedAt: ZonedDateTimeString;
    content: string;
  };
};

export type NewsQueryVariables = Exact<{ [key: string]: never }>;

export type NewsQuery = {
  __typename: "Query";
  news: Array<{
    __typename: "News";
    id: string;
    title: string;
    publishedAt: ZonedDateTimeString;
    contentType: NewsContentType;
    content: string;
  }>;
};

export type GetViewerForTrialRedirectQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetViewerForTrialRedirectQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
};

export type PermissionOnReservationFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PermissionOnReservationFormQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    isFilledRequiredProfile: boolean;
    hasReservablePlan: boolean;
    accessibleReservationCalendars: Array<AccessibleReservationCalendarType>;
    subscription: {
      __typename: "UserSubscription";
      suspended: boolean;
      enrolledAt?: ZonedDateTimeString | null;
      enrollmentScheduledAt?: ZonedDateTimeString | null;
    };
    trialContract?: { __typename: "TrialContract"; id: string } | null;
    staffContract?: { __typename: "StaffContract"; id: string } | null;
    coOwnerships: Array<{
      __typename: "UserOwnership";
      id: string;
      usageStartDate: PlainDateString;
    }>;
    fullOwnerships: Array<{
      __typename: "UserOwnership";
      id: string;
      usageStartDate: PlainDateString;
    }>;
    organization?: {
      __typename: "Organization";
      id: string;
      suspended: boolean;
    } | null;
  } & {
    " $fragmentRefs"?: {
      ReservationUnavailableMessageFragment: ReservationUnavailableMessageFragment;
      ReservationOwnershipSelectTabFragment: ReservationOwnershipSelectTabFragment;
      ReservationProviderSelectFragment: ReservationProviderSelectFragment;
      UserReservationCountForLogFragment: UserReservationCountForLogFragment;
    };
  };
};

export type OriginalReservationQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type OriginalReservationQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    provider:
      | {
          __typename: "BusinessPlanAccommodationReservationProvider";
          organizationId: string;
        }
      | {
          __typename: "CoOwnersPlanAccommodationReservationProvider";
          userOwnershipId: string;
        }
      | {
          __typename: "FullOwnerPlanAccommodationReservationProvider";
          userOwnershipId: string;
        }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | {
          __typename: "StaffPlanAccommodationReservationProvider";
          staffContractId: string;
        }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | {
          __typename: "TrialPlanAccommodationReservationProvider";
          trialContractId: string;
        };
  } & {
    " $fragmentRefs"?: {
      OriginalReservationOnReservationFormFragment: OriginalReservationOnReservationFormFragment;
    };
  };
};

export type ReservationUnavailableMessageFragment = {
  __typename: "User";
  hasUnpaidAccommodationFee: boolean;
  subscription: { __typename: "UserSubscription"; suspended: boolean };
  trialContract?: { __typename: "TrialContract"; suspended: boolean } | null;
  organization?: { __typename: "Organization"; suspended: boolean } | null;
  organizationMembership?: {
    __typename: "OrganizationMembership";
    reservationNewStatus: {
      __typename: "OrganizationMemberNewReservationStatus";
      suspended: boolean;
    };
  } | null;
} & { " $fragmentName"?: "ReservationUnavailableMessageFragment" };

export type ReservationOwnershipSelectTabFragment = {
  __typename: "User";
  coOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    plan: { __typename: "OwnerPlan" } & {
      " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
    };
  }>;
  fullOwnerships: Array<{
    __typename: "UserOwnership";
    id: string;
    plan: { __typename: "OwnerPlan" } & {
      " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
    };
  }>;
} & { " $fragmentName"?: "ReservationOwnershipSelectTabFragment" };

export type ReservationProviderSelectFragment = {
  __typename: "User";
  accessibleReservationCalendars: Array<AccessibleReservationCalendarType>;
  organization?: { __typename: "Organization"; id: string } | null;
} & { " $fragmentName"?: "ReservationProviderSelectFragment" };

export type TermsAgreementGuardQueryVariables = Exact<{
  provider: AccommodationReservationProviderInput;
}>;

export type TermsAgreementGuardQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    requiredTermsAgreements: Array<
      { __typename: "TermsRevision"; id: string } & {
        " $fragmentRefs"?: {
          TermsAgreementModal_TermsRevisionFragment: TermsAgreementModal_TermsRevisionFragment;
        };
      }
    >;
  };
};

export type ReservationPageQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ReservationPageQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    canCheckIn: boolean;
    isTentative: boolean;
  };
};

export type TentativeReservationForReservationStatusQueryVariables = Exact<{
  code: Scalars["ID"]["input"];
}>;

export type TentativeReservationForReservationStatusQuery = {
  __typename: "Query";
  tentativeAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | { __typename: "RedirectLocation"; path: string }
    | ({
        __typename: "TentativeAccommodationReservationError";
        case: TentativeAccommodationReservationErrorCase;
      } & {
        " $fragmentRefs"?: {
          TentativeAccommodationReservationErrorCaseFragment: TentativeAccommodationReservationErrorCaseFragment;
        };
      });
};

export type MaybeViewerForReservationStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MaybeViewerForReservationStatusQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    isFilledRequiredProfile: boolean;
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; last4: string } | null;
    };
  } | null;
};

export type ReservationDetailPageQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ReservationDetailPageQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    isFilledRequiredProfile: boolean;
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; last4: string } | null;
    };
  };
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    canCheckIn: boolean;
    earlyCheckInStatus: EarlyCheckInStatus;
    isTentative: boolean;
    userAcceptCode?: string | null;
    firstDate: PlainDateString;
    lastDate: PlainDateString;
    user?: { __typename: "User"; id: string } | null;
    accommodation: {
      __typename: "Accommodation";
      name: string;
      architectureType: { __typename: "ArchitectureType"; name: string };
    };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    fee: {
      __typename: "AccommodationFee";
      totalAmount: number;
      items: Array<{
        __typename: "AccommodationFeeItem";
        type: AccommodationFeeItemPerType;
        key: string;
        label: string;
        amount: number;
        taxRate: number;
      }>;
    };
    localTaxPolicies: Array<{ __typename: "LocalTaxPolicy"; id: string }>;
    stayTicketUnit?:
      | ({ __typename: "StayTicketUnit" } & {
          " $fragmentRefs"?: {
            StayTicketUnitForCancelFeePolicyFragmentFragment: StayTicketUnitForCancelFeePolicyFragmentFragment;
          };
        })
      | null;
  } & {
    " $fragmentRefs"?: {
      AccommodationReservationInfoFragment: AccommodationReservationInfoFragment;
    };
  };
};

export type AccommodationReservationCancelPageQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationCancelPageQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    canCancel: boolean;
  };
};

export type AccommodationReservationCompanionsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationCompanionsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    name: string;
    companions?: Array<{
      __typename: "UserCompanion";
      id: string;
      name: string;
    }> | null;
  };
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    userCompanions: Array<{
      __typename: "UserCompanion";
      id: string;
      name: string;
    }>;
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfTotalChildren: number;
    };
  };
};

export type AssignCompanionsMutationVariables = Exact<{
  accommodationReservationId: Scalars["ID"]["input"];
  userCompanionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AssignCompanionsMutation = {
  __typename: "Mutation";
  assignUserCompanions: Array<{
    __typename: "UserCompanion";
    id: string;
    name: string;
  }>;
};

export type OneMoreCabinAccommodationReservationCancelConfirmationFragment = ({
  __typename: "AccommodationReservation";
  id: string;
  firstDate: PlainDateString;
  lastDate: PlainDateString;
  accommodation: {
    __typename: "Accommodation";
    name: string;
    architectureType: { __typename: "ArchitectureType"; name: string };
  };
  detail: {
    __typename: "AccommodationReservationDetail";
    numberOfAdults: number;
    numberOfTotalChildren: number;
    previousLocation: string;
    nextLocation: string;
  };
} & {
  " $fragmentRefs"?: {
    AccommodationReservationInfoFragment: AccommodationReservationInfoFragment;
  };
}) & {
  " $fragmentName"?: "OneMoreCabinAccommodationReservationCancelConfirmationFragment";
};

export type CancelOneMoreCabinAccommodationReservationMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
  }>;

export type CancelOneMoreCabinAccommodationReservationMutation = {
  __typename: "Mutation";
  cancelAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "CancelAccommodationReservationError";
        case: CancelAccommodationReservationErrorCase;
      };
};

export type OneMoreCabinAccommodationReservationFragment = ({
  __typename: "AccommodationReservation";
  id: string;
  firstDate: PlainDateString;
  lastDate: PlainDateString;
  tentativeDeadline?: ZonedDateTimeString | null;
  isTentative: boolean;
  invitationUrl?: string | null;
  accommodation: {
    __typename: "Accommodation";
    name: string;
    architectureType: { __typename: "ArchitectureType"; name: string };
  };
  fee: {
    __typename: "AccommodationFee";
    items: Array<{
      __typename: "AccommodationFeeItem";
      type: AccommodationFeeItemPerType;
      key: string;
      label: string;
      amount: number;
      taxRate: number;
      night?: PlainDateString | null;
      createdAt?: DateTimeString | null;
    }>;
  };
} & {
  " $fragmentRefs"?: {
    OneMoreCabinAccommodationReservationCancelConfirmationFragment: OneMoreCabinAccommodationReservationCancelConfirmationFragment;
    AccommodationReservationInfoFragment: AccommodationReservationInfoFragment;
  };
}) & { " $fragmentName"?: "OneMoreCabinAccommodationReservationFragment" };

export type OneMoreCabinAccommodationReservationQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type OneMoreCabinAccommodationReservationQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    accommodation: { __typename: "Accommodation"; code: string };
    oneMoreCabinAccommodationReservation?:
      | ({ __typename: "AccommodationReservation"; id: string } & {
          " $fragmentRefs"?: {
            OneMoreCabinAccommodationReservationFragment: OneMoreCabinAccommodationReservationFragment;
            OriginalReservationOnReservationFormFragment: OriginalReservationOnReservationFormFragment;
          };
        })
      | null;
  };
  viewer: { __typename: "User" } & {
    " $fragmentRefs"?: {
      UserReservationCountForLogFragment: UserReservationCountForLogFragment;
    };
  };
};

export type CancellableStayGiftsForOwnerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CancellableStayGiftsForOwnerQuery = {
  __typename: "Query";
  cancellableStayGiftsForOwner: Array<{
    __typename: "StayTicket";
    id: string;
    code: string;
    expiresAt: ZonedDateTimeString;
    reservationInfo: { __typename: "StayTicketReservationInfo"; name: string };
  }>;
};

export type CancelStayGiftsMutationVariables = Exact<{
  ticketIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type CancelStayGiftsMutation = {
  __typename: "Mutation";
  cancelStayGifts:
    | { __typename: "CancelStayGiftsError"; case: CancelStayGiftsErrorCase }
    | {
        __typename: "CancelStayGiftsResult";
        cancelledTickets: Array<{ __typename: "StayTicket"; id: string }>;
      };
};

export type OwnershipForStayGiftFragmentFragment = {
  __typename: "UserOwnership";
  id: string;
  plan: {
    __typename: "OwnerPlan";
    type: OwnerPlanType;
    site: { __typename: "Site"; name: string };
    architectureType?: { __typename: "ArchitectureType"; name: string } | null;
    accommodation?: { __typename: "Accommodation"; name: string } | null;
  };
  currentYearStatus: {
    __typename: "UserOwnershipProgramYearStatus";
    year: number;
    remainingNights: number;
    endDate: PlainDateString;
  };
  nextYearStatus?: {
    __typename: "UserOwnershipProgramYearStatus";
    year: number;
    remainingNights: number;
    endDate: PlainDateString;
  } | null;
} & { " $fragmentName"?: "OwnershipForStayGiftFragmentFragment" };

export type ExportStayGiftsForOwnerQueryVariables = Exact<{
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ExportStayGiftsForOwnerQuery = {
  __typename: "Query";
  exportStayGiftsForOwner: {
    __typename: "ExportStayGiftsPayload";
    tickets: Array<{
      __typename: "StayGiftExportItem";
      code: string;
      invitationUrl: string;
      issuedAt: PlainDateString;
      validFrom: PlainDateString;
      validTo: PlainDateString;
      status: StayTicketStatusType;
    }>;
  };
};

export type AcquireStayTicketsMutationVariables = Exact<{
  input: AcquireStayTicketsInput;
}>;

export type AcquireStayTicketsMutation = {
  __typename: "Mutation";
  acquireStayTickets:
    | {
        __typename: "AcquireStayTicketsError";
        case: AcquireStayTicketsErrorCase;
      }
    | {
        __typename: "AcquireStayTicketsResult";
        tickets: Array<{ __typename: "StayTicket"; code: string }>;
      };
};

export type StayTicketTableFragmentFragment = {
  __typename: "StayTicket";
  id: string;
  status: StayTicketStatusType;
  code: string;
  expiresAt: ZonedDateTimeString;
  reservationInfo: { __typename: "StayTicketReservationInfo"; name: string };
} & { " $fragmentName"?: "StayTicketTableFragmentFragment" };

export type StayGiftTicketsQueryVariables = Exact<{ [key: string]: never }>;

export type StayGiftTicketsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    isGuest: boolean;
    email: string;
    isEligibleToPurchaseStayGift: boolean;
    stayTickets: Array<
      { __typename: "StayTicket"; status: StayTicketStatusType } & {
        " $fragmentRefs"?: {
          StayTicketTableFragmentFragment: StayTicketTableFragmentFragment;
        };
      }
    >;
    coOwnerships: Array<
      { __typename: "UserOwnership" } & {
        " $fragmentRefs"?: {
          OwnershipForStayGiftFragmentFragment: OwnershipForStayGiftFragmentFragment;
        };
      }
    >;
    fullOwnerships: Array<
      { __typename: "UserOwnership" } & {
        " $fragmentRefs"?: {
          OwnershipForStayGiftFragmentFragment: OwnershipForStayGiftFragmentFragment;
        };
      }
    >;
  };
};

export type AccommodationResrvationToGetProviderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationResrvationToGetProviderQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    acceptMarketingEmail?: boolean | null;
  };
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    nights: number;
    reservedFrom: ZonedDateTimeString;
    reservedTo: ZonedDateTimeString;
    standardCheckInTime: ZonedDateTimeString;
    firstDate: PlainDateString;
    lastDate: PlainDateString;
    isRoomTypeReservation: boolean;
    isTentative: boolean;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      name: string;
      code: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: {
        __typename: "Site";
        slug: string;
        name: string;
        isRemote: boolean;
        checkInAuthenticationType: CheckInAuthenticationType;
        area: { __typename: "Area"; slug: string };
      };
      architectureType: {
        __typename: "ArchitectureType";
        series: ArchitectureTypeSeries;
        name: string;
        size?: ArchitectureTypeSize | null;
        capacity: number;
        additionalFee: number;
      };
      roomType?: { __typename: "RoomType"; displayName: string } | null;
    };
    detail: {
      __typename: "AccommodationReservationDetail";
      bringDog: boolean;
      useEvCharger: boolean;
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      previousLocation: string;
      nextLocation: string;
      numberOfDogs: number;
    };
    fee: {
      __typename: "AccommodationFee";
      totalAmount: number;
      billingMethod: BillingMethod;
      items: Array<{
        __typename: "AccommodationFeeItem";
        type: AccommodationFeeItemPerType;
        key: string;
        label: string;
        amount: number;
        night?: PlainDateString | null;
      }>;
    };
    feeApplicability: {
      __typename: "AccommodationFeeApplicability";
      waiveArchitectureTypeAdditionalFee: boolean;
      waiveDogFee: boolean;
      waiveSaunaFee: boolean;
      waiveOnsenFee: boolean;
      waiveEvChargerFee: boolean;
      waiveDogRunFee: boolean;
    };
    localTaxPolicies: Array<{ __typename: "LocalTaxPolicy"; id: string }>;
    stayTicketUnit?:
      | ({
          __typename: "StayTicketUnit";
          stayTicketMasterId?: string | null;
          reservationInfo: {
            __typename: "StayTicketReservationInfo";
            type: StayTicketType;
            additionalGuestFeeStartsAt?: number | null;
            additionalGuestFeeAdultPricePerNight?: number | null;
            additionalGuestFeeKidsPricePerNight?: number | null;
          };
        } & {
          " $fragmentRefs"?: {
            StayTicketUnitForCancelFeePolicyFragmentFragment: StayTicketUnitForCancelFeePolicyFragmentFragment;
          };
        })
      | null;
    provider:
      | {
          __typename: "BusinessPlanAccommodationReservationProvider";
          organizationId: string;
        }
      | {
          __typename: "CoOwnersPlanAccommodationReservationProvider";
          userOwnershipId: string;
        }
      | {
          __typename: "FullOwnerPlanAccommodationReservationProvider";
          userOwnershipId: string;
        }
      | {
          __typename: "OneMoreCabinAccommodationReservationProvider";
          parentAccommodationReservationId: string;
        }
      | {
          __typename: "OnlineTravelAgentAccommodationReservationProvider";
          isIkyuDiamondMember: boolean;
        }
      | {
          __typename: "SanuIncAccommodationReservationProvider";
          usage: AccommodationReservationProviderSanuIncUsage;
        }
      | {
          __typename: "StaffPlanAccommodationReservationProvider";
          staffContractId: string;
        }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | {
          __typename: "StayTicketAccommodationReservationProvider";
          stayTicketUnitId: string;
        }
      | {
          __typename: "TrialPlanAccommodationReservationProvider";
          trialContractId: string;
        };
  } & {
    " $fragmentRefs"?: {
      OriginalAccommodationReservationOnDraftReservationFormFragment: OriginalAccommodationReservationOnDraftReservationFormFragment;
    };
  };
};

export type AccommodationForProviderOnConfirmPageQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  provider: AccommodationReservationProviderInput;
  night: Scalars["PlainDate"]["input"];
}>;

export type AccommodationForProviderOnConfirmPageQuery = {
  __typename: "Query";
  accommodation?: {
    __typename: "Accommodation";
    id: string;
    isOwned: boolean;
    accommodationClass?: AccommodationClass | null;
    classRelation?: AccommodationClassRelation | null;
  } | null;
};

export type UpdateAccommodationReservationOptionsOnConfirmPageMutationVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    input: UpdateAccommodationReservationOptionsInput;
  }>;

export type UpdateAccommodationReservationOptionsOnConfirmPageMutation = {
  __typename: "Mutation";
  updateAccommodationReservationOptions:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "UpdateAccommodationReservationOptionsError";
        case: UpdateAccommodationReservationOptionsErrorCase;
      };
};

export type ConfirmTentativeAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: ConfirmTentativeAccommodationReservationInput;
}>;

export type ConfirmTentativeAccommodationReservationMutation = {
  __typename: "Mutation";
  confirmTentativeAccommodationReservation:
    | { __typename: "AccommodationReservation" }
    | {
        __typename: "ConfirmTentativeAccommodationReservationError";
        case: ConfirmTentativeAccommodationReservationErrorCase;
      };
};

export type UpdateViewerMarketingEmailConsentMutationVariables = Exact<{
  accept: Scalars["Boolean"]["input"];
}>;

export type UpdateViewerMarketingEmailConsentMutation = {
  __typename: "Mutation";
  updateViewerMarketingEmailConsent: {
    __typename: "User";
    id: string;
    acceptMarketingEmail?: boolean | null;
  };
};

export type TentativeReservationForProfileEditQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TentativeReservationForProfileEditQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    isTentative: boolean;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
  };
};

export type AcceptTentativeReservationMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type AcceptTentativeReservationMutation = {
  __typename: "Mutation";
  acceptAccommodationReservation:
    | {
        __typename: "AcceptAccommodationReservationError";
        case: AcceptAccommodationReservationErrorCase;
      }
    | { __typename: "AccommodationReservation"; id: string };
};

export type AccommodationReservationForStayTicketQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationForStayTicketQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    mutationScope: AccommodationReservationMutationScope;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | {
          __typename: "StayTicketAccommodationReservationProvider";
          stayTicketUnitId: string;
        }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    stayTicketUnit?:
      | ({
          __typename: "StayTicketUnit";
          reservationInfo: {
            __typename: "StayTicketReservationInfo";
            cancelFeePolicy:
              | { __typename: "CancelFeeFixedPolicy"; immediate: boolean }
              | { __typename: "CancelFeeRatePolicy"; immediate: boolean };
          };
        } & {
          " $fragmentRefs"?: {
            StayTicketUnitForTicketReservationFormFragment: StayTicketUnitForTicketReservationFormFragment;
          };
        })
      | null;
  } & {
    " $fragmentRefs"?: {
      OriginalReservationOnReservationFormFragment: OriginalReservationOnReservationFormFragment;
    };
  };
};

export type TicketReservationConditionsFragment = {
  __typename: "StayTicketUnit";
  stayStartNight: PlainDateString;
  reservationInfo: {
    __typename: "StayTicketReservationInfo";
    type: StayTicketType;
    name: string;
    waiveCleaningFee: boolean;
    waiveConsumedSuppliesFee: boolean;
    waiveDogFee: boolean;
    waiveSaunaFee: boolean;
    waiveOnsenFee: boolean;
    waiveEvChargerFee: boolean;
  };
  stayTickets: Array<{
    __typename: "StayTicket";
    id: string;
    stayEndNight: PlainDateString;
  }>;
} & { " $fragmentName"?: "TicketReservationConditionsFragment" };

export type StayTicketValidationResultFragment = {
  __typename: "StayTicketValidationResult";
  stayTicketCode: string;
  validationError?: StayTicketValidationError | null;
} & { " $fragmentName"?: "StayTicketValidationResultFragment" };

export type StayTicketUnitForTicketReservationFormFragment = ({
  __typename: "StayTicketUnit";
  id: string;
  stayTicketMasterId?: string | null;
  stayStartNight: PlainDateString;
  stayEndNight: PlainDateString;
  reservationInfo: {
    __typename: "StayTicketReservationInfo";
    type: StayTicketType;
    name: string;
    notice?: string | null;
    additionalNoticeTypes: Array<AdditionalNoticeType>;
    additionalGuestFeeStartsAt?: number | null;
    availableSites: Array<{
      __typename: "Site";
      id: string;
      name: string;
      area: { __typename: "Area"; id: string };
    }>;
    availableArchitectureTypes: Array<{
      __typename: "ArchitectureType";
      id: string;
      name: string;
    }>;
  };
  stayTickets: Array<{
    __typename: "StayTicket";
    id: string;
    code: string;
    expiresAt: ZonedDateTimeString;
    stayStartNight: PlainDateString;
    stayEndNight: PlainDateString;
  }>;
} & {
  " $fragmentRefs"?: {
    TicketReservationConditionsFragment: TicketReservationConditionsFragment;
  };
}) & { " $fragmentName"?: "StayTicketUnitForTicketReservationFormFragment" };

export type ConfirmPageQueryVariables = Exact<{
  stayTicketUnitId: Scalars["ID"]["input"];
  roomTypeId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ConfirmPageQuery = {
  __typename: "Query";
  stayTicketReservationInfo?: {
    __typename: "StayTicketReservationInfo";
    additionalNoticeTypes: Array<AdditionalNoticeType>;
  } | null;
  roomType?: {
    __typename: "RoomType";
    id: string;
    availabilities: {
      __typename: "RoomTypeAvailabilities";
      nights: Array<{
        __typename: "RoomTypeAvailability";
        night: PlainDateString;
        availableAccommodations: Array<{
          __typename: "Accommodation";
          id: string;
          facilityTypes: Array<AccommodationFacilityType>;
        }>;
      }>;
    };
  } | null;
};

export type BundleStayTicketsMutationVariables = Exact<{
  codes: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type BundleStayTicketsMutation = {
  __typename: "Mutation";
  bundleStayTickets: {
    __typename: "BundleStayTicketsPayload";
    stayTicketsValidationResult: Array<
      { __typename: "StayTicketValidationResult" } & {
        " $fragmentRefs"?: {
          StayTicketValidationResultFragment: StayTicketValidationResultFragment;
        };
      }
    >;
    stayTicketUnit?:
      | ({ __typename: "StayTicketUnit" } & {
          " $fragmentRefs"?: {
            StayTicketUnitForTicketReservationFormFragment: StayTicketUnitForTicketReservationFormFragment;
          };
        })
      | null;
  };
};

export type GetUserCardInTrialSubscriptionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserCardInTrialSubscriptionQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: {
        __typename: "StripeCard";
        brand: string;
        last4: string;
        exp_month: number;
        exp_year: number;
      } | null;
    };
  } | null;
};

export type GetCardExistenceInTrialSubscriptionApplyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCardExistenceInTrialSubscriptionApplyQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; brand: string } | null;
    };
  };
};

export type GetTrialContractStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTrialContractStatusQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    trialContract?: {
      __typename: "TrialContract";
      status: TrialContractStatus;
    } | null;
  };
};

export type ApplyToTrialSubscriptionMutationVariables = Exact<{
  enrollmentMonth: Scalars["PlainYearMonth"]["input"];
}>;

export type ApplyToTrialSubscriptionMutation = {
  __typename: "Mutation";
  applyToTrialSubscription:
    | {
        __typename: "ApplyToTrialSubscriptionError";
        case: ApplyToTrialSubscriptionErrorCase;
      }
    | { __typename: "StripeRequireNextAction"; clientSecret: string }
    | { __typename: "Success"; _: boolean };
};

export type GetUserNameOnTrialSubscriptionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserNameOnTrialSubscriptionQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; name: string };
};

export type SetUserNameOnTrialSubscriptionMutationVariables = Exact<{
  name: Scalars["String"]["input"];
}>;

export type SetUserNameOnTrialSubscriptionMutation = {
  __typename: "Mutation";
  updateViewerName?: { __typename: "User"; id: string } | null;
};

export type EstimateStandardSubscriptionApplicationFeeByPromotionCodeQueryVariables =
  Exact<{
    promotionCode?: InputMaybe<Scalars["String"]["input"]>;
  }>;

export type EstimateStandardSubscriptionApplicationFeeByPromotionCodeQuery = {
  __typename: "Query";
  estimateStandardSubscriptionApplicationFee:
    | {
        __typename: "EstimateStandardSubscriptionApplicationError";
        case: EstimateStandardSubscriptionApplicationErrorCase;
      }
    | {
        __typename: "EstimateStandardSubscriptionApplicationSuccess";
        amount: number;
      };
};

export type GetCardExistenceInSubscriptionApplyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCardExistenceInSubscriptionApplyQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: {
        __typename: "StripeCard";
        brand: string;
        last4: string;
        exp_month: number;
        exp_year: number;
      } | null;
    };
  };
};

export type GetSubscriptionStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSubscriptionStatusQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    subscription: {
      __typename: "UserSubscription";
      status: UserSubscriptionStatus;
    };
  };
};

export type ApplyToStartWeekdaySubscriptionMutationVariables = Exact<{
  startFrom: Scalars["PlainDate"]["input"];
  promotionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ApplyToStartWeekdaySubscriptionMutation = {
  __typename: "Mutation";
  applyToWeekdaySubscription:
    | {
        __typename: "ApplyToWeekdaySubscriptionError";
        case: ApplyToWeekdaySubscriptionErrorCase;
      }
    | { __typename: "StripeRequireNextAction"; clientSecret: string }
    | { __typename: "Success" };
};

export type GetUserNameOnStandardSubscriptionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserNameOnStandardSubscriptionQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; name: string };
};

export type SetUserNameOnStandardSubscriptionMutationVariables = Exact<{
  name: Scalars["String"]["input"];
}>;

export type SetUserNameOnStandardSubscriptionMutation = {
  __typename: "Mutation";
  updateViewerName?: { __typename: "User"; id: string } | null;
};

export type GetTerminationDateQueryVariables = Exact<{ [key: string]: never }>;

export type GetTerminationDateQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    subscription: {
      __typename: "UserSubscription";
      statusDetail: UserSubscriptionStatusDetail;
      terminatableDate?: PlainDateString | null;
      terminatableFrom?: PlainDateString | null;
      terminationProhibitReason: UserSubscriptionTerminationProhibitReason;
    };
    s2o: { __typename: "S2o"; balance: number };
  };
};

export type GetStatusDetailQueryVariables = Exact<{ [key: string]: never }>;

export type GetStatusDetailQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    subscription: {
      __typename: "UserSubscription";
      statusDetail: UserSubscriptionStatusDetail;
      terminatableFrom?: PlainDateString | null;
    };
  };
};

export type ScheduleStandardSubscriptionTerminationMutationVariables = Exact<{
  questionnaire: UserSubscriptionTerminationQuestionnaireInput;
}>;

export type ScheduleStandardSubscriptionTerminationMutation = {
  __typename: "Mutation";
  scheduleStandardSubscriptionTermination:
    | {
        __typename: "ScheduleStandardSubscriptionTerminationError";
        case: ScheduleStandardSubscriptionTerminationErrorCase;
      }
    | { __typename: "Success" };
};

export type CancelStandardSubscriptionResumeMutationVariables = Exact<{
  questionnaire: UserSubscriptionTerminationQuestionnaireInput;
}>;

export type CancelStandardSubscriptionResumeMutation = {
  __typename: "Mutation";
  cancelStandardSubscriptionResume:
    | {
        __typename: "CancelStandardSubscriptionResumeError";
        case: CancelStandardSubscriptionResumeErrorCase;
      }
    | { __typename: "Success" };
};

export type AccommodationReservationForCheckOutQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationForCheckOutQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    canCheckOut: boolean;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    accommodation: {
      __typename: "Accommodation";
      id: string;
      architectureType: { __typename: "ArchitectureType"; name: string };
      site: { __typename: "Site"; id: string; name: string } & {
        " $fragmentRefs"?: {
          SiteContentFragmentFragment: SiteContentFragmentFragment;
        };
      };
    };
  };
};

export type CheckoutAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type CheckoutAccommodationReservationMutation = {
  __typename: "Mutation";
  checkOutAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "CheckOutAccommodationReservationError";
        case: CheckOutAccommodationReservationErrorCase;
      };
};

export type MemberPermissionCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MemberPermissionCheckQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; hasReservablePlan: boolean } | null;
};

export type HealthcheckQueryVariables = Exact<{ [key: string]: never }>;

export type HealthcheckQuery = {
  __typename: "Query";
  areas: Array<{ __typename: "Area"; id: string }>;
};

export type EarlyCheckInDashboardAreasQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EarlyCheckInDashboardAreasQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{
      __typename: "InternalSite";
      id: string;
      name: string;
      earlyCheckInEnabled: boolean;
    }>;
  }>;
};

export type EarlyCheckInDashboardReservationsQueryVariables = Exact<{
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  accommodationScope?: InputMaybe<AccommodationScope>;
}>;

export type EarlyCheckInDashboardReservationsQuery = {
  __typename: "Query";
  internalAccommodationReservationsBySearch: Array<{
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    hasCanceled: boolean;
    earlyCheckInEligible: boolean;
    checkedInAt?: ZonedDateTimeString | null;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      site: { __typename: "Site"; id: string; name: string };
    };
    detail: {
      __typename: "AccommodationReservationDetail";
      earlyCheckInFee?: number | null;
      earlyCheckInSlot?: {
        __typename: "EarlyCheckInPriceSlot";
        id: string;
        label: string;
        price: number;
      } | null;
    };
  }>;
};

export type EarlyCheckInDashboardViewerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EarlyCheckInDashboardViewerQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; id: string; email: string };
};

export type GetViewerNameAndEmailQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetViewerNameAndEmailQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; id: string; name: string; email: string };
};

export type AccommodationRowFragmentFragment = {
  __typename: "Accommodation";
  id: string;
  code: string;
  name: string;
  facilityTypes: Array<AccommodationFacilityType>;
  site: { __typename: "Site"; id: string; name: string };
  architectureType?: {
    __typename: "ArchitectureType";
    size?: ArchitectureTypeSize | null;
  };
} & { " $fragmentName"?: "AccommodationRowFragmentFragment" };

export type DeleteAccommodationAvailabilityBlockMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteAccommodationAvailabilityBlockMutation = {
  __typename: "Mutation";
  deleteAccommodationAvailabilityBlock?: boolean | null;
};

export type PartnerCalendarViewerDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PartnerCalendarViewerDataQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    id: string;
    email: string;
    staffContract?: {
      __typename: "StaffContract";
      status: StaffContractStatus;
    } | null;
    adminRoleAssignments: Array<{
      __typename: "AdminRoleAssignment";
      role: AdminRole;
      site?: { __typename: "Site"; id: string; name: string } | null;
    }>;
  } | null;
};

export type PartnerCalendarAreasDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PartnerCalendarAreasDataQuery = {
  __typename: "Query";
  internalAreas: Array<{
    __typename: "InternalArea";
    id: string;
    name: string;
    sites: Array<{ __typename: "InternalSite"; id: string; name: string }>;
  }>;
};

export type PartnerCalendarBaseDataQueryVariables = Exact<{
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
  withArchitecture: Scalars["Boolean"]["input"];
}>;

export type PartnerCalendarBaseDataQuery = {
  __typename: "Query";
  internalAccommodations: Array<
    {
      __typename: "Accommodation";
      id: string;
      site: { __typename: "Site"; id: string };
    } & {
      " $fragmentRefs"?: {
        AccommodationRowFragmentFragment: AccommodationRowFragmentFragment;
      };
    }
  >;
};

export type PartnerCalendarEventsDataQueryVariables = Exact<{
  startLastNight: Scalars["PlainDate"]["input"];
  endFirstNight: Scalars["PlainDate"]["input"];
  accommodationScope?: InputMaybe<AccommodationScope>;
}>;

export type PartnerCalendarEventsDataQuery = {
  __typename: "Query";
  internalAccommodationReservationsBySearch: Array<{
    __typename: "AccommodationReservation";
    id: string;
    firstDate: PlainDateString;
    lastDate: PlainDateString;
    stayStatus: AccommodationReservationStayStatus;
    earlyCheckInEligible: boolean;
    guestName?: string | null;
    accommodation: { __typename: "Accommodation"; id: string; name: string };
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      numberOfTotalChildren: number;
      internalStamp?: string | null;
      allowRoomChange: boolean;
    };
    otaDetail?: {
      __typename: "AccommodationReservationOtaDetail";
      arrivalTime?: string | null;
    } | null;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
  }>;
  accommodationAvailabilityBlocks: Array<{
    __typename: "AccommodationAvailabilityBlock";
    id: string;
    beginNight: PlainDateString;
    endNight: PlainDateString;
    name: string;
    isTentative: boolean;
    note: string;
    createdAt: ZonedDateTimeString;
    updatedAt: ZonedDateTimeString;
    site: { __typename: "Site"; id: string; name: string };
    accommodation?: {
      __typename: "Accommodation";
      id: string;
      name: string;
    } | null;
    createdByUser?: { __typename: "User"; name: string; email: string } | null;
    updatedByUser?: { __typename: "User"; name: string; email: string } | null;
  }>;
};

export type StaffGroupsForReservationFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaffGroupsForReservationFormQuery = {
  __typename: "Query";
  staffGroups: Array<{
    __typename: "StaffGroup";
    id: string;
    name: string;
    fullName?: string | null;
  }>;
};

export type PermissionOnInternalReservationFormQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type PermissionOnInternalReservationFormQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    name: string;
    accessibleReservationCalendars: Array<AccessibleReservationCalendarType>;
    isFilledRequiredProfile: boolean;
    coOwnerships: Array<{
      __typename: "UserOwnership";
      id: string;
      plan: {
        __typename: "OwnerPlan";
        site: { __typename: "Site"; name: string };
      };
    }>;
    fullOwnerships: Array<{
      __typename: "UserOwnership";
      id: string;
      plan: {
        __typename: "OwnerPlan";
        site: { __typename: "Site"; name: string };
      };
    }>;
    organization?: { __typename: "Organization"; id: string } | null;
    trialContract?: { __typename: "TrialContract"; id: string } | null;
  };
};

export type OriginalReservationOnInternalReservationFormQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type OriginalReservationOnInternalReservationFormQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      facilityTypes: Array<AccommodationFacilityType>;
    };
    user?: { __typename: "User"; id: string } | null;
    provider:
      | {
          __typename: "BusinessPlanAccommodationReservationProvider";
          organizationId: string;
        }
      | {
          __typename: "CoOwnersPlanAccommodationReservationProvider";
          userOwnershipId: string;
        }
      | {
          __typename: "FullOwnerPlanAccommodationReservationProvider";
          userOwnershipId: string;
        }
      | {
          __typename: "OneMoreCabinAccommodationReservationProvider";
          parentAccommodationReservationId: string;
        }
      | {
          __typename: "OnlineTravelAgentAccommodationReservationProvider";
          isIkyuDiamondMember: boolean;
        }
      | {
          __typename: "SanuIncAccommodationReservationProvider";
          usage: AccommodationReservationProviderSanuIncUsage;
          staffGroup?: {
            __typename: "StaffGroup";
            id: string;
            name: string;
            fullName?: string | null;
          } | null;
        }
      | {
          __typename: "StaffPlanAccommodationReservationProvider";
          staffContractId: string;
        }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | {
          __typename: "StayTicketAccommodationReservationProvider";
          stayTicketUnitId: string;
        }
      | {
          __typename: "TrialPlanAccommodationReservationProvider";
          trialContractId: string;
        };
  } & {
    " $fragmentRefs"?: {
      OriginalReservationOnReservationFormFragment: OriginalReservationOnReservationFormFragment;
      InternalOriginalReservationOnReservationFormFragment: InternalOriginalReservationOnReservationFormFragment;
    };
  };
};

export type OverlappingBlocksNotice_AccommodationAvailabilityBlockFragment = {
  __typename: "AccommodationAvailabilityBlock";
  id: string;
  name: string;
  beginNight: PlainDateString;
  endNight: PlainDateString;
  isTentative: boolean;
  accommodation?: { __typename: "Accommodation"; id: string } | null;
  categoryInfo: {
    __typename: "AccommodationAvailabilityBlockCategoryInfo";
    label: string;
  };
} & {
  " $fragmentName"?: "OverlappingBlocksNotice_AccommodationAvailabilityBlockFragment";
};

export type OverlappingAvailabilityBlocksForReservationNoticeQueryVariables =
  Exact<{
    siteId: Scalars["ID"]["input"];
    firstNight: Scalars["PlainDate"]["input"];
    lastNight: Scalars["PlainDate"]["input"];
  }>;

export type OverlappingAvailabilityBlocksForReservationNoticeQuery = {
  __typename: "Query";
  accommodationAvailabilityBlocks: Array<
    { __typename: "AccommodationAvailabilityBlock" } & {
      " $fragmentRefs"?: {
        OverlappingBlocksNotice_AccommodationAvailabilityBlockFragment: OverlappingBlocksNotice_AccommodationAvailabilityBlockFragment;
      };
    }
  >;
};

export type RoomTypeDemoQueryVariables = Exact<{
  areaIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
  provider: AccommodationReservationProviderInput;
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  facilitySlugs?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type RoomTypeDemoQuery = {
  __typename: "Query";
  areasForReservation: Array<{
    __typename: "Area";
    id: string;
    name: string;
    sitesForReservation: Array<{
      __typename: "Site";
      id: string;
      name: string;
      ordinalName?: string | null;
      roomTypesForReservation: Array<{
        __typename: "RoomType";
        id: string;
        displayName: string;
        features: Array<{
          __typename: "RoomTypeFeature";
          slug: string;
          displayName: string;
        }>;
        availabilities: {
          __typename: "RoomTypeAvailabilities";
          fromPrice?: number | null;
          nights: Array<{
            __typename: "RoomTypeAvailability";
            night: PlainDateString;
            isAvailable: boolean;
            availableCount: number;
            price: number;
            availableAccommodations: Array<{
              __typename: "Accommodation";
              id: string;
            }>;
          }>;
        };
      }>;
    }>;
  }>;
};

export type SubscriptionStatusForDevelopQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SubscriptionStatusForDevelopQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; brand: string } | null;
    };
    subscription: {
      __typename: "UserSubscription";
      status: UserSubscriptionStatus;
    };
  };
};

export type ApplySubscriptionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ApplySubscriptionMutation = {
  __typename: "Mutation";
  immediatelyApplyToStandardSubscriptionForDevelop: boolean;
};

export type CancelSubscriptionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CancelSubscriptionMutation = {
  __typename: "Mutation";
  immediatelyCancelStandardSubscriptionForDevelop: boolean;
};

export type ViewerOnReservationRulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ViewerOnReservationRulesQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    name: string;
    subscription: {
      __typename: "UserSubscription";
      billingCycleDay?: number | null;
      reservationCycle?: {
        __typename: "UserSubscriptionReservationCycle";
        startDay: number;
        endDay?: number | null;
      } | null;
      reservationCyclePeriods: Array<{
        __typename: "UserSubscriptionReservationCyclePeriod";
        start: PlainDateString;
        end: PlainDateString;
        stayedAndReservedNights: number;
        additionalNights: number;
      }>;
    };
    trialContract?: {
      __typename: "TrialContract";
      id: string;
      enrolledDate: PlainDateString;
      firstSemesterEndDate: PlainDateString;
      secondSemesterStartDate: PlainDateString;
      endDate: PlainDateString;
      firstSemesterStayCredits: number;
      firstSemesterRemainingPeakDays: number;
      secondSemesterStayCredits: number;
      secondSemesterRemainingPeakDays: number;
    } | null;
    coOwnerships: Array<
      { __typename: "UserOwnership"; id: string } & {
        " $fragmentRefs"?: {
          UserOwnershipOnReservationRulesFragment: UserOwnershipOnReservationRulesFragment;
        };
      }
    >;
    fullOwnerships: Array<
      { __typename: "UserOwnership"; id: string } & {
        " $fragmentRefs"?: {
          UserOwnershipOnReservationRulesFragment: UserOwnershipOnReservationRulesFragment;
        };
      }
    >;
  };
};

export type UserOwnershipOnReservationRulesFragment = {
  __typename: "UserOwnership";
  plan: { __typename: "OwnerPlan" } & {
    " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
  };
  currentYearStatus: { __typename: "UserOwnershipProgramYearStatus" } & {
    " $fragmentRefs"?: {
      ProgramYearStatusOnReservationRulesFragment: ProgramYearStatusOnReservationRulesFragment;
    };
  };
  nextYearStatus?:
    | ({ __typename: "UserOwnershipProgramYearStatus" } & {
        " $fragmentRefs"?: {
          ProgramYearStatusOnReservationRulesFragment: ProgramYearStatusOnReservationRulesFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "UserOwnershipOnReservationRulesFragment" };

export type ProgramYearStatusOnReservationRulesFragment = {
  __typename: "UserOwnershipProgramYearStatus";
  startDate: PlainDateString;
  endDate: PlainDateString;
  remainingNights: number;
  remainingPeakDays?: number | null;
  remainingSiteHighSeasonDays?: number | null;
} & { " $fragmentName"?: "ProgramYearStatusOnReservationRulesFragment" };

export type GetReservationsForCardsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetReservationsForCardsQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    accessibleReservationCalendars: Array<AccessibleReservationCalendarType>;
    trialContract?: { __typename: "TrialContract"; id: string } | null;
    coOwnerships: Array<{
      __typename: "UserOwnership";
      id: string;
      plan: { __typename: "OwnerPlan" } & {
        " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
      };
    }>;
    fullOwnerships: Array<{
      __typename: "UserOwnership";
      id: string;
      plan: { __typename: "OwnerPlan" } & {
        " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
      };
    }>;
    accommodationReservations: Array<
      {
        __typename: "AccommodationReservation";
        id: string;
        firstNight: PlainDateString;
        reservedFrom: ZonedDateTimeString;
        reservedTo: ZonedDateTimeString;
        nights: number;
        stayStatus: AccommodationReservationStayStatus;
        canCheckIn: boolean;
        canCheckOut: boolean;
        canCancel: boolean;
        mutationScope: AccommodationReservationMutationScope;
        earlyCheckInEligible: boolean;
        earlyCheckInStatus: EarlyCheckInStatus;
        standardCheckInTime: ZonedDateTimeString;
        isSaunaControlAccessible: boolean;
        hasSanuDevices: boolean;
        canReserveOneMoreCabin: boolean;
        provider:
          | { __typename: "BusinessPlanAccommodationReservationProvider" }
          | {
              __typename: "CoOwnersPlanAccommodationReservationProvider";
              userOwnershipId: string;
            }
          | {
              __typename: "FullOwnerPlanAccommodationReservationProvider";
              userOwnershipId: string;
            }
          | { __typename: "OneMoreCabinAccommodationReservationProvider" }
          | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
          | { __typename: "SanuIncAccommodationReservationProvider" }
          | { __typename: "StaffPlanAccommodationReservationProvider" }
          | { __typename: "StandardPlanAccommodationReservationProvider" }
          | { __typename: "StayDirectAccommodationReservationProvider" }
          | { __typename: "StayTicketAccommodationReservationProvider" }
          | { __typename: "TrialPlanAccommodationReservationProvider" };
        review?: { __typename: "StayReview"; comment?: string | null } | null;
        accommodation: {
          __typename: "Accommodation";
          name: string;
          code: string;
          architectureType: {
            __typename: "ArchitectureType";
            name: string;
            slug: string;
            series: ArchitectureTypeSeries;
          };
          content: {
            __typename: "AccommodationContent";
            manualUrl?: string | null;
          };
          site: {
            __typename: "Site";
            id: string;
            slug: string;
            name: string;
            checkInAuthenticationType: CheckInAuthenticationType;
            area: { __typename: "Area"; slug: string };
            content: {
              __typename: "SiteContent";
              googleMapsUrl?: string | null;
            };
          } & {
            " $fragmentRefs"?: {
              SiteContentFragmentFragment: SiteContentFragmentFragment;
              SiteTrafficInfoFragment: SiteTrafficInfoFragment;
              ActivityProgramCards_SiteFragment: ActivityProgramCards_SiteFragment;
            };
          };
        };
        detail: {
          __typename: "AccommodationReservationDetail";
          numberOfAdults: number;
          numberOfTotalChildren: number;
          numberOfDogs: number;
        };
        oneMoreCabinAccommodationReservation?: {
          __typename: "AccommodationReservation";
          id: string;
          tentativeDeadline?: ZonedDateTimeString | null;
          stayStatus: AccommodationReservationStayStatus;
        } | null;
        stayTicketUnit?: {
          __typename: "StayTicketUnit";
          reservationInfo: {
            __typename: "StayTicketReservationInfo";
            cancelFeePolicy:
              | { __typename: "CancelFeeFixedPolicy"; immediate: boolean }
              | { __typename: "CancelFeeRatePolicy"; immediate: boolean };
          };
        } | null;
      } & {
        " $fragmentRefs"?: {
          EarlyCheckInInfoModalFragment: EarlyCheckInInfoModalFragment;
          AccommodationFacilityListFragment: AccommodationFacilityListFragment;
          AccommodationNoticesForReservationFragment: AccommodationNoticesForReservationFragment;
        };
      }
    >;
  };
};

export type IssueTicketsMutationVariables = Exact<{
  input: IssueStayTicketsInput;
}>;

export type IssueTicketsMutation = {
  __typename: "Mutation";
  issueStayTickets:
    | { __typename: "IssueStayTicketsError"; case: IssueStayTicketsErrorCase }
    | {
        __typename: "IssueStayTicketsResult";
        tickets: Array<{ __typename: "StayTicket"; code: string }>;
      };
};

export type BundleStayTicketsForConfirmMutationVariables = Exact<{
  codes: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type BundleStayTicketsForConfirmMutation = {
  __typename: "Mutation";
  bundleStayTickets: {
    __typename: "BundleStayTicketsPayload";
    stayTicketUnit?: { __typename: "StayTicketUnit"; id: string } | null;
  };
};

export type BookingSimSitesQueryVariables = Exact<{ [key: string]: never }>;

export type BookingSimSitesQuery = {
  __typename: "Query";
  areasForReservation: Array<{
    __typename: "Area";
    id: string;
    name: string;
    sitesForReservation: Array<{
      __typename: "Site";
      id: string;
      slug: string;
      name: string;
      roomTypesForReservation: Array<{
        __typename: "RoomType";
        id: string;
        displayName: string;
      }>;
    }>;
  }>;
};

export type ReservationEstimateQueryVariables = Exact<{
  input: DraftAccommodationReservationInput;
}>;

export type ReservationEstimateQuery = {
  __typename: "Query";
  draftAccommodationReservation: {
    __typename: "DraftAccommodationReservation";
    fee: { __typename: "AccommodationFee"; totalAmount: number };
  };
};

export type AccommodationNoticesForReservationFragment = {
  __typename: "AccommodationReservation";
  accommodationNotices: Array<{
    __typename: "AccommodationNotice";
    brief: string;
    detail?: string | null;
    externalUrl?: string | null;
  }>;
} & { " $fragmentName"?: "AccommodationNoticesForReservationFragment" };

export type ImpersonatorAdminStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ImpersonatorAdminStatusQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; name: string };
};

export type GetLoginOnTopPageQueryVariables = Exact<{ [key: string]: never }>;

export type GetLoginOnTopPageQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
};

export type OwnerPlanNameFragment = {
  __typename: "OwnerPlan";
  type: OwnerPlanType;
  site: { __typename: "Site"; name: string };
  architectureType?: { __typename: "ArchitectureType"; name: string } | null;
  accommodation?: { __typename: "Accommodation"; name: string } | null;
} & { " $fragmentName"?: "OwnerPlanNameFragment" };

export type StayTicketUnitForCancelFeePolicyFragmentFragment = {
  __typename: "StayTicketUnit";
  reservationInfo: {
    __typename: "StayTicketReservationInfo";
    type: StayTicketType;
    ownerPlanType?: OwnerPlanType | null;
    cancelFeePolicy:
      | {
          __typename: "CancelFeeFixedPolicy";
          immediate: boolean;
          before1DaysFee: number;
          before3DaysFee: number;
          before7DaysFee: number;
        }
      | {
          __typename: "CancelFeeRatePolicy";
          immediate: boolean;
          before1DaysRate: number;
          before3DaysRate: number;
          before7DaysRate: number;
        };
  };
} & { " $fragmentName"?: "StayTicketUnitForCancelFeePolicyFragmentFragment" };

export type AccommodationReservationForChangeQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type AccommodationReservationForChangeQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    reservedFrom: ZonedDateTimeString;
    reservedTo: ZonedDateTimeString;
    accommodation: { __typename: "Accommodation"; id: string; name: string };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      numberOfTotalChildren: number;
      previousLocation: string;
      nextLocation: string;
      bringDog: boolean;
      numberOfDogs: number;
      useEvCharger: boolean;
      allowRoomChange: boolean;
      internalStamp?: string | null;
    };
    stayTicketUnit?:
      | ({
          __typename: "StayTicketUnit";
          stayTicketMasterId?: string | null;
        } & {
          " $fragmentRefs"?: {
            StayTicketUnitForCancelFeePolicyFragmentFragment: StayTicketUnitForCancelFeePolicyFragmentFragment;
          };
        })
      | null;
  } & {
    " $fragmentRefs"?: {
      ReservationSummaryFragment: ReservationSummaryFragment;
      AccommodationReservationInfoFragment: AccommodationReservationInfoFragment;
    };
  };
};

export type AccommodationReservationChangeFeeQueryVariables = Exact<{
  fromAccommodationReservationId: Scalars["ID"]["input"];
  to: EstimatedChangeFeeOfAccommodationReservationInput;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AccommodationReservationChangeFeeQuery = {
  __typename: "Query";
  estimatedChangeFeeOfAccommodationReservation:
    | { __typename: "EstimatedChangeFeeOfAccommodationReservationError" }
    | ({
        __typename: "EstimatedChargeOfAccommodationReservation";
        items: Array<{
          __typename: "EstimatedChargeOfAccommodationReservationItem";
        }>;
      } & {
        " $fragmentRefs"?: {
          ChangeOrCancelEstimatedChargeFragmentFragment: ChangeOrCancelEstimatedChargeFragmentFragment;
        };
      });
};

export type ChangeAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UpdateAccommodationReservationInput;
}>;

export type ChangeAccommodationReservationMutation = {
  __typename: "Mutation";
  changeAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "ChangeAccommodationReservationError";
        case: ChangeAccommodationReservationErrorCase;
        internalCode?: string | null;
      };
};

export type InternalChangeAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationReservationInput;
}>;

export type InternalChangeAccommodationReservationMutation = {
  __typename: "Mutation";
  internalChangeAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "ChangeAccommodationReservationError";
        case: ChangeAccommodationReservationErrorCase;
        internalCode?: string | null;
      };
};

export type OriginalAccommodationReservationOnDraftReservationFragment = ({
  __typename: "AccommodationReservation";
  id: string;
  detail: {
    __typename: "AccommodationReservationDetail";
    useEvCharger: boolean;
    bringDog: boolean;
    numberOfDogs: number;
  };
} & {
  " $fragmentRefs"?: {
    OriginalAccommodationReservationOnDraftReservationFormFragment: OriginalAccommodationReservationOnDraftReservationFormFragment;
  };
}) & {
  " $fragmentName"?: "OriginalAccommodationReservationOnDraftReservationFragment";
};

export type InternalDraftAccommodationReservationQueryVariables = Exact<{
  input: DraftAccommodationReservationInput;
  waiveCleaningFee: Scalars["Boolean"]["input"];
}>;

export type InternalDraftAccommodationReservationQuery = {
  __typename: "Query";
  internalDraftAccommodationReservation: {
    __typename: "DraftAccommodationReservation";
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    nights: number;
    reservedFrom: ZonedDateTimeString;
    reservedTo: ZonedDateTimeString;
    standardCheckInTime: ZonedDateTimeString;
    firstDate: PlainDateString;
    lastDate: PlainDateString;
    additionalNights: number;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      name: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: { __typename: "Site"; id: string; name: string; slug: string };
      architectureType: {
        __typename: "ArchitectureType";
        series: ArchitectureTypeSeries;
        name: string;
        capacity: number;
        additionalFee: number;
      };
    };
    options: {
      __typename: "AccommodationReservationOptions";
      bringDog: boolean;
      numberOfDogs: number;
      useEvCharger: boolean;
    };
    fee: {
      __typename: "AccommodationFee";
      totalAmount: number;
      billingMethod: BillingMethod;
      billingMethodManualDetail?: string | null;
      items: Array<{
        __typename: "AccommodationFeeItem";
        type: AccommodationFeeItemPerType;
        label: string;
        key: string;
        amount: number;
        night?: PlainDateString | null;
      }>;
    };
    stayTicketUnit?: {
      __typename: "StayTicketUnit";
      reservationInfo: {
        __typename: "StayTicketReservationInfo";
        additionalGuestFeeStartsAt?: number | null;
      };
    } | null;
  };
};

export type InternalCreateAccommodationReservationMutationVariables = Exact<{
  input: InternalCreateAccommodationReservationInput;
}>;

export type InternalCreateAccommodationReservationMutation = {
  __typename: "Mutation";
  internalCreateAccommodationReservation:
    | {
        __typename: "AccommodationReservation";
        id: string;
        invitationUrl?: string | null;
        tentativeDeadline?: ZonedDateTimeString | null;
      }
    | {
        __typename: "CreateAccommodationReservationError";
        case: CreateAccommodationReservationErrorCase;
        internalCode?: string | null;
      };
};

export type InternalOriginalAccommodationReservationOnDraftReservationFragment =
  {
    __typename: "AccommodationReservation";
    id: string;
    mutationScope: AccommodationReservationMutationScope;
    isTentative: boolean;
    detail: {
      __typename: "AccommodationReservationDetail";
      useEvCharger: boolean;
      bringDog: boolean;
      numberOfDogs: number;
      numberOfAdults: number;
      numberOfKids: number;
      numberOfInfants: number;
      previousLocation: string;
      nextLocation: string;
      internalStamp?: string | null;
      allowRoomChange: boolean;
    };
    fee: {
      __typename: "AccommodationFee";
      billingMethod: BillingMethod;
      billingMethodManualDetail?: string | null;
      items: Array<{
        __typename: "AccommodationFeeItem";
        type: AccommodationFeeItemPerType;
        label: string;
        amount: number;
        night?: PlainDateString | null;
        key: string;
      }>;
    };
    accommodation: {
      __typename: "Accommodation";
      id: string;
      architectureType: { __typename: "ArchitectureType"; capacity: number };
    };
  } & {
    " $fragmentName"?: "InternalOriginalAccommodationReservationOnDraftReservationFragment";
  };

export type InternalOriginalReservationOnReservationFormFragment = ({
  __typename: "AccommodationReservation";
  firstNight: PlainDateString;
  lastNight: PlainDateString;
  mutationScope: AccommodationReservationMutationScope;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    facilityTypes: Array<AccommodationFacilityType>;
  };
} & {
  " $fragmentRefs"?: {
    OriginalAccommodationReservationOnReservationCalendarFragment: OriginalAccommodationReservationOnReservationCalendarFragment;
    InternalOriginalAccommodationReservationOnDraftReservationFragment: InternalOriginalAccommodationReservationOnDraftReservationFragment;
  };
}) & {
  " $fragmentName"?: "InternalOriginalReservationOnReservationFormFragment";
};

export type AreasOnReservationFormQueryVariables = Exact<{
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  minNight: Scalars["PlainDate"]["input"];
  maxNight: Scalars["PlainDate"]["input"];
  provider?: InputMaybe<AccommodationReservationProviderInput>;
  occupancyLimitTarget?: InputMaybe<OccupancyLimitTargetType>;
  areaId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  withDeferred: Scalars["Boolean"]["input"];
  internal: Scalars["Boolean"]["input"];
}>;

export type AreasOnReservationFormQuery = {
  __typename: "Query";
  peakDays: Array<PlainDateString>;
  areasForReservation: Array<
    {
      __typename: "Area";
      id: string;
      slug: string;
      name: string;
      sitesForReservation: Array<
        {
          __typename: "Site";
          id: string;
          accommodationsForReservation: Array<
            {
              __typename: "Accommodation";
              id: string;
              facilityTypes: Array<AccommodationFacilityType>;
              isOwned: boolean;
              architectureType: {
                __typename: "ArchitectureType";
                id: string;
                name: string;
                series: ArchitectureTypeSeries;
                seriesShortName: string;
                size?: ArchitectureTypeSize | null;
              };
              availabilities?: Array<{
                __typename: "AccommodationAvailability";
                date: PlainDateString;
                isAvailable: boolean;
              }>;
            } & {
              " $fragmentRefs"?: {
                AccommodationsGroupOnCalendarFragment: AccommodationsGroupOnCalendarFragment;
                AccommodationForSiteHeaderFragment: AccommodationForSiteHeaderFragment;
              };
            }
          >;
          facilities: Array<
            { __typename: "Facility" } & {
              " $fragmentRefs"?: {
                FacilityForSiteHeaderFragment: FacilityForSiteHeaderFragment;
              };
            }
          >;
        } & {
          " $fragmentRefs"?: { SiteForHeaderFragment: SiteForHeaderFragment };
        }
      >;
    } & {
      " $fragmentRefs"?: {
        AreaHeaderFragmentFragment: AreaHeaderFragmentFragment;
      };
    }
  >;
  maybeViewer?: {
    __typename: "User";
    name: string;
    subscription: {
      __typename: "UserSubscription";
      reservationCyclePeriods: Array<{
        __typename: "UserSubscriptionReservationCyclePeriod";
        start: PlainDateString;
        end: PlainDateString;
        stayedAndReservedNights: number;
        remainingBaseNights: number;
        hasActiveReservation: boolean;
      }>;
      next7DaysReservationPeriod?: {
        __typename: "UserSubscriptionNext7DaysReservationPeriod";
        start: PlainDateString;
        end: PlainDateString;
      } | null;
    };
    organizationMembership?: {
      __typename: "OrganizationMembership";
      role: OrganizationRole;
    } | null;
  } | null;
};

export type AccommodationOnHeaderCellFragment = {
  __typename: "Accommodation";
  code: string;
  facilityTypes: Array<AccommodationFacilityType>;
  operationType?: AccommodationOperationType | null;
  architectureType: {
    __typename: "ArchitectureType";
    size?: ArchitectureTypeSize | null;
  };
} & { " $fragmentName"?: "AccommodationOnHeaderCellFragment" };

export type AccommodationsGroupOnCalendarFragment = ({
  __typename: "Accommodation";
  id: string;
  name: string;
  isOwned: boolean;
  roomType?: { __typename: "RoomType"; slug?: string | null } | null;
  site: {
    __typename: "Site";
    slug: string;
    area: { __typename: "Area"; slug: string };
  };
} & {
  " $fragmentRefs"?: {
    AccommodationsOnCalendarFragment: AccommodationsOnCalendarFragment;
  };
}) & { " $fragmentName"?: "AccommodationsGroupOnCalendarFragment" };

export type AccommodationsOnCalendarFragment = ({
  __typename: "Accommodation";
  id: string;
  name: string;
  availabilities?: Array<
    {
      __typename: "AccommodationAvailability";
      date: PlainDateString;
      isAvailable: boolean;
    } & {
      " $fragmentRefs"?: {
        AvailabilityOnAvailabilityCellFragment: AvailabilityOnAvailabilityCellFragment;
      };
    }
  >;
} & {
  " $fragmentRefs"?: {
    AccommodationOnHeaderCellFragment: AccommodationOnHeaderCellFragment;
    AccommodationOnAvailabilityCellFragment: AccommodationOnAvailabilityCellFragment;
  };
}) & { " $fragmentName"?: "AccommodationsOnCalendarFragment" };

export type AreaHeaderFragmentFragment = {
  __typename: "Area";
  id: string;
  slug: string;
  name: string;
  content: {
    __typename: "AreaContent";
    allCapsName?: string | null;
    reservationFormCoverImageUrl?: string | null;
  };
} & { " $fragmentName"?: "AreaHeaderFragmentFragment" };

export type AccommodationOnAvailabilityCellFragment = {
  __typename: "Accommodation";
  id: string;
  name: string;
  facilityTypes: Array<AccommodationFacilityType>;
  notices: Array<{
    __typename: "AccommodationNotice";
    brief: string;
    detail?: string | null;
    externalUrl?: string | null;
    startDate: PlainDateString;
    endDate: PlainDateString;
  }>;
} & { " $fragmentName"?: "AccommodationOnAvailabilityCellFragment" };

export type AvailabilityOnAvailabilityCellFragment = {
  __typename: "AccommodationAvailability";
  date: PlainDateString;
  isAvailable: boolean;
  guaranteedPrice?: number | null;
  block?: {
    __typename: "AccommodationAvailabilityBlock";
    id: string;
    name: string;
    category: AccommodationAvailabilityBlockCategory;
    isTentative: boolean;
    note: string;
    createdAt: ZonedDateTimeString;
    updatedAt: ZonedDateTimeString;
    categoryInfo: {
      __typename: "AccommodationAvailabilityBlockCategoryInfo";
      key: AccommodationAvailabilityBlockCategory;
      label: string;
      note: string;
      categoryGroup: string;
    };
    createdByUser?: { __typename: "User"; name: string; email: string } | null;
    updatedByUser?: { __typename: "User"; name: string; email: string } | null;
  } | null;
} & { " $fragmentName"?: "AvailabilityOnAvailabilityCellFragment" };

export type OriginalAccommodationReservationOnAvailabilityCellFragment = {
  __typename: "AccommodationReservation";
  id: string;
  firstNight: PlainDateString;
  lastNight: PlainDateString;
  mutationScope: AccommodationReservationMutationScope;
  accommodation: { __typename: "Accommodation"; id: string };
} & {
  " $fragmentName"?: "OriginalAccommodationReservationOnAvailabilityCellFragment";
};

export type SiteForHeaderFragment = {
  __typename: "Site";
  id: string;
  name: string;
  ordinalName?: string | null;
  slug: string;
  area: { __typename: "Area"; slug: string };
} & { " $fragmentName"?: "SiteForHeaderFragment" };

export type AccommodationForSiteHeaderFragment = {
  __typename: "Accommodation";
  architectureType: {
    __typename: "ArchitectureType";
    seriesShortName: string;
    size?: ArchitectureTypeSize | null;
    slug: string;
  };
} & { " $fragmentName"?: "AccommodationForSiteHeaderFragment" };

export type FacilityForSiteHeaderFragment = ({
  __typename: "Facility";
  id: string;
} & {
  " $fragmentRefs"?: {
    FacilityDetailModalFragmentFragment: FacilityDetailModalFragmentFragment;
  };
}) & { " $fragmentName"?: "FacilityForSiteHeaderFragment" };

export type AccommodationDayPricesOnCheckoutDatePickerDrawerQueryVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
    lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
    provider?: InputMaybe<AccommodationReservationProviderInput>;
  }>;

export type AccommodationDayPricesOnCheckoutDatePickerDrawerQuery = {
  __typename: "Query";
  accommodation?: {
    __typename: "Accommodation";
    id: string;
    availabilities: Array<{
      __typename: "AccommodationAvailability";
      date: PlainDateString;
      isAvailable: boolean;
      guaranteedPrice?: number | null;
    }>;
  } | null;
};

export type CheckOutAvailabilitiesOnCheckoutDatePickerDrawerQueryVariables =
  Exact<{
    input: AccommodationReservationCheckOutAvailabilitiesInput;
  }>;

export type CheckOutAvailabilitiesOnCheckoutDatePickerDrawerQuery = {
  __typename: "Query";
  accommodationReservationCheckOutAvailabilities: {
    __typename: "AccommodationReservationCheckOutAvailabilitiesPayload";
    items: Array<{
      __typename: "AccommodationReservationCheckOutItem";
      date: PlainDateString;
      available: boolean;
    }>;
  };
};

export type StayTicketFeeDiscountsOnCheckoutDatePickerDrawerQueryVariables =
  Exact<{
    stayTicketUnitId: Scalars["ID"]["input"];
  }>;

export type StayTicketFeeDiscountsOnCheckoutDatePickerDrawerQuery = {
  __typename: "Query";
  stayTicketReservationInfo?: {
    __typename: "StayTicketReservationInfo";
    discounts: Array<{
      __typename: "AccommodationFeeDiscount";
      ruleType: AccommodationFeeRuleType;
      night: number;
      feeModifier: number;
      feeModifierType: FeeModifierType;
    }>;
  } | null;
};

export type OriginalAccommodationReservationOnReservationCalendarFragment = ({
  __typename: "AccommodationReservation";
  id: string;
  firstNight: PlainDateString;
  lastNight: PlainDateString;
  mutationScope: AccommodationReservationMutationScope;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    site: {
      __typename: "Site";
      id: string;
      area: { __typename: "Area"; id: string };
    };
  };
} & {
  " $fragmentRefs"?: {
    OriginalAccommodationReservationOnAvailabilityCellFragment: OriginalAccommodationReservationOnAvailabilityCellFragment;
  };
}) & {
  " $fragmentName"?: "OriginalAccommodationReservationOnReservationCalendarFragment";
};

export type AccommodationReservationCheckOutAvailabilitiesQueryVariables =
  Exact<{
    input: AccommodationReservationCheckOutAvailabilitiesInput;
    internal: Scalars["Boolean"]["input"];
  }>;

export type AccommodationReservationCheckOutAvailabilitiesQuery = {
  __typename: "Query";
  accommodationReservationCheckOutAvailabilities: {
    __typename: "AccommodationReservationCheckOutAvailabilitiesPayload";
    items: Array<{
      __typename: "AccommodationReservationCheckOutItem";
      date: PlainDateString;
      available: boolean;
      additionalNightsFee: number;
      discounts: Array<{
        __typename: "AccommodationFeeDiscount";
        ruleType: AccommodationFeeRuleType;
        feeModifier: number;
        feeModifierType: FeeModifierType;
      }>;
      block?: {
        __typename: "AccommodationAvailabilityBlock";
        id: string;
        name: string;
        category: AccommodationAvailabilityBlockCategory;
        isTentative: boolean;
        note: string;
        createdAt: ZonedDateTimeString;
        updatedAt: ZonedDateTimeString;
        categoryInfo: {
          __typename: "AccommodationAvailabilityBlockCategoryInfo";
          key: AccommodationAvailabilityBlockCategory;
          label: string;
          categoryGroup: string;
          note: string;
        };
        createdByUser?: {
          __typename: "User";
          name: string;
          email: string;
        } | null;
        updatedByUser?: {
          __typename: "User";
          name: string;
          email: string;
        } | null;
      } | null;
    }>;
  };
};

export type OriginalReservationOnReservationFormFragment = ({
  __typename: "AccommodationReservation";
  firstNight: PlainDateString;
  lastNight: PlainDateString;
  mutationScope: AccommodationReservationMutationScope;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    facilityTypes: Array<AccommodationFacilityType>;
  };
} & {
  " $fragmentRefs"?: {
    OriginalAccommodationReservationOnReservationCalendarFragment: OriginalAccommodationReservationOnReservationCalendarFragment;
    OriginalAccommodationReservationOnDraftReservationFragment: OriginalAccommodationReservationOnDraftReservationFragment;
  };
}) & { " $fragmentName"?: "OriginalReservationOnReservationFormFragment" };

export type UserReservationCountForLogFragment = {
  __typename: "User";
  stayedReservationCount: number;
} & { " $fragmentName"?: "UserReservationCountForLogFragment" };

export type ReservationFormOwnershipSelectorFragmentFragment = {
  __typename: "UserOwnership";
  id: string;
  plan: { __typename: "OwnerPlan" } & {
    " $fragmentRefs"?: { OwnerPlanNameFragment: OwnerPlanNameFragment };
  };
} & { " $fragmentName"?: "ReservationFormOwnershipSelectorFragmentFragment" };

export type DraftAccommodationReservationQueryVariables = Exact<{
  input: DraftAccommodationReservationInput;
  provider: AccommodationReservationProviderInput;
  lastNight: Scalars["PlainDate"]["input"];
}>;

export type DraftAccommodationReservationQuery = {
  __typename: "Query";
  draftAccommodationReservation: {
    __typename: "DraftAccommodationReservation";
    firstNight: PlainDateString;
    lastNight: PlainDateString;
    nights: number;
    reservedFrom: ZonedDateTimeString;
    reservedTo: ZonedDateTimeString;
    standardCheckInTime: ZonedDateTimeString;
    firstDate: PlainDateString;
    lastDate: PlainDateString;
    additionalNights: number;
    canSelectAllowRoomChange: boolean;
    accommodationNotices: Array<{
      __typename: "AccommodationNotice";
      brief: string;
      detail?: string | null;
      externalUrl?: string | null;
    }>;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      name: string;
      code: string;
      facilityTypes: Array<AccommodationFacilityType>;
      isOwned: boolean;
      accommodationClass?: AccommodationClass | null;
      classRelation?: AccommodationClassRelation | null;
      site: {
        __typename: "Site";
        slug: string;
        isRemote: boolean;
        name: string;
        checkInAuthenticationType: CheckInAuthenticationType;
        area: { __typename: "Area"; slug: string };
      };
      architectureType: {
        __typename: "ArchitectureType";
        series: ArchitectureTypeSeries;
        name: string;
        size?: ArchitectureTypeSize | null;
        capacity: number;
        additionalFee: number;
      };
    };
    options: {
      __typename: "AccommodationReservationOptions";
      bringDog: boolean;
      numberOfDogs: number;
      useEvCharger: boolean;
    };
    fee: {
      __typename: "AccommodationFee";
      totalAmount: number;
      billingMethod: BillingMethod;
      items: Array<{
        __typename: "AccommodationFeeItem";
        type: AccommodationFeeItemPerType;
        key: string;
        label: string;
        amount: number;
        night?: PlainDateString | null;
      }>;
    };
    feeApplicability: {
      __typename: "AccommodationFeeApplicability";
      waiveArchitectureTypeAdditionalFee: boolean;
      waiveDogFee: boolean;
      waiveSaunaFee: boolean;
      waiveOnsenFee: boolean;
      waiveEvChargerFee: boolean;
      waiveDogRunFee: boolean;
    };
    localTaxPolicies: Array<{ __typename: "LocalTaxPolicy"; id: string }>;
    stayTicketUnit?:
      | ({
          __typename: "StayTicketUnit";
          reservationInfo: {
            __typename: "StayTicketReservationInfo";
            type: StayTicketType;
            additionalGuestFeeStartsAt?: number | null;
            additionalGuestFeeAdultPricePerNight?: number | null;
            additionalGuestFeeKidsPricePerNight?: number | null;
          };
        } & {
          " $fragmentRefs"?: {
            StayTicketUnitForCancelFeePolicyFragmentFragment: StayTicketUnitForCancelFeePolicyFragmentFragment;
          };
        })
      | null;
    cancellationPolicyContent?:
      | ({ __typename: "CancellationPolicyContent" } & {
          " $fragmentRefs"?: {
            CancellationPolicyContentFragmentFragment: CancellationPolicyContentFragmentFragment;
          };
        })
      | null;
  } & {
    " $fragmentRefs"?: {
      DraftAccommodationReservationInfoFragment: DraftAccommodationReservationInfoFragment;
    };
  };
};

export type CreateAccommodationReservationMutationVariables = Exact<{
  input: CreateAccommodationReservationInput;
}>;

export type CreateAccommodationReservationMutation = {
  __typename: "Mutation";
  createAccommodationReservation:
    | {
        __typename: "AccommodationReservation";
        id: string;
        invitationUrl?: string | null;
        tentativeDeadline?: ZonedDateTimeString | null;
        userAcceptCode?: string | null;
      }
    | {
        __typename: "CreateAccommodationReservationError";
        case: CreateAccommodationReservationErrorCase;
        internalCode?: string | null;
      };
};

export type MaybeViewerQueryVariables = Exact<{ [key: string]: never }>;

export type MaybeViewerQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: { __typename: "StripeCard"; last4: string } | null;
    };
    fullOwnerships: Array<{
      __typename: "UserOwnership";
      plan: {
        __typename: "OwnerPlan";
        accommodation?: { __typename: "Accommodation"; id: string } | null;
      };
    }>;
    subscription: { __typename: "UserSubscription"; id: string };
  } | null;
};

export type OriginalAccommodationReservationOnDraftReservationFormFragment = {
  __typename: "AccommodationReservation";
  id: string;
  mutationScope: AccommodationReservationMutationScope;
  canCancel: boolean;
  isTentative: boolean;
  detail: {
    __typename: "AccommodationReservationDetail";
    numberOfAdults: number;
    numberOfKids: number;
    numberOfInfants: number;
    previousLocation: string;
    nextLocation: string;
    bringDog: boolean;
    numberOfDogs: number;
    useEvCharger: boolean;
    allowRoomChange: boolean;
  };
  fee: {
    __typename: "AccommodationFee";
    items: Array<{
      __typename: "AccommodationFeeItem";
      type: AccommodationFeeItemPerType;
      label: string;
      amount: number;
      night?: PlainDateString | null;
      key: string;
    }>;
  };
} & {
  " $fragmentName"?: "OriginalAccommodationReservationOnDraftReservationFormFragment";
};

export type OrganizationReservationNewStatusFragment = {
  __typename: "OrganizationMembership";
  reservationNewStatus: {
    __typename: "OrganizationMemberNewReservationStatus";
    holdMaxInTotal: boolean;
    suspended: boolean;
    latestMonthlyReservationStatuses: Array<{
      __typename: "OrganizationMonthlyReservationStatus";
      yearMonth: PlainYearMonthString;
      isContracted: boolean;
      remainingNights: number;
      alreadyHold: boolean;
      yearlyReservationStatus?: {
        __typename: "OrganizationYearlyReservationStatus";
        remainingNights: number;
        startYearMonth: PlainYearMonthString;
        endYearMonth: PlainYearMonthString;
        maxNights: number;
      } | null;
    }>;
  };
} & { " $fragmentName"?: "OrganizationReservationNewStatusFragment" };

export type ReservationRuleOfOwnershipBannerFragmentFragment = {
  __typename: "UserOwnership";
  currentYearStatus: { __typename: "UserOwnershipProgramYearStatus" } & {
    " $fragmentRefs"?: {
      ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment: ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment;
    };
  };
  nextYearStatus?:
    | ({ __typename: "UserOwnershipProgramYearStatus" } & {
        " $fragmentRefs"?: {
          ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment: ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "ReservationRuleOfOwnershipBannerFragmentFragment" };

export type ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment = {
  __typename: "UserOwnershipProgramYearStatus";
  startDate: PlainDateString;
  endDate: PlainDateString;
  remainingNights: number;
  remainingPeakDays?: number | null;
  remainingSiteHighSeasonDays?: number | null;
} & {
  " $fragmentName"?: "ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment";
};

export type ReservationRuleOfStaffPlanBannerFragment = {
  __typename: "StaffContract";
  semesterCredits: Array<{
    __typename: "StaffSemesterCredit";
    semester: StaffSemester;
    year: number;
    remainingStayCredits: number;
    grantedStayCredits: number;
    remainingPeakDays: number;
  }>;
} & { " $fragmentName"?: "ReservationRuleOfStaffPlanBannerFragment" };

export type ReservationRuleBannerFragment = {
  __typename: "UserSubscription";
  billingCycleDay?: number | null;
  reservationCycle?: {
    __typename: "UserSubscriptionReservationCycle";
    startDay: number;
    endDay?: number | null;
  } | null;
  reservationCyclePeriods: Array<{
    __typename: "UserSubscriptionReservationCyclePeriod";
    start: PlainDateString;
    end: PlainDateString;
    stayedAndReservedNights: number;
  }>;
} & { " $fragmentName"?: "ReservationRuleBannerFragment" };

export type ReservationRuleOfTrialPlanBannerFragment = {
  __typename: "TrialContract";
  enrolledDate: PlainDateString;
  firstSemesterEndDate: PlainDateString;
  secondSemesterStartDate: PlainDateString;
  endDate: PlainDateString;
  firstSemesterStayCredits: number;
  firstSemesterRemainingPeakDays: number;
  secondSemesterStayCredits: number;
  secondSemesterRemainingPeakDays: number;
} & { " $fragmentName"?: "ReservationRuleOfTrialPlanBannerFragment" };

export type ViewerOnReservationRulesBannerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ViewerOnReservationRulesBannerQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    name: string;
    subscription: { __typename: "UserSubscription" } & {
      " $fragmentRefs"?: {
        ReservationRuleBannerFragment: ReservationRuleBannerFragment;
      };
    };
    trialContract?:
      | ({ __typename: "TrialContract" } & {
          " $fragmentRefs"?: {
            ReservationRuleOfTrialPlanBannerFragment: ReservationRuleOfTrialPlanBannerFragment;
          };
        })
      | null;
    staffContract?:
      | ({ __typename: "StaffContract" } & {
          " $fragmentRefs"?: {
            ReservationRuleOfStaffPlanBannerFragment: ReservationRuleOfStaffPlanBannerFragment;
          };
        })
      | null;
    organizationMembership?:
      | ({ __typename: "OrganizationMembership" } & {
          " $fragmentRefs"?: {
            OrganizationReservationNewStatusFragment: OrganizationReservationNewStatusFragment;
          };
        })
      | null;
    coOwnerships: Array<
      { __typename: "UserOwnership"; id: string } & {
        " $fragmentRefs"?: {
          ReservationRuleOfOwnershipBannerFragmentFragment: ReservationRuleOfOwnershipBannerFragmentFragment;
          ReservationFormOwnershipSelectorFragmentFragment: ReservationFormOwnershipSelectorFragmentFragment;
        };
      }
    >;
    fullOwnerships: Array<
      { __typename: "UserOwnership"; id: string } & {
        " $fragmentRefs"?: {
          ReservationRuleOfOwnershipBannerFragmentFragment: ReservationRuleOfOwnershipBannerFragmentFragment;
          ReservationFormOwnershipSelectorFragmentFragment: ReservationFormOwnershipSelectorFragmentFragment;
        };
      }
    >;
  };
};

export type CancellationPolicyContentFragmentFragment = {
  __typename: "CancellationPolicyContent";
  sections: Array<{
    __typename: "CancellationPolicySection";
    conditionLabel?: string | null;
    noShowDescription: string;
    changeDeadlineDescription: string;
    tiers: Array<{
      __typename: "CancellationFeeTier";
      label: string;
      feeDescription: string;
    }>;
  }>;
} & { " $fragmentName"?: "CancellationPolicyContentFragmentFragment" };

export type AccommodationReservationFeeFragmentFragment = {
  __typename: "AccommodationReservation";
  fee: {
    __typename: "AccommodationFee";
    totalAmount: number;
    billingMethod: BillingMethod;
    items: Array<{
      __typename: "AccommodationFeeItem";
      label: string;
      amount: number;
      night?: PlainDateString | null;
    }>;
  };
  consumedSuppliesFee: {
    __typename: "ConsumedSuppliesFee";
    items: Array<{
      __typename: "ConsumedSuppliesFeeItem";
      label: string;
      amount: number;
    }>;
  };
  facilityFee: {
    __typename: "FacilityFee";
    items: Array<{
      __typename: "FacilityFeeItem";
      label: string;
      amount: number;
    }>;
  };
  localTaxPolicies: Array<{ __typename: "LocalTaxPolicy"; id: string }>;
} & { " $fragmentName"?: "AccommodationReservationFeeFragmentFragment" };

export type AccommodationReservationQueryVariables = Exact<{
  input: Scalars["ID"]["input"];
}>;

export type AccommodationReservationQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
  } & {
    " $fragmentRefs"?: {
      AccommodationReservationFeeFragmentFragment: AccommodationReservationFeeFragmentFragment;
    };
  };
};

export type ActivityProgramCards_SiteFragment = {
  __typename: "Site";
  area: { __typename: "Area"; name: string };
  content: {
    __typename: "SiteContent";
    activityPrograms: Array<{
      __typename: "SiteActivityProgram";
      id: string;
      title: string;
      description?: string | null;
      externalUrl: string;
      image: { __typename: "UploadedFile"; url: string };
    }>;
  };
} & { " $fragmentName"?: "ActivityProgramCards_SiteFragment" };

export type AccommodationReservationCancelFeeQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  internal: Scalars["Boolean"]["input"];
}>;

export type AccommodationReservationCancelFeeQuery = {
  __typename: "Query";
  estimatedCancelFeeOfAccommodationReservation:
    | { __typename: "EstimatedCancelFeeOfAccommodationReservationError" }
    | ({
        __typename: "EstimatedChargeOfAccommodationReservation";
        items: Array<{
          __typename: "EstimatedChargeOfAccommodationReservationItem";
        }>;
      } & {
        " $fragmentRefs"?: {
          ChangeOrCancelEstimatedChargeFragmentFragment: ChangeOrCancelEstimatedChargeFragmentFragment;
        };
      });
  accommodationReservation: {
    __typename: "AccommodationReservation";
    reservedFrom: ZonedDateTimeString;
    reservedTo: ZonedDateTimeString;
    accommodation: { __typename: "Accommodation"; name: string };
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    detail: {
      __typename: "AccommodationReservationDetail";
      numberOfAdults: number;
      numberOfTotalChildren: number;
      previousLocation: string;
      nextLocation: string;
    };
    stayTicketUnit?:
      | ({ __typename: "StayTicketUnit" } & {
          " $fragmentRefs"?: {
            StayTicketUnitForCancelFeePolicyFragmentFragment: StayTicketUnitForCancelFeePolicyFragmentFragment;
          };
        })
      | null;
  } & {
    " $fragmentRefs"?: {
      ReservationSummaryFragment: ReservationSummaryFragment;
    };
  };
};

export type CancelAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type CancelAccommodationReservationMutation = {
  __typename: "Mutation";
  cancelAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "CancelAccommodationReservationError";
        case: CancelAccommodationReservationErrorCase;
      };
};

export type InternalCancelAccommodationReservationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type InternalCancelAccommodationReservationMutation = {
  __typename: "Mutation";
  internalCancelAccommodationReservation:
    | { __typename: "AccommodationReservation"; id: string }
    | {
        __typename: "CancelAccommodationReservationError";
        case: CancelAccommodationReservationErrorCase;
      };
};

export type ChangeOrCancelEstimatedChargeFragmentFragment = {
  __typename: "EstimatedChargeOfAccommodationReservation";
  totalAmountOfFee: number;
  items: Array<{
    __typename: "EstimatedChargeOfAccommodationReservationItem";
    label: string;
    chargeType: EstimatedChargeOfAccommodationReservationItemType;
    night: PlainDateString;
    amountOfFee?: number | null;
  }>;
} & { " $fragmentName"?: "ChangeOrCancelEstimatedChargeFragmentFragment" };

export type EarlyCheckInInfoModalFragment = {
  __typename: "AccommodationReservation";
  earlyCheckInPriceTable?: Array<{
    __typename: "EarlyCheckInPriceSlot";
    id: string;
    startHour: number;
    endHour: number;
    price: number;
    label: string;
  }> | null;
} & { " $fragmentName"?: "EarlyCheckInInfoModalFragment" };

export type ReservationBoxFragment = {
  __typename: "AccommodationReservation";
  stayStatus: AccommodationReservationStayStatus;
  firstDate: PlainDateString;
  lastDate: PlainDateString;
  reservedFrom: ZonedDateTimeString;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  accommodation: {
    __typename: "Accommodation";
    name: string;
    code: string;
    site: {
      __typename: "Site";
      slug: string;
      name: string;
      area: { __typename: "Area"; slug: string };
    };
    architectureType: {
      __typename: "ArchitectureType";
      series: ArchitectureTypeSeries;
    };
  };
} & { " $fragmentName"?: "ReservationBoxFragment" };

export type ReservationSummaryFragment = {
  __typename: "AccommodationReservation";
  reservedFrom: ZonedDateTimeString;
  reservedTo: ZonedDateTimeString;
  standardCheckInTime: ZonedDateTimeString;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  accommodation: {
    __typename: "Accommodation";
    name: string;
    code: string;
    site: {
      __typename: "Site";
      slug: string;
      name: string;
      area: { __typename: "Area"; slug: string };
    };
    architectureType: {
      __typename: "ArchitectureType";
      series: ArchitectureTypeSeries;
    };
  };
  detail: {
    __typename: "AccommodationReservationDetail";
    numberOfAdults: number;
    numberOfKids: number;
    numberOfInfants: number;
    numberOfTotalChildren: number;
    previousLocation: string;
    nextLocation: string;
    allowRoomChange: boolean;
    internalStamp?: string | null;
  };
  fee: {
    __typename: "AccommodationFee";
    billingMethod: BillingMethod;
    totalAmount: number;
  };
} & { " $fragmentName"?: "ReservationSummaryFragment" };

export type SiteContentFragmentFragment = {
  __typename: "Site";
  area: { __typename: "Area"; slug: string };
  content: {
    __typename: "SiteContent";
    id: string;
    mapImageUrl?: string | null;
    faqs: Array<{ __typename: "SiteFaq"; question: string; answer: string }>;
  };
} & { " $fragmentName"?: "SiteContentFragmentFragment" };

export type SiteTrafficInfoFragment = {
  __typename: "Site";
  area: {
    __typename: "Area";
    content: {
      __typename: "AreaContent";
      roadConditionLiveCameraUrl?: string | null;
    };
  };
  content: { __typename: "SiteContent"; iceRoadInfoUrl?: string | null };
} & { " $fragmentName"?: "SiteTrafficInfoFragment" };

export type ConcernPanel_StayReviewConcernKindDefinitionFragment = {
  __typename: "StayReviewConcernKindDefinition";
  label: string;
  commentPlaceholder?: string | null;
  details: Array<{
    __typename: "StayReviewConcernDetailOption";
    value: StayReviewConcernDetail;
    label: string;
  }>;
} & {
  " $fragmentName"?: "ConcernPanel_StayReviewConcernKindDefinitionFragment";
};

export type MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment =
  {
    __typename: "StayReviewMemorableExperienceOption";
    value: StayReviewMemorableExperience;
    label: string;
    description?: string | null;
  } & {
    " $fragmentName"?: "MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment";
  };

export type SaveStayReviewDraftMutationVariables = Exact<{
  accommodationReservationId: Scalars["ID"]["input"];
  input: StayReviewV2Input;
}>;

export type SaveStayReviewDraftMutation = {
  __typename: "Mutation";
  saveStayReviewV2Draft:
    | { __typename: "StayReviewV2"; id: string }
    | { __typename: "StayReviewV2Error"; case: StayReviewV2ErrorCase };
};

export type StayReviewCompleted_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  stayStatus: AccommodationReservationStayStatus;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
} & {
  " $fragmentName"?: "StayReviewCompleted_AccommodationReservationFragment";
};

export type StayReviewCompleted_UserFragment = {
  __typename: "User";
  id: string;
  stayedReservationCount: number;
} & { " $fragmentName"?: "StayReviewCompleted_UserFragment" };

export type StayReviewForm_StayReviewV2Fragment = {
  __typename: "StayReviewV2";
  id: string;
  submittedAt?: ZonedDateTimeString | null;
  memorableExperiences: Array<StayReviewMemorableExperience>;
  architectureAndNatureRating?: number | null;
  cleaningRating?: number | null;
  equipmentRating?: number | null;
  guidanceAndSupportRating?: number | null;
  comment?: string | null;
  concerns: Array<{
    __typename: "StayReviewV2Concern";
    kind: StayReviewConcernKind;
    details: Array<StayReviewConcernDetail>;
    comment?: string | null;
  }>;
} & { " $fragmentName"?: "StayReviewForm_StayReviewV2Fragment" };

export type StayReviewForm_StayReviewV2FormFragment = {
  __typename: "StayReviewV2Form";
  memorableExperiences: Array<
    {
      __typename: "StayReviewMemorableExperienceOption";
      value: StayReviewMemorableExperience;
    } & {
      " $fragmentRefs"?: {
        MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment: MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment;
      };
    }
  >;
  axes: Array<{
    __typename: "StayReviewAxisDefinition";
    axis: StayReviewAxis;
    label: string;
    description: string;
    concernKinds: Array<
      {
        __typename: "StayReviewConcernKindDefinition";
        kind: StayReviewConcernKind;
        label: string;
        details: Array<{
          __typename: "StayReviewConcernDetailOption";
          value: StayReviewConcernDetail;
          label: string;
        }>;
      } & {
        " $fragmentRefs"?: {
          ConcernPanel_StayReviewConcernKindDefinitionFragment: ConcernPanel_StayReviewConcernKindDefinitionFragment;
        };
      }
    >;
  }>;
} & { " $fragmentName"?: "StayReviewForm_StayReviewV2FormFragment" };

export type SubmitStayReviewMutationVariables = Exact<{
  accommodationReservationId: Scalars["ID"]["input"];
  input: StayReviewV2Input;
}>;

export type SubmitStayReviewMutation = {
  __typename: "Mutation";
  submitStayReviewV2:
    | {
        __typename: "StayReviewV2";
        id: string;
        submittedAt?: ZonedDateTimeString | null;
      }
    | { __typename: "StayReviewV2Error"; case: StayReviewV2ErrorCase };
};

export type StayReviewPageQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type StayReviewPageQuery = {
  __typename: "Query";
  accommodationReservation: {
    __typename: "AccommodationReservation";
    id: string;
    provider:
      | { __typename: "BusinessPlanAccommodationReservationProvider" }
      | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
      | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
      | { __typename: "OneMoreCabinAccommodationReservationProvider" }
      | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
      | { __typename: "SanuIncAccommodationReservationProvider" }
      | { __typename: "StaffPlanAccommodationReservationProvider" }
      | { __typename: "StandardPlanAccommodationReservationProvider" }
      | { __typename: "StayDirectAccommodationReservationProvider" }
      | { __typename: "StayTicketAccommodationReservationProvider" }
      | { __typename: "TrialPlanAccommodationReservationProvider" };
    stayReviewV2?:
      | ({ __typename: "StayReviewV2" } & {
          " $fragmentRefs"?: {
            StayReviewQuickSelect_StayReviewV2Fragment: StayReviewQuickSelect_StayReviewV2Fragment;
            StayReviewForm_StayReviewV2Fragment: StayReviewForm_StayReviewV2Fragment;
          };
        })
      | null;
  } & {
    " $fragmentRefs"?: {
      StayReviewQuickSelect_AccommodationReservationFragment: StayReviewQuickSelect_AccommodationReservationFragment;
      StayReviewCompleted_AccommodationReservationFragment: StayReviewCompleted_AccommodationReservationFragment;
    };
  };
  viewer: { __typename: "User" } & {
    " $fragmentRefs"?: {
      StayReviewCompleted_UserFragment: StayReviewCompleted_UserFragment;
    };
  };
  stayReviewV2Form: {
    __typename: "StayReviewV2Form";
    memorableExperiences: Array<{
      __typename: "StayReviewMemorableExperienceOption";
      value: StayReviewMemorableExperience;
    }>;
  } & {
    " $fragmentRefs"?: {
      StayReviewQuickSelect_StayReviewV2FormFragment: StayReviewQuickSelect_StayReviewV2FormFragment;
      StayReviewForm_StayReviewV2FormFragment: StayReviewForm_StayReviewV2FormFragment;
    };
  };
};

export type StayReviewQuickSelect_AccommodationReservationFragment = {
  __typename: "AccommodationReservation";
  id: string;
  accommodation: {
    __typename: "Accommodation";
    id: string;
    architectureType: { __typename: "ArchitectureType"; name: string };
    site: { __typename: "Site"; id: string; name: string };
  };
} & {
  " $fragmentName"?: "StayReviewQuickSelect_AccommodationReservationFragment";
};

export type StayReviewQuickSelect_StayReviewV2Fragment = {
  __typename: "StayReviewV2";
  id: string;
  memorableExperiences: Array<StayReviewMemorableExperience>;
} & { " $fragmentName"?: "StayReviewQuickSelect_StayReviewV2Fragment" };

export type StayReviewQuickSelect_StayReviewV2FormFragment = {
  __typename: "StayReviewV2Form";
  memorableExperiences: Array<
    {
      __typename: "StayReviewMemorableExperienceOption";
      value: StayReviewMemorableExperience;
    } & {
      " $fragmentRefs"?: {
        MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment: MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment;
      };
    }
  >;
} & { " $fragmentName"?: "StayReviewQuickSelect_StayReviewV2FormFragment" };

export type AccommodationOnRoomDetailContentFragment = {
  __typename: "Accommodation";
  code: string;
  site: {
    __typename: "Site";
    id: string;
    name: string;
    content: {
      __typename: "SiteContent";
      id: string;
      googleMapsUrl?: string | null;
    };
  };
  roomType?: {
    __typename: "RoomType";
    id: string;
    displayName: string;
    notes?: string | null;
    features: Array<{
      __typename: "RoomTypeFeature";
      id: string;
      slug: string;
      displayName: string;
      iconSlug?: string | null;
      sort: number;
    }>;
    content?: {
      __typename: "ContentRoomType";
      id: string;
      heroImages: Array<{ __typename: "UploadedFile"; rawUrl: string }>;
    } | null;
  } | null;
  architectureType: {
    __typename: "ArchitectureType";
    id: string;
    name: string;
    content: {
      __typename: "ContentArchitectureType";
      id: string;
      capacityDescription: string;
      sizeDescription: string;
      equipmentsListUrl?: string | null;
      basicAmenities: Array<{
        __typename: "ContentArchitectureTypeBasicAmenity";
        name: string;
      }>;
    };
  };
} & { " $fragmentName"?: "AccommodationOnRoomDetailContentFragment" };

export type RoomTypeOnRoomDetailContentFragment = {
  __typename: "RoomType";
  displayName: string;
  notes?: string | null;
  features: Array<{
    __typename: "RoomTypeFeature";
    id: string;
    slug: string;
    displayName: string;
    iconSlug?: string | null;
    sort: number;
  }>;
  content?: {
    __typename: "ContentRoomType";
    id: string;
    heroImages: Array<{ __typename: "UploadedFile"; rawUrl: string }>;
  } | null;
  site: {
    __typename: "Site";
    id: string;
    name: string;
    content: {
      __typename: "SiteContent";
      id: string;
      googleMapsUrl?: string | null;
    };
  };
  architectureType?: {
    __typename: "ArchitectureType";
    id: string;
    name: string;
    content: {
      __typename: "ContentArchitectureType";
      id: string;
      capacityDescription: string;
      sizeDescription: string;
      equipmentsListUrl?: string | null;
      basicAmenities: Array<{
        __typename: "ContentArchitectureTypeBasicAmenity";
        name: string;
      }>;
    };
  } | null;
} & { " $fragmentName"?: "RoomTypeOnRoomDetailContentFragment" };

export type RoomDetailDrawerQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
  skipAvailability: Scalars["Boolean"]["input"];
}>;

export type RoomDetailDrawerQuery = {
  __typename: "Query";
  accommodation?:
    | ({
        __typename: "Accommodation";
        id: string;
        availabilities?: Array<
          { __typename: "AccommodationAvailability" } & {
            " $fragmentRefs"?: {
              AvailabilityOnCtaButtonFragment: AvailabilityOnCtaButtonFragment;
            };
          }
        >;
      } & {
        " $fragmentRefs"?: {
          AccommodationOnRoomDetailContentFragment: AccommodationOnRoomDetailContentFragment;
        };
      })
    | null;
};

export type RoomDetailDrawerRoomTypeQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type RoomDetailDrawerRoomTypeQuery = {
  __typename: "Query";
  roomType?:
    | ({ __typename: "RoomType"; id: string } & {
        " $fragmentRefs"?: {
          RoomTypeOnRoomDetailContentFragment: RoomTypeOnRoomDetailContentFragment;
        };
      })
    | null;
};

export type AvailabilityOnCtaButtonFragment = {
  __typename: "AccommodationAvailability";
  date: PlainDateString;
  guaranteedPrice?: number | null;
} & { " $fragmentName"?: "AvailabilityOnCtaButtonFragment" };

export type RoomTypeBrowseQueryVariables = Exact<{
  provider: AccommodationReservationProviderInput;
  withDeferred: Scalars["Boolean"]["input"];
  isDateFilterActive: Scalars["Boolean"]["input"];
  facilitySlugs?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  architectureTypes?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
}>;

export type RoomTypeBrowseQuery = {
  __typename: "Query";
  areasForReservation: Array<{
    __typename: "Area";
    id: string;
    name: string;
    slug: string;
    sitesForReservation: Array<{
      __typename: "Site";
      id: string;
      name: string;
      slug: string;
      shortAddress?: string | null;
      content: {
        __typename: "SiteContent";
        id: string;
        prefecture?: string | null;
        city?: string | null;
        heroImages: Array<{ __typename: "UploadedFile"; rawUrl: string }>;
      };
      roomTypesForReservation: Array<
        {
          __typename: "RoomType";
          id: string;
          displayName: string;
          architectureType?: {
            __typename: "ArchitectureType";
            id: string;
            name: string;
            series: ArchitectureTypeSeries;
            capacity: number;
            content: {
              __typename: "ContentArchitectureType";
              id: string;
              capacityDescription: string;
            };
          } | null;
          features: Array<{
            __typename: "RoomTypeFeature";
            id: string;
            slug: string;
          }>;
          availabilities?: {
            __typename: "RoomTypeAvailabilities";
            fromPrice?: number | null;
            nights?: Array<{
              __typename: "RoomTypeAvailability";
              night: PlainDateString;
              availableAccommodations: Array<{
                __typename: "Accommodation";
                id: string;
              }>;
            }>;
          };
        } & {
          " $fragmentRefs"?: {
            FeatureSubtext_RoomTypeFragment: FeatureSubtext_RoomTypeFragment;
          };
        }
      >;
    }>;
  }>;
};

export type RoomTypeCalendarAvailabilityQueryVariables = Exact<{
  provider: AccommodationReservationProviderInput;
  areaIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
  facilitySlugs?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  architectureTypes?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
}>;

export type RoomTypeCalendarAvailabilityQuery = {
  __typename: "Query";
  areasForReservation: Array<{
    __typename: "Area";
    id: string;
    slug: string;
    sitesForReservation: Array<{
      __typename: "Site";
      id: string;
      roomTypesForReservation: Array<{
        __typename: "RoomType";
        id: string;
        availabilities: {
          __typename: "RoomTypeAvailabilities";
          nights: Array<{
            __typename: "RoomTypeAvailability";
            night: PlainDateString;
            isAvailable: boolean;
            price: number;
            maxConsecutiveNights: number;
          }>;
        };
      }>;
    }>;
  }>;
};

export type SiteAvailabilityQueryVariables = Exact<{
  provider: AccommodationReservationProviderInput;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  facilitySlugs: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  architectureTypes:
    | Array<Scalars["String"]["input"]>
    | Scalars["String"]["input"];
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SiteAvailabilityQuery = {
  __typename: "Query";
  areasForReservation: Array<{
    __typename: "Area";
    id: string;
    sitesForReservation: Array<{
      __typename: "Site";
      id: string;
      availability: Array<{
        __typename: "SiteAvailabilityNight";
        night: PlainDateString;
        isAvailable: boolean;
        fromPrice?: number | null;
      }>;
    }>;
  }>;
};

export type FeatureSubtext_RoomTypeFragment = {
  __typename: "RoomType";
  features: Array<{ __typename: "RoomTypeFeature"; id: string; slug: string }>;
} & { " $fragmentName"?: "FeatureSubtext_RoomTypeFragment" };

export type RoomTypeReservationAvailabilityQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  provider: AccommodationReservationProviderInput;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
}>;

export type RoomTypeReservationAvailabilityQuery = {
  __typename: "Query";
  roomType?: {
    __typename: "RoomType";
    id: string;
    availabilities: {
      __typename: "RoomTypeAvailabilities";
      stayTicketMasterId?: string | null;
      nights: Array<{
        __typename: "RoomTypeAvailability";
        night: PlainDateString;
        isAvailable: boolean;
        price: number;
        availableAccommodations: Array<{
          __typename: "Accommodation";
          id: string;
          facilityTypes: Array<AccommodationFacilityType>;
        }>;
      }>;
    };
  } | null;
};

export type RoomTypeReservationAvailabilityByStayTicketMasterQueryVariables =
  Exact<{
    id: Scalars["ID"]["input"];
    firstNight: Scalars["PlainDate"]["input"];
    lastNight: Scalars["PlainDate"]["input"];
    stayTicketMasterReference: StayTicketMasterReferenceInput;
    evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  }>;

export type RoomTypeReservationAvailabilityByStayTicketMasterQuery = {
  __typename: "Query";
  roomType?: {
    __typename: "RoomType";
    id: string;
    site: { __typename: "Site"; id: string; isRemote: boolean };
    availabilitiesByStayTicketMaster: {
      __typename: "RoomTypeAvailabilities";
      stayTicketMasterId?: string | null;
      nights: Array<{
        __typename: "RoomTypeAvailability";
        night: PlainDateString;
        isAvailable: boolean;
        price: number;
        availableAccommodations: Array<{
          __typename: "Accommodation";
          id: string;
          facilityTypes: Array<AccommodationFacilityType>;
        }>;
      }>;
    };
  } | null;
};

export type IssueSanuEdgeDeviceAccessTokenMutationVariables = Exact<{
  input: IssueSanuEdgeDeviceAccessTokenInput;
}>;

export type IssueSanuEdgeDeviceAccessTokenMutation = {
  __typename: "Mutation";
  issueSanuEdgeDeviceAccessToken:
    | {
        __typename: "IssueSanuEdgeDeviceAccessTokenError";
        case: IssueSanuEdgeDeviceAccessTokenErrorCase;
      }
    | {
        __typename: "IssueSanuEdgeDeviceAccessTokenSuccess";
        token: string;
        device: { __typename: "SanuEdgeDevice"; deviceId: string };
      };
};

export type SiteDetailDrawerQueryVariables = Exact<{
  siteSlug: Scalars["String"]["input"];
  provider: AccommodationReservationProviderInput;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  withDeferred: Scalars["Boolean"]["input"];
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SiteDetailDrawerQuery = {
  __typename: "Query";
  siteBySlug?:
    | ({
        __typename: "Site";
        id: string;
        roomTypesForReservation: Array<
          {
            __typename: "RoomType";
            id: string;
            displayName: string;
            architectureType?: {
              __typename: "ArchitectureType";
              id: string;
              name: string;
              series: ArchitectureTypeSeries;
              capacity: number;
              content: {
                __typename: "ContentArchitectureType";
                id: string;
                capacityDescription: string;
              };
            } | null;
            features: Array<{
              __typename: "RoomTypeFeature";
              id: string;
              slug: string;
            }>;
            availabilities?: {
              __typename: "RoomTypeAvailabilities";
              fromPrice?: number | null;
              nights: Array<{
                __typename: "RoomTypeAvailability";
                night: PlainDateString;
                availableAccommodations: Array<{
                  __typename: "Accommodation";
                  id: string;
                }>;
              }>;
            };
          } & {
            " $fragmentRefs"?: {
              FeatureSubtext_RoomTypeFragment: FeatureSubtext_RoomTypeFragment;
            };
          }
        >;
      } & {
        " $fragmentRefs"?: {
          SiteHero_SiteFragment: SiteHero_SiteFragment;
          SiteAboutOverview_SiteFragment: SiteAboutOverview_SiteFragment;
          SiteAboutFacilities_SiteFragment: SiteAboutFacilities_SiteFragment;
          DxAccessSection_SiteFragment: DxAccessSection_SiteFragment;
          DxFaqSection_SiteFragment: DxFaqSection_SiteFragment;
        };
      })
    | null;
};

export type CreateSetupIntentOnAccountMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateSetupIntentOnAccountMutation = {
  __typename: "Mutation";
  createStripeCardSetupIntentOfViewer: {
    __typename: "CreateStripeCardSetupIntentOfViewerPayload";
    clientSecret: string;
  };
};

export type CreateSetupIntentOnAccountOfOrganizationMutationVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
}>;

export type CreateSetupIntentOnAccountOfOrganizationMutation = {
  __typename: "Mutation";
  createStripeCardSetupIntentOfOrganization: {
    __typename: "CreateStripeCardSetupIntentOfOrganizationPayload";
    clientSecret: string;
  };
};

export type TermsAgreementModal_TermsRevisionFragment = {
  __typename: "TermsRevision";
  id: string;
  description: string;
  news?: { __typename: "News"; id: string } | null;
  terms: { __typename: "Terms"; id: string; documentUrl: string };
} & { " $fragmentName"?: "TermsAgreementModal_TermsRevisionFragment" };

export type AgreeToTermsMutationVariables = Exact<{
  termsRevisionId: Scalars["ID"]["input"];
}>;

export type AgreeToTermsMutation = {
  __typename: "Mutation";
  agreeToTerms:
    | { __typename: "AgreeToTermsError"; case: AgreeToTermsErrorCase }
    | { __typename: "Success" };
};

export type AccommodationReservationInfoFragment = {
  __typename: "AccommodationReservation";
  id: string;
  firstDate: PlainDateString;
  lastDate: PlainDateString;
  reservedFrom: ZonedDateTimeString;
  provider:
    | { __typename: "BusinessPlanAccommodationReservationProvider" }
    | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
    | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
    | { __typename: "OneMoreCabinAccommodationReservationProvider" }
    | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
    | { __typename: "SanuIncAccommodationReservationProvider" }
    | { __typename: "StaffPlanAccommodationReservationProvider" }
    | { __typename: "StandardPlanAccommodationReservationProvider" }
    | { __typename: "StayDirectAccommodationReservationProvider" }
    | { __typename: "StayTicketAccommodationReservationProvider" }
    | { __typename: "TrialPlanAccommodationReservationProvider" };
  accommodation: {
    __typename: "Accommodation";
    name: string;
    code: string;
    facilityTypes: Array<AccommodationFacilityType>;
    site: {
      __typename: "Site";
      name: string;
      slug: string;
      area: { __typename: "Area"; slug: string };
    };
    architectureType: {
      __typename: "ArchitectureType";
      name: string;
      series: ArchitectureTypeSeries;
    };
  };
  detail: {
    __typename: "AccommodationReservationDetail";
    bringDog: boolean;
    useEvCharger: boolean;
  };
  stayTicketUnit?: {
    __typename: "StayTicketUnit";
    reservationInfo: { __typename: "StayTicketReservationInfo"; name: string };
  } | null;
} & { " $fragmentName"?: "AccommodationReservationInfoFragment" };

export type DraftAccommodationReservationInfoFragment = {
  __typename: "DraftAccommodationReservation";
  firstDate: PlainDateString;
  lastDate: PlainDateString;
  reservedFrom: ZonedDateTimeString;
  accommodation: {
    __typename: "Accommodation";
    name: string;
    code: string;
    facilityTypes: Array<AccommodationFacilityType>;
    site: {
      __typename: "Site";
      name: string;
      slug: string;
      area: { __typename: "Area"; slug: string };
    };
    architectureType: {
      __typename: "ArchitectureType";
      name: string;
      series: ArchitectureTypeSeries;
    };
    roomType?: { __typename: "RoomType"; displayName: string } | null;
  };
  options: {
    __typename: "AccommodationReservationOptions";
    bringDog: boolean;
    useEvCharger: boolean;
  };
  stayTicketUnit?: {
    __typename: "StayTicketUnit";
    reservationInfo: { __typename: "StayTicketReservationInfo"; name: string };
  } | null;
} & { " $fragmentName"?: "DraftAccommodationReservationInfoFragment" };

export type UpdateViewerProfileMutationVariables = Exact<{
  input: UpdateViewerInput;
}>;

export type UpdateViewerProfileMutation = {
  __typename: "Mutation";
  updateViewer: { __typename: "User"; id: string; name: string };
};

export type ViewerProfileQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerProfileQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    id: string;
    name: string;
    nameKana?: string | null;
    email: string;
    phoneNumber?: string | null;
    profile: {
      __typename: "UserProfile";
      birthDate?: PlainDateString | null;
      gender?: GenderType | null;
      nationality?: CountryEnum | null;
      professionType?: UserProfileProfessionType | null;
      professionFree?: string | null;
      householdComposition?: UserProfileHouseholdComposition | null;
      numberOfDogs?: number | null;
      carOwnershipStatus?: UserProfileCarOwnershipStatus | null;
      passportNumber?: string | null;
      address?:
        | {
            __typename: "AddressInJapan";
            postalCode: string;
            line1: string;
            line2: string;
          }
        | {
            __typename: "AddressInternational";
            line1: string;
            city: string;
            stateProvince: string;
            postalCode: string;
            country: CountryEnum;
            internationalLine2?: string | null;
          }
        | null;
      passportPhoto?: {
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      } | null;
      facePhoto?: {
        __typename: "UploadedFile";
        rawUrl: string;
        url: string;
      } | null;
    };
  };
};

export type GetUserCardQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserCardQuery = {
  __typename: "Query";
  maybeViewer?: {
    __typename: "User";
    stripe: {
      __typename: "StripeCustomer";
      defaultCard?: {
        __typename: "StripeCard";
        brand: string;
        last4: string;
        exp_month: number;
        exp_year: number;
      } | null;
    };
  } | null;
};

export type AreasForGlobalMenuQueryVariables = Exact<{ [key: string]: never }>;

export type AreasForGlobalMenuQuery = {
  __typename: "Query";
  areas: Array<{
    __typename: "Area";
    id: string;
    name: string;
    slug: string;
    sites: Array<{ __typename: "Site"; id: string }>;
  }>;
};

export type ReservationRuleRevision2027PolicyQueryVariables = Exact<{
  provider: AccommodationReservationProviderInput;
}>;

export type ReservationRuleRevision2027PolicyQuery = {
  __typename: "Query";
  reservationRuleRevision2027Policy: {
    __typename: "ReservationRuleRevision2027Policy";
    announcementStartDate: PlainDateString;
    firstApplicableNight: PlainDateString;
  };
};

export type UseUploadFileCreateUserFileUplaodPolicyMutationVariables = Exact<{
  input: CreateUserFileUploadPolicyInput;
}>;

export type UseUploadFileCreateUserFileUplaodPolicyMutation = {
  __typename: "Mutation";
  createUserFileUploadPolicy:
    | {
        __typename: "CreateFileUploadPolicyError";
        case: CreateFileUploadPolicyErrorCase;
      }
    | {
        __typename: "CreateFileUploadPolicySuccess";
        policy: {
          __typename: "S3UploadPolicy";
          uploadUrl: string;
          rawUrl: string;
          fields: Array<{
            __typename: "S3UploadPolicyField";
            key: string;
            value: string;
          }>;
        };
      };
};

export type CompleteAddIdentityMutationVariables = Exact<{
  input: CompleteAddIdentityInput;
}>;

export type CompleteAddIdentityMutation = {
  __typename: "Mutation";
  completeAddIdentity:
    | {
        __typename: "CompleteAddIdentityError";
        case: CompleteAddIdentityErrorCase;
      }
    | { __typename: "CompleteAddIdentitySuccess"; redirectUrl: string };
};

export type VerifyAddIdentityReauthMutationVariables = Exact<{
  input: VerifyAddIdentityReauthInput;
}>;

export type VerifyAddIdentityReauthMutation = {
  __typename: "Mutation";
  verifyAddIdentityReauth:
    | {
        __typename: "VerifyAddIdentityReauthError";
        case: VerifyAddIdentityReauthErrorCase;
      }
    | { __typename: "VerifyAddIdentityReauthRedirect"; redirectUrl: string };
};

export type AdminActionsAdminStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminActionsAdminStatusQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    adminRoleAssignments: Array<{
      __typename: "AdminRoleAssignment";
      role: AdminRole;
      site?: { __typename: "Site"; id: string } | null;
    }>;
  };
};

export type ImpersonateViewerQueryVariables = Exact<{ [key: string]: never }>;

export type ImpersonateViewerQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    adminRoleAssignments: Array<{
      __typename: "AdminRoleAssignment";
      role: AdminRole;
      site?: { __typename: "Site"; id: string } | null;
    }>;
  };
};

export type ImpersonateUserByIdQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type ImpersonateUserByIdQuery = {
  __typename: "Query";
  internalUser: {
    __typename: "User";
    id: string;
    deletedAt?: DateTimeString | null;
    adminRoleAssignments: Array<{
      __typename: "AdminRoleAssignment";
      role: AdminRole;
    }>;
  };
};

export type FinalizeAccountLinkMutationVariables = Exact<{
  input: FinalizeAccountLinkInput;
}>;

export type FinalizeAccountLinkMutation = {
  __typename: "Mutation";
  finalizeAccountLink:
    | {
        __typename: "FinalizeAccountLinkError";
        case: FinalizeAccountLinkErrorCase;
      }
    | { __typename: "FinalizeAccountLinkSuccess"; continueUrl: string };
};

export type ViewerEmailVerifiedQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerEmailVerifiedQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; emailVerified: boolean };
};

export type CreateConsumedSuppliesFeeItemsMutationVariables = Exact<{
  input: InternalCreateConsumedSuppliesFeeItemsInput;
}>;

export type CreateConsumedSuppliesFeeItemsMutation = {
  __typename: "Mutation";
  internalCreateConsumedSuppliesFeeItems:
    | {
        __typename: "InternalCreateConsumedSuppliesFeeItemsError";
        case: InternalCreateConsumedSuppliesFeeItemsErrorCase;
      }
    | { __typename: "Success" };
};

export type GetFutureCleaningAmountsQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
}>;

export type GetFutureCleaningAmountsQuery = {
  __typename: "Query";
  internalFutureCleaningAmounts:
    | {
        __typename: "InternalFutureCleaningAmounts";
        list: Array<{
          __typename: "InternalFutureCleaningAmount";
          date: PlainDateString;
          amount: number;
          amountByFacilities: Array<{
            __typename: "InternalFutureCleaningAmountByFacility";
            facilityCombinationName: string;
            amount: number;
          }>;
        }>;
      }
    | { __typename: "InternalFutureCleaningAmountsError"; message: string };
};

export type ProcessCronJobMutationVariables = Exact<{
  job: CronJobName;
  authHeader: Scalars["String"]["input"];
}>;

export type ProcessCronJobMutation = {
  __typename: "Mutation";
  processCronJob: {
    __typename: "ProcessCronJobResponse";
    status: number;
    body: string;
  };
};

export type InternalJtasCreateOrUpdateInspectionStatusesMutationVariables =
  Exact<{
    input: InternalJtasCreateOrUpdateInspectionStatusesInput;
  }>;

export type InternalJtasCreateOrUpdateInspectionStatusesMutation = {
  __typename: "Mutation";
  internalJtasCreateOrUpdateInspectionStatuses:
    | {
        __typename: "InternalJtasCreateOrUpdateInspectionStatusesError";
        case: InternalJtasCreateOrUpdateInspectionStatusesErrorCase;
      }
    | { __typename: "Success" };
};

export type InternalSitesQueryVariables = Exact<{ [key: string]: never }>;

export type InternalSitesQuery = {
  __typename: "Query";
  internalSites: Array<{
    __typename: "Site";
    id: string;
    name: string;
    accommodations: Array<{
      __typename: "Accommodation";
      id: string;
      code: string;
      name: string;
      architectureType: {
        __typename: "ArchitectureType";
        id: string;
        name: string;
      };
    }>;
  }>;
};

export type InternalJtasInspectionForRoomQueryVariables = Exact<{
  accommodationId: Scalars["ID"]["input"];
  inspectionDate: Scalars["PlainDate"]["input"];
}>;

export type InternalJtasInspectionForRoomQuery = {
  __typename: "Query";
  internalJtasInspections: Array<{
    __typename: "Inspection";
    status: InspectionStatusType;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      code: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: { __typename: "Site"; id: string };
      accessKey?: {
        __typename: "AccommodationAccessKey";
        pin: string;
        isSynced: boolean;
        startsAt?: ZonedDateTimeString | null;
        endsAt?: ZonedDateTimeString | null;
      } | null;
    };
    reservation?: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastNight: PlainDateString;
      reservedFrom: ZonedDateTimeString;
      reservedTo: ZonedDateTimeString;
      stayStatus: AccommodationReservationStayStatus;
      earlyCheckInEligible: boolean;
      user?: { __typename: "User"; name: string } | null;
      otaDetail?: {
        __typename: "AccommodationReservationOtaDetail";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      detail: {
        __typename: "AccommodationReservationDetail";
        numberOfAdults: number;
        numberOfKids: number;
        numberOfInfants: number;
        numberOfDogs: number;
      };
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
    } | null;
  }>;
};

export type InternalJtasCreateOrUpdateSupplyReportMutationVariables = Exact<{
  input: InternalJtasCreateOrUpdateSupplyReportInput;
}>;

export type InternalJtasCreateOrUpdateSupplyReportMutation = {
  __typename: "Mutation";
  internalJtasCreateOrUpdateSupplyReport:
    | {
        __typename: "InternalJtasCreateOrUpdateSupplyReportError";
        case: InternalJtasCreateOrUpdateSupplyReportErrorCase;
      }
    | { __typename: "Success" };
};

export type InternalSupplyItemsQueryVariables = Exact<{
  accommodationId: Scalars["ID"]["input"];
}>;

export type InternalSupplyItemsQuery = {
  __typename: "Query";
  internalAccommodation?: {
    __typename: "Accommodation";
    site: { __typename: "Site"; id: string };
  } | null;
  internalSupplyItems: Array<{
    __typename: "SupplyItem";
    defaultQuantity: number;
    master: {
      __typename: "SupplyItemMaster";
      id: string;
      namePublic: string;
      namePrivate: string;
      unit?: string | null;
      price: number;
    };
  }>;
};

export type InternalJtasInspectionsQueryVariables = Exact<{
  siteId: Scalars["ID"]["input"];
  inspectionDate: Scalars["PlainDate"]["input"];
}>;

export type InternalJtasInspectionsQuery = {
  __typename: "Query";
  internalJtasInspections: Array<{
    __typename: "Inspection";
    status: InspectionStatusType;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      code: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: { __typename: "Site"; id: string };
      accessKey?: {
        __typename: "AccommodationAccessKey";
        pin: string;
        isSynced: boolean;
        startsAt?: ZonedDateTimeString | null;
        endsAt?: ZonedDateTimeString | null;
      } | null;
    };
    reservation?: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastNight: PlainDateString;
      reservedFrom: ZonedDateTimeString;
      reservedTo: ZonedDateTimeString;
      stayStatus: AccommodationReservationStayStatus;
      earlyCheckInEligible: boolean;
      user?: { __typename: "User"; name: string } | null;
      otaDetail?: {
        __typename: "AccommodationReservationOtaDetail";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      detail: {
        __typename: "AccommodationReservationDetail";
        numberOfAdults: number;
        numberOfKids: number;
        numberOfInfants: number;
        numberOfDogs: number;
      };
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
    } | null;
  }>;
};

export type InternalJtasCreateOrUpdateViolationReportMutationVariables = Exact<{
  input: InternalJtasCreateOrUpdateViolationReportInput;
}>;

export type InternalJtasCreateOrUpdateViolationReportMutation = {
  __typename: "Mutation";
  internalJtasCreateOrUpdateViolationReport:
    | {
        __typename: "InternalJtasCreateOrUpdateViolationReportError";
        case: InternalJtasCreateOrUpdateViolationReportErrorCase;
      }
    | { __typename: "Success" };
};

export type InternalJtasDeleteViolationReportMutationVariables = Exact<{
  input: InternalJtasDeleteViolationReportInput;
}>;

export type InternalJtasDeleteViolationReportMutation = {
  __typename: "Mutation";
  internalJtasDeleteViolationReport:
    | {
        __typename: "InternalJtasDeleteViolationReportError";
        case: InternalJtasDeleteViolationReportErrorCase;
      }
    | { __typename: "Success" };
};

export type VerifyCheckInQrCodeWebhookMutationVariables = Exact<{
  input: VerifyCheckInQrCodeInput;
}>;

export type VerifyCheckInQrCodeWebhookMutation = {
  __typename: "Mutation";
  verifyCheckInQrCode:
    | {
        __typename: "VerifyCheckInQrCodeError";
        case: VerifyCheckInQrCodeErrorCase;
      }
    | {
        __typename: "VerifyCheckInQrCodeSuccess";
        accommodationReservationId: string;
      };
};

export type ProcessStripeWebhookEventMutationVariables = Exact<{
  payload: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
}>;

export type ProcessStripeWebhookEventMutation = {
  __typename: "Mutation";
  processStripeEvent: {
    __typename: "ProcessStripeEventResponse";
    status: number;
    body: string;
  };
};

export type ProcessTrustdockWebhookEventMutationVariables = Exact<{
  payload: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
}>;

export type ProcessTrustdockWebhookEventMutation = {
  __typename: "Mutation";
  processTrustdockEvent: {
    __typename: "ProcessTrustdockEventResponse";
    status: number;
    body: string;
  };
};

export type InternalApplyStaffAccessKeyMutationVariables = Exact<{
  keyType: AccessKeyType;
  accommodationId?: InputMaybe<Scalars["String"]["input"]>;
  siteId?: InputMaybe<Scalars["String"]["input"]>;
  triggerType: StaffAccessKeyTrigger;
}>;

export type InternalApplyStaffAccessKeyMutation = {
  __typename: "Mutation";
  internalApplyStaffAccessKey:
    | { __typename: "InternalApplyStaffAccessKeyError"; message: string }
    | { __typename: "Success" };
};

export type InternalApplyGuestAccessKeyMutationVariables = Exact<{
  reservationId: Scalars["String"]["input"];
  triggerType: GuestAccessKeyTrigger;
  bookingId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type InternalApplyGuestAccessKeyMutation = {
  __typename: "Mutation";
  internalApplyGuestAccessKey:
    | { __typename: "InternalApplyGuestAccessKeyError"; message: string }
    | { __typename: "Success" };
};

export type InternalReleaseAccessKeyMutationVariables = Exact<{
  accessPersonId: Scalars["String"]["input"];
  bookingId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type InternalReleaseAccessKeyMutation = {
  __typename: "Mutation";
  internalReleaseAccessKey:
    | { __typename: "InternalReleaseAccessKeyError"; message: string }
    | { __typename: "Success" };
};

export type Beds24CreateOrUpdateBookingMutationVariables = Exact<{
  reservationId: Scalars["String"]["input"];
}>;

export type Beds24CreateOrUpdateBookingMutation = {
  __typename: "Mutation";
  internalBeds24CreateOrUpdateBooking: boolean;
};

export type Beds24CreateOrUpdateBlackBookingMutationVariables = Exact<{
  blockId: Scalars["String"]["input"];
}>;

export type Beds24CreateOrUpdateBlackBookingMutation = {
  __typename: "Mutation";
  internalBeds24CreateOrUpdateBlackBooking: boolean;
};

export type Beds24CreateOrUpdateBlackBookingsMutationVariables = Exact<{
  blockIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type Beds24CreateOrUpdateBlackBookingsMutation = {
  __typename: "Mutation";
  internalBeds24CreateOrUpdateBlackBookings: boolean;
};

export type Beds24DeleteBlackBookingsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type Beds24DeleteBlackBookingsMutation = {
  __typename: "Mutation";
  internalBeds24DeleteBlackBookings: boolean;
};

export type Beds24SendBookingMessageMutationVariables = Exact<{
  reservationId: Scalars["String"]["input"];
  kind: Beds24BookingMessageKind;
}>;

export type Beds24SendBookingMessageMutation = {
  __typename: "Mutation";
  internalBeds24SendBookingMessage: {
    __typename: "Beds24BookingMessageResultPayload";
    result:
      | {
          __typename: "Beds24BookingMessageError";
          case: Beds24BookingMessageErrorCase;
        }
      | { __typename: "Success"; _: boolean };
  };
};

export type Beds24ProcessWebhookEventMutationVariables = Exact<{
  event: Beds24BookingEvent;
}>;

export type Beds24ProcessWebhookEventMutation = {
  __typename: "Mutation";
  internalBeds24ProcessWebhookEvent: {
    __typename: "Beds24WebhookResultPayload";
    message?: string | null;
    result:
      | { __typename: "Beds24WebhookError"; errorCase: Beds24WebhookErrorCase }
      | {
          __typename: "Beds24WebhookSuccess";
          successCase: Beds24WebhookSuccessCase;
        };
    reservation?: {
      __typename: "AccommodationReservation";
      id: string;
      reservedFrom: ZonedDateTimeString;
      reservedTo: ZonedDateTimeString;
      accommodation: { __typename: "Accommodation"; name: string };
      fee: { __typename: "AccommodationFee"; totalAmount: number };
    } | null;
    changes?: Array<{
      __typename: "AccommodationReservationChange";
      type: string;
      from: string;
      to: string;
    }> | null;
    bookingDetail?: {
      __typename: "Beds24BookingDetail";
      isGroupBooking: boolean;
      masterBookingId?: number | null;
      fee: {
        __typename: "Beds24BookingFee";
        totalAmount?: number | null;
        totalUnpaidAmount?: number | null;
        perRoomAmount: number;
      };
    } | null;
  };
};

export type Beds24SyncFollowingReservationsMutationVariables = Exact<{
  leadingReservationId: Scalars["String"]["input"];
}>;

export type Beds24SyncFollowingReservationsMutation = {
  __typename: "Mutation";
  internalBeds24SyncFollowingReservations: Array<
    | {
        __typename: "CancelAccommodationReservationError";
        cancelErrorCase: CancelAccommodationReservationErrorCase;
      }
    | {
        __typename: "ChangeAccommodationReservationError";
        changeErrorCase: ChangeAccommodationReservationErrorCase;
      }
  >;
};

export type Beds24SendGuestMessageAutoReplysMutationVariables = Exact<{
  bookingId: Scalars["Int"]["input"];
}>;

export type Beds24SendGuestMessageAutoReplysMutation = {
  __typename: "Mutation";
  internalBeds24SendGuestMessageAutoReply: boolean;
};

export type HubSpotSyncContactMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type HubSpotSyncContactMutation = {
  __typename: "Mutation";
  internalHubSpotSyncContact:
    | {
        __typename: "HubSpotSyncContactError";
        case: HubSpotSyncContactErrorCase;
      }
    | { __typename: "Success"; _: boolean };
};

export type HubSpotSyncDealMutationVariables = Exact<{
  coOwnersApplicationId: Scalars["String"]["input"];
}>;

export type HubSpotSyncDealMutation = {
  __typename: "Mutation";
  internalHubSpotSyncDeal:
    | { __typename: "HubSpotSyncDealError"; case: HubSpotSyncDealErrorCase }
    | { __typename: "Success"; _: boolean };
};

export type IpBeds24SetupStepMutationVariables = Exact<{
  state: Scalars["String"]["input"];
}>;

export type IpBeds24SetupStepMutation = {
  __typename: "Mutation";
  internalIpBeds24SetupStep: boolean;
};

export type InternalJtasInspectionQueryVariables = Exact<{
  accommodationId: Scalars["ID"]["input"];
  inspectionDate: Scalars["PlainDate"]["input"];
  reservationId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type InternalJtasInspectionQuery = {
  __typename: "Query";
  internalJtasInspections: Array<{
    __typename: "Inspection";
    status: InspectionStatusType;
    accommodation: {
      __typename: "Accommodation";
      id: string;
      code: string;
      facilityTypes: Array<AccommodationFacilityType>;
      site: { __typename: "Site"; id: string; name: string };
      accessKey?: {
        __typename: "AccommodationAccessKey";
        pin: string;
        isSynced: boolean;
        startsAt?: ZonedDateTimeString | null;
        endsAt?: ZonedDateTimeString | null;
      } | null;
    };
    reservation?: {
      __typename: "AccommodationReservation";
      id: string;
      firstNight: PlainDateString;
      lastNight: PlainDateString;
      reservedFrom: ZonedDateTimeString;
      reservedTo: ZonedDateTimeString;
      stayStatus: AccommodationReservationStayStatus;
      earlyCheckInEligible: boolean;
      user?: { __typename: "User"; name: string } | null;
      otaDetail?: {
        __typename: "AccommodationReservationOtaDetail";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      detail: {
        __typename: "AccommodationReservationDetail";
        numberOfAdults: number;
        numberOfKids: number;
        numberOfInfants: number;
        numberOfDogs: number;
      };
      provider:
        | { __typename: "BusinessPlanAccommodationReservationProvider" }
        | { __typename: "CoOwnersPlanAccommodationReservationProvider" }
        | { __typename: "FullOwnerPlanAccommodationReservationProvider" }
        | { __typename: "OneMoreCabinAccommodationReservationProvider" }
        | { __typename: "OnlineTravelAgentAccommodationReservationProvider" }
        | { __typename: "SanuIncAccommodationReservationProvider" }
        | { __typename: "StaffPlanAccommodationReservationProvider" }
        | { __typename: "StandardPlanAccommodationReservationProvider" }
        | { __typename: "StayDirectAccommodationReservationProvider" }
        | { __typename: "StayTicketAccommodationReservationProvider" }
        | { __typename: "TrialPlanAccommodationReservationProvider" };
    } | null;
  }>;
};

export type SendCoOwnersIdentityVerificationRequestMutationVariables = Exact<{
  coOwnersApplicationId: Scalars["String"]["input"];
}>;

export type SendCoOwnersIdentityVerificationRequestMutation = {
  __typename: "Mutation";
  internalSendCoOwnersIdentityVerificationRequest: {
    __typename: "Success";
    _: boolean;
  };
};

export type ZendeskSyncUserMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  updateEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ZendeskSyncUserMutation = {
  __typename: "Mutation";
  internalZendeskSyncUser:
    | { __typename: "Success"; _: boolean }
    | { __typename: "ZendeskSyncUserError"; case: ZendeskSyncUserErrorCase };
};

export type LayoutGtmUserIdQueryVariables = Exact<{ [key: string]: never }>;

export type LayoutGtmUserIdQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
};

export type UrlFromCodeQueryVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type UrlFromCodeQuery = {
  __typename: "Query";
  urlFromCode?: string | null;
};

export type SitemapAreasAndSitesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SitemapAreasAndSitesQuery = {
  __typename: "Query";
  areas: Array<{
    __typename: "Area";
    slug: string;
    sites: Array<{ __typename: "Site"; slug: string }>;
  }>;
};

export type TestLocaleLinkQueryVariables = Exact<{ [key: string]: never }>;

export type TestLocaleLinkQuery = { __typename: "Query" };

export type GtmUserIdQueryVariables = Exact<{ [key: string]: never }>;

export type GtmUserIdQuery = {
  __typename: "Query";
  maybeViewer?: { __typename: "User"; id: string } | null;
};

export type IntercomJwtQueryVariables = Exact<{ [key: string]: never }>;

export type IntercomJwtQuery = {
  __typename: "Query";
  viewer: { __typename: "User"; intercomJwt?: string | null };
};

export type InternalSessionGateQueryVariables = Exact<{ [key: string]: never }>;

export type InternalSessionGateQuery = {
  __typename: "Query";
  viewer: {
    __typename: "User";
    adminRoleAssignments: Array<{
      __typename: "AdminRoleAssignment";
      role: AdminRole;
      site?: { __typename: "Site"; id: string } | null;
    }>;
  };
};

export const ReservationWaivers_ConsumedSuppliesFeeItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationWaivers_ConsumedSuppliesFeeItem",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsumedSuppliesFeeItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "reportedQuantity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationWaivers_ConsumedSuppliesFeeItemFragment,
  unknown
>;
export const AccommodationFacilityHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationFacilityHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationFacility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationFacilityHeaderFragment, unknown>;
export const AccommodationNoticesTable_AccommodationNoticeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "AccommodationNoticesTable_AccommodationNotice",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationNotice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          { kind: "Field", name: { kind: "Name", value: "detail" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToExpectedUsers" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastUpdatedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationNoticesTable_AccommodationNoticeFragment,
  unknown
>;
export const AccommodationEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockDeviceId" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationEditSheetFragment, unknown>;
export const AccommodationBasicInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockDeviceId" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockDeviceId" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationBasicInfoFragment, unknown>;
export const AccommodationContentEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "manualUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationContentEditSheetFragment, unknown>;
export const AccommodationContentTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "manualUrl" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationContentEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "manualUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationContentTabFragment, unknown>;
export const AccommodationHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationHeaderFragment, unknown>;
export const ActivityProgramSheet_SiteActivityProgramFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityProgramSheet_SiteActivityProgram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedTitle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "publishStartAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishEndAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivityProgramSheet_SiteActivityProgramFragment,
  unknown
>;
export const AdminRoleAssignmentsTable_AdminRoleAssignmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "AdminRoleAssignmentsTable_AdminRoleAssignment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AdminRoleAssignment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "grantedAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "grantedByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "revokedByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRoleAssignmentsTable_AdminRoleAssignmentFragment,
  unknown
>;
export const ArchitectureTypeEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "additionalFee" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchitectureTypeEditSheetFragment, unknown>;
export const ArchitectureTypeBasicInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "seriesName" } },
          { kind: "Field", name: { kind: "Name", value: "seriesShortName" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "additionalFee" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ArchitectureTypeEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "additionalFee" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchitectureTypeBasicInfoFragment, unknown>;
export const ArchitectureTypeContentTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customEmailCoverImageUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "capacityDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sizeDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "sizeSqm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectComment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architect" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "equipmentsListUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amenitiesInstructionsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thumbnailImageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrls" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "basicAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "floorPlanImageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchitectureTypeContentTabFragment, unknown>;
export const ArchitectureTypeHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchitectureTypeHeaderFragment, unknown>;
export const ArchitectureTypeVariantCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeVariantCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "caption" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageConditionsDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchitectureTypeVariantCardFragment, unknown>;
export const ArchitectureTypeVariantsTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeVariantsTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "variations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ArchitectureTypeVariantCard",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ArchitectureTypeVariantCard",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeVariantCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "caption" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageConditionsDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchitectureTypeVariantsTabFragment, unknown>;
export const AreaEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaEditSheetFragment, unknown>;
export const AreaBasicInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
                { kind: "Field", name: { kind: "Name", value: "openingDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "reservable" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "reservableForOwnerEarlyAccess",
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AreaEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaBasicInfoFragment, unknown>;
export const AreaContentEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaContentEditSheetFragment, unknown>;
export const AreaContentTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AreaContentEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaContentTabFragment, unknown>;
export const AreaHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaHeaderFragment, unknown>;
export const BusinessPlansTable_BusinessPlanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BusinessPlansTable_BusinessPlan" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BusinessPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "feePerNum" } },
          { kind: "Field", name: { kind: "Name", value: "feePerNights" } },
          { kind: "Field", name: { kind: "Name", value: "isPeakDayFeeFree" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BusinessPlansTable_BusinessPlanFragment, unknown>;
export const CoOwnersApplicationComment_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationComment_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationComment_CoOwnersApplicationFragment,
  unknown
>;
export const CoOwnersApplicationHeader_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationHeader_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationHeader_CoOwnersApplicationFragment,
  unknown
>;
export const CoOwnersApplicationOverview_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationOverview_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationFacilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "s2oPoint" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationOverview_CoOwnersApplicationFragment,
  unknown
>;
export const CoOwnersApplicantInfo_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicantInfo_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isPep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "purchasePurpose" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "purchasePurposeFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailIndividual",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "householdIncome" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "personalFinancialAssets",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "employerName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "intendedUsage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "useLoan" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailOrganization",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "organizationAddress",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line2" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "representativeName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "businessActivity" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "businessActivityFree",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "organizationRelationship",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "registryCertificateDocuments",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerRelationship",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerRelationshipFree",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerName",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerBirthDate",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerAddress",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line2" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerOthers",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicantInfo_CoOwnersApplicationFragment,
  unknown
>;
export const CoOwnersApplicationFileRow_CoOwnersApplicationFileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationFileRow_CoOwnersApplicationFile",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplicationFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fileName" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "visibleToApplicant" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "isAdmin" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationFileRow_CoOwnersApplicationFileFragment,
  unknown
>;
export const IdentityVerificationItem_IdentityVerificationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "IdentityVerificationItem_IdentityVerification",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentityVerification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "result" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustdockVerificationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustdockOperationPageUrl" },
          },
          { kind: "Field", name: { kind: "Name", value: "submissionPageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "submissionPageUrlExpiresAt" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IdentityVerificationItem_IdentityVerificationFragment,
  unknown
>;
export const CoOwnersApplicationIdentityVerification_CoOwnersApplicationFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "CoOwnersApplicationIdentityVerification_CoOwnersApplication",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "CoOwnersApplication" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "identityVerifications" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  {
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "IdentityVerificationItem_IdentityVerification",
                    },
                  },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "applicantInfo" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "identificationDocumentType" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "identificationDocument1" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "rawUrl" },
                        },
                        { kind: "Field", name: { kind: "Name", value: "url" } },
                      ],
                    },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "identificationDocument2" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "rawUrl" },
                        },
                        { kind: "Field", name: { kind: "Name", value: "url" } },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "IdentityVerificationItem_IdentityVerification",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "IdentityVerification" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "method" } },
            { kind: "Field", name: { kind: "Name", value: "status" } },
            { kind: "Field", name: { kind: "Name", value: "result" } },
            { kind: "Field", name: { kind: "Name", value: "note" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "trustdockVerificationId" },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "trustdockOperationPageUrl" },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "submissionPageUrl" },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "submissionPageUrlExpiresAt" },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    CoOwnersApplicationIdentityVerification_CoOwnersApplicationFragment,
    unknown
  >;
export const CoOwnersApplicationManagement_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationManagement_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestedOtherWebinarSchedule" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "disclosureAssitant" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "otherFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "caption" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationManagement_CoOwnersApplicationFragment,
  unknown
>;
export const CoOwnersApplicationPayment_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationPayment_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "registrationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingAmountPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "friendReferralDiscountAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "employeeReferralDiscountAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalPurchaseDiscountAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalPurchaseDiscountNote" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "otherDiscountAmount" },
          },
          { kind: "Field", name: { kind: "Name", value: "otherDiscountNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "s2oPoint" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "s2o" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balance" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationPayment_CoOwnersApplicationFragment,
  unknown
>;
export const ApplicationSummaryList_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ApplicationSummaryList_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationSummaryList_CoOwnersApplicationFragment,
  unknown
>;
export const StayCreditOverrideSheet_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayCreditOverrideSheet_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ApplicationSummaryList_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayCreditOverrideSheet_CoOwnersApplicationFragment,
  unknown
>;
export const CancelApplicationDialog_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CancelApplicationDialog_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ApplicationSummaryList_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelApplicationDialog_CoOwnersApplicationFragment,
  unknown
>;
export const StatusActionButtons_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusActionButtons_CoOwnersApplication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "StayCreditOverrideSheet_CoOwnersApplication",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "CancelApplicationDialog_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ApplicationSummaryList_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayCreditOverrideSheet_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CancelApplicationDialog_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusActionButtons_CoOwnersApplicationFragment,
  unknown
>;
export const CoOwnersApplicationStatusTab_CoOwnersApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationStatusTab_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitSales" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saleYearMonth" },
                },
                { kind: "Field", name: { kind: "Name", value: "soldAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "StatusActionButtons_CoOwnersApplication",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                { kind: "Field", name: { kind: "Name", value: "reviewedAt" } },
                { kind: "Field", name: { kind: "Name", value: "completedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitedToDisclosureAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participatedInDisclosureAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractSignedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advancePaymentReceivedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentReceivedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverCompletedAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ApplicationSummaryList_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayCreditOverrideSheet_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CancelApplicationDialog_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusActionButtons_CoOwnersApplication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "StayCreditOverrideSheet_CoOwnersApplication",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "CancelApplicationDialog_CoOwnersApplication",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationStatusTab_CoOwnersApplicationFragment,
  unknown
>;
export const EquipmentDetailSheet_AccommodationEquipmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "EquipmentDetailSheet_AccommodationEquipment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationEquipment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sanuEdgeDevices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WifiEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "primary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "secondary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "MusicConnectEquipmentAttribute",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruction" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SaunaEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EquipmentDetailSheet_AccommodationEquipmentFragment,
  unknown
>;
export const EditFacilitySheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EditFacilitySheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "isVisibleEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isCleaningReportEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "isDataSyncEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "termsUrl" } },
          { kind: "Field", name: { kind: "Name", value: "termsLabel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "baseFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitFeeAmount" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeModifierType" },
                },
                { kind: "Field", name: { kind: "Name", value: "feeValue" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                { kind: "Field", name: { kind: "Name", value: "startMinute" } },
                { kind: "Field", name: { kind: "Name", value: "endHour" } },
                { kind: "Field", name: { kind: "Name", value: "endMinute" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditFacilitySheetFragment, unknown>;
export const FacilityReservationUsageSection_FacilityReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationUsageSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FacilityReservationUsageSection_FacilityReservationFragment,
  unknown
>;
export const FacilityReservationControllerAttributeSection_FacilityReservationFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value:
            "FacilityReservationControllerAttributeSection_FacilityReservation",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "FacilityReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: { kind: "Name", value: "controllers" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "type" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "controllerAttribute" },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    FacilityReservationControllerAttributeSection_FacilityReservationFragment,
    unknown
  >;
export const FacilityReservationDetailSheet_FacilityReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationDetailSheet_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "totalFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "discountAmount" } },
          { kind: "Field", name: { kind: "Name", value: "chargedFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "discountReason" } },
          { kind: "Field", name: { kind: "Name", value: "termsAgreedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facility" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isDataSyncEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataSync" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customFieldValues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FacilityReservationUsageSection_FacilityReservation",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value:
                "FacilityReservationControllerAttributeSection_FacilityReservation",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationUsageSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value:
          "FacilityReservationControllerAttributeSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FacilityReservationDetailSheet_FacilityReservationFragment,
  unknown
>;
export const NewsTable_RawNewsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NewsTable_RawNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RawNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "displayCategory" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "targetPlans" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsTable_RawNewsFragment, unknown>;
export const OrganizationContractsListTable_OrganizationYearlyContractFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OrganizationContractsListTable_OrganizationYearlyContract",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "OrganizationYearlyContract" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "status" } },
            { kind: "Field", name: { kind: "Name", value: "startMonth" } },
            { kind: "Field", name: { kind: "Name", value: "endMonth" } },
            { kind: "Field", name: { kind: "Name", value: "amountRecord" } },
            { kind: "Field", name: { kind: "Name", value: "totalFee" } },
            { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
            { kind: "Field", name: { kind: "Name", value: "nightsPerMonth" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "continuationType" },
            },
            { kind: "Field", name: { kind: "Name", value: "createdAt" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "createdInvoiceCount" },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "organization" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "defaultFrequency" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "defaultPaymentMethod" },
                  },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "businessPlan" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OrganizationContractsListTable_OrganizationYearlyContractFragment,
    unknown
  >;
export const OrganizationInvoicesListTable_StripeInvoiceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationInvoicesListTable_StripeInvoice",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StripeInvoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "collection_method" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadata_list" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationInvoicesListTable_StripeInvoiceFragment,
  unknown
>;
export const OrganizationContractsTable_OrganizationYearlyContractFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OrganizationContractsTable_OrganizationYearlyContract",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "OrganizationYearlyContract" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "status" } },
            { kind: "Field", name: { kind: "Name", value: "startMonth" } },
            { kind: "Field", name: { kind: "Name", value: "endMonth" } },
            { kind: "Field", name: { kind: "Name", value: "amountRecord" } },
            { kind: "Field", name: { kind: "Name", value: "totalFee" } },
            { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
            { kind: "Field", name: { kind: "Name", value: "nightsPerMonth" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "continuationType" },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "businessPlan" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OrganizationContractsTable_OrganizationYearlyContractFragment,
    unknown
  >;
export const OrganizationInvoicesTable_StripeInvoiceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationInvoicesTable_StripeInvoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StripeInvoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hosted_invoice_url" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "collection_method" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadata_list" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationInvoicesTable_StripeInvoiceFragment,
  unknown
>;
export const OrganizationMembersTable_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationMembersTable_User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationStatus" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationMembersTable_UserFragment, unknown>;
export const OrganizationInfo_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationInfo_Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailDomainsForMember" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "control" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerStay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMember" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMonth" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "billingEmail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "announcementContent" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethodCardEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultFrequency" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "memberCustomField" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationInfo_OrganizationFragment, unknown>;
export const OrganizationStatus_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationStatus_Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "suspended" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "membersStay" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usedNightsInCurrentContract" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentOrUpcomingContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "startMonth" } },
                { kind: "Field", name: { kind: "Name", value: "endMonth" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationStatus_OrganizationFragment, unknown>;
export const OrganizationReservationsTable_AccommodationReservationFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OrganizationReservationsTable_AccommodationReservation",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "firstNight" } },
            { kind: "Field", name: { kind: "Name", value: "lastDate" } },
            { kind: "Field", name: { kind: "Name", value: "nights" } },
            { kind: "Field", name: { kind: "Name", value: "isTentative" } },
            { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
            { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "user" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "code" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "site" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        { kind: "Field", name: { kind: "Name", value: "id" } },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "name" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OrganizationReservationsTable_AccommodationReservationFragment,
    unknown
  >;
export const OrganizationFormSheet_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationFormSheet_Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          { kind: "Field", name: { kind: "Name", value: "billingEmail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailDomainsForMember" },
          },
          { kind: "Field", name: { kind: "Name", value: "suspended" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethodCardEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultFrequency" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "announcementContent" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "control" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerStay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMember" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMonth" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "memberCustomField" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationFormSheet_OrganizationFragment,
  unknown
>;
export const ReservationBasicInfo_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationBasicInfo_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketMasterId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "otaDetail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "referer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apiReference" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "nights" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "tentativeDeadline" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consumedSuppliesFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationBasicInfo_AccommodationReservationFragment,
  unknown
>;
export const CompanionDetailSheet_UserCompanionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanionDetailSheet_UserCompanion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserCompanion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "professionType" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "passportNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "passportPhoto" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddressInJapan" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "japanLine2" },
                        name: { kind: "Name", value: "line2" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddressInternational" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "intlLine2" },
                        name: { kind: "Name", value: "line2" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateProvince" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanionDetailSheet_UserCompanionFragment,
  unknown
>;
export const ReservationCompanionsTab_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationCompanionsTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "nameKana" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userCompanions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CompanionDetailSheet_UserCompanion",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanionDetailSheet_UserCompanion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserCompanion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "professionType" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "passportNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "passportPhoto" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddressInJapan" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "japanLine2" },
                        name: { kind: "Name", value: "line2" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddressInternational" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "intlLine2" },
                        name: { kind: "Name", value: "line2" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateProvince" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationCompanionsTab_AccommodationReservationFragment,
  unknown
>;
export const ReservationDetailHeader_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationDetailHeader_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "code" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripeInvoiceId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationDetailHeader_AccommodationReservationFragment,
  unknown
>;
export const ReservationReviewTab_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationReviewTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memorableExperiences" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureAndNatureRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cleaningRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "equipmentRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guidanceAndSupportRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "concerns" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewResponse" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionnaire" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAtCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAtCheckOutAnswer" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAfterCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAfterCheckOutAnswer" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationReviewTab_AccommodationReservationFragment,
  unknown
>;
export const ReservationStaffGroup_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationStaffGroup_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SanuIncAccommodationReservationProvider",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "usage" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "staffGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationStaffGroup_AccommodationReservationFragment,
  unknown
>;
export const ReservationStayStatusTab_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationStayStatusTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "accessCode" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkedInGeoLocation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInQrCode" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationStayStatusTab_AccommodationReservationFragment,
  unknown
>;
export const ReservationTicketsTab_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationTicketsTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "tentativeDeadline" } },
          { kind: "Field", name: { kind: "Name", value: "invitationUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStartNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayEndNight" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationTicketsTab_AccommodationReservationFragment,
  unknown
>;
export const SiteEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "openingDate" } },
          { kind: "Field", name: { kind: "Name", value: "publicOpeningDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInAuthenticationType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customReservationLeadMonths" },
          },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "switchbotLocationApiKey" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockLocationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteEditSheetFragment, unknown>;
export const SiteBasicInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "openingDate" } },
          { kind: "Field", name: { kind: "Name", value: "publicOpeningDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInAuthenticationType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customReservationLeadMonths" },
          },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "switchbotLocationApiKey" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockLocationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "openingDate" } },
          { kind: "Field", name: { kind: "Name", value: "publicOpeningDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInAuthenticationType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customReservationLeadMonths" },
          },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "switchbotLocationApiKey" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockLocationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteBasicInfoFragment, unknown>;
export const SiteContentEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsReviewUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addressForEdit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prefecture" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "city" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteContentEditSheetFragment, unknown>;
export const SiteContentTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seriesShortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsReviewUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteContentEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsReviewUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addressForEdit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prefecture" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "city" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteContentTabFragment, unknown>;
export const SiteHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteHeaderFragment, unknown>;
export const SiteOtaTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteOtaTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "beds24PropertyId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beds24RoomId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otaRoomUnits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facilityTypes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "seriesShortName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteOtaTabFragment, unknown>;
export const StaffGroupFormSheet_StaffGroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffGroupFormSheet_StaffGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "fullName" } },
          { kind: "Field", name: { kind: "Name", value: "smarthrId" } },
          { kind: "Field", name: { kind: "Name", value: "archivedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffGroupFormSheet_StaffGroupFragment, unknown>;
export const EditSupplyItemInstallationsSheet_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EditSupplyItemInstallationsSheet_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditSupplyItemInstallationsSheet_SiteFragment,
  unknown
>;
export const EditSupplyItemInstallationsSheet_SupplyItemInstallationFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "EditSupplyItemInstallationsSheet_SupplyItemInstallation",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "SupplyItemInstallation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "architectureType" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  { kind: "Field", name: { kind: "Name", value: "code" } },
                ],
              },
            },
            { kind: "Field", name: { kind: "Name", value: "defaultQuantity" } },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    EditSupplyItemInstallationsSheet_SupplyItemInstallationFragment,
    unknown
  >;
export const EditSupplyItemSheet_SupplyItemMasterFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EditSupplyItemSheet_SupplyItemMaster" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupplyItemMaster" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "namePublic" } },
          { kind: "Field", name: { kind: "Name", value: "namePrivate" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "taxRateType" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditSupplyItemSheet_SupplyItemMasterFragment,
  unknown
>;
export const TermsDetail_TermsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsDetail_Terms" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Terms" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "plan" } },
          { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "revisions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "revisedDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetOwnerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalSummary" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TermsDetail_TermsFragment, unknown>;
export const ContractDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingCycleDay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationCycle" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDay" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "appliedAt" } },
                { kind: "Field", name: { kind: "Name", value: "enrolledAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrollmentScheduledAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminationScheduledAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pauseScheduledAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "pausedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resumeScheduledAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "resumedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accumulatedS2oAmount" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trialContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "appliedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolledDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentPeriodStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstSemesterStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "secondSemesterStayCredits" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "staffType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReservable" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentSemesterStayCredits" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "currentSemesterGrantedStayCredits",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customFieldValue" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationNewStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNightsPerStay" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "latestYearlyReservationStatuses",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remainingNights" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxNights" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxPeakDaysPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPaymentDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "holderName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentYearStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingPeakDays" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPaymentDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "holderName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentYearStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractDetailFragment, unknown>;
export const ContractListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trialContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractListFragment, unknown>;
export const ReservationWaivers_ConsumedSupplyFeeItemWaiverFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsumedSupplyFeeItemWaiver" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supplyItemMasterCategory" },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationWaivers_ConsumedSupplyFeeItemWaiverFragment,
  unknown
>;
export const ReservationDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allAccommodationReservations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkedOutAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "accessCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "date" },
                            value: {
                              kind: "StringValue",
                              value: "今日の日付",
                              block: false,
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "faqs" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "question",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "answer",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userCompanions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gender" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "birthDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationNotices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "brief" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingMethod" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "consumedSupplyFeeItemWaivers",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "endAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargedFeeAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facility" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketMasterId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTickets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expiresAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayStartNight" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayEndNight" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otaDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "referer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apiReference" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsumedSupplyFeeItemWaiver" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supplyItemMasterCategory" },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationDetailFragment, unknown>;
export const ReservationListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allAccommodationReservations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationListFragment, unknown>;
export const UserEditSheetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameKana" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "nationality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "householdComposition" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "carOwnershipStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlPostalCode" },
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserEditSheetFragment, unknown>;
export const UserProfileTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProfileTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameKana" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facePhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "nationality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportPhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "householdComposition" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "carOwnershipStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UserEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameKana" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "nationality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "householdComposition" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "carOwnershipStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlPostalCode" },
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserProfileTabFragment, unknown>;
export const UserHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facePhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserHeaderFragment, unknown>;
export const UserOwnershipTab_UserOwnershipFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOwnershipTab_UserOwnership" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserOwnershipTab_UserOwnershipFragment, unknown>;
export const UserTableRowFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserTableRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facePhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserTableRowFragment, unknown>;
export const ViolationHandlingForm_InspectionViolationHandlingFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ViolationHandlingForm_InspectionViolationHandling",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InspectionViolationHandling" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "severityAssessedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "severityAssessedByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "warningActionNote" } },
          { kind: "Field", name: { kind: "Name", value: "warningActionAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warningActionByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViolationHandlingForm_InspectionViolationHandlingFragment,
  unknown
>;
export const ContentFacilityDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentFacilityDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentFacilityDetails" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityAmenities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageConditionsDescription" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentFacilityDetailsFragment, unknown>;
export const AccommodationsPerSiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsPerSite" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariantSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationsPerSiteFragment, unknown>;
export const ContentArchitectureTypeVariantFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentFacilityDetails" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationsPerSite" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentFacilityDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentFacilityDetails" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityAmenities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageConditionsDescription" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsPerSite" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariantSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentArchitectureTypeVariantFragment, unknown>;
export const ContentArchitecturePageNavigationItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentArchitecturePageNavigationItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitecturePageNavigationItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "path" } },
          { kind: "Field", name: { kind: "Name", value: "area" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subItems" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "path" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentArchitecturePageNavigationItemFragment,
  unknown
>;
export const ContentArchitectureTypeExperiencesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentArchitectureTypeExperiences" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "experiences" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContentArchitectureTypeExperiencesFragment,
  unknown
>;
export const AreaAbout_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaAbout_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaAbout_AreaFragment, unknown>;
export const DxActivityProgramSection_SiteActivityProgramFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DxActivityProgramSection_SiteActivityProgramFragment,
  unknown
>;
export const AreaActivityPrograms_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaActivityPrograms_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activityPrograms" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "DxActivityProgramSection_SiteActivityProgram",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaActivityPrograms_AreaFragment, unknown>;
export const AreaBases_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaBases_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaBases_AreaFragment, unknown>;
export const AreaGuideArticles_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaGuideArticles_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideArticles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaGuideArticles_AreaFragment, unknown>;
export const AreaHero_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHero_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaHero_AreaFragment, unknown>;
export const AreaJsonLd_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaJsonLd_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaJsonLd_AreaFragment, unknown>;
export const AreaSidebar_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaSidebar_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "seriesShortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "capacityDescription",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roomType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "features" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sort" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaSidebar_AreaFragment, unknown>;
export const AreaSpHeader_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaSpHeader_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaSpHeader_AreaFragment, unknown>;
export const AreaSpotsPreview_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaSpotsPreview_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaSpotsPreview_AreaFragment, unknown>;
export const AreaDetailPageMeta_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaDetailPageMeta_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaDetailPageMeta_AreaFragment, unknown>;
export const SiteAboutOverview_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutOverview_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteAboutOverview_SiteFragment, unknown>;
export const FacilityDetailModalFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityDetailModalFragmentFragment, unknown>;
export const SiteAboutFacilities_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutFacilities_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityDetailModalFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteAboutFacilities_SiteFragment, unknown>;
export const SiteAbout_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAbout_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteAboutOverview_Site" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteAboutFacilities_Site" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutOverview_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutFacilities_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityDetailModalFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteAbout_SiteFragment, unknown>;
export const SiteActivityPrograms_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteActivityPrograms_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activityPrograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "DxActivityProgramSection_SiteActivityProgram",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteActivityPrograms_SiteFragment, unknown>;
export const SiteHero_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteHero_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteHero_SiteFragment, unknown>;
export const SiteRoomTypes_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteRoomTypes_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roomTypesForReservation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "capacityDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sizeDescription" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteRoomTypes_SiteFragment, unknown>;
export const SiteDetailPageMeta_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteDetailPageMeta_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteDetailPageMeta_SiteFragment, unknown>;
export const RoomTypeAbout_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeAbout_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prefecture" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingCapacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingInfo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapImageUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "iconSlug" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeAbout_RoomTypeFragment, unknown>;
export const DxAccessSection_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxAccessSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessRouteGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transportIcon" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "points" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "legToNextDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DxAccessSection_SiteFragment, unknown>;
export const RoomTypeAccess_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeAccess_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxAccessSection_Site" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxAccessSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessRouteGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transportIcon" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "points" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "legToNextDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeAccess_RoomTypeFragment, unknown>;
export const RoomTypeActivityPrograms_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeActivityPrograms_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activityPrograms" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "DxActivityProgramSection_SiteActivityProgram",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomTypeActivityPrograms_RoomTypeFragment,
  unknown
>;
export const RoomTypeAmenities_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeAmenities_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeAmenities_RoomTypeFragment, unknown>;
export const RoomTypeHero_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeHero_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeHero_RoomTypeFragment, unknown>;
export const DxFaqSection_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxFaqSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DxFaqSection_SiteFragment, unknown>;
export const RoomTypeInformation_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeInformation_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxFaqSection_Site" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxFaqSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeInformation_RoomTypeFragment, unknown>;
export const RoomTypeJsonLd_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeJsonLd_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "capacity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeSqm" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeJsonLd_RoomTypeFragment, unknown>;
export const RoomTypeManual_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeManual_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "amenitiesInstructionsUrl",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeManual_RoomTypeFragment, unknown>;
export const RoomTypeServices_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeServices_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FacilityDetailModalFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeServices_RoomTypeFragment, unknown>;
export const SpotsBottomInfo_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsBottomInfo_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpotsBottomInfo_AreaFragment, unknown>;
export const SpotsJsonLd_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsJsonLd_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
  ],
} as unknown as DocumentNode<SpotsJsonLd_AreaFragment, unknown>;
export const SpotCard_AreaGuideSpotFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotCard_AreaGuideSpot" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AreaGuideSpot" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "categories" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "businessHours" } },
          { kind: "Field", name: { kind: "Name", value: "websiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "mapUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "images" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpotCard_AreaGuideSpotFragment, unknown>;
export const SpotsList_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsList_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SpotCard_AreaGuideSpot" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotCard_AreaGuideSpot" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AreaGuideSpot" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "categories" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "businessHours" } },
          { kind: "Field", name: { kind: "Name", value: "websiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "mapUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "images" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SpotsList_AreaFragment, unknown>;
export const SpotsPanelHeader_AreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsPanelHeader_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
  ],
} as unknown as DocumentNode<SpotsPanelHeader_AreaFragment, unknown>;
export const DxHotelJsonLd_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxHotelJsonLd_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DxHotelJsonLd_SiteFragment, unknown>;
export const OrganizationMemberTableFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationMemberTableFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationStatus" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationMemberTableFragmentFragment, unknown>;
export const OrganizationMemberExportFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationMemberExportFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customFieldValue" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationStatus" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationMemberExportFragmentFragment, unknown>;
export const OrganizationBillingEmailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationBillingEmail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "billingEmail" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationBillingEmailFragment, unknown>;
export const AccommodationReservationDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "review" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationReservationDetailFragment, unknown>;
export const OrganizationSettingsFormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationSettingsForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "control" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMonth" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerStay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMember" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailDomainsForMember" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "memberCustomField" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "announcementContent" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentOrUpcomingContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerMonth" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationSettingsFormFragment, unknown>;
export const CheckInQrCodeFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckInQrCodeFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckInQrCode" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckInQrCodeFieldsFragment, unknown>;
export const CoOwnersApplicationDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "unitNightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitPurchaseAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitApplicationFee" },
          },
          { kind: "Field", name: { kind: "Name", value: "registrationFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersMaxPeakDaysPerUnit" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "coOwnersMaxConcurrentReservationsPerUnit",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersPlanOfferings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "earlyAccessCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "estimate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoOwnersApplicationDetailsFragment, unknown>;
export const CoWorkingSpaceDoorLockFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoWorkingSpaceDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "keyUrl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoWorkingSpaceDoorLockFragmentFragment, unknown>;
export const OnsenAndSaunaDoorLockFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnsenAndSaunaDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnsenAndSaunaDoorLockFragmentFragment, unknown>;
export const EvChargerLockFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EvChargerLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EvChargerLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "expireAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EvChargerLockFragmentFragment, unknown>;
export const RentalCycleKeyBoxFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RentalCycleKeyBoxFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RentalCycleKeyBox" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inUseAt" } },
          { kind: "Field", name: { kind: "Name", value: "returnedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reservationId" } },
          { kind: "Field", name: { kind: "Name", value: "usableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "usableTo" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RentalCycleKeyBoxFragmentFragment, unknown>;
export const WashingMachineTrackerFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WashingMachineTrackerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WashingMachineTracker" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WashingMachineTrackerFragmentFragment, unknown>;
export const FacilityControllerFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityControllerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityController" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoWorkingSpaceDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnsenAndSaunaDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "EvChargerLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EvChargerLockFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RentalCycleKeyBox" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RentalCycleKeyBoxFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WashingMachineTracker" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WashingMachineTrackerFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoWorkingSpaceDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "keyUrl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnsenAndSaunaDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EvChargerLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EvChargerLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "expireAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RentalCycleKeyBoxFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RentalCycleKeyBox" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inUseAt" } },
          { kind: "Field", name: { kind: "Name", value: "returnedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reservationId" } },
          { kind: "Field", name: { kind: "Name", value: "usableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "usableTo" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WashingMachineTrackerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WashingMachineTracker" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityControllerFragmentFragment, unknown>;
export const FacilityReservationDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityReservationDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          { kind: "Field", name: { kind: "Name", value: "chargedFeeAmount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customFieldValues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isCancelable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "estimatedCancelFee" },
          },
          { kind: "Field", name: { kind: "Name", value: "resourceLabel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityControllerFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facility" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "facilityType" },
                        name: { kind: "Name", value: "type" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detailUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentUsage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentDetail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentNotice" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelRuleUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customFields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "required" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "options" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "placeholder" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoWorkingSpaceDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "keyUrl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnsenAndSaunaDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EvChargerLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EvChargerLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "expireAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RentalCycleKeyBoxFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RentalCycleKeyBox" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inUseAt" } },
          { kind: "Field", name: { kind: "Name", value: "returnedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reservationId" } },
          { kind: "Field", name: { kind: "Name", value: "usableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "usableTo" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WashingMachineTrackerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WashingMachineTracker" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityControllerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityController" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoWorkingSpaceDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnsenAndSaunaDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "EvChargerLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EvChargerLockFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RentalCycleKeyBox" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RentalCycleKeyBoxFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WashingMachineTracker" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WashingMachineTrackerFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityReservationDetailFragment, unknown>;
export const FacilityItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "facilityType" },
            name: { kind: "Name", value: "type" },
          },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "isReservable" } },
          { kind: "Field", name: { kind: "Name", value: "isUsable" } },
          { kind: "Field", name: { kind: "Name", value: "isReserved" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityItemFragment, unknown>;
export const AccommodationFacilityListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationFacilityList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "facilityType" },
            name: { kind: "Name", value: "type" },
          },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "isReservable" } },
          { kind: "Field", name: { kind: "Name", value: "isUsable" } },
          { kind: "Field", name: { kind: "Name", value: "isReserved" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationFacilityListFragment, unknown>;
export const TentativeAccommodationReservationErrorCaseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "TentativeAccommodationReservationErrorCase",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TentativeAccommodationReservationError" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "case" } }],
      },
    },
  ],
} as unknown as DocumentNode<
  TentativeAccommodationReservationErrorCaseFragment,
  unknown
>;
export const CoOwnersApplicationFilesAreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationFilesArea" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoOwnersApplicationFilesAreaFragment, unknown>;
export const CoOwnersOwnerInfoFormDefaultValuesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverStartDate" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailIndividual",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "useLoan" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailOrganization",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "representativeName",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersOwnerInfoFormDefaultValuesFragment,
  unknown
>;
export const CoOwnersApplicationFormDialogFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationFormDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverStartDate" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailIndividual",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "useLoan" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailOrganization",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "representativeName",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoOwnersApplicationFormDialogFragment, unknown>;
export const CoOwnersApplicationWebinarSelectorFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationWebinarSelector" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationWebinarSelectorFragment,
  unknown
>;
export const CoOwnersApplicationProgressAreaFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationProgressArea" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasCoOwnersApplicationRequiredFieldsFilled",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestedOtherWebinarSchedule" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersApplicationFormDialog" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersApplicationWebinarSelector" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverStartDate" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailIndividual",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "useLoan" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailOrganization",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "representativeName",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationFormDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationWebinarSelector" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoOwnersApplicationProgressAreaFragment, unknown>;
export const PastStayRowFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PastStayRowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nights" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PastStayRowFragmentFragment, unknown>;
export const OwnerPlanNameFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerPlanNameFragment, unknown>;
export const CoOwnersPlanDetail_UserOwnershipFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersPlanDetail_UserOwnership" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
                { kind: "Field", name: { kind: "Name", value: "siteSizeSqm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "leasedLandSizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestRoomSizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balconySizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeePerNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heldAccommodationClass" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualMaintenanceFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualRepairReserve" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualLandRentFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formOfRights" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maxPeakDaysPerYear" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "maxSiteHighSeasonDaysPerYear" },
          },
          { kind: "Field", name: { kind: "Name", value: "holderName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoOwnersPlanDetail_UserOwnershipFragment, unknown>;
export const FullOwnerPlanDetail_UserOwnershipFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullOwnerPlanDetail_UserOwnership" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeePerNight" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "nonOwnedBaseAccommodationFeePerNight",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heldAccommodationClass" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FullOwnerPlanDetail_UserOwnershipFragment,
  unknown
>;
export const TrialContractOnPlanSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrialContractOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TrialContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterGrantedStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterGrantedStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accumulatedS2oAmount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrialContractOnPlanSectionFragmentFragment,
  unknown
>;
export const StaffContractOnPlanSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffContractOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusDetail" } },
          { kind: "Field", name: { kind: "Name", value: "staffType" } },
          { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
          { kind: "Field", name: { kind: "Name", value: "terminatedDate" } },
          { kind: "Field", name: { kind: "Name", value: "isReservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentSemesterGrantedStayCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "semesterCredits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "semester" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grantedStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingPeakDays" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffContractOnPlanSectionFragmentFragment,
  unknown
>;
export const CoOwnershipOnPlanSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnershipOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoOwnershipOnPlanSectionFragmentFragment, unknown>;
export const CoOwnersApplicationSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationSectionFragmentFragment,
  unknown
>;
export const FullOwnershipOnPlanSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullOwnershipOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
          { kind: "Field", name: { kind: "Name", value: "usageEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "nextPaymentDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FullOwnershipOnPlanSectionFragmentFragment,
  unknown
>;
export const SubscriptionOnPlanSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserSubscription" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusDetail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enrollmentScheduledAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "enrolledAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "terminationScheduledAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "terminatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "pauseScheduledAt" } },
          { kind: "Field", name: { kind: "Name", value: "pausedAt" } },
          { kind: "Field", name: { kind: "Name", value: "resumeScheduledAt" } },
          { kind: "Field", name: { kind: "Name", value: "resumedAt" } },
          { kind: "Field", name: { kind: "Name", value: "pausableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "terminatableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "billingCycleDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationCycle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accumulatedS2oAmount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscriptionOnPlanSectionFragmentFragment,
  unknown
>;
export const OrganizationMembershipOnPlanSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationMembershipOnPlanSectionFragment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrganizationMembership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationNewStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "latestYearlyReservationStatuses",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endYearMonth" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationMembershipOnPlanSectionFragmentFragment,
  unknown
>;
export const TopPageBannerContentsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopPageBannerContents" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TopPage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bannerContents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopPageBannerContentsFragment, unknown>;
export const HouseRulesDialogFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HouseRulesDialogFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "systemSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasSeenHouseRules" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HouseRulesDialogFragmentFragment, unknown>;
export const TermsAgreementModal_TermsRevisionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsAgreementModal_TermsRevision" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermsRevision" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "terms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TermsAgreementModal_TermsRevisionFragment,
  unknown
>;
export const TermsAgreementSection_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsAgreementSection_User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredTermsAgreements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "plan" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "TermsAgreementModal_TermsRevision",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsAgreementModal_TermsRevision" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermsRevision" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "terms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TermsAgreementSection_UserFragment, unknown>;
export const TopPageUpdatesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopPageUpdates" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TopPage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceUpdate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "isNew" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveArticle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "isNew" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "contentType" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopPageUpdatesFragment, unknown>;
export const ReservationUnavailableMessageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationUnavailableMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trialContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationNewStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasUnpaidAccommodationFee" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationUnavailableMessageFragment, unknown>;
export const ReservationOwnershipSelectTabFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationOwnershipSelectTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OwnerPlanName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OwnerPlanName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationOwnershipSelectTabFragment, unknown>;
export const ReservationProviderSelectFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationProviderSelect" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accessibleReservationCalendars" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationProviderSelectFragment, unknown>;
export const AccommodationReservationInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationReservationInfoFragment, unknown>;
export const OneMoreCabinAccommodationReservationCancelConfirmationFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OneMoreCabinAccommodationReservationCancelConfirmation",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "architectureType" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "name" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            { kind: "Field", name: { kind: "Name", value: "firstDate" } },
            { kind: "Field", name: { kind: "Name", value: "lastDate" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "detail" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfAdults" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfTotalChildren" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "previousLocation" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "nextLocation" },
                  },
                ],
              },
            },
            {
              kind: "FragmentSpread",
              name: { kind: "Name", value: "AccommodationReservationInfo" },
            },
          ],
        },
      },
      {
        kind: "FragmentDefinition",
        name: { kind: "Name", value: "AccommodationReservationInfo" },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "provider" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "__typename" },
                  },
                ],
              },
            },
            { kind: "Field", name: { kind: "Name", value: "firstDate" } },
            { kind: "Field", name: { kind: "Name", value: "lastDate" } },
            { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "name" } },
                  { kind: "Field", name: { kind: "Name", value: "code" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "site" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "name" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "slug" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "area" },
                          selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                              {
                                kind: "Field",
                                name: { kind: "Name", value: "slug" },
                              },
                            ],
                          },
                        },
                      ],
                    },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "architectureType" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "name" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "series" },
                        },
                      ],
                    },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "facilityTypes" },
                  },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "detail" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "useEvCharger" },
                  },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "stayTicketUnit" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "reservationInfo" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "name" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OneMoreCabinAccommodationReservationCancelConfirmationFragment,
    unknown
  >;
export const OneMoreCabinAccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OneMoreCabinAccommodationReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "taxRate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "tentativeDeadline" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          { kind: "Field", name: { kind: "Name", value: "invitationUrl" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OneMoreCabinAccommodationReservationCancelConfirmation",
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationReservationInfo" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OneMoreCabinAccommodationReservationCancelConfirmation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTotalChildren" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationReservationInfo" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OneMoreCabinAccommodationReservationFragment,
  unknown
>;
export const OwnershipForStayGiftFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnershipForStayGiftFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnershipForStayGiftFragmentFragment, unknown>;
export const StayTicketTableFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketTableFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StayTicketTableFragmentFragment, unknown>;
export const StayTicketValidationResultFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketValidationResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketValidationResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "stayTicketCode" } },
          { kind: "Field", name: { kind: "Name", value: "validationError" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StayTicketValidationResultFragment, unknown>;
export const TicketReservationConditionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TicketReservationConditions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketReservationConditionsFragment, unknown>;
export const StayTicketUnitForTicketReservationFormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForTicketReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketMasterId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "notice" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableSites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableArchitectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNoticeTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeeStartsAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayStartNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
          { kind: "Field", name: { kind: "Name", value: "stayEndNight" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TicketReservationConditions" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TicketReservationConditions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayTicketUnitForTicketReservationFormFragment,
  unknown
>;
export const AccommodationRowFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationRowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withArchitecture" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationRowFragmentFragment, unknown>;
export const OverlappingBlocksNotice_AccommodationAvailabilityBlockFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OverlappingBlocksNotice_AccommodationAvailabilityBlock",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationAvailabilityBlock" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "name" } },
            { kind: "Field", name: { kind: "Name", value: "beginNight" } },
            { kind: "Field", name: { kind: "Name", value: "endNight" } },
            { kind: "Field", name: { kind: "Name", value: "isTentative" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "categoryInfo" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "label" } },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OverlappingBlocksNotice_AccommodationAvailabilityBlockFragment,
    unknown
  >;
export const ProgramYearStatusOnReservationRulesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProgramYearStatusOnReservationRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnershipProgramYearStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "remainingNights" } },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingSiteHighSeasonDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProgramYearStatusOnReservationRulesFragment,
  unknown
>;
export const UserOwnershipOnReservationRulesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOwnershipOnReservationRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ProgramYearStatusOnReservationRules",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ProgramYearStatusOnReservationRules",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProgramYearStatusOnReservationRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnershipProgramYearStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "remainingNights" } },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingSiteHighSeasonDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserOwnershipOnReservationRulesFragment, unknown>;
export const AccommodationNoticesForReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationNoticesForReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationNotices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brief" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationNoticesForReservationFragment,
  unknown
>;
export const StayTicketUnitForCancelFeePolicyFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForCancelFeePolicyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlanType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayTicketUnitForCancelFeePolicyFragmentFragment,
  unknown
>;
export const OriginalAccommodationReservationOnAvailabilityCellFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OriginalAccommodationReservationOnAvailabilityCellFragment,
  unknown
>;
export const OriginalAccommodationReservationOnReservationCalendarFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OriginalAccommodationReservationOnReservationCalendar",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "firstNight" } },
            { kind: "Field", name: { kind: "Name", value: "lastNight" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "site" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        { kind: "Field", name: { kind: "Name", value: "id" } },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "area" },
                          selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                              {
                                kind: "Field",
                                name: { kind: "Name", value: "id" },
                              },
                            ],
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
            {
              kind: "FragmentSpread",
              name: {
                kind: "Name",
                value: "OriginalAccommodationReservationOnAvailabilityCell",
              },
            },
          ],
        },
      },
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OriginalAccommodationReservationOnAvailabilityCell",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "firstNight" } },
            { kind: "Field", name: { kind: "Name", value: "lastNight" } },
            { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OriginalAccommodationReservationOnReservationCalendarFragment,
    unknown
  >;
export const InternalOriginalAccommodationReservationOnDraftReservationFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "InternalOriginalAccommodationReservationOnDraftReservation",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "detail" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "useEvCharger" },
                  },
                  { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfDogs" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfAdults" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfKids" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfInfants" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "previousLocation" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "nextLocation" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "internalStamp" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "allowRoomChange" },
                  },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "fee" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "items" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "type" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "label" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "amount" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "night" },
                        },
                        { kind: "Field", name: { kind: "Name", value: "key" } },
                      ],
                    },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "billingMethod" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "billingMethodManualDetail" },
                  },
                ],
              },
            },
            { kind: "Field", name: { kind: "Name", value: "isTentative" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "accommodation" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  { kind: "Field", name: { kind: "Name", value: "id" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "architectureType" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "capacity" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    InternalOriginalAccommodationReservationOnDraftReservationFragment,
    unknown
  >;
export const InternalOriginalReservationOnReservationFormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "InternalOriginalReservationOnReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value:
                "InternalOriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnReservationCalendar",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnAvailabilityCell",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "InternalOriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalStamp" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethodManualDetail" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacity" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalOriginalReservationOnReservationFormFragment,
  unknown
>;
export const AccommodationOnHeaderCellFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnHeaderCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          { kind: "Field", name: { kind: "Name", value: "operationType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationOnHeaderCellFragment, unknown>;
export const AccommodationOnAvailabilityCellFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brief" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationOnAvailabilityCellFragment, unknown>;
export const AvailabilityOnAvailabilityCellFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilityOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailability" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
          { kind: "Field", name: { kind: "Name", value: "guaranteedPrice" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "block" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "internal" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryGroup" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilityOnAvailabilityCellFragment, unknown>;
export const AccommodationsOnCalendarFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsOnCalendar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationOnHeaderCell" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availabilities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "occupancyLimitTarget" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "occupancyLimitTarget" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internal" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withDeferred" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AvailabilityOnAvailabilityCell",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnHeaderCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          { kind: "Field", name: { kind: "Name", value: "operationType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brief" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilityOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailability" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
          { kind: "Field", name: { kind: "Name", value: "guaranteedPrice" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "block" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "internal" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryGroup" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationsOnCalendarFragment, unknown>;
export const AccommodationsGroupOnCalendarFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsGroupOnCalendar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isOwned" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationsOnCalendar" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnHeaderCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          { kind: "Field", name: { kind: "Name", value: "operationType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brief" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilityOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailability" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
          { kind: "Field", name: { kind: "Name", value: "guaranteedPrice" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "block" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "internal" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryGroup" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsOnCalendar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationOnHeaderCell" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availabilities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "occupancyLimitTarget" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "occupancyLimitTarget" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internal" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withDeferred" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AvailabilityOnAvailabilityCell",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationsGroupOnCalendarFragment, unknown>;
export const AreaHeaderFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHeaderFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaHeaderFragmentFragment, unknown>;
export const SiteForHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteForHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteForHeaderFragment, unknown>;
export const AccommodationForSiteHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationForSiteHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationForSiteHeaderFragment, unknown>;
export const FacilityForSiteHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityForSiteHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "FacilityDetailModalFragment" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityForSiteHeaderFragment, unknown>;
export const OriginalAccommodationReservationOnDraftReservationFormFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "OriginalAccommodationReservationOnDraftReservationForm",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "AccommodationReservation" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "id" } },
            { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
            { kind: "Field", name: { kind: "Name", value: "canCancel" } },
            { kind: "Field", name: { kind: "Name", value: "isTentative" } },
            {
              kind: "Field",
              name: { kind: "Name", value: "detail" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfAdults" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfKids" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfInfants" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "previousLocation" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "nextLocation" },
                  },
                  { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "numberOfDogs" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "useEvCharger" },
                  },
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "allowRoomChange" },
                  },
                ],
              },
            },
            {
              kind: "Field",
              name: { kind: "Name", value: "fee" },
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "items" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "type" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "label" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "amount" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "night" },
                        },
                        { kind: "Field", name: { kind: "Name", value: "key" } },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    OriginalAccommodationReservationOnDraftReservationFormFragment,
    unknown
  >;
export const OriginalAccommodationReservationOnDraftReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservationForm",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OriginalAccommodationReservationOnDraftReservationFragment,
  unknown
>;
export const OriginalReservationOnReservationFormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OriginalReservationOnReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnReservationCalendar",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnAvailabilityCell",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservationForm",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OriginalReservationOnReservationFormFragment,
  unknown
>;
export const UserReservationCountForLogFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserReservationCountForLog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stayedReservationCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserReservationCountForLogFragment, unknown>;
export const ReservationFormOwnershipSelectorFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationFormOwnershipSelectorFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationFormOwnershipSelectorFragmentFragment,
  unknown
>;
export const OrganizationReservationNewStatusFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationReservationNewStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrganizationMembership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationNewStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holdMaxInTotal" },
                },
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "latestMonthlyReservationStatuses",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yearMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isContracted" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "yearlyReservationStatus",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remainingNights" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxNights" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alreadyHold" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationReservationNewStatusFragment, unknown>;
export const ProgramYearStatusOnReservationRuleOfOwnershipBannerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnershipProgramYearStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "remainingNights" } },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingSiteHighSeasonDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProgramYearStatusOnReservationRuleOfOwnershipBannerFragment,
  unknown
>;
export const ReservationRuleOfOwnershipBannerFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleOfOwnershipBannerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnershipProgramYearStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "remainingNights" } },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingSiteHighSeasonDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationRuleOfOwnershipBannerFragmentFragment,
  unknown
>;
export const ReservationRuleOfStaffPlanBannerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleOfStaffPlanBanner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "semesterCredits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "semester" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grantedStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingPeakDays" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationRuleOfStaffPlanBannerFragment, unknown>;
export const ReservationRuleBannerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleBanner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserSubscription" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "billingCycleDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationCycle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationCyclePeriods" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "5" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayedAndReservedNights" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationRuleBannerFragment, unknown>;
export const ReservationRuleOfTrialPlanBannerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleOfTrialPlanBanner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TrialContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterEndDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterStartDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterRemainingPeakDays" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterRemainingPeakDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationRuleOfTrialPlanBannerFragment, unknown>;
export const CancellationPolicyContentFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CancellationPolicyContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CancellationPolicyContent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "conditionLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tiers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeDescription" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noShowDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changeDeadlineDescription" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancellationPolicyContentFragmentFragment,
  unknown
>;
export const AccommodationReservationFeeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationFeeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consumedSuppliesFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localTaxPolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationFeeFragmentFragment,
  unknown
>;
export const ActivityProgramCards_SiteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityProgramCards_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activityPrograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityProgramCards_SiteFragment, unknown>;
export const ChangeOrCancelEstimatedChargeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeOrCancelEstimatedChargeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "EstimatedChargeOfAccommodationReservation",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalAmountOfFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "chargeType" } },
                { kind: "Field", name: { kind: "Name", value: "night" } },
                { kind: "Field", name: { kind: "Name", value: "amountOfFee" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeOrCancelEstimatedChargeFragmentFragment,
  unknown
>;
export const EarlyCheckInInfoModalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EarlyCheckInInfoModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInPriceTable" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                { kind: "Field", name: { kind: "Name", value: "endHour" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EarlyCheckInInfoModalFragment, unknown>;
export const ReservationBoxFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationBox" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationBoxFragment, unknown>;
export const ReservationSummaryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationSummary" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "standardCheckInTime" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTotalChildren" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalStamp" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReservationSummaryFragment, unknown>;
export const SiteContentFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteContentFragmentFragment, unknown>;
export const SiteTrafficInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteTrafficInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roadConditionLiveCameraUrl",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteTrafficInfoFragment, unknown>;
export const StayReviewCompleted_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayReviewCompleted_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayReviewCompleted_AccommodationReservationFragment,
  unknown
>;
export const StayReviewCompleted_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewCompleted_User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayedReservationCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StayReviewCompleted_UserFragment, unknown>;
export const StayReviewForm_StayReviewV2FragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewForm_StayReviewV2" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureAndNatureRating" },
          },
          { kind: "Field", name: { kind: "Name", value: "cleaningRating" } },
          { kind: "Field", name: { kind: "Name", value: "equipmentRating" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "guidanceAndSupportRating" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "concerns" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "kind" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StayReviewForm_StayReviewV2Fragment, unknown>;
export const MemorableExperienceChips_StayReviewMemorableExperienceOptionFragmentDoc =
  {
    kind: "Document",
    definitions: [
      {
        kind: "FragmentDefinition",
        name: {
          kind: "Name",
          value: "MemorableExperienceChips_StayReviewMemorableExperienceOption",
        },
        typeCondition: {
          kind: "NamedType",
          name: { kind: "Name", value: "StayReviewMemorableExperienceOption" },
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            { kind: "Field", name: { kind: "Name", value: "value" } },
            { kind: "Field", name: { kind: "Name", value: "label" } },
            { kind: "Field", name: { kind: "Name", value: "description" } },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    MemorableExperienceChips_StayReviewMemorableExperienceOptionFragment,
    unknown
  >;
export const ConcernPanel_StayReviewConcernKindDefinitionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ConcernPanel_StayReviewConcernKindDefinition",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewConcernKindDefinition" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "commentPlaceholder" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConcernPanel_StayReviewConcernKindDefinitionFragment,
  unknown
>;
export const StayReviewForm_StayReviewV2FormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewForm_StayReviewV2Form" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2Form" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "MemorableExperienceChips_StayReviewMemorableExperienceOption",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "axes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "axis" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "concernKinds" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ConcernPanel_StayReviewConcernKindDefinition",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "MemorableExperienceChips_StayReviewMemorableExperienceOption",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewMemorableExperienceOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ConcernPanel_StayReviewConcernKindDefinition",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewConcernKindDefinition" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "commentPlaceholder" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StayReviewForm_StayReviewV2FormFragment, unknown>;
export const StayReviewQuickSelect_AccommodationReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayReviewQuickSelect_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayReviewQuickSelect_AccommodationReservationFragment,
  unknown
>;
export const StayReviewQuickSelect_StayReviewV2FragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewQuickSelect_StayReviewV2" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayReviewQuickSelect_StayReviewV2Fragment,
  unknown
>;
export const StayReviewQuickSelect_StayReviewV2FormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewQuickSelect_StayReviewV2Form" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2Form" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "MemorableExperienceChips_StayReviewMemorableExperienceOption",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "MemorableExperienceChips_StayReviewMemorableExperienceOption",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewMemorableExperienceOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayReviewQuickSelect_StayReviewV2FormFragment,
  unknown
>;
export const AccommodationOnRoomDetailContentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnRoomDetailContent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "googleMapsUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "features" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconSlug" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccommodationOnRoomDetailContentFragment, unknown>;
export const RoomTypeOnRoomDetailContentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeOnRoomDetailContent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "iconSlug" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "googleMapsUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeOnRoomDetailContentFragment, unknown>;
export const AvailabilityOnCtaButtonFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilityOnCtaButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailability" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "guaranteedPrice" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilityOnCtaButtonFragment, unknown>;
export const FeatureSubtext_RoomTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeatureSubtext_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureSubtext_RoomTypeFragment, unknown>;
export const DraftAccommodationReservationInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DraftAccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DraftAccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DraftAccommodationReservationInfoFragment,
  unknown
>;
export const OfferedCoOwnerPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OfferedCoOwnerPlans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "offeredCoOwnersPlans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "earlyAccessCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advancePaymentRequired" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationFacilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitApplicationFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advancePaymentRequired" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersMaxPeakDaysPerUnit" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "coOwnersMaxConcurrentReservationsPerUnit",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersPlanOfferings" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "earlyAccessCode" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "code" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSoldOut" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "estimate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CoOwnersApplicationDetails" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "unitNightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitPurchaseAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitApplicationFee" },
          },
          { kind: "Field", name: { kind: "Name", value: "registrationFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersMaxPeakDaysPerUnit" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "coOwnersMaxConcurrentReservationsPerUnit",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersPlanOfferings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "earlyAccessCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "estimate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OfferedCoOwnerPlansQuery,
  OfferedCoOwnerPlansQueryVariables
>;
export const OwnerPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OwnerPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "NullValue" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitApplicationFee" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CoOwnersApplicationDetails" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "unitNightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitPurchaseAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitApplicationFee" },
          },
          { kind: "Field", name: { kind: "Name", value: "registrationFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersMaxPeakDaysPerUnit" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "coOwnersMaxConcurrentReservationsPerUnit",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersPlanOfferings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "earlyAccessCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "estimate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerPlanQuery, OwnerPlanQueryVariables>;
export const S2oPointsOfViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "S2oPointsOfViewer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ownerPlanId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "units" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "useWeekdayTrial" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "useStayCredit" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "s2o" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "weekdayTrialBalance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayCreditBalance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedAmount" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "ownerPlanId" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "ownerPlanId" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "units" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "units" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "useWeekdayTrial" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "useWeekdayTrial" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "useStayCredit" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "useStayCredit" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  S2oPointsOfViewerQuery,
  S2oPointsOfViewerQueryVariables
>;
export const TentativeReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TentativeReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tentativeAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "series" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "area" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slug" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "night" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tentativeDeadline" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedFrom" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AccommodationReservationInfo",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RedirectLocation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "TentativeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "TentativeAccommodationReservationErrorCase",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "TentativeAccommodationReservationErrorCase",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TentativeAccommodationReservationError" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "case" } }],
      },
    },
  ],
} as unknown as DocumentNode<
  TentativeReservationQuery,
  TentativeReservationQueryVariables
>;
export const AdminApproveIdentityVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminApproveIdentityVerification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateIdentityVerificationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateIdentityVerification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateIdentityVerificationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminApproveIdentityVerificationMutation,
  AdminApproveIdentityVerificationMutationVariables
>;
export const AdminAreaFilterAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaFilterAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaFilterAreasQuery,
  AdminAreaFilterAreasQueryVariables
>;
export const AdminRejectIdentityVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRejectIdentityVerification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateIdentityVerificationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateIdentityVerification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateIdentityVerificationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRejectIdentityVerificationMutation,
  AdminRejectIdentityVerificationMutationVariables
>;
export const AdminSiteFilterAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteFilterAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteFilterAreasQuery,
  AdminSiteFilterAreasQueryVariables
>;
export const AdminCreateArchitectureContentImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateArchitectureContentImageUploadPolicy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "InternalCreateArchitectureContentImageUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateArchitectureContentImageUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateArchitectureContentImageUploadPolicyMutation,
  AdminCreateArchitectureContentImageUploadPolicyMutationVariables
>;
export const AdminAccommodationFacilityBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationFacilityBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationFacilityBasicInfoQuery,
  AdminAccommodationFacilityBasicInfoQueryVariables
>;
export const AdminAccommodationFacilityHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationFacilityHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationFacilityHeader" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalContentArchitecturalFeature",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationFacilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationFacilityHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationFacility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationFacilityHeaderQuery,
  AdminAccommodationFacilityHeaderQueryVariables
>;
export const AdminAccommodationFacilityAmenitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationFacilityAmenities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationFacilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContentFacilityAmenities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationFacilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationFacilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "referenceCounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "variations" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "features" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationFacilityAmenitiesQuery,
  AdminAccommodationFacilityAmenitiesQueryVariables
>;
export const AdminDeleteContentFacilityAmenityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteContentFacilityAmenity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteContentFacilityAmenity",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteContentFacilityAmenityMutation,
  AdminDeleteContentFacilityAmenityMutationVariables
>;
export const AdminCreateOrUpdateContentFacilityAmenityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateContentFacilityAmenity",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentFacilityAmenityInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentFacilityAmenity",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ContentArchitectureTypeVariantFacilityAmenity",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "descriptionMarkup" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodationFacility" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateContentFacilityAmenityMutation,
  AdminCreateOrUpdateContentFacilityAmenityMutationVariables
>;
export const AdminDeleteContentArchitecturalFeatureDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteContentArchitecturalFeature" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteContentArchitecturalFeature",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteContentArchitecturalFeatureMutation,
  AdminDeleteContentArchitecturalFeatureMutationVariables
>;
export const AdminCreateOrUpdateContentArchitecturalFeatureDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateContentArchitecturalFeature",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationFacilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentArchitecturalFeatureInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitecturalFeature",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationFacilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationFacilityId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ContentArchitecturalFeature",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateContentArchitecturalFeatureMutation,
  AdminCreateOrUpdateContentArchitecturalFeatureMutationVariables
>;
export const AdminAccommodationFacilityContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationFacilityContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationFacilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalContentArchitecturalFeature",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationFacilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationFacilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageConditionsDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilityNote" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ruleNoteMarkup" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thumbnailImageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrls" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bodyMarkup" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContentFacilityAmenities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationFacilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationFacilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationFacilityContentQuery,
  AdminAccommodationFacilityContentQueryVariables
>;
export const AdminUpdateContentArchitecturalFeatureImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminUpdateContentArchitecturalFeatureImages",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationFacilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentArchitecturalFeatureInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitecturalFeature",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationFacilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationFacilityId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ContentArchitecturalFeature",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnailImageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrls" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateContentArchitecturalFeatureImagesMutation,
  AdminUpdateContentArchitecturalFeatureImagesMutationVariables
>;
export const AdminCreateOrUpdateContentArchitecturalFeatureUsageRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateContentArchitecturalFeatureUsageRule",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "featureId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value:
                "internalCreateOrUpdateContentArchitecturalFeatureUsageRule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "featureId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "featureId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ContentArchitecturalFeatureUsageRule",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bodyMarkup" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateContentArchitecturalFeatureUsageRuleMutation,
  AdminCreateOrUpdateContentArchitecturalFeatureUsageRuleMutationVariables
>;
export const AdminReorderContentArchitecturalFeatureUsageRulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminReorderContentArchitecturalFeatureUsageRules",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "InternalReorderArchitectureContentInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalReorderContentArchitecturalFeatureUsageRules",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderContentArchitecturalFeatureUsageRulesMutation,
  AdminReorderContentArchitecturalFeatureUsageRulesMutationVariables
>;
export const AdminDeleteContentArchitecturalFeatureUsageRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminDeleteContentArchitecturalFeatureUsageRule",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteContentArchitecturalFeatureUsageRule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteContentArchitecturalFeatureUsageRuleMutation,
  AdminDeleteContentArchitecturalFeatureUsageRuleMutationVariables
>;
export const AdminAccommodationFacilitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationFacilities" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationFacilitiesQuery,
  AdminAccommodationFacilitiesQueryVariables
>;
export const AdminCreateOrUpdateAccommodationNoticeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateAccommodationNotice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAccommodationNoticeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAccommodationNotice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationNotice" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "AccommodationNoticesTable_AccommodationNotice",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateAccommodationNoticeError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "AccommodationNoticesTable_AccommodationNotice",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationNotice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          { kind: "Field", name: { kind: "Name", value: "detail" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToExpectedUsers" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastUpdatedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateAccommodationNoticeMutation,
  AdminCreateOrUpdateAccommodationNoticeMutationVariables
>;
export const AdminAccommodationNoticesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationNotices" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationNotices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AccommodationNoticesTable_AccommodationNotice",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "AccommodationNoticesTable_AccommodationNotice",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationNotice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          { kind: "Field", name: { kind: "Name", value: "detail" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToExpectedUsers" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastUpdatedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationNoticesQuery,
  AdminAccommodationNoticesQueryVariables
>;
export const AdminAccommodationNoticeMastersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationNoticeMasters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationNoticeMastersQuery,
  AdminAccommodationNoticeMastersQueryVariables
>;
export const AdminAccommodationBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationBasicInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockDeviceId" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockDeviceId" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationBasicInfoQuery,
  AdminAccommodationBasicInfoQueryVariables
>;
export const AdminCreateOrUpdateAccommodationContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateAccommodationContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAccommodationContentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAccommodationContent",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manualUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateAccommodationContentMutation,
  AdminCreateOrUpdateAccommodationContentMutationVariables
>;
export const AdminAccommodationContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationContentTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "manualUrl" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "manualUrl" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationContentEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationContentQuery,
  AdminAccommodationContentQueryVariables
>;
export const AdminAccommodationHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationHeader" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationHeaderQuery,
  AdminAccommodationHeaderQueryVariables
>;
export const AdminUpdateAccommodationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateAccommodation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAccommodationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAccommodation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Accommodation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "seriesShortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remoteLockDeviceId" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateAccommodationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateAccommodationMutation,
  AdminUpdateAccommodationMutationVariables
>;
export const AdminArchitectureTypesForAccommodationEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminArchitectureTypesForAccommodationEdit",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypesForAccommodationEditQuery,
  AdminArchitectureTypesForAccommodationEditQueryVariables
>;
export const AdminFacilitiesForAccommodationEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilitiesForAccommodationEdit" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilitiesForAccommodationEditQuery,
  AdminFacilitiesForAccommodationEditQueryVariables
>;
export const AdminAccommodationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seriesShortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remoteLockDeviceId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationsQuery,
  AdminAccommodationsQueryVariables
>;
export const AdminAccommodationAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationAreasQuery,
  AdminAccommodationAreasQueryVariables
>;
export const AdminAccommodationArchitectureTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAccommodationArchitectureTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationArchitectureTypesQuery,
  AdminAccommodationArchitectureTypesQueryVariables
>;
export const AdminReorderAccommodationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderAccommodations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "InternalReorderAccommodationInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReorderAccommodations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderAccommodationsMutation,
  AdminReorderAccommodationsMutationVariables
>;
export const AdminCreateAccommodationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateAccommodation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAccommodationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAccommodation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Accommodation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateAccommodationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAccommodationMutation,
  AdminCreateAccommodationMutationVariables
>;
export const AdminArchitectureTypesForAccommodationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminArchitectureTypesForAccommodation" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypesForAccommodationQuery,
  AdminArchitectureTypesForAccommodationQueryVariables
>;
export const AdminFacilitiesForAccommodationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilitiesForAccommodation" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilitiesForAccommodationQuery,
  AdminFacilitiesForAccommodationQueryVariables
>;
export const AdminActivityProgramsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminActivityPrograms" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSiteActivityPrograms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localizedTitle" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishStartAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishEndAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ActivityProgramSheet_SiteActivityProgram",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityProgramSheet_SiteActivityProgram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedTitle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "publishStartAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishEndAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminActivityProgramsQuery,
  AdminActivityProgramsQueryVariables
>;
export const AdminActivityProgramSiteOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminActivityProgramSiteOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminActivityProgramSiteOptionsQuery,
  AdminActivityProgramSiteOptionsQueryVariables
>;
export const AdminCreateActivityProgramDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateActivityProgram" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateSiteActivityProgramInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateSiteActivityProgram" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SiteActivityProgram" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ActivityProgramSheet_SiteActivityProgram",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateSiteActivityProgramError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityProgramSheet_SiteActivityProgram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedTitle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "publishStartAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishEndAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateActivityProgramMutation,
  AdminCreateActivityProgramMutationVariables
>;
export const AdminUpdateActivityProgramDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateActivityProgram" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateSiteActivityProgramInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteActivityProgram" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SiteActivityProgram" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ActivityProgramSheet_SiteActivityProgram",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateSiteActivityProgramError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityProgramSheet_SiteActivityProgram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedTitle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          { kind: "Field", name: { kind: "Name", value: "publishStartAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishEndAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateActivityProgramMutation,
  AdminUpdateActivityProgramMutationVariables
>;
export const AdminDeleteActivityProgramDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteActivityProgram" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteSiteActivityProgram" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "_" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteActivityProgramMutation,
  AdminDeleteActivityProgramMutationVariables
>;
export const AdminCreateActivityProgramImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateActivityProgramImageUploadPolicy",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateSiteActivityProgramImageUploadPolicy",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateActivityProgramImageUploadPolicyMutation,
  AdminCreateActivityProgramImageUploadPolicyMutationVariables
>;
export const AdminAdditionalGuestFeePolicyDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdditionalGuestFeePolicyDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAdditionalGuestFeePolicyById",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                { kind: "Field", name: { kind: "Name", value: "adultPrices" } },
                { kind: "Field", name: { kind: "Name", value: "kidsPrices" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdditionalGuestFeePolicyDetailQuery,
  AdminAdditionalGuestFeePolicyDetailQueryVariables
>;
export const AdminAdditionalGuestFeePoliciesContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdditionalGuestFeePoliciesContent" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdditionalGuestFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                { kind: "Field", name: { kind: "Name", value: "adultPrices" } },
                { kind: "Field", name: { kind: "Name", value: "kidsPrices" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdditionalGuestFeePoliciesContentQuery,
  AdminAdditionalGuestFeePoliciesContentQueryVariables
>;
export const AdminCreateOrUpdateAdditionalGuestFeePolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateAdditionalGuestFeePolicy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAdditionalGuestFeePolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAdditionalGuestFeePolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AdditionalGuestFeePolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "adultPrices" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "kidsPrices" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateAdditionalGuestFeePolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateAdditionalGuestFeePolicyMutation,
  AdminCreateOrUpdateAdditionalGuestFeePolicyMutationVariables
>;
export const AdminAdditionalGuestFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdditionalGuestFeePolicies" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdditionalGuestFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                { kind: "Field", name: { kind: "Name", value: "adultPrices" } },
                { kind: "Field", name: { kind: "Name", value: "kidsPrices" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdditionalGuestFeePoliciesQuery,
  AdminAdditionalGuestFeePoliciesQueryVariables
>;
export const AdminAdminRoleAssignmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdminRoleAssignments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeInactive" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AdminRole" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdminRoleAssignments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeInactive" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "includeInactive" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "role" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AdminRoleAssignmentsTable_AdminRoleAssignment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "AdminRoleAssignmentsTable_AdminRoleAssignment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AdminRoleAssignment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "grantedAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "grantedByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "revokedByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdminRoleAssignmentsQuery,
  AdminAdminRoleAssignmentsQueryVariables
>;
export const AdminAdminRoleAssignmentSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdminRoleAssignmentSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdminRoleAssignmentSitesQuery,
  AdminAdminRoleAssignmentSitesQueryVariables
>;
export const AdminAdminRoleAssignmentFilterUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdminRoleAssignmentFilterUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdminRoleAssignmentFilterUserQuery,
  AdminAdminRoleAssignmentFilterUserQueryVariables
>;
export const AdminRevokeAdminRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRevokeAdminRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalRevokeAdminRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AdminRoleAssignment" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "revokedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "revokedByUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalRevokeAdminRoleError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRevokeAdminRoleMutation,
  AdminRevokeAdminRoleMutationVariables
>;
export const AdminGrantableAdminRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminGrantableAdminRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalGrantableAdminRoles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "scope" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminGrantableAdminRolesQuery,
  AdminGrantableAdminRolesQueryVariables
>;
export const AdminAssignAdminRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminAssignAdminRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalAssignAdminRoleInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAssignAdminRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AdminRoleAssignment" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAssignAdminRoleError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAssignAdminRoleMutation,
  AdminAssignAdminRoleMutationVariables
>;
export const AdminAdminRoleUserCandidatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAdminRoleUserCandidates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "excludeDeleted" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUsersSearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "excludeDeleted" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "excludeDeleted" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdminRoleUserCandidatesQuery,
  AdminAdminRoleUserCandidatesQueryVariables
>;
export const AdminCreateOrUpdateContentArchitectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateContentArchitect" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentArchitectInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitect",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ContentArchitect" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameEn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "company" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "bio" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureTypes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateContentArchitectMutation,
  AdminCreateOrUpdateContentArchitectMutationVariables
>;
export const AdminContentArchitectsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminContentArchitects" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContentArchitects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "company" } },
                { kind: "Field", name: { kind: "Name", value: "bio" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminContentArchitectsQuery,
  AdminContentArchitectsQueryVariables
>;
export const AdminDeleteContentArchitectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteContentArchitect" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteContentArchitect" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteContentArchitectMutation,
  AdminDeleteContentArchitectMutationVariables
>;
export const AdminArchitectureTypeBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminArchitectureTypeBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ArchitectureTypeBasicInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "additionalFee" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "seriesName" } },
          { kind: "Field", name: { kind: "Name", value: "seriesShortName" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "additionalFee" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ArchitectureTypeEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypeBasicInfoQuery,
  AdminArchitectureTypeBasicInfoQueryVariables
>;
export const AdminArchitectureTypeContentEditSheetOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminArchitectureTypeContentEditSheetOptions",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContentArchitects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalContentArchitectureTypeBasicAmenities",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypeContentEditSheetOptionsQuery,
  AdminArchitectureTypeContentEditSheetOptionsQueryVariables
>;
export const AdminUpdateContentArchitectureTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateContentArchitectureType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentArchitectureTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitectureType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "architectureTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "architectureTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ContentArchitectureType" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeSqm" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectComment" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "customEmailCoverImageUrl",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "amenitiesInstructionsUrl",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architect" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "iconUrl" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateContentArchitectureTypeMutation,
  AdminUpdateContentArchitectureTypeMutationVariables
>;
export const AdminArchitectureTypeContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminArchitectureTypeContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ArchitectureTypeContentTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customEmailCoverImageUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "capacityDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sizeDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "sizeSqm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectComment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architect" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "equipmentsListUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amenitiesInstructionsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thumbnailImageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrls" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "basicAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "floorPlanImageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypeContentQuery,
  AdminArchitectureTypeContentQueryVariables
>;
export const AdminUpdateContentArchitectureTypeImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateContentArchitectureTypeImages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentArchitectureTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitectureType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "architectureTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "architectureTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ContentArchitectureType" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnailImageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrls" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "floorPlanImageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateContentArchitectureTypeImagesMutation,
  AdminUpdateContentArchitectureTypeImagesMutationVariables
>;
export const AdminArchitectureTypeHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminArchitectureTypeHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ArchitectureTypeHeader" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "series" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypeHeaderQuery,
  AdminArchitectureTypeHeaderQueryVariables
>;
export const AdminUpdateArchitectureTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateArchitectureType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateArchitectureTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateArchitectureType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "series" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "capacity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "published" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateArchitectureTypeMutation,
  AdminUpdateArchitectureTypeMutationVariables
>;
export const AdminArchitectureTypeVariantEditSheetOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminArchitectureTypeVariantEditSheetOptions",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContentFacilityAmenities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationFacility" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypeVariantEditSheetOptionsQuery,
  AdminArchitectureTypeVariantEditSheetOptionsQueryVariables
>;
export const AdminCreateOrUpdateContentArchitectureTypeVariantDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateContentArchitectureTypeVariant",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "kind" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ContentArchitectureTypeVariantKind",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "InternalCreateOrUpdateContentArchitectureTypeVariantInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitectureTypeVariant",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "architectureTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "architectureTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "kind" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "kind" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateContentArchitectureTypeVariantMutation,
  AdminCreateOrUpdateContentArchitectureTypeVariantMutationVariables
>;
export const AdminArchitectureTypeVariantsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminArchitectureTypeVariants" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ArchitectureTypeVariantsTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeVariantCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "caption" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageConditionsDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ArchitectureTypeVariantsTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "variations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ArchitectureTypeVariantCard",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ArchitectureTypeVariantCard",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypeVariantsQuery,
  AdminArchitectureTypeVariantsQueryVariables
>;
export const AdminDeleteContentArchitectureTypeVariantDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminDeleteContentArchitectureTypeVariant",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "kind" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ContentArchitectureTypeVariantKind",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteContentArchitectureTypeVariant",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "kind" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "kind" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteContentArchitectureTypeVariantMutation,
  AdminDeleteContentArchitectureTypeVariantMutationVariables
>;
export const AdminCreateArchitectureTypeContentOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminCreateArchitectureTypeContentOptions",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalContentArchitects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalContent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateArchitectureTypeContentOptionsQuery,
  AdminCreateArchitectureTypeContentOptionsQueryVariables
>;
export const AdminCreateContentArchitectureTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateContentArchitectureType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateContentArchitectureTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateContentArchitectureType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "architectureTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "architectureTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ContentArchitectureType" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateContentArchitectureTypeMutation,
  AdminCreateContentArchitectureTypeMutationVariables
>;
export const AdminArchitectureTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminArchitectureTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "series" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "capacity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationsCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalContent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminArchitectureTypesQuery,
  AdminArchitectureTypesQueryVariables
>;
export const AdminReorderContentArchitectureTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderContentArchitectureTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "InternalReorderArchitectureContentInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalReorderContentArchitectureTypes",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderContentArchitectureTypesMutation,
  AdminReorderContentArchitectureTypesMutationVariables
>;
export const AdminCreateArchitectureTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateArchitectureType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateArchitectureTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateArchitectureType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateArchitectureTypeMutation,
  AdminCreateArchitectureTypeMutationVariables
>;
export const AdminAreaGuideArticleAreaOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaGuideArticleAreaOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaGuideArticleAreaOptionsQuery,
  AdminAreaGuideArticleAreaOptionsQueryVariables
>;
export const AdminCreateOrUpdateAreaGuideArticleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateAreaGuideArticle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAreaGuideArticleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAreaGuideArticle",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "areas" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateAreaGuideArticleMutation,
  AdminCreateOrUpdateAreaGuideArticleMutationVariables
>;
export const AdminAreaGuideArticlesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaGuideArticles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreaGuideArticles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "areas" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaGuideArticlesQuery,
  AdminAreaGuideArticlesQueryVariables
>;
export const AdminDeleteAreaGuideArticleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteAreaGuideArticle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteAreaGuideArticle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteAreaGuideArticleMutation,
  AdminDeleteAreaGuideArticleMutationVariables
>;
export const AdminReorderAreaGuideArticlesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderAreaGuideArticles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternalReorderInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReorderAreaGuideArticles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderAreaGuideArticlesMutation,
  AdminReorderAreaGuideArticlesMutationVariables
>;
export const AdminCreateAreaGuideArticleImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateAreaGuideArticleImageUploadPolicy",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateAreaGuideArticleImageUploadPolicy",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAreaGuideArticleImageUploadPolicyMutation,
  AdminCreateAreaGuideArticleImageUploadPolicyMutationVariables
>;
export const AdminAreaBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaBasicInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
                { kind: "Field", name: { kind: "Name", value: "openingDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "reservable" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "reservableForOwnerEarlyAccess",
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AreaEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaBasicInfoQuery,
  AdminAreaBasicInfoQueryVariables
>;
export const AdminUpdateAreaContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateAreaContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateAreaContentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateAreaContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allCapsName" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservationFormCoverImageUrl",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roadConditionLiveCameraUrl",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortAddress" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "catchCopy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accessFromTokyoDescription",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guideSpotTipsTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guideSpotTips" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guideSpotMapListUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateAreaContentMutation,
  AdminUpdateAreaContentMutationVariables
>;
export const AdminAreaContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaContentTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AreaContentEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaContentQuery,
  AdminAreaContentQueryVariables
>;
export const AdminUpdateAreaReservationFormCoverImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateAreaReservationFormCoverImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateAreaContentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateAreaContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservationFormCoverImageUrl",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateAreaReservationFormCoverImageMutation,
  AdminUpdateAreaReservationFormCoverImageMutationVariables
>;
export const AdminReplaceAreaHeroImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReplaceAreaHeroImages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateAreaContentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateAreaContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "caption" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReplaceAreaHeroImagesMutation,
  AdminReplaceAreaHeroImagesMutationVariables
>;
export const AdminAreaDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaHeader" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaBasicInfo" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaContentTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
                { kind: "Field", name: { kind: "Name", value: "openingDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "reservable" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "reservableForOwnerEarlyAccess",
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AreaEditSheet" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roadConditionLiveCameraUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AreaContentEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaDetailQuery,
  AdminAreaDetailQueryVariables
>;
export const AdminAreaHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaHeader" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalArea" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaHeaderQuery,
  AdminAreaHeaderQueryVariables
>;
export const AdminUpdateAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateAreaInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalArea" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "localizedName" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalUpdateAreaError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateAreaMutation,
  AdminUpdateAreaMutationVariables
>;
export const AdminAreaGuideSpotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreaGuideSpots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessHours" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "websiteUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishStartDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishEndDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedNow" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAreaGuideSpotsQuery,
  AdminAreaGuideSpotsQueryVariables
>;
export const AdminCreateOrUpdateAreaGuideSpotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateAreaGuideSpot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateAreaGuideSpotInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateAreaGuideSpot",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "categories" } },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "websiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mapUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedNow" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateAreaGuideSpotMutation,
  AdminCreateOrUpdateAreaGuideSpotMutationVariables
>;
export const AdminDeleteAreaGuideSpotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteAreaGuideSpot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteAreaGuideSpot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteAreaGuideSpotMutation,
  AdminDeleteAreaGuideSpotMutationVariables
>;
export const AdminReorderAreaGuideSpotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderAreaGuideSpots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternalReorderInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReorderAreaGuideSpots" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderAreaGuideSpotsMutation,
  AdminReorderAreaGuideSpotsMutationVariables
>;
export const AdminCreateAreaImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateAreaImageUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateAreaImageUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateAreaImageUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAreaImageUploadPolicyMutation,
  AdminCreateAreaImageUploadPolicyMutationVariables
>;
export const AdminAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allCapsName" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roadConditionLiveCameraUrl",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminAreasQuery, AdminAreasQueryVariables>;
export const AdminReorderAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderAreas" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternalReorderAreaInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReorderAreas" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderAreasMutation,
  AdminReorderAreasMutationVariables
>;
export const AdminCreateAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateAreaInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAreaMutation,
  AdminCreateAreaMutationVariables
>;
export const AdminBeds24DeleteBlackBookingsTargetCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminBeds24DeleteBlackBookingsTargetCount",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBeds24DeleteBlackBookingsTargetCount",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBeds24DeleteBlackBookingsTargetCountQuery,
  AdminBeds24DeleteBlackBookingsTargetCountQueryVariables
>;
export const AdminEnqueueBeds24DeleteBlackBookingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminEnqueueBeds24DeleteBlackBookings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalEnqueueBeds24DeleteBlackBookings",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminEnqueueBeds24DeleteBlackBookingsMutation,
  AdminEnqueueBeds24DeleteBlackBookingsMutationVariables
>;
export const AdminAvailabilityBlocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAvailabilityBlocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startBeginNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endBeginNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationAvailabilityBlocks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startBeginNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startBeginNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endBeginNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endBeginNight" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "beginNight" } },
                { kind: "Field", name: { kind: "Name", value: "endNight" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryGroup" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAvailabilityBlocksQuery,
  AdminAvailabilityBlocksQueryVariables
>;
export const AdminAvailabilityBlockFilterMastersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAvailabilityBlockFilterMasters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "accommodationAvailabilityBlockCategoryInfos",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeInvalidated" },
                value: { kind: "BooleanValue", value: true },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAvailabilityBlockFilterMastersQuery,
  AdminAvailabilityBlockFilterMastersQueryVariables
>;
export const AdminAvailabilityBlockViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAvailabilityBlockViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAvailabilityBlockViewerQuery,
  AdminAvailabilityBlockViewerQueryVariables
>;
export const AdminCreateAvailabilityBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateAvailabilityBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateAccommodationAvailabilityBlockInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createAccommodationAvailabilityBlock",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAvailabilityBlockMutation,
  AdminCreateAvailabilityBlockMutationVariables
>;
export const AdminChangeAvailabilityBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminChangeAvailabilityBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ChangeAccommodationAvailabilityBlockInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "changeAccommodationAvailabilityBlock",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminChangeAvailabilityBlockMutation,
  AdminChangeAvailabilityBlockMutationVariables
>;
export const AdminBulkDeleteAvailabilityBlocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminBulkDeleteAvailabilityBlocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBulkDeleteAccommodationAvailabilityBlocks",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "successIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBulkDeleteAvailabilityBlocksMutation,
  AdminBulkDeleteAvailabilityBlocksMutationVariables
>;
export const AdminDeleteAvailabilityBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteAvailabilityBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "deleteAccommodationAvailabilityBlock",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteAvailabilityBlockMutation,
  AdminDeleteAvailabilityBlockMutationVariables
>;
export const AdminBaseFeePolicyDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBaseFeePolicyDetail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBaseAccommodationFeePolicies",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dailyFeePolicy" },
                },
                { kind: "Field", name: { kind: "Name", value: "feeModifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeModifierType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isThirdPartyCovered" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "thirdPartyCoveredDailyFeePolicy",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeRules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifierType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifier" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "rawBaseAccommodationFeePolicy",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBaseFeePolicyDetailQuery,
  AdminBaseFeePolicyDetailQueryVariables
>;
export const AdminBaseFeePoliciesContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBaseFeePoliciesContent" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBaseAccommodationFeePolicies",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dailyFeePolicy" },
                },
                { kind: "Field", name: { kind: "Name", value: "feeModifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeModifierType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isThirdPartyCovered" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "thirdPartyCoveredDailyFeePolicy",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBaseFeePoliciesContentQuery,
  AdminBaseFeePoliciesContentQueryVariables
>;
export const AdminCreateOrUpdateBaseFeePolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateBaseFeePolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateBaseAccommodationFeePolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateBaseAccommodationFeePolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "RawBaseAccommodationFeePolicy",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dailyFeePolicy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifierType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isThirdPartyCovered" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "thirdPartyCoveredDailyFeePolicy",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeRules" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ruleType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feeModifierType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feeModifier" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateBaseAccommodationFeePolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateBaseFeePolicyMutation,
  AdminCreateOrUpdateBaseFeePolicyMutationVariables
>;
export const AdminBaseFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBaseFeePolicies" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBaseAccommodationFeePolicies",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dailyFeePolicy" },
                },
                { kind: "Field", name: { kind: "Name", value: "feeModifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeModifierType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isThirdPartyCovered" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "thirdPartyCoveredDailyFeePolicy",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBaseFeePoliciesQuery,
  AdminBaseFeePoliciesQueryVariables
>;
export const AdminContentBasicAmenitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminContentBasicAmenities" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalContentArchitectureTypeBasicAmenities",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iconUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminContentBasicAmenitiesQuery,
  AdminContentBasicAmenitiesQueryVariables
>;
export const AdminDeleteContentBasicAmenityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteContentBasicAmenity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteContentArchitectureTypeBasicAmenity",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteContentBasicAmenityMutation,
  AdminDeleteContentBasicAmenityMutationVariables
>;
export const AdminReorderContentBasicAmenitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderContentBasicAmenities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "InternalReorderArchitectureContentInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalReorderContentArchitectureTypeBasicAmenities",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderContentBasicAmenitiesMutation,
  AdminReorderContentBasicAmenitiesMutationVariables
>;
export const AdminCreateOrUpdateContentBasicAmenityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateContentBasicAmenity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value:
                "internalCreateOrUpdateContentArchitectureTypeBasicAmenity",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ContentArchitectureTypeBasicAmenity",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureTypes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalArchitectureContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateContentBasicAmenityMutation,
  AdminCreateOrUpdateContentBasicAmenityMutationVariables
>;
export const AdminBeds24TokenStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBeds24TokenStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBeds24TokenStatus" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBeds24TokenStatusQuery,
  AdminBeds24TokenStatusQueryVariables
>;
export const AdminBeds24ExchangeInviteCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminBeds24ExchangeInviteCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBeds24ExchangeInviteCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteCode" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBeds24ExchangeInviteCodeMutation,
  AdminBeds24ExchangeInviteCodeMutationVariables
>;
export const AdminIpBeds24SetupStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminIpBeds24SetupStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalIpBeds24SetupStatus" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminIpBeds24SetupStatusQuery,
  AdminIpBeds24SetupStatusQueryVariables
>;
export const AdminIpBeds24SetupEstimateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminIpBeds24SetupEstimate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phases" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalIpBeds24SetupEstimate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "phases" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phases" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminIpBeds24SetupEstimateQuery,
  AdminIpBeds24SetupEstimateQueryVariables
>;
export const AdminStartIpBeds24SetupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminStartIpBeds24Setup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phases" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStartIpBeds24Setup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "phases" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phases" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStartIpBeds24SetupMutation,
  AdminStartIpBeds24SetupMutationVariables
>;
export const AdminCancelIpBeds24SetupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCancelIpBeds24Setup" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelIpBeds24Setup" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelIpBeds24SetupMutation,
  AdminCancelIpBeds24SetupMutationVariables
>;
export const AdminBlockReleaseSchedulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBlockReleaseSchedules" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationAvailabilityBlockReleaseSchedules",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "siteId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "daysBeforeCheckin" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockRoomCountUpperLimit" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBlockReleaseSchedulesQuery,
  AdminBlockReleaseSchedulesQueryVariables
>;
export const AdminCreateBlockReleaseScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateBlockReleaseSchedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value:
                "internalCreateAccommodationAvailabilityBlockReleaseSchedule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "siteId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "daysBeforeCheckin" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockRoomCountUpperLimit" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateBlockReleaseScheduleMutation,
  AdminCreateBlockReleaseScheduleMutationVariables
>;
export const AdminUpdateBlockReleaseScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateBlockReleaseSchedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value:
                "internalUpdateAccommodationAvailabilityBlockReleaseSchedule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "siteId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "daysBeforeCheckin" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockRoomCountUpperLimit" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateBlockReleaseScheduleMutation,
  AdminUpdateBlockReleaseScheduleMutationVariables
>;
export const AdminDeleteBlockReleaseScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteBlockReleaseSchedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value:
                "internalDeleteAccommodationAvailabilityBlockReleaseSchedule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteBlockReleaseScheduleMutation,
  AdminDeleteBlockReleaseScheduleMutationVariables
>;
export const AdminCreateOrUpdateBusinessPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateBusinessPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessPlanId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrUpdateBusinessPlanInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOrUpdateBusinessPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "businessPlanId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "businessPlanId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BusinessPlan" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feePerNum" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feePerNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPeakDayFeeFree" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateBusinessPlanError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateBusinessPlanMutation,
  AdminCreateOrUpdateBusinessPlanMutationVariables
>;
export const AdminBusinessPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBusinessPlans" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBusinessPlans" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "BusinessPlansTable_BusinessPlan",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BusinessPlansTable_BusinessPlan" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BusinessPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "feePerNum" } },
          { kind: "Field", name: { kind: "Name", value: "feePerNights" } },
          { kind: "Field", name: { kind: "Name", value: "isPeakDayFeeFree" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBusinessPlansQuery,
  AdminBusinessPlansQueryVariables
>;
export const AdminCancelFeePolicyDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCancelFeePolicyDetail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rawCancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelFeePolicyDetailQuery,
  AdminCancelFeePolicyDetailQueryVariables
>;
export const AdminCancelFeePoliciesContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCancelFeePoliciesContent" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelFeePoliciesContentQuery,
  AdminCancelFeePoliciesContentQueryVariables
>;
export const AdminCreateOrUpdateCancelFeePolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateCancelFeePolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateCancelFeePolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateCancelFeePolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RawCancelFeePolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelFeePolicy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CancelFeeRatePolicy",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "before1DaysRate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "before3DaysRate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "before7DaysRate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "immediate" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CancelFeeFixedPolicy",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "before1DaysFee",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "before3DaysFee",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "before7DaysFee",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "immediate" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateCancelFeePolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateCancelFeePolicyMutation,
  AdminCreateOrUpdateCancelFeePolicyMutationVariables
>;
export const AdminCancelFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCancelFeePolicies" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelFeePoliciesQuery,
  AdminCancelFeePoliciesQueryVariables
>;
export const AdminCleaningTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCleaningTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "unrestricted" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacilityReservations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "Reserved" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "guestName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "unrestricted" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facility" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isCleaningReportEnabled",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sites" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservation" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "unrestricted" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastNight" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "startAt" } },
                { kind: "Field", name: { kind: "Name", value: "endAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cleaningReport" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCleaningTasksQuery,
  AdminCleaningTasksQueryVariables
>;
export const AdminCoOwnersApplicationCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationComment_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationComment_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationCommentQuery,
  AdminCoOwnersApplicationCommentQueryVariables
>;
export const AdminCoOwnersApplicationHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationHeader_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationHeader_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationHeaderQuery,
  AdminCoOwnersApplicationHeaderQueryVariables
>;
export const AdminCoOwnersApplicationOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationOverview_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationOverview_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationFacilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "s2oPoint" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationOverviewQuery,
  AdminCoOwnersApplicationOverviewQueryVariables
>;
export const AdminUpdateCoOwnersApplicationInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateCoOwnersApplicationInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoOwnersApplicationInfoInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateCoOwnersApplicationInfo",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "disclosureAssitant" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "applicationFeePaymentMethod",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "registrationFeePaymentMethod",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "remainingAmountPaymentMethod",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "advancePaymentRequired" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "desiredHandoverDate" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "friendReferralDiscountAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "employeeReferralDiscountAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalPurchaseDiscountAmount",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalPurchaseDiscountNote",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherDiscountAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherDiscountNote" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "applicantInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isPep" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "purchasePurpose" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "purchasePurposeFree",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "identificationDocumentType",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "identificationDocument1",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "identificationDocument2",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "detail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "CoOwnersApplicantInfoDetailIndividual",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "householdIncome",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "personalFinancialAssets",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "employerName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "intendedUsage",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "useLoan",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "CoOwnersApplicantInfoDetailOrganization",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organizationName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organizationAddress",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "postalCode",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line1",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line2",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "representativeName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "businessActivity",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "businessActivityFree",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organizationRelationship",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "registryCertificateDocuments",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "rawUrl",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "beneficialOwnerRelationship",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "beneficialOwnerRelationshipFree",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerBirthDate",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerAddress",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "postalCode",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line1",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line2",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerOthers",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "selectedWebinarSchedule",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startsAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "events" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "submittedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviewedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "invitedToDisclosureAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participatedInDisclosureAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contractSignedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "advancePaymentReceivedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "paymentReceivedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "handoverCompletedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelledAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateCoOwnersApplicationInfoError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateCoOwnersApplicationInfoMutation,
  AdminUpdateCoOwnersApplicationInfoMutationVariables
>;
export const AdminCoOwnersApplicantInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicantInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicantInfo_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicantInfo_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isPep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "purchasePurpose" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "purchasePurposeFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailIndividual",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "householdIncome" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "personalFinancialAssets",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "employerName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "intendedUsage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "useLoan" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailOrganization",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "organizationAddress",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line2" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "representativeName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "businessActivity" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "businessActivityFree",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "organizationRelationship",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "registryCertificateDocuments",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerRelationship",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerRelationshipFree",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerName",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerBirthDate",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerAddress",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line2" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "beneficialOwnerOthers",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicantInfoQuery,
  AdminCoOwnersApplicantInfoQueryVariables
>;
export const AdminUpdateCoOwnersApplicationDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateCoOwnersApplicationDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoOwnersApplicationDetailInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateCoOwnersApplicationDetail",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "applicantInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isPep" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "purchasePurpose" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "purchasePurposeFree",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "identificationDocumentType",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "identificationDocument1",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "identificationDocument2",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "detail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "CoOwnersApplicantInfoDetailIndividual",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "householdIncome",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "personalFinancialAssets",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "employerName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "intendedUsage",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "useLoan",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "CoOwnersApplicantInfoDetailOrganization",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organizationName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organizationAddress",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "postalCode",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line1",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line2",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "representativeName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "businessActivity",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "businessActivityFree",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organizationRelationship",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "registryCertificateDocuments",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "rawUrl",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "beneficialOwnerRelationship",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "beneficialOwnerRelationshipFree",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerBirthDate",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerAddress",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "postalCode",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line1",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "line2",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "beneficialOwnerOthers",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateCoOwnersApplicationDetailError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateCoOwnersApplicationDetailMutation,
  AdminUpdateCoOwnersApplicationDetailMutationVariables
>;
export const AdminCoOwnersApplicationFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allFiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDeleted" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deletedAt" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "CoOwnersApplicationFileRow_CoOwnersApplicationFile",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationFileRow_CoOwnersApplicationFile",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplicationFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fileName" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "visibleToApplicant" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "isAdmin" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationFilesQuery,
  AdminCoOwnersApplicationFilesQueryVariables
>;
export const AdminCreateCoOwnersApplicationFileUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateCoOwnersApplicationFileUploadPolicy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateCoOwnersApplicationFileUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateCoOwnersApplicationFileUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateCoOwnersApplicationFileUploadPolicyMutation,
  AdminCreateCoOwnersApplicationFileUploadPolicyMutationVariables
>;
export const AdminRegisterCoOwnersApplicationFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRegisterCoOwnersApplicationFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalRegisterCoOwnersApplicationFileInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalRegisterCoOwnersApplicationFile",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "RegisterCoOwnersApplicationFileError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRegisterCoOwnersApplicationFileMutation,
  AdminRegisterCoOwnersApplicationFileMutationVariables
>;
export const AdminCreateCoOwnersApplicationFileDownloadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateCoOwnersApplicationFileDownloadUrl",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateCoOwnersApplicationFileDownloadUrl",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationFileId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateCoOwnersApplicationFileDownloadUrlSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateCoOwnersApplicationFileDownloadUrlMutation,
  AdminCreateCoOwnersApplicationFileDownloadUrlMutationVariables
>;
export const AdminUpdateCoOwnersApplicationFileVisibilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminUpdateCoOwnersApplicationFileVisibility",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "visibleToApplicant" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateCoOwnersApplicationFileVisibility",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationFileId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "visibleToApplicant" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "visibleToApplicant" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplicationFile" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "visibleToApplicant" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateCoOwnersApplicationFileVisibilityMutation,
  AdminUpdateCoOwnersApplicationFileVisibilityMutationVariables
>;
export const AdminDeleteCoOwnersApplicationFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteCoOwnersApplicationFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteCoOwnersApplicationFile",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationFileId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplicationFile" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deletedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deletedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteCoOwnersApplicationFileMutation,
  AdminDeleteCoOwnersApplicationFileMutationVariables
>;
export const AdminCoOwnersApplicationIdentityVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminCoOwnersApplicationIdentityVerification",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "CoOwnersApplicationIdentityVerification_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "IdentityVerificationItem_IdentityVerification",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentityVerification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "result" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustdockVerificationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustdockOperationPageUrl" },
          },
          { kind: "Field", name: { kind: "Name", value: "submissionPageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "submissionPageUrlExpiresAt" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationIdentityVerification_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "identityVerifications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "IdentityVerificationItem_IdentityVerification",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identificationDocumentType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identificationDocument1" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identificationDocument2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationIdentityVerificationQuery,
  AdminCoOwnersApplicationIdentityVerificationQueryVariables
>;
export const AdminCreateCoOwnersIdentityVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateCoOwnersIdentityVerification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coOwnersApplicationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateCoOwnersIdentityVerificationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateCoOwnersIdentityVerification",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "coOwnersApplicationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "IdentityVerification" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "method" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "result" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateCoOwnersIdentityVerificationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateCoOwnersIdentityVerificationMutation,
  AdminCreateCoOwnersIdentityVerificationMutationVariables
>;
export const AdminCreateUserFileUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateUserFileUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateUserFileUploadPolicyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUserFileUploadPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateUserFileUploadPolicyMutation,
  AdminCreateUserFileUploadPolicyMutationVariables
>;
export const AdminCoOwnersApplicationManagementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationManagement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationManagement_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationManagement_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestedOtherWebinarSchedule" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "disclosureAssitant" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "otherFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "caption" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationManagementQuery,
  AdminCoOwnersApplicationManagementQueryVariables
>;
export const AdminWebinarScheduleOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminWebinarScheduleOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "applicationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "applicationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersWebinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminWebinarScheduleOptionsQuery,
  AdminWebinarScheduleOptionsQueryVariables
>;
export const AdminAppendS2oPointsToCoOwnersApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminAppendS2oPointsToCoOwnersApplication",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coOwnersApplicationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amount" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAppendS2oPointsToCoOwnersApplication",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "coOwnersApplicationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "amount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "amount" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalAppendS2oPointsToCoOwnersApplicationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAppendS2oPointsToCoOwnersApplicationMutation,
  AdminAppendS2oPointsToCoOwnersApplicationMutationVariables
>;
export const AdminCoOwnersApplicationPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationPayment_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationPayment_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "registrationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingAmountPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "friendReferralDiscountAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "employeeReferralDiscountAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalPurchaseDiscountAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalPurchaseDiscountNote" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "otherDiscountAmount" },
          },
          { kind: "Field", name: { kind: "Name", value: "otherDiscountNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "s2oPoint" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "s2o" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balance" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationPaymentQuery,
  AdminCoOwnersApplicationPaymentQueryVariables
>;
export const AdminCancelCoOwnersApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCancelCoOwnersApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "events" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "submittedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviewedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "invitedToDisclosureAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participatedInDisclosureAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contractSignedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "advancePaymentReceivedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "paymentReceivedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "handoverCompletedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelledAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCancelCoOwnersApplicationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelCoOwnersApplicationMutation,
  AdminCancelCoOwnersApplicationMutationVariables
>;
export const AdminCoOwnersApplicationStatusTabDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplicationStatusTab" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationStatusTab_CoOwnersApplication",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ApplicationSummaryList_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayCreditOverrideSheet_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CancelApplicationDialog_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicationFeePaymentMethod" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ApplicationSummaryList_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusActionButtons_CoOwnersApplication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "StayCreditOverrideSheet_CoOwnersApplication",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "CancelApplicationDialog_CoOwnersApplication",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationStatusTab_CoOwnersApplication",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitSales" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saleYearMonth" },
                },
                { kind: "Field", name: { kind: "Name", value: "soldAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "StatusActionButtons_CoOwnersApplication",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                { kind: "Field", name: { kind: "Name", value: "reviewedAt" } },
                { kind: "Field", name: { kind: "Name", value: "completedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitedToDisclosureAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participatedInDisclosureAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contractSignedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advancePaymentReceivedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentReceivedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverCompletedAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationStatusTabQuery,
  AdminCoOwnersApplicationStatusTabQueryVariables
>;
export const AdminInternalMarkCoOwnersApplicationSoldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminInternalMarkCoOwnersApplicationSold" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalMarkCoOwnersApplicationSold",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitSales" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "units" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "saleYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "soldAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalMarkCoOwnersApplicationSoldError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminInternalMarkCoOwnersApplicationSoldMutation,
  AdminInternalMarkCoOwnersApplicationSoldMutationVariables
>;
export const AdminInternalMarkCoOwnersApplicationPlannedForSaleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminInternalMarkCoOwnersApplicationPlannedForSale",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "units" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "saleYearMonth" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainYearMonth" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalMarkCoOwnersApplicationPlannedForSale",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "units" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "units" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "saleYearMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "saleYearMonth" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitSales" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "units" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "saleYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "soldAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalMarkCoOwnersApplicationPlannedForSaleError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminInternalMarkCoOwnersApplicationPlannedForSaleMutation,
  AdminInternalMarkCoOwnersApplicationPlannedForSaleMutationVariables
>;
export const AdminInternalVoidCoOwnersApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminInternalVoidCoOwnersApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalVoidCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "events" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "submittedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "handoverCompletedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelledAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalVoidCoOwnersApplicationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminInternalVoidCoOwnersApplicationMutation,
  AdminInternalVoidCoOwnersApplicationMutationVariables
>;
export const AdminUpdateCoOwnersApplicationStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateCoOwnersApplicationStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoOwnersApplicationStatusInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateCoOwnersApplicationStatus",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "events" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "submittedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviewedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "invitedToDisclosureAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participatedInDisclosureAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contractSignedAt" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "advancePaymentReceivedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "paymentReceivedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "handoverCompletedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelledAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateCoOwnersApplicationStatusError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateCoOwnersApplicationStatusMutation,
  AdminUpdateCoOwnersApplicationStatusMutationVariables
>;
export const AdminCoOwnersApplicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersApplications" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersApplications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitNightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitPurchaseAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accommodationFacilities",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "events" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "submittedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersApplicationsQuery,
  AdminCoOwnersApplicationsQueryVariables
>;
export const AdminCoOwnersInvoiceAnnualPaymentItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersInvoiceAnnualPaymentItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "programYear" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCoOwnersBakurakuInvoiceAnnualPaymentItems",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "programYear" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "programYear" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipientCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "taxRate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentDueDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersInvoiceAnnualPaymentItemsQuery,
  AdminCoOwnersInvoiceAnnualPaymentItemsQueryVariables
>;
export const AdminCoOwnersInvoiceRecipientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersInvoiceRecipients" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCoOwnersBakurakuInvoiceRecipients",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipientName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departmentName" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailDelivery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersInvoiceRecipientsQuery,
  AdminCoOwnersInvoiceRecipientsQueryVariables
>;
export const AdminCoOwnersInvoiceRegistrationFeeItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersInvoiceRegistrationFeeItems" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCoOwnersBakurakuInvoiceRegistrationFeeItems",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipientCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "taxRate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentDueDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersInvoiceRegistrationFeeItemsQuery,
  AdminCoOwnersInvoiceRegistrationFeeItemsQueryVariables
>;
export const AdminCoOwnersInvoiceRemainingPaymentItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminCoOwnersInvoiceRemainingPaymentItems",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCoOwnersBakurakuInvoiceRemainingPaymentItems",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipientCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "taxRate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentDueDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value:
                "internalCoOwnersBakurakuInvoiceRemainingPaymentExcludedApplicationCount",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersInvoiceRemainingPaymentItemsQuery,
  AdminCoOwnersInvoiceRemainingPaymentItemsQueryVariables
>;
export const AdminCoOwnersWebinarScheduleDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersWebinarScheduleDetail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersWebinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "applicant" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ownerPlan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersWebinarScheduleDetailQuery,
  AdminCoOwnersWebinarScheduleDetailQueryVariables
>;
export const AdminCoOwnersWebinarSchedulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminCoOwnersWebinarSchedules" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCoOwnersWebinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCoOwnersWebinarSchedulesQuery,
  AdminCoOwnersWebinarSchedulesQueryVariables
>;
export const AdminWebinarScheduleSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminWebinarScheduleSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminWebinarScheduleSitesQuery,
  AdminWebinarScheduleSitesQueryVariables
>;
export const AdminCreateOrUpdateCoOwnersWebinarScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateCoOwnersWebinarSchedule",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateCoOwnersWebinarScheduleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateCoOwnersWebinarSchedule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersWebinarSchedule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startsAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateCoOwnersWebinarScheduleError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateCoOwnersWebinarScheduleMutation,
  AdminCreateOrUpdateCoOwnersWebinarScheduleMutationVariables
>;
export const AdminBulkCreateAvailabilityBlocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminBulkCreateAvailabilityBlocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "CreateAccommodationAvailabilityBlockInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBulkCreateAccommodationAvailabilityBlocks",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "success" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "beginNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "input" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "beginNight" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endNight" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accommodationId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBulkCreateAvailabilityBlocksMutation,
  AdminBulkCreateAvailabilityBlocksMutationVariables
>;
export const AdminBlockMatrixDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBlockMatrix" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scope" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccommodationScope" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "from" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seriesShortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationReservationsBySearch",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "from" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "to" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "scope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationAvailabilityBlocks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startEndNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "from" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endBeginNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "to" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "scope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "beginNight" } },
                { kind: "Field", name: { kind: "Name", value: "endNight" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBlockMatrixQuery,
  AdminBlockMatrixQueryVariables
>;
export const AdminCsvBulkCreateAvailabilityBlocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCsvBulkCreateAvailabilityBlocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "CreateAccommodationAvailabilityBlockInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBulkCreateAccommodationAvailabilityBlocks",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "success" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "beginNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "input" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "beginNight" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endNight" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "siteId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accommodationId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCsvBulkCreateAvailabilityBlocksMutation,
  AdminCsvBulkCreateAvailabilityBlocksMutationVariables
>;
export const AdminBlockCsvMastersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBlockCsvMasters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "accommodationAvailabilityBlockCategoryInfos",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBlockCsvMastersQuery,
  AdminBlockCsvMastersQueryVariables
>;
export const AdminBulkBlockMastersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBulkBlockMasters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mapImageUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "accommodationAvailabilityBlockCategoryInfos",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBulkBlockMastersQuery,
  AdminBulkBlockMastersQueryVariables
>;
export const AdminEquipmentAccommodationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminEquipmentAccommodations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sanuEdgeDevices" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "deviceId" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminEquipmentAccommodationsQuery,
  AdminEquipmentAccommodationsQueryVariables
>;
export const AdminCreateAccommodationEquipmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateAccommodationEquipment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateAccommodationEquipmentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateAccommodationEquipment",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationEquipment" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "EquipmentDetailSheet_AccommodationEquipment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAccommodationEquipmentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "EquipmentDetailSheet_AccommodationEquipment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationEquipment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sanuEdgeDevices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WifiEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "primary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "secondary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "MusicConnectEquipmentAttribute",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruction" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SaunaEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAccommodationEquipmentMutation,
  AdminCreateAccommodationEquipmentMutationVariables
>;
export const AdminUpdateAccommodationEquipmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateAccommodationEquipment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateAccommodationEquipmentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateAccommodationEquipment",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationEquipment" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "EquipmentDetailSheet_AccommodationEquipment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAccommodationEquipmentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "EquipmentDetailSheet_AccommodationEquipment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationEquipment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sanuEdgeDevices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WifiEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "primary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "secondary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "MusicConnectEquipmentAttribute",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruction" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SaunaEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateAccommodationEquipmentMutation,
  AdminUpdateAccommodationEquipmentMutationVariables
>;
export const AdminDeleteAccommodationEquipmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteAccommodationEquipment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteAccommodationEquipment",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalDeleteAccommodationEquipmentSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAccommodationEquipmentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteAccommodationEquipmentMutation,
  AdminDeleteAccommodationEquipmentMutationVariables
>;
export const AdminEquipmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminEquipments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationEquipments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "EquipmentDetailSheet_AccommodationEquipment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "EquipmentDetailSheet_AccommodationEquipment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationEquipment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sanuEdgeDevices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WifiEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "primary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "secondary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ssid" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "password" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "MusicConnectEquipmentAttribute",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instruction" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SaunaEquipmentAttribute" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminEquipmentsQuery,
  AdminEquipmentsQueryVariables
>;
export const AdminUpdateFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateFeePolicies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateFeePoliciesMutation,
  AdminUpdateFeePoliciesMutationVariables
>;
export const AdminFacilityFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityFeePolicies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identifier" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityFeePoliciesQuery,
  AdminFacilityFeePoliciesQueryVariables
>;
export const AdminDeleteFeePolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteFeePolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteFeePolicyMutation,
  AdminDeleteFeePolicyMutationVariables
>;
export const AdminFacilityEditSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityEditSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityEditSitesQuery,
  AdminFacilityEditSitesQueryVariables
>;
export const AdminUpdateFacilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateFacility" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateFacilityMutation,
  AdminUpdateFacilityMutationVariables
>;
export const AdminFacilityBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReserveEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
                { kind: "Field", name: { kind: "Name", value: "termsUrl" } },
                { kind: "Field", name: { kind: "Name", value: "termsLabel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelDeadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelDeadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EditFacilitySheet" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EditFacilitySheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "isVisibleEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isCleaningReportEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "isDataSyncEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "termsUrl" } },
          { kind: "Field", name: { kind: "Name", value: "termsLabel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "baseFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitFeeAmount" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeModifierType" },
                },
                { kind: "Field", name: { kind: "Name", value: "feeValue" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slots" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                { kind: "Field", name: { kind: "Name", value: "startMinute" } },
                { kind: "Field", name: { kind: "Name", value: "endHour" } },
                { kind: "Field", name: { kind: "Name", value: "endMinute" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityBasicInfoQuery,
  AdminFacilityBasicInfoQueryVariables
>;
export const AdminUpdateFacilityImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateFacilityImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateFacilityImageMutation,
  AdminUpdateFacilityImageMutationVariables
>;
export const AdminFacilityForBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityForBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityForBlockQuery,
  AdminFacilityForBlockQueryVariables
>;
export const AdminCreateFacilityResourceBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateFacilityResourceBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateFacilityResourceBlockInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateFacilityResourceBlock",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityResourceBlockError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateFacilityResourceBlockMutation,
  AdminCreateFacilityResourceBlockMutationVariables
>;
export const AdminFacilityDetailBlocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityDetailBlocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "blockType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FacilityResourceBlockType" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resourceId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacilityResourceBlocks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "blockType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "blockType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "resourceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "resourceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facility" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "startAt" } },
                { kind: "Field", name: { kind: "Name", value: "endAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resourceBlockType" },
                },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityDetailBlocksQuery,
  AdminFacilityDetailBlocksQueryVariables
>;
export const AdminDeleteFacilityResourceBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteFacilityResourceBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteFacilityResourceBlock",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalDeleteFacilityResourceBlockError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteFacilityResourceBlockMutation,
  AdminDeleteFacilityResourceBlockMutationVariables
>;
export const AdminFacilityDetailBlocksResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityDetailBlocksResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityDetailBlocksResourcesQuery,
  AdminFacilityDetailBlocksResourcesQueryVariables
>;
export const AdminUpdateCancelFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateCancelFeePolicies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateCancelFeePoliciesMutation,
  AdminUpdateCancelFeePoliciesMutationVariables
>;
export const AdminFacilityCancelFeePoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityCancelFeePolicies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deadlineDaysBefore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deadlineHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifierType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeValue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identifier" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityCancelFeePoliciesQuery,
  AdminFacilityCancelFeePoliciesQueryVariables
>;
export const AdminDeleteCancelFeePolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteCancelFeePolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteCancelFeePolicyMutation,
  AdminDeleteCancelFeePolicyMutationVariables
>;
export const AdminUpdateFacilityContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateFacilityContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateFacilityContentMutation,
  AdminUpdateFacilityContentMutationVariables
>;
export const AdminFacilityContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentUsage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentNotice" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentGuide" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityContentQuery,
  AdminFacilityContentQueryVariables
>;
export const AdminUpdateFacilityContentImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateFacilityContentImages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateFacilityContentImagesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateFacilityContentImages",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateFacilityContentImagesMutation,
  AdminUpdateFacilityContentImagesMutationVariables
>;
export const AdminFacilityTabsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityTabs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReserveEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityTabsQuery,
  AdminFacilityTabsQueryVariables
>;
export const AdminFacilityForReservationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityForReservationForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationReservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isForce" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationReservationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                { kind: "Field", name: { kind: "Name", value: "termsUrl" } },
                { kind: "Field", name: { kind: "Name", value: "termsLabel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "discountFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discountModifierType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discountValue" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isReservable" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "isForce" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "isForce" },
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "baseFeePolicies" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unit" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unitFeeAmount" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "slotAvailabilities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "isForce" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "isForce" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slotId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isReservable" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "unavailableReason",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customFields" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "required" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityForReservationFormQuery,
  AdminFacilityForReservationFormQueryVariables
>;
export const AdminCreateFacilityReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateFacilityReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateFacilityReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateFacilityReservationMutation,
  AdminCreateFacilityReservationMutationVariables
>;
export const AdminFacilityForReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityForReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityForReservationQuery,
  AdminFacilityForReservationQueryVariables
>;
export const AdminCancelFacilityReservationSharedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCancelFacilityReservationShared" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelFacilityReservationSharedMutation,
  AdminCancelFacilityReservationSharedMutationVariables
>;
export const AdminFacilityDetailReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityDetailReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FacilityReservationStatusType" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resourceId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacilityReservations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "resourceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "resourceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startAt" } },
                { kind: "Field", name: { kind: "Name", value: "endAt" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargedFeeAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facility" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isDataSyncEnabled",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataSync" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FacilityReservationDetailSheet_FacilityReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationUsageSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value:
          "FacilityReservationControllerAttributeSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationDetailSheet_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "totalFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "discountAmount" } },
          { kind: "Field", name: { kind: "Name", value: "chargedFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "discountReason" } },
          { kind: "Field", name: { kind: "Name", value: "termsAgreedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facility" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isDataSyncEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataSync" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customFieldValues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FacilityReservationUsageSection_FacilityReservation",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value:
                "FacilityReservationControllerAttributeSection_FacilityReservation",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityDetailReservationsQuery,
  AdminFacilityDetailReservationsQueryVariables
>;
export const AdminCancelFacilityReservationFromListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCancelFacilityReservationFromList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCancelFacilityReservationFromListMutation,
  AdminCancelFacilityReservationFromListMutationVariables
>;
export const UpdateFacilityReservationCleaningDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFacilityReservationCleaning" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FacilityReservationCleaningStatus",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateFacilityReservationCleaning",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateFacilityReservationCleaningError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFacilityReservationCleaningMutation,
  UpdateFacilityReservationCleaningMutationVariables
>;
export const UpdateFacilityReservationDataSyncDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFacilityReservationDataSync" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FacilityReservationDataSyncStatus",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateFacilityReservationDataSync",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateFacilityReservationDataSyncError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFacilityReservationDataSyncMutation,
  UpdateFacilityReservationDataSyncMutationVariables
>;
export const AdminFacilityUsageOperatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityUsageOperator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityUsageOperatorQuery,
  AdminFacilityUsageOperatorQueryVariables
>;
export const AdminUpdateFacilityReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateFacilityReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateFacilityReservationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateFacilityReservationSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "controllers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "controllerAttribute",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateFacilityReservationMutation,
  AdminUpdateFacilityReservationMutationVariables
>;
export const AdminFacilityDetailReservationsResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityDetailReservationsResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityDetailReservationsResourcesQuery,
  AdminFacilityDetailReservationsResourcesQueryVariables
>;
export const AdminAccommodationReservationsForFacilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AdminAccommodationReservationsForFacility",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startLastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationScope" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccommodationScope" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FacilityType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationReservationsBySearch",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationScope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFacilityReservable" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "facilityType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "facilityType" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "isForce" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAccommodationReservationsForFacilityQuery,
  AdminAccommodationReservationsForFacilityQueryVariables
>;
export const AdminUpdateResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateResourcesMutation,
  AdminUpdateResourcesMutationVariables
>;
export const AdminFacilityResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReserveEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customInvoiceLabel" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "format" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resourceControllers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attribute" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityResourcesQuery,
  AdminFacilityResourcesQueryVariables
>;
export const AdminDeleteFacilityResourceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteFacilityResource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteFacilityResourceMutation,
  AdminDeleteFacilityResourceMutationVariables
>;
export const AdminCreateSlotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSlot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSlotMutation,
  AdminCreateSlotMutationVariables
>;
export const AdminFacilitySlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilitySlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "slots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identifier" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilitySlotsQuery,
  AdminFacilitySlotsQueryVariables
>;
export const AdminDeleteSlotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteSlot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteSlotMutation,
  AdminDeleteSlotMutationVariables
>;
export const AdminCreateFacilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateFacility" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateFacilityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateFacilityError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateFacilityMutation,
  AdminCreateFacilityMutationVariables
>;
export const AdminFacilitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FacilityType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacilities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReserveEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelDeadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelDeadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilitiesQuery,
  AdminFacilitiesQueryVariables
>;
export const AdminFacilityHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilityHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFacility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilityHeaderQuery,
  AdminFacilityHeaderQueryVariables
>;
export const AdminFacilitiesSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFacilitiesSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFacilitiesSitesQuery,
  AdminFacilitiesSitesQueryVariables
>;
export const AdminCreateFacilityImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateFacilityImageUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateFacilityImageUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateFacilityImageUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateFacilityImageUploadPolicyMutation,
  AdminCreateFacilityImageUploadPolicyMutationVariables
>;
export const AdminViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maybeProfile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facePhoto" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminViewerQuery, AdminViewerQueryVariables>;
export const AdminDeleteLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalDeleteLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteLocalTaxPolicyMutation,
  AdminDeleteLocalTaxPolicyMutationVariables
>;
export const AdminUpdateLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateLocalTaxPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LocalTaxPolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effectiveTo" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateLocalTaxPolicyMutation,
  AdminUpdateLocalTaxPolicyMutationVariables
>;
export const AdminLocalTaxPolicyHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminLocalTaxPolicyHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taxType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localGovernmentName" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminLocalTaxPolicyHeaderQuery,
  AdminLocalTaxPolicyHeaderQueryVariables
>;
export const AdminLocalTaxPolicyDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminLocalTaxPolicyDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taxType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localGovernmentName" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "effectiveTo" } },
                { kind: "Field", name: { kind: "Name", value: "waiveKids" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "brackets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "taxAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "taxRate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxTaxAmount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminLocalTaxPolicyDetailQuery,
  AdminLocalTaxPolicyDetailQueryVariables
>;
export const AdminCreateLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateLocalTaxPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LocalTaxPolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateLocalTaxPolicyMutation,
  AdminCreateLocalTaxPolicyMutationVariables
>;
export const AdminLocalTaxPoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminLocalTaxPolicies" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalLocalTaxPolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taxType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localGovernmentName" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "effectiveTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminLocalTaxPoliciesQuery,
  AdminLocalTaxPoliciesQueryVariables
>;
export const AdminCreateOrUpdateNativeAppHomeContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateNativeAppHomeContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalNativeAppHomeContentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateNativeAppHomeContent",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalNativeAppHomeContent",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "title" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "label" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "labelType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "link" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "linkLabel" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "linkAction" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateNativeAppHomeContentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateNativeAppHomeContentMutation,
  AdminCreateOrUpdateNativeAppHomeContentMutationVariables
>;
export const AdminNativeAppHomeContentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminNativeAppHomeContents" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalNativeAppHomeContents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "title" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                      { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                      { kind: "Field", name: { kind: "Name", value: "zhTw" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "description" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                      { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                      { kind: "Field", name: { kind: "Name", value: "zhTw" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "label" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                      { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                      { kind: "Field", name: { kind: "Name", value: "zhTw" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "labelType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "link" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                      { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                      { kind: "Field", name: { kind: "Name", value: "zhTw" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linkLabel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                      { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                      { kind: "Field", name: { kind: "Name", value: "zhTw" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "linkAction" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminNativeAppHomeContentsQuery,
  AdminNativeAppHomeContentsQueryVariables
>;
export const AdminCreateNativeAppHomeContentImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateNativeAppHomeContentImageUploadPolicy",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateNativeAppHomeContentImageUploadPolicy",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateNativeAppHomeContentImageUploadPolicyMutation,
  AdminCreateNativeAppHomeContentImageUploadPolicyMutationVariables
>;
export const AdminSendPushNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSendPushNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalSendPushNotificationsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSendPushNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalSendPushNotificationsResult",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deliveredEmails" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notFoundEmails" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noDeviceEmails" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "failedEmails" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalSendPushNotificationsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSendPushNotificationsMutation,
  AdminSendPushNotificationsMutationVariables
>;
export const AdminNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminNews" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "NewsTable_RawNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NewsTable_RawNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RawNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "displayCategory" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "targetPlans" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminNewsQuery, AdminNewsQueryVariables>;
export const AdminCreateOrUpdateNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateOrUpdateNewsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOrUpdateNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "News" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayCategory" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateNewsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateNewsMutation,
  AdminCreateOrUpdateNewsMutationVariables
>;
export const AdminNewsTopPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminNewsTopPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "topPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serviceUpdate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "isNew" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "archiveArticle" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "isNew" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "news" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminNewsTopPageQuery,
  AdminNewsTopPageQueryVariables
>;
export const AdminAllOrganizationContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAllOrganizationContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ContractStatus" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startMonth" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainYearMonthFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endMonth" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainYearMonthFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "OrganizationYearlyContractSortInput",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startingAfter" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalOrganizationYearlyContracts",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startMonth" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endMonth" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sort" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startingAfter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startingAfter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "hasMore" } },
                { kind: "Field", name: { kind: "Name", value: "nextCursor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "OrganizationContractsListTable_OrganizationYearlyContract",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationContractsListTable_OrganizationYearlyContract",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrganizationYearlyContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "startMonth" } },
          { kind: "Field", name: { kind: "Name", value: "endMonth" } },
          { kind: "Field", name: { kind: "Name", value: "amountRecord" } },
          { kind: "Field", name: { kind: "Name", value: "totalFee" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerMonth" } },
          { kind: "Field", name: { kind: "Name", value: "continuationType" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdInvoiceCount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultFrequency" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultPaymentMethod" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAllOrganizationContractsQuery,
  AdminAllOrganizationContractsQueryVariables
>;
export const AdminOrganizationContractOrganizationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationContractOrganizations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationContractOrganizationsQuery,
  AdminOrganizationContractOrganizationsQueryVariables
>;
export const AdminAllOrganizationInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAllOrganizationInvoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "StripeInvoiceStatus" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractStartMonth" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainYearMonthFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractEndMonth" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainYearMonthFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startingAfter" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalOrganizationYearlyContractInvoices",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractStartMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractStartMonth" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractEndMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractEndMonth" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startingAfter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startingAfter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "hasMore" } },
                { kind: "Field", name: { kind: "Name", value: "nextCursor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrganizationInvoicesListTable_StripeInvoice",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationInvoicesListTable_StripeInvoice",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StripeInvoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "collection_method" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadata_list" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAllOrganizationInvoicesQuery,
  AdminAllOrganizationInvoicesQueryVariables
>;
export const AdminOrganizationInvoiceOrganizationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationInvoiceOrganizations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationInvoiceOrganizationsQuery,
  AdminOrganizationInvoiceOrganizationsQueryVariables
>;
export const AdminBusinessPlansForContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBusinessPlansForContract" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBusinessPlans" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBusinessPlansForContractQuery,
  AdminBusinessPlansForContractQueryVariables
>;
export const AdminCreateOrUpdateOrganizationYearlyContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateOrganizationYearlyContract",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateOrganizationYearlyContractInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateOrganizationYearlyContract",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OrganizationYearlyContract" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amountRecord" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nightsPerMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "continuationType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessPlan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateOrganizationYearlyContractError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateOrganizationYearlyContractMutation,
  AdminCreateOrUpdateOrganizationYearlyContractMutationVariables
>;
export const AdminInvalidateOrganizationYearlyContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminInvalidateOrganizationYearlyContract",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalInvalidateOrganizationYearlyContract",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalInvalidateOrganizationYearlyContractError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminInvalidateOrganizationYearlyContractMutation,
  AdminInvalidateOrganizationYearlyContractMutationVariables
>;
export const AdminOrganizationContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contracts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "OrganizationContractsTable_OrganizationYearlyContract",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationContractsTable_OrganizationYearlyContract",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrganizationYearlyContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "startMonth" } },
          { kind: "Field", name: { kind: "Name", value: "endMonth" } },
          { kind: "Field", name: { kind: "Name", value: "amountRecord" } },
          { kind: "Field", name: { kind: "Name", value: "totalFee" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerMonth" } },
          { kind: "Field", name: { kind: "Name", value: "continuationType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "businessPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationContractsQuery,
  AdminOrganizationContractsQueryVariables
>;
export const AdminUpdateOrganizationYearlyContractInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminUpdateOrganizationYearlyContractInvoice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateOrganizationYearlyContractInvoiceInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateOrganizationYearlyContractInvoice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateOrganizationYearlyContractInvoiceMutation,
  AdminUpdateOrganizationYearlyContractInvoiceMutationVariables
>;
export const AdminFinalizeOrganizationYearlyContractInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminFinalizeOrganizationYearlyContractInvoice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalFinalizeOrganizationYearlyContractInvoice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFinalizeOrganizationYearlyContractInvoiceMutation,
  AdminFinalizeOrganizationYearlyContractInvoiceMutationVariables
>;
export const AdminInvalidateOrganizationYearlyContractInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminInvalidateOrganizationYearlyContractInvoice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalInvalidateOrganizationYearlyContractInvoice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalInvalidateOrganizationYearlyContractInvoiceError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminInvalidateOrganizationYearlyContractInvoiceMutation,
  AdminInvalidateOrganizationYearlyContractInvoiceMutationVariables
>;
export const AdminCreateOrganizationYearlyContractInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrganizationYearlyContractInvoice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateOrganizationYearlyContractInvoiceInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateOrganizationYearlyContractInvoice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrganizationYearlyContractInvoiceMutation,
  AdminCreateOrganizationYearlyContractInvoiceMutationVariables
>;
export const AdminBulkCreateOrganizationYearlyContractInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminBulkCreateOrganizationYearlyContractInvoices",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "BulkCreateOrganizationYearlyContractInvoicesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBulkCreateOrganizationYearlyContractInvoices",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalBulkCreateOrganizationYearlyContractInvoicesSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoiceIds" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalBulkCreateOrganizationYearlyContractInvoicesError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orphanedInvoiceIds" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBulkCreateOrganizationYearlyContractInvoicesMutation,
  AdminBulkCreateOrganizationYearlyContractInvoicesMutationVariables
>;
export const AdminOrganizationInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationInvoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultFrequency" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultPaymentMethod" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contracts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endMonth" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoices" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "OrganizationInvoicesTable_StripeInvoice",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationInvoicesTable_StripeInvoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StripeInvoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "total" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hosted_invoice_url" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "collection_method" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadata_list" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationInvoicesQuery,
  AdminOrganizationInvoicesQueryVariables
>;
export const AdminOrganizationMemberCandidatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationMemberCandidates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUsersSearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "excludeDeleted" },
                value: { kind: "BooleanValue", value: true },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organizationMembership" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organization" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationMemberCandidatesQuery,
  AdminOrganizationMemberCandidatesQueryVariables
>;
export const AdminJoinOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminJoinOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userEmail" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrganizationRole" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalJoinOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userEmail" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userEmail" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "role" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminJoinOrganizationMutation,
  AdminJoinOrganizationMutationVariables
>;
export const AdminOrganizationMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "members" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrganizationMembersTable_User",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationMembersTable_User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationStatus" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationMembersQuery,
  AdminOrganizationMembersQueryVariables
>;
export const AdminUpdateOrganizationMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateOrganizationMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrganizationRole" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "partialUpdateOrganizationMembership",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "role" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "role" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OrganizationMembership" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "PartialUpdateOrganizationMembershipError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateOrganizationMembershipMutation,
  AdminUpdateOrganizationMembershipMutationVariables
>;
export const AdminLeaveOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminLeaveOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userEmail" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalLeaveOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userEmail" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userEmail" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalLeaveOrganizationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminLeaveOrganizationMutation,
  AdminLeaveOrganizationMutationVariables
>;
export const AdminOrganizationHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignedUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationHeaderQuery,
  AdminOrganizationHeaderQueryVariables
>;
export const AdminOrganizationInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OrganizationStatus_Organization",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OrganizationInfo_Organization",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OrganizationFormSheet_Organization",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationStatus_Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "suspended" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "membersStay" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usedNightsInCurrentContract" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentOrUpcomingContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "startMonth" } },
                { kind: "Field", name: { kind: "Name", value: "endMonth" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationInfo_Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailDomainsForMember" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "control" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerStay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMember" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMonth" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "billingEmail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "announcementContent" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethodCardEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultFrequency" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "memberCustomField" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationFormSheet_Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          { kind: "Field", name: { kind: "Name", value: "billingEmail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailDomainsForMember" },
          },
          { kind: "Field", name: { kind: "Name", value: "suspended" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethodCardEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultFrequency" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "announcementContent" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "control" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerStay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMember" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMonth" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "memberCustomField" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "assignedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationInfoQuery,
  AdminOrganizationInfoQueryVariables
>;
export const AdminOrganizationReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizationReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contracts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedNightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledNightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessPlan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accommodationReservations",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "OrganizationReservationsTable_AccommodationReservation",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationReservationsTable_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "nights" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationReservationsQuery,
  AdminOrganizationReservationsQueryVariables
>;
export const AdminCreateOrUpdateOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrUpdateOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOrUpdateOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Organization" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitationCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailDomainsForMember" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingEmail" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "paymentMethodCardEnabled",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultFrequency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultPaymentMethod" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "announcementContent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "control" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxNightsPerStay" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxNightsPerMember",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxNightsPerMonth",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "memberCustomField" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "placeholder" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "required" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assignedUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateOrganizationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateOrganizationMutation,
  AdminCreateOrUpdateOrganizationMutationVariables
>;
export const AdminOrganizationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOrganizations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitationCode" },
                },
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignedUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentOrUpcomingContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endMonth" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOrganizationsQuery,
  AdminOrganizationsQueryVariables
>;
export const AdminOwnerPlanDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOwnerPlanDetail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOwnerPlans" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "managedName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationFacilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dogFriendlyFilter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitApplicationFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitBuildingFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeePerNight" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "nonOwnedBaseAccommodationFeePerNight",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualMaintenanceFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualRepairReserve" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualLandRentFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualFireInsuranceFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualPropertyTax" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formOfRights" },
                },
                { kind: "Field", name: { kind: "Name", value: "siteSizeSqm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "leasedLandSizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestRoomSizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balconySizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "limitPeakDays" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersMaxPeakDaysPerUnit" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "coOwnersMaxConcurrentReservationsPerUnit",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverStartDate" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "registrationFeeAdvancePaymentDeadline",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "advancePaymentRequired" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "internalCoOwnersPlanOfferings",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isHidden" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSoldOut" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyAccessCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "estimate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOwnerPlanDetailQuery,
  AdminOwnerPlanDetailQueryVariables
>;
export const AdminCreateOrUpdateCoOwnersPlanOfferingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateCoOwnersPlanOffering" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateCoOwnersPlanOfferingInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateCoOwnersPlanOffering",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersPlanOffering" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isHidden" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSoldOut" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyAccessCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "estimate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateCoOwnersPlanOfferingError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateCoOwnersPlanOfferingMutation,
  AdminCreateOrUpdateCoOwnersPlanOfferingMutationVariables
>;
export const AdminCreateSanuOwnerPlanFileUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSanuOwnerPlanFileUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateSanuOwnerPlanFileUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createSanuOwnerPlanFileUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSanuOwnerPlanFileUploadPolicyMutation,
  AdminCreateSanuOwnerPlanFileUploadPolicyMutationVariables
>;
export const AdminOwnerPlanFormOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOwnerPlanFormOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOwnerPlanFormOptionsQuery,
  AdminOwnerPlanFormOptionsQueryVariables
>;
export const AdminOwnerPlanAccommodationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOwnerPlanAccommodations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOwnerPlanAccommodationsQuery,
  AdminOwnerPlanAccommodationsQueryVariables
>;
export const AdminCreateOrUpdateOwnerPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateOwnerPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateOwnerPlanInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOrUpdateOwnerPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OwnerPlan" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "managedName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accommodationFacilities",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dogFriendlyFilter" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitNightsPerYear" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitPurchaseAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitApplicationFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitBuildingFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalUnits" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "baseAccommodationFeePerNight",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "nonOwnedBaseAccommodationFeePerNight",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationFee" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "unitAnnualMaintenanceFee",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "unitAnnualRepairReserve",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitAnnualLandRentFee" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "unitAnnualFireInsuranceFee",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitAnnualPropertyTax" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitAnnualOnsenFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "formOfRights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteSizeSqm" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "leasedLandSizeSqm" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guestRoomSizeSqm" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balconySizeSqm" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "limitPeakDays" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "coOwnersMaxPeakDaysPerUnit",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "handoverStartDate" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "registrationFeeAdvancePaymentDeadline",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateOwnerPlanError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateOwnerPlanMutation,
  AdminCreateOrUpdateOwnerPlanMutationVariables
>;
export const AdminOwnerPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOwnerPlans" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOwnerPlans" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "managedName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationFacilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalUnits" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverStartDate" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOwnerPlansQuery,
  AdminOwnerPlansQueryVariables
>;
export const AdminUpsertConsumedSupplyFeeItemWaiversDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpsertConsumedSupplyFeeItemWaivers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpsertConsumedSupplyFeeItemWaiversInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpsertConsumedSupplyFeeItemWaivers",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpsertConsumedSupplyFeeItemWaiversError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpsertConsumedSupplyFeeItemWaiversMutation,
  AdminUpsertConsumedSupplyFeeItemWaiversMutationVariables
>;
export const AdminReservationBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationBasicInfo_AccommodationReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationBasicInfo_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketMasterId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "otaDetail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "referer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apiReference" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "nights" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "tentativeDeadline" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consumedSuppliesFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationBasicInfoQuery,
  AdminReservationBasicInfoQueryVariables
>;
export const AdminCheckInAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCheckInAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CheckInAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCheckInAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "ReservationStayStatusTab_AccommodationReservation",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CheckInAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationStayStatusTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "accessCode" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkedInGeoLocation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInQrCode" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCheckInAccommodationReservationMutation,
  AdminCheckInAccommodationReservationMutationVariables
>;
export const AdminReservationCompanionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationCompanions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationCompanionsTab_AccommodationReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanionDetailSheet_UserCompanion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserCompanion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "professionType" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "passportNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "passportPhoto" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddressInJapan" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "japanLine2" },
                        name: { kind: "Name", value: "line2" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddressInternational" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "intlLine2" },
                        name: { kind: "Name", value: "line2" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateProvince" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationCompanionsTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "nameKana" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userCompanions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CompanionDetailSheet_UserCompanion",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationCompanionsQuery,
  AdminReservationCompanionsQueryVariables
>;
export const AdminReservationHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStripeDashboardBaseUrl" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationDetailHeader_AccommodationReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationDetailHeader_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "code" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripeInvoiceId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationHeaderQuery,
  AdminReservationHeaderQueryVariables
>;
export const AdminReservationFacilitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationFacilities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "endAt" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargedFeeAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facility" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "FacilityReservationDetailSheet_FacilityReservation",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationUsageSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value:
          "FacilityReservationControllerAttributeSection_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerAttribute" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "FacilityReservationDetailSheet_FacilityReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "totalFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "discountAmount" } },
          { kind: "Field", name: { kind: "Name", value: "chargedFeeAmount" } },
          { kind: "Field", name: { kind: "Name", value: "discountReason" } },
          { kind: "Field", name: { kind: "Name", value: "termsAgreedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facility" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isDataSyncEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataSync" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customFieldValues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FacilityReservationUsageSection_FacilityReservation",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value:
                "FacilityReservationControllerAttributeSection_FacilityReservation",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationFacilitiesQuery,
  AdminReservationFacilitiesQueryVariables
>;
export const AdminReservationReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationReviewTab_AccommodationReservation",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewV2Form" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memorableExperiences" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "axes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "axis" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concernKinds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "kind" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationReviewTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memorableExperiences" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureAndNatureRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cleaningRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "equipmentRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guidanceAndSupportRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "concerns" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewResponse" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionnaire" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAtCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAtCheckOutAnswer" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAfterCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAfterCheckOutAnswer" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationReviewQuery,
  AdminReservationReviewQueryVariables
>;
export const AdminReservationStaffGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationStaffGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationStaffGroup_AccommodationReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationStaffGroup_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SanuIncAccommodationReservationProvider",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "usage" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "staffGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationStaffGroupQuery,
  AdminReservationStaffGroupQueryVariables
>;
export const AdminReservationStayStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationStayStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationStayStatusTab_AccommodationReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationStayStatusTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "accessCode" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkedInGeoLocation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInQrCode" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationStayStatusQuery,
  AdminReservationStayStatusQueryVariables
>;
export const AdminAssignAccessCodeToAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminAssignAccessCodeToAccommodationReservation",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAssignAccessCodeToAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessCode" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "ReservationStayStatusTab_AccommodationReservation",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalAssignAccessCodeToAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationStayStatusTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
          { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "accessCode" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkedInGeoLocation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInQrCode" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAssignAccessCodeToAccommodationReservationMutation,
  AdminAssignAccessCodeToAccommodationReservationMutationVariables
>;
export const AdminReservationTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationTicketsTab_AccommodationReservation",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationTicketsTab_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "tentativeDeadline" } },
          { kind: "Field", name: { kind: "Name", value: "invitationUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStartNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayEndNight" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationTicketsQuery,
  AdminReservationTicketsQueryVariables
>;
export const AdminReservationWaiversDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationWaivers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "consumedSupplyFeeItemWaivers",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumedSuppliesFee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "ReservationWaivers_ConsumedSuppliesFeeItem",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsumedSupplyFeeItemWaiver" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supplyItemMasterCategory" },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationWaivers_ConsumedSuppliesFeeItem",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsumedSuppliesFeeItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "reportedQuantity" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationWaiversQuery,
  AdminReservationWaiversQueryVariables
>;
export const AdminResetTentativeReservationUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminResetTentativeReservationUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalResetTentativeReservationUser",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminResetTentativeReservationUserMutation,
  AdminResetTentativeReservationUserMutationVariables
>;
export const AdminReservationAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationAreasQuery,
  AdminReservationAreasQueryVariables
>;
export const AdminReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startLastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endLastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationScope" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccommodationScope" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withAccessCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withFee" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationReservationsBySearch",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationScope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "guestName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkedOutAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessCode" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "withAccessCode" },
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "withFee" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationsQuery,
  AdminReservationsQueryVariables
>;
export const AdminReservationsExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminReservationsExport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startLastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endLastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationScope" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccommodationScope" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationReservationsForExport",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationScope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "guestName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkedOutAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReservationsExportQuery,
  AdminReservationsExportQueryVariables
>;
export const AdminRunOneShotScriptDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRunOneShotScript" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalRunOneShotScriptInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalRunOneShotScript" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalScriptExecution" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dryRun" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summary" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "interrupted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finishedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "affected" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ts" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "level" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "message" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalRunOneShotScriptError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRunOneShotScriptMutation,
  AdminRunOneShotScriptMutationVariables
>;
export const AdminOneShotScriptDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOneShotScriptDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOneShotScript" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportsDryRun" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiredPermission" },
                },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "sourceHtml" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOneShotScriptDetailQuery,
  AdminOneShotScriptDetailQueryVariables
>;
export const AdminScriptExecutionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminScriptExecutions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalScriptExecutions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "dryRun" } },
                { kind: "Field", name: { kind: "Name", value: "summary" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
                { kind: "Field", name: { kind: "Name", value: "interrupted" } },
                { kind: "Field", name: { kind: "Name", value: "startedAt" } },
                { kind: "Field", name: { kind: "Name", value: "finishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ts" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeredBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminScriptExecutionsQuery,
  AdminScriptExecutionsQueryVariables
>;
export const AdminOneShotScriptsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminOneShotScripts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOneShotScripts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportsDryRun" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiredPermission" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastExecutedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminOneShotScriptsQuery,
  AdminOneShotScriptsQueryVariables
>;
export const SiteOpeningCreateAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SiteOpeningCreateArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateAreaInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteOpeningCreateAreaMutation,
  SiteOpeningCreateAreaMutationVariables
>;
export const AdminSiteOpeningAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteOpeningAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ordinalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicOpeningDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "checkInAuthenticationType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteOpeningAreasQuery,
  AdminSiteOpeningAreasQueryVariables
>;
export const AdminUpdateSiteBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateSiteBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateSiteParametersInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteParameters" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalSite" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ordinalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicOpeningDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "checkInAuthenticationType",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateSiteParametersError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateSiteBasicInfoMutation,
  AdminUpdateSiteBasicInfoMutationVariables
>;
export const AdminCreateOtaRoomTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOtaRoomType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateRoomTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateRoomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beds24RoomId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOtaRoomTypeMutation,
  AdminCreateOtaRoomTypeMutationVariables
>;
export const AdminUpdateOtaRoomTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateOtaRoomType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateRoomTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateRoomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateOtaRoomTypeMutation,
  AdminUpdateOtaRoomTypeMutationVariables
>;
export const AdminCreateOtaRoomUnitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOtaRoomUnit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roomTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateOtaRoomUnitInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOtaRoomUnit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "roomTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roomTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOtaRoomUnitMutation,
  AdminCreateOtaRoomUnitMutationVariables
>;
export const AdminSyncBeds24RoomQtyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSyncBeds24RoomQty" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roomTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSyncBeds24RoomQty" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "roomTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roomTypeId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSyncBeds24RoomQtyMutation,
  AdminSyncBeds24RoomQtyMutationVariables
>;
export const AdminSiteAccessRouteGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteAccessRouteGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prefecture" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressLine" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessRouteGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transportIcon" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "points" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "legToNextDescription",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sort" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteAccessRouteGroupsQuery,
  AdminSiteAccessRouteGroupsQueryVariables
>;
export const AdminCreateOrUpdateSiteAccessRouteGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateSiteAccessRouteGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateSiteAccessRouteGroupInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateSiteAccessRouteGroup",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transportIcon" },
                },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "points" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "legToNextDescription" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateSiteAccessRouteGroupMutation,
  AdminCreateOrUpdateSiteAccessRouteGroupMutationVariables
>;
export const AdminDeleteSiteAccessRouteGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteSiteAccessRouteGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteSiteAccessRouteGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteSiteAccessRouteGroupMutation,
  AdminDeleteSiteAccessRouteGroupMutationVariables
>;
export const AdminReorderSiteAccessRouteGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderSiteAccessRouteGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternalReorderInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalReorderSiteAccessRouteGroups",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderSiteAccessRouteGroupsMutation,
  AdminReorderSiteAccessRouteGroupsMutationVariables
>;
export const AdminSiteBasicInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteBasicInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteBasicInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "openingDate" } },
          { kind: "Field", name: { kind: "Name", value: "publicOpeningDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInAuthenticationType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customReservationLeadMonths" },
          },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "switchbotLocationApiKey" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockLocationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedName" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ja" } },
                { kind: "Field", name: { kind: "Name", value: "en" } },
                { kind: "Field", name: { kind: "Name", value: "zhCn" } },
                { kind: "Field", name: { kind: "Name", value: "zhTw" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteBasicInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "openingDate" } },
          { kind: "Field", name: { kind: "Name", value: "publicOpeningDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInAuthenticationType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customReservationLeadMonths" },
          },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "switchbotLocationApiKey" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remoteLockLocationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteBasicInfoQuery,
  AdminSiteBasicInfoQueryVariables
>;
export const AdminUpdateSiteContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateSiteContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateSiteContentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "googleMapsUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "googleMapsReviewUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapImageUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iceRoadInfoUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latitude" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "longitude" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressForEdit" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "prefecture" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ja" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "en" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ja" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "en" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "addressLine" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ja" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "en" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingCapacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingInfo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateSiteContentMutation,
  AdminUpdateSiteContentMutationVariables
>;
export const AdminSiteContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteContentTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsReviewUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addressForEdit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prefecture" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "city" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seriesShortName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsReviewUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteContentEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteContentQuery,
  AdminSiteContentQueryVariables
>;
export const AdminDeleteSiteImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteSiteImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateSiteImagesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteImages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteSiteImageMutation,
  AdminDeleteSiteImageMutationVariables
>;
export const AdminReplaceSiteHeroImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReplaceSiteHeroImages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateSiteContentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "caption" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReplaceSiteHeroImagesMutation,
  AdminReplaceSiteHeroImagesMutationVariables
>;
export const AdminUpdateSiteMapImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateSiteMapImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateSiteContentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapImageUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateSiteMapImageMutation,
  AdminUpdateSiteMapImageMutationVariables
>;
export const AdminSiteHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteHeader" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "reservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservableForOwnerEarlyAccess" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteHeaderQuery,
  AdminSiteHeaderQueryVariables
>;
export const AdminUpdateSiteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateSite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateSiteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalSite" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ordinalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicOpeningDate" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "checkInAuthenticationType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "customReservationLeadMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEnabled" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "switchbotLocationApiKey",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remoteLockLocationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "localizedName" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhCn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zhTw" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalUpdateSiteError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateSiteMutation,
  AdminUpdateSiteMutationVariables
>;
export const AdminSiteFaqsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteFaqs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSiteFaqs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "question" } },
                { kind: "Field", name: { kind: "Name", value: "answer" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guidanceImageUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSiteFaqsQuery, AdminSiteFaqsQueryVariables>;
export const AdminCreateOrUpdateSiteFaqDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateSiteFaq" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateSiteFaqInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOrUpdateSiteFaq" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RawSiteFaq" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guidanceImageUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateSiteFaqError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateSiteFaqMutation,
  AdminCreateOrUpdateSiteFaqMutationVariables
>;
export const AdminDeleteSiteFaqDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteSiteFaq" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteSiteFaq" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteSiteFaqMutation,
  AdminDeleteSiteFaqMutationVariables
>;
export const AdminReorderSiteFaqsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderSiteFaqs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternalReorderSiteFaqInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReorderSiteFaqs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderSiteFaqsMutation,
  AdminReorderSiteFaqsMutationVariables
>;
export const AdminSiteHighSeasonPeriodsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteHighSeasonPeriods" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSiteHighSeasonPeriods" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "siteId" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "startMonth" } },
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endMonth" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalFeeAmount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteHighSeasonPeriodsQuery,
  AdminSiteHighSeasonPeriodsQueryVariables
>;
export const AdminCreateSiteHighSeasonPeriodDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSiteHighSeasonPeriod" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateSiteHighSeasonPeriodInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateSiteHighSeasonPeriod" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "startMonth" } },
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endMonth" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalFeeAmount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSiteHighSeasonPeriodMutation,
  AdminCreateSiteHighSeasonPeriodMutationVariables
>;
export const AdminUpdateSiteHighSeasonPeriodDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateSiteHighSeasonPeriod" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateSiteHighSeasonPeriodInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateSiteHighSeasonPeriod" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "startMonth" } },
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endMonth" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalFeeAmount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateSiteHighSeasonPeriodMutation,
  AdminUpdateSiteHighSeasonPeriodMutationVariables
>;
export const AdminDeleteSiteHighSeasonPeriodDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteSiteHighSeasonPeriod" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteSiteHighSeasonPeriod" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteSiteHighSeasonPeriodMutation,
  AdminDeleteSiteHighSeasonPeriodMutationVariables
>;
export const AdminSiteOtaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteOta" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteOtaTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteOtaTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "beds24PropertyId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beds24RoomId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otaRoomUnits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facilityTypes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "seriesShortName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSiteOtaQuery, AdminSiteOtaQueryVariables>;
export const AdminCreateOrUpdateBeds24PropertyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateBeds24Property" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateBeds24Property",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beds24PropertyId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateBeds24PropertyMutation,
  AdminCreateOrUpdateBeds24PropertyMutationVariables
>;
export const AdminConnectBeds24PropertyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminConnectBeds24Property" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalConnectBeds24Property" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "propertyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beds24PropertyId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminConnectBeds24PropertyMutation,
  AdminConnectBeds24PropertyMutationVariables
>;
export const AdminSyncAllBeds24RoomsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSyncAllBeds24Rooms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSyncAllBeds24Rooms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSyncAllBeds24RoomsMutation,
  AdminSyncAllBeds24RoomsMutationVariables
>;
export const AdminBeds24PropertyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminBeds24Property" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "propertyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBeds24Property" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "propertyId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminBeds24PropertyQuery,
  AdminBeds24PropertyQueryVariables
>;
export const AdminCreateSiteFaqImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSiteFaqImageUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateSiteFaqImageUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateSiteFaqImageUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSiteFaqImageUploadPolicyMutation,
  AdminCreateSiteFaqImageUploadPolicyMutationVariables
>;
export const AdminCreateSiteImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSiteImageUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateSiteImageUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateSiteImageUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSiteImageUploadPolicyMutation,
  AdminCreateSiteImageUploadPolicyMutationVariables
>;
export const AdminAddAccommodationLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminAddAccommodationLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "policyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAddLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "policyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "policyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "target" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accommodationIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "accommodationIds" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LocalTaxPolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAddLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAddAccommodationLocalTaxPolicyMutation,
  AdminAddAccommodationLocalTaxPolicyMutationVariables
>;
export const AdminAddSiteLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminAddSiteLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "policyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAddLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "policyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "policyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "target" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "siteId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "siteId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LocalTaxPolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sites" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAddLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAddSiteLocalTaxPolicyMutation,
  AdminAddSiteLocalTaxPolicyMutationVariables
>;
export const AdminRemoveAccommodationLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRemoveAccommodationLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "policyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalRemoveLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "policyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "policyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "target" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accommodationId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "accommodationId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LocalTaxPolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalRemoveLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRemoveAccommodationLocalTaxPolicyMutation,
  AdminRemoveAccommodationLocalTaxPolicyMutationVariables
>;
export const AdminRemoveSiteLocalTaxPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminRemoveSiteLocalTaxPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "policyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalRemoveLocalTaxPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "policyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "policyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "target" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "siteId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "siteId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LocalTaxPolicy" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sites" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalRemoveLocalTaxPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRemoveSiteLocalTaxPolicyMutation,
  AdminRemoveSiteLocalTaxPolicyMutationVariables
>;
export const AdminSiteLocalTaxPoliciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteLocalTaxPolicies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalLocalTaxPolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taxType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localGovernmentName" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "effectiveTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteLocalTaxPoliciesQuery,
  AdminSiteLocalTaxPoliciesQueryVariables
>;
export const AdminCreateAccommodationOperationGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateAccommodationOperationGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateAccommodationOperationGroupInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateAccommodationOperationGroup",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AccommodationOperationGroup",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateAccommodationOperationGroupError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateAccommodationOperationGroupMutation,
  AdminCreateAccommodationOperationGroupMutationVariables
>;
export const AdminUpdateAccommodationOperationGroupSettingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminUpdateAccommodationOperationGroupSetting",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateAccommodationOperationGroupSettingInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateAccommodationOperationGroupSetting",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AccommodationOperationGroupSetting",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effectiveFrom" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "class" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "operationType" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalFeeForClassEOwner",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalFeeForClassFOwner",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalFeeForBusinessPlan",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalUpdateAccommodationOperationGroupSettingError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateAccommodationOperationGroupSettingMutation,
  AdminUpdateAccommodationOperationGroupSettingMutationVariables
>;
export const AdminSiteOperationGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteOperationGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationOperationGroups",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effectiveFrom" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "class" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "operationType" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalFeeForClassEOwner",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalFeeForClassFOwner",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalFeeForBusinessPlan",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteOperationGroupsQuery,
  AdminSiteOperationGroupsQueryVariables
>;
export const AdminRoomTypeBasicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminRoomTypeBasic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayNames" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "features" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ja" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "iconSlug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otaRoomUnits" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unit" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accommodation" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "architectureType",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "facilityTypes",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypeFeatures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconSlug" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "series" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRoomTypeBasicQuery,
  AdminRoomTypeBasicQueryVariables
>;
export const AdminUpdateRoomTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateRoomType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateRoomTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateRoomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayNames" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ja" } },
                      { kind: "Field", name: { kind: "Name", value: "en" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "features" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconSlug" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateRoomTypeMutation,
  AdminUpdateRoomTypeMutationVariables
>;
export const AdminRoomTypeHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminRoomTypeHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRoomTypeHeaderQuery,
  AdminRoomTypeHeaderQueryVariables
>;
export const AdminCreateRoomTypeImageUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateRoomTypeImageUploadPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateRoomTypeImageUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateRoomTypeImageUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateRoomTypeImageUploadPolicyMutation,
  AdminCreateRoomTypeImageUploadPolicyMutationVariables
>;
export const AdminRoomTypeContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminRoomTypeContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "heroImages" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "caption" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminRoomTypeContentQuery,
  AdminRoomTypeContentQueryVariables
>;
export const AdminUpdateRoomTypeContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateRoomTypeContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roomTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateRoomTypeContentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateRoomTypeContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "roomTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roomTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateRoomTypeContentMutation,
  AdminUpdateRoomTypeContentMutationVariables
>;
export const AdminSiteRoomTypesSelectorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteRoomTypesSelector" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteRoomTypesSelectorQuery,
  AdminSiteRoomTypesSelectorQueryVariables
>;
export const AdminSiteFirstRoomTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSiteFirstRoomType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSiteFirstRoomTypeQuery,
  AdminSiteFirstRoomTypeQueryVariables
>;
export const AdminCreateSiteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateSiteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateSite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalSite" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ordinalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingDate" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "checkInAuthenticationType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "customReservationLeadMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEnabled" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalCreateSiteError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSiteMutation,
  AdminCreateSiteMutationVariables
>;
export const AdminSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ordinalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "published" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "checkInAuthenticationType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "customReservationLeadMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remoteLockLocationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSitesQuery, AdminSitesQueryVariables>;
export const AdminReorderSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminReorderSites" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternalReorderSiteInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReorderSites" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminReorderSitesMutation,
  AdminReorderSitesMutationVariables
>;
export const AdminStaffGroupHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffGroupHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStaffGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffGroupHeaderQuery,
  AdminStaffGroupHeaderQueryVariables
>;
export const AdminStaffGroupDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffGroupDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStaffGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "smarthrId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archivedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "StaffGroupFormSheet_StaffGroup",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffGroupFormSheet_StaffGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "fullName" } },
          { kind: "Field", name: { kind: "Name", value: "smarthrId" } },
          { kind: "Field", name: { kind: "Name", value: "archivedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffGroupDetailQuery,
  AdminStaffGroupDetailQueryVariables
>;
export const AdminCreateOrUpdateStaffGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateStaffGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffGroupId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrUpdateStaffGroupInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateOrUpdateStaffGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "staffGroupId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "staffGroupId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StaffGroup" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "smarthrId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archivedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateStaffGroupError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateStaffGroupMutation,
  AdminCreateOrUpdateStaffGroupMutationVariables
>;
export const AdminStaffGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffGroups" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeInvalidated" },
                value: { kind: "BooleanValue", value: true },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "smarthrId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archivedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffGroupsQuery,
  AdminStaffGroupsQueryVariables
>;
export const AdminAdjustStaffCreditsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminAdjustStaffCredits" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "semester" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffSemester" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "nights" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "peakDays" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdjustStaffCredits" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "semester" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "semester" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "nights" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "nights" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "peakDays" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "peakDays" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAdjustStaffCreditsSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contract" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAdjustStaffCreditsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdjustStaffCreditsMutation,
  AdminAdjustStaffCreditsMutationVariables
>;
export const AdminStaffContractDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffContractDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStaffContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "staffType" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "enrolledAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReservable" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentSemesterStayCredits" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "currentSemesterGrantedStayCredits",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingPeakDays" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "semesterCredits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "semester" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingStayCredits" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "grantedStayCredits" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingPeakDays" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffContractDetailQuery,
  AdminStaffContractDetailQueryVariables
>;
export const AdminStaffCreditTransactionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffCreditTransactions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStaffCreditTransactions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "peakDaysAmount" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "semester" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastNight" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffCreditTransactionsQuery,
  AdminStaffCreditTransactionsQueryVariables
>;
export const AdminStaffContractHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffContractHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStaffContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "staffType" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffContractHeaderQuery,
  AdminStaffContractHeaderQueryVariables
>;
export const AdminViewerForStaffPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminViewerForStaffPlan" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminViewerForStaffPlanQuery,
  AdminViewerForStaffPlanQueryVariables
>;
export const AdminStopStaffPlanFromDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminStopStaffPlanFromDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStopStaffPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalStopStaffPlanSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contract" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusDetail" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "terminatedAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InternalStopStaffPlanError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStopStaffPlanFromDetailMutation,
  AdminStopStaffPlanFromDetailMutationVariables
>;
export const AdminStaffContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStaffContracts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStaffContracts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "staffType" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "enrolledAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStaffContractsQuery,
  AdminStaffContractsQueryVariables
>;
export const AdminAvailableStaffSemestersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAvailableStaffSemesters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAvailableStaffSemesters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "semester" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAvailableStaffSemestersQuery,
  AdminAvailableStaffSemestersQueryVariables
>;
export const AdminUsersBySearchForStaffPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUsersBySearchForStaffPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUsersBySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUsersBySearchForStaffPlanQuery,
  AdminUsersBySearchForStaffPlanQueryVariables
>;
export const AdminStartStaffPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminStartStaffPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startSemester" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffSemester" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startYear" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "initialNights" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStartStaffPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "staffType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "staffType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startSemester" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startSemester" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startYear" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startYear" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "initialNights" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "initialNights" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalStartStaffPlanSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contract" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalStartStaffPlanError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStartStaffPlanMutation,
  AdminStartStaffPlanMutationVariables
>;
export const AdminStayReviewResponseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewResponse" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayReviewResponse" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facilities" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionnaire" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "options" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "options" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAtCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAtCheckOutAnswer" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAfterCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAfterCheckOutAnswer" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewResponseQuery,
  AdminStayReviewResponseQueryVariables
>;
export const AdminStayReviewResponsesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewResponses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startCheckOutDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endCheckOutDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayReviewResponses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startCheckOutDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startCheckOutDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endCheckOutDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endCheckOutDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewResponsesQuery,
  AdminStayReviewResponsesQueryVariables
>;
export const AdminStayReviewArchitectureTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewArchitectureTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewArchitectureTypesQuery,
  AdminStayReviewArchitectureTypesQueryVariables
>;
export const AdminStayReviewResponsePreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewResponsePreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayReviewResponse" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionnaire" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAtCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectionAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "freeTextAfterCheckOut" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAtCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAtCheckOutAnswer" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionAfterCheckOutAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freeTextAfterCheckOutAnswer" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewResponsePreviewQuery,
  AdminStayReviewResponsePreviewQueryVariables
>;
export const AdminStayReviewFilterArchitectureTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewFilterArchitectureTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewFilterArchitectureTypesQuery,
  AdminStayReviewFilterArchitectureTypesQueryVariables
>;
export const AdminStayReviewedReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewedReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startCheckOutDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endCheckOutDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalStayReviewedAccommodationReservations",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startCheckOutDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startCheckOutDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endCheckOutDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endCheckOutDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayReviewV2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "submittedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "memorableExperiences" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "architectureAndNatureRating",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cleaningRating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentRating" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "guidanceAndSupportRating",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concerns" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "kind" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "comment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewedReservationsQuery,
  AdminStayReviewedReservationsQueryVariables
>;
export const AdminStayReviewFormLabelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayReviewFormLabels" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewV2Form" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memorableExperiences" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "axes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "axis" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concernKinds" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "kind" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayReviewFormLabelsQuery,
  AdminStayReviewFormLabelsQueryVariables
>;
export const AdminMasterTemplateRefDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminMasterTemplateRefData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBaseAccommodationFeePolicies",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdditionalGuestFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminMasterTemplateRefDataQuery,
  AdminMasterTemplateRefDataQueryVariables
>;
export const AdminCreateOrUpdateStayTicketMasterTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateOrUpdateStayTicketMasterTemplate",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateStayTicketMasterTemplateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateStayTicketMasterTemplate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayTicketMasterTemplate" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateStayTicketMasterTemplateError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateStayTicketMasterTemplateMutation,
  AdminCreateOrUpdateStayTicketMasterTemplateMutationVariables
>;
export const AdminStayTicketMasterTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayTicketMasterTemplates" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasterTemplates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "isBulkUsage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "occupancyLimitTarget" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeeMode" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "waiveArchitectureTypeAdditionalFee",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveDogRunFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waivePeakDayFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSiteAdditionalFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "includeSeasonalFee" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "rawBaseAccommodationFeePolicy",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rawCancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableSites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableArchitectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "availableAccommodationFacilities",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayTicketMasterTemplatesQuery,
  AdminStayTicketMasterTemplatesQueryVariables
>;
export const AdminCreateTicketsFromMasterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateTicketsFromMaster" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stayTicketMasterId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "count" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "expiresAt" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ZonedDateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stayStartNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stayEndNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "destinationEmail" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateTicketsFromMaster" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stayTicketMasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stayTicketMasterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "count" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "count" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "expiresAt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "expiresAt" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stayStartNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stayStartNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stayEndNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destinationEmail" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "destinationEmail" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateTicketsFromMasterMutation,
  AdminCreateTicketsFromMasterMutationVariables
>;
export const AdminStayTicketMasterHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayTicketMasterHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasterById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ticketCategory" },
                },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayTicketMasterHeaderQuery,
  AdminStayTicketMasterHeaderQueryVariables
>;
export const AdminStayTicketMasterDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayTicketMasterDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasterById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "notice" } },
                { kind: "Field", name: { kind: "Name", value: "isBulkUsage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "occupancyLimitTarget" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeeMode" },
                },
                { kind: "Field", name: { kind: "Name", value: "lookupKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ticketCategory" },
                },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "includeSeasonalFee" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "waiveArchitectureTypeAdditionalFee",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveDogRunFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waivePeakDayFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSiteAdditionalFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNoticeTypes" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "rawBaseAccommodationFeePolicy",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rawCancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "adultPrices" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "kidsPrices" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableSites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableArchitectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "availableAccommodationFacilities",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "template" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayTicketMasterDetailQuery,
  AdminStayTicketMasterDetailQueryVariables
>;
export const AdminMastersForTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminMastersForTemplate" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminMastersForTemplateQuery,
  AdminMastersForTemplateQueryVariables
>;
export const AdminCreateOrUpdateStayTicketTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateStayTicketTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateStayTicketTemplateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateStayTicketTemplate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayTicketTemplate" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lookupKey" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateStayTicketTemplateError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateStayTicketTemplateMutation,
  AdminCreateOrUpdateStayTicketTemplateMutationVariables
>;
export const AdminMasterTemplatesTabDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminMasterTemplatesTab" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasterById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "templates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lookupKey" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysUntilExpiration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysUntilLastStay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawExpiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawStayStartNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawStayEndNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "master" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminMasterTemplatesTabQuery,
  AdminMasterTemplatesTabQueryVariables
>;
export const AdminMasterTicketsPaginatedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminMasterTicketsPaginated" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "masterId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "StayTicketStatusType" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InternalStayTicketsOrderBy" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderDir" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SortDirection" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stayTicketMasterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "masterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderDir" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderDir" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStartNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayEndNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "destinationEmail" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminMasterTicketsPaginatedQuery,
  AdminMasterTicketsPaginatedQueryVariables
>;
export const AdminUpdateStayTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateStayTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateStayTicketInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateStayTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayTicket" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStartNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayEndNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "destinationEmail" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateStayTicketNotFoundError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateStayTicketInvalidStatusError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateStayTicketMutation,
  AdminUpdateStayTicketMutationVariables
>;
export const AdminMasterFormReferenceDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminMasterFormReferenceData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalArchitectureTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "series" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBaseAccommodationFeePolicies",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCancelFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdditionalGuestFeePolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasterTemplates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "occupancyLimitTarget" },
                },
                { kind: "Field", name: { kind: "Name", value: "isBulkUsage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeeMode" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "rawBaseAccommodationFeePolicy",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rawCancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "waiveArchitectureTypeAdditionalFee",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveDogRunFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waivePeakDayFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSiteAdditionalFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "includeSeasonalFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableSites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableArchitectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "availableAccommodationFacilities",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminMasterFormReferenceDataQuery,
  AdminMasterFormReferenceDataQueryVariables
>;
export const AdminCreateOrUpdateStayTicketMasterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateOrUpdateStayTicketMaster" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateStayTicketMasterInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateStayTicketMaster",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayTicketMaster" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalGuestFeePolicy",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "internalName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateStayTicketMasterError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateOrUpdateStayTicketMasterMutation,
  AdminCreateOrUpdateStayTicketMasterMutationVariables
>;
export const AdminStayTicketMastersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayTicketMasters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "isBulkUsage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ticketCategory" },
                },
                { kind: "Field", name: { kind: "Name", value: "isArchived" } },
                { kind: "Field", name: { kind: "Name", value: "lookupKey" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayTicketMastersQuery,
  AdminStayTicketMastersQueryVariables
>;
export const AdminStayTicketTemplatesSearchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayTicketTemplatesSearch" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketTemplates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "lookupKey" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "daysUntilExpiration" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "daysUntilLastStay" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "master" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayTicketTemplatesSearchQuery,
  AdminStayTicketTemplatesSearchQueryVariables
>;
export const AdminStayTicketByCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminStayTicketByCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStayTicketByCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayStartNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "destinationEmail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "master" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userOwnership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminStayTicketByCodeQuery,
  AdminStayTicketByCodeQueryVariables
>;
export const AdminUpdateStayTicketFromSearchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateStayTicketFromSearch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateStayTicketInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateStayTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayTicket" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStartNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayEndNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "destinationEmail" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateStayTicketNotFoundError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateStayTicketInvalidStatusError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateStayTicketFromSearchMutation,
  AdminUpdateStayTicketFromSearchMutationVariables
>;
export const AdminUpsertSupplyItemInstallationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpsertSupplyItemInstallations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "masterId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "installations" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "InternalCreateOrUpdateSupplyItemInstallationInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateSupplyItemInstallations",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "masterId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "masterId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "installations" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "installations" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalCreateOrUpdateSupplyItemInstallationsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpsertSupplyItemInstallationsMutation,
  AdminUpsertSupplyItemInstallationsMutationVariables
>;
export const AdminDeleteSupplyItemInstallationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminDeleteSupplyItemInstallation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDeleteSupplyItemInstallation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalDeleteSupplyItemInstallationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminDeleteSupplyItemInstallationMutation,
  AdminDeleteSupplyItemInstallationMutationVariables
>;
export const AdminInstallationSupplyItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminInstallationSupplyItems" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSupplyItemMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "namePrivate" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminInstallationSupplyItemsQuery,
  AdminInstallationSupplyItemsQueryVariables
>;
export const AdminSupplyItemMasterInstallationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSupplyItemMasterInstallations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSupplyItemMaster" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "supplyItemInstallations",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "masterId" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "id" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accommodation" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "defaultQuantity" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "EditSupplyItemInstallationsSheet_SupplyItemInstallation",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "EditSupplyItemInstallationsSheet_Site",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "EditSupplyItemInstallationsSheet_SupplyItemInstallation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupplyItemInstallation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultQuantity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EditSupplyItemInstallationsSheet_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InternalSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSupplyItemMasterInstallationsQuery,
  AdminSupplyItemMasterInstallationsQueryVariables
>;
export const AdminCreateSupplyItemMasterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateSupplyItemMaster" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateSupplyItemMasterInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateSupplyItemMaster",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SupplyItemMaster" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateSupplyItemMasterError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateSupplyItemMasterMutation,
  AdminCreateSupplyItemMasterMutationVariables
>;
export const AdminUpdateSupplyItemMasterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateSupplyItemMaster" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateOrUpdateSupplyItemMasterInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateOrUpdateSupplyItemMaster",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SupplyItemMaster" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "namePublic" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "namePrivate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      { kind: "Field", name: { kind: "Name", value: "price" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "taxRateType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateOrUpdateSupplyItemMasterError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateSupplyItemMasterMutation,
  AdminUpdateSupplyItemMasterMutationVariables
>;
export const AdminSupplyItemMastersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSupplyItemMasters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSupplyItemMasters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "namePublic" } },
                { kind: "Field", name: { kind: "Name", value: "namePrivate" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "taxRateType" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "EditSupplyItemSheet_SupplyItemMaster",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EditSupplyItemSheet_SupplyItemMaster" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupplyItemMaster" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "namePublic" } },
          { kind: "Field", name: { kind: "Name", value: "namePrivate" } },
          { kind: "Field", name: { kind: "Name", value: "unit" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "taxRateType" } },
          { kind: "Field", name: { kind: "Name", value: "sort" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSupplyItemMastersQuery,
  AdminSupplyItemMastersQueryVariables
>;
export const AdminSupplyReportDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSupplyReportDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalInspectionReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: { kind: "EnumValue", value: "Supply" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "closedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supplyItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supplyItemMedia" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSupplyReportDetailQuery,
  AdminSupplyReportDetailQueryVariables
>;
export const AdminSupplyReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSupplyReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalInspectionReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: { kind: "EnumValue", value: "Supply" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supplyItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSupplyReportsQuery,
  AdminSupplyReportsQueryVariables
>;
export const AdminSupplyReportSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminSupplyReportSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSupplyReportSitesQuery,
  AdminSupplyReportSitesQueryVariables
>;
export const AdminCreateTermsRevisionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateTermsRevision" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreateTermsRevisionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateTermsRevision" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Terms" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "TermsDetail_Terms" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateTermsRevisionError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsDetail_Terms" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Terms" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "plan" } },
          { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "revisions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "revisedDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetOwnerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalSummary" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateTermsRevisionMutation,
  AdminCreateTermsRevisionMutationVariables
>;
export const AdminTermsRevisionTargetOwnerPlansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminTermsRevisionTargetOwnerPlans" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOwnerPlans" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminTermsRevisionTargetOwnerPlansQuery,
  AdminTermsRevisionTargetOwnerPlansQueryVariables
>;
export const AdminCreateIndividualTermsDocumentUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "AdminCreateIndividualTermsDocumentUploadPolicy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateFullOwnerContractUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createFullOwnerContractUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateIndividualTermsDocumentUploadPolicyMutation,
  AdminCreateIndividualTermsDocumentUploadPolicyMutationVariables
>;
export const AdminUpdateIndividualTermsDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateIndividualTermsDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateIndividualTermsDocumentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateIndividualTermsDocument",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Terms" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "TermsDetail_Terms" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateIndividualTermsDocumentError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsDetail_Terms" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Terms" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "plan" } },
          { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "revisions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "revisedDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetOwnerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalSummary" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateIndividualTermsDocumentMutation,
  AdminUpdateIndividualTermsDocumentMutationVariables
>;
export const AdminTermsDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminTermsDetail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalTerms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermsDetail_Terms" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsDetail_Terms" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Terms" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "plan" } },
          { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "revisions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "revisedDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetOwnerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalSummary" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminTermsDetailQuery,
  AdminTermsDetailQueryVariables
>;
export const AdminTermsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminTerms" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalTerms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "plan" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "revisions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "revisedDate" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminTermsQuery, AdminTermsQueryVariables>;
export const AdminSendTestSmsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminSendTestSms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "message" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSendTestSms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "message" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "message" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminSendTestSmsMutation,
  AdminSendTestSmsMutationVariables
>;
export const AdminUserOwnershipDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserOwnershipDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUserOwnership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxPeakDaysPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxSiteHighSeasonDaysPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPaymentDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "holderName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentYearStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingPeakDays" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "remainingSiteHighSeasonDays",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextYearStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingPeakDays" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "remainingSiteHighSeasonDays",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "managedName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserOwnershipDetailQuery,
  AdminUserOwnershipDetailQueryVariables
>;
export const AdminAdjustOwnerStayCreditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminAdjustOwnerStayCredit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ownershipId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amount" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAdjustOwnerStayCredit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ownershipId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ownershipId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "amount" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "amount" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalAdjustOwnerStayCreditError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAdjustOwnerStayCreditMutation,
  AdminAdjustOwnerStayCreditMutationVariables
>;
export const AdminUserOwnershipsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserOwnershipsList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUserOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserOwnershipsListQuery,
  AdminUserOwnershipsListQueryVariables
>;
export const AdminUserAnalyticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserAnalytics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personaMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "frequency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "loyalty" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "investment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "exploration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seasonality" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserAnalyticsQuery,
  AdminUserAnalyticsQueryVariables
>;
export const AdminUserRequiredTermsAgreementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserRequiredTermsAgreements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiredTermsAgreements" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserRequiredTermsAgreementsQuery,
  AdminUserRequiredTermsAgreementsQueryVariables
>;
export const AdminUserOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "zendeskId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContractList" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContractDetail" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReservationList" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReservationDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsumedSupplyFeeItemWaiver" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supplyItemMasterCategory" },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trialContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingCycleDay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationCycle" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDay" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "appliedAt" } },
                { kind: "Field", name: { kind: "Name", value: "enrolledAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrollmentScheduledAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminationScheduledAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pauseScheduledAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "pausedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resumeScheduledAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "resumedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accumulatedS2oAmount" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trialContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "appliedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolledDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentPeriodStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstSemesterStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "secondSemesterStayCredits" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelledAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "staffType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolledDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReservable" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentSemesterStayCredits" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "currentSemesterGrantedStayCredits",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customFieldValue" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationNewStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNightsPerStay" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "latestYearlyReservationStatuses",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remainingNights" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxNights" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxPeakDaysPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPaymentDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "holderName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentYearStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingPeakDays" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageEndDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPaymentDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "holderName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentYearStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allAccommodationReservations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allAccommodationReservations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkedOutAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "accessCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "date" },
                            value: {
                              kind: "StringValue",
                              value: "今日の日付",
                              block: false,
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "faqs" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "question",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "answer",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userCompanions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gender" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "birthDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationNotices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "brief" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingMethod" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "consumedSupplyFeeItemWaivers",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "ReservationWaivers_ConsumedSupplyFeeItemWaiver",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "endAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargedFeeAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facility" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketMasterId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTickets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expiresAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayStartNight" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayEndNight" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otaDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "referer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "apiReference" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserOverviewQuery,
  AdminUserOverviewQueryVariables
>;
export const AdminUserProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserProfileTab" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserEditSheet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameKana" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "nationality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "householdComposition" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "carOwnershipStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlPostalCode" },
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserProfileTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameKana" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facePhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "nationality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportPhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionFree" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "householdComposition" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "carOwnershipStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UserEditSheet" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserProfileQuery,
  AdminUserProfileQueryVariables
>;
export const AdminUserSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "systemSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasSeenHouseRules" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserSettingsQuery,
  AdminUserSettingsQueryVariables
>;
export const InternalPartialUpdateUserSystemSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalPartialUpdateUserSystemSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserSystemSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalPartialUpdateUserSystemSettings",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "systemSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasSeenHouseRules" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalPartialUpdateUserSystemSettingsMutation,
  InternalPartialUpdateUserSystemSettingsMutationVariables
>;
export const AdminUserHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserHeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserHeader" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facePhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserHeaderQuery,
  AdminUserHeaderQueryVariables
>;
export const InternalUpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalUpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalUpdateUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUpdateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "nameKana" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maybeProfile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "birthDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gender" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nationality" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "passportNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "professionType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "professionFree" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "householdComposition" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "carOwnershipStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AddressInJapan" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "japanLine2",
                                    },
                                    name: { kind: "Name", value: "line2" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AddressInternational",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "intlLine1" },
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "intlLine2" },
                                    name: { kind: "Name", value: "line2" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "stateProvince",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "intlPostalCode",
                                    },
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalUpdateUserMutation,
  InternalUpdateUserMutationVariables
>;
export const AdminFullOwnerPlanOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminFullOwnerPlanOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalOwnerPlans" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "managedName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminFullOwnerPlanOptionsQuery,
  AdminFullOwnerPlanOptionsQueryVariables
>;
export const AdminUserAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAuth0DashboardBaseUrl" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailVerified" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailVerified" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "connection" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAppleRelay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSocial" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSyncedLocally" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserAccountsQuery,
  AdminUserAccountsQueryVariables
>;
export const AdminAuth0UsersByEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminAuth0UsersByEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAuth0UsersByEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailVerified" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "connection" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSocial" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profileEmail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profileEmailVerified" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminAuth0UsersByEmailQuery,
  AdminAuth0UsersByEmailQueryVariables
>;
export const InternalUnlinkIdentityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalUnlinkIdentity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "IdentityProvider" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUnlinkIdentity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalUnlinkIdentityMutation,
  InternalUnlinkIdentityMutationVariables
>;
export const InternalDeleteAuth0UserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalDeleteAuth0User" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "auth0UserId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalDeleteAuth0User" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "auth0UserId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "auth0UserId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalDeleteAuth0UserMutation,
  InternalDeleteAuth0UserMutationVariables
>;
export const InternalUnlinkAuth0IdentityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalUnlinkAuth0Identity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "primaryAuth0UserId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerUserId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUnlinkAuth0Identity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "primaryAuth0UserId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "primaryAuth0UserId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerUserId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerUserId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalUnlinkAuth0IdentityMutation,
  InternalUnlinkAuth0IdentityMutationVariables
>;
export const AdminUserDevicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserDevices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appInstallations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fcmToken" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platform" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "installationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registeredDeviceModel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registeredOsVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registeredAppVersion" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserDevicesQuery,
  AdminUserDevicesQueryVariables
>;
export const AdminCreateFullOwnerIdentityVerificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateFullOwnerIdentityVerification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ownerPlanId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateFullOwnerIdentityVerificationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateFullOwnerIdentityVerification",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ownerPlanId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ownerPlanId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "IdentityVerification" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateFullOwnerIdentityVerificationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateFullOwnerIdentityVerificationMutation,
  AdminCreateFullOwnerIdentityVerificationMutationVariables
>;
export const AdminUserIdentityVerificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserIdentityVerifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "fullOwnerIdentityVerifications",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ownerPlan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "managedName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "IdentityVerificationItem_IdentityVerification",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "IdentityVerificationItem_IdentityVerification",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentityVerification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "method" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "result" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustdockVerificationId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustdockOperationPageUrl" },
          },
          { kind: "Field", name: { kind: "Name", value: "submissionPageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "submissionPageUrlExpiresAt" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserIdentityVerificationsQuery,
  AdminUserIdentityVerificationsQueryVariables
>;
export const AdminUserInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserInvoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalStripeDashboardBaseUrl" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_month" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_year" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoices" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hosted_invoice_url",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserInvoicesQuery,
  AdminUserInvoicesQueryVariables
>;
export const AdminUserMonthlyStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserMonthlyStatement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "yearMonth" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainYearMonth" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalGenerateUserMonthlyStatement",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "yearMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "yearMonth" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UserMonthlyStatement" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yearMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPrice" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationStatements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accommodationName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "canceledAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fee" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "billingMethod",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "billingMethodManualDetail",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "priceStatement" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "baseFee" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "additionalFee",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "additionalFacilityFee",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "cleaningFee",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cancelFee" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "dogFee" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "evFee" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "consumedSuppliesFeeByTaxRate",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "price",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "taxRate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalGenerateUserMonthlyStatementError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserMonthlyStatementQuery,
  AdminUserMonthlyStatementQueryVariables
>;
export const AdminUserMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appliedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enrolledAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enrollmentScheduledAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationCycle" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDay" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resumedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resumeScheduledAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminationScheduledAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserMembershipQuery,
  AdminUserMembershipQueryVariables
>;
export const AdminCreateFullOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminCreateFullOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ownerPlanId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalCreateUserOwnership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ownerPlanId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ownerPlanId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "units" },
                value: { kind: "IntValue", value: "1" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminCreateFullOwnershipMutation,
  AdminCreateFullOwnershipMutationVariables
>;
export const AdminUserOwnershipsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserOwnerships" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "UserOwnershipTab_UserOwnership",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "UserOwnershipTab_UserOwnership",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ownerPlan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOwnershipTab_UserOwnership" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserOwnershipsQuery,
  AdminUserOwnershipsQueryVariables
>;
export const AdminUserReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allAccommodationReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isTentative" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayCreditEstimate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "breakdown" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserReservationsQuery,
  AdminUserReservationsQueryVariables
>;
export const AdminUserS2oDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserS2o" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "s2o" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "points" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transactionType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "note" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayCreditEstimate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualifyingStayCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingStayCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activatable" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminUserS2oQuery, AdminUserS2oQueryVariables>;
export const AdminUsersSearchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUsersSearch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUsersSearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserTableRow" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserTableRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facePhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUsersSearchQuery,
  AdminUsersSearchQueryVariables
>;
export const AdminUserStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserStats" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUserStats" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalUsers" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeMembers" },
                },
                { kind: "Field", name: { kind: "Name", value: "guests" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newSignupsThisMonth" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "monthlyChurnRate" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "usersWithUpcomingReservations",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminUserStatsQuery, AdminUserStatsQueryVariables>;
export const AdminUpdateInspectionViolationHandlingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AdminUpdateInspectionViolationHandling" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateInspectionViolationHandlingInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalUpdateInspectionViolationHandling",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalUpdateInspectionViolationHandlingError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUpdateInspectionViolationHandlingMutation,
  AdminUpdateInspectionViolationHandlingMutationVariables
>;
export const AdminUserPastViolationReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminUserPastViolationReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalInspectionReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: { kind: "EnumValue", value: "Violation" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "violationHandling" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severity" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserPastViolationReportsQuery,
  AdminUserPastViolationReportsQueryVariables
>;
export const AdminViolationReportDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminViolationReportDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalInspectionReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: { kind: "EnumValue", value: "Violation" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "violationDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "violationItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "typeName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "violationMedia" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "violationHandling" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severityAssessedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severityAssessedByUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "warningActionAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "warningActionByUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value:
                            "ViolationHandlingForm_InspectionViolationHandling",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ViolationHandlingForm_InspectionViolationHandling",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InspectionViolationHandling" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "severity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "severityAssessedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "severityAssessedByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "warningActionNote" } },
          { kind: "Field", name: { kind: "Name", value: "warningActionAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "warningActionByUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminViolationReportDetailQuery,
  AdminViolationReportDetailQueryVariables
>;
export const AdminViolationReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminViolationReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalInspectionReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: { kind: "EnumValue", value: "Violation" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "violationHandling" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severityAssessedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "severityAssessedByUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "warningActionAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "warningActionByUser" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminViolationReportsQuery,
  AdminViolationReportsQueryVariables
>;
export const AdminViolationReportSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminViolationReportSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminViolationReportSitesQuery,
  AdminViolationReportSitesQueryVariables
>;
export const GetOrganizationIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrganizationId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invitationCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationIdByInvitationCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitationCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invitationCode" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOrganizationIdQuery,
  GetOrganizationIdQueryVariables
>;
export const GetViewerKindDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetViewerKind" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetViewerKindQuery, GetViewerKindQueryVariables>;
export const GetOrganizationForOnboardingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrganizationForOnboarding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailDomainsForMember" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitationCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "announcementContent" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardingInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNightsPerStay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPeakDayFeeFree" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feePerNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nightsPerYear" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOrganizationForOnboardingQuery,
  GetOrganizationForOnboardingQueryVariables
>;
export const ReservationStatusLocalePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReservationStatusLocalePage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canCheckIn" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationStatusLocalePageQuery,
  ReservationStatusLocalePageQueryVariables
>;
export const TentativeReservationForLocaleReservationStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "TentativeReservationForLocaleReservationStatus",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tentativeAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RedirectLocation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "TentativeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "TentativeAccommodationReservationErrorCase",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "TentativeAccommodationReservationErrorCase",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TentativeAccommodationReservationError" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "case" } }],
      },
    },
  ],
} as unknown as DocumentNode<
  TentativeReservationForLocaleReservationStatusQuery,
  TentativeReservationForLocaleReservationStatusQueryVariables
>;
export const MaybeViewerForLocaleReservationStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MaybeViewerForLocaleReservationStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFilledRequiredProfile" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MaybeViewerForLocaleReservationStatusQuery,
  MaybeViewerForLocaleReservationStatusQueryVariables
>;
export const AcceptTentativeReservationLocaleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AcceptTentativeReservationLocale" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userAcceptCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AcceptAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AcceptTentativeReservationLocaleMutation,
  AcceptTentativeReservationLocaleMutationVariables
>;
export const ArchitectureTypePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArchitectureTypePage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureTypePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seriesShortName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "area" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrls" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architect" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "company" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameEn" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "bio" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "capacityDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sizeDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOpeningSoon" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "basicAmenities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "equipmentsListUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amenitiesInstructionsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "floorPlanImageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "variations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ContentArchitectureTypeVariant",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ContentArchitectureTypeVariant",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ContentArchitectureTypeExperiences",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectComment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentFacilityDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentFacilityDetails" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityAmenities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageConditionsDescription" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsPerSite" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariantSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariant" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brief" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageUrls" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentFacilityDetails" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationsPerSite" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentArchitectureTypeExperiences" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "experiences" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchitectureTypePageQuery,
  ArchitectureTypePageQueryVariables
>;
export const FeaturePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FeaturePage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "featurePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageUrls" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContentFacilityDetails" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageRule" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleItems" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bodyMarkup" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noteMarkup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilityNote" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesByArchitectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureTypeName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sites" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AccommodationsPerSite",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentFacilityDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentFacilityDetails" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityAmenities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionMarkup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageFeesDescriptionMarkup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usageConditionsDescription" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsPerSite" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitectureTypeVariantSite" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeaturePageQuery, FeaturePageQueryVariables>;
export const ArchitectureTopNavigationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArchitectureTopNavigation" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureTopPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalSeries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subItems" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ContentArchitecturePageNavigationItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionSeries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ContentArchitecturePageNavigationItem",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ContentArchitecturePageNavigationItem",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentArchitecturePageNavigationItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentArchitecturePageNavigationItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "path" } },
          { kind: "Field", name: { kind: "Name", value: "area" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "thumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subItems" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "path" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchitectureTopNavigationQuery,
  ArchitectureTopNavigationQueryVariables
>;
export const ArchitectureTopDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArchitectureTop" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureTopPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalSeries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subItems" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "path" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectionSeries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feature" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchitectureTopQuery,
  ArchitectureTopQueryVariables
>;
export const AreaLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AreaLayout" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areaBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaSidebar_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaSpHeader_Area" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaSidebar_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "seriesShortName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "capacityDescription",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roomType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "features" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sort" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaSpHeader_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaLayoutQuery, AreaLayoutQueryVariables>;
export const AreaDetailPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AreaDetailPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areaBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaDetailPageMeta_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaJsonLd_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaHero_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaAbout_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaActivityPrograms_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaGuideArticles_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaSpotsPreview_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaBases_Area" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaDetailPageMeta_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessFromTokyoDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaJsonLd_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHero_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaAbout_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "catchCopy" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaActivityPrograms_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activityPrograms" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "DxActivityProgramSection_SiteActivityProgram",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaGuideArticles_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideArticles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaSpotsPreview_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaBases_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AreaDetailPageQuery, AreaDetailPageQueryVariables>;
export const SiteDetailPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SiteDetailPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteSlug" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasReservablePlan" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "siteBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteSlug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "reservable" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "reservableForOwnerEarlyAccess",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypesForReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "seriesShortName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteDetailPageMeta_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteHero_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteAbout_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteRoomTypes_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteActivityPrograms_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxAccessSection_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxFaqSection_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxHotelJsonLd_Site" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutOverview_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutFacilities_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityDetailModalFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteDetailPageMeta_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteHero_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAbout_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteAboutOverview_Site" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "SiteAboutFacilities_Site" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteRoomTypes_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roomTypesForReservation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "size" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "capacityDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sizeDescription" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteActivityPrograms_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activityPrograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "DxActivityProgramSection_SiteActivityProgram",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxAccessSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessRouteGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transportIcon" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "points" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "legToNextDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxFaqSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxHotelJsonLd_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteDetailPageQuery, SiteDetailPageQueryVariables>;
export const RoomTypeDetailPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomTypeDetailPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteSlug" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roomTypeSlug" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roomTypeBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteSlug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteSlug" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roomTypeSlug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roomTypeSlug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservable" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservableForOwnerEarlyAccess",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seriesShortName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "features" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeJsonLd_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeHero_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeAbout_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeServices_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "RoomTypeActivityPrograms_RoomType",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeAmenities_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeAccess_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeManual_RoomType" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeInformation_RoomType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "DxActivityProgramSection_SiteActivityProgram",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteActivityProgram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxAccessSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessRouteGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transportIcon" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "points" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "legToNextDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxFaqSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeJsonLd_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "capacity" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeSqm" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeHero_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeAbout_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "prefecture" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingCapacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parkingInfo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapImageUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "iconSlug" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeServices_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FacilityDetailModalFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeActivityPrograms_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activityPrograms" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "DxActivityProgramSection_SiteActivityProgram",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeAmenities_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeAccess_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxAccessSection_Site" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeManual_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "amenitiesInstructionsUrl",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeInformation_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxFaqSection_Site" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomTypeDetailPageQuery,
  RoomTypeDetailPageQueryVariables
>;
export const AreaSpotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AreaSpots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areaBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortAddress" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accessFromTokyoDescription",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SpotsPanelHeader_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SpotsList_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SpotsBottomInfo_Area" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SpotsJsonLd_Area" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotCard_AreaGuideSpot" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AreaGuideSpot" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "categories" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "businessHours" } },
          { kind: "Field", name: { kind: "Name", value: "websiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "mapUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "images" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsPanelHeader_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsList_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SpotCard_AreaGuideSpot" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsBottomInfo_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTipsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotTips" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guideSpotMapListUrl" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SpotsJsonLd_Area" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
      },
    },
  ],
} as unknown as DocumentNode<AreaSpotsQuery, AreaSpotsQueryVariables>;
export const ResendEmailToVerifyEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResendEmailToVerifyEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SendEmailToVerifyEmailInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToVerifyEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResendEmailToVerifyEmailMutation,
  ResendEmailToVerifyEmailMutationVariables
>;
export const SendVerificationEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendVerificationEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SendEmailToVerifyEmailInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToVerifyEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables
>;
export const IsOrganizationManagerForGlobalMenuDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsOrganizationManagerForGlobalMenu" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IsOrganizationManagerForGlobalMenuQuery,
  IsOrganizationManagerForGlobalMenuQueryVariables
>;
export const OrgMemberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgMember" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMember" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "myself" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organizationMembership" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organization" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "reservationStatus",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customFieldValue" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgMemberQuery, OrgMemberQueryVariables>;
export const UpdateMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "PartialUpdateOrganizationMembershipInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "partialUpdateOrganizationMembership",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "PartialUpdateOrganizationMembershipError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OrganizationMembership" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customFieldValue" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMembershipMutation,
  UpdateMembershipMutationVariables
>;
export const LeaveOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeaveOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LeaveOrganizationError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveOrganizationMutation,
  LeaveOrganizationMutationVariables
>;
export const InviteBusinessMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InviteBusinessMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InviteBusinessMembersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inviteBusinessMembers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InviteBusinessMembersSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sentCount" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InviteBusinessMembersError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteBusinessMembersMutation,
  InviteBusinessMembersMutationVariables
>;
export const DataForOrgMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DataForOrgMembers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailDomainsForMember" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "members" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deletedAt" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "OrganizationMemberTableFragment",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "OrganizationMemberExportFragment",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "memberCustomField" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "placeholder" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationMemberTableFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationStatus" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationMemberExportFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "japanLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine1" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "intlLine2" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "role" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customFieldValue" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationStatus" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataForOrgMembersQuery,
  DataForOrgMembersQueryVariables
>;
export const DataForDashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DataForDashboard" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "currentOrUpcomingContract",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nightsPerYear" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nightsPerMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "businessPlan" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "feePerNights",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isPeakDayFeeFree",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amountRecord" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membersStay" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "monthlyConsumedNights",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "yearMonth" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nights" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "usedNightsInCurrentContract",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "control" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxNightsPerMonth",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxNightsPerStay" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataForDashboardQuery,
  DataForDashboardQueryVariables
>;
export const UpdateOrganizationBillingEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrganizationBillingEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PartialUpdateOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "partialUpdateOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "PartialUpdateOrganizationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrganizationBillingEmailMutation,
  UpdateOrganizationBillingEmailMutationVariables
>;
export const OrganizationPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrganizationPayments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stripe" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "defaultCard" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "brand" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "last4" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exp_month" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exp_year" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoices" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "statuses" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      { kind: "EnumValue", value: "paid" },
                                      { kind: "EnumValue", value: "open" },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "total" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "hosted_invoice_url",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subscription",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "createdAt" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "status_transitions",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "paid_at",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "paymentMethodCardEnabled",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bubbleId" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrganizationBillingEmail",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationBillingEmail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "billingEmail" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationPaymentsQuery,
  OrganizationPaymentsQueryVariables
>;
export const ReservationsForExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReservationsForExport" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membersStay" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "reservationsForExport",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contractStartDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organizationName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "userName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "userEmail" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "accommodationCode",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "siteName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "checkInDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "checkOutDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "stayStatus" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "totalAmount",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "numberOfAdults",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "numberOfInfants",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "numberOfKids",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "numberOfDogs",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nights" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "stayComment",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "stayRating" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "createdAt" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "updatedAt" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationsForExportQuery,
  ReservationsForExportQueryVariables
>;
export const DataForOrgReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DataForOrgReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "yearMonth" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainYearMonth" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membersStay" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservations" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "month" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "yearMonth" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "excludeCancel",
                                  },
                                  value: { kind: "BooleanValue", value: false },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "email",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "accommodation",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nights" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "stayStatus" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AccommodationReservationDetail",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
          { kind: "Field", name: { kind: "Name", value: "checkedOutAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "review" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rating" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataForOrgReservationsQuery,
  DataForOrgReservationsQueryVariables
>;
export const UpdateOrganizationSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrganizationSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PartialUpdateOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "partialUpdateOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "PartialUpdateOrganizationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrganizationSettingsMutation,
  UpdateOrganizationSettingsMutationVariables
>;
export const DataForOrgSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DataForOrgSettings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "currentOrUpcomingContract",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nightsPerYear" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "businessPlan" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amountRecord" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrganizationSettingsForm",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationSettingsForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "control" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMonth" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerStay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxNightsPerMember" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "invitationCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailDomainsForMember" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "memberCustomField" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "announcementContent" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentOrUpcomingContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerYear" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nightsPerMonth" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataForOrgSettingsQuery,
  DataForOrgSettingsQueryVariables
>;
export const GetOrganizationForSignUpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrganizationForSignUp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailDomainsForMember" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitationCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "announcementContent" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memberCustomField" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabled" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "required" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOrganizationForSignUpQuery,
  GetOrganizationForSignUpQueryVariables
>;
export const SetUserNameAndJoinOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetUserNameAndJoinOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customFieldValue" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateViewerName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "joinOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "EnumValue", value: "Member" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customFieldValue" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customFieldValue" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "JoinOrganizationError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetUserNameAndJoinOrganizationMutation,
  SetUserNameAndJoinOrganizationMutationVariables
>;
export const AccommodationReservationForCheckInDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationForCheckIn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardCheckInTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfTotalChildren" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previousLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeApplicability" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveDogFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveEvChargerFee" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "checkInAuthenticationType",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userCompanions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkInQrCode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "earlyCheckInStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentEarlyCheckInFee" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EarlyCheckInInfoModal" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EarlyCheckInInfoModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInPriceTable" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                { kind: "Field", name: { kind: "Name", value: "endHour" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationForCheckInQuery,
  AccommodationReservationForCheckInQueryVariables
>;
export const UpdateAccommodationReservationOptionsOnCheckInPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "UpdateAccommodationReservationOptionsOnCheckInPage",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateAccommodationReservationOptionsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateAccommodationReservationOptions",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateAccommodationReservationOptionsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAccommodationReservationOptionsOnCheckInPageMutation,
  UpdateAccommodationReservationOptionsOnCheckInPageMutationVariables
>;
export const CheckInAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "checkInAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CheckInAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkInAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CheckInAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckInAccommodationReservationMutation,
  CheckInAccommodationReservationMutationVariables
>;
export const AccommodationReservationForQrCodeAuthGuideDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AccommodationReservationForQrCodeAuthGuide",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "mapImageUrl",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "checkInAuthenticationType",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationForQrCodeAuthGuideQuery,
  AccommodationReservationForQrCodeAuthGuideQueryVariables
>;
export const GenerateCheckInQrCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateCheckInQrCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenerateCheckInQrCodeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateCheckInQrCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "GenerateCheckInQrCodeSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "checkInQrCode" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CheckInQrCodeFields",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "GenerateCheckInQrCodeError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckInQrCodeFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckInQrCode" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateCheckInQrCodeMutation,
  GenerateCheckInQrCodeMutationVariables
>;
export const CheckInQrCodeStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CheckInQrCodeStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkInQrCode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CheckInQrCodeFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckInQrCodeFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckInQrCode" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckInQrCodeStatusQuery,
  CheckInQrCodeStatusQueryVariables
>;
export const IsViewerLoggedInForCheckinDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsViewerLoggedInForCheckin" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IsViewerLoggedInForCheckinQuery,
  IsViewerLoggedInForCheckinQueryVariables
>;
export const LookupOtaReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LookupOtaReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reference" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lookupOtaReservationByReference" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reference" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reference" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "OtaReservationLookupSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preRegistrationUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureTypeName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OtaReservationLookupError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LookupOtaReservationQuery,
  LookupOtaReservationQueryVariables
>;
export const CheckinRedirectMaybeViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CheckinRedirectMaybeViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allAccommodationReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckinRedirectMaybeViewerQuery,
  CheckinRedirectMaybeViewerQueryVariables
>;
export const SubmitCoOwnersApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitCoOwnersApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoOwnersApplicationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SubmitCoOwnersApplicationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StripeRequireNextAction" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clientSecret" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "coOwnersApplicationId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitCoOwnersApplicationMutation,
  SubmitCoOwnersApplicationMutationVariables
>;
export const FacilityReservationCancelDialogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FacilityReservationCancelDialog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resourceLabel" },
                },
                { kind: "Field", name: { kind: "Name", value: "startAt" } },
                { kind: "Field", name: { kind: "Name", value: "endAt" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargedFeeAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "estimatedCancelFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facility" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelRuleUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FacilityReservationCancelDialogQuery,
  FacilityReservationCancelDialogQueryVariables
>;
export const UpdateFacilityReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFacilityReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateFacilityReservationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateFacilityReservationSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isCancelable" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "estimatedCancelFee",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "controllers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attribute" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename",
                                          },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "RentalCycleKeyBox",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "RentalCycleKeyBoxFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RentalCycleKeyBoxFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RentalCycleKeyBox" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inUseAt" } },
          { kind: "Field", name: { kind: "Name", value: "returnedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reservationId" } },
          { kind: "Field", name: { kind: "Name", value: "usableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "usableTo" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFacilityReservationMutation,
  UpdateFacilityReservationMutationVariables
>;
export const WashingMachineTrackerStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WashingMachineTrackerStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plugDevice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastChangedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WashingMachineTrackerStatusQuery,
  WashingMachineTrackerStatusQueryVariables
>;
export const FacilityDetailPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FacilityDetailPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FacilityType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "facilityType" },
                  name: { kind: "Name", value: "type" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReserveEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentUsage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentNotice" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "controllers" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: {
                              kind: "Name",
                              value: "accommodationReservationId",
                            },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "id" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FacilityControllerFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoWorkingSpaceDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "keyUrl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnsenAndSaunaDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EvChargerLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EvChargerLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "expireAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RentalCycleKeyBoxFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RentalCycleKeyBox" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inUseAt" } },
          { kind: "Field", name: { kind: "Name", value: "returnedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reservationId" } },
          { kind: "Field", name: { kind: "Name", value: "usableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "usableTo" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WashingMachineTrackerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WashingMachineTracker" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityControllerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityController" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoWorkingSpaceDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnsenAndSaunaDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "EvChargerLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EvChargerLockFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RentalCycleKeyBox" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RentalCycleKeyBoxFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WashingMachineTracker" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WashingMachineTrackerFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FacilityDetailPageQuery,
  FacilityDetailPageQueryVariables
>;
export const FacilityReservationsByAccommodationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FacilityReservationsByAccommodation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FacilityType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFacilityReservable" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "facilityType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "facilityType" },
                      },
                    },
                  ],
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityReservations" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "EnumValue", value: "Reserved" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "facilityType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "facilityType" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FacilityReservationDetail",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoWorkingSpaceDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "keyUrl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OnsenAndSaunaDoorLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EvChargerLockFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EvChargerLock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "expireAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RentalCycleKeyBoxFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RentalCycleKeyBox" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "pinCode" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inUseAt" } },
          { kind: "Field", name: { kind: "Name", value: "returnedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reservationId" } },
          { kind: "Field", name: { kind: "Name", value: "usableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "usableTo" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WashingMachineTrackerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WashingMachineTracker" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "controllerId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityControllerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityController" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attribute" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoWorkingSpaceDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoWorkingSpaceDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "OnsenAndSaunaDoorLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OnsenAndSaunaDoorLockFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "EvChargerLock" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EvChargerLockFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RentalCycleKeyBox" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "RentalCycleKeyBoxFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WashingMachineTracker" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WashingMachineTrackerFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityReservationDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FacilityReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "startAt" } },
          { kind: "Field", name: { kind: "Name", value: "endAt" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          { kind: "Field", name: { kind: "Name", value: "chargedFeeAmount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customFieldValues" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isCancelable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "estimatedCancelFee" },
          },
          { kind: "Field", name: { kind: "Name", value: "resourceLabel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "controllers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityControllerFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facility" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "facilityType" },
                        name: { kind: "Name", value: "type" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detailUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentUsage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentDetail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentNotice" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelRuleUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customFields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "required" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "options" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "placeholder" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FacilityReservationsByAccommodationQuery,
  FacilityReservationsByAccommodationQueryVariables
>;
export const CancelFacilityReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelFacilityReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelFacilityReservationMutation,
  CancelFacilityReservationMutationVariables
>;
export const CreateFacilityReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateFacilityReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateFacilityReservationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFacilityReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFacilityReservationSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFacilityReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFacilityReservationMutation,
  CreateFacilityReservationMutationVariables
>;
export const FacilityReservationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FacilityReservationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FacilityType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "facility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "facilityType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isReserveEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isReservable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "baseFeePolicies" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unit" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unitFeeAmount" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "slotAvailabilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slotId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isReservable" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "unavailableReason",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentGuide" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customFields" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "required" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "discountFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discountModifierType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discountValue" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "termsUrl" } },
                { kind: "Field", name: { kind: "Name", value: "termsLabel" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FacilityReservationPageQuery,
  FacilityReservationPageQueryVariables
>;
export const PermissionOnDefaultLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PermissionOnDefaultLayout" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasReservablePlan" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PermissionOnDefaultLayoutQuery,
  PermissionOnDefaultLayoutQueryVariables
>;
export const MyReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MyReservations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCheckIn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCheckOut" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentEarlyCheckInFee" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ReservationBox" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationBox" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyReservationsQuery, MyReservationsQueryVariables>;
export const InitiateAccountLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InitiateAccountLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InitiateAccountLinkInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "initiateAccountLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InitiateAccountLinkSuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redirectUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InitiateAccountLinkError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiateAccountLinkMutation,
  InitiateAccountLinkMutationVariables
>;
export const VerifyAccountLinkSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "VerifyAccountLinkSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VerifyAccountLinkSessionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyAccountLinkSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "VerifyAccountLinkSessionSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentIdentity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "provider" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "connection" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "candidateIdentity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "provider" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "connection" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "VerifyAccountLinkSessionError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyAccountLinkSessionQuery,
  VerifyAccountLinkSessionQueryVariables
>;
export const EditEmailDialogSendEmailToVerifyNewEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditEmailDialogSendEmailToVerifyNewEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newEmail" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToVerifyNewEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "newEmail" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "newEmail" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditEmailDialogSendEmailToVerifyNewEmailMutation,
  EditEmailDialogSendEmailToVerifyNewEmailMutationVariables
>;
export const EditEmailDialogVerifyNewEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditEmailDialogVerifyNewEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newEmail" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyNewEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "newEmail" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "newEmail" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "code" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerifyNewEmailError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditEmailDialogVerifyNewEmailMutation,
  EditEmailDialogVerifyNewEmailMutationVariables
>;
export const LinkedIdentitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LinkedIdentities" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailVerified" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "connection" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAppleRelay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "autoGeneratedPassword" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkedIdentitiesQuery,
  LinkedIdentitiesQueryVariables
>;
export const InitiateAddIdentityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InitiateAddIdentity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InitiateAddIdentityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "initiateAddIdentity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InitiateAddIdentitySuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redirectUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InitiateAddIdentityError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiateAddIdentityMutation,
  InitiateAddIdentityMutationVariables
>;
export const RemoveIdentityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveIdentity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RemoveIdentityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeIdentity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RemoveIdentitySuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "removedProvider" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RemoveIdentityError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveIdentityMutation,
  RemoveIdentityMutationVariables
>;
export const LinkedIdentitiesResendVerificationEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkedIdentitiesResendVerificationEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SendEmailToVerifyEmailInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailToVerifyEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendEmailToVerifyNewEmailError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkedIdentitiesResendVerificationEmailMutation,
  LinkedIdentitiesResendVerificationEmailMutationVariables
>;
export const LinkedIdentitiesSendPasswordResetEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkedIdentitiesSendPasswordResetEmail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendPasswordResetEmail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendPasswordResetEmailSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkedIdentitiesSendPasswordResetEmailMutation,
  LinkedIdentitiesSendPasswordResetEmailMutationVariables
>;
export const CoOwnerApplicationDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CoOwnerApplicationDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "NullValue" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitApplicationFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitPurchaseAmount" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoOwnersApplicationDetails",
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "selectedWebinarSchedule" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startsAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "s2oPoint" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersApplicationProgressArea",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CoOwnersApplicationFilesArea" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "handoverStartDate" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "applicantInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailIndividual",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "useLoan" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "CoOwnersApplicantInfoDetailOrganization",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "representativeName",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "desiredHandoverDate" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationFormDialog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersOwnerInfoFormDefaultValues" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationWebinarSelector" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "unitNightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitPurchaseAmount" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitApplicationFee" },
          },
          { kind: "Field", name: { kind: "Name", value: "registrationFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersMaxPeakDaysPerUnit" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "coOwnersMaxConcurrentReservationsPerUnit",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnersPlanOfferings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "earlyAccessCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "units" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "estimate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationFacilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationProgressArea" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "advancePaymentRequired" },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasCoOwnersApplicationRequiredFieldsFilled",
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestedOtherWebinarSchedule" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "webinarSchedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedWebinarSchedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startsAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersApplicationFormDialog" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CoOwnersApplicationWebinarSelector" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationFilesArea" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnerApplicationDetailQuery,
  CoOwnerApplicationDetailQueryVariables
>;
export const CancelCoOwnersApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelCoOwnersApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelCoOwnersApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelCoOwnersApplicationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelCoOwnersApplicationMutation,
  CancelCoOwnersApplicationMutationVariables
>;
export const CoOwnersApplicationFilesAreaCreateUploadPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationFilesAreaCreateUploadPolicy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateCoOwnersApplicationFileUploadPolicyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createCoOwnersApplicationFileUploadPolicy",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationFilesAreaCreateUploadPolicyMutation,
  CoOwnersApplicationFilesAreaCreateUploadPolicyMutationVariables
>;
export const CoOwnersApplicationFilesAreaRegisterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CoOwnersApplicationFilesAreaRegister" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "RegisterCoOwnersApplicationFileInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerCoOwnersApplicationFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationFilesAreaRegisterMutation,
  CoOwnersApplicationFilesAreaRegisterMutationVariables
>;
export const CoOwnersApplicationFilesAreaCreateDownloadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "CoOwnersApplicationFilesAreaCreateDownloadUrl",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createCoOwnersApplicationFileDownloadUrl",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationFileId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateCoOwnersApplicationFileDownloadUrlSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoOwnersApplicationFilesAreaCreateDownloadUrlMutation,
  CoOwnersApplicationFilesAreaCreateDownloadUrlMutationVariables
>;
export const UpdateCoOwnersApplicationOwnerInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCoOwnersApplicationOwnerInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CoOwnersApplicationOwnerInfoInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCoOwnersApplicationOwnerInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateCoOwnersApplicationOwnerInfoError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCoOwnersApplicationOwnerInfoMutation,
  UpdateCoOwnersApplicationOwnerInfoMutationVariables
>;
export const SelectWebinarScheduleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SelectWebinarSchedule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "webinarScheduleId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "applicationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "selectWebinarSchedule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersWebinarScheduleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "webinarScheduleId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "applicationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CoOwnersApplication" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SelectWebinarScheduleError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SelectWebinarScheduleMutation,
  SelectWebinarScheduleMutationVariables
>;
export const GetViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AddressInJapan" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line2" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AddressInternational",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "lineOne" },
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "lineTwo" },
                                    name: { kind: "Name", value: "line2" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "stateProvince",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetViewerQuery, GetViewerQueryVariables>;
export const GetUserCompanionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserCompanion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userCompanion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInJapan" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AddressInternational" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "lineOne" },
                              name: { kind: "Name", value: "line1" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "lineTwo" },
                              name: { kind: "Name", value: "line2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateProvince" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionType" },
                },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "nationality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passportPhoto" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserCompanionQuery,
  GetUserCompanionQueryVariables
>;
export const CreateUserCompanionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateUserCompanion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserCompanionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUserCompanion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateUserCompanionMutation,
  CreateUserCompanionMutationVariables
>;
export const UpdateUserCompanionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserCompanion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserCompanionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserCompanion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserCompanionMutation,
  UpdateUserCompanionMutationVariables
>;
export const DeleteUserCompanionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUserCompanion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUserCompanion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteUserCompanionMutation,
  DeleteUserCompanionMutationVariables
>;
export const UserCompanionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserCompanions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "companions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCompanionsQuery, UserCompanionsQueryVariables>;
export const DeleteViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DeleteViewerError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteViewerMutation,
  DeleteViewerMutationVariables
>;
export const GetInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInvoices" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingCycleDay" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_month" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_year" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoices" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "statuses" },
                            value: {
                              kind: "ListValue",
                              values: [{ kind: "EnumValue", value: "paid" }],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hosted_invoice_url",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subscription" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "bubbleId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const ViewerPastStayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewerPastStay" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allAccommodationReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PastStayRowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PastStayRowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nights" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewerPastStayQuery, ViewerPastStayQueryVariables>;
export const ViewerOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewerOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userOwnership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "CoOwnersPlanDetail_UserOwnership",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FullOwnerPlanDetail_UserOwnership",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersPlanDetail_UserOwnership" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
                { kind: "Field", name: { kind: "Name", value: "siteSizeSqm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "leasedLandSizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestRoomSizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balconySizeSqm" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeePerNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heldAccommodationClass" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitPurchaseAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualMaintenanceFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualRepairReserve" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitAnnualLandRentFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formOfRights" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "maxPeakDaysPerYear" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "maxSiteHighSeasonDaysPerYear" },
          },
          { kind: "Field", name: { kind: "Name", value: "holderName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullOwnerPlanDetail_UserOwnership" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseAccommodationFeePerNight" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "nonOwnedBaseAccommodationFeePerNight",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heldAccommodationClass" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewerOwnershipQuery,
  ViewerOwnershipQueryVariables
>;
export const ResolveBusinessMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ResolveBusinessMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invitationCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationIdByInvitationCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitationCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invitationCode" },
                },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResolveBusinessMembershipQuery,
  ResolveBusinessMembershipQueryVariables
>;
export const CancelStandardSubscriptionApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelStandardSubscriptionApplication" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "cancelStandardSubscriptionApplication",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelStandardSubscriptionApplicationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stripeRequestId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelStandardSubscriptionApplicationMutation,
  CancelStandardSubscriptionApplicationMutationVariables
>;
export const CancelStandardSubscriptionPauseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelStandardSubscriptionPause" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelStandardSubscriptionPause" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelStandardSubscriptionPauseError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelStandardSubscriptionPauseMutation,
  CancelStandardSubscriptionPauseMutationVariables
>;
export const CancelStandardSubscriptionTerminationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelStandardSubscriptionTermination" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "cancelStandardSubscriptionTermination",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelStandardSubscriptionTerminationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelStandardSubscriptionTerminationMutation,
  CancelStandardSubscriptionTerminationMutationVariables
>;
export const ResumeStandardSubscriptionImmediatelyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResumeStandardSubscriptionImmediately" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "resumeStandardSubscriptionImmediately",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ResumeStandardSubscriptionImmediatelyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeStandardSubscriptionImmediatelyMutation,
  ResumeStandardSubscriptionImmediatelyMutationVariables
>;
export const CancelTrialSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelTrialSubscription" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelTrialSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelTrialSubscriptionError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelTrialSubscriptionMutation,
  CancelTrialSubscriptionMutationVariables
>;
export const GetSubscriptionStatusForPollingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSubscriptionStatusForPolling" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusDetail" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSubscriptionStatusForPollingQuery,
  GetSubscriptionStatusForPollingQueryVariables
>;
export const GetTrialContractStatusForPollingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTrialContractStatusForPolling" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusDetail" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTrialContractStatusForPollingQuery,
  GetTrialContractStatusForPollingQueryVariables
>;
export const GetViewerDataToEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetViewerDataToEdit" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrganizationMembershipOnPlanSectionFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "SubscriptionOnPlanSectionFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "TrialContractOnPlanSectionFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StaffContractOnPlanSectionFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "coOwnersApplication" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoOwnershipOnPlanSectionFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FullOwnershipOnPlanSectionFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnersApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CoOwnersApplicationSectionFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OrganizationMembershipOnPlanSectionFragment",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrganizationMembership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationNewStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "latestYearlyReservationStatuses",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endYearMonth" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserSubscription" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusDetail" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "enrollmentScheduledAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "enrolledAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "terminationScheduledAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "terminatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "pauseScheduledAt" } },
          { kind: "Field", name: { kind: "Name", value: "pausedAt" } },
          { kind: "Field", name: { kind: "Name", value: "resumeScheduledAt" } },
          { kind: "Field", name: { kind: "Name", value: "resumedAt" } },
          { kind: "Field", name: { kind: "Name", value: "pausableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "terminatableFrom" } },
          { kind: "Field", name: { kind: "Name", value: "billingCycleDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationCycle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accumulatedS2oAmount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrialContractOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TrialContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterGrantedStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterGrantedStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accumulatedS2oAmount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffContractOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusDetail" } },
          { kind: "Field", name: { kind: "Name", value: "staffType" } },
          { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
          { kind: "Field", name: { kind: "Name", value: "terminatedDate" } },
          { kind: "Field", name: { kind: "Name", value: "isReservable" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentSemesterGrantedStayCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "semesterCredits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "semester" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grantedStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingPeakDays" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnershipOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullOwnershipOnPlanSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "nightsPerYear" } },
          { kind: "Field", name: { kind: "Name", value: "usageStartDate" } },
          { kind: "Field", name: { kind: "Name", value: "usageEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "nextPaymentDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CoOwnersApplicationSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoOwnersApplication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerPlan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitNightsPerYear" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetViewerDataToEditQuery,
  GetViewerDataToEditQueryVariables
>;
export const LeaveOrganizationMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeaveOrganizationMembership" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveOrganizationByViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "LeaveOrganizationByViewerError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveOrganizationMembershipMutation,
  LeaveOrganizationMembershipMutationVariables
>;
export const DrinkTicketCurrentStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DrinkTicketCurrentStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "isEligibleMemberForDrinkTicketPerks",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentMonthUsedDrinkTicket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "used" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DrinkTicketCurrentStatusQuery,
  DrinkTicketCurrentStatusQueryVariables
>;
export const ActivateDrinkTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ActivateDrinkTicket" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activateMemberPerksDrinkTicket" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ActivateMemberPerksDrinkTicketError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivateDrinkTicketMutation,
  ActivateDrinkTicketMutationVariables
>;
export const UpdateViewerSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateViewerSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserSystemSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "partialUpdateViewerSystemSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "systemSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasSeenHouseRules" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateViewerSettingsMutation,
  UpdateViewerSettingsMutationVariables
>;
export const PreRegistrationResumeButtonQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PreRegistrationResumeButtonQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFilledRequiredProfile" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PreRegistrationResumeButtonQueryQuery,
  PreRegistrationResumeButtonQueryQueryVariables
>;
export const QueryForMyTentativeReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QueryForMyTentativeReservations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "unconfirmedAccommodationReservations",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QueryForMyTentativeReservationsQuery,
  QueryForMyTentativeReservationsQueryVariables
>;
export const TopPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TopPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "topPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bannerContents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TopPageBannerContents" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TopPageUpdates" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HouseRulesDialogFragment" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermsAgreementSection_User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsAgreementModal_TermsRevision" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermsRevision" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "terms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopPageBannerContents" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TopPage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bannerContents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopPageUpdates" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TopPage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "serviceUpdate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "isNew" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveArticle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "isNew" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "contentType" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HouseRulesDialogFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "systemSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasSeenHouseRules" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsAgreementSection_User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredTermsAgreements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "plan" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "TermsAgreementModal_TermsRevision",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopPageQuery, TopPageQueryVariables>;
export const NewsDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NewsDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "newsDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsDetailQuery, NewsDetailQueryVariables>;
export const NewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "News" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "contentType" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsQuery, NewsQueryVariables>;
export const GetViewerForTrialRedirectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetViewerForTrialRedirect" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetViewerForTrialRedirectQuery,
  GetViewerForTrialRedirectQueryVariables
>;
export const PermissionOnReservationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PermissionOnReservationForm" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFilledRequiredProfile" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasReservablePlan" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "accessibleReservationCalendars",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enrolledAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enrollmentScheduledAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usageStartDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usageStartDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationUnavailableMessage",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ReservationOwnershipSelectTab",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReservationProviderSelect" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserReservationCountForLog" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationUnavailableMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "subscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trialContract" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationNewStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suspended" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasUnpaidAccommodationFee" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationOwnershipSelectTab" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OwnerPlanName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fullOwnerships" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OwnerPlanName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationProviderSelect" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accessibleReservationCalendars" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserReservationCountForLog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stayedReservationCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PermissionOnReservationFormQuery,
  PermissionOnReservationFormQueryVariables
>;
export const OriginalReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OriginalReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "StandardPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "CoOwnersPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userOwnershipId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "FullOwnerPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userOwnershipId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "BusinessPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "TrialPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trialContractId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StaffPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "staffContractId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OriginalReservationOnReservationForm",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnReservationCalendar",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnAvailabilityCell",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservationForm",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OriginalReservationOnReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OriginalReservationQuery,
  OriginalReservationQueryVariables
>;
export const TermsAgreementGuardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TermsAgreementGuard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requiredTermsAgreements" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "TermsAgreementModal_TermsRevision",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermsAgreementModal_TermsRevision" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermsRevision" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "terms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "documentUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TermsAgreementGuardQuery,
  TermsAgreementGuardQueryVariables
>;
export const ReservationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReservationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "canCheckIn" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationPageQuery,
  ReservationPageQueryVariables
>;
export const TentativeReservationForReservationStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TentativeReservationForReservationStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tentativeAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RedirectLocation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "TentativeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "TentativeAccommodationReservationErrorCase",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "TentativeAccommodationReservationErrorCase",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TentativeAccommodationReservationError" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "case" } }],
      },
    },
  ],
} as unknown as DocumentNode<
  TentativeReservationForReservationStatusQuery,
  TentativeReservationForReservationStatusQueryVariables
>;
export const MaybeViewerForReservationStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MaybeViewerForReservationStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFilledRequiredProfile" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MaybeViewerForReservationStatusQuery,
  MaybeViewerForReservationStatusQueryVariables
>;
export const ReservationDetailPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReservationDetailPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFilledRequiredProfile" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "canCheckIn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "earlyCheckInStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userAcceptCode" },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "taxRate" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localTaxPolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForCancelFeePolicyFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationReservationInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForCancelFeePolicyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlanType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationDetailPageQuery,
  ReservationDetailPageQueryVariables
>;
export const AccommodationReservationCancelPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationCancelPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "canCancel" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationCancelPageQuery,
  AccommodationReservationCancelPageQueryVariables
>;
export const AccommodationReservationCompanionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationCompanions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "companions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userCompanions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfTotalChildren" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationCompanionsQuery,
  AccommodationReservationCompanionsQueryVariables
>;
export const AssignCompanionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AssignCompanions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationReservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userCompanionIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignUserCompanions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationReservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userCompanionIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userCompanionIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignCompanionsMutation,
  AssignCompanionsMutationVariables
>;
export const CancelOneMoreCabinAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "CancelOneMoreCabinAccommodationReservation",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelOneMoreCabinAccommodationReservationMutation,
  CancelOneMoreCabinAccommodationReservationMutationVariables
>;
export const OneMoreCabinAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OneMoreCabinAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "oneMoreCabinAccommodationReservation",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OneMoreCabinAccommodationReservation",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OriginalReservationOnReservationForm",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserReservationCountForLog" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OneMoreCabinAccommodationReservationCancelConfirmation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTotalChildren" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationReservationInfo" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnReservationCalendar",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnAvailabilityCell",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservationForm",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OneMoreCabinAccommodationReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "taxRate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "tentativeDeadline" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          { kind: "Field", name: { kind: "Name", value: "invitationUrl" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OneMoreCabinAccommodationReservationCancelConfirmation",
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationReservationInfo" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OriginalReservationOnReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserReservationCountForLog" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stayedReservationCount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OneMoreCabinAccommodationReservationQuery,
  OneMoreCabinAccommodationReservationQueryVariables
>;
export const CancellableStayGiftsForOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CancellableStayGiftsForOwner" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancellableStayGiftsForOwner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancellableStayGiftsForOwnerQuery,
  CancellableStayGiftsForOwnerQueryVariables
>;
export const CancelStayGiftsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelStayGifts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ticketIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelStayGifts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ticketIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ticketIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelStayGiftsResult" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelledTickets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelStayGiftsError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelStayGiftsMutation,
  CancelStayGiftsMutationVariables
>;
export const ExportStayGiftsForOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ExportStayGiftsForOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userOwnershipId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportStayGiftsForOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userOwnershipId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userOwnershipId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitationUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "validFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "validTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportStayGiftsForOwnerQuery,
  ExportStayGiftsForOwnerQueryVariables
>;
export const AcquireStayTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AcquireStayTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AcquireStayTicketsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acquireStayTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AcquireStayTicketsResult" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tickets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AcquireStayTicketsError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AcquireStayTicketsMutation,
  AcquireStayTicketsMutationVariables
>;
export const StayGiftTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StayGiftTickets" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isGuest" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketTableFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OwnershipForStayGiftFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OwnershipForStayGiftFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isEligibleToPurchaseStayGift" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketTableFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnershipForStayGiftFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingNights" },
                },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayGiftTicketsQuery,
  StayGiftTicketsQueryVariables
>;
export const AccommodationResrvationToGetProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationResrvationToGetProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptMarketingEmail" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardCheckInTime" },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isRoomTypeReservation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isRemote" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "checkInAuthenticationType",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "area" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "series" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "capacity" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "additionalFee" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roomType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previousLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingMethod" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeApplicability" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "waiveArchitectureTypeAdditionalFee",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveDogFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveSaunaFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveOnsenFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveEvChargerFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveDogRunFee" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localTaxPolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketMasterId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeStartsAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeAdultPricePerNight",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeKidsPricePerNight",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForCancelFeePolicyFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "OneMoreCabinAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "parentAccommodationReservationId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "CoOwnersPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userOwnershipId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "FullOwnerPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userOwnershipId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "BusinessPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "SanuIncAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "usage" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StayTicketAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayTicketUnitId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "OnlineTravelAgentAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isIkyuDiamondMember",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "TrialPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trialContractId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StaffPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "staffContractId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "OriginalAccommodationReservationOnDraftReservationForm",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForCancelFeePolicyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlanType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationResrvationToGetProviderQuery,
  AccommodationResrvationToGetProviderQueryVariables
>;
export const AccommodationForProviderOnConfirmPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationForProviderOnConfirmPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "night" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isOwned" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationClass" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "night" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "night" },
                      },
                    },
                  ],
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "classRelation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "night" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "night" },
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationForProviderOnConfirmPageQuery,
  AccommodationForProviderOnConfirmPageQueryVariables
>;
export const UpdateAccommodationReservationOptionsOnConfirmPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "UpdateAccommodationReservationOptionsOnConfirmPage",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateAccommodationReservationOptionsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateAccommodationReservationOptions",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateAccommodationReservationOptionsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAccommodationReservationOptionsOnConfirmPageMutation,
  UpdateAccommodationReservationOptionsOnConfirmPageMutationVariables
>;
export const ConfirmTentativeAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmTentativeAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ConfirmTentativeAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "confirmTentativeAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "detailInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ConfirmTentativeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmTentativeAccommodationReservationMutation,
  ConfirmTentativeAccommodationReservationMutationVariables
>;
export const UpdateViewerMarketingEmailConsentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateViewerMarketingEmailConsent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accept" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateViewerMarketingEmailConsent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accept" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accept" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptMarketingEmail" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateViewerMarketingEmailConsentMutation,
  UpdateViewerMarketingEmailConsentMutationVariables
>;
export const TentativeReservationForProfileEditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TentativeReservationForProfileEdit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TentativeReservationForProfileEditQuery,
  TentativeReservationForProfileEditQueryVariables
>;
export const AcceptTentativeReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AcceptTentativeReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userAcceptCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AcceptAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AcceptTentativeReservationMutation,
  AcceptTentativeReservationMutationVariables
>;
export const AccommodationReservationForStayTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationForStayTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutationScope" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StayTicketAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayTicketUnitId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelFeePolicy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CancelFeeRatePolicy",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "immediate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CancelFeeFixedPolicy",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "immediate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForTicketReservationForm",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OriginalReservationOnReservationForm",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TicketReservationConditions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnReservationCalendar",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnAvailabilityCell",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservationForm",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForTicketReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketMasterId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "notice" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableSites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableArchitectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNoticeTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeeStartsAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayStartNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
          { kind: "Field", name: { kind: "Name", value: "stayEndNight" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TicketReservationConditions" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OriginalReservationOnReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationForStayTicketQuery,
  AccommodationReservationForStayTicketQueryVariables
>;
export const ConfirmPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ConfirmPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stayTicketUnitId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roomTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketReservationInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stayTicketUnitId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stayTicketUnitId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNoticeTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roomTypeId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilities" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "firstNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "lastNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "evChargerAvailable" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "evChargerAvailable" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nights" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "availableAccommodations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "facilityTypes",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmPageQuery, ConfirmPageQueryVariables>;
export const BundleStayTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BundleStayTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "codes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bundleStayTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "codes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "codes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketsValidationResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketValidationResult",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForTicketReservationForm",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TicketReservationConditions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveConsumedSuppliesFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "waiveDogFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveSaunaFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveOnsenFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "waiveEvChargerFee" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketValidationResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketValidationResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "stayTicketCode" } },
          { kind: "Field", name: { kind: "Name", value: "validationError" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForTicketReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketMasterId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "notice" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableSites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableArchitectureTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNoticeTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalGuestFeeStartsAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTickets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayStartNight" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayEndNight" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "stayStartNight" } },
          { kind: "Field", name: { kind: "Name", value: "stayEndNight" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TicketReservationConditions" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BundleStayTicketsMutation,
  BundleStayTicketsMutationVariables
>;
export const GetUserCardInTrialSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserCardInTrialSubscription" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_month" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_year" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserCardInTrialSubscriptionQuery,
  GetUserCardInTrialSubscriptionQueryVariables
>;
export const GetCardExistenceInTrialSubscriptionApplyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCardExistenceInTrialSubscriptionApply" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCardExistenceInTrialSubscriptionApplyQuery,
  GetCardExistenceInTrialSubscriptionApplyQueryVariables
>;
export const GetTrialContractStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTrialContractStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTrialContractStatusQuery,
  GetTrialContractStatusQueryVariables
>;
export const ApplyToTrialSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplyToTrialSubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "enrollmentMonth" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainYearMonth" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyToTrialSubscription" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "enrollmentMonth" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "enrollmentMonth" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ApplyToTrialSubscriptionError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StripeRequireNextAction" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clientSecret" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyToTrialSubscriptionMutation,
  ApplyToTrialSubscriptionMutationVariables
>;
export const GetUserNameOnTrialSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserNameOnTrialSubscription" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserNameOnTrialSubscriptionQuery,
  GetUserNameOnTrialSubscriptionQueryVariables
>;
export const SetUserNameOnTrialSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetUserNameOnTrialSubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateViewerName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetUserNameOnTrialSubscriptionMutation,
  SetUserNameOnTrialSubscriptionMutationVariables
>;
export const EstimateStandardSubscriptionApplicationFeeByPromotionCodeDocument =
  {
    kind: "Document",
    definitions: [
      {
        kind: "OperationDefinition",
        operation: "query",
        name: {
          kind: "Name",
          value: "EstimateStandardSubscriptionApplicationFeeByPromotionCode",
        },
        variableDefinitions: [
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "promotionCode" },
            },
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value: "estimateStandardSubscriptionApplicationFee",
              },
              arguments: [
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "promotionCode" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "promotionCode" },
                  },
                },
              ],
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "InlineFragment",
                    typeCondition: {
                      kind: "NamedType",
                      name: {
                        kind: "Name",
                        value: "EstimateStandardSubscriptionApplicationSuccess",
                      },
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "amount" },
                        },
                      ],
                    },
                  },
                  {
                    kind: "InlineFragment",
                    typeCondition: {
                      kind: "NamedType",
                      name: {
                        kind: "Name",
                        value: "EstimateStandardSubscriptionApplicationError",
                      },
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "case" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    EstimateStandardSubscriptionApplicationFeeByPromotionCodeQuery,
    EstimateStandardSubscriptionApplicationFeeByPromotionCodeQueryVariables
  >;
export const GetCardExistenceInSubscriptionApplyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCardExistenceInSubscriptionApply" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_month" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_year" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCardExistenceInSubscriptionApplyQuery,
  GetCardExistenceInSubscriptionApplyQueryVariables
>;
export const GetSubscriptionStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSubscriptionStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSubscriptionStatusQuery,
  GetSubscriptionStatusQueryVariables
>;
export const ApplyToStartWeekdaySubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplyToStartWeekdaySubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startFrom" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "promotionCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyToWeekdaySubscription" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startFrom" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startFrom" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "promotionCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "promotionCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StripeRequireNextAction" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clientSecret" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ApplyToWeekdaySubscriptionError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyToStartWeekdaySubscriptionMutation,
  ApplyToStartWeekdaySubscriptionMutationVariables
>;
export const GetUserNameOnStandardSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserNameOnStandardSubscription" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserNameOnStandardSubscriptionQuery,
  GetUserNameOnStandardSubscriptionQueryVariables
>;
export const SetUserNameOnStandardSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetUserNameOnStandardSubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateViewerName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetUserNameOnStandardSubscriptionMutation,
  SetUserNameOnStandardSubscriptionMutationVariables
>;
export const GetTerminationDateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTerminationDate" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusDetail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminatableDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminatableFrom" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "terminationProhibitReason",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "s2o" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balance" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTerminationDateQuery,
  GetTerminationDateQueryVariables
>;
export const GetStatusDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetStatusDetail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusDetail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminatableFrom" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetStatusDetailQuery,
  GetStatusDetailQueryVariables
>;
export const ScheduleStandardSubscriptionTerminationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ScheduleStandardSubscriptionTermination" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "questionnaire" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UserSubscriptionTerminationQuestionnaireInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "scheduleStandardSubscriptionTermination",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "questionnaire" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "questionnaire" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ScheduleStandardSubscriptionTerminationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScheduleStandardSubscriptionTerminationMutation,
  ScheduleStandardSubscriptionTerminationMutationVariables
>;
export const CancelStandardSubscriptionResumeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelStandardSubscriptionResume" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "questionnaire" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UserSubscriptionTerminationQuestionnaireInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelStandardSubscriptionResume" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "questionnaire" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "questionnaire" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelStandardSubscriptionResumeError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelStandardSubscriptionResumeMutation,
  CancelStandardSubscriptionResumeMutationVariables
>;
export const AccommodationReservationForCheckOutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationForCheckOut" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "canCheckOut" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "SiteContentFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationForCheckOutQuery,
  AccommodationReservationForCheckOutQueryVariables
>;
export const CheckoutAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CheckoutAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkOutAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CheckOutAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckoutAccommodationReservationMutation,
  CheckoutAccommodationReservationMutationVariables
>;
export const MemberPermissionCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MemberPermissionCheck" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasReservablePlan" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MemberPermissionCheckQuery,
  MemberPermissionCheckQueryVariables
>;
export const HealthcheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Healthcheck" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HealthcheckQuery, HealthcheckQueryVariables>;
export const EarlyCheckInDashboardAreasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EarlyCheckInDashboardAreas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EarlyCheckInDashboardAreasQuery,
  EarlyCheckInDashboardAreasQueryVariables
>;
export const EarlyCheckInDashboardReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EarlyCheckInDashboardReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endFirstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationScope" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccommodationScope" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationReservationsBySearch",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationScope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "hasCanceled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "earlyCheckInEligible" },
                },
                { kind: "Field", name: { kind: "Name", value: "checkedInAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInSlot" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EarlyCheckInDashboardReservationsQuery,
  EarlyCheckInDashboardReservationsQueryVariables
>;
export const EarlyCheckInDashboardViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EarlyCheckInDashboardViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EarlyCheckInDashboardViewerQuery,
  EarlyCheckInDashboardViewerQueryVariables
>;
export const GetViewerNameAndEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetViewerNameAndEmail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetViewerNameAndEmailQuery,
  GetViewerNameAndEmailQueryVariables
>;
export const DeleteAccommodationAvailabilityBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteAccommodationAvailabilityBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "deleteAccommodationAvailabilityBlock",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAccommodationAvailabilityBlockMutation,
  DeleteAccommodationAvailabilityBlockMutationVariables
>;
export const PartnerCalendarViewerDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PartnerCalendarViewerData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PartnerCalendarViewerDataQuery,
  PartnerCalendarViewerDataQueryVariables
>;
export const PartnerCalendarAreasDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PartnerCalendarAreasData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PartnerCalendarAreasDataQuery,
  PartnerCalendarAreasDataQueryVariables
>;
export const PartnerCalendarBaseDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PartnerCalendarBaseData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withArchitecture" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationRowFragment" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationRowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withArchitecture" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PartnerCalendarBaseDataQuery,
  PartnerCalendarBaseDataQueryVariables
>;
export const PartnerCalendarEventsDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PartnerCalendarEventsData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startLastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endFirstNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationScope" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AccommodationScope" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalAccommodationReservationsBySearch",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startLastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endFirstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationScope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "earlyCheckInEligible" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "guestName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfTotalChildren" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalStamp" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowRoomChange" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otaDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "arrivalTime" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationAvailabilityBlocks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startEndNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startLastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endBeginNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endFirstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationScope" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "beginNight" } },
                { kind: "Field", name: { kind: "Name", value: "endNight" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PartnerCalendarEventsDataQuery,
  PartnerCalendarEventsDataQueryVariables
>;
export const StaffGroupsForReservationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StaffGroupsForReservationForm" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeInvalidated" },
                value: { kind: "BooleanValue", value: false },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffGroupsForReservationFormQuery,
  StaffGroupsForReservationFormQueryVariables
>;
export const PermissionOnInternalReservationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PermissionOnInternalReservationForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "accessibleReservationCalendars",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isFilledRequiredProfile" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PermissionOnInternalReservationFormQuery,
  PermissionOnInternalReservationFormQueryVariables
>;
export const OriginalReservationOnInternalReservationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "OriginalReservationOnInternalReservationForm",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "OneMoreCabinAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "parentAccommodationReservationId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "BusinessPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organizationId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "CoOwnersPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userOwnershipId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "FullOwnerPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userOwnershipId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "SanuIncAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "usage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "staffGroup" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fullName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StayTicketAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayTicketUnitId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value:
                              "OnlineTravelAgentAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isIkyuDiamondMember",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "TrialPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trialContractId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StaffPlanAccommodationReservationProvider",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "staffContractId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "OriginalReservationOnReservationForm",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "InternalOriginalReservationOnReservationForm",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnAvailabilityCell",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnReservationCalendar",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnAvailabilityCell",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          { kind: "Field", name: { kind: "Name", value: "canCancel" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservationForm",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "InternalOriginalAccommodationReservationOnDraftReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDogs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalStamp" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethodManualDetail" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacity" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OriginalReservationOnReservationForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "InternalOriginalReservationOnReservationForm",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNight" } },
          { kind: "Field", name: { kind: "Name", value: "lastNight" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "mutationScope" } },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OriginalAccommodationReservationOnReservationCalendar",
            },
          },
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value:
                "InternalOriginalAccommodationReservationOnDraftReservation",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OriginalReservationOnInternalReservationFormQuery,
  OriginalReservationOnInternalReservationFormQueryVariables
>;
export const OverlappingAvailabilityBlocksForReservationNoticeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "OverlappingAvailabilityBlocksForReservationNotice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationAvailabilityBlocks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationScope" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "siteIds" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "Variable",
                            name: { kind: "Name", value: "siteId" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startEndNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endBeginNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastNight" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "OverlappingBlocksNotice_AccommodationAvailabilityBlock",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "OverlappingBlocksNotice_AccommodationAvailabilityBlock",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailabilityBlock" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "beginNight" } },
          { kind: "Field", name: { kind: "Name", value: "endNight" } },
          { kind: "Field", name: { kind: "Name", value: "isTentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OverlappingAvailabilityBlocksForReservationNoticeQuery,
  OverlappingAvailabilityBlocksForReservationNoticeQueryVariables
>;
export const RoomTypeDemoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomTypeDemo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilitySlugs" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areasForReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesForReservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ordinalName" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roomTypesForReservation",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "facilitySlugs" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "facilitySlugs" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "evChargerAvailable" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "evChargerAvailable",
                              },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "features" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availabilities" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "firstNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "firstNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "lastNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "lastNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "provider" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "provider" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "evChargerAvailable",
                                  },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "evChargerAvailable",
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fromPrice" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nights" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "night",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isAvailable",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "availableCount",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "price",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "availableAccommodations",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeDemoQuery, RoomTypeDemoQueryVariables>;
export const SubscriptionStatusForDevelopDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SubscriptionStatusForDevelop" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscriptionStatusForDevelopQuery,
  SubscriptionStatusForDevelopQueryVariables
>;
export const ApplySubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplySubscription" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "immediatelyApplyToStandardSubscriptionForDevelop",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplySubscriptionMutation,
  ApplySubscriptionMutationVariables
>;
export const CancelSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelSubscription" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "immediatelyCancelStandardSubscriptionForDevelop",
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelSubscriptionMutation,
  CancelSubscriptionMutationVariables
>;
export const ViewerOnReservationRulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewerOnReservationRules" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingCycleDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationCycle" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDay" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDay" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservationCyclePeriods",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: { kind: "IntValue", value: "5" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "start" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "end" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "stayedAndReservedNights",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "additionalNights" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enrolledDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstSemesterEndDate" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "secondSemesterStartDate",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "firstSemesterStayCredits",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "firstSemesterRemainingPeakDays",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "secondSemesterStayCredits",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "secondSemesterRemainingPeakDays",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "UserOwnershipOnReservationRules",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "UserOwnershipOnReservationRules",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProgramYearStatusOnReservationRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnershipProgramYearStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "remainingNights" } },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingSiteHighSeasonDays" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserOwnershipOnReservationRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ProgramYearStatusOnReservationRules",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ProgramYearStatusOnReservationRules",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewerOnReservationRulesQuery,
  ViewerOnReservationRulesQueryVariables
>;
export const GetReservationsForCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReservationsForCards" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "accessibleReservationCalendars",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "OwnerPlanName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "OwnerPlanName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationReservations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCheckIn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCheckOut" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canCancel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mutationScope" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEligible" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "standardCheckInTime" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EarlyCheckInInfoModal" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value:
                                    "CoOwnersPlanAccommodationReservationProvider",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "userOwnershipId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value:
                                    "FullOwnerPlanAccommodationReservationProvider",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "userOwnershipId",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "review" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "comment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "isSaunaControlAccessible",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasSanuDevices" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "series" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "manualUrl" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "site" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "area" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slug" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "googleMapsUrl",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "checkInAuthenticationType",
                                    },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SiteContentFragment",
                                    },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "SiteTrafficInfo",
                                    },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ActivityProgramCards_Site",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfAdults" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "numberOfTotalChildren",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfDogs" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "oneMoreCabinAccommodationReservation",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "tentativeDeadline",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stayStatus" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canReserveOneMoreCabin" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketUnit" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "cancelFeePolicy",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "CancelFeeRatePolicy",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "immediate",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "CancelFeeFixedPolicy",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "immediate",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AccommodationFacilityList",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AccommodationNoticesForReservation",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "facilityType" },
            name: { kind: "Name", value: "type" },
          },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "isReservable" } },
          { kind: "Field", name: { kind: "Name", value: "isUsable" } },
          { kind: "Field", name: { kind: "Name", value: "isReserved" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EarlyCheckInInfoModal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "earlyCheckInPriceTable" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                { kind: "Field", name: { kind: "Name", value: "endHour" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteTrafficInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roadConditionLiveCameraUrl",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iceRoadInfoUrl" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityProgramCards_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activityPrograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationFacilityList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationNoticesForReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationNotices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brief" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReservationsForCardsQuery,
  GetReservationsForCardsQueryVariables
>;
export const IssueTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "IssueTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "IssueStayTicketsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "issueStayTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "IssueStayTicketsError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "IssueStayTicketsResult" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tickets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IssueTicketsMutation,
  IssueTicketsMutationVariables
>;
export const BundleStayTicketsForConfirmDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BundleStayTicketsForConfirm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "codes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bundleStayTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "codes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "codes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BundleStayTicketsForConfirmMutation,
  BundleStayTicketsForConfirmMutationVariables
>;
export const BookingSimSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BookingSimSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areasForReservation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesForReservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roomTypesForReservation",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BookingSimSitesQuery,
  BookingSimSitesQueryVariables
>;
export const ReservationEstimateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReservationEstimate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DraftAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "draftAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationEstimateQuery,
  ReservationEstimateQueryVariables
>;
export const ImpersonatorAdminStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ImpersonatorAdminStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImpersonatorAdminStatusQuery,
  ImpersonatorAdminStatusQueryVariables
>;
export const GetLoginOnTopPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLoginOnTopPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLoginOnTopPageQuery,
  GetLoginOnTopPageQueryVariables
>;
export const AccommodationReservationForChangeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationForChange" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfKids" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfInfants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfTotalChildren" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previousLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowRoomChange" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalStamp" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketMasterId" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForCancelFeePolicyFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReservationSummary" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccommodationReservationInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForCancelFeePolicyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlanType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationSummary" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "standardCheckInTime" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTotalChildren" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalStamp" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationForChangeQuery,
  AccommodationReservationForChangeQueryVariables
>;
export const AccommodationReservationChangeFeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationChangeFee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromAccommodationReservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "EstimatedChangeFeeOfAccommodationReservationInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "internal" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "estimatedChangeFeeOfAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromAccommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "fromAccommodationReservationId",
                  },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "to" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "to" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internal" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "EstimatedChargeOfAccommodationReservation",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ChangeOrCancelEstimatedChargeFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeOrCancelEstimatedChargeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "EstimatedChargeOfAccommodationReservation",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalAmountOfFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "chargeType" } },
                { kind: "Field", name: { kind: "Name", value: "night" } },
                { kind: "Field", name: { kind: "Name", value: "amountOfFee" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationChangeFeeQuery,
  AccommodationReservationChangeFeeQueryVariables
>;
export const ChangeAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ChangeAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ChangeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeAccommodationReservationMutation,
  ChangeAccommodationReservationMutationVariables
>;
export const InternalChangeAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalChangeAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalUpdateAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalChangeAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ChangeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalChangeAccommodationReservationMutation,
  InternalChangeAccommodationReservationMutationVariables
>;
export const InternalDraftAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalDraftAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DraftAccommodationReservationInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "waiveCleaningFee" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalDraftAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "waiveCleaningFee" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "waiveCleaningFee" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardCheckInTime" },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "series" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "capacity" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "additionalFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingMethod" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "billingMethodManualDetail",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNights" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeStartsAt",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalDraftAccommodationReservationQuery,
  InternalDraftAccommodationReservationQueryVariables
>;
export const InternalCreateAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalCreateAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitationUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tentativeDeadline" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalCreateAccommodationReservationMutation,
  InternalCreateAccommodationReservationMutationVariables
>;
export const AreasOnReservationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AreasOnReservationForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "minNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "maxNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "AccommodationReservationProviderInput",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "occupancyLimitTarget" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OccupancyLimitTargetType" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withDeferred" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "internal" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areasForReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AreaHeaderFragment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesForReservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "siteId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accommodationsForReservation",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "id" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accommodationId" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "series" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "seriesShortName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facilityTypes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availabilities" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "firstNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "firstNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "lastNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "lastNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "provider" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "provider" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "occupancyLimitTarget",
                                  },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "occupancyLimitTarget",
                                    },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "internal" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "internal" },
                                  },
                                },
                              ],
                              directives: [
                                {
                                  kind: "Directive",
                                  name: { kind: "Name", value: "include" },
                                  arguments: [
                                    {
                                      kind: "Argument",
                                      name: { kind: "Name", value: "if" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "withDeferred",
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "date" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isAvailable",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isOwned" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "provider" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "provider" },
                                  },
                                },
                              ],
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AccommodationsGroupOnCalendar",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AccommodationForSiteHeader",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FacilityForSiteHeader",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SiteForHeader" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reservationCyclePeriods",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: { kind: "IntValue", value: "5" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "start" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "end" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "stayedAndReservedNights",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "remainingBaseNights",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hasActiveReservation",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "next7DaysReservationPeriod",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "start" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "end" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "peakDays" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "minNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "maxNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnHeaderCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "size" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          { kind: "Field", name: { kind: "Name", value: "operationType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "facilityTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "notices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brief" } },
                { kind: "Field", name: { kind: "Name", value: "detail" } },
                { kind: "Field", name: { kind: "Name", value: "externalUrl" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilityOnAvailabilityCell" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailability" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
          { kind: "Field", name: { kind: "Name", value: "guaranteedPrice" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "block" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "internal" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categoryInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "note" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categoryGroup" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isTentative" } },
                { kind: "Field", name: { kind: "Name", value: "note" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsOnCalendar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationOnHeaderCell" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationOnAvailabilityCell" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "availabilities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastNight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastNight" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "occupancyLimitTarget" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "occupancyLimitTarget" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internal" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withDeferred" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "isAvailable" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AvailabilityOnAvailabilityCell",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AreaHeaderFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Area" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "allCapsName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationFormCoverImageUrl" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationsGroupOnCalendar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isOwned" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "area" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AccommodationsOnCalendar" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationForSiteHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "seriesShortName" },
                },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityForSiteHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "FacilityDetailModalFragment" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteForHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "ordinalName" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "area" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AreasOnReservationFormQuery,
  AreasOnReservationFormQueryVariables
>;
export const AccommodationDayPricesOnCheckoutDatePickerDrawerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AccommodationDayPricesOnCheckoutDatePickerDrawer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "AccommodationReservationProviderInput",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilities" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "firstNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "lastNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guaranteedPrice" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationDayPricesOnCheckoutDatePickerDrawerQuery,
  AccommodationDayPricesOnCheckoutDatePickerDrawerQueryVariables
>;
export const CheckOutAvailabilitiesOnCheckoutDatePickerDrawerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "CheckOutAvailabilitiesOnCheckoutDatePickerDrawer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationCheckOutAvailabilitiesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "accommodationReservationCheckOutAvailabilities",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "available" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckOutAvailabilitiesOnCheckoutDatePickerDrawerQuery,
  CheckOutAvailabilitiesOnCheckoutDatePickerDrawerQueryVariables
>;
export const StayTicketFeeDiscountsOnCheckoutDatePickerDrawerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "StayTicketFeeDiscountsOnCheckoutDatePickerDrawer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stayTicketUnitId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketReservationInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stayTicketUnitId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stayTicketUnitId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "discounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeModifierType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StayTicketFeeDiscountsOnCheckoutDatePickerDrawerQuery,
  StayTicketFeeDiscountsOnCheckoutDatePickerDrawerQueryVariables
>;
export const AccommodationReservationCheckOutAvailabilitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "AccommodationReservationCheckOutAvailabilities",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationCheckOutAvailabilitiesInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "internal" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "accommodationReservationCheckOutAvailabilities",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internal" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "available" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "additionalNightsFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ruleType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feeModifier" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feeModifierType" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "block" },
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "include" },
                            arguments: [
                              {
                                kind: "Argument",
                                name: { kind: "Name", value: "if" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "internal" },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "categoryInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "categoryGroup",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "note" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isTentative" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "note" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdByUser" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedByUser" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationCheckOutAvailabilitiesQuery,
  AccommodationReservationCheckOutAvailabilitiesQueryVariables
>;
export const DraftAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DraftAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DraftAccommodationReservationInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "draftAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstNight" } },
                { kind: "Field", name: { kind: "Name", value: "lastNight" } },
                { kind: "Field", name: { kind: "Name", value: "nights" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardCheckInTime" },
                },
                { kind: "Field", name: { kind: "Name", value: "firstDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodationNotices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "brief" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isRemote" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "area" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "checkInAuthenticationType",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "series" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "capacity" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "additionalFee" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOwned" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodationClass" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "night" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "lastNight" },
                            },
                          },
                        ],
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "classRelation" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "night" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "lastNight" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bringDog" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "useEvCharger" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billingMethod" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feeApplicability" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "waiveArchitectureTypeAdditionalFee",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveDogFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveSaunaFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveOnsenFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveEvChargerFee" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "waiveDogRunFee" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalNights" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canSelectAllowRoomChange" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "localTaxPolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeStartsAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeAdultPricePerNight",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalGuestFeeKidsPricePerNight",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForCancelFeePolicyFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancellationPolicyContent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CancellationPolicyContentFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "DraftAccommodationReservationInfo",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForCancelFeePolicyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlanType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CancellationPolicyContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CancellationPolicyContent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "conditionLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tiers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feeDescription" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noShowDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changeDeadlineDescription" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DraftAccommodationReservationInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DraftAccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstDate" } },
          { kind: "Field", name: { kind: "Name", value: "lastDate" } },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilityTypes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "options" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bringDog" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useEvCharger" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayTicketUnit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DraftAccommodationReservationQuery,
  DraftAccommodationReservationQueryVariables
>;
export const CreateAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateAccommodationReservationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitationUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tentativeDeadline" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userAcceptCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "internalCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAccommodationReservationMutation,
  CreateAccommodationReservationMutationVariables
>;
export const MaybeViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MaybeViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plan" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accommodation" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaybeViewerQuery, MaybeViewerQueryVariables>;
export const ViewerOnReservationRulesBannerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewerOnReservationRulesBanner" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ReservationRuleBanner" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trialContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ReservationRuleOfTrialPlanBanner",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffContract" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ReservationRuleOfStaffPlanBanner",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizationMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrganizationReservationNewStatus",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ReservationRuleOfOwnershipBannerFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ReservationFormOwnershipSelectorFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fullOwnerships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ReservationRuleOfOwnershipBannerFragment",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ReservationFormOwnershipSelectorFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnershipProgramYearStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "remainingNights" } },
          { kind: "Field", name: { kind: "Name", value: "remainingPeakDays" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingSiteHighSeasonDays" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnerPlanName" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerPlan" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleBanner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserSubscription" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "billingCycleDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationCycle" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "startDay" } },
                { kind: "Field", name: { kind: "Name", value: "endDay" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationCyclePeriods" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "5" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "end" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayedAndReservedNights" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleOfTrialPlanBanner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TrialContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enrolledDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterEndDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterStartDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "firstSemesterRemainingPeakDays" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterStayCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondSemesterRemainingPeakDays" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleOfStaffPlanBanner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "semesterCredits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "semester" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grantedStayCredits" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingPeakDays" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationReservationNewStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrganizationMembership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationNewStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holdMaxInTotal" },
                },
                { kind: "Field", name: { kind: "Name", value: "suspended" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "latestMonthlyReservationStatuses",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yearMonth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isContracted" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "yearlyReservationStatus",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remainingNights" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endYearMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maxNights" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingNights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alreadyHold" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationRuleOfOwnershipBannerFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextYearStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "ProgramYearStatusOnReservationRuleOfOwnershipBanner",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationFormOwnershipSelectorFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserOwnership" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnerPlanName" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewerOnReservationRulesBannerQuery,
  ViewerOnReservationRulesBannerQueryVariables
>;
export const AccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AccommodationReservationFeeFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationReservationFeeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "night" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consumedSuppliesFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilityFee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "localTaxPolicies" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationQuery,
  AccommodationReservationQueryVariables
>;
export const AccommodationReservationCancelFeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccommodationReservationCancelFee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "internal" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "estimatedCancelFeeOfAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "internal" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "internal" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "EstimatedChargeOfAccommodationReservation",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ChangeOrCancelEstimatedChargeFragment",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfAdults" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfTotalChildren" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previousLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextLocation" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayTicketUnit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayTicketUnitForCancelFeePolicyFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReservationSummary" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeOrCancelEstimatedChargeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "EstimatedChargeOfAccommodationReservation",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalAmountOfFee" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "chargeType" } },
                { kind: "Field", name: { kind: "Name", value: "night" } },
                { kind: "Field", name: { kind: "Name", value: "amountOfFee" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayTicketUnitForCancelFeePolicyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayTicketUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ownerPlanType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelFeePolicy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeRatePolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysRate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CancelFeeFixedPolicy" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "immediate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before1DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before3DaysFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "before7DaysFee" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReservationSummary" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "area" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "series" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reservedFrom" } },
          { kind: "Field", name: { kind: "Name", value: "reservedTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "standardCheckInTime" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfAdults" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfKids" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfInfants" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTotalChildren" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextLocation" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowRoomChange" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internalStamp" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingMethod" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccommodationReservationCancelFeeQuery,
  AccommodationReservationCancelFeeQueryVariables
>;
export const CancelAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelAccommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelAccommodationReservationMutation,
  CancelAccommodationReservationMutationVariables
>;
export const InternalCancelAccommodationReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalCancelAccommodationReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCancelAccommodationReservation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccommodationReservation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalCancelAccommodationReservationMutation,
  InternalCancelAccommodationReservationMutationVariables
>;
export const SaveStayReviewDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveStayReviewDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationReservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StayReviewV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveStayReviewV2Draft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationReservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayReviewV2" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayReviewV2Error" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveStayReviewDraftMutation,
  SaveStayReviewDraftMutationVariables
>;
export const SubmitStayReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitStayReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationReservationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StayReviewV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitStayReviewV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationReservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayReviewV2" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "submittedAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StayReviewV2Error" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitStayReviewMutation,
  SubmitStayReviewMutationVariables
>;
export const StayReviewPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StayReviewPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodationReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stayReviewV2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayReviewQuickSelect_StayReviewV2",
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "StayReviewForm_StayReviewV2",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "StayReviewQuickSelect_AccommodationReservation",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "StayReviewCompleted_AccommodationReservation",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StayReviewCompleted_User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayReviewV2Form" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memorableExperiences" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "StayReviewQuickSelect_StayReviewV2Form",
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "StayReviewForm_StayReviewV2Form",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "MemorableExperienceChips_StayReviewMemorableExperienceOption",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewMemorableExperienceOption" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ConcernPanel_StayReviewConcernKindDefinition",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewConcernKindDefinition" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "commentPlaceholder" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewQuickSelect_StayReviewV2" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewForm_StayReviewV2" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureAndNatureRating" },
          },
          { kind: "Field", name: { kind: "Name", value: "cleaningRating" } },
          { kind: "Field", name: { kind: "Name", value: "equipmentRating" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "guidanceAndSupportRating" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "concerns" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "kind" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayReviewQuickSelect_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "StayReviewCompleted_AccommodationReservation",
      },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "stayStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "provider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewCompleted_User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "stayedReservationCount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewQuickSelect_StayReviewV2Form" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2Form" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "MemorableExperienceChips_StayReviewMemorableExperienceOption",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StayReviewForm_StayReviewV2Form" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StayReviewV2Form" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "memorableExperiences" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value:
                      "MemorableExperienceChips_StayReviewMemorableExperienceOption",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "axes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "axis" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "concernKinds" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ConcernPanel_StayReviewConcernKindDefinition",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StayReviewPageQuery, StayReviewPageQueryVariables>;
export const RoomDetailDrawerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomDetailDrawer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "AccommodationReservationProviderInput",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "skipAvailability" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "AccommodationOnRoomDetailContent",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilities" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "firstNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "lastNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "skip" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "skipAvailability" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AvailabilityOnCtaButton",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccommodationOnRoomDetailContent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accommodation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "code" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "googleMapsUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "features" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "iconSlug" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroImages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AvailabilityOnCtaButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccommodationAvailability" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "guaranteedPrice" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomDetailDrawerQuery,
  RoomDetailDrawerQueryVariables
>;
export const RoomDetailDrawerRoomTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomDetailDrawerRoomType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoomTypeOnRoomDetailContent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoomTypeOnRoomDetailContent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "iconSlug" } },
                { kind: "Field", name: { kind: "Name", value: "sort" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rawUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "site" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "googleMapsUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "architectureType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capacityDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentsListUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicAmenities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomDetailDrawerRoomTypeQuery,
  RoomDetailDrawerRoomTypeQueryVariables
>;
export const RoomTypeBrowseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomTypeBrowse" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withDeferred" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isDateFilterActive" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilitySlugs" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "largeOnly" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areasForReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesForReservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortAddress" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "prefecture" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "heroImages" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rawUrl" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roomTypesForReservation",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "facilitySlugs" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "facilitySlugs" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "evChargerAvailable" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "evChargerAvailable",
                              },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "architectureTypes" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "architectureTypes",
                              },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "largeOnly" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "largeOnly" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "architectureType" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "series" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "capacity" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "capacityDescription",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "features" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "FeatureSubtext_RoomType",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availabilities" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "firstNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "firstNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "lastNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "lastNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "provider" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "provider" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "evChargerAvailable",
                                  },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "evChargerAvailable",
                                    },
                                  },
                                },
                              ],
                              directives: [
                                {
                                  kind: "Directive",
                                  name: { kind: "Name", value: "include" },
                                  arguments: [
                                    {
                                      kind: "Argument",
                                      name: { kind: "Name", value: "if" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "withDeferred",
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fromPrice" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nights" },
                                    directives: [
                                      {
                                        kind: "Directive",
                                        name: {
                                          kind: "Name",
                                          value: "include",
                                        },
                                        arguments: [
                                          {
                                            kind: "Argument",
                                            name: { kind: "Name", value: "if" },
                                            value: {
                                              kind: "Variable",
                                              name: {
                                                kind: "Name",
                                                value: "isDateFilterActive",
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "night",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "availableAccommodations",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeatureSubtext_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypeBrowseQuery, RoomTypeBrowseQueryVariables>;
export const RoomTypeCalendarAvailabilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomTypeCalendarAvailability" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "areaIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilitySlugs" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "largeOnly" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areasForReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "areaIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "areaIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesForReservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "roomTypesForReservation",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "facilitySlugs" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "facilitySlugs" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "evChargerAvailable" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "evChargerAvailable",
                              },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "architectureTypes" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "architectureTypes",
                              },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "largeOnly" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "largeOnly" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availabilities" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "firstNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "firstNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "lastNight" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "lastNight" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "provider" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "provider" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "evChargerAvailable",
                                  },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "evChargerAvailable",
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nights" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "night",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isAvailable",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "price",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "maxConsecutiveNights",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomTypeCalendarAvailabilityQuery,
  RoomTypeCalendarAvailabilityQueryVariables
>;
export const SiteAvailabilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SiteAvailability" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilitySlugs" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "architectureTypes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "largeOnly" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areasForReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sitesForReservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availability" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "firstNight" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "firstNight" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "lastNight" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "lastNight" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "facilitySlugs" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "facilitySlugs" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "evChargerAvailable" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "evChargerAvailable",
                              },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "architectureTypes" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "architectureTypes",
                              },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "largeOnly" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "largeOnly" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isAvailable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fromPrice" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteAvailabilityQuery,
  SiteAvailabilityQueryVariables
>;
export const RoomTypeReservationAvailabilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RoomTypeReservationAvailability" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PlainDate" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilities" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "evChargerAvailable" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "evChargerAvailable" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "firstNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "lastNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastNight" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketMasterId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nights" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isAvailable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "availableAccommodations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "facilityTypes",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomTypeReservationAvailabilityQuery,
  RoomTypeReservationAvailabilityQueryVariables
>;
export const RoomTypeReservationAvailabilityByStayTicketMasterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "RoomTypeReservationAvailabilityByStayTicketMaster",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stayTicketMasterReference" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StayTicketMasterReferenceInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roomType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRemote" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "availabilitiesByStayTicketMaster",
                  },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "firstNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "lastNight" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastNight" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "stayTicketMasterReference",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "stayTicketMasterReference",
                        },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "evChargerAvailable" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "evChargerAvailable" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayTicketMasterId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nights" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "night" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isAvailable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "availableAccommodations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "facilityTypes",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoomTypeReservationAvailabilityByStayTicketMasterQuery,
  RoomTypeReservationAvailabilityByStayTicketMasterQueryVariables
>;
export const IssueSanuEdgeDeviceAccessTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "IssueSanuEdgeDeviceAccessToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "IssueSanuEdgeDeviceAccessTokenInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "issueSanuEdgeDeviceAccessToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "IssueSanuEdgeDeviceAccessTokenSuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "token" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "device" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "IssueSanuEdgeDeviceAccessTokenError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IssueSanuEdgeDeviceAccessTokenMutation,
  IssueSanuEdgeDeviceAccessTokenMutationVariables
>;
export const SiteDetailDrawerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SiteDetailDrawer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteSlug" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastNight" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withDeferred" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "evChargerAvailable" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "siteBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteSlug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteHero_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteAboutOverview_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SiteAboutFacilities_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxAccessSection_Site" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DxFaqSection_Site" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roomTypesForReservation" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "provider" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "provider" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "evChargerAvailable" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "evChargerAvailable" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "series" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "capacity" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "capacityDescription",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "features" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FeatureSubtext_RoomType",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availabilities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "firstNight" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "firstNight" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "lastNight" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "lastNight" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "provider" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "provider" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "evChargerAvailable" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "evChargerAvailable",
                              },
                            },
                          },
                        ],
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "include" },
                            arguments: [
                              {
                                kind: "Argument",
                                name: { kind: "Name", value: "if" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "withDeferred" },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fromPrice" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nights" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "night" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "availableAccommodations",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FacilityDetailModalFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Facility" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "rawUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "detailUrl" } },
          { kind: "Field", name: { kind: "Name", value: "isReserveEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "unitType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineHour" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserveDeadlineDaysBefore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baseFeePolicies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitFeeAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteHero_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caption" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accommodations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "architectureType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutOverview_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SiteAboutFacilities_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parkingCapacity" },
                },
                { kind: "Field", name: { kind: "Name", value: "parkingInfo" } },
                { kind: "Field", name: { kind: "Name", value: "mapImageUrl" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "facilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FacilityDetailModalFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxAccessSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "prefecture" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "googleMapsUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessRouteGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transportIcon" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sort" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "points" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "legToNextDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sort" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DxFaqSection_Site" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Site" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faqs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "question" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeatureSubtext_RoomType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RoomType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteDetailDrawerQuery,
  SiteDetailDrawerQueryVariables
>;
export const CreateSetupIntentOnAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSetupIntentOnAccount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createStripeCardSetupIntentOfViewer",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clientSecret" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSetupIntentOnAccountMutation,
  CreateSetupIntentOnAccountMutationVariables
>;
export const CreateSetupIntentOnAccountOfOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSetupIntentOnAccountOfOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "organizationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createStripeCardSetupIntentOfOrganization",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "organizationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "organizationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clientSecret" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSetupIntentOnAccountOfOrganizationMutation,
  CreateSetupIntentOnAccountOfOrganizationMutationVariables
>;
export const AgreeToTermsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AgreeToTerms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "termsRevisionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agreeToTerms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "termsRevisionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "termsRevisionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AgreeToTermsError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AgreeToTermsMutation,
  AgreeToTermsMutationVariables
>;
export const UpdateViewerProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateViewerProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateViewerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateViewer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateViewerProfileMutation,
  UpdateViewerProfileMutationVariables
>;
export const ViewerProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewerProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "nameKana" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AddressInJapan" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line2" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AddressInternational",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line1" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "internationalLine2",
                                    },
                                    name: { kind: "Name", value: "line2" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "stateProvince",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "postalCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "birthDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gender" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nationality" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "professionType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "professionFree" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "householdComposition" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "numberOfDogs" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "carOwnershipStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "passportNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "passportPhoto" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facePhoto" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewerProfileQuery, ViewerProfileQueryVariables>;
export const GetUserCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserCard" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stripe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "brand" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last4" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_month" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exp_year" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserCardQuery, GetUserCardQueryVariables>;
export const AreasForGlobalMenuDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AreasForGlobalMenu" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AreasForGlobalMenuQuery,
  AreasForGlobalMenuQueryVariables
>;
export const ReservationRuleRevision2027PolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReservationRuleRevision2027Policy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AccommodationReservationProviderInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reservationRuleRevision2027Policy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "announcementStartDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstApplicableNight" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationRuleRevision2027PolicyQuery,
  ReservationRuleRevision2027PolicyQueryVariables
>;
export const UseUploadFileCreateUserFileUplaodPolicyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UseUploadFileCreateUserFileUplaodPolicy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateUserFileUploadPolicyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUserFileUploadPolicy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicySuccess",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "policy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uploadUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "key" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rawUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CreateFileUploadPolicyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UseUploadFileCreateUserFileUplaodPolicyMutation,
  UseUploadFileCreateUserFileUplaodPolicyMutationVariables
>;
export const CompleteAddIdentityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CompleteAddIdentity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CompleteAddIdentityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "completeAddIdentity" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CompleteAddIdentitySuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redirectUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CompleteAddIdentityError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteAddIdentityMutation,
  CompleteAddIdentityMutationVariables
>;
export const VerifyAddIdentityReauthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifyAddIdentityReauth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VerifyAddIdentityReauthInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyAddIdentityReauth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "VerifyAddIdentityReauthRedirect",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redirectUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "VerifyAddIdentityReauthError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyAddIdentityReauthMutation,
  VerifyAddIdentityReauthMutationVariables
>;
export const AdminActionsAdminStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AdminActionsAdminStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminActionsAdminStatusQuery,
  AdminActionsAdminStatusQueryVariables
>;
export const ImpersonateViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ImpersonateViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImpersonateViewerQuery,
  ImpersonateViewerQueryVariables
>;
export const ImpersonateUserByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ImpersonateUserById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "deletedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImpersonateUserByIdQuery,
  ImpersonateUserByIdQueryVariables
>;
export const FinalizeAccountLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FinalizeAccountLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FinalizeAccountLinkInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finalizeAccountLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FinalizeAccountLinkSuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "continueUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FinalizeAccountLinkError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinalizeAccountLinkMutation,
  FinalizeAccountLinkMutationVariables
>;
export const ViewerEmailVerifiedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ViewerEmailVerified" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailVerified" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewerEmailVerifiedQuery,
  ViewerEmailVerifiedQueryVariables
>;
export const CreateConsumedSuppliesFeeItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateConsumedSuppliesFeeItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalCreateConsumedSuppliesFeeItemsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalCreateConsumedSuppliesFeeItems",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalCreateConsumedSuppliesFeeItemsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateConsumedSuppliesFeeItemsMutation,
  CreateConsumedSuppliesFeeItemsMutationVariables
>;
export const GetFutureCleaningAmountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFutureCleaningAmounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalFutureCleaningAmounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalFutureCleaningAmounts",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "list" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "amountByFacilities",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "facilityCombinationName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalFutureCleaningAmountsError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFutureCleaningAmountsQuery,
  GetFutureCleaningAmountsQueryVariables
>;
export const ProcessCronJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProcessCronJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "job" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CronJobName" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "authHeader" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "processCronJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "job" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "job" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "authHeader" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "authHeader" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProcessCronJobMutation,
  ProcessCronJobMutationVariables
>;
export const InternalJtasCreateOrUpdateInspectionStatusesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "InternalJtasCreateOrUpdateInspectionStatuses",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalJtasCreateOrUpdateInspectionStatusesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalJtasCreateOrUpdateInspectionStatuses",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value:
                        "InternalJtasCreateOrUpdateInspectionStatusesError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasCreateOrUpdateInspectionStatusesMutation,
  InternalJtasCreateOrUpdateInspectionStatusesMutationVariables
>;
export const InternalSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "architectureType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InternalSitesQuery, InternalSitesQueryVariables>;
export const InternalJtasInspectionForRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalJtasInspectionForRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inspectionDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalJtasInspections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inspectionDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inspectionDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessKey" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keyType" },
                            value: {
                              kind: "EnumValue",
                              value: "SiteCleaningStaff",
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pin" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSynced" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startsAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endsAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEligible" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otaDetail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfAdults" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfKids" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfInfants" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfDogs" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasInspectionForRoomQuery,
  InternalJtasInspectionForRoomQueryVariables
>;
export const InternalJtasCreateOrUpdateSupplyReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalJtasCreateOrUpdateSupplyReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalJtasCreateOrUpdateSupplyReportInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalJtasCreateOrUpdateSupplyReport",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalJtasCreateOrUpdateSupplyReportError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasCreateOrUpdateSupplyReportMutation,
  InternalJtasCreateOrUpdateSupplyReportMutationVariables
>;
export const InternalSupplyItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalSupplyItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalAccommodation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "site" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "internalSupplyItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "master" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "namePublic" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "namePrivate" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                      { kind: "Field", name: { kind: "Name", value: "price" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultQuantity" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalSupplyItemsQuery,
  InternalSupplyItemsQueryVariables
>;
export const InternalJtasInspectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalJtasInspections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inspectionDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalJtasInspections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inspectionDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inspectionDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessKey" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keyType" },
                            value: {
                              kind: "EnumValue",
                              value: "SiteCleaningStaff",
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pin" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSynced" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startsAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endsAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEligible" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otaDetail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfAdults" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfKids" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfInfants" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfDogs" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasInspectionsQuery,
  InternalJtasInspectionsQueryVariables
>;
export const InternalJtasCreateOrUpdateViolationReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "InternalJtasCreateOrUpdateViolationReport",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalJtasCreateOrUpdateViolationReportInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalJtasCreateOrUpdateViolationReport",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalJtasCreateOrUpdateViolationReportError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasCreateOrUpdateViolationReportMutation,
  InternalJtasCreateOrUpdateViolationReportMutationVariables
>;
export const InternalJtasDeleteViolationReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalJtasDeleteViolationReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "InternalJtasDeleteViolationReportInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalJtasDeleteViolationReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalJtasDeleteViolationReportError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasDeleteViolationReportMutation,
  InternalJtasDeleteViolationReportMutationVariables
>;
export const VerifyCheckInQrCodeWebhookDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifyCheckInQrCodeWebhook" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VerifyCheckInQrCodeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyCheckInQrCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerifyCheckInQrCodeSuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "accommodationReservationId",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerifyCheckInQrCodeError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyCheckInQrCodeWebhookMutation,
  VerifyCheckInQrCodeWebhookMutationVariables
>;
export const ProcessStripeWebhookEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProcessStripeWebhookEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payload" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "signature" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "processStripeEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "payload" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payload" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "signature" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "signature" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProcessStripeWebhookEventMutation,
  ProcessStripeWebhookEventMutationVariables
>;
export const ProcessTrustdockWebhookEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProcessTrustdockWebhookEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payload" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "signature" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "processTrustdockEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "payload" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payload" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "signature" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "signature" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProcessTrustdockWebhookEventMutation,
  ProcessTrustdockWebhookEventMutationVariables
>;
export const InternalApplyStaffAccessKeyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalApplyStaffAccessKey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "keyType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccessKeyType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "triggerType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffAccessKeyTrigger" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalApplyStaffAccessKey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "keyType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "keyType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "siteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "siteId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "triggerType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "triggerType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalApplyStaffAccessKeyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalApplyStaffAccessKeyMutation,
  InternalApplyStaffAccessKeyMutationVariables
>;
export const InternalApplyGuestAccessKeyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalApplyGuestAccessKey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "triggerType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GuestAccessKeyTrigger" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookingId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalApplyGuestAccessKey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "triggerType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "triggerType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookingId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalApplyGuestAccessKeyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalApplyGuestAccessKeyMutation,
  InternalApplyGuestAccessKeyMutationVariables
>;
export const InternalReleaseAccessKeyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InternalReleaseAccessKey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accessPersonId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookingId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalReleaseAccessKey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessPersonId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accessPersonId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookingId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InternalReleaseAccessKeyError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalReleaseAccessKeyMutation,
  InternalReleaseAccessKeyMutationVariables
>;
export const Beds24CreateOrUpdateBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24CreateOrUpdateBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBeds24CreateOrUpdateBooking",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24CreateOrUpdateBookingMutation,
  Beds24CreateOrUpdateBookingMutationVariables
>;
export const Beds24CreateOrUpdateBlackBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24CreateOrUpdateBlackBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "blockId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBeds24CreateOrUpdateBlackBooking",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "blockId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "blockId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24CreateOrUpdateBlackBookingMutation,
  Beds24CreateOrUpdateBlackBookingMutationVariables
>;
export const Beds24CreateOrUpdateBlackBookingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24CreateOrUpdateBlackBookings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "blockIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBeds24CreateOrUpdateBlackBookings",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "blockIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "blockIds" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24CreateOrUpdateBlackBookingsMutation,
  Beds24CreateOrUpdateBlackBookingsMutationVariables
>;
export const Beds24DeleteBlackBookingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24DeleteBlackBookings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBeds24DeleteBlackBookings" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24DeleteBlackBookingsMutation,
  Beds24DeleteBlackBookingsMutationVariables
>;
export const Beds24SendBookingMessageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24SendBookingMessage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "kind" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Beds24BookingMessageKind" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBeds24SendBookingMessage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "kind" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "kind" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Success" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "_" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "Beds24BookingMessageError",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "case" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24SendBookingMessageMutation,
  Beds24SendBookingMessageMutationVariables
>;
export const Beds24ProcessWebhookEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24ProcessWebhookEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Beds24BookingEvent" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalBeds24ProcessWebhookEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Beds24WebhookSuccess" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "successCase" },
                              name: { kind: "Name", value: "case" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Beds24WebhookError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "errorCase" },
                              name: { kind: "Name", value: "case" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accommodation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalAmount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "from" } },
                      { kind: "Field", name: { kind: "Name", value: "to" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bookingDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isGroupBooking" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "masterBookingId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalAmount" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "totalUnpaidAmount",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "perRoomAmount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24ProcessWebhookEventMutation,
  Beds24ProcessWebhookEventMutationVariables
>;
export const Beds24SyncFollowingReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24SyncFollowingReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "leadingReservationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBeds24SyncFollowingReservations",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "leadingReservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "leadingReservationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ChangeAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "changeErrorCase" },
                        name: { kind: "Name", value: "case" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "CancelAccommodationReservationError",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "cancelErrorCase" },
                        name: { kind: "Name", value: "case" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24SyncFollowingReservationsMutation,
  Beds24SyncFollowingReservationsMutationVariables
>;
export const Beds24SendGuestMessageAutoReplysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Beds24SendGuestMessageAutoReplys" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookingId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalBeds24SendGuestMessageAutoReply",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookingId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Beds24SendGuestMessageAutoReplysMutation,
  Beds24SendGuestMessageAutoReplysMutationVariables
>;
export const HubSpotSyncContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "HubSpotSyncContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalHubSpotSyncContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "HubSpotSyncContactError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HubSpotSyncContactMutation,
  HubSpotSyncContactMutationVariables
>;
export const HubSpotSyncDealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "HubSpotSyncDeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coOwnersApplicationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalHubSpotSyncDeal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "coOwnersApplicationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "HubSpotSyncDealError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HubSpotSyncDealMutation,
  HubSpotSyncDealMutationVariables
>;
export const IpBeds24SetupStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "IpBeds24SetupStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "state" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalIpBeds24SetupStep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "state" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "state" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IpBeds24SetupStepMutation,
  IpBeds24SetupStepMutationVariables
>;
export const InternalJtasInspectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalJtasInspection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accommodationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inspectionDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlainDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reservationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalJtasInspections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accommodationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accommodationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inspectionDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inspectionDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reservationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reservationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accommodation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilityTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessKey" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keyType" },
                            value: {
                              kind: "EnumValue",
                              value: "SiteCleaningStaff",
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pin" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSynced" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startsAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endsAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastNight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservedTo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stayStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earlyCheckInEligible" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otaDetail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfAdults" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfKids" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfInfants" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "numberOfDogs" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalJtasInspectionQuery,
  InternalJtasInspectionQueryVariables
>;
export const SendCoOwnersIdentityVerificationRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendCoOwnersIdentityVerificationRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coOwnersApplicationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internalSendCoOwnersIdentityVerificationRequest",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "coOwnersApplicationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "coOwnersApplicationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "_" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendCoOwnersIdentityVerificationRequestMutation,
  SendCoOwnersIdentityVerificationRequestMutationVariables
>;
export const ZendeskSyncUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ZendeskSyncUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updateEmail" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "internalZendeskSyncUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateEmail" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateEmail" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Success" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ZendeskSyncUserError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "case" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ZendeskSyncUserMutation,
  ZendeskSyncUserMutationVariables
>;
export const LayoutGtmUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LayoutGtmUserId" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LayoutGtmUserIdQuery,
  LayoutGtmUserIdQueryVariables
>;
export const UrlFromCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UrlFromCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "urlFromCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UrlFromCodeQuery, UrlFromCodeQueryVariables>;
export const SitemapAreasAndSitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SitemapAreasAndSites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "areas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sites" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SitemapAreasAndSitesQuery,
  SitemapAreasAndSitesQueryVariables
>;
export const TestLocaleLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TestLocaleLink" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TestLocaleLinkQuery, TestLocaleLinkQueryVariables>;
export const GtmUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GtmUserId" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "maybeViewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GtmUserIdQuery, GtmUserIdQueryVariables>;
export const IntercomJwtDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IntercomJwt" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "intercomJwt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IntercomJwtQuery, IntercomJwtQueryVariables>;
export const InternalSessionGateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InternalSessionGate" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminRoleAssignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "site" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InternalSessionGateQuery,
  InternalSessionGateQueryVariables
>;
